
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49ed"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49ed"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1QpD4", function(module, exports) {

$parcel$export(module.exports, "captureEvents", function () { return $157e872c35b5d32e$export$a12732eb8ef45f6a; });
$parcel$export(module.exports, "findSelfiesByAttendeeId", function () { return $157e872c35b5d32e$export$7bdb0b3c8e430fa1; });
$parcel$export(module.exports, "deleteSelfie", function () { return $157e872c35b5d32e$export$83e5cfb779ec03dc; });
$parcel$export(module.exports, "findEvent", function () { return $157e872c35b5d32e$export$f0d01cb7f4fd90ce; });
$parcel$export(module.exports, "regByWebappIdFirstStep1", function () { return $157e872c35b5d32e$export$309064234c7f14e9; });
$parcel$export(module.exports, "regByWebappIdFirstStep2", function () { return $157e872c35b5d32e$export$5a9a02b716a313b2; });
$parcel$export(module.exports, "addVisitDateInfo", function () { return $157e872c35b5d32e$export$4d692b4aa5f5532d; });
$parcel$export(module.exports, "print", function () { return $157e872c35b5d32e$export$c2d084dc44961371; });
$parcel$export(module.exports, "updateAttendee", function () { return $157e872c35b5d32e$export$51f2efc35f7641ae; });
$parcel$export(module.exports, "findAttendeeByUIDAndEventId", function () { return $157e872c35b5d32e$export$8f8f5499952f3b39; });
$parcel$export(module.exports, "findPhotos", function () { return $157e872c35b5d32e$export$69549842e1b45fb3; });

var $8xnfv = parcelRequire("8xnfv");
function $157e872c35b5d32e$var$haveAdminPerm(keyType) {
    return keyType === null;
}
function $157e872c35b5d32e$var$safeParseJSON(opts) {
    return opts && JSON.parse(opts) || {};
}
const $157e872c35b5d32e$var$restApi = (0, $8xnfv.initRequest)("https://api-new.occo.io/v1");
const $157e872c35b5d32e$var$defaultImgPath = "https://images.occo.io";
async function $157e872c35b5d32e$export$a12732eb8ef45f6a(param) {
    const events = getEvents();
    if (!events || events.length === 0) return;
    return $157e872c35b5d32e$var$restApi.post("/activity/capture-event", events);
    function getEvents() {
        if (Array.isArray(param)) return param;
        return [
            param
        ];
    }
}
async function $157e872c35b5d32e$export$bb613c728286d830(file, { eventName: eventName, attendeeUId: attendeeUId, keepOriginName: keepOriginName = true }) {
    return $157e872c35b5d32e$var$getAccessToUploadInS3({
        eventName: eventName,
        fileName: file.name,
        attendeeUId: attendeeUId,
        keepOriginName: keepOriginName
    }).then((resp)=>resp.result).then((result)=>(0, $8xnfv.sendFileToS3)(file, {
            s3key: result.fields.key,
            s3bucketUrl: result.url,
            s3fields: result.fields,
            defaultImgPath: $157e872c35b5d32e$var$defaultImgPath
        }));
}
async function $157e872c35b5d32e$var$getAccessToUploadInS3({ eventName: eventName, fileName: fileName, attendeeUId: attendeeUId, keepOriginName: keepOriginName = true }) {
    return $157e872c35b5d32e$var$restApi.post("/event/tmp-photo-upload-access/retrieve", {
        event_name: eventName,
        file_name: fileName,
        keep_origin_name: keepOriginName,
        attendee_uid: attendeeUId
    });
}
async function $157e872c35b5d32e$export$261b4884ce0c342c(file, { attendeeId: attendeeId, eventName: eventName }) {
    const now = new Date();
    const selfiePath = `${eventName}/${now.getFullYear()}/${now.getMonth() + 1}/${now.getDate()}/${file.name}`;
    return $157e872c35b5d32e$var$getAccessToUploadInS3Selfie(selfiePath).then((resp)=>resp.result).then((result)=>(0, $8xnfv.sendFileToS3)(file, {
            s3key: result.fields.key,
            s3bucketUrl: result.url,
            s3fields: result.fields,
            defaultImgPath: $157e872c35b5d32e$var$defaultImgPath
        })).then((imgSrc)=>$157e872c35b5d32e$var$addToDBSelfie({
            attendeeId: attendeeId,
            imgSrc: imgSrc,
            eventName: eventName
        }));
}
async function $157e872c35b5d32e$var$addToDBSelfie({ attendeeId: attendeeId, imgSrc: imgSrc, eventName: eventName }) {
    return $157e872c35b5d32e$var$restApi.post("/attendee/profile-photo/create", {
        attendee_uid: attendeeId,
        full_path: imgSrc,
        event_name: eventName
    });
}
async function $157e872c35b5d32e$var$getAccessToUploadInS3Selfie(fileName) {
    return $157e872c35b5d32e$var$restApi.post("/photo/tmp-upload-access/retrieve", {
        file_relative_path: fileName
    });
}
async function $157e872c35b5d32e$export$7109c3452fbff301({ eventOwnerApiKey: eventOwnerApiKey, photoUrlList: photoUrlList, faceMatchThreshold: faceMatchThreshold = 60, isKiosk: isKiosk = false, startDate: startDate, endDate: endDate }) {
    return $157e872c35b5d32e$var$restApi.post("/photo/search-by-face", {
        event_owner_api_key: eventOwnerApiKey,
        photo_url_list: photoUrlList,
        face_match_threshold: faceMatchThreshold,
        isKiosk: isKiosk,
        start_date: startDate,
        end_date: endDate
    });
}
async function $157e872c35b5d32e$export$7bdb0b3c8e430fa1(attendeeId) {
    return $157e872c35b5d32e$var$restApi.post("/attendee/profile-photo/list/retrieve", {
        attendee_uid: attendeeId
    });
}
async function $157e872c35b5d32e$export$83e5cfb779ec03dc(attendeeId, photoUId) {
    return $157e872c35b5d32e$var$restApi.post("/attendee/profile-photo/delete", {
        attendee_uid: attendeeId,
        photo_uid: photoUId
    });
}
async function $157e872c35b5d32e$export$f0d01cb7f4fd90ce({ eventName: eventName, basicDataOnly: basicDataOnly = false }) {
    const response = await $157e872c35b5d32e$var$restApi.post("/event/retrieve", {
        event_name: eventName,
        basicDataOnly: basicDataOnly
    });
    if (response.result) response.result.opts = $157e872c35b5d32e$var$safeParseJSON(response.result.opts);
    return response;
}
async function $157e872c35b5d32e$export$e6a36f7b37c560ba({ id: id }) {
    const response = await $157e872c35b5d32e$var$restApi.post("/event/list/retrieve", {
        key_type: "event_private_api_key",
        key_value: id,
        max_size: 1,
        page_number: 1
    });
    const event = response.result.dataList[0];
    event.opts = $157e872c35b5d32e$var$safeParseJSON(event.opts);
    return {
        result: event,
        status: response.status
    };
}
async function $157e872c35b5d32e$export$309064234c7f14e9() {
    return $157e872c35b5d32e$var$restApi.post("/attendee/create/by-webapp-id-first/step-1");
}
async function $157e872c35b5d32e$export$5a9a02b716a313b2({ eventId: eventId, attendeeUid: attendeeUid, attendeeName: attendeeName, attendeeEmail: attendeeEmail, attendeePhoneNumber: attendeePhoneNumber }) {
    return $157e872c35b5d32e$var$restApi.post("/attendee/create/by-webapp-id-first/step-2", {
        eventId: eventId,
        attendeeUid: attendeeUid,
        attendeeName: attendeeName,
        attendeeEmail: attendeeEmail,
        attendeePhoneNumber: attendeePhoneNumber
    });
}
function $157e872c35b5d32e$export$825ac59bb370e6d4({ attendeeUIds: attendeeUIds, eventPrivateApiKey: eventPrivateApiKey }) {
    return $157e872c35b5d32e$var$restApi.post("/attendee/check-and-group-uid-list", {
        attendee_uid_list: attendeeUIds,
        event_private_api_key: eventPrivateApiKey
    });
}
async function $157e872c35b5d32e$export$4d692b4aa5f5532d({ eventName: eventName, uId: uId, vDate: vDate, lat: lat, long: long, lang: lang, prePaid: prePaid = false, email: email }) {
    return $157e872c35b5d32e$var$restApi.post("/genting-app/add-visit-date-info", {
        app_info_obj: {
            uId: uId,
            vDate: vDate && prepareDate(),
            lat: lat,
            long: long,
            lang: lang,
            prePaid: prePaid,
            email: email,
            eventName: eventName
        }
    });
    function prepareDate() {
        const year = vDate.getFullYear();
        const month = padTo2Digits(vDate.getMonth() + 1);
        const day = padTo2Digits(vDate.getDate());
        return `${year}${month}${day}`;
    }
    function padTo2Digits(num) {
        return num.toString().padStart(2, "0");
    }
}
async function $157e872c35b5d32e$export$c2d084dc44961371({ eventId: eventId, attendeeUid: attendeeUid, printerPoolName: printerPoolName, photosUid: photosUid, copies: copies = 0, isStory: isStory = false }, { keyType: keyType = null, keyValue: keyValue = null } = {}) {
    return $157e872c35b5d32e$var$restApi.post(determinePath(), prepareBody());
    function determinePath() {
        return $157e872c35b5d32e$var$haveAdminPerm(keyType) ? "/occo-owner/photo/print-with-queue" : "/photo/print-with-queue";
    }
    function prepareBody() {
        const body = {
            event_id: eventId,
            attUid: attendeeUid,
            printable_photo_uid_array: photosUid,
            printing_count: copies + 1,
            printer_pool_name: printerPoolName,
            isStory: isStory
        };
        if (!$157e872c35b5d32e$var$haveAdminPerm(keyType)) {
            body.key_type = keyType;
            body.key_value = keyValue;
        }
        return body;
    }
}
async function $157e872c35b5d32e$export$3e45e94f46f8bebe(attendeeUid) {
    return $157e872c35b5d32e$var$restApi.post("/attendee/retrieve", {
        attendee_uid: attendeeUid
    });
}
async function $157e872c35b5d32e$export$51f2efc35f7641ae({ attendeeUid: attendeeUid, email: email, name: name, phoneNumber: phoneNumber, eventCode: eventCode }) {
    return $157e872c35b5d32e$var$restApi.post("/attendee/update-by-kiosk", {
        attendee_uid: attendeeUid,
        email_address: email,
        full_name: name,
        phone_number: phoneNumber,
        event_name: eventCode,
        app_url: undefined
    });
}
async function $157e872c35b5d32e$export$8f8f5499952f3b39(attendeeUid, eventId) {
    return $157e872c35b5d32e$var$restApi.post("/event/attendee/retrieve", {
        attendeeUid: attendeeUid,
        eventId: eventId
    });
}
async function $157e872c35b5d32e$export$69549842e1b45fb3({ eventId: eventId, attId: attId, maxSize: maxSize, pageNumber: pageNumber = null, keyType: keyType = null, keyValue: keyValue = null, isVisible: isVisible = null, startDate: startDate = null, endDate: endDate = null, minInterval: minInterval = null, maxInterval: maxInterval = null, forKiosk: forKiosk = false, isCuratable: isCuratable = null, isCurated: isCurated = null, isOriginal: isOriginal = null, printable: printable = null, printed: printed = null, showTotalCount: showTotalCount = false, fileName: fileName = null, getFromTmp: getFromTmp = null }) {
    return $157e872c35b5d32e$var$restApi.post(determinePath(), prepareBody());
    function determinePath() {
        return $157e872c35b5d32e$var$haveAdminPerm(keyType) ? "/occo-owner/photo/list/retrieve" : "/photo/list/retrieve";
    }
    function prepareBody() {
        const body = {
            event_id: eventId,
            max_size: maxSize,
            page_number: pageNumber,
            min_time_minutes_interval: minInterval,
            max_time_minutes_interval: maxInterval,
            is_kiosk: forKiosk,
            is_curatable: isCuratable,
            is_curated: isCurated,
            is_original: isOriginal,
            printable: printable,
            printed: printed,
            file_name: fileName,
            attendee_uid: attId,
            show_total_count: showTotalCount,
            get_from_tmp: getFromTmp
        };
        if (typeof isVisible !== "undefined" && isVisible !== null && isVisible !== "" && isVisible !== "null") body.is_visible = isVisible;
        if (startDate) body.start_date = startDate;
        if (endDate) body.end_date = endDate;
        if (!$157e872c35b5d32e$var$haveAdminPerm(keyType)) {
            body.key_type = keyType;
            body.key_value = keyValue;
        }
        return body;
    }
}
async function $157e872c35b5d32e$export$abf742e0032fe27b(imageProcessListOptions = {}) {
    const { token: token = null, accessCode: accessCode = null } = imageProcessListOptions;
    const requestPath = getRequestPath();
    const body = buildRequestBody();
    const options = getOptions();
    return $157e872c35b5d32e$var$restApi.post(requestPath, body, options);
    function getRequestPath() {
        return $157e872c35b5d32e$var$haveAdminPerm(token) ? "/occo-owner/image-process/basic-list/retrieve" : "/image-process/basic-list/retrieve";
    }
    function buildRequestBody() {
        const reqBody = {};
        if (token) {
            reqBody.token = token;
            reqBody.accessCode = accessCode;
        }
        return reqBody;
    }
    function getOptions() {
        return {
            addAuth: $157e872c35b5d32e$var$haveAdminPerm(token)
        };
    }
}

});
parcelRegister("8xnfv", function(module, exports) {

$parcel$export(module.exports, "sendFileToS3", function () { return $637370987cf40442$export$a66317a466bfa2d8; });
$parcel$export(module.exports, "initRequest", function () { return $637370987cf40442$export$af0c4af558fd76ef; });
function $637370987cf40442$var$recallAfterOffline(XMLHttpRequest1, fn) {
    if (XMLHttpRequest1.readyState === 0 || XMLHttpRequest1.readyState === 4) // Network error (i.e. connection refused, access denied due to CORS, etc.)
    window.addEventListener("online", ()=>{
        fn();
    }, {
        once: true
    });
}
async function $637370987cf40442$export$a66317a466bfa2d8(file, { s3key: s3key, s3bucketUrl: s3bucketUrl, s3fields: s3fields, defaultImgPath: defaultImgPath, defaultFileType: defaultFileType = "image/jpeg" }, { retryIfOffline: retryIfOffline = false } = {}) {
    return new Promise(function exec(resolve) {
        const xhr = new XMLHttpRequest();
        xhr.addEventListener("load", ()=>resolve(finalPath()), false);
        xhr.addEventListener("error", (err)=>{
            if (retryIfOffline) $637370987cf40442$var$recallAfterOffline(err.currentTarget, ()=>exec(resolve));
        }, false);
        xhr.open("POST", s3bucketUrl, true); // MUST BE LAST LINE BEFORE YOU SEND
        xhr.send(prepareFormData());
    });
    function prepareFormData() {
        const fd = new FormData();
        fd.append("key", s3key);
        fd.append("acl", "public-read");
        fd.append("success_action_status", "201");
        fd.append("Content-Type", getFileType());
        fd.append("X-Amz-Credential", s3fields["X-Amz-Credential"]);
        fd.append("X-Amz-Algorithm", s3fields["X-Amz-Algorithm"]);
        fd.append("X-Amz-Date", s3fields["X-Amz-Date"]);
        fd.append("X-Amz-Security-Token", s3fields["X-Amz-Security-Token"]);
        fd.append("Policy", s3fields.Policy);
        fd.append("X-Amz-Signature", s3fields["X-Amz-Signature"]);
        fd.append("file", file);
        return fd;
    }
    function finalPath() {
        if (s3fields.bucket) return `https://${s3fields.bucket}/${s3key}`;
        return `${defaultImgPath}/${s3key}`;
    }
    function getFileType() {
        return file.type && file.type !== "" ? file.type : defaultFileType;
    }
}
const $637370987cf40442$export$af0c4af558fd76ef = (serverUrl)=>({
        post: async (path, body = {}, { addAuth: addAuth = false, retryIfOffline: retryIfOffline = false } = {})=>{
            let auth = null;
            if (addAuth) auth = await $637370987cf40442$var$getAuthToken();
            return new Promise(function exec(resolve, reject) {
                const xhr = new XMLHttpRequest();
                xhr.responseType = "json";
                xhr.addEventListener("load", (event)=>{
                    resolve(event.currentTarget.response);
                }, false);
                xhr.addEventListener("error", (err)=>{
                    if (retryIfOffline) $637370987cf40442$var$recallAfterOffline(err.currentTarget, ()=>exec(resolve));
                    else reject(err.currentTarget);
                }, false);
                xhr.open("POST", `${serverUrl}${path}`, true); // MUST BE LAST LINE BEFORE YOU SEND
                if (auth) xhr.setRequestHeader("Authorization", auth);
                xhr.send(JSON.stringify(body));
            });
        }
    });
async function $637370987cf40442$var$getAuthToken() {
    return new Promise((resolve, reject)=>{
        const cognitoUser = getCurrentUser();
        if (cognitoUser == null) {
            reject(new Error("unauthorized_user"));
            return;
        }
        cognitoUser.getSession((err, session)=>{
            if (err || !session.isValid()) {
                const error = {};
                error.type = "unauthorized_user";
                if (err) error.innerError = err;
                reject(error);
            } else resolve(session.getIdToken().getJwtToken());
        });
        function getCurrentUser() {
            if (!AmazonCognitoIdentity) throw new Error("AmazonCognitoIdentity should be included");
            const userPool = new AmazonCognitoIdentity.CognitoUserPool({
                UserPoolId: "us-west-2_TIXPqIBIl",
                ClientId: "2n6kdarusphageo0usm4hdfdp3"
            });
            return userPool.getCurrentUser();
        }
    });
}
function $637370987cf40442$export$60955a2a33777029(input) {
    const isoRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?Z$/;
    const seen = new WeakMap();
    function transform(value) {
        // string -> Date if matches ISO pattern
        if (typeof value === "string") return isoRegex.test(value) ? new Date(value) : value;
        // keep Date instances as-is
        if (value instanceof Date) return value;
        // primitives and null
        if (value === null || typeof value !== "object") return value;
        // handle circular references
        if (seen.has(value)) return seen.get(value);
        // arrays
        if (Array.isArray(value)) {
            const outArr = value.map((el)=>transform(el));
            seen.set(value, outArr);
            return outArr;
        }
        // plain or custom objects: preserve prototype
        const proto = Object.getPrototypeOf(value);
        const outObj = Object.create(proto);
        seen.set(value, outObj);
        for (const [k, v] of Object.entries(value))outObj[k] = transform(v);
        return outObj;
    }
    return transform(input);
}

});


parcelRegister("QsXqF", function(module, exports) {

$parcel$export(module.exports, "ST_TEXTS", function () { return $09db51ce609a8925$export$87ab2296c422f46d; });
$parcel$export(module.exports, "REAL_IMAGE_PATH", function () { return $09db51ce609a8925$export$3f6ef097d2b7f6a7; });
$parcel$export(module.exports, "DEFAULT_SHOOT_HELP_IMG", function () { return $09db51ce609a8925$export$4b217e8daf86c1e1; });
$parcel$export(module.exports, "OCCO_360_VIEWER_PATH", function () { return $09db51ce609a8925$export$8e3e6de9078c835f; });
$parcel$export(module.exports, "photoPlusVariantId", function () { return $09db51ce609a8925$export$6bff081d5e550aac; });
$parcel$export(module.exports, "capitalize", function () { return $09db51ce609a8925$export$9a00dee1beb8f576; });
$parcel$export(module.exports, "formatCurrency", function () { return $09db51ce609a8925$export$3dc27271f5d5c629; });
$parcel$export(module.exports, "formatPrice", function () { return $09db51ce609a8925$export$c86caf1be068fb8d; });
$parcel$export(module.exports, "getQueryVariable", function () { return $09db51ce609a8925$export$34c5a9262f934fa5; });
$parcel$export(module.exports, "showLoading", function () { return $09db51ce609a8925$export$64858b67578a10bb; });
$parcel$export(module.exports, "hideLoading", function () { return $09db51ce609a8925$export$7d026bf51c574e0d; });
$parcel$export(module.exports, "customPopUp", function () { return $09db51ce609a8925$export$9704d2cd3b48497c; });
$parcel$export(module.exports, "getParameterByName", function () { return $09db51ce609a8925$export$7a5418d73bdac342; });
$parcel$export(module.exports, "alertMessagePopup", function () { return $09db51ce609a8925$export$32a3bfc434160815; });
$parcel$export(module.exports, "elId", function () { return $09db51ce609a8925$export$d5fafd96da807b8f; });
$parcel$export(module.exports, "remoteCapture", function () { return $09db51ce609a8925$export$441b80c92889e371; });
$parcel$export(module.exports, "uploadFileToS3", function () { return $09db51ce609a8925$export$9c774f4c11be1742; });
$parcel$export(module.exports, "isValidExtension", function () { return $09db51ce609a8925$export$adc006f73652ef71; });
$parcel$export(module.exports, "updateAppParams", function () { return $09db51ce609a8925$export$c008e664a296dada; });
$parcel$export(module.exports, "deleteImagesReq", function () { return $09db51ce609a8925$export$97c4d823a6dea434; });
$parcel$export(module.exports, "pAttendeeAttachPhotosByQR", function () { return $09db51ce609a8925$export$c9b084775f33891e; });
$parcel$export(module.exports, "attendeeAttachPhotosByQR", function () { return $09db51ce609a8925$export$770078730fa8faec; });
$parcel$export(module.exports, "get360url", function () { return $09db51ce609a8925$export$bff2728bbd426c96; });
$parcel$export(module.exports, "backToKioskStoreHome", function () { return $09db51ce609a8925$export$2d66ebc03a52fdf6; });
$parcel$export(module.exports, "backToHomePage", function () { return $09db51ce609a8925$export$aa31e5ab3c78730a; });
$parcel$export(module.exports, "showPaidMessage", function () { return $09db51ce609a8925$export$37d211164fe25ad1; });
$parcel$export(module.exports, "buyPhotoPlusGlob", function () { return $09db51ce609a8925$export$97c2ec2cb8964420; });
$parcel$export(module.exports, "getCustomAttribute", function () { return $09db51ce609a8925$export$79a99262bbe888be; });
$parcel$export(module.exports, "isDigitalPack", function () { return $09db51ce609a8925$export$7e7dc7b17a7bc469; });
$parcel$export(module.exports, "alertDigitalPackDuplicationAndRedirect", function () { return $09db51ce609a8925$export$c1c8b5173d09e137; });
$parcel$export(module.exports, "alertIfNoEvent", function () { return $09db51ce609a8925$export$b4c9562b4fe385a5; });
$parcel$export(module.exports, "trackPhotoEvent", function () { return $09db51ce609a8925$export$81c028dff25f2b70; });
$parcel$export(module.exports, "trackListOfPhotoEvent", function () { return $09db51ce609a8925$export$2c891fc7eb6d45ab; });
$parcel$export(module.exports, "fromUrlFilename", function () { return $09db51ce609a8925$export$a3878ae81adf338a; });
$parcel$export(module.exports, "isValidEmail", function () { return $09db51ce609a8925$export$371e338370561054; });
$parcel$export(module.exports, "showAlert", function () { return $09db51ce609a8925$export$de026b00723010c1; });
$parcel$export(module.exports, "createAttendee", function () { return $09db51ce609a8925$export$738ce82e3cb95b57; });
$parcel$export(module.exports, "deleteRestrictionHelpMessage", function () { return $09db51ce609a8925$export$8859af7305300b0a; });
$parcel$export(module.exports, "getCollectionOrProductVisibility", function () { return $09db51ce609a8925$export$44965a0ab0c7a9b2; });
$parcel$export(module.exports, "prepareTagsFilter", function () { return $09db51ce609a8925$export$4db89c48f2651f19; });
$parcel$export(module.exports, "isJsonString", function () { return $09db51ce609a8925$export$abd67cc48e99962b; });
$parcel$export(module.exports, "isVisibleCombo", function () { return $09db51ce609a8925$export$5a3abbab71d8b087; });
$parcel$export(module.exports, "getProductTagType", function () { return $09db51ce609a8925$export$f17bf166de11360f; });
$parcel$export(module.exports, "getComboTagType", function () { return $09db51ce609a8925$export$27cbaf7f9422ff60; });
$parcel$export(module.exports, "initThrottle", function () { return $09db51ce609a8925$export$49e33a6a3ab524d9; });
$parcel$export(module.exports, "isPrintable", function () { return $09db51ce609a8925$export$fc95a5c486aa74c0; });
$parcel$export(module.exports, "isNonPrintable", function () { return $09db51ce609a8925$export$b7ed17c2edb4d953; });
$parcel$export(module.exports, "isSelectable", function () { return $09db51ce609a8925$export$ff75e500ee7af77c; });
$parcel$export(module.exports, "isNonSelectable", function () { return $09db51ce609a8925$export$c970901de3da6e49; });
$parcel$export(module.exports, "isValidForPrint", function () { return $09db51ce609a8925$export$3509b628d6b4aca5; });
$parcel$export(module.exports, "isValidForPrintAndUnlock", function () { return $09db51ce609a8925$export$d700d4bedcca3f6e; });
$parcel$export(module.exports, "preparePhotosForDisplay", function () { return $09db51ce609a8925$export$d17b2e634dc29da6; });
$parcel$export(module.exports, "checkProductTagTypeAndImageTag", function () { return $09db51ce609a8925$export$c5c99856861f4364; });
$parcel$export(module.exports, "pluck", function () { return $09db51ce609a8925$export$c44985b87d605eff; });
$parcel$export(module.exports, "checkProductTagTypeForAllImages", function () { return $09db51ce609a8925$export$3610dff0396da865; });
$parcel$export(module.exports, "checkProductTagTypeForAllImagesWrapper", function () { return $09db51ce609a8925$export$773647ccbc7c158; });
$parcel$export(module.exports, "checkComboProductsTagTypeForAllImages", function () { return $09db51ce609a8925$export$1962d8d7d1ac121; });
$parcel$export(module.exports, "transformIdsToPhotos", function () { return $09db51ce609a8925$export$f0fcbfd028dcb7eb; });
$parcel$export(module.exports, "getCurrentFormModelItem", function () { return $09db51ce609a8925$export$55def886b2067470; });
$parcel$export(module.exports, "isAndroid", function () { return $09db51ce609a8925$export$a11b0059900ceec8; });
$parcel$export(module.exports, "isIPhone", function () { return $09db51ce609a8925$export$186c6964ca17d99; });
$parcel$export(module.exports, "isMobile", function () { return $09db51ce609a8925$export$d0a8044dce8ff2fc; });
$parcel$export(module.exports, "renameFileNameMutate", function () { return $09db51ce609a8925$export$bf344be07946b610; });
$parcel$export(module.exports, "getUUID", function () { return $09db51ce609a8925$export$36ec425867d538d7; });
$parcel$export(module.exports, "initMultipleDownload", function () { return $09db51ce609a8925$export$ebc809a96627e361; });

var $a4qiB = parcelRequire("a4qiB");

var $cKtgb = parcelRequire("cKtgb");

var $5fxxW = parcelRequire("5fxxW");

var $lIiEk = parcelRequire("lIiEk");

var $2iUhu = parcelRequire("2iUhu");

var $6ct87 = parcelRequire("6ct87");
const $09db51ce609a8925$var$shopifyService = new (0, $2iUhu.ShopifyService)();
const $09db51ce609a8925$export$87ab2296c422f46d = {
    noImages: "Oops, looks like you have no images in your album yet.<br> <br>Learn how to link images and videos with your album. ",
    noImagesWithoutLink: "Oops, looks like you have no images in your album yet.",
    noImagesSelfies: "Oops, looks like you have not registered your selfie to unlock your Photo+ images and videos that will appear here. Take a selfie now or scan QR to receive your priceless memories.",
    myTickets: "My Photo+",
    noImagesSelfiesWA: "Oops, looks like you have not yet registered faces we can use to find your images. Please register one good selfie for each member of your party.",
    myWebApp: "My Album",
    paidMessage: "Oops, looks like you do not have a Photo+ Pass yet.<br><br>Get yours now to gain access to high resolution content. ",
    addPhotoPlusMessage: "Would you like to add a<br>Photo+ to your shopping<br>cart and gain access to<br>all your digitals?",
    digitalUnlockDupMessage: "You already have a digital access package in your shopping cart.<br>A new package can not be added until you remove or purchase the current one.",
    scanQR: "Scan the QR code on images or videos of you from the photo viewing kiosk to link your media with this app.",
    helpQR: "Where can I find the QR of my photo?",
    videoAccess: "\uD83C\uDFA5 Please ensure that you have enabled the camera access to scan QR code.",
    showMyQR: "Scan this QR code to our Photo+ photographer to use it to access your photos at any photo sales locations.",
    showMyQRWA: "Scan this QR at the kiosk to access your photos, or present it to our roaming photographers when asked.",
    opTutorial: "FAQs",
    regFace: "Register a face",
    scanLinkQR: "Link my photo",
    showMyQRBut: "Show my Photo ",
    showMyQRButWA: "Show my QR",
    faceRegTitle: "Your images and videos will appear here <br>once you have registered your face. ",
    rightFaceMessage: "Please make sure that your face is evenly illuminated and fully visible. Maintain neutral expression.",
    noFaceMask: "NO FACE MASKS",
    shareDownloadRestrict: "You can share or download only one picture at a time.",
    downloadRestrict: "You can download only one picture at a time.",
    emptyCart: "Cart is empty",
    addAnotherProd: "Add another product",
    addAnotherProdWA: "Choose an add-on",
    shippingMessage: "Shipping and discount codes are added at checkout.",
    noVisitDateMessage: "Oops, looks like you don\u2019t have a valid ticket yet for your park visit. Link your ticket to enjoy our Photo+ experience.",
    scannedImage: "Yay, great picture! For Security please confirm. Is this your image?",
    selfieAlbDefTxt: "Add a selfie or a portrait picture<br> for each member of your party.",
    selfieEmptyTxt: "There are no recent images in this album.",
    notAvailableYet: "Your Photo+ experience is available during your Genting SkyWorlds' visit.",
    noUidMessage: "Oops, there was an issue locating your account. Please try again.",
    noSelfiesSugMessage: "Oops, looks like you have not registered your selfie. Take a selfie now to receive your priceless memories.",
    shootPhoto: "Look at the camera and click 'Shoot' when ready",
    countDownPhoto: "Look at the lights",
    renderingVideo: "Your content is being created. Check your album in a few seconds for an awesome new video!",
    uploadUGCTxt: "Upload a photo from your camera roll for printing!",
    uploadTMITxtFromQR: "Take a selfie or upload a portrait from your camera roll.",
    asyncUGCUploadText: "Your photos will be in your album in a minute!",
    asyncTMIUploadTextFromQR: "We are working on transforming your image! Refresh this page in a minute or so.",
    deleteRestrictHelp: "You must keep at least one package in your shopping cart if you wish to purchase add-ons. If you need to change the package - please first remove all add-ons from your shopping cart."
};
const $09db51ce609a8925$export$3f6ef097d2b7f6a7 = "https://images.occo.io";
const $09db51ce609a8925$export$4b217e8daf86c1e1 = "img/remoteShootingDefaultImage.jpg";
const $09db51ce609a8925$export$8e3e6de9078c835f = `${$09db51ce609a8925$export$3f6ef097d2b7f6a7}/360viewer/`;
const $09db51ce609a8925$export$6bff081d5e550aac = localStorage.getItem("shopDigitalVariantId");
function $09db51ce609a8925$export$9a00dee1beb8f576(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
function $09db51ce609a8925$export$3dc27271f5d5c629(currencyCode) {
    if (currencyCode === "USD") return "$";
    return currencyCode;
}
function $09db51ce609a8925$var$formatDecimals(value, digitals = 2) {
    return (Math.round(value * 100) / 100).toFixed(digitals);
}
function $09db51ce609a8925$export$c86caf1be068fb8d({ amount: amount = 0, currencyCode: currencyCode = "USD" }) {
    return `${$09db51ce609a8925$export$3dc27271f5d5c629(currencyCode)}${$09db51ce609a8925$var$formatDecimals(amount)}`;
}
function $09db51ce609a8925$export$34c5a9262f934fa5(variable) {
    const query = window.location.search.substring(1);
    const vars = query.split("&");
    for(let i = 0; i < vars.length; i += 1){
        const pair = vars[i].split("=");
        if (pair[0] === variable) return decodeURI(pair[1]);
    }
    return false;
}
function $09db51ce609a8925$export$64858b67578a10bb() {
    (0, (/*@__PURE__*/$parcel$interopDefault($a4qiB)))(".screenOverlay").show();
    (0, (/*@__PURE__*/$parcel$interopDefault($a4qiB)))("#cssload-cupcake").show();
}
function $09db51ce609a8925$export$7d026bf51c574e0d() {
    setTimeout(()=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($a4qiB)))("#cssload-cupcake").hide();
        (0, (/*@__PURE__*/$parcel$interopDefault($a4qiB)))(".screenOverlay").hide();
    }, 100);
}
const $09db51ce609a8925$export$9704d2cd3b48497c = {
    show () {
        (0, (/*@__PURE__*/$parcel$interopDefault($a4qiB)))("#customPopUp").modal("show");
    },
    hide () {
        (0, (/*@__PURE__*/$parcel$interopDefault($a4qiB)))("#customPopUp").modal("hide");
    },
    html (content) {
        (0, (/*@__PURE__*/$parcel$interopDefault($a4qiB)))("#customPopUpBody").html(content || "");
    }
};
function $09db51ce609a8925$export$7a5418d73bdac342(name, url) {
    const normalizedName = name.replace(/[\[\]]/g, "\\$&");
    const regex = new RegExp(`[?&]${normalizedName}(=([^&#]*)|&|#|$)`);
    const results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}
function $09db51ce609a8925$export$32a3bfc434160815(text) {
    const opt = {
        title: (0, $cKtgb.default).occo_album,
        body: text
    };
    $09db51ce609a8925$export$d5fafd96da807b8f("messagePopUpTitle").innerHTML = opt.title ? opt.title : "";
    $09db51ce609a8925$export$d5fafd96da807b8f("messagePopUpBody").innerHTML = opt.body ? opt.body : "";
    (0, (/*@__PURE__*/$parcel$interopDefault($a4qiB)))("#messagePopUp").modal("show");
}
function $09db51ce609a8925$export$441b80c92889e371(attId, robotId) {
    $09db51ce609a8925$export$64858b67578a10bb();
    $09db51ce609a8925$var$getRobotSettings(robotId, (robotSettings)=>{
        $09db51ce609a8925$export$7d026bf51c574e0d();
        const RC_TXT1 = robotSettings.RC_TXT1 || $09db51ce609a8925$export$87ab2296c422f46d.shootPhoto;
        const RC_TXT2 = robotSettings.RC_TXT2 || $09db51ce609a8925$export$87ab2296c422f46d.countDownPhoto;
        const RC_TXT3 = robotSettings.RC_TXT3 || $09db51ce609a8925$export$87ab2296c422f46d.renderingVideo;
        const RC_URL1 = robotSettings.RC_URL1 || $09db51ce609a8925$export$4b217e8daf86c1e1;
        const content = `<div id="shootCont">
        <img src="${RC_URL1}" width="100%" alt="" /><br><br>
        <span class="">${RC_TXT1}</span><br><br>
        <button type='button'  id="shootPhoto" class='btn btn-primary btn-circle btn-xl'  >Shoot</button>
        </div><br>`;
        $09db51ce609a8925$export$9704d2cd3b48497c.html(content);
        $09db51ce609a8925$export$9704d2cd3b48497c.show();
        (0, (/*@__PURE__*/$parcel$interopDefault($a4qiB)))("#shootPhoto").on("click", ()=>{
            const shootContent = `<div id="cDownCont">
            <span class="" id="hpText">${RC_TXT2}</span><br><br>
            <div id ="cDId" class="cDownLabel">3</div> <br>
            <div id ="closeCont">
              <button class="btn btn-primary btn-sh" onclick="backToHomePage()">Ok</button>
            </div>
            </div><br>`;
            (0, (/*@__PURE__*/$parcel$interopDefault($a4qiB)))("#shootCont").html(shootContent);
            (0, (/*@__PURE__*/$parcel$interopDefault($a4qiB)))("#closeCont").hide();
            $09db51ce609a8925$var$countDown(3, RC_TXT3);
            $09db51ce609a8925$var$remoteCaptureReq(attId, robotId);
        });
    });
}
function $09db51ce609a8925$export$9c774f4c11be1742(file, s3key, s3bucketUrl, s3fields, callbackSuccess) {
    const fd = new FormData();
    fd.append("key", s3key);
    fd.append("acl", "public-read");
    fd.append("success_action_status", "201");
    let fileType = "image/jpeg";
    if (file.type && file.type !== "") fileType = file.type;
    fd.append("Content-Type", fileType);
    fd.append("X-Amz-Credential", s3fields["X-Amz-Credential"]);
    fd.append("X-Amz-Algorithm", s3fields["X-Amz-Algorithm"]);
    fd.append("X-Amz-Date", s3fields["X-Amz-Date"]);
    fd.append("X-Amz-Security-Token", s3fields["X-Amz-Security-Token"]);
    fd.append("Policy", s3fields.Policy);
    fd.append("X-Amz-Signature", s3fields["X-Amz-Signature"]);
    fd.append("file", file);
    const xhr = new XMLHttpRequest();
    // xhr.upload.addEventListener("progress", uploadProgress, false);
    xhr.addEventListener("load", ()=>{
        // onSuccess
        let finalPath = `${$09db51ce609a8925$export$3f6ef097d2b7f6a7}/${s3key}`;
        if (callbackSuccess) {
            if (s3fields.bucket) finalPath = `https://${s3fields.bucket}/${s3key}`;
            callbackSuccess(finalPath);
        }
    }, false);
    // xhr.addEventListener("error", uploadFailed, false);
    // xhr.addEventListener("abort", uploadCanceled, false);
    xhr.open("POST", s3bucketUrl, true); // MUST BE LAST LINE BEFORE YOU SEND
    xhr.send(fd);
}
function $09db51ce609a8925$export$d5fafd96da807b8f(id) {
    return document.getElementById(id);
}
function $09db51ce609a8925$export$adc006f73652ef71(extension) {
    return /(jpg|jpeg|png|gif|mp4)$/gi.test(extension);
}
function $09db51ce609a8925$export$c008e664a296dada(visitDate, eventName = null, callback = ()=>{}) {
    const appInfoObj = {
        uId: $09db51ce609a8925$export$34c5a9262f934fa5("uId"),
        vDate: visitDate || $09db51ce609a8925$export$34c5a9262f934fa5("vDate"),
        lat: $09db51ce609a8925$export$34c5a9262f934fa5("lat"),
        long: $09db51ce609a8925$export$34c5a9262f934fa5("long"),
        prePaid: $09db51ce609a8925$export$34c5a9262f934fa5("prePaid"),
        email: $09db51ce609a8925$export$34c5a9262f934fa5("email"),
        lang: $09db51ce609a8925$export$34c5a9262f934fa5("lang"),
        eventName: eventName
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($a4qiB))).ajax({
        type: "POST",
        url: `${"https://api-new.occo.io/v1"}/genting-app/add-visit-date-info`,
        data: JSON.stringify({
            app_info_obj: appInfoObj
        }),
        dataType: "json",
        success (resp) {
            if (resp === null || resp === void 0 ? void 0 : resp.result) callback(resp.result);
        }
    });
}
function $09db51ce609a8925$export$97c4d823a6dea434(selectedPhotoIdArray, deleteReason, eventId, keyType, keyValue, callback) {
    const body = {
        photo_id_array: selectedPhotoIdArray,
        delete_reason: deleteReason,
        event_id: eventId,
        key_type: keyType,
        key_value: keyValue
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($a4qiB))).ajax({
        type: "POST",
        url: `${"https://api-new.occo.io/v1"}/photo/list/delete`,
        data: JSON.stringify(body),
        dataType: "json",
        success (resp) {
            if (resp === null || resp === void 0 ? void 0 : resp.result) callback(null, resp.result);
        },
        error (err) {
            callback(err, null);
        }
    });
}
function $09db51ce609a8925$export$c9b084775f33891e(attendeeUid, photoUids) {
    return new Promise((resolve)=>{
        const body = {
            attendee_uid: attendeeUid,
            photo_uid_array: photoUids
        };
        (0, (/*@__PURE__*/$parcel$interopDefault($a4qiB))).ajax({
            type: "POST",
            url: `${"https://api-new.occo.io/v1"}/attendee/attach-photos-by-qr-scan`,
            data: JSON.stringify(body),
            dataType: "json",
            success: resolve
        });
    });
}
function $09db51ce609a8925$export$770078730fa8faec(attendeeUid, photoUids) {
    $09db51ce609a8925$export$64858b67578a10bb();
    const body = {
        attendee_uid: attendeeUid,
        photo_uid_array: photoUids
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($a4qiB))).ajax({
        type: "POST",
        url: `${"https://api-new.occo.io/v1"}/attendee/attach-photos-by-qr-scan`,
        data: JSON.stringify(body),
        dataType: "json",
        success () {
            $09db51ce609a8925$var$reloadPage();
        }
    });
}
function $09db51ce609a8925$var$reloadPage() {
    window.location.reload();
}
function $09db51ce609a8925$export$bff2728bbd426c96(normalImageUrl) {
    return `${$09db51ce609a8925$export$8e3e6de9078c835f}?url=${normalImageUrl}&closeable=false`;
}
function $09db51ce609a8925$export$2d66ebc03a52fdf6() {
    (0, $6ct87.redirectToPage).index({
        rawSearch: "?hfb=true"
    });
}
function $09db51ce609a8925$export$aa31e5ab3c78730a() {
    window.location.href = localStorage.getItem("home");
}
function $09db51ce609a8925$export$37d211164fe25ad1(checkout, fromHome) {
    const photoPlusAlreadyExist = $09db51ce609a8925$var$hasPhotoPlus(checkout);
    const isVip = localStorage.getItem("isVip");
    if (!fromHome) {
        if (photoPlusAlreadyExist || isVip === "1") {
            $09db51ce609a8925$var$openCheckoutPage(checkout);
            return;
        }
    } else if (photoPlusAlreadyExist || isVip === "1") return;
    const lsMessage = localStorage.getItem("shopDigitalProductMsg");
    const message = lsMessage || $09db51ce609a8925$export$87ab2296c422f46d.addPhotoPlusMessage;
    // if (fromHome) {
    //     message = ST_TEXTS.paidMessage
    // }
    const content = `<div>
    <h6>${message} </h6><br> <br>
     <button id="maybeLaterBtn" type = "button" class = "btn btn-light btn-lg" data-dismiss = "modal" > Maybe Later </button>
     <button id="buyPhotoPlus" type = "button" class = "btn btn-primary btn-lg" > Yes, Upgrade </button></div>`;
    $09db51ce609a8925$export$9704d2cd3b48497c.html(content);
    $09db51ce609a8925$export$9704d2cd3b48497c.show();
    if (!fromHome) (0, (/*@__PURE__*/$parcel$interopDefault($a4qiB)))("#maybeLaterBtn").on("click", ()=>{
        $09db51ce609a8925$var$openCheckoutPage(checkout);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($a4qiB)))("#buyPhotoPlus").on("click", ()=>{
        $09db51ce609a8925$export$9704d2cd3b48497c.hide();
        $09db51ce609a8925$export$97c2ec2cb8964420(checkout);
    });
}
function $09db51ce609a8925$var$hasPhotoPlus(checkout) {
    if (!($09db51ce609a8925$export$6bff081d5e550aac === null || $09db51ce609a8925$export$6bff081d5e550aac === void 0 ? void 0 : $09db51ce609a8925$export$6bff081d5e550aac.trim())) return true;
    const prodPlusVariantIdNorm = $09db51ce609a8925$var$shopifyService.normalizeProductVariantId($09db51ce609a8925$export$6bff081d5e550aac);
    return checkout.lineItems.some((lineItem)=>{
        const variantArr = JSON.parse($09db51ce609a8925$export$79a99262bbe888be(lineItem, "_variantArr") || "[]");
        return variantArr === null || variantArr === void 0 ? void 0 : variantArr.some((variant)=>(variant === null || variant === void 0 ? void 0 : variant.id) === prodPlusVariantIdNorm);
    });
}
function $09db51ce609a8925$export$7e7dc7b17a7bc469(id) {
    const prodPlusVariantIdNorm = $09db51ce609a8925$var$shopifyService.normalizeProductVariantId($09db51ce609a8925$export$6bff081d5e550aac);
    return id === prodPlusVariantIdNorm;
}
function $09db51ce609a8925$export$c1c8b5173d09e137(variants, checkout) {
    if (hasDigitalPack() && $09db51ce609a8925$var$hasPhotoPlus(checkout)) {
        const lsMessage = localStorage.getItem("shopDigitalProductDupMsg");
        const message = lsMessage || $09db51ce609a8925$export$87ab2296c422f46d.digitalUnlockDupMessage;
        const content = `<div>
        <h6>${message} </h6><br> <br>
        <button id="buttonOK" type="button" class="btn btn-primary btn-lg"> OK </button></div>`;
        $09db51ce609a8925$export$9704d2cd3b48497c.html(content);
        $09db51ce609a8925$export$9704d2cd3b48497c.show();
        (0, (/*@__PURE__*/$parcel$interopDefault($a4qiB)))("#buttonOK").on("click", ()=>{
            window.location.href = "cart.html";
        });
        return true;
    }
    return false;
    function hasDigitalPack() {
        if (Array.isArray(variants)) return variants.findIndex((variant)=>$09db51ce609a8925$export$7e7dc7b17a7bc469(variant.id)) > -1;
        return $09db51ce609a8925$export$7e7dc7b17a7bc469(variants);
    }
}
function $09db51ce609a8925$export$b4c9562b4fe385a5(eventName) {
    if (!eventName || eventName === false || eventName === "false" || eventName === null || eventName === "null") {
        alert("eventName is not provided.");
        return true;
    }
    return false;
}
function $09db51ce609a8925$export$97c2ec2cb8964420(checkout) {
    const photoPlusAlreadyExist = $09db51ce609a8925$var$hasPhotoPlus(checkout);
    if (photoPlusAlreadyExist) {
        $09db51ce609a8925$var$openCheckoutPage(checkout);
        return;
    }
    const eventName = localStorage.getItem("eventName");
    // Event name is critical parameter and must be provided correctly
    if ($09db51ce609a8925$export$b4c9562b4fe385a5(eventName)) return;
    const lineItems = [];
    const attUid = localStorage.getItem("attUidWA") || $09db51ce609a8925$export$34c5a9262f934fa5("uId");
    const prodVariantId = $09db51ce609a8925$var$shopifyService.normalizeProductVariantId($09db51ce609a8925$export$6bff081d5e550aac);
    const lineItem = {
        variantId: prodVariantId,
        quantity: 1
    };
    lineItem.customAttributes = [];
    const variantArr = [];
    const newVariant = {};
    newVariant.productTitle = "";
    newVariant.pid = 0;
    newVariant.eventName = eventName;
    newVariant.id = prodVariantId;
    newVariant.attendeeUid = attUid;
    newVariant.action = "unlock";
    variantArr.push(newVariant);
    lineItem.customAttributes.push({
        key: "_variantArr",
        value: JSON.stringify(variantArr)
    });
    lineItems.push(lineItem);
    $09db51ce609a8925$var$shopifyService.addLineItems(checkout.id, lineItems).then($09db51ce609a8925$var$openCheckoutPage);
}
function $09db51ce609a8925$export$79a99262bbe888be(lineItem, customAttName) {
    var _lineItem_customAttributes_find, _lineItem_customAttributes;
    var _lineItem_customAttributes_find_value;
    return (_lineItem_customAttributes_find_value = (_lineItem_customAttributes = lineItem.customAttributes) === null || _lineItem_customAttributes === void 0 ? void 0 : (_lineItem_customAttributes_find = _lineItem_customAttributes.find((att)=>att.key === customAttName)) === null || _lineItem_customAttributes_find === void 0 ? void 0 : _lineItem_customAttributes_find.value) !== null && _lineItem_customAttributes_find_value !== void 0 ? _lineItem_customAttributes_find_value : null;
}
function $09db51ce609a8925$var$openCheckoutPage(checkout) {
    window.location = checkout.webUrl;
}
function $09db51ce609a8925$var$remoteCaptureReq(attendeeUid, robotId) {
    const body = {
        attendee_uid: attendeeUid,
        aws_robot_name: robotId
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($a4qiB))).ajax({
        type: "POST",
        url: `${"https://api-new.occo.io/v1"}/attendee/make-a-shoot`,
        data: JSON.stringify(body),
        dataType: "json",
        success () {}
    });
}
function $09db51ce609a8925$var$countDown(number, RC_TXT3) {
    let count = number;
    if (count >= 0) {
        (0, (/*@__PURE__*/$parcel$interopDefault($a4qiB)))("#cDId").html(count);
        count -= 1;
        setTimeout(()=>{
            $09db51ce609a8925$var$countDown(count, RC_TXT3);
        }, 1000);
    } else {
        (0, (/*@__PURE__*/$parcel$interopDefault($a4qiB)))("#cDId").html("");
        (0, (/*@__PURE__*/$parcel$interopDefault($a4qiB)))("#closeCont").show();
        (0, (/*@__PURE__*/$parcel$interopDefault($a4qiB)))("#hpText").html(RC_TXT3);
    }
}
function $09db51ce609a8925$export$81c028dff25f2b70({ activityName: activityName, photoId: photoId, robotId: robotId = null, attendeeUid: attendeeUid }) {
    const activityType = "info";
    (0, $5fxxW.occoApi).activityCreateByRobotId(robotId, photoId, activityName, activityType, attendeeUid, (err)=>{
        if (err) return $09db51ce609a8925$export$32a3bfc434160815(err.message_key);
    });
}
function $09db51ce609a8925$export$2c891fc7eb6d45ab({ activityName: activityName, listOfPhotoId: listOfPhotoId, robotId: robotId = null, attendeeUid: attendeeUid }) {
    const activityType = "info";
    (0, $5fxxW.occoApi).activityBulkCreateByRobotId(robotId, listOfPhotoId, activityName, activityType, attendeeUid, (err)=>{
        if (err) return $09db51ce609a8925$export$32a3bfc434160815(err.message_key);
    });
}
function $09db51ce609a8925$var$getRobotSettings(robotId, callback) {
    const body = {
        aws_robot_name: robotId
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($a4qiB))).ajax({
        type: "POST",
        url: `${"https://api-new.occo.io/v1"}/robot/settings/retrieve`,
        data: JSON.stringify(body),
        dataType: "json",
        success (resp) {
            var _resp_result;
            let settings = {};
            if (resp === null || resp === void 0 ? void 0 : (_resp_result = resp.result) === null || _resp_result === void 0 ? void 0 : _resp_result.state) settings = resp.result.state;
            callback(settings);
        }
    });
}
function $09db51ce609a8925$export$a3878ae81adf338a(url) {
    if (!url) return url;
    return url.split("/").pop();
}
function $09db51ce609a8925$export$371e338370561054(email, multi = false) {
    const emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // Email address
    let validEmail = true;
    if (multi) {
        const emails = email.split(",");
        if (emails && emails.length > 1) (0, (/*@__PURE__*/$parcel$interopDefault($a4qiB))).each(emails, (index, value)=>{
            if (!emailRegex.test(value)) return false;
        });
        else validEmail = emailRegex.test(emails[0]);
    } else validEmail = emailRegex.test(email);
    return validEmail;
}
function $09db51ce609a8925$export$de026b00723010c1(text) {
    alert(text);
}
async function $09db51ce609a8925$export$738ce82e3cb95b57({ eventCode: eventCode, name: name, email: email, phoneNumber: phoneNumber }) {
    return new Promise((resolve)=>{
        const data = {
            eventCode: eventCode,
            attendeeName: name,
            attendeeEmail: email,
            attendeePhoneNumber: phoneNumber
        };
        (0, (/*@__PURE__*/$parcel$interopDefault($a4qiB))).ajax({
            type: "POST",
            url: `${"https://api-new.occo.io/v1"}/attendee/create-and-send-email`,
            data: JSON.stringify(data),
            dataType: "json",
            success: resolve
        });
    });
}
function $09db51ce609a8925$export$8859af7305300b0a() {
    const content = `<div>${$09db51ce609a8925$export$87ab2296c422f46d.deleteRestrictHelp}</div><br>
                     <button  type = "button" class = "btn btn-primary btn-lg" data-dismiss = "modal" > Ok </button>`;
    $09db51ce609a8925$export$9704d2cd3b48497c.html(content);
    $09db51ce609a8925$export$9704d2cd3b48497c.show();
}
function $09db51ce609a8925$export$44965a0ab0c7a9b2(checkingObj) {
    let isObjectVisible = true;
    const description = checkingObj.desc || checkingObj.description;
    const isVip = localStorage.getItem("isVip") === "1";
    const objType = checkingObj.desc ? "product" : "collection";
    if (description && description.length > 15) try {
        const descObj = JSON.parse(description);
        if (descObj === null || descObj === void 0 ? void 0 : descObj.show_on_webapp) {
            if (descObj.show_on_webapp.toLowerCase() === "no") isObjectVisible = false;
        }
        isObjectVisible = isObjectVisible && !(isVip && (descObj === null || descObj === void 0 ? void 0 : descObj.hide_for_vip));
    } catch (error) {
        console.log(`Wrong JSON format in ${objType} description: ${description} error: ${error}`);
    }
    return isObjectVisible;
}
function $09db51ce609a8925$export$4db89c48f2651f19(desc) {
    if (!desc || !$09db51ce609a8925$export$abd67cc48e99962b(desc)) return {
        acceptTags: [],
        denyTags: []
    };
    const params = JSON.parse(desc);
    const acceptTags = params.require_tag || [];
    const denyTags = params.deny_tag || [];
    return {
        acceptTags: acceptTags,
        denyTags: denyTags
    };
}
function $09db51ce609a8925$export$5a3abbab71d8b087(comboObj) {
    return $09db51ce609a8925$export$44965a0ab0c7a9b2(comboObj);
}
function $09db51ce609a8925$export$f17bf166de11360f(product) {
    const prodDesc = product.desc || product.description;
    let prodDescJson = {};
    const resProdTypes = {
        acceptTags: [],
        denyTags: []
    };
    if (prodDesc) try {
        prodDescJson = JSON.parse(prodDesc);
    } catch (error) {
        console.log(`Wrong JSON format in description: ${prodDesc} error: ${error}`);
        prodDescJson = {};
    }
    let productAcceptTags = [];
    let productDenyTags = [];
    if (prodDescJson.require_tag) {
        productAcceptTags = productAcceptTags.concat(prodDescJson.require_tag);
        resProdTypes.acceptTags = productAcceptTags;
    }
    if (prodDescJson.deny_tag) {
        productDenyTags = productDenyTags.concat(prodDescJson.deny_tag);
        resProdTypes.denyTags = productDenyTags;
    }
    return resProdTypes;
}
function $09db51ce609a8925$export$27cbaf7f9422ff60(collection) {
    const comboType = {
        comboAcceptTags: [],
        comboDenyTags: []
    };
    const { products: products } = collection;
    for(let p = 0; p < products.length; p += 1){
        // collects combo printable tags
        const prodTags = $09db51ce609a8925$export$f17bf166de11360f(products[p]);
        if (prodTags.acceptTags.length > 0) comboType.comboAcceptTags = comboType.comboAcceptTags.concat(prodTags.acceptTags);
        if (prodTags.denyTags.length > 0) comboType.comboDenyTags = comboType.comboDenyTags.concat(prodTags.denyTags);
    }
    return comboType;
}
function $09db51ce609a8925$export$49e33a6a3ab524d9() {
    const throttleData = {};
    // eslint-disable-next-line no-prototype-builtins
    const isEnabled = (key)=>throttleData.hasOwnProperty(key) && throttleData[key];
    const disable = (key)=>{
        throttleData[key] = false;
    };
    const enable = (key)=>{
        throttleData[key] = true;
    };
    const disableOverTime = (key, milliseconds)=>setTimeout(()=>disable(key), milliseconds);
    return (id, cb, timeout)=>{
        if (!isEnabled(id)) {
            cb();
            enable(id);
            disableOverTime(id, timeout);
        }
    };
}
function $09db51ce609a8925$export$fc95a5c486aa74c0(variant) {
    return variant.poolPrefix !== null && variant.poolPrefix !== undefined && variant.poolPrefix !== "";
}
function $09db51ce609a8925$export$b7ed17c2edb4d953(variant) {
    return !$09db51ce609a8925$export$fc95a5c486aa74c0(variant);
}
function $09db51ce609a8925$var$isUnlockMedia(variant) {
    return variant.unlockMedia !== null && variant.unlockMedia !== undefined && variant.unlockMedia !== "";
}
function $09db51ce609a8925$export$ff75e500ee7af77c(variant) {
    return $09db51ce609a8925$export$fc95a5c486aa74c0(variant) || $09db51ce609a8925$var$isUnlockMedia(variant);
}
function $09db51ce609a8925$export$c970901de3da6e49(variant) {
    return !$09db51ce609a8925$export$ff75e500ee7af77c(variant);
}
function $09db51ce609a8925$export$3509b628d6b4aca5(src, tags) {
    return /(jpg|jpeg|png)$/gi.test(fileExt(src)) || src.includes("uokg5o") && tags.acceptTags.includes("uokg5o");
    function fileExt(path) {
        return path.split(".").pop().toLowerCase();
    }
}
function $09db51ce609a8925$export$d700d4bedcca3f6e(src, tags, unlockMedia) {
    return /(jpg|jpeg|png)$/gi.test(fileExt(src)) || unlockMedia === "unlock_media" || localStorage.getItem("isUnlockMedia") === "true" || src.includes("uokg5o") && tags.acceptTags.includes("uokg5o");
    function fileExt(path) {
        return path.split(".").pop().toLowerCase();
    }
}
function $09db51ce609a8925$export$abd67cc48e99962b(str) {
    if (!str || str.trim().length === 0) return false;
    try {
        JSON.parse(str);
    } catch (error) {
        console.log(`Wrong JSON string: ${str} error: ${error}`);
        return false;
    }
    return true;
}
const $09db51ce609a8925$var$accessDataStorage = (0, $lIiEk.initAccessDataStorage)();
$09db51ce609a8925$var$accessDataStorage.getData((0, $lIiEk.makeAccessData)());
function $09db51ce609a8925$export$d17b2e634dc29da6(photos, tags, unlockMedia) {
    return photos.filter((photo)=>$09db51ce609a8925$export$d700d4bedcca3f6e(photo.full_path, tags, unlockMedia) && $09db51ce609a8925$export$c5c99856861f4364(photo.thumb_full_path, tags)).map((photo)=>({
            ...photo,
            watermarkSrc: (0, $lIiEk.getWatermarkSrc)($09db51ce609a8925$var$accessDataStorage.getData(), photo)
        }));
}
function $09db51ce609a8925$export$c5c99856861f4364(imgUrl, prodTag) {
    if (!prodTag || !prodTag.acceptTags && !prodTag.denyTags || prodTag.acceptTags.length === 0 && prodTag.denyTags.length === 0) return true;
    let fileName = "";
    if (imgUrl) fileName = $09db51ce609a8925$export$a3878ae81adf338a(imgUrl);
    let isPassedAccept = prodTag.acceptTags.length === 0;
    let isPassedDeny = true;
    for(let i = 0; i < prodTag.acceptTags.length; i += 1)if (fileName.indexOf(prodTag.acceptTags[i]) !== -1) {
        isPassedAccept = true;
        break;
    }
    if (isPassedAccept) {
        for(let i = 0; i < prodTag.denyTags.length; i += 1)if (fileName.indexOf(prodTag.denyTags[i]) !== -1) {
            isPassedDeny = false;
            break;
        }
    }
    return isPassedAccept && isPassedDeny;
}
const $09db51ce609a8925$export$c44985b87d605eff = (arr, ...keys)=>keys.length > 1 ? arr.map((i)=>keys.map((k)=>i[k])) : arr.map((i)=>i[keys[0]]);
function $09db51ce609a8925$export$3610dff0396da865(imgPaths, prodTags) {
    if (!prodTags || !prodTags.acceptTags && !prodTags.denyTags || prodTags.acceptTags.length === 0 && prodTags.denyTags.length === 0 || !imgPaths || imgPaths.length === 0) return true;
    let showProduct = false;
    for(const i in imgPaths)showProduct = showProduct || $09db51ce609a8925$export$c5c99856861f4364(imgPaths[i], prodTags);
    return showProduct;
}
function $09db51ce609a8925$export$773647ccbc7c158(variant) {
    return $09db51ce609a8925$export$3610dff0396da865($09db51ce609a8925$export$c44985b87d605eff(JSON.parse(localStorage.getItem("allPhotos")), "full_path"), $09db51ce609a8925$export$4db89c48f2651f19(variant.desc));
}
function $09db51ce609a8925$export$1962d8d7d1ac121(combo, alaCarteId, imgPaths) {
    let showComboAfterTagFiltering = !combo.id.includes(alaCarteId);
    const prodTags = {};
    for(const i in combo.products){
        prodTags.acceptTags = $09db51ce609a8925$export$f17bf166de11360f(combo.products[i]).acceptTags;
        prodTags.denyTags = $09db51ce609a8925$export$f17bf166de11360f(combo.products[i]).denyTags;
        showComboAfterTagFiltering = combo.id.includes(alaCarteId) ? showComboAfterTagFiltering || $09db51ce609a8925$export$3610dff0396da865(imgPaths, prodTags) : showComboAfterTagFiltering && $09db51ce609a8925$export$3610dff0396da865(imgPaths, prodTags);
    }
    return showComboAfterTagFiltering;
}
function $09db51ce609a8925$export$f0fcbfd028dcb7eb(ids, photos) {
    return ids.map((photoId)=>photos.find((photo)=>photo.id === photoId)).filter((photo)=>Boolean(photo));
}
function $09db51ce609a8925$export$55def886b2067470(formModel, currentStep) {
    return formModel[currentStep - 1];
}
function $09db51ce609a8925$export$a11b0059900ceec8() {
    return /android/i.exec(navigator.userAgent);
}
function $09db51ce609a8925$export$186c6964ca17d99() {
    return /(iPad)|(iPhone)|(iPod)/i.exec(navigator.userAgent);
}
function $09db51ce609a8925$export$d0a8044dce8ff2fc() {
    return $09db51ce609a8925$export$a11b0059900ceec8() || $09db51ce609a8925$export$186c6964ca17d99();
}
function $09db51ce609a8925$export$bf344be07946b610(file, newName) {
    Object.defineProperty(file, "name", {
        writable: true,
        value: newName,
        configurable: true
    });
}
function $09db51ce609a8925$export$36ec425867d538d7() {
    var _crypto;
    if ((_crypto = crypto) === null || _crypto === void 0 ? void 0 : _crypto.randomUUID) return crypto.randomUUID();
    return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
}
const $09db51ce609a8925$var$downloadSingleFile = async (url)=>{
    const response = await fetch(url);
    const blob = await response.blob();
    const urlAsArray = url.split("/");
    const fileName = urlAsArray[urlAsArray.length - 1];
    const a = document.createElement("a");
    a.download = fileName;
    a.style.display = "none";
    a.href = URL.createObjectURL(blob);
    a.addEventListener("click", ()=>{
        setTimeout(()=>{
            URL.revokeObjectURL(a.href);
            a.remove();
        }, 1000);
    });
    document.body.append(a);
    a.click();
};
const $09db51ce609a8925$export$ebc809a96627e361 = (waitingNotice)=>async (photos, attendeeUid)=>{
        const title = "Photos";
        // Track download events for each photo
        const photoIdList = photos.map((photo)=>photo.id);
        $09db51ce609a8925$export$2c891fc7eb6d45ab({
            activityName: "Download",
            listOfPhotoId: photoIdList,
            attendeeUid: attendeeUid
        });
        const downloadFiles = async (urls)=>{
            waitingNotice.text("Downloading files.<br/>Please be patient.");
            waitingNotice.show();
            try {
                if ($09db51ce609a8925$export$186c6964ca17d99()) {
                    // Check sharing capability before downloading
                    if (!navigator.canShare) {
                        alert("Your browser does not support sharing multiple files.");
                        waitingNotice.hide();
                        return;
                    }
                    // iOS handling using navigator.share
                    const files = await Promise.all(urls.map(async (url)=>{
                        const response = await fetch(url);
                        const blob = await response.blob();
                        const urlAsArray = url.split("/");
                        const fileName = urlAsArray[urlAsArray.length - 1];
                        return new File([
                            blob
                        ], fileName, {
                            type: blob.type
                        });
                    }));
                    await navigator.share({
                        files: files,
                        title: title
                    });
                } else // Android and other devices handling
                await Promise.all(urls.map($09db51ce609a8925$var$downloadSingleFile));
            } catch (error) {
                console.error("Error downloading files:", error);
            } finally{
                waitingNotice.hide();
            }
        };
        await downloadFiles(photos.map((photo)=>photo.full_path));
    };

});
parcelRegister("a4qiB", function(module, exports) {
/*!
 * jQuery JavaScript Library v3.6.4
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-03-08T15:28Z
 */ (function(global, factory) {
    "use strict";
    if (typeof module.exports === "object") // For CommonJS and CommonJS-like environments where a proper `window`
    // is present, execute the factory and get jQuery.
    // For environments that do not have a `window` with a `document`
    // (such as Node.js), expose a factory as module.exports.
    // This accentuates the need for the creation of a real `window`.
    // e.g. var jQuery = require("jquery")(window);
    // See ticket trac-14549 for more info.
    module.exports = global.document ? factory(global, true) : function(w) {
        if (!w.document) throw new Error("jQuery requires a window with a document");
        return factory(w);
    };
    else factory(global);
// Pass this if window is not defined yet
})(typeof window !== "undefined" ? window : module.exports, function(window1, noGlobal) {
    // Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
    // throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
    // arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
    // enough that all such attempts are guarded in a try block.
    "use strict";
    var arr = [];
    var getProto = Object.getPrototypeOf;
    var slice = arr.slice;
    var flat = arr.flat ? function(array) {
        return arr.flat.call(array);
    } : function(array) {
        return arr.concat.apply([], array);
    };
    var push = arr.push;
    var indexOf = arr.indexOf;
    var class2type = {};
    var toString = class2type.toString;
    var hasOwn = class2type.hasOwnProperty;
    var fnToString = hasOwn.toString;
    var ObjectFunctionString = fnToString.call(Object);
    var support = {};
    var isFunction = function isFunction(obj) {
        // Support: Chrome <=57, Firefox <=52
        // In some browsers, typeof returns "function" for HTML <object> elements
        // (i.e., `typeof document.createElement( "object" ) === "function"`).
        // We don't want to classify *any* DOM node as a function.
        // Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
        // Plus for old WebKit, typeof returns "function" for HTML collections
        // (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
        return typeof obj === "function" && typeof obj.nodeType !== "number" && typeof obj.item !== "function";
    };
    var isWindow = function isWindow(obj) {
        return obj != null && obj === obj.window;
    };
    var document = window1.document;
    var preservedScriptAttributes = {
        type: true,
        src: true,
        nonce: true,
        noModule: true
    };
    function DOMEval(code, node, doc) {
        doc = doc || document;
        var i, val, script = doc.createElement("script");
        script.text = code;
        if (node) for(i in preservedScriptAttributes){
            // Support: Firefox 64+, Edge 18+
            // Some browsers don't support the "nonce" property on scripts.
            // On the other hand, just using `getAttribute` is not enough as
            // the `nonce` attribute is reset to an empty string whenever it
            // becomes browsing-context connected.
            // See https://github.com/whatwg/html/issues/2369
            // See https://html.spec.whatwg.org/#nonce-attributes
            // The `node.getAttribute` check was added for the sake of
            // `jQuery.globalEval` so that it can fake a nonce-containing node
            // via an object.
            val = node[i] || node.getAttribute && node.getAttribute(i);
            if (val) script.setAttribute(i, val);
        }
        doc.head.appendChild(script).parentNode.removeChild(script);
    }
    function toType(obj) {
        if (obj == null) return obj + "";
        // Support: Android <=2.3 only (functionish RegExp)
        return typeof obj === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj;
    }
    /* global Symbol */ // Defining this global in .eslintrc.json would create a danger of using the global
    // unguarded in another place, it seems safer to define global only for this module
    var version = "3.6.4", // Define a local copy of jQuery
    jQuery = function(selector, context) {
        // The jQuery object is actually just the init constructor 'enhanced'
        // Need init if jQuery is called (just allow error to be thrown if not included)
        return new jQuery.fn.init(selector, context);
    };
    jQuery.fn = jQuery.prototype = {
        // The current version of jQuery being used
        jquery: version,
        constructor: jQuery,
        // The default length of a jQuery object is 0
        length: 0,
        toArray: function() {
            return slice.call(this);
        },
        // Get the Nth element in the matched element set OR
        // Get the whole matched element set as a clean array
        get: function(num) {
            // Return all the elements in a clean array
            if (num == null) return slice.call(this);
            // Return just the one element from the set
            return num < 0 ? this[num + this.length] : this[num];
        },
        // Take an array of elements and push it onto the stack
        // (returning the new matched element set)
        pushStack: function(elems) {
            // Build a new jQuery matched element set
            var ret = jQuery.merge(this.constructor(), elems);
            // Add the old object onto the stack (as a reference)
            ret.prevObject = this;
            // Return the newly-formed element set
            return ret;
        },
        // Execute a callback for every element in the matched set.
        each: function(callback) {
            return jQuery.each(this, callback);
        },
        map: function(callback) {
            return this.pushStack(jQuery.map(this, function(elem, i) {
                return callback.call(elem, i, elem);
            }));
        },
        slice: function() {
            return this.pushStack(slice.apply(this, arguments));
        },
        first: function() {
            return this.eq(0);
        },
        last: function() {
            return this.eq(-1);
        },
        even: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return (i + 1) % 2;
            }));
        },
        odd: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return i % 2;
            }));
        },
        eq: function(i) {
            var len = this.length, j = +i + (i < 0 ? len : 0);
            return this.pushStack(j >= 0 && j < len ? [
                this[j]
            ] : []);
        },
        end: function() {
            return this.prevObject || this.constructor();
        },
        // For internal use only.
        // Behaves like an Array's method, not like a jQuery method.
        push: push,
        sort: arr.sort,
        splice: arr.splice
    };
    jQuery.extend = jQuery.fn.extend = function() {
        var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, i = 1, length = arguments.length, deep = false;
        // Handle a deep copy situation
        if (typeof target === "boolean") {
            deep = target;
            // Skip the boolean and the target
            target = arguments[i] || {};
            i++;
        }
        // Handle case when target is a string or something (possible in deep copy)
        if (typeof target !== "object" && !isFunction(target)) target = {};
        // Extend jQuery itself if only one argument is passed
        if (i === length) {
            target = this;
            i--;
        }
        for(; i < length; i++){
            // Only deal with non-null/undefined values
            if ((options = arguments[i]) != null) // Extend the base object
            for(name in options){
                copy = options[name];
                // Prevent Object.prototype pollution
                // Prevent never-ending loop
                if (name === "__proto__" || target === copy) continue;
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
                    src = target[name];
                    // Ensure proper type for the source value
                    if (copyIsArray && !Array.isArray(src)) clone = [];
                    else if (!copyIsArray && !jQuery.isPlainObject(src)) clone = {};
                    else clone = src;
                    copyIsArray = false;
                    // Never move original objects, clone them
                    target[name] = jQuery.extend(deep, clone, copy);
                // Don't bring in undefined values
                } else if (copy !== undefined) target[name] = copy;
            }
        }
        // Return the modified object
        return target;
    };
    jQuery.extend({
        // Unique for each copy of jQuery on the page
        expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
        // Assume jQuery is ready without the ready module
        isReady: true,
        error: function(msg) {
            throw new Error(msg);
        },
        noop: function() {},
        isPlainObject: function(obj) {
            var proto, Ctor;
            // Detect obvious negatives
            // Use toString instead of jQuery.type to catch host objects
            if (!obj || toString.call(obj) !== "[object Object]") return false;
            proto = getProto(obj);
            // Objects with no prototype (e.g., `Object.create( null )`) are plain
            if (!proto) return true;
            // Objects with prototype are plain iff they were constructed by a global Object function
            Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
            return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
        },
        isEmptyObject: function(obj) {
            var name;
            for(name in obj)return false;
            return true;
        },
        // Evaluates a script in a provided context; falls back to the global one
        // if not specified.
        globalEval: function(code, options, doc) {
            DOMEval(code, {
                nonce: options && options.nonce
            }, doc);
        },
        each: function(obj, callback) {
            var length, i = 0;
            if (isArrayLike(obj)) {
                length = obj.length;
                for(; i < length; i++){
                    if (callback.call(obj[i], i, obj[i]) === false) break;
                }
            } else for(i in obj){
                if (callback.call(obj[i], i, obj[i]) === false) break;
            }
            return obj;
        },
        // results is for internal usage only
        makeArray: function(arr, results) {
            var ret = results || [];
            if (arr != null) {
                if (isArrayLike(Object(arr))) jQuery.merge(ret, typeof arr === "string" ? [
                    arr
                ] : arr);
                else push.call(ret, arr);
            }
            return ret;
        },
        inArray: function(elem, arr, i) {
            return arr == null ? -1 : indexOf.call(arr, elem, i);
        },
        // Support: Android <=4.0 only, PhantomJS 1 only
        // push.apply(_, arraylike) throws on ancient WebKit
        merge: function(first, second) {
            var len = +second.length, j = 0, i = first.length;
            for(; j < len; j++)first[i++] = second[j];
            first.length = i;
            return first;
        },
        grep: function(elems, callback, invert) {
            var callbackInverse, matches = [], i = 0, length = elems.length, callbackExpect = !invert;
            // Go through the array, only saving the items
            // that pass the validator function
            for(; i < length; i++){
                callbackInverse = !callback(elems[i], i);
                if (callbackInverse !== callbackExpect) matches.push(elems[i]);
            }
            return matches;
        },
        // arg is for internal usage only
        map: function(elems, callback, arg) {
            var length, value, i = 0, ret = [];
            // Go through the array, translating each of the items to their new values
            if (isArrayLike(elems)) {
                length = elems.length;
                for(; i < length; i++){
                    value = callback(elems[i], i, arg);
                    if (value != null) ret.push(value);
                }
            // Go through every key on the object,
            } else for(i in elems){
                value = callback(elems[i], i, arg);
                if (value != null) ret.push(value);
            }
            // Flatten any nested arrays
            return flat(ret);
        },
        // A global GUID counter for objects
        guid: 1,
        // jQuery.support is not used in Core but other projects attach their
        // properties to it so it needs to exist.
        support: support
    });
    if (typeof Symbol === "function") jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
    // Populate the class2type map
    jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(_i, name) {
        class2type["[object " + name + "]"] = name.toLowerCase();
    });
    function isArrayLike(obj) {
        // Support: real iOS 8.2 only (not reproducible in simulator)
        // `in` check used to prevent JIT error (gh-2145)
        // hasOwn isn't used here due to false negatives
        // regarding Nodelist length in IE
        var length = !!obj && "length" in obj && obj.length, type = toType(obj);
        if (isFunction(obj) || isWindow(obj)) return false;
        return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
    }
    var Sizzle = /*!
 * Sizzle CSS Selector Engine v2.3.10
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://js.foundation/
 *
 * Date: 2023-02-14
 */ function(window1) {
        var i, support, Expr, getText, isXML, tokenize, compile, select, outermostContext, sortInput, hasDuplicate, // Local document vars
        setDocument, document, docElem, documentIsHTML, rbuggyQSA, rbuggyMatches, matches, contains, // Instance-specific data
        expando = "sizzle" + 1 * new Date(), preferredDoc = window1.document, dirruns = 0, done = 0, classCache = createCache(), tokenCache = createCache(), compilerCache = createCache(), nonnativeSelectorCache = createCache(), sortOrder = function(a, b) {
            if (a === b) hasDuplicate = true;
            return 0;
        }, // Instance methods
        hasOwn = {}.hasOwnProperty, arr = [], pop = arr.pop, pushNative = arr.push, push = arr.push, slice = arr.slice, // Use a stripped-down indexOf as it's faster than native
        // https://jsperf.com/thor-indexof-vs-for/5
        indexOf = function(list, elem) {
            var i = 0, len = list.length;
            for(; i < len; i++){
                if (list[i] === elem) return i;
            }
            return -1;
        }, booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", // Regular expressions
        // http://www.w3.org/TR/css3-selectors/#whitespace
        whitespace = "[\\x20\\t\\r\\n\\f]", // https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
        identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\x00-\\x7f])+", // Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
        attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace + // Operator (capture 2)
        "*([*^$|!~]?=)" + whitespace + // "Attribute values must be CSS identifiers [capture 5]
        // or strings [capture 3 or capture 4]"
        "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]", pseudos = ":(" + identifier + ")(?:\\((" + // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
        // 1. quoted (capture 3; capture 4 or capture 5)
        "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" + // 2. simple (capture 6)
        "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" + // 3. anything else (capture 2)
        ".*" + ")\\)|)", // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
        rwhitespace = new RegExp(whitespace + "+", "g"), rtrim = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g"), rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"), rleadingCombinator = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"), rdescend = new RegExp(whitespace + "|>"), rpseudo = new RegExp(pseudos), ridentifier = new RegExp("^" + identifier + "$"), matchExpr = {
            "ID": new RegExp("^#(" + identifier + ")"),
            "CLASS": new RegExp("^\\.(" + identifier + ")"),
            "TAG": new RegExp("^(" + identifier + "|[*])"),
            "ATTR": new RegExp("^" + attributes),
            "PSEUDO": new RegExp("^" + pseudos),
            "CHILD": new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
            "bool": new RegExp("^(?:" + booleans + ")$", "i"),
            // For use in libraries implementing .is()
            // We use this for POS matching in `select`
            "needsContext": new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
        }, rhtml = /HTML$/i, rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, rnative = /^[^{]+\{\s*\[native \w/, // Easily-parseable/retrievable ID or TAG or CLASS selectors
        rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, rsibling = /[+~]/, // CSS escapes
        // http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
        runescape = new RegExp("\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g"), funescape = function(escape, nonHex) {
            var high = "0x" + escape.slice(1) - 0x10000;
            return nonHex ? // Strip the backslash prefix from a non-hex escape sequence
            nonHex : // Replace a hexadecimal escape sequence with the encoded Unicode code point
            // Support: IE <=11+
            // For values outside the Basic Multilingual Plane (BMP), manually construct a
            // surrogate pair
            high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
        }, // CSS string/identifier serialization
        // https://drafts.csswg.org/cssom/#common-serializing-idioms
        rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g, fcssescape = function(ch, asCodePoint) {
            if (asCodePoint) {
                // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
                if (ch === "\x00") return "\uFFFD";
                // Control characters and (dependent upon position) numbers get escaped as code points
                return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
            }
            // Other potentially-special ASCII characters get backslash-escaped
            return "\\" + ch;
        }, // Used for iframes
        // See setDocument()
        // Removing the function wrapper causes a "Permission Denied"
        // error in IE
        unloadHandler = function() {
            setDocument();
        }, inDisabledFieldset = addCombinator(function(elem) {
            return elem.disabled === true && elem.nodeName.toLowerCase() === "fieldset";
        }, {
            dir: "parentNode",
            next: "legend"
        });
        // Optimize for push.apply( _, NodeList )
        try {
            push.apply(arr = slice.call(preferredDoc.childNodes), preferredDoc.childNodes);
            // Support: Android<4.0
            // Detect silently failing push.apply
            // eslint-disable-next-line no-unused-expressions
            arr[preferredDoc.childNodes.length].nodeType;
        } catch (e) {
            push = {
                apply: arr.length ? // Leverage slice if possible
                function(target, els) {
                    pushNative.apply(target, slice.call(els));
                } : // Support: IE<9
                // Otherwise append directly
                function(target, els) {
                    var j = target.length, i = 0;
                    // Can't trust NodeList.length
                    while(target[j++] = els[i++]);
                    target.length = j - 1;
                }
            };
        }
        function Sizzle(selector, context, results, seed) {
            var m, i, elem, nid, match, groups, newSelector, newContext = context && context.ownerDocument, // nodeType defaults to 9, since context defaults to document
            nodeType = context ? context.nodeType : 9;
            results = results || [];
            // Return early from calls with invalid selector or context
            if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) return results;
            // Try to shortcut find operations (as opposed to filters) in HTML documents
            if (!seed) {
                setDocument(context);
                context = context || document;
                if (documentIsHTML) {
                    // If the selector is sufficiently simple, try using a "get*By*" DOM method
                    // (excepting DocumentFragment context, where the methods don't exist)
                    if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {
                        // ID selector
                        if (m = match[1]) {
                            // Document context
                            if (nodeType === 9) {
                                if (elem = context.getElementById(m)) // Support: IE, Opera, Webkit
                                // TODO: identify versions
                                // getElementById can match elements by name instead of ID
                                {
                                    if (elem.id === m) {
                                        results.push(elem);
                                        return results;
                                    }
                                } else return results;
                            // Element context
                            } else // Support: IE, Opera, Webkit
                            // TODO: identify versions
                            // getElementById can match elements by name instead of ID
                            if (newContext && (elem = newContext.getElementById(m)) && contains(context, elem) && elem.id === m) {
                                results.push(elem);
                                return results;
                            }
                        // Type selector
                        } else if (match[2]) {
                            push.apply(results, context.getElementsByTagName(selector));
                            return results;
                        // Class selector
                        } else if ((m = match[3]) && support.getElementsByClassName && context.getElementsByClassName) {
                            push.apply(results, context.getElementsByClassName(m));
                            return results;
                        }
                    }
                    // Take advantage of querySelectorAll
                    if (support.qsa && !nonnativeSelectorCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector)) && // Support: IE 8 only
                    // Exclude object elements
                    (nodeType !== 1 || context.nodeName.toLowerCase() !== "object")) {
                        newSelector = selector;
                        newContext = context;
                        // qSA considers elements outside a scoping root when evaluating child or
                        // descendant combinators, which is not what we want.
                        // In such cases, we work around the behavior by prefixing every selector in the
                        // list with an ID selector referencing the scope context.
                        // The technique has to be used as well when a leading combinator is used
                        // as such selectors are not recognized by querySelectorAll.
                        // Thanks to Andrew Dupont for this technique.
                        if (nodeType === 1 && (rdescend.test(selector) || rleadingCombinator.test(selector))) {
                            // Expand context for sibling selectors
                            newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
                            // We can use :scope instead of the ID hack if the browser
                            // supports it & if we're not changing the context.
                            if (newContext !== context || !support.scope) {
                                // Capture the context ID, setting it first if necessary
                                if (nid = context.getAttribute("id")) nid = nid.replace(rcssescape, fcssescape);
                                else context.setAttribute("id", nid = expando);
                            }
                            // Prefix every selector in the list
                            groups = tokenize(selector);
                            i = groups.length;
                            while(i--)groups[i] = (nid ? "#" + nid : ":scope") + " " + toSelector(groups[i]);
                            newSelector = groups.join(",");
                        }
                        try {
                            push.apply(results, newContext.querySelectorAll(newSelector));
                            return results;
                        } catch (qsaError) {
                            nonnativeSelectorCache(selector, true);
                        } finally{
                            if (nid === expando) context.removeAttribute("id");
                        }
                    }
                }
            }
            // All others
            return select(selector.replace(rtrim, "$1"), context, results, seed);
        }
        /**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */ function createCache() {
            var keys = [];
            function cache(key, value) {
                // Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
                if (keys.push(key + " ") > Expr.cacheLength) // Only keep the most recent entries
                delete cache[keys.shift()];
                return cache[key + " "] = value;
            }
            return cache;
        }
        /**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */ function markFunction(fn) {
            fn[expando] = true;
            return fn;
        }
        /**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */ function assert(fn) {
            var el = document.createElement("fieldset");
            try {
                return !!fn(el);
            } catch (e) {
                return false;
            } finally{
                // Remove from its parent by default
                if (el.parentNode) el.parentNode.removeChild(el);
                // release memory in IE
                el = null;
            }
        }
        /**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */ function addHandle(attrs, handler) {
            var arr = attrs.split("|"), i = arr.length;
            while(i--)Expr.attrHandle[arr[i]] = handler;
        }
        /**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */ function siblingCheck(a, b) {
            var cur = b && a, diff = cur && a.nodeType === 1 && b.nodeType === 1 && a.sourceIndex - b.sourceIndex;
            // Use IE sourceIndex if available on both nodes
            if (diff) return diff;
            // Check if b follows a
            if (cur) while(cur = cur.nextSibling){
                if (cur === b) return -1;
            }
            return a ? 1 : -1;
        }
        /**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */ function createInputPseudo(type) {
            return function(elem) {
                var name = elem.nodeName.toLowerCase();
                return name === "input" && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */ function createButtonPseudo(type) {
            return function(elem) {
                var name = elem.nodeName.toLowerCase();
                return (name === "input" || name === "button") && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */ function createDisabledPseudo(disabled) {
            // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
            return function(elem) {
                // Only certain elements can match :enabled or :disabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
                if ("form" in elem) {
                    // Check for inherited disabledness on relevant non-disabled elements:
                    // * listed form-associated elements in a disabled fieldset
                    //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
                    // * option elements in a disabled optgroup
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
                    // All such elements have a "form" property.
                    if (elem.parentNode && elem.disabled === false) {
                        // Option elements defer to a parent optgroup if present
                        if ("label" in elem) {
                            if ("label" in elem.parentNode) return elem.parentNode.disabled === disabled;
                            else return elem.disabled === disabled;
                        }
                        // Support: IE 6 - 11
                        // Use the isDisabled shortcut property to check for disabled fieldset ancestors
                        return elem.isDisabled === disabled || // Where there is no isDisabled, check manually
                        /* jshint -W018 */ elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled;
                    }
                    return elem.disabled === disabled;
                // Try to winnow out elements that can't be disabled before trusting the disabled property.
                // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
                // even exist on them, let alone have a boolean value.
                } else if ("label" in elem) return elem.disabled === disabled;
                // Remaining elements are neither :enabled nor :disabled
                return false;
            };
        }
        /**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */ function createPositionalPseudo(fn) {
            return markFunction(function(argument) {
                argument = +argument;
                return markFunction(function(seed, matches) {
                    var j, matchIndexes = fn([], seed.length, argument), i = matchIndexes.length;
                    // Match elements found at the specified indexes
                    while(i--)if (seed[j = matchIndexes[i]]) seed[j] = !(matches[j] = seed[j]);
                });
            });
        }
        /**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */ function testContext(context) {
            return context && typeof context.getElementsByTagName !== "undefined" && context;
        }
        // Expose support vars for convenience
        support = Sizzle.support = {};
        /**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */ isXML = Sizzle.isXML = function(elem) {
            var namespace = elem && elem.namespaceURI, docElem = elem && (elem.ownerDocument || elem).documentElement;
            // Support: IE <=8
            // Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
            // https://bugs.jquery.com/ticket/4833
            return !rhtml.test(namespace || docElem && docElem.nodeName || "HTML");
        };
        /**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */ setDocument = Sizzle.setDocument = function(node) {
            var hasCompare, subWindow, doc = node ? node.ownerDocument || node : preferredDoc;
            // Return early if doc is invalid or already selected
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (doc == document || doc.nodeType !== 9 || !doc.documentElement) return document;
            // Update global variables
            document = doc;
            docElem = document.documentElement;
            documentIsHTML = !isXML(document);
            // Support: IE 9 - 11+, Edge 12 - 18+
            // Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (preferredDoc != document && (subWindow = document.defaultView) && subWindow.top !== subWindow) {
                // Support: IE 11, Edge
                if (subWindow.addEventListener) subWindow.addEventListener("unload", unloadHandler, false);
                else if (subWindow.attachEvent) subWindow.attachEvent("onunload", unloadHandler);
            }
            // Support: IE 8 - 11+, Edge 12 - 18+, Chrome <=16 - 25 only, Firefox <=3.6 - 31 only,
            // Safari 4 - 5 only, Opera <=11.6 - 12.x only
            // IE/Edge & older browsers don't support the :scope pseudo-class.
            // Support: Safari 6.0 only
            // Safari 6.0 supports :scope but it's an alias of :root there.
            support.scope = assert(function(el) {
                docElem.appendChild(el).appendChild(document.createElement("div"));
                return typeof el.querySelectorAll !== "undefined" && !el.querySelectorAll(":scope fieldset div").length;
            });
            // Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
            // Make sure the the `:has()` argument is parsed unforgivingly.
            // We include `*` in the test to detect buggy implementations that are
            // _selectively_ forgiving (specifically when the list includes at least
            // one valid selector).
            // Note that we treat complete lack of support for `:has()` as if it were
            // spec-compliant support, which is fine because use of `:has()` in such
            // environments will fail in the qSA path and fall back to jQuery traversal
            // anyway.
            support.cssHas = assert(function() {
                try {
                    document.querySelector(":has(*,:jqfake)");
                    return false;
                } catch (e) {
                    return true;
                }
            });
            /* Attributes
	---------------------------------------------------------------------- */ // Support: IE<8
            // Verify that getAttribute really returns attributes and not properties
            // (excepting IE8 booleans)
            support.attributes = assert(function(el) {
                el.className = "i";
                return !el.getAttribute("className");
            });
            /* getElement(s)By*
	---------------------------------------------------------------------- */ // Check if getElementsByTagName("*") returns only elements
            support.getElementsByTagName = assert(function(el) {
                el.appendChild(document.createComment(""));
                return !el.getElementsByTagName("*").length;
            });
            // Support: IE<9
            support.getElementsByClassName = rnative.test(document.getElementsByClassName);
            // Support: IE<10
            // Check if getElementById returns elements by name
            // The broken getElementById methods don't pick up programmatically-set names,
            // so use a roundabout getElementsByName test
            support.getById = assert(function(el) {
                docElem.appendChild(el).id = expando;
                return !document.getElementsByName || !document.getElementsByName(expando).length;
            });
            // ID filter and find
            if (support.getById) {
                Expr.filter["ID"] = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        return elem.getAttribute("id") === attrId;
                    };
                };
                Expr.find["ID"] = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var elem = context.getElementById(id);
                        return elem ? [
                            elem
                        ] : [];
                    }
                };
            } else {
                Expr.filter["ID"] = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
                        return node && node.value === attrId;
                    };
                };
                // Support: IE 6 - 7 only
                // getElementById is not reliable as a find shortcut
                Expr.find["ID"] = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var node, i, elems, elem = context.getElementById(id);
                        if (elem) {
                            // Verify the id attribute
                            node = elem.getAttributeNode("id");
                            if (node && node.value === id) return [
                                elem
                            ];
                            // Fall back on getElementsByName
                            elems = context.getElementsByName(id);
                            i = 0;
                            while(elem = elems[i++]){
                                node = elem.getAttributeNode("id");
                                if (node && node.value === id) return [
                                    elem
                                ];
                            }
                        }
                        return [];
                    }
                };
            }
            // Tag
            Expr.find["TAG"] = support.getElementsByTagName ? function(tag, context) {
                if (typeof context.getElementsByTagName !== "undefined") return context.getElementsByTagName(tag);
                else if (support.qsa) return context.querySelectorAll(tag);
            } : function(tag, context) {
                var elem, tmp = [], i = 0, // By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
                results = context.getElementsByTagName(tag);
                // Filter out possible comments
                if (tag === "*") {
                    while(elem = results[i++])if (elem.nodeType === 1) tmp.push(elem);
                    return tmp;
                }
                return results;
            };
            // Class
            Expr.find["CLASS"] = support.getElementsByClassName && function(className, context) {
                if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) return context.getElementsByClassName(className);
            };
            /* QSA/matchesSelector
	---------------------------------------------------------------------- */ // QSA and matchesSelector support
            // matchesSelector(:active) reports false when true (IE9/Opera 11.5)
            rbuggyMatches = [];
            // qSa(:focus) reports false when true (Chrome 21)
            // We allow this because of a bug in IE8/9 that throws an error
            // whenever `document.activeElement` is accessed on an iframe
            // So, we allow :focus to pass through QSA all the time to avoid the IE error
            // See https://bugs.jquery.com/ticket/13378
            rbuggyQSA = [];
            if (support.qsa = rnative.test(document.querySelectorAll)) {
                // Build QSA regex
                // Regex strategy adopted from Diego Perini
                assert(function(el) {
                    var input;
                    // Select is set to empty string on purpose
                    // This is to test IE's treatment of not explicitly
                    // setting a boolean content attribute,
                    // since its presence should be enough
                    // https://bugs.jquery.com/ticket/12359
                    docElem.appendChild(el).innerHTML = "<a id='" + expando + "'></a>" + "<select id='" + expando + "-\r\\' msallowcapture=''>" + "<option selected=''></option></select>";
                    // Support: IE8, Opera 11-12.16
                    // Nothing should be selected when empty strings follow ^= or $= or *=
                    // The test attribute must be unknown in Opera but "safe" for WinRT
                    // https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
                    if (el.querySelectorAll("[msallowcapture^='']").length) rbuggyQSA.push("[*^$]=" + whitespace + "*(?:''|\"\")");
                    // Support: IE8
                    // Boolean attributes and "value" are not treated correctly
                    if (!el.querySelectorAll("[selected]").length) rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
                    // Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
                    if (!el.querySelectorAll("[id~=" + expando + "-]").length) rbuggyQSA.push("~=");
                    // Support: IE 11+, Edge 15 - 18+
                    // IE 11/Edge don't find elements on a `[name='']` query in some cases.
                    // Adding a temporary attribute to the document before the selection works
                    // around the issue.
                    // Interestingly, IE 10 & older don't seem to have the issue.
                    input = document.createElement("input");
                    input.setAttribute("name", "");
                    el.appendChild(input);
                    if (!el.querySelectorAll("[name='']").length) rbuggyQSA.push("\\[" + whitespace + "*name" + whitespace + "*=" + whitespace + "*(?:''|\"\")");
                    // Webkit/Opera - :checked should return selected option elements
                    // http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                    // IE8 throws error here and will not see later tests
                    if (!el.querySelectorAll(":checked").length) rbuggyQSA.push(":checked");
                    // Support: Safari 8+, iOS 8+
                    // https://bugs.webkit.org/show_bug.cgi?id=136851
                    // In-page `selector#id sibling-combinator selector` fails
                    if (!el.querySelectorAll("a#" + expando + "+*").length) rbuggyQSA.push(".#.+[+~]");
                    // Support: Firefox <=3.6 - 5 only
                    // Old Firefox doesn't throw on a badly-escaped identifier.
                    el.querySelectorAll("\\\f");
                    rbuggyQSA.push("[\\r\\n\\f]");
                });
                assert(function(el) {
                    el.innerHTML = "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
                    // Support: Windows 8 Native Apps
                    // The type and name attributes are restricted during .innerHTML assignment
                    var input = document.createElement("input");
                    input.setAttribute("type", "hidden");
                    el.appendChild(input).setAttribute("name", "D");
                    // Support: IE8
                    // Enforce case-sensitivity of name attribute
                    if (el.querySelectorAll("[name=d]").length) rbuggyQSA.push("name" + whitespace + "*[*^$|!~]?=");
                    // FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
                    // IE8 throws error here and will not see later tests
                    if (el.querySelectorAll(":enabled").length !== 2) rbuggyQSA.push(":enabled", ":disabled");
                    // Support: IE9-11+
                    // IE's :disabled selector does not pick up the children of disabled fieldsets
                    docElem.appendChild(el).disabled = true;
                    if (el.querySelectorAll(":disabled").length !== 2) rbuggyQSA.push(":enabled", ":disabled");
                    // Support: Opera 10 - 11 only
                    // Opera 10-11 does not throw on post-comma invalid pseudos
                    el.querySelectorAll("*,:x");
                    rbuggyQSA.push(",.*:");
                });
            }
            if (support.matchesSelector = rnative.test(matches = docElem.matches || docElem.webkitMatchesSelector || docElem.mozMatchesSelector || docElem.oMatchesSelector || docElem.msMatchesSelector)) assert(function(el) {
                // Check to see if it's possible to do matchesSelector
                // on a disconnected node (IE 9)
                support.disconnectedMatch = matches.call(el, "*");
                // This should fail with an exception
                // Gecko does not error, returns false instead
                matches.call(el, "[s!='']:x");
                rbuggyMatches.push("!=", pseudos);
            });
            if (!support.cssHas) // Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
            // Our regular `try-catch` mechanism fails to detect natively-unsupported
            // pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
            // in browsers that parse the `:has()` argument as a forgiving selector list.
            // https://drafts.csswg.org/selectors/#relational now requires the argument
            // to be parsed unforgivingly, but browsers have not yet fully adjusted.
            rbuggyQSA.push(":has");
            rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
            rbuggyMatches = rbuggyMatches.length && new RegExp(rbuggyMatches.join("|"));
            /* Contains
	---------------------------------------------------------------------- */ hasCompare = rnative.test(docElem.compareDocumentPosition);
            // Element contains another
            // Purposefully self-exclusive
            // As in, an element does not contain itself
            contains = hasCompare || rnative.test(docElem.contains) ? function(a, b) {
                // Support: IE <9 only
                // IE doesn't have `contains` on `document` so we need to check for
                // `documentElement` presence.
                // We need to fall back to `a` when `documentElement` is missing
                // as `ownerDocument` of elements within `<template/>` may have
                // a null one - a default behavior of all modern browsers.
                var adown = a.nodeType === 9 && a.documentElement || a, bup = b && b.parentNode;
                return a === bup || !!(bup && bup.nodeType === 1 && (adown.contains ? adown.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
            } : function(a, b) {
                if (b) while(b = b.parentNode){
                    if (b === a) return true;
                }
                return false;
            };
            /* Sorting
	---------------------------------------------------------------------- */ // Document order sorting
            sortOrder = hasCompare ? function(a, b) {
                // Flag for duplicate removal
                if (a === b) {
                    hasDuplicate = true;
                    return 0;
                }
                // Sort on method existence if only one input has compareDocumentPosition
                var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
                if (compare) return compare;
                // Calculate position if both inputs belong to the same document
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                compare = (a.ownerDocument || a) == (b.ownerDocument || b) ? a.compareDocumentPosition(b) : // Otherwise we know they are disconnected
                1;
                // Disconnected nodes
                if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
                    // Choose the first element that is related to our preferred document
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (a == document || a.ownerDocument == preferredDoc && contains(preferredDoc, a)) return -1;
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (b == document || b.ownerDocument == preferredDoc && contains(preferredDoc, b)) return 1;
                    // Maintain original order
                    return sortInput ? indexOf(sortInput, a) - indexOf(sortInput, b) : 0;
                }
                return compare & 4 ? -1 : 1;
            } : function(a, b) {
                // Exit early if the nodes are identical
                if (a === b) {
                    hasDuplicate = true;
                    return 0;
                }
                var cur, i = 0, aup = a.parentNode, bup = b.parentNode, ap = [
                    a
                ], bp = [
                    b
                ];
                // Parentless nodes are either documents or disconnected
                if (!aup || !bup) // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                /* eslint-disable eqeqeq */ return a == document ? -1 : b == document ? 1 : /* eslint-enable eqeqeq */ aup ? -1 : bup ? 1 : sortInput ? indexOf(sortInput, a) - indexOf(sortInput, b) : 0;
                else if (aup === bup) return siblingCheck(a, b);
                // Otherwise we need full lists of their ancestors for comparison
                cur = a;
                while(cur = cur.parentNode)ap.unshift(cur);
                cur = b;
                while(cur = cur.parentNode)bp.unshift(cur);
                // Walk down the tree looking for a discrepancy
                while(ap[i] === bp[i])i++;
                return i ? // Do a sibling check if the nodes have a common ancestor
                siblingCheck(ap[i], bp[i]) : // Otherwise nodes in our document sort first
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                /* eslint-disable eqeqeq */ ap[i] == preferredDoc ? -1 : bp[i] == preferredDoc ? 1 : /* eslint-enable eqeqeq */ 0;
            };
            return document;
        };
        Sizzle.matches = function(expr, elements) {
            return Sizzle(expr, null, null, elements);
        };
        Sizzle.matchesSelector = function(elem, expr) {
            setDocument(elem);
            if (support.matchesSelector && documentIsHTML && !nonnativeSelectorCache[expr + " "] && (!rbuggyMatches || !rbuggyMatches.test(expr)) && (!rbuggyQSA || !rbuggyQSA.test(expr))) try {
                var ret = matches.call(elem, expr);
                // IE 9's matchesSelector returns false on disconnected nodes
                if (ret || support.disconnectedMatch || // As well, disconnected nodes are said to be in a document
                // fragment in IE 9
                elem.document && elem.document.nodeType !== 11) return ret;
            } catch (e) {
                nonnativeSelectorCache(expr, true);
            }
            return Sizzle(expr, document, null, [
                elem
            ]).length > 0;
        };
        Sizzle.contains = function(context, elem) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((context.ownerDocument || context) != document) setDocument(context);
            return contains(context, elem);
        };
        Sizzle.attr = function(elem, name) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((elem.ownerDocument || elem) != document) setDocument(elem);
            var fn = Expr.attrHandle[name.toLowerCase()], // Don't get fooled by Object.prototype properties (jQuery #13807)
            val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
            return val !== undefined ? val : support.attributes || !documentIsHTML ? elem.getAttribute(name) : (val = elem.getAttributeNode(name)) && val.specified ? val.value : null;
        };
        Sizzle.escape = function(sel) {
            return (sel + "").replace(rcssescape, fcssescape);
        };
        Sizzle.error = function(msg) {
            throw new Error("Syntax error, unrecognized expression: " + msg);
        };
        /**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */ Sizzle.uniqueSort = function(results) {
            var elem, duplicates = [], j = 0, i = 0;
            // Unless we *know* we can detect duplicates, assume their presence
            hasDuplicate = !support.detectDuplicates;
            sortInput = !support.sortStable && results.slice(0);
            results.sort(sortOrder);
            if (hasDuplicate) {
                while(elem = results[i++])if (elem === results[i]) j = duplicates.push(i);
                while(j--)results.splice(duplicates[j], 1);
            }
            // Clear input after sorting to release objects
            // See https://github.com/jquery/sizzle/pull/225
            sortInput = null;
            return results;
        };
        /**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */ getText = Sizzle.getText = function(elem) {
            var node, ret = "", i = 0, nodeType = elem.nodeType;
            if (!nodeType) // If no nodeType, this is expected to be an array
            while(node = elem[i++])// Do not traverse comment nodes
            ret += getText(node);
            else if (nodeType === 1 || nodeType === 9 || nodeType === 11) {
                // Use textContent for elements
                // innerText usage removed for consistency of new lines (jQuery #11153)
                if (typeof elem.textContent === "string") return elem.textContent;
                else // Traverse its children
                for(elem = elem.firstChild; elem; elem = elem.nextSibling)ret += getText(elem);
            } else if (nodeType === 3 || nodeType === 4) return elem.nodeValue;
            // Do not include comment or processing instruction nodes
            return ret;
        };
        Expr = Sizzle.selectors = {
            // Can be adjusted by the user
            cacheLength: 50,
            createPseudo: markFunction,
            match: matchExpr,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: true
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: true
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                "ATTR": function(match) {
                    match[1] = match[1].replace(runescape, funescape);
                    // Move the given value to match[3] whether quoted or unquoted
                    match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);
                    if (match[2] === "~=") match[3] = " " + match[3] + " ";
                    return match.slice(0, 4);
                },
                "CHILD": function(match) {
                    /* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/ match[1] = match[1].toLowerCase();
                    if (match[1].slice(0, 3) === "nth") {
                        // nth-* requires argument
                        if (!match[3]) Sizzle.error(match[0]);
                        // numeric x and y parameters for Expr.filter.CHILD
                        // remember that false/true cast respectively to 0/1
                        match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
                        match[5] = +(match[7] + match[8] || match[3] === "odd");
                    // other types prohibit arguments
                    } else if (match[3]) Sizzle.error(match[0]);
                    return match;
                },
                "PSEUDO": function(match) {
                    var excess, unquoted = !match[6] && match[2];
                    if (matchExpr["CHILD"].test(match[0])) return null;
                    // Accept quoted arguments as-is
                    if (match[3]) match[2] = match[4] || match[5] || "";
                    else if (unquoted && rpseudo.test(unquoted) && // Get excess from tokenize (recursively)
                    (excess = tokenize(unquoted, true)) && // advance to the next closing parenthesis
                    (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
                        // excess is a negative index
                        match[0] = match[0].slice(0, excess);
                        match[2] = unquoted.slice(0, excess);
                    }
                    // Return only captures needed by the pseudo filter method (type and argument)
                    return match.slice(0, 3);
                }
            },
            filter: {
                "TAG": function(nodeNameSelector) {
                    var nodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
                    return nodeNameSelector === "*" ? function() {
                        return true;
                    } : function(elem) {
                        return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
                    };
                },
                "CLASS": function(className) {
                    var pattern = classCache[className + " "];
                    return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)"), classCache(className, function(elem) {
                        return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
                    }));
                },
                "ATTR": function(name, operator, check) {
                    return function(elem) {
                        var result = Sizzle.attr(elem, name);
                        if (result == null) return operator === "!=";
                        if (!operator) return true;
                        result += "";
                        /* eslint-disable max-len */ return operator === "=" ? result === check : operator === "!=" ? result !== check : operator === "^=" ? check && result.indexOf(check) === 0 : operator === "*=" ? check && result.indexOf(check) > -1 : operator === "$=" ? check && result.slice(-check.length) === check : operator === "~=" ? (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1 : operator === "|=" ? result === check || result.slice(0, check.length + 1) === check + "-" : false;
                    /* eslint-enable max-len */ };
                },
                "CHILD": function(type, what, _argument, first, last) {
                    var simple = type.slice(0, 3) !== "nth", forward = type.slice(-4) !== "last", ofType = what === "of-type";
                    return first === 1 && last === 0 ? // Shortcut for :nth-*(n)
                    function(elem) {
                        return !!elem.parentNode;
                    } : function(elem, _context, xml) {
                        var cache, uniqueCache, outerCache, node, nodeIndex, start, dir = simple !== forward ? "nextSibling" : "previousSibling", parent = elem.parentNode, name = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType, diff = false;
                        if (parent) {
                            // :(first|last|only)-(child|of-type)
                            if (simple) {
                                while(dir){
                                    node = elem;
                                    while(node = node[dir]){
                                        if (ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1) return false;
                                    }
                                    // Reverse direction for :only-* (if we haven't yet done so)
                                    start = dir = type === "only" && !start && "nextSibling";
                                }
                                return true;
                            }
                            start = [
                                forward ? parent.firstChild : parent.lastChild
                            ];
                            // non-xml :nth-child(...) stores cache data on `parent`
                            if (forward && useCache) {
                                // Seek `elem` from a previously-cached index
                                // ...in a gzip-friendly way
                                node = parent;
                                outerCache = node[expando] || (node[expando] = {});
                                // Support: IE <9 only
                                // Defend against cloned attroperties (jQuery gh-1709)
                                uniqueCache = outerCache[node.uniqueID] || (outerCache[node.uniqueID] = {});
                                cache = uniqueCache[type] || [];
                                nodeIndex = cache[0] === dirruns && cache[1];
                                diff = nodeIndex && cache[2];
                                node = nodeIndex && parent.childNodes[nodeIndex];
                                while(node = ++nodeIndex && node && node[dir] || // Fallback to seeking `elem` from the start
                                (diff = nodeIndex = 0) || start.pop())// When found, cache indexes on `parent` and break
                                if (node.nodeType === 1 && ++diff && node === elem) {
                                    uniqueCache[type] = [
                                        dirruns,
                                        nodeIndex,
                                        diff
                                    ];
                                    break;
                                }
                            } else {
                                // Use previously-cached element index if available
                                if (useCache) {
                                    // ...in a gzip-friendly way
                                    node = elem;
                                    outerCache = node[expando] || (node[expando] = {});
                                    // Support: IE <9 only
                                    // Defend against cloned attroperties (jQuery gh-1709)
                                    uniqueCache = outerCache[node.uniqueID] || (outerCache[node.uniqueID] = {});
                                    cache = uniqueCache[type] || [];
                                    nodeIndex = cache[0] === dirruns && cache[1];
                                    diff = nodeIndex;
                                }
                                // xml :nth-child(...)
                                // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                                if (diff === false) {
                                    // Use the same loop as above to seek `elem` from the start
                                    while(node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop())if ((ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1) && ++diff) {
                                        // Cache the index of each encountered element
                                        if (useCache) {
                                            outerCache = node[expando] || (node[expando] = {});
                                            // Support: IE <9 only
                                            // Defend against cloned attroperties (jQuery gh-1709)
                                            uniqueCache = outerCache[node.uniqueID] || (outerCache[node.uniqueID] = {});
                                            uniqueCache[type] = [
                                                dirruns,
                                                diff
                                            ];
                                        }
                                        if (node === elem) break;
                                    }
                                }
                            }
                            // Incorporate the offset, then check against cycle size
                            diff -= last;
                            return diff === first || diff % first === 0 && diff / first >= 0;
                        }
                    };
                },
                "PSEUDO": function(pseudo, argument) {
                    // pseudo-class names are case-insensitive
                    // http://www.w3.org/TR/selectors/#pseudo-classes
                    // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
                    // Remember that setFilters inherits from pseudos
                    var args, fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || Sizzle.error("unsupported pseudo: " + pseudo);
                    // The user may use createPseudo to indicate that
                    // arguments are needed to create the filter function
                    // just as Sizzle does
                    if (fn[expando]) return fn(argument);
                    // But maintain support for old signatures
                    if (fn.length > 1) {
                        args = [
                            pseudo,
                            pseudo,
                            "",
                            argument
                        ];
                        return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function(seed, matches) {
                            var idx, matched = fn(seed, argument), i = matched.length;
                            while(i--){
                                idx = indexOf(seed, matched[i]);
                                seed[idx] = !(matches[idx] = matched[i]);
                            }
                        }) : function(elem) {
                            return fn(elem, 0, args);
                        };
                    }
                    return fn;
                }
            },
            pseudos: {
                // Potentially complex pseudos
                "not": markFunction(function(selector) {
                    // Trim the selector passed to compile
                    // to avoid treating leading and trailing
                    // spaces as combinators
                    var input = [], results = [], matcher = compile(selector.replace(rtrim, "$1"));
                    return matcher[expando] ? markFunction(function(seed, matches, _context, xml) {
                        var elem, unmatched = matcher(seed, null, xml, []), i = seed.length;
                        // Match elements unmatched by `matcher`
                        while(i--)if (elem = unmatched[i]) seed[i] = !(matches[i] = elem);
                    }) : function(elem, _context, xml) {
                        input[0] = elem;
                        matcher(input, null, xml, results);
                        // Don't keep the element (issue #299)
                        input[0] = null;
                        return !results.pop();
                    };
                }),
                "has": markFunction(function(selector) {
                    return function(elem) {
                        return Sizzle(selector, elem).length > 0;
                    };
                }),
                "contains": markFunction(function(text) {
                    text = text.replace(runescape, funescape);
                    return function(elem) {
                        return (elem.textContent || getText(elem)).indexOf(text) > -1;
                    };
                }),
                // "Whether an element is represented by a :lang() selector
                // is based solely on the element's language value
                // being equal to the identifier C,
                // or beginning with the identifier C immediately followed by "-".
                // The matching of C against the element's language value is performed case-insensitively.
                // The identifier C does not have to be a valid language name."
                // http://www.w3.org/TR/selectors/#lang-pseudo
                "lang": markFunction(function(lang) {
                    // lang value must be a valid identifier
                    if (!ridentifier.test(lang || "")) Sizzle.error("unsupported lang: " + lang);
                    lang = lang.replace(runescape, funescape).toLowerCase();
                    return function(elem) {
                        var elemLang;
                        do if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
                            elemLang = elemLang.toLowerCase();
                            return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
                        }
                        while ((elem = elem.parentNode) && elem.nodeType === 1);
                        return false;
                    };
                }),
                // Miscellaneous
                "target": function(elem) {
                    var hash = window1.location && window1.location.hash;
                    return hash && hash.slice(1) === elem.id;
                },
                "root": function(elem) {
                    return elem === docElem;
                },
                "focus": function(elem) {
                    return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
                },
                // Boolean properties
                "enabled": createDisabledPseudo(false),
                "disabled": createDisabledPseudo(true),
                "checked": function(elem) {
                    // In CSS3, :checked should return both checked and selected elements
                    // http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                    var nodeName = elem.nodeName.toLowerCase();
                    return nodeName === "input" && !!elem.checked || nodeName === "option" && !!elem.selected;
                },
                "selected": function(elem) {
                    // Accessing this property makes selected-by-default
                    // options in Safari work properly
                    if (elem.parentNode) // eslint-disable-next-line no-unused-expressions
                    elem.parentNode.selectedIndex;
                    return elem.selected === true;
                },
                // Contents
                "empty": function(elem) {
                    // http://www.w3.org/TR/selectors/#empty-pseudo
                    // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
                    //   but not by others (comment: 8; processing instruction: 7; etc.)
                    // nodeType < 6 works because attributes (2) do not appear as children
                    for(elem = elem.firstChild; elem; elem = elem.nextSibling){
                        if (elem.nodeType < 6) return false;
                    }
                    return true;
                },
                "parent": function(elem) {
                    return !Expr.pseudos["empty"](elem);
                },
                // Element/input types
                "header": function(elem) {
                    return rheader.test(elem.nodeName);
                },
                "input": function(elem) {
                    return rinputs.test(elem.nodeName);
                },
                "button": function(elem) {
                    var name = elem.nodeName.toLowerCase();
                    return name === "input" && elem.type === "button" || name === "button";
                },
                "text": function(elem) {
                    var attr;
                    return elem.nodeName.toLowerCase() === "input" && elem.type === "text" && // Support: IE <10 only
                    // New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
                    ((attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
                },
                // Position-in-collection
                "first": createPositionalPseudo(function() {
                    return [
                        0
                    ];
                }),
                "last": createPositionalPseudo(function(_matchIndexes, length) {
                    return [
                        length - 1
                    ];
                }),
                "eq": createPositionalPseudo(function(_matchIndexes, length, argument) {
                    return [
                        argument < 0 ? argument + length : argument
                    ];
                }),
                "even": createPositionalPseudo(function(matchIndexes, length) {
                    var i = 0;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                "odd": createPositionalPseudo(function(matchIndexes, length) {
                    var i = 1;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                "lt": createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i = argument < 0 ? argument + length : argument > length ? length : argument;
                    for(; --i >= 0;)matchIndexes.push(i);
                    return matchIndexes;
                }),
                "gt": createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i = argument < 0 ? argument + length : argument;
                    for(; ++i < length;)matchIndexes.push(i);
                    return matchIndexes;
                })
            }
        };
        Expr.pseudos["nth"] = Expr.pseudos["eq"];
        // Add button/input type pseudos
        for(i in {
            radio: true,
            checkbox: true,
            file: true,
            password: true,
            image: true
        })Expr.pseudos[i] = createInputPseudo(i);
        for(i in {
            submit: true,
            reset: true
        })Expr.pseudos[i] = createButtonPseudo(i);
        // Easy API for creating new setFilters
        function setFilters() {}
        setFilters.prototype = Expr.filters = Expr.pseudos;
        Expr.setFilters = new setFilters();
        tokenize = Sizzle.tokenize = function(selector, parseOnly) {
            var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + " "];
            if (cached) return parseOnly ? 0 : cached.slice(0);
            soFar = selector;
            groups = [];
            preFilters = Expr.preFilter;
            while(soFar){
                // Comma and first run
                if (!matched || (match = rcomma.exec(soFar))) {
                    if (match) // Don't consume trailing commas as valid
                    soFar = soFar.slice(match[0].length) || soFar;
                    groups.push(tokens = []);
                }
                matched = false;
                // Combinators
                if (match = rleadingCombinator.exec(soFar)) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        // Cast descendant combinators to space
                        type: match[0].replace(rtrim, " ")
                    });
                    soFar = soFar.slice(matched.length);
                }
                // Filters
                for(type in Expr.filter)if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        type: type,
                        matches: match
                    });
                    soFar = soFar.slice(matched.length);
                }
                if (!matched) break;
            }
            // Return the length of the invalid excess
            // if we're just parsing
            // Otherwise, throw an error or return tokens
            return parseOnly ? soFar.length : soFar ? Sizzle.error(selector) : // Cache the tokens
            tokenCache(selector, groups).slice(0);
        };
        function toSelector(tokens) {
            var i = 0, len = tokens.length, selector = "";
            for(; i < len; i++)selector += tokens[i].value;
            return selector;
        }
        function addCombinator(matcher, combinator, base) {
            var dir = combinator.dir, skip = combinator.next, key = skip || dir, checkNonElements = base && key === "parentNode", doneName = done++;
            return combinator.first ? // Check against closest ancestor/preceding element
            function(elem, context, xml) {
                while(elem = elem[dir]){
                    if (elem.nodeType === 1 || checkNonElements) return matcher(elem, context, xml);
                }
                return false;
            } : // Check against all ancestor/preceding elements
            function(elem, context, xml) {
                var oldCache, uniqueCache, outerCache, newCache = [
                    dirruns,
                    doneName
                ];
                // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
                if (xml) {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        if (matcher(elem, context, xml)) return true;
                    }
                } else {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        outerCache = elem[expando] || (elem[expando] = {});
                        // Support: IE <9 only
                        // Defend against cloned attroperties (jQuery gh-1709)
                        uniqueCache = outerCache[elem.uniqueID] || (outerCache[elem.uniqueID] = {});
                        if (skip && skip === elem.nodeName.toLowerCase()) elem = elem[dir] || elem;
                        else if ((oldCache = uniqueCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) // Assign to newCache so results back-propagate to previous elements
                        return newCache[2] = oldCache[2];
                        else {
                            // Reuse newcache so results back-propagate to previous elements
                            uniqueCache[key] = newCache;
                            // A match means we're done; a fail means we have to keep checking
                            if (newCache[2] = matcher(elem, context, xml)) return true;
                        }
                    }
                }
                return false;
            };
        }
        function elementMatcher(matchers) {
            return matchers.length > 1 ? function(elem, context, xml) {
                var i = matchers.length;
                while(i--){
                    if (!matchers[i](elem, context, xml)) return false;
                }
                return true;
            } : matchers[0];
        }
        function multipleContexts(selector, contexts, results) {
            var i = 0, len = contexts.length;
            for(; i < len; i++)Sizzle(selector, contexts[i], results);
            return results;
        }
        function condense(unmatched, map, filter, context, xml) {
            var elem, newUnmatched = [], i = 0, len = unmatched.length, mapped = map != null;
            for(; i < len; i++){
                if (elem = unmatched[i]) {
                    if (!filter || filter(elem, context, xml)) {
                        newUnmatched.push(elem);
                        if (mapped) map.push(i);
                    }
                }
            }
            return newUnmatched;
        }
        function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
            if (postFilter && !postFilter[expando]) postFilter = setMatcher(postFilter);
            if (postFinder && !postFinder[expando]) postFinder = setMatcher(postFinder, postSelector);
            return markFunction(function(seed, results, context, xml) {
                var temp, i, elem, preMap = [], postMap = [], preexisting = results.length, // Get initial elements from seed or context
                elems = seed || multipleContexts(selector || "*", context.nodeType ? [
                    context
                ] : context, []), // Prefilter to get matcher input, preserving a map for seed-results synchronization
                matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems, matcherOut = matcher ? // If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
                postFinder || (seed ? preFilter : preexisting || postFilter) ? // ...intermediate processing is necessary
                [] : // ...otherwise use results directly
                results : matcherIn;
                // Find primary matches
                if (matcher) matcher(matcherIn, matcherOut, context, xml);
                // Apply postFilter
                if (postFilter) {
                    temp = condense(matcherOut, postMap);
                    postFilter(temp, [], context, xml);
                    // Un-match failing elements by moving them back to matcherIn
                    i = temp.length;
                    while(i--)if (elem = temp[i]) matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
                }
                if (seed) {
                    if (postFinder || preFilter) {
                        if (postFinder) {
                            // Get the final matcherOut by condensing this intermediate into postFinder contexts
                            temp = [];
                            i = matcherOut.length;
                            while(i--)if (elem = matcherOut[i]) // Restore matcherIn since elem is not yet a final match
                            temp.push(matcherIn[i] = elem);
                            postFinder(null, matcherOut = [], temp, xml);
                        }
                        // Move matched elements from seed to results to keep them synchronized
                        i = matcherOut.length;
                        while(i--)if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf(seed, elem) : preMap[i]) > -1) seed[temp] = !(results[temp] = elem);
                    }
                } else {
                    matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
                    if (postFinder) postFinder(null, results, matcherOut, xml);
                    else push.apply(results, matcherOut);
                }
            });
        }
        function matcherFromTokens(tokens) {
            var checkContext, matcher, j, len = tokens.length, leadingRelative = Expr.relative[tokens[0].type], implicitRelative = leadingRelative || Expr.relative[" "], i = leadingRelative ? 1 : 0, // The foundational matcher ensures that elements are reachable from top-level context(s)
            matchContext = addCombinator(function(elem) {
                return elem === checkContext;
            }, implicitRelative, true), matchAnyContext = addCombinator(function(elem) {
                return indexOf(checkContext, elem) > -1;
            }, implicitRelative, true), matchers = [
                function(elem, context, xml) {
                    var ret = !leadingRelative && (xml || context !== outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
                    // Avoid hanging onto element (issue #299)
                    checkContext = null;
                    return ret;
                }
            ];
            for(; i < len; i++)if (matcher = Expr.relative[tokens[i].type]) matchers = [
                addCombinator(elementMatcher(matchers), matcher)
            ];
            else {
                matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);
                // Return special upon seeing a positional matcher
                if (matcher[expando]) {
                    // Find the next relative operator (if any) for proper handling
                    j = ++i;
                    for(; j < len; j++){
                        if (Expr.relative[tokens[j].type]) break;
                    }
                    return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(// If the preceding token was a descendant combinator, insert an implicit any-element `*`
                    tokens.slice(0, i - 1).concat({
                        value: tokens[i - 2].type === " " ? "*" : ""
                    })).replace(rtrim, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
                }
                matchers.push(matcher);
            }
            return elementMatcher(matchers);
        }
        function matcherFromGroupMatchers(elementMatchers, setMatchers) {
            var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function(seed, context, xml, results, outermost) {
                var elem, j, matcher, matchedCount = 0, i = "0", unmatched = seed && [], setMatched = [], contextBackup = outermostContext, // We must always have either seed elements or outermost context
                elems = seed || byElement && Expr.find["TAG"]("*", outermost), // Use integer dirruns iff this is the outermost matcher
                dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1, len = elems.length;
                if (outermost) // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                outermostContext = context == document || context || outermost;
                // Add elements passing elementMatchers directly to results
                // Support: IE<9, Safari
                // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
                for(; i !== len && (elem = elems[i]) != null; i++){
                    if (byElement && elem) {
                        j = 0;
                        // Support: IE 11+, Edge 17 - 18+
                        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                        // two documents; shallow comparisons work.
                        // eslint-disable-next-line eqeqeq
                        if (!context && elem.ownerDocument != document) {
                            setDocument(elem);
                            xml = !documentIsHTML;
                        }
                        while(matcher = elementMatchers[j++])if (matcher(elem, context || document, xml)) {
                            results.push(elem);
                            break;
                        }
                        if (outermost) dirruns = dirrunsUnique;
                    }
                    // Track unmatched elements for set filters
                    if (bySet) {
                        // They will have gone through all possible matchers
                        if (elem = !matcher && elem) matchedCount--;
                        // Lengthen the array for every element, matched or not
                        if (seed) unmatched.push(elem);
                    }
                }
                // `i` is now the count of elements visited above, and adding it to `matchedCount`
                // makes the latter nonnegative.
                matchedCount += i;
                // Apply set filters to unmatched elements
                // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
                // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
                // no element matchers and no seed.
                // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
                // case, which will result in a "00" `matchedCount` that differs from `i` but is also
                // numerically zero.
                if (bySet && i !== matchedCount) {
                    j = 0;
                    while(matcher = setMatchers[j++])matcher(unmatched, setMatched, context, xml);
                    if (seed) {
                        // Reintegrate element matches to eliminate the need for sorting
                        if (matchedCount > 0) {
                            while(i--)if (!(unmatched[i] || setMatched[i])) setMatched[i] = pop.call(results);
                        }
                        // Discard index placeholder values to get only actual matches
                        setMatched = condense(setMatched);
                    }
                    // Add matches to results
                    push.apply(results, setMatched);
                    // Seedless set matches succeeding multiple successful matchers stipulate sorting
                    if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) Sizzle.uniqueSort(results);
                }
                // Override manipulation of globals by nested matchers
                if (outermost) {
                    dirruns = dirrunsUnique;
                    outermostContext = contextBackup;
                }
                return unmatched;
            };
            return bySet ? markFunction(superMatcher) : superMatcher;
        }
        compile = Sizzle.compile = function(selector, match /* Internal Use Only */ ) {
            var i, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + " "];
            if (!cached) {
                // Generate a function of recursive functions that can be used to check each element
                if (!match) match = tokenize(selector);
                i = match.length;
                while(i--){
                    cached = matcherFromTokens(match[i]);
                    if (cached[expando]) setMatchers.push(cached);
                    else elementMatchers.push(cached);
                }
                // Cache the compiled function
                cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
                // Save selector and tokenization
                cached.selector = selector;
            }
            return cached;
        };
        /**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */ select = Sizzle.select = function(selector, context, results, seed) {
            var i, tokens, token, type, find, compiled = typeof selector === "function" && selector, match = !seed && tokenize(selector = compiled.selector || selector);
            results = results || [];
            // Try to minimize operations if there is only one selector in the list and no seed
            // (the latter of which guarantees us context)
            if (match.length === 1) {
                // Reduce context if the leading compound selector is an ID
                tokens = match[0] = match[0].slice(0);
                if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
                    context = (Expr.find["ID"](token.matches[0].replace(runescape, funescape), context) || [])[0];
                    if (!context) return results;
                    else if (compiled) context = context.parentNode;
                    selector = selector.slice(tokens.shift().value.length);
                }
                // Fetch a seed set for right-to-left matching
                i = matchExpr["needsContext"].test(selector) ? 0 : tokens.length;
                while(i--){
                    token = tokens[i];
                    // Abort if we hit a combinator
                    if (Expr.relative[type = token.type]) break;
                    if (find = Expr.find[type]) // Search, expanding context for leading sibling combinators
                    {
                        if (seed = find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
                            // If seed is empty or no tokens remain, we can return early
                            tokens.splice(i, 1);
                            selector = seed.length && toSelector(tokens);
                            if (!selector) {
                                push.apply(results, seed);
                                return results;
                            }
                            break;
                        }
                    }
                }
            }
            // Compile and execute a filtering function if one is not provided
            // Provide `match` to avoid retokenization if we modified the selector above
            (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
            return results;
        };
        // One-time assignments
        // Sort stability
        support.sortStable = expando.split("").sort(sortOrder).join("") === expando;
        // Support: Chrome 14-35+
        // Always assume duplicates if they aren't passed to the comparison function
        support.detectDuplicates = !!hasDuplicate;
        // Initialize against the default document
        setDocument();
        // Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
        // Detached nodes confoundingly follow *each other*
        support.sortDetached = assert(function(el) {
            // Should return 1, but returns 4 (following)
            return el.compareDocumentPosition(document.createElement("fieldset")) & 1;
        });
        // Support: IE<8
        // Prevent attribute/property "interpolation"
        // https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
        if (!assert(function(el) {
            el.innerHTML = "<a href='#'></a>";
            return el.firstChild.getAttribute("href") === "#";
        })) addHandle("type|href|height|width", function(elem, name, isXML) {
            if (!isXML) return elem.getAttribute(name, name.toLowerCase() === "type" ? 1 : 2);
        });
        // Support: IE<9
        // Use defaultValue in place of getAttribute("value")
        if (!support.attributes || !assert(function(el) {
            el.innerHTML = "<input/>";
            el.firstChild.setAttribute("value", "");
            return el.firstChild.getAttribute("value") === "";
        })) addHandle("value", function(elem, _name, isXML) {
            if (!isXML && elem.nodeName.toLowerCase() === "input") return elem.defaultValue;
        });
        // Support: IE<9
        // Use getAttributeNode to fetch booleans when getAttribute lies
        if (!assert(function(el) {
            return el.getAttribute("disabled") == null;
        })) addHandle(booleans, function(elem, name, isXML) {
            var val;
            if (!isXML) return elem[name] === true ? name.toLowerCase() : (val = elem.getAttributeNode(name)) && val.specified ? val.value : null;
        });
        return Sizzle;
    }(window1);
    jQuery.find = Sizzle;
    jQuery.expr = Sizzle.selectors;
    // Deprecated
    jQuery.expr[":"] = jQuery.expr.pseudos;
    jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
    jQuery.text = Sizzle.getText;
    jQuery.isXMLDoc = Sizzle.isXML;
    jQuery.contains = Sizzle.contains;
    jQuery.escapeSelector = Sizzle.escape;
    var dir = function(elem, dir, until) {
        var matched = [], truncate = until !== undefined;
        while((elem = elem[dir]) && elem.nodeType !== 9)if (elem.nodeType === 1) {
            if (truncate && jQuery(elem).is(until)) break;
            matched.push(elem);
        }
        return matched;
    };
    var siblings = function(n, elem) {
        var matched = [];
        for(; n; n = n.nextSibling)if (n.nodeType === 1 && n !== elem) matched.push(n);
        return matched;
    };
    var rneedsContext = jQuery.expr.match.needsContext;
    function nodeName(elem, name) {
        return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
    }
    var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    // Implement the identical functionality for filter and not
    function winnow(elements, qualifier, not) {
        if (isFunction(qualifier)) return jQuery.grep(elements, function(elem, i) {
            return !!qualifier.call(elem, i, elem) !== not;
        });
        // Single element
        if (qualifier.nodeType) return jQuery.grep(elements, function(elem) {
            return elem === qualifier !== not;
        });
        // Arraylike of elements (jQuery, arguments, Array)
        if (typeof qualifier !== "string") return jQuery.grep(elements, function(elem) {
            return indexOf.call(qualifier, elem) > -1 !== not;
        });
        // Filtered directly for both simple and complex selectors
        return jQuery.filter(qualifier, elements, not);
    }
    jQuery.filter = function(expr, elems, not) {
        var elem = elems[0];
        if (not) expr = ":not(" + expr + ")";
        if (elems.length === 1 && elem.nodeType === 1) return jQuery.find.matchesSelector(elem, expr) ? [
            elem
        ] : [];
        return jQuery.find.matches(expr, jQuery.grep(elems, function(elem) {
            return elem.nodeType === 1;
        }));
    };
    jQuery.fn.extend({
        find: function(selector) {
            var i, ret, len = this.length, self = this;
            if (typeof selector !== "string") return this.pushStack(jQuery(selector).filter(function() {
                for(i = 0; i < len; i++){
                    if (jQuery.contains(self[i], this)) return true;
                }
            }));
            ret = this.pushStack([]);
            for(i = 0; i < len; i++)jQuery.find(selector, self[i], ret);
            return len > 1 ? jQuery.uniqueSort(ret) : ret;
        },
        filter: function(selector) {
            return this.pushStack(winnow(this, selector || [], false));
        },
        not: function(selector) {
            return this.pushStack(winnow(this, selector || [], true));
        },
        is: function(selector) {
            return !!winnow(this, // If this is a positional/relative selector, check membership in the returned set
            // so $("p:first").is("p:last") won't return true for a doc with two "p".
            typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
        }
    });
    // Initialize a jQuery object
    // A central reference to the root jQuery(document)
    var rootjQuery, // A simple way to check for HTML strings
    // Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
    // Strict HTML recognition (trac-11290: must start with <)
    // Shortcut simple #id case for speed
    rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, init = jQuery.fn.init = function(selector, context, root) {
        var match, elem;
        // HANDLE: $(""), $(null), $(undefined), $(false)
        if (!selector) return this;
        // Method init() accepts an alternate rootjQuery
        // so migrate can support jQuery.sub (gh-2101)
        root = root || rootjQuery;
        // Handle HTML strings
        if (typeof selector === "string") {
            if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) // Assume that strings that start and end with <> are HTML and skip the regex check
            match = [
                null,
                selector,
                null
            ];
            else match = rquickExpr.exec(selector);
            // Match html or make sure no context is specified for #id
            if (match && (match[1] || !context)) {
                // HANDLE: $(html) -> $(array)
                if (match[1]) {
                    context = context instanceof jQuery ? context[0] : context;
                    // Option to run scripts is true for back-compat
                    // Intentionally let the error be thrown if parseHTML is not present
                    jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, true));
                    // HANDLE: $(html, props)
                    if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
                        for(match in context)// Properties of context are called as methods if possible
                        if (isFunction(this[match])) this[match](context[match]);
                        else this.attr(match, context[match]);
                    }
                    return this;
                // HANDLE: $(#id)
                } else {
                    elem = document.getElementById(match[2]);
                    if (elem) {
                        // Inject the element directly into the jQuery object
                        this[0] = elem;
                        this.length = 1;
                    }
                    return this;
                }
            } else if (!context || context.jquery) return (context || root).find(selector);
            else return this.constructor(context).find(selector);
        // HANDLE: $(DOMElement)
        } else if (selector.nodeType) {
            this[0] = selector;
            this.length = 1;
            return this;
        // HANDLE: $(function)
        // Shortcut for document ready
        } else if (isFunction(selector)) return root.ready !== undefined ? root.ready(selector) : // Execute immediately if ready is not present
        selector(jQuery);
        return jQuery.makeArray(selector, this);
    };
    // Give the init function the jQuery prototype for later instantiation
    init.prototype = jQuery.fn;
    // Initialize central reference
    rootjQuery = jQuery(document);
    var rparentsprev = /^(?:parents|prev(?:Until|All))/, // Methods guaranteed to produce a unique set when starting from a unique set
    guaranteedUnique = {
        children: true,
        contents: true,
        next: true,
        prev: true
    };
    jQuery.fn.extend({
        has: function(target) {
            var targets = jQuery(target, this), l = targets.length;
            return this.filter(function() {
                var i = 0;
                for(; i < l; i++){
                    if (jQuery.contains(this, targets[i])) return true;
                }
            });
        },
        closest: function(selectors, context) {
            var cur, i = 0, l = this.length, matched = [], targets = typeof selectors !== "string" && jQuery(selectors);
            // Positional selectors never match, since there's no _selection_ context
            if (!rneedsContext.test(selectors)) for(; i < l; i++){
                for(cur = this[i]; cur && cur !== context; cur = cur.parentNode)// Always skip document fragments
                if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 : // Don't pass non-elements to Sizzle
                cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {
                    matched.push(cur);
                    break;
                }
            }
            return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
        },
        // Determine the position of an element within the set
        index: function(elem) {
            // No argument, return index in parent
            if (!elem) return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            // Index in selector
            if (typeof elem === "string") return indexOf.call(jQuery(elem), this[0]);
            // Locate the position of the desired element
            return indexOf.call(this, // If it receives a jQuery object, the first element is used
            elem.jquery ? elem[0] : elem);
        },
        add: function(selector, context) {
            return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
        },
        addBack: function(selector) {
            return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
        }
    });
    function sibling(cur, dir) {
        while((cur = cur[dir]) && cur.nodeType !== 1);
        return cur;
    }
    jQuery.each({
        parent: function(elem) {
            var parent = elem.parentNode;
            return parent && parent.nodeType !== 11 ? parent : null;
        },
        parents: function(elem) {
            return dir(elem, "parentNode");
        },
        parentsUntil: function(elem, _i, until) {
            return dir(elem, "parentNode", until);
        },
        next: function(elem) {
            return sibling(elem, "nextSibling");
        },
        prev: function(elem) {
            return sibling(elem, "previousSibling");
        },
        nextAll: function(elem) {
            return dir(elem, "nextSibling");
        },
        prevAll: function(elem) {
            return dir(elem, "previousSibling");
        },
        nextUntil: function(elem, _i, until) {
            return dir(elem, "nextSibling", until);
        },
        prevUntil: function(elem, _i, until) {
            return dir(elem, "previousSibling", until);
        },
        siblings: function(elem) {
            return siblings((elem.parentNode || {}).firstChild, elem);
        },
        children: function(elem) {
            return siblings(elem.firstChild);
        },
        contents: function(elem) {
            if (elem.contentDocument != null && // Support: IE 11+
            // <object> elements with no `data` attribute has an object
            // `contentDocument` with a `null` prototype.
            getProto(elem.contentDocument)) return elem.contentDocument;
            // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
            // Treat the template element as a regular one in browsers that
            // don't support it.
            if (nodeName(elem, "template")) elem = elem.content || elem;
            return jQuery.merge([], elem.childNodes);
        }
    }, function(name, fn) {
        jQuery.fn[name] = function(until, selector) {
            var matched = jQuery.map(this, fn, until);
            if (name.slice(-5) !== "Until") selector = until;
            if (selector && typeof selector === "string") matched = jQuery.filter(selector, matched);
            if (this.length > 1) {
                // Remove duplicates
                if (!guaranteedUnique[name]) jQuery.uniqueSort(matched);
                // Reverse order for parents* and prev-derivatives
                if (rparentsprev.test(name)) matched.reverse();
            }
            return this.pushStack(matched);
        };
    });
    var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;
    // Convert String-formatted options into Object-formatted ones
    function createOptions(options) {
        var object = {};
        jQuery.each(options.match(rnothtmlwhite) || [], function(_, flag) {
            object[flag] = true;
        });
        return object;
    }
    /*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */ jQuery.Callbacks = function(options) {
        // Convert options from String-formatted to Object-formatted if needed
        // (we check in cache first)
        options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
        var firing, // Last fire value for non-forgettable lists
        memory, // Flag to know if list was already fired
        fired, // Flag to prevent firing
        locked, // Actual callback list
        list = [], // Queue of execution data for repeatable lists
        queue = [], // Index of currently firing callback (modified by add/remove as needed)
        firingIndex = -1, // Fire callbacks
        fire = function() {
            // Enforce single-firing
            locked = locked || options.once;
            // Execute callbacks for all pending executions,
            // respecting firingIndex overrides and runtime changes
            fired = firing = true;
            for(; queue.length; firingIndex = -1){
                memory = queue.shift();
                while(++firingIndex < list.length)// Run callback and check for early termination
                if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
                    // Jump to end and forget the data so .add doesn't re-fire
                    firingIndex = list.length;
                    memory = false;
                }
            }
            // Forget the data if we're done with it
            if (!options.memory) memory = false;
            firing = false;
            // Clean up if we're done firing for good
            if (locked) {
                // Keep an empty list if we have data for future add calls
                if (memory) list = [];
                else list = "";
            }
        }, // Actual Callbacks object
        self = {
            // Add a callback or a collection of callbacks to the list
            add: function() {
                if (list) {
                    // If we have memory from a past run, we should fire after adding
                    if (memory && !firing) {
                        firingIndex = list.length - 1;
                        queue.push(memory);
                    }
                    (function add(args) {
                        jQuery.each(args, function(_, arg) {
                            if (isFunction(arg)) {
                                if (!options.unique || !self.has(arg)) list.push(arg);
                            } else if (arg && arg.length && toType(arg) !== "string") // Inspect recursively
                            add(arg);
                        });
                    })(arguments);
                    if (memory && !firing) fire();
                }
                return this;
            },
            // Remove a callback from the list
            remove: function() {
                jQuery.each(arguments, function(_, arg) {
                    var index;
                    while((index = jQuery.inArray(arg, list, index)) > -1){
                        list.splice(index, 1);
                        // Handle firing indexes
                        if (index <= firingIndex) firingIndex--;
                    }
                });
                return this;
            },
            // Check if a given callback is in the list.
            // If no argument is given, return whether or not list has callbacks attached.
            has: function(fn) {
                return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
            },
            // Remove all callbacks from the list
            empty: function() {
                if (list) list = [];
                return this;
            },
            // Disable .fire and .add
            // Abort any current/pending executions
            // Clear all callbacks and values
            disable: function() {
                locked = queue = [];
                list = memory = "";
                return this;
            },
            disabled: function() {
                return !list;
            },
            // Disable .fire
            // Also disable .add unless we have memory (since it would have no effect)
            // Abort any pending executions
            lock: function() {
                locked = queue = [];
                if (!memory && !firing) list = memory = "";
                return this;
            },
            locked: function() {
                return !!locked;
            },
            // Call all callbacks with the given context and arguments
            fireWith: function(context, args) {
                if (!locked) {
                    args = args || [];
                    args = [
                        context,
                        args.slice ? args.slice() : args
                    ];
                    queue.push(args);
                    if (!firing) fire();
                }
                return this;
            },
            // Call all the callbacks with the given arguments
            fire: function() {
                self.fireWith(this, arguments);
                return this;
            },
            // To know if the callbacks have already been called at least once
            fired: function() {
                return !!fired;
            }
        };
        return self;
    };
    function Identity(v) {
        return v;
    }
    function Thrower(ex) {
        throw ex;
    }
    function adoptValue(value, resolve, reject, noValue) {
        var method;
        try {
            // Check for promise aspect first to privilege synchronous behavior
            if (value && isFunction(method = value.promise)) method.call(value).done(resolve).fail(reject);
            else if (value && isFunction(method = value.then)) method.call(value, resolve, reject);
            else // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
            // * false: [ value ].slice( 0 ) => resolve( value )
            // * true: [ value ].slice( 1 ) => resolve()
            resolve.apply(undefined, [
                value
            ].slice(noValue));
        // For Promises/A+, convert exceptions into rejections
        // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
        // Deferred#then to conditionally suppress rejection.
        } catch (value) {
            // Support: Android 4.0 only
            // Strict mode functions invoked without .call/.apply get global-object context
            reject.apply(undefined, [
                value
            ]);
        }
    }
    jQuery.extend({
        Deferred: function(func) {
            var tuples = [
                // action, add listener, callbacks,
                // ... .then handlers, argument index, [final state]
                [
                    "notify",
                    "progress",
                    jQuery.Callbacks("memory"),
                    jQuery.Callbacks("memory"),
                    2
                ],
                [
                    "resolve",
                    "done",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    0,
                    "resolved"
                ],
                [
                    "reject",
                    "fail",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    1,
                    "rejected"
                ]
            ], state = "pending", promise = {
                state: function() {
                    return state;
                },
                always: function() {
                    deferred.done(arguments).fail(arguments);
                    return this;
                },
                "catch": function(fn) {
                    return promise.then(null, fn);
                },
                // Keep pipe for back-compat
                pipe: function() {
                    var fns = arguments;
                    return jQuery.Deferred(function(newDefer) {
                        jQuery.each(tuples, function(_i, tuple) {
                            // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                            var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];
                            // deferred.progress(function() { bind to newDefer or newDefer.notify })
                            // deferred.done(function() { bind to newDefer or newDefer.resolve })
                            // deferred.fail(function() { bind to newDefer or newDefer.reject })
                            deferred[tuple[1]](function() {
                                var returned = fn && fn.apply(this, arguments);
                                if (returned && isFunction(returned.promise)) returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
                                else newDefer[tuple[0] + "With"](this, fn ? [
                                    returned
                                ] : arguments);
                            });
                        });
                        fns = null;
                    }).promise();
                },
                then: function(onFulfilled, onRejected, onProgress) {
                    var maxDepth = 0;
                    function resolve(depth, deferred, handler, special) {
                        return function() {
                            var that = this, args = arguments, mightThrow = function() {
                                var returned, then;
                                // Support: Promises/A+ section 2.3.3.3.3
                                // https://promisesaplus.com/#point-59
                                // Ignore double-resolution attempts
                                if (depth < maxDepth) return;
                                returned = handler.apply(that, args);
                                // Support: Promises/A+ section 2.3.1
                                // https://promisesaplus.com/#point-48
                                if (returned === deferred.promise()) throw new TypeError("Thenable self-resolution");
                                // Support: Promises/A+ sections 2.3.3.1, 3.5
                                // https://promisesaplus.com/#point-54
                                // https://promisesaplus.com/#point-75
                                // Retrieve `then` only once
                                then = returned && // Support: Promises/A+ section 2.3.4
                                // https://promisesaplus.com/#point-64
                                // Only check objects and functions for thenability
                                (typeof returned === "object" || typeof returned === "function") && returned.then;
                                // Handle a returned thenable
                                if (isFunction(then)) {
                                    // Special processors (notify) just wait for resolution
                                    if (special) then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special));
                                    else {
                                        // ...and disregard older resolution values
                                        maxDepth++;
                                        then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith));
                                    }
                                } else {
                                    // Only substitute handlers pass on context
                                    // and multiple values (non-spec behavior)
                                    if (handler !== Identity) {
                                        that = undefined;
                                        args = [
                                            returned
                                        ];
                                    }
                                    // Process the value(s)
                                    // Default process is resolve
                                    (special || deferred.resolveWith)(that, args);
                                }
                            }, // Only normal processors (resolve) catch and reject exceptions
                            process = special ? mightThrow : function() {
                                try {
                                    mightThrow();
                                } catch (e) {
                                    if (jQuery.Deferred.exceptionHook) jQuery.Deferred.exceptionHook(e, process.stackTrace);
                                    // Support: Promises/A+ section 2.3.3.3.4.1
                                    // https://promisesaplus.com/#point-61
                                    // Ignore post-resolution exceptions
                                    if (depth + 1 >= maxDepth) {
                                        // Only substitute handlers pass on context
                                        // and multiple values (non-spec behavior)
                                        if (handler !== Thrower) {
                                            that = undefined;
                                            args = [
                                                e
                                            ];
                                        }
                                        deferred.rejectWith(that, args);
                                    }
                                }
                            };
                            // Support: Promises/A+ section 2.3.3.3.1
                            // https://promisesaplus.com/#point-57
                            // Re-resolve promises immediately to dodge false rejection from
                            // subsequent errors
                            if (depth) process();
                            else {
                                // Call an optional hook to record the stack, in case of exception
                                // since it's otherwise lost when execution goes async
                                if (jQuery.Deferred.getStackHook) process.stackTrace = jQuery.Deferred.getStackHook();
                                window1.setTimeout(process);
                            }
                        };
                    }
                    return jQuery.Deferred(function(newDefer) {
                        // progress_handlers.add( ... )
                        tuples[0][3].add(resolve(0, newDefer, isFunction(onProgress) ? onProgress : Identity, newDefer.notifyWith));
                        // fulfilled_handlers.add( ... )
                        tuples[1][3].add(resolve(0, newDefer, isFunction(onFulfilled) ? onFulfilled : Identity));
                        // rejected_handlers.add( ... )
                        tuples[2][3].add(resolve(0, newDefer, isFunction(onRejected) ? onRejected : Thrower));
                    }).promise();
                },
                // Get a promise for this deferred
                // If obj is provided, the promise aspect is added to the object
                promise: function(obj) {
                    return obj != null ? jQuery.extend(obj, promise) : promise;
                }
            }, deferred = {};
            // Add list-specific methods
            jQuery.each(tuples, function(i, tuple) {
                var list = tuple[2], stateString = tuple[5];
                // promise.progress = list.add
                // promise.done = list.add
                // promise.fail = list.add
                promise[tuple[1]] = list.add;
                // Handle state
                if (stateString) list.add(function() {
                    // state = "resolved" (i.e., fulfilled)
                    // state = "rejected"
                    state = stateString;
                }, // rejected_callbacks.disable
                // fulfilled_callbacks.disable
                tuples[3 - i][2].disable, // rejected_handlers.disable
                // fulfilled_handlers.disable
                tuples[3 - i][3].disable, // progress_callbacks.lock
                tuples[0][2].lock, // progress_handlers.lock
                tuples[0][3].lock);
                // progress_handlers.fire
                // fulfilled_handlers.fire
                // rejected_handlers.fire
                list.add(tuple[3].fire);
                // deferred.notify = function() { deferred.notifyWith(...) }
                // deferred.resolve = function() { deferred.resolveWith(...) }
                // deferred.reject = function() { deferred.rejectWith(...) }
                deferred[tuple[0]] = function() {
                    deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
                    return this;
                };
                // deferred.notifyWith = list.fireWith
                // deferred.resolveWith = list.fireWith
                // deferred.rejectWith = list.fireWith
                deferred[tuple[0] + "With"] = list.fireWith;
            });
            // Make the deferred a promise
            promise.promise(deferred);
            // Call given func if any
            if (func) func.call(deferred, deferred);
            // All done!
            return deferred;
        },
        // Deferred helper
        when: function(singleValue) {
            var // count of uncompleted subordinates
            remaining = arguments.length, // count of unprocessed arguments
            i = remaining, // subordinate fulfillment data
            resolveContexts = Array(i), resolveValues = slice.call(arguments), // the primary Deferred
            primary = jQuery.Deferred(), // subordinate callback factory
            updateFunc = function(i) {
                return function(value) {
                    resolveContexts[i] = this;
                    resolveValues[i] = arguments.length > 1 ? slice.call(arguments) : value;
                    if (!--remaining) primary.resolveWith(resolveContexts, resolveValues);
                };
            };
            // Single- and empty arguments are adopted like Promise.resolve
            if (remaining <= 1) {
                adoptValue(singleValue, primary.done(updateFunc(i)).resolve, primary.reject, !remaining);
                // Use .then() to unwrap secondary thenables (cf. gh-3000)
                if (primary.state() === "pending" || isFunction(resolveValues[i] && resolveValues[i].then)) return primary.then();
            }
            // Multiple arguments are aggregated like Promise.all array elements
            while(i--)adoptValue(resolveValues[i], updateFunc(i), primary.reject);
            return primary.promise();
        }
    });
    // These usually indicate a programmer mistake during development,
    // warn about them ASAP rather than swallowing them by default.
    var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    jQuery.Deferred.exceptionHook = function(error, stack) {
        // Support: IE 8 - 9 only
        // Console exists when dev tools are open, which can happen at any time
        if (window1.console && window1.console.warn && error && rerrorNames.test(error.name)) window1.console.warn("jQuery.Deferred exception: " + error.message, error.stack, stack);
    };
    jQuery.readyException = function(error) {
        window1.setTimeout(function() {
            throw error;
        });
    };
    // The deferred used on DOM ready
    var readyList = jQuery.Deferred();
    jQuery.fn.ready = function(fn) {
        readyList.then(fn)// Wrap jQuery.readyException in a function so that the lookup
        // happens at the time of error handling instead of callback
        // registration.
        .catch(function(error) {
            jQuery.readyException(error);
        });
        return this;
    };
    jQuery.extend({
        // Is the DOM ready to be used? Set to true once it occurs.
        isReady: false,
        // A counter to track how many items to wait for before
        // the ready event fires. See trac-6781
        readyWait: 1,
        // Handle when the DOM is ready
        ready: function(wait) {
            // Abort if there are pending holds or we're already ready
            if (wait === true ? --jQuery.readyWait : jQuery.isReady) return;
            // Remember that the DOM is ready
            jQuery.isReady = true;
            // If a normal DOM Ready event fired, decrement, and wait if need be
            if (wait !== true && --jQuery.readyWait > 0) return;
            // If there are functions bound, to execute
            readyList.resolveWith(document, [
                jQuery
            ]);
        }
    });
    jQuery.ready.then = readyList.then;
    // The ready event handler and self cleanup method
    function completed() {
        document.removeEventListener("DOMContentLoaded", completed);
        window1.removeEventListener("load", completed);
        jQuery.ready();
    }
    // Catch cases where $(document).ready() is called
    // after the browser event has already occurred.
    // Support: IE <=9 - 10 only
    // Older IE sometimes signals "interactive" too soon
    if (document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) // Handle it asynchronously to allow scripts the opportunity to delay ready
    window1.setTimeout(jQuery.ready);
    else {
        // Use the handy event callback
        document.addEventListener("DOMContentLoaded", completed);
        // A fallback to window.onload, that will always work
        window1.addEventListener("load", completed);
    }
    // Multifunctional method to get and set values of a collection
    // The value/s can optionally be executed if it's a function
    var access = function(elems, fn, key, value, chainable, emptyGet, raw) {
        var i = 0, len = elems.length, bulk = key == null;
        // Sets many values
        if (toType(key) === "object") {
            chainable = true;
            for(i in key)access(elems, fn, i, key[i], true, emptyGet, raw);
        // Sets one value
        } else if (value !== undefined) {
            chainable = true;
            if (!isFunction(value)) raw = true;
            if (bulk) {
                // Bulk operations run against the entire set
                if (raw) {
                    fn.call(elems, value);
                    fn = null;
                // ...except when executing function values
                } else {
                    bulk = fn;
                    fn = function(elem, _key, value) {
                        return bulk.call(jQuery(elem), value);
                    };
                }
            }
            if (fn) for(; i < len; i++)fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
        }
        if (chainable) return elems;
        // Gets
        if (bulk) return fn.call(elems);
        return len ? fn(elems[0], key) : emptyGet;
    };
    // Matches dashed string for camelizing
    var rmsPrefix = /^-ms-/, rdashAlpha = /-([a-z])/g;
    // Used by camelCase as callback to replace()
    function fcamelCase(_all, letter) {
        return letter.toUpperCase();
    }
    // Convert dashed to camelCase; used by the css and data modules
    // Support: IE <=9 - 11, Edge 12 - 15
    // Microsoft forgot to hump their vendor prefix (trac-9572)
    function camelCase(string) {
        return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
    }
    var acceptData = function(owner) {
        // Accepts only:
        //  - Node
        //    - Node.ELEMENT_NODE
        //    - Node.DOCUMENT_NODE
        //  - Object
        //    - Any
        return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
    };
    function Data() {
        this.expando = jQuery.expando + Data.uid++;
    }
    Data.uid = 1;
    Data.prototype = {
        cache: function(owner) {
            // Check if the owner object already has a cache
            var value = owner[this.expando];
            // If not, create one
            if (!value) {
                value = {};
                // We can accept data for non-element nodes in modern browsers,
                // but we should not, see trac-8335.
                // Always return an empty object.
                if (acceptData(owner)) {
                    // If it is a node unlikely to be stringify-ed or looped over
                    // use plain assignment
                    if (owner.nodeType) owner[this.expando] = value;
                    else Object.defineProperty(owner, this.expando, {
                        value: value,
                        configurable: true
                    });
                }
            }
            return value;
        },
        set: function(owner, data, value) {
            var prop, cache = this.cache(owner);
            // Handle: [ owner, key, value ] args
            // Always use camelCase key (gh-2257)
            if (typeof data === "string") cache[camelCase(data)] = value;
            else // Copy the properties one-by-one to the cache object
            for(prop in data)cache[camelCase(prop)] = data[prop];
            return cache;
        },
        get: function(owner, key) {
            return key === undefined ? this.cache(owner) : // Always use camelCase key (gh-2257)
            owner[this.expando] && owner[this.expando][camelCase(key)];
        },
        access: function(owner, key, value) {
            // In cases where either:
            //
            //   1. No key was specified
            //   2. A string key was specified, but no value provided
            //
            // Take the "read" path and allow the get method to determine
            // which value to return, respectively either:
            //
            //   1. The entire cache object
            //   2. The data stored at the key
            //
            if (key === undefined || key && typeof key === "string" && value === undefined) return this.get(owner, key);
            // When the key is not a string, or both a key and value
            // are specified, set or extend (existing objects) with either:
            //
            //   1. An object of properties
            //   2. A key and value
            //
            this.set(owner, key, value);
            // Since the "set" path can have two possible entry points
            // return the expected data based on which path was taken[*]
            return value !== undefined ? value : key;
        },
        remove: function(owner, key) {
            var i, cache = owner[this.expando];
            if (cache === undefined) return;
            if (key !== undefined) {
                // Support array or space separated string of keys
                if (Array.isArray(key)) // If key is an array of keys...
                // We always set camelCase keys, so remove that.
                key = key.map(camelCase);
                else {
                    key = camelCase(key);
                    // If a key with the spaces exists, use it.
                    // Otherwise, create an array by matching non-whitespace
                    key = key in cache ? [
                        key
                    ] : key.match(rnothtmlwhite) || [];
                }
                i = key.length;
                while(i--)delete cache[key[i]];
            }
            // Remove the expando if there's no more data
            if (key === undefined || jQuery.isEmptyObject(cache)) {
                // Support: Chrome <=35 - 45
                // Webkit & Blink performance suffers when deleting properties
                // from DOM nodes, so set to undefined instead
                // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
                if (owner.nodeType) owner[this.expando] = undefined;
                else delete owner[this.expando];
            }
        },
        hasData: function(owner) {
            var cache = owner[this.expando];
            return cache !== undefined && !jQuery.isEmptyObject(cache);
        }
    };
    var dataPriv = new Data();
    var dataUser = new Data();
    //	Implementation Summary
    //
    //	1. Enforce API surface and semantic compatibility with 1.9.x branch
    //	2. Improve the module's maintainability by reducing the storage
    //		paths to a single mechanism.
    //	3. Use the same single mechanism to support "private" and "user" data.
    //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
    //	5. Avoid exposing implementation details on user objects (eg. expando properties)
    //	6. Provide a clear path for implementation upgrade to WeakMap in 2014
    var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, rmultiDash = /[A-Z]/g;
    function getData(data) {
        if (data === "true") return true;
        if (data === "false") return false;
        if (data === "null") return null;
        // Only convert to a number if it doesn't change the string
        if (data === +data + "") return +data;
        if (rbrace.test(data)) return JSON.parse(data);
        return data;
    }
    function dataAttr(elem, key, data) {
        var name;
        // If nothing was found internally, try to fetch any
        // data from the HTML5 data-* attribute
        if (data === undefined && elem.nodeType === 1) {
            name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
            data = elem.getAttribute(name);
            if (typeof data === "string") {
                try {
                    data = getData(data);
                } catch (e) {}
                // Make sure we set the data so it isn't changed later
                dataUser.set(elem, key, data);
            } else data = undefined;
        }
        return data;
    }
    jQuery.extend({
        hasData: function(elem) {
            return dataUser.hasData(elem) || dataPriv.hasData(elem);
        },
        data: function(elem, name, data) {
            return dataUser.access(elem, name, data);
        },
        removeData: function(elem, name) {
            dataUser.remove(elem, name);
        },
        // TODO: Now that all calls to _data and _removeData have been replaced
        // with direct calls to dataPriv methods, these can be deprecated.
        _data: function(elem, name, data) {
            return dataPriv.access(elem, name, data);
        },
        _removeData: function(elem, name) {
            dataPriv.remove(elem, name);
        }
    });
    jQuery.fn.extend({
        data: function(key, value) {
            var i, name, data, elem = this[0], attrs = elem && elem.attributes;
            // Gets all values
            if (key === undefined) {
                if (this.length) {
                    data = dataUser.get(elem);
                    if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
                        i = attrs.length;
                        while(i--)// Support: IE 11 only
                        // The attrs elements can be null (trac-14894)
                        if (attrs[i]) {
                            name = attrs[i].name;
                            if (name.indexOf("data-") === 0) {
                                name = camelCase(name.slice(5));
                                dataAttr(elem, name, data[name]);
                            }
                        }
                        dataPriv.set(elem, "hasDataAttrs", true);
                    }
                }
                return data;
            }
            // Sets multiple values
            if (typeof key === "object") return this.each(function() {
                dataUser.set(this, key);
            });
            return access(this, function(value) {
                var data;
                // The calling jQuery object (element matches) is not empty
                // (and therefore has an element appears at this[ 0 ]) and the
                // `value` parameter was not undefined. An empty jQuery object
                // will result in `undefined` for elem = this[ 0 ] which will
                // throw an exception if an attempt to read a data cache is made.
                if (elem && value === undefined) {
                    // Attempt to get data from the cache
                    // The key will always be camelCased in Data
                    data = dataUser.get(elem, key);
                    if (data !== undefined) return data;
                    // Attempt to "discover" the data in
                    // HTML5 custom data-* attrs
                    data = dataAttr(elem, key);
                    if (data !== undefined) return data;
                    // We tried really hard, but the data doesn't exist.
                    return;
                }
                // Set the data...
                this.each(function() {
                    // We always store the camelCased key
                    dataUser.set(this, key, value);
                });
            }, null, value, arguments.length > 1, null, true);
        },
        removeData: function(key) {
            return this.each(function() {
                dataUser.remove(this, key);
            });
        }
    });
    jQuery.extend({
        queue: function(elem, type, data) {
            var queue;
            if (elem) {
                type = (type || "fx") + "queue";
                queue = dataPriv.get(elem, type);
                // Speed up dequeue by getting out quickly if this is just a lookup
                if (data) {
                    if (!queue || Array.isArray(data)) queue = dataPriv.access(elem, type, jQuery.makeArray(data));
                    else queue.push(data);
                }
                return queue || [];
            }
        },
        dequeue: function(elem, type) {
            type = type || "fx";
            var queue = jQuery.queue(elem, type), startLength = queue.length, fn = queue.shift(), hooks = jQuery._queueHooks(elem, type), next = function() {
                jQuery.dequeue(elem, type);
            };
            // If the fx queue is dequeued, always remove the progress sentinel
            if (fn === "inprogress") {
                fn = queue.shift();
                startLength--;
            }
            if (fn) {
                // Add a progress sentinel to prevent the fx queue from being
                // automatically dequeued
                if (type === "fx") queue.unshift("inprogress");
                // Clear up the last queue stop function
                delete hooks.stop;
                fn.call(elem, next, hooks);
            }
            if (!startLength && hooks) hooks.empty.fire();
        },
        // Not public - generate a queueHooks object, or return the current one
        _queueHooks: function(elem, type) {
            var key = type + "queueHooks";
            return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
                empty: jQuery.Callbacks("once memory").add(function() {
                    dataPriv.remove(elem, [
                        type + "queue",
                        key
                    ]);
                })
            });
        }
    });
    jQuery.fn.extend({
        queue: function(type, data) {
            var setter = 2;
            if (typeof type !== "string") {
                data = type;
                type = "fx";
                setter--;
            }
            if (arguments.length < setter) return jQuery.queue(this[0], type);
            return data === undefined ? this : this.each(function() {
                var queue = jQuery.queue(this, type, data);
                // Ensure a hooks for this queue
                jQuery._queueHooks(this, type);
                if (type === "fx" && queue[0] !== "inprogress") jQuery.dequeue(this, type);
            });
        },
        dequeue: function(type) {
            return this.each(function() {
                jQuery.dequeue(this, type);
            });
        },
        clearQueue: function(type) {
            return this.queue(type || "fx", []);
        },
        // Get a promise resolved when queues of a certain type
        // are emptied (fx is the type by default)
        promise: function(type, obj) {
            var tmp, count = 1, defer = jQuery.Deferred(), elements = this, i = this.length, resolve = function() {
                if (!--count) defer.resolveWith(elements, [
                    elements
                ]);
            };
            if (typeof type !== "string") {
                obj = type;
                type = undefined;
            }
            type = type || "fx";
            while(i--){
                tmp = dataPriv.get(elements[i], type + "queueHooks");
                if (tmp && tmp.empty) {
                    count++;
                    tmp.empty.add(resolve);
                }
            }
            resolve();
            return defer.promise(obj);
        }
    });
    var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
    var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
    var cssExpand = [
        "Top",
        "Right",
        "Bottom",
        "Left"
    ];
    var documentElement = document.documentElement;
    var isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem);
    }, composed = {
        composed: true
    };
    // Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
    // Check attachment across shadow DOM boundaries when possible (gh-3504)
    // Support: iOS 10.0-10.2 only
    // Early iOS 10 versions support `attachShadow` but not `getRootNode`,
    // leading to errors. We need to check for `getRootNode`.
    if (documentElement.getRootNode) isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
    };
    var isHiddenWithinTree = function(elem, el) {
        // isHiddenWithinTree might be called from jQuery#filter function;
        // in that case, element will be second argument
        elem = el || elem;
        // Inline style trumps all
        return elem.style.display === "none" || elem.style.display === "" && // Otherwise, check computed style
        // Support: Firefox <=43 - 45
        // Disconnected elements can have computed display: none, so first confirm that elem is
        // in the document.
        isAttached(elem) && jQuery.css(elem, "display") === "none";
    };
    function adjustCSS(elem, prop, valueParts, tween) {
        var adjusted, scale, maxIterations = 20, currentValue = tween ? function() {
            return tween.cur();
        } : function() {
            return jQuery.css(elem, prop, "");
        }, initial = currentValue(), unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"), // Starting value computation is required for potential unit mismatches
        initialInUnit = elem.nodeType && (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
        if (initialInUnit && initialInUnit[3] !== unit) {
            // Support: Firefox <=54
            // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
            initial = initial / 2;
            // Trust units reported by jQuery.css
            unit = unit || initialInUnit[3];
            // Iteratively approximate from a nonzero starting point
            initialInUnit = +initial || 1;
            while(maxIterations--){
                // Evaluate and update our best guess (doubling guesses that zero out).
                // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
                jQuery.style(elem, prop, initialInUnit + unit);
                if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) maxIterations = 0;
                initialInUnit = initialInUnit / scale;
            }
            initialInUnit = initialInUnit * 2;
            jQuery.style(elem, prop, initialInUnit + unit);
            // Make sure we update the tween properties later on
            valueParts = valueParts || [];
        }
        if (valueParts) {
            initialInUnit = +initialInUnit || +initial || 0;
            // Apply relative offset (+=/-=) if specified
            adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
            if (tween) {
                tween.unit = unit;
                tween.start = initialInUnit;
                tween.end = adjusted;
            }
        }
        return adjusted;
    }
    var defaultDisplayMap = {};
    function getDefaultDisplay(elem) {
        var temp, doc = elem.ownerDocument, nodeName = elem.nodeName, display = defaultDisplayMap[nodeName];
        if (display) return display;
        temp = doc.body.appendChild(doc.createElement(nodeName));
        display = jQuery.css(temp, "display");
        temp.parentNode.removeChild(temp);
        if (display === "none") display = "block";
        defaultDisplayMap[nodeName] = display;
        return display;
    }
    function showHide(elements, show) {
        var display, elem, values = [], index = 0, length = elements.length;
        // Determine new display value for elements that need to change
        for(; index < length; index++){
            elem = elements[index];
            if (!elem.style) continue;
            display = elem.style.display;
            if (show) {
                // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
                // check is required in this first loop unless we have a nonempty display value (either
                // inline or about-to-be-restored)
                if (display === "none") {
                    values[index] = dataPriv.get(elem, "display") || null;
                    if (!values[index]) elem.style.display = "";
                }
                if (elem.style.display === "" && isHiddenWithinTree(elem)) values[index] = getDefaultDisplay(elem);
            } else if (display !== "none") {
                values[index] = "none";
                // Remember what we're overwriting
                dataPriv.set(elem, "display", display);
            }
        }
        // Set the display of the elements in a second loop to avoid constant reflow
        for(index = 0; index < length; index++)if (values[index] != null) elements[index].style.display = values[index];
        return elements;
    }
    jQuery.fn.extend({
        show: function() {
            return showHide(this, true);
        },
        hide: function() {
            return showHide(this);
        },
        toggle: function(state) {
            if (typeof state === "boolean") return state ? this.show() : this.hide();
            return this.each(function() {
                if (isHiddenWithinTree(this)) jQuery(this).show();
                else jQuery(this).hide();
            });
        }
    });
    var rcheckableType = /^(?:checkbox|radio)$/i;
    var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
    var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;
    (function() {
        var fragment = document.createDocumentFragment(), div = fragment.appendChild(document.createElement("div")), input = document.createElement("input");
        // Support: Android 4.0 - 4.3 only
        // Check state lost if the name is set (trac-11217)
        // Support: Windows Web Apps (WWA)
        // `name` and `type` must use .setAttribute for WWA (trac-14901)
        input.setAttribute("type", "radio");
        input.setAttribute("checked", "checked");
        input.setAttribute("name", "t");
        div.appendChild(input);
        // Support: Android <=4.1 only
        // Older WebKit doesn't clone checked state correctly in fragments
        support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;
        // Support: IE <=11 only
        // Make sure textarea (and checkbox) defaultValue is properly cloned
        div.innerHTML = "<textarea>x</textarea>";
        support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;
        // Support: IE <=9 only
        // IE <=9 replaces <option> tags with their contents when inserted outside of
        // the select element.
        div.innerHTML = "<option></option>";
        support.option = !!div.lastChild;
    })();
    // We have to close these tags to support XHTML (trac-13200)
    var wrapMap = {
        // XHTML parsers do not magically insert elements in the
        // same way that tag soup parsers do. So we cannot shorten
        // this by omitting <tbody> or other required elements.
        thead: [
            1,
            "<table>",
            "</table>"
        ],
        col: [
            2,
            "<table><colgroup>",
            "</colgroup></table>"
        ],
        tr: [
            2,
            "<table><tbody>",
            "</tbody></table>"
        ],
        td: [
            3,
            "<table><tbody><tr>",
            "</tr></tbody></table>"
        ],
        _default: [
            0,
            "",
            ""
        ]
    };
    wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
    wrapMap.th = wrapMap.td;
    // Support: IE <=9 only
    if (!support.option) wrapMap.optgroup = wrapMap.option = [
        1,
        "<select multiple='multiple'>",
        "</select>"
    ];
    function getAll(context, tag) {
        // Support: IE <=9 - 11 only
        // Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
        var ret;
        if (typeof context.getElementsByTagName !== "undefined") ret = context.getElementsByTagName(tag || "*");
        else if (typeof context.querySelectorAll !== "undefined") ret = context.querySelectorAll(tag || "*");
        else ret = [];
        if (tag === undefined || tag && nodeName(context, tag)) return jQuery.merge([
            context
        ], ret);
        return ret;
    }
    // Mark scripts as having already been evaluated
    function setGlobalEval(elems, refElements) {
        var i = 0, l = elems.length;
        for(; i < l; i++)dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
    }
    var rhtml = /<|&#?\w+;/;
    function buildFragment(elems, context, scripts, selection, ignored) {
        var elem, tmp, tag, wrap, attached, j, fragment = context.createDocumentFragment(), nodes = [], i = 0, l = elems.length;
        for(; i < l; i++){
            elem = elems[i];
            if (elem || elem === 0) {
                // Add nodes directly
                if (toType(elem) === "object") // Support: Android <=4.0 only, PhantomJS 1 only
                // push.apply(_, arraylike) throws on ancient WebKit
                jQuery.merge(nodes, elem.nodeType ? [
                    elem
                ] : elem);
                else if (!rhtml.test(elem)) nodes.push(context.createTextNode(elem));
                else {
                    tmp = tmp || fragment.appendChild(context.createElement("div"));
                    // Deserialize a standard representation
                    tag = (rtagName.exec(elem) || [
                        "",
                        ""
                    ])[1].toLowerCase();
                    wrap = wrapMap[tag] || wrapMap._default;
                    tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];
                    // Descend through wrappers to the right content
                    j = wrap[0];
                    while(j--)tmp = tmp.lastChild;
                    // Support: Android <=4.0 only, PhantomJS 1 only
                    // push.apply(_, arraylike) throws on ancient WebKit
                    jQuery.merge(nodes, tmp.childNodes);
                    // Remember the top-level container
                    tmp = fragment.firstChild;
                    // Ensure the created nodes are orphaned (trac-12392)
                    tmp.textContent = "";
                }
            }
        }
        // Remove wrapper from fragment
        fragment.textContent = "";
        i = 0;
        while(elem = nodes[i++]){
            // Skip elements already in the context collection (trac-4087)
            if (selection && jQuery.inArray(elem, selection) > -1) {
                if (ignored) ignored.push(elem);
                continue;
            }
            attached = isAttached(elem);
            // Append to fragment
            tmp = getAll(fragment.appendChild(elem), "script");
            // Preserve script evaluation history
            if (attached) setGlobalEval(tmp);
            // Capture executables
            if (scripts) {
                j = 0;
                while(elem = tmp[j++])if (rscriptType.test(elem.type || "")) scripts.push(elem);
            }
        }
        return fragment;
    }
    var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
    function returnTrue() {
        return true;
    }
    function returnFalse() {
        return false;
    }
    // Support: IE <=9 - 11+
    // focus() and blur() are asynchronous, except when they are no-op.
    // So expect focus to be synchronous when the element is already active,
    // and blur to be synchronous when the element is not already active.
    // (focus and blur are always synchronous in other supported browsers,
    // this just defines when we can count on it).
    function expectSync(elem, type) {
        return elem === safeActiveElement() === (type === "focus");
    }
    // Support: IE <=9 only
    // Accessing document.activeElement can throw unexpectedly
    // https://bugs.jquery.com/ticket/13393
    function safeActiveElement() {
        try {
            return document.activeElement;
        } catch (err) {}
    }
    function on(elem, types, selector, data, fn, one) {
        var origFn, type;
        // Types can be a map of types/handlers
        if (typeof types === "object") {
            // ( types-Object, selector, data )
            if (typeof selector !== "string") {
                // ( types-Object, data )
                data = data || selector;
                selector = undefined;
            }
            for(type in types)on(elem, type, selector, data, types[type], one);
            return elem;
        }
        if (data == null && fn == null) {
            // ( types, fn )
            fn = selector;
            data = selector = undefined;
        } else if (fn == null) {
            if (typeof selector === "string") {
                // ( types, selector, fn )
                fn = data;
                data = undefined;
            } else {
                // ( types, data, fn )
                fn = data;
                data = selector;
                selector = undefined;
            }
        }
        if (fn === false) fn = returnFalse;
        else if (!fn) return elem;
        if (one === 1) {
            origFn = fn;
            fn = function(event) {
                // Can use an empty set, since event contains the info
                jQuery().off(event);
                return origFn.apply(this, arguments);
            };
            // Use same guid so caller can remove using origFn
            fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
        }
        return elem.each(function() {
            jQuery.event.add(this, types, fn, data, selector);
        });
    }
    /*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */ jQuery.event = {
        global: {},
        add: function(elem, types, handler, data, selector) {
            var handleObjIn, eventHandle, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.get(elem);
            // Only attach events to objects that accept data
            if (!acceptData(elem)) return;
            // Caller can pass in an object of custom data in lieu of the handler
            if (handler.handler) {
                handleObjIn = handler;
                handler = handleObjIn.handler;
                selector = handleObjIn.selector;
            }
            // Ensure that invalid selectors throw exceptions at attach time
            // Evaluate against documentElement in case elem is a non-element node (e.g., document)
            if (selector) jQuery.find.matchesSelector(documentElement, selector);
            // Make sure that the handler has a unique ID, used to find/remove it later
            if (!handler.guid) handler.guid = jQuery.guid++;
            // Init the element's event structure and main handler, if this is the first
            if (!(events = elemData.events)) events = elemData.events = Object.create(null);
            if (!(eventHandle = elemData.handle)) eventHandle = elemData.handle = function(e) {
                // Discard the second event of a jQuery.event.trigger() and
                // when an event is called after a page has unloaded
                return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
            };
            // Handle multiple events separated by a space
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // There *must* be a type, no attaching namespace-only handlers
                if (!type) continue;
                // If event changes its type, use the special event handlers for the changed type
                special = jQuery.event.special[type] || {};
                // If selector defined, determine special event api type, otherwise given type
                type = (selector ? special.delegateType : special.bindType) || type;
                // Update special based on newly reset type
                special = jQuery.event.special[type] || {};
                // handleObj is passed to all event handlers
                handleObj = jQuery.extend({
                    type: type,
                    origType: origType,
                    data: data,
                    handler: handler,
                    guid: handler.guid,
                    selector: selector,
                    needsContext: selector && jQuery.expr.match.needsContext.test(selector),
                    namespace: namespaces.join(".")
                }, handleObjIn);
                // Init the event handler queue if we're the first
                if (!(handlers = events[type])) {
                    handlers = events[type] = [];
                    handlers.delegateCount = 0;
                    // Only use addEventListener if the special events handler returns false
                    if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
                        if (elem.addEventListener) elem.addEventListener(type, eventHandle);
                    }
                }
                if (special.add) {
                    special.add.call(elem, handleObj);
                    if (!handleObj.handler.guid) handleObj.handler.guid = handler.guid;
                }
                // Add to the element's handler list, delegates in front
                if (selector) handlers.splice(handlers.delegateCount++, 0, handleObj);
                else handlers.push(handleObj);
                // Keep track of which events have ever been used, for event optimization
                jQuery.event.global[type] = true;
            }
        },
        // Detach an event or set of events from an element
        remove: function(elem, types, handler, selector, mappedTypes) {
            var j, origCount, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
            if (!elemData || !(events = elemData.events)) return;
            // Once for each type.namespace in types; type may be omitted
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // Unbind all events (on this namespace, if provided) for the element
                if (!type) {
                    for(type in events)jQuery.event.remove(elem, type + types[t], handler, selector, true);
                    continue;
                }
                special = jQuery.event.special[type] || {};
                type = (selector ? special.delegateType : special.bindType) || type;
                handlers = events[type] || [];
                tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
                // Remove matching events
                origCount = j = handlers.length;
                while(j--){
                    handleObj = handlers[j];
                    if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
                        handlers.splice(j, 1);
                        if (handleObj.selector) handlers.delegateCount--;
                        if (special.remove) special.remove.call(elem, handleObj);
                    }
                }
                // Remove generic event handler if we removed something and no more handlers exist
                // (avoids potential for endless recursion during removal of special event handlers)
                if (origCount && !handlers.length) {
                    if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) jQuery.removeEvent(elem, type, elemData.handle);
                    delete events[type];
                }
            }
            // Remove data and the expando if it's no longer used
            if (jQuery.isEmptyObject(events)) dataPriv.remove(elem, "handle events");
        },
        dispatch: function(nativeEvent) {
            var i, j, ret, matched, handleObj, handlerQueue, args = new Array(arguments.length), // Make a writable jQuery.Event from the native event object
            event = jQuery.event.fix(nativeEvent), handlers = (dataPriv.get(this, "events") || Object.create(null))[event.type] || [], special = jQuery.event.special[event.type] || {};
            // Use the fix-ed jQuery.Event rather than the (read-only) native event
            args[0] = event;
            for(i = 1; i < arguments.length; i++)args[i] = arguments[i];
            event.delegateTarget = this;
            // Call the preDispatch hook for the mapped type, and let it bail if desired
            if (special.preDispatch && special.preDispatch.call(this, event) === false) return;
            // Determine handlers
            handlerQueue = jQuery.event.handlers.call(this, event, handlers);
            // Run delegates first; they may want to stop propagation beneath us
            i = 0;
            while((matched = handlerQueue[i++]) && !event.isPropagationStopped()){
                event.currentTarget = matched.elem;
                j = 0;
                while((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped())// If the event is namespaced, then each handler is only invoked if it is
                // specially universal or its namespaces are a superset of the event's.
                if (!event.rnamespace || handleObj.namespace === false || event.rnamespace.test(handleObj.namespace)) {
                    event.handleObj = handleObj;
                    event.data = handleObj.data;
                    ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
                    if (ret !== undefined) {
                        if ((event.result = ret) === false) {
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    }
                }
            }
            // Call the postDispatch hook for the mapped type
            if (special.postDispatch) special.postDispatch.call(this, event);
            return event.result;
        },
        handlers: function(event, handlers) {
            var i, handleObj, sel, matchedHandlers, matchedSelectors, handlerQueue = [], delegateCount = handlers.delegateCount, cur = event.target;
            // Find delegate handlers
            if (delegateCount && // Support: IE <=9
            // Black-hole SVG <use> instance trees (trac-13180)
            cur.nodeType && // Support: Firefox <=42
            // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
            // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
            // Support: IE 11 only
            // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
            !(event.type === "click" && event.button >= 1)) {
                for(; cur !== this; cur = cur.parentNode || this)// Don't check non-elements (trac-13208)
                // Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
                if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
                    matchedHandlers = [];
                    matchedSelectors = {};
                    for(i = 0; i < delegateCount; i++){
                        handleObj = handlers[i];
                        // Don't conflict with Object.prototype properties (trac-13203)
                        sel = handleObj.selector + " ";
                        if (matchedSelectors[sel] === undefined) matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [
                            cur
                        ]).length;
                        if (matchedSelectors[sel]) matchedHandlers.push(handleObj);
                    }
                    if (matchedHandlers.length) handlerQueue.push({
                        elem: cur,
                        handlers: matchedHandlers
                    });
                }
            }
            // Add the remaining (directly-bound) handlers
            cur = this;
            if (delegateCount < handlers.length) handlerQueue.push({
                elem: cur,
                handlers: handlers.slice(delegateCount)
            });
            return handlerQueue;
        },
        addProp: function(name, hook) {
            Object.defineProperty(jQuery.Event.prototype, name, {
                enumerable: true,
                configurable: true,
                get: isFunction(hook) ? function() {
                    if (this.originalEvent) return hook(this.originalEvent);
                } : function() {
                    if (this.originalEvent) return this.originalEvent[name];
                },
                set: function(value) {
                    Object.defineProperty(this, name, {
                        enumerable: true,
                        configurable: true,
                        writable: true,
                        value: value
                    });
                }
            });
        },
        fix: function(originalEvent) {
            return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
        },
        special: {
            load: {
                // Prevent triggered image.load events from bubbling to window.load
                noBubble: true
            },
            click: {
                // Utilize native event to ensure correct state for checkable inputs
                setup: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Claim the first handler
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) // dataPriv.set( el, "click", ... )
                    leverageNative(el, "click", returnTrue);
                    // Return false to allow normal processing in the caller
                    return false;
                },
                trigger: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Force setup before triggering a click
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) leverageNative(el, "click");
                    // Return non-false to allow normal event-path propagation
                    return true;
                },
                // For cross-browser consistency, suppress native .click() on links
                // Also prevent it if we're currently inside a leveraged native-event stack
                _default: function(event) {
                    var target = event.target;
                    return rcheckableType.test(target.type) && target.click && nodeName(target, "input") && dataPriv.get(target, "click") || nodeName(target, "a");
                }
            },
            beforeunload: {
                postDispatch: function(event) {
                    // Support: Firefox 20+
                    // Firefox doesn't alert if the returnValue field is not set.
                    if (event.result !== undefined && event.originalEvent) event.originalEvent.returnValue = event.result;
                }
            }
        }
    };
    // Ensure the presence of an event listener that handles manually-triggered
    // synthetic events by interrupting progress until reinvoked in response to
    // *native* events that it fires directly, ensuring that state changes have
    // already occurred before other listeners are invoked.
    function leverageNative(el, type, expectSync) {
        // Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
        if (!expectSync) {
            if (dataPriv.get(el, type) === undefined) jQuery.event.add(el, type, returnTrue);
            return;
        }
        // Register the controller as a special universal handler for all event namespaces
        dataPriv.set(el, type, false);
        jQuery.event.add(el, type, {
            namespace: false,
            handler: function(event) {
                var notAsync, result, saved = dataPriv.get(this, type);
                if (event.isTrigger & 1 && this[type]) {
                    // Interrupt processing of the outer synthetic .trigger()ed event
                    // Saved data should be false in such cases, but might be a leftover capture object
                    // from an async native handler (gh-4350)
                    if (!saved.length) {
                        // Store arguments for use when handling the inner native event
                        // There will always be at least one argument (an event object), so this array
                        // will not be confused with a leftover capture object.
                        saved = slice.call(arguments);
                        dataPriv.set(this, type, saved);
                        // Trigger the native event and capture its result
                        // Support: IE <=9 - 11+
                        // focus() and blur() are asynchronous
                        notAsync = expectSync(this, type);
                        this[type]();
                        result = dataPriv.get(this, type);
                        if (saved !== result || notAsync) dataPriv.set(this, type, false);
                        else result = {};
                        if (saved !== result) {
                            // Cancel the outer synthetic event
                            event.stopImmediatePropagation();
                            event.preventDefault();
                            // Support: Chrome 86+
                            // In Chrome, if an element having a focusout handler is blurred by
                            // clicking outside of it, it invokes the handler synchronously. If
                            // that handler calls `.remove()` on the element, the data is cleared,
                            // leaving `result` undefined. We need to guard against this.
                            return result && result.value;
                        }
                    // If this is an inner synthetic event for an event with a bubbling surrogate
                    // (focus or blur), assume that the surrogate already propagated from triggering the
                    // native event and prevent that from happening again here.
                    // This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
                    // bubbling surrogate propagates *after* the non-bubbling base), but that seems
                    // less bad than duplication.
                    } else if ((jQuery.event.special[type] || {}).delegateType) event.stopPropagation();
                // If this is a native event triggered above, everything is now in order
                // Fire an inner synthetic event with the original arguments
                } else if (saved.length) {
                    // ...and capture the result
                    dataPriv.set(this, type, {
                        value: jQuery.event.trigger(// Support: IE <=9 - 11+
                        // Extend with the prototype to reset the above stopImmediatePropagation()
                        jQuery.extend(saved[0], jQuery.Event.prototype), saved.slice(1), this)
                    });
                    // Abort handling of the native event
                    event.stopImmediatePropagation();
                }
            }
        });
    }
    jQuery.removeEvent = function(elem, type, handle) {
        // This "if" is needed for plain objects
        if (elem.removeEventListener) elem.removeEventListener(type, handle);
    };
    jQuery.Event = function(src, props) {
        // Allow instantiation without the 'new' keyword
        if (!(this instanceof jQuery.Event)) return new jQuery.Event(src, props);
        // Event object
        if (src && src.type) {
            this.originalEvent = src;
            this.type = src.type;
            // Events bubbling up the document may have been marked as prevented
            // by a handler lower down the tree; reflect the correct value.
            this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === undefined && // Support: Android <=2.3 only
            src.returnValue === false ? returnTrue : returnFalse;
            // Create target properties
            // Support: Safari <=6 - 7 only
            // Target should not be a text node (trac-504, trac-13143)
            this.target = src.target && src.target.nodeType === 3 ? src.target.parentNode : src.target;
            this.currentTarget = src.currentTarget;
            this.relatedTarget = src.relatedTarget;
        // Event type
        } else this.type = src;
        // Put explicitly provided properties onto the event object
        if (props) jQuery.extend(this, props);
        // Create a timestamp if incoming event doesn't have one
        this.timeStamp = src && src.timeStamp || Date.now();
        // Mark it as fixed
        this[jQuery.expando] = true;
    };
    // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
    // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
    jQuery.Event.prototype = {
        constructor: jQuery.Event,
        isDefaultPrevented: returnFalse,
        isPropagationStopped: returnFalse,
        isImmediatePropagationStopped: returnFalse,
        isSimulated: false,
        preventDefault: function() {
            var e = this.originalEvent;
            this.isDefaultPrevented = returnTrue;
            if (e && !this.isSimulated) e.preventDefault();
        },
        stopPropagation: function() {
            var e = this.originalEvent;
            this.isPropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopPropagation();
        },
        stopImmediatePropagation: function() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopImmediatePropagation();
            this.stopPropagation();
        }
    };
    // Includes all common event props including KeyEvent and MouseEvent specific props
    jQuery.each({
        altKey: true,
        bubbles: true,
        cancelable: true,
        changedTouches: true,
        ctrlKey: true,
        detail: true,
        eventPhase: true,
        metaKey: true,
        pageX: true,
        pageY: true,
        shiftKey: true,
        view: true,
        "char": true,
        code: true,
        charCode: true,
        key: true,
        keyCode: true,
        button: true,
        buttons: true,
        clientX: true,
        clientY: true,
        offsetX: true,
        offsetY: true,
        pointerId: true,
        pointerType: true,
        screenX: true,
        screenY: true,
        targetTouches: true,
        toElement: true,
        touches: true,
        which: true
    }, jQuery.event.addProp);
    jQuery.each({
        focus: "focusin",
        blur: "focusout"
    }, function(type, delegateType) {
        jQuery.event.special[type] = {
            // Utilize native event if possible so blur/focus sequence is correct
            setup: function() {
                // Claim the first handler
                // dataPriv.set( this, "focus", ... )
                // dataPriv.set( this, "blur", ... )
                leverageNative(this, type, expectSync);
                // Return false to allow normal processing in the caller
                return false;
            },
            trigger: function() {
                // Force setup before trigger
                leverageNative(this, type);
                // Return non-false to allow normal event-path propagation
                return true;
            },
            // Suppress native focus or blur if we're currently inside
            // a leveraged native-event stack
            _default: function(event) {
                return dataPriv.get(event.target, type);
            },
            delegateType: delegateType
        };
    });
    // Create mouseenter/leave events using mouseover/out and event-time checks
    // so that event delegation works in jQuery.
    // Do the same for pointerenter/pointerleave and pointerover/pointerout
    //
    // Support: Safari 7 only
    // Safari sends mouseenter too often; see:
    // https://bugs.chromium.org/p/chromium/issues/detail?id=470258
    // for the description of the bug (it existed in older Chrome versions as well).
    jQuery.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(orig, fix) {
        jQuery.event.special[orig] = {
            delegateType: fix,
            bindType: fix,
            handle: function(event) {
                var ret, target = this, related = event.relatedTarget, handleObj = event.handleObj;
                // For mouseenter/leave call the handler if related is outside the target.
                // NB: No relatedTarget if the mouse left/entered the browser window
                if (!related || related !== target && !jQuery.contains(target, related)) {
                    event.type = handleObj.origType;
                    ret = handleObj.handler.apply(this, arguments);
                    event.type = fix;
                }
                return ret;
            }
        };
    });
    jQuery.fn.extend({
        on: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn);
        },
        one: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn, 1);
        },
        off: function(types, selector, fn) {
            var handleObj, type;
            if (types && types.preventDefault && types.handleObj) {
                // ( event )  dispatched jQuery.Event
                handleObj = types.handleObj;
                jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
                return this;
            }
            if (typeof types === "object") {
                // ( types-object [, selector] )
                for(type in types)this.off(type, selector, types[type]);
                return this;
            }
            if (selector === false || typeof selector === "function") {
                // ( types [, fn] )
                fn = selector;
                selector = undefined;
            }
            if (fn === false) fn = returnFalse;
            return this.each(function() {
                jQuery.event.remove(this, types, fn, selector);
            });
        }
    });
    var // Support: IE <=10 - 11, Edge 12 - 13 only
    // In IE/Edge using regex groups here causes severe slowdowns.
    // See https://connect.microsoft.com/IE/feedback/details/1736512/
    rnoInnerhtml = /<script|<style|<link/i, // checked="checked" or checked
    rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i, rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
    // Prefer a tbody over its parent table for containing new rows
    function manipulationTarget(elem, content) {
        if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) return jQuery(elem).children("tbody")[0] || elem;
        return elem;
    }
    // Replace/restore the type attribute of script elements for safe DOM manipulation
    function disableScript(elem) {
        elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
        return elem;
    }
    function restoreScript(elem) {
        if ((elem.type || "").slice(0, 5) === "true/") elem.type = elem.type.slice(5);
        else elem.removeAttribute("type");
        return elem;
    }
    function cloneCopyEvent(src, dest) {
        var i, l, type, pdataOld, udataOld, udataCur, events;
        if (dest.nodeType !== 1) return;
        // 1. Copy private data: events, handlers, etc.
        if (dataPriv.hasData(src)) {
            pdataOld = dataPriv.get(src);
            events = pdataOld.events;
            if (events) {
                dataPriv.remove(dest, "handle events");
                for(type in events)for(i = 0, l = events[type].length; i < l; i++)jQuery.event.add(dest, type, events[type][i]);
            }
        }
        // 2. Copy user data
        if (dataUser.hasData(src)) {
            udataOld = dataUser.access(src);
            udataCur = jQuery.extend({}, udataOld);
            dataUser.set(dest, udataCur);
        }
    }
    // Fix IE bugs, see support tests
    function fixInput(src, dest) {
        var nodeName = dest.nodeName.toLowerCase();
        // Fails to persist the checked state of a cloned checkbox or radio button.
        if (nodeName === "input" && rcheckableType.test(src.type)) dest.checked = src.checked;
        else if (nodeName === "input" || nodeName === "textarea") dest.defaultValue = src.defaultValue;
    }
    function domManip(collection, args, callback, ignored) {
        // Flatten any nested arrays
        args = flat(args);
        var fragment, first, scripts, hasScripts, node, doc, i = 0, l = collection.length, iNoClone = l - 1, value = args[0], valueIsFunction = isFunction(value);
        // We can't cloneNode fragments that contain checked, in WebKit
        if (valueIsFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) return collection.each(function(index) {
            var self = collection.eq(index);
            if (valueIsFunction) args[0] = value.call(this, index, self.html());
            domManip(self, args, callback, ignored);
        });
        if (l) {
            fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
            first = fragment.firstChild;
            if (fragment.childNodes.length === 1) fragment = first;
            // Require either new content or an interest in ignored elements to invoke the callback
            if (first || ignored) {
                scripts = jQuery.map(getAll(fragment, "script"), disableScript);
                hasScripts = scripts.length;
                // Use the original fragment for the last item
                // instead of the first because it can end up
                // being emptied incorrectly in certain situations (trac-8070).
                for(; i < l; i++){
                    node = fragment;
                    if (i !== iNoClone) {
                        node = jQuery.clone(node, true, true);
                        // Keep references to cloned scripts for later restoration
                        if (hasScripts) // Support: Android <=4.0 only, PhantomJS 1 only
                        // push.apply(_, arraylike) throws on ancient WebKit
                        jQuery.merge(scripts, getAll(node, "script"));
                    }
                    callback.call(collection[i], node, i);
                }
                if (hasScripts) {
                    doc = scripts[scripts.length - 1].ownerDocument;
                    // Reenable scripts
                    jQuery.map(scripts, restoreScript);
                    // Evaluate executable scripts on first document insertion
                    for(i = 0; i < hasScripts; i++){
                        node = scripts[i];
                        if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery.contains(doc, node)) {
                            if (node.src && (node.type || "").toLowerCase() !== "module") // Optional AJAX dependency, but won't run scripts if not present
                            {
                                if (jQuery._evalUrl && !node.noModule) jQuery._evalUrl(node.src, {
                                    nonce: node.nonce || node.getAttribute("nonce")
                                }, doc);
                            } else // Unwrap a CDATA section containing script contents. This shouldn't be
                            // needed as in XML documents they're already not visible when
                            // inspecting element contents and in HTML documents they have no
                            // meaning but we're preserving that logic for backwards compatibility.
                            // This will be removed completely in 4.0. See gh-4904.
                            DOMEval(node.textContent.replace(rcleanScript, ""), node, doc);
                        }
                    }
                }
            }
        }
        return collection;
    }
    function remove(elem, selector, keepData) {
        var node, nodes = selector ? jQuery.filter(selector, elem) : elem, i = 0;
        for(; (node = nodes[i]) != null; i++){
            if (!keepData && node.nodeType === 1) jQuery.cleanData(getAll(node));
            if (node.parentNode) {
                if (keepData && isAttached(node)) setGlobalEval(getAll(node, "script"));
                node.parentNode.removeChild(node);
            }
        }
        return elem;
    }
    jQuery.extend({
        htmlPrefilter: function(html) {
            return html;
        },
        clone: function(elem, dataAndEvents, deepDataAndEvents) {
            var i, l, srcElements, destElements, clone = elem.cloneNode(true), inPage = isAttached(elem);
            // Fix IE cloning issues
            if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
                // We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
                destElements = getAll(clone);
                srcElements = getAll(elem);
                for(i = 0, l = srcElements.length; i < l; i++)fixInput(srcElements[i], destElements[i]);
            }
            // Copy the events from the original to the clone
            if (dataAndEvents) {
                if (deepDataAndEvents) {
                    srcElements = srcElements || getAll(elem);
                    destElements = destElements || getAll(clone);
                    for(i = 0, l = srcElements.length; i < l; i++)cloneCopyEvent(srcElements[i], destElements[i]);
                } else cloneCopyEvent(elem, clone);
            }
            // Preserve script evaluation history
            destElements = getAll(clone, "script");
            if (destElements.length > 0) setGlobalEval(destElements, !inPage && getAll(elem, "script"));
            // Return the cloned set
            return clone;
        },
        cleanData: function(elems) {
            var data, elem, type, special = jQuery.event.special, i = 0;
            for(; (elem = elems[i]) !== undefined; i++)if (acceptData(elem)) {
                if (data = elem[dataPriv.expando]) {
                    if (data.events) {
                        for(type in data.events)if (special[type]) jQuery.event.remove(elem, type);
                        else jQuery.removeEvent(elem, type, data.handle);
                    }
                    // Support: Chrome <=35 - 45+
                    // Assign undefined instead of using delete, see Data#remove
                    elem[dataPriv.expando] = undefined;
                }
                if (elem[dataUser.expando]) // Support: Chrome <=35 - 45+
                // Assign undefined instead of using delete, see Data#remove
                elem[dataUser.expando] = undefined;
            }
        }
    });
    jQuery.fn.extend({
        detach: function(selector) {
            return remove(this, selector, true);
        },
        remove: function(selector) {
            return remove(this, selector);
        },
        text: function(value) {
            return access(this, function(value) {
                return value === undefined ? jQuery.text(this) : this.empty().each(function() {
                    if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) this.textContent = value;
                });
            }, null, value, arguments.length);
        },
        append: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.appendChild(elem);
                }
            });
        },
        prepend: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.insertBefore(elem, target.firstChild);
                }
            });
        },
        before: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this);
            });
        },
        after: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this.nextSibling);
            });
        },
        empty: function() {
            var elem, i = 0;
            for(; (elem = this[i]) != null; i++)if (elem.nodeType === 1) {
                // Prevent memory leaks
                jQuery.cleanData(getAll(elem, false));
                // Remove any remaining nodes
                elem.textContent = "";
            }
            return this;
        },
        clone: function(dataAndEvents, deepDataAndEvents) {
            dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
            deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
            return this.map(function() {
                return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
            });
        },
        html: function(value) {
            return access(this, function(value) {
                var elem = this[0] || {}, i = 0, l = this.length;
                if (value === undefined && elem.nodeType === 1) return elem.innerHTML;
                // See if we can take a shortcut and just use innerHTML
                if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || [
                    "",
                    ""
                ])[1].toLowerCase()]) {
                    value = jQuery.htmlPrefilter(value);
                    try {
                        for(; i < l; i++){
                            elem = this[i] || {};
                            // Remove element nodes and prevent memory leaks
                            if (elem.nodeType === 1) {
                                jQuery.cleanData(getAll(elem, false));
                                elem.innerHTML = value;
                            }
                        }
                        elem = 0;
                    // If using innerHTML throws an exception, use the fallback method
                    } catch (e) {}
                }
                if (elem) this.empty().append(value);
            }, null, value, arguments.length);
        },
        replaceWith: function() {
            var ignored = [];
            // Make the changes, replacing each non-ignored context element with the new content
            return domManip(this, arguments, function(elem) {
                var parent = this.parentNode;
                if (jQuery.inArray(this, ignored) < 0) {
                    jQuery.cleanData(getAll(this));
                    if (parent) parent.replaceChild(elem, this);
                }
            // Force callback invocation
            }, ignored);
        }
    });
    jQuery.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(name, original) {
        jQuery.fn[name] = function(selector) {
            var elems, ret = [], insert = jQuery(selector), last = insert.length - 1, i = 0;
            for(; i <= last; i++){
                elems = i === last ? this : this.clone(true);
                jQuery(insert[i])[original](elems);
                // Support: Android <=4.0 only, PhantomJS 1 only
                // .get() because push.apply(_, arraylike) throws on ancient WebKit
                push.apply(ret, elems.get());
            }
            return this.pushStack(ret);
        };
    });
    var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
    var rcustomProp = /^--/;
    var getStyles = function(elem) {
        // Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
        // IE throws on elements created in popups
        // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
        var view = elem.ownerDocument.defaultView;
        if (!view || !view.opener) view = window1;
        return view.getComputedStyle(elem);
    };
    var swap = function(elem, options, callback) {
        var ret, name, old = {};
        // Remember the old values, and insert the new ones
        for(name in options){
            old[name] = elem.style[name];
            elem.style[name] = options[name];
        }
        ret = callback.call(elem);
        // Revert the old values
        for(name in options)elem.style[name] = old[name];
        return ret;
    };
    var rboxStyle = new RegExp(cssExpand.join("|"), "i");
    var whitespace = "[\\x20\\t\\r\\n\\f]";
    var rtrimCSS = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g");
    (function() {
        // Executing both pixelPosition & boxSizingReliable tests require only one layout
        // so they're executed at the same time to save the second computation.
        function computeStyleTests() {
            // This is a singleton, we need to execute it only once
            if (!div) return;
            container.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0";
            div.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%";
            documentElement.appendChild(container).appendChild(div);
            var divStyle = window1.getComputedStyle(div);
            pixelPositionVal = divStyle.top !== "1%";
            // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
            reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;
            // Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
            // Some styles come back with percentage values, even though they shouldn't
            div.style.right = "60%";
            pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;
            // Support: IE 9 - 11 only
            // Detect misreporting of content dimensions for box-sizing:border-box elements
            boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;
            // Support: IE 9 only
            // Detect overflow:scroll screwiness (gh-3699)
            // Support: Chrome <=64
            // Don't get tricked when zoom affects offsetWidth (gh-4029)
            div.style.position = "absolute";
            scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;
            documentElement.removeChild(container);
            // Nullify the div so it wouldn't be stored in the memory and
            // it will also be a sign that checks already performed
            div = null;
        }
        function roundPixelMeasures(measure) {
            return Math.round(parseFloat(measure));
        }
        var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal, reliableTrDimensionsVal, reliableMarginLeftVal, container = document.createElement("div"), div = document.createElement("div");
        // Finish early in limited (non-browser) environments
        if (!div.style) return;
        // Support: IE <=9 - 11 only
        // Style of cloned element affects source element cloned (trac-8908)
        div.style.backgroundClip = "content-box";
        div.cloneNode(true).style.backgroundClip = "";
        support.clearCloneStyle = div.style.backgroundClip === "content-box";
        jQuery.extend(support, {
            boxSizingReliable: function() {
                computeStyleTests();
                return boxSizingReliableVal;
            },
            pixelBoxStyles: function() {
                computeStyleTests();
                return pixelBoxStylesVal;
            },
            pixelPosition: function() {
                computeStyleTests();
                return pixelPositionVal;
            },
            reliableMarginLeft: function() {
                computeStyleTests();
                return reliableMarginLeftVal;
            },
            scrollboxSize: function() {
                computeStyleTests();
                return scrollboxSizeVal;
            },
            // Support: IE 9 - 11+, Edge 15 - 18+
            // IE/Edge misreport `getComputedStyle` of table rows with width/height
            // set in CSS while `offset*` properties report correct values.
            // Behavior in IE 9 is more subtle than in newer versions & it passes
            // some versions of this test; make sure not to make it pass there!
            //
            // Support: Firefox 70+
            // Only Firefox includes border widths
            // in computed dimensions. (gh-4529)
            reliableTrDimensions: function() {
                var table, tr, trChild, trStyle;
                if (reliableTrDimensionsVal == null) {
                    table = document.createElement("table");
                    tr = document.createElement("tr");
                    trChild = document.createElement("div");
                    table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
                    tr.style.cssText = "border:1px solid";
                    // Support: Chrome 86+
                    // Height set through cssText does not get applied.
                    // Computed height then comes back as 0.
                    tr.style.height = "1px";
                    trChild.style.height = "9px";
                    // Support: Android 8 Chrome 86+
                    // In our bodyBackground.html iframe,
                    // display for all div elements is set to "inline",
                    // which causes a problem only in Android 8 Chrome 86.
                    // Ensuring the div is display: block
                    // gets around this issue.
                    trChild.style.display = "block";
                    documentElement.appendChild(table).appendChild(tr).appendChild(trChild);
                    trStyle = window1.getComputedStyle(tr);
                    reliableTrDimensionsVal = parseInt(trStyle.height, 10) + parseInt(trStyle.borderTopWidth, 10) + parseInt(trStyle.borderBottomWidth, 10) === tr.offsetHeight;
                    documentElement.removeChild(table);
                }
                return reliableTrDimensionsVal;
            }
        });
    })();
    function curCSS(elem, name, computed) {
        var width, minWidth, maxWidth, ret, isCustomProp = rcustomProp.test(name), // Support: Firefox 51+
        // Retrieving style before computed somehow
        // fixes an issue with getting wrong values
        // on detached elements
        style = elem.style;
        computed = computed || getStyles(elem);
        // getPropertyValue is needed for:
        //   .css('filter') (IE 9 only, trac-12537)
        //   .css('--customProperty) (gh-3144)
        if (computed) {
            // Support: IE <=9 - 11+
            // IE only supports `"float"` in `getPropertyValue`; in computed styles
            // it's only available as `"cssFloat"`. We no longer modify properties
            // sent to `.css()` apart from camelCasing, so we need to check both.
            // Normally, this would create difference in behavior: if
            // `getPropertyValue` returns an empty string, the value returned
            // by `.css()` would be `undefined`. This is usually the case for
            // disconnected elements. However, in IE even disconnected elements
            // with no styles return `"none"` for `getPropertyValue( "float" )`
            ret = computed.getPropertyValue(name) || computed[name];
            if (isCustomProp && ret) // Support: Firefox 105+, Chrome <=105+
            // Spec requires trimming whitespace for custom properties (gh-4926).
            // Firefox only trims leading whitespace. Chrome just collapses
            // both leading & trailing whitespace to a single space.
            //
            // Fall back to `undefined` if empty string returned.
            // This collapses a missing definition with property defined
            // and set to an empty string but there's no standard API
            // allowing us to differentiate them without a performance penalty
            // and returning `undefined` aligns with older jQuery.
            //
            // rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
            // as whitespace while CSS does not, but this is not a problem
            // because CSS preprocessing replaces them with U+000A LINE FEED
            // (which *is* CSS whitespace)
            // https://www.w3.org/TR/css-syntax-3/#input-preprocessing
            ret = ret.replace(rtrimCSS, "$1") || undefined;
            if (ret === "" && !isAttached(elem)) ret = jQuery.style(elem, name);
            // A tribute to the "awesome hack by Dean Edwards"
            // Android Browser returns percentage for some values,
            // but width seems to be reliably pixels.
            // This is against the CSSOM draft spec:
            // https://drafts.csswg.org/cssom/#resolved-values
            if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {
                // Remember the original values
                width = style.width;
                minWidth = style.minWidth;
                maxWidth = style.maxWidth;
                // Put in the new values to get a computed value out
                style.minWidth = style.maxWidth = style.width = ret;
                ret = computed.width;
                // Revert the changed values
                style.width = width;
                style.minWidth = minWidth;
                style.maxWidth = maxWidth;
            }
        }
        return ret !== undefined ? // Support: IE <=9 - 11 only
        // IE returns zIndex value as an integer.
        ret + "" : ret;
    }
    function addGetHookIf(conditionFn, hookFn) {
        // Define the hook, we'll check on the first run if it's really needed.
        return {
            get: function() {
                if (conditionFn()) {
                    // Hook not needed (or it's not possible to use it due
                    // to missing dependency), remove it.
                    delete this.get;
                    return;
                }
                // Hook needed; redefine it so that the support test is not executed again.
                return (this.get = hookFn).apply(this, arguments);
            }
        };
    }
    var cssPrefixes = [
        "Webkit",
        "Moz",
        "ms"
    ], emptyStyle = document.createElement("div").style, vendorProps = {};
    // Return a vendor-prefixed property or undefined
    function vendorPropName(name) {
        // Check for vendor prefixed names
        var capName = name[0].toUpperCase() + name.slice(1), i = cssPrefixes.length;
        while(i--){
            name = cssPrefixes[i] + capName;
            if (name in emptyStyle) return name;
        }
    }
    // Return a potentially-mapped jQuery.cssProps or vendor prefixed property
    function finalPropName(name) {
        var final = jQuery.cssProps[name] || vendorProps[name];
        if (final) return final;
        if (name in emptyStyle) return name;
        return vendorProps[name] = vendorPropName(name) || name;
    }
    var // Swappable if display is none or starts with table
    // except "table", "table-cell", or "table-caption"
    // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
    rdisplayswap = /^(none|table(?!-c[ea]).+)/, cssShow = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }, cssNormalTransform = {
        letterSpacing: "0",
        fontWeight: "400"
    };
    function setPositiveNumber(_elem, value, subtract) {
        // Any relative (+/-) values have already been
        // normalized at this point
        var matches = rcssNum.exec(value);
        return matches ? // Guard against undefined "subtract", e.g., when used as in cssHooks
        Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
    }
    function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
        var i = dimension === "width" ? 1 : 0, extra = 0, delta = 0;
        // Adjustment may not be necessary
        if (box === (isBorderBox ? "border" : "content")) return 0;
        for(; i < 4; i += 2){
            // Both box models exclude margin
            if (box === "margin") delta += jQuery.css(elem, box + cssExpand[i], true, styles);
            // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
            if (!isBorderBox) {
                // Add padding
                delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "border" or "margin", add border
                if (box !== "padding") delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
                else extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            // If we get here with a border-box (content + padding + border), we're seeking "content" or
            // "padding" or "margin"
            } else {
                // For "content", subtract padding
                if (box === "content") delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "content" or "padding", subtract border
                if (box !== "margin") delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            }
        }
        // Account for positive content-box scroll gutter when requested by providing computedVal
        if (!isBorderBox && computedVal >= 0) // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
        // Assuming integer scroll gutter, subtract the rest and round down
        delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5)) || 0;
        return delta;
    }
    function getWidthOrHeight(elem, dimension, extra) {
        // Start with computed style
        var styles = getStyles(elem), // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
        // Fake content-box until we know it's needed to know the true value.
        boxSizingNeeded = !support.boxSizingReliable() || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", valueIsBorderBox = isBorderBox, val = curCSS(elem, dimension, styles), offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);
        // Support: Firefox <=54
        // Return a confounding non-pixel value or feign ignorance, as appropriate.
        if (rnumnonpx.test(val)) {
            if (!extra) return val;
            val = "auto";
        }
        // Support: IE 9 - 11 only
        // Use offsetWidth/offsetHeight for when box sizing is unreliable.
        // In those cases, the computed value can be trusted to be border-box.
        if ((!support.boxSizingReliable() && isBorderBox || // Support: IE 10 - 11+, Edge 15 - 18+
        // IE/Edge misreport `getComputedStyle` of table rows with width/height
        // set in CSS while `offset*` properties report correct values.
        // Interestingly, in some cases IE 9 doesn't suffer from this issue.
        !support.reliableTrDimensions() && nodeName(elem, "tr") || // Fall back to offsetWidth/offsetHeight when value is "auto"
        // This happens for inline elements with no explicit setting (gh-3571)
        val === "auto" || // Support: Android <=4.1 - 4.3 only
        // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
        !parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") && // Make sure the element is visible & connected
        elem.getClientRects().length) {
            isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";
            // Where available, offsetWidth/offsetHeight approximate border box dimensions.
            // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
            // retrieved value as a content box dimension.
            valueIsBorderBox = offsetProp in elem;
            if (valueIsBorderBox) val = elem[offsetProp];
        }
        // Normalize "" and auto
        val = parseFloat(val) || 0;
        // Adjust for the element's box model
        return val + boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles, // Provide the current computed size to request scroll gutter calculation (gh-3589)
        val) + "px";
    }
    jQuery.extend({
        // Add in style property hooks for overriding the default
        // behavior of getting and setting a style property
        cssHooks: {
            opacity: {
                get: function(elem, computed) {
                    if (computed) {
                        // We should always get a number back from opacity
                        var ret = curCSS(elem, "opacity");
                        return ret === "" ? "1" : ret;
                    }
                }
            }
        },
        // Don't automatically add "px" to these possibly-unitless properties
        cssNumber: {
            "animationIterationCount": true,
            "columnCount": true,
            "fillOpacity": true,
            "flexGrow": true,
            "flexShrink": true,
            "fontWeight": true,
            "gridArea": true,
            "gridColumn": true,
            "gridColumnEnd": true,
            "gridColumnStart": true,
            "gridRow": true,
            "gridRowEnd": true,
            "gridRowStart": true,
            "lineHeight": true,
            "opacity": true,
            "order": true,
            "orphans": true,
            "widows": true,
            "zIndex": true,
            "zoom": true
        },
        // Add in properties whose names you wish to fix before
        // setting or getting the value
        cssProps: {},
        // Get and set the style property on a DOM Node
        style: function(elem, name, value, extra) {
            // Don't set styles on text and comment nodes
            if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) return;
            // Make sure that we're working with the right name
            var ret, type, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name), style = elem.style;
            // Make sure that we're working with the right name. We don't
            // want to query the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Gets hook for the prefixed version, then unprefixed version
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // Check if we're setting a value
            if (value !== undefined) {
                type = typeof value;
                // Convert "+=" or "-=" to relative numbers (trac-7345)
                if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
                    value = adjustCSS(elem, name, ret);
                    // Fixes bug trac-9237
                    type = "number";
                }
                // Make sure that null and NaN values aren't set (trac-7116)
                if (value == null || value !== value) return;
                // If a number was passed in, add the unit (except for certain CSS properties)
                // The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
                // "px" to a few hardcoded values.
                if (type === "number" && !isCustomProp) value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
                // background-* props affect original clone's values
                if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) style[name] = "inherit";
                // If a hook was provided, use that value, otherwise just set the specified value
                if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
                    if (isCustomProp) style.setProperty(name, value);
                    else style[name] = value;
                }
            } else {
                // If a hook was provided get the non-computed value from there
                if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) return ret;
                // Otherwise just get the value from the style object
                return style[name];
            }
        },
        css: function(elem, name, extra, styles) {
            var val, num, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name);
            // Make sure that we're working with the right name. We don't
            // want to modify the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Try prefixed name followed by the unprefixed name
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // If a hook was provided get the computed value from there
            if (hooks && "get" in hooks) val = hooks.get(elem, true, extra);
            // Otherwise, if a way to get the computed value exists, use that
            if (val === undefined) val = curCSS(elem, name, styles);
            // Convert "normal" to computed value
            if (val === "normal" && name in cssNormalTransform) val = cssNormalTransform[name];
            // Make numeric if forced or a qualifier was provided and val looks numeric
            if (extra === "" || extra) {
                num = parseFloat(val);
                return extra === true || isFinite(num) ? num || 0 : val;
            }
            return val;
        }
    });
    jQuery.each([
        "height",
        "width"
    ], function(_i, dimension) {
        jQuery.cssHooks[dimension] = {
            get: function(elem, computed, extra) {
                if (computed) // Certain elements can have dimension info if we invisibly show them
                // but it must have a current display style that would benefit
                return rdisplayswap.test(jQuery.css(elem, "display")) && // Support: Safari 8+
                // Table columns in Safari have non-zero offsetWidth & zero
                // getBoundingClientRect().width unless display is changed.
                // Support: IE <=11 only
                // Running getBoundingClientRect on a disconnected node
                // in IE throws an error.
                (!elem.getClientRects().length || !elem.getBoundingClientRect().width) ? swap(elem, cssShow, function() {
                    return getWidthOrHeight(elem, dimension, extra);
                }) : getWidthOrHeight(elem, dimension, extra);
            },
            set: function(elem, value, extra) {
                var matches, styles = getStyles(elem), // Only read styles.position if the test has a chance to fail
                // to avoid forcing a reflow.
                scrollboxSizeBuggy = !support.scrollboxSize() && styles.position === "absolute", // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
                boxSizingNeeded = scrollboxSizeBuggy || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", subtract = extra ? boxModelAdjustment(elem, dimension, extra, isBorderBox, styles) : 0;
                // Account for unreliable border-box dimensions by comparing offset* to computed and
                // faking a content-box to get border and padding (gh-3699)
                if (isBorderBox && scrollboxSizeBuggy) subtract -= Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - parseFloat(styles[dimension]) - boxModelAdjustment(elem, dimension, "border", false, styles) - 0.5);
                // Convert to pixels if value adjustment is needed
                if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
                    elem.style[dimension] = value;
                    value = jQuery.css(elem, dimension);
                }
                return setPositiveNumber(elem, value, subtract);
            }
        };
    });
    jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function(elem, computed) {
        if (computed) return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap(elem, {
            marginLeft: 0
        }, function() {
            return elem.getBoundingClientRect().left;
        })) + "px";
    });
    // These hooks are used by animate to expand properties
    jQuery.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(prefix, suffix) {
        jQuery.cssHooks[prefix + suffix] = {
            expand: function(value) {
                var i = 0, expanded = {}, // Assumes a single number if not a string
                parts = typeof value === "string" ? value.split(" ") : [
                    value
                ];
                for(; i < 4; i++)expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
                return expanded;
            }
        };
        if (prefix !== "margin") jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
    });
    jQuery.fn.extend({
        css: function(name, value) {
            return access(this, function(elem, name, value) {
                var styles, len, map = {}, i = 0;
                if (Array.isArray(name)) {
                    styles = getStyles(elem);
                    len = name.length;
                    for(; i < len; i++)map[name[i]] = jQuery.css(elem, name[i], false, styles);
                    return map;
                }
                return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
            }, name, value, arguments.length > 1);
        }
    });
    function Tween(elem, options, prop, end, easing) {
        return new Tween.prototype.init(elem, options, prop, end, easing);
    }
    jQuery.Tween = Tween;
    Tween.prototype = {
        constructor: Tween,
        init: function(elem, options, prop, end, easing, unit) {
            this.elem = elem;
            this.prop = prop;
            this.easing = easing || jQuery.easing._default;
            this.options = options;
            this.start = this.now = this.cur();
            this.end = end;
            this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
        },
        cur: function() {
            var hooks = Tween.propHooks[this.prop];
            return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
        },
        run: function(percent) {
            var eased, hooks = Tween.propHooks[this.prop];
            if (this.options.duration) this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
            else this.pos = eased = percent;
            this.now = (this.end - this.start) * eased + this.start;
            if (this.options.step) this.options.step.call(this.elem, this.now, this);
            if (hooks && hooks.set) hooks.set(this);
            else Tween.propHooks._default.set(this);
            return this;
        }
    };
    Tween.prototype.init.prototype = Tween.prototype;
    Tween.propHooks = {
        _default: {
            get: function(tween) {
                var result;
                // Use a property on the element directly when it is not a DOM element,
                // or when there is no matching style property that exists.
                if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) return tween.elem[tween.prop];
                // Passing an empty string as a 3rd parameter to .css will automatically
                // attempt a parseFloat and fallback to a string if the parse fails.
                // Simple values such as "10px" are parsed to Float;
                // complex values such as "rotate(1rad)" are returned as-is.
                result = jQuery.css(tween.elem, tween.prop, "");
                // Empty strings, null, undefined and "auto" are converted to 0.
                return !result || result === "auto" ? 0 : result;
            },
            set: function(tween) {
                // Use step hook for back compat.
                // Use cssHook if its there.
                // Use .style if available and use plain properties where available.
                if (jQuery.fx.step[tween.prop]) jQuery.fx.step[tween.prop](tween);
                else if (tween.elem.nodeType === 1 && (jQuery.cssHooks[tween.prop] || tween.elem.style[finalPropName(tween.prop)] != null)) jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
                else tween.elem[tween.prop] = tween.now;
            }
        }
    };
    // Support: IE <=9 only
    // Panic based approach to setting things on disconnected nodes
    Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
        set: function(tween) {
            if (tween.elem.nodeType && tween.elem.parentNode) tween.elem[tween.prop] = tween.now;
        }
    };
    jQuery.easing = {
        linear: function(p) {
            return p;
        },
        swing: function(p) {
            return 0.5 - Math.cos(p * Math.PI) / 2;
        },
        _default: "swing"
    };
    jQuery.fx = Tween.prototype.init;
    // Back compat <1.8 extension point
    jQuery.fx.step = {};
    var fxNow, inProgress, rfxtypes = /^(?:toggle|show|hide)$/, rrun = /queueHooks$/;
    function schedule() {
        if (inProgress) {
            if (document.hidden === false && window1.requestAnimationFrame) window1.requestAnimationFrame(schedule);
            else window1.setTimeout(schedule, jQuery.fx.interval);
            jQuery.fx.tick();
        }
    }
    // Animations created synchronously will run synchronously
    function createFxNow() {
        window1.setTimeout(function() {
            fxNow = undefined;
        });
        return fxNow = Date.now();
    }
    // Generate parameters to create a standard animation
    function genFx(type, includeWidth) {
        var which, i = 0, attrs = {
            height: type
        };
        // If we include width, step value is 1 to do all cssExpand values,
        // otherwise step value is 2 to skip over Left and Right
        includeWidth = includeWidth ? 1 : 0;
        for(; i < 4; i += 2 - includeWidth){
            which = cssExpand[i];
            attrs["margin" + which] = attrs["padding" + which] = type;
        }
        if (includeWidth) attrs.opacity = attrs.width = type;
        return attrs;
    }
    function createTween(value, prop, animation) {
        var tween, collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]), index = 0, length = collection.length;
        for(; index < length; index++){
            if (tween = collection[index].call(animation, prop, value)) // We're done with this property
            return tween;
        }
    }
    function defaultPrefilter(elem, props, opts) {
        var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display, isBox = "width" in props || "height" in props, anim = this, orig = {}, style = elem.style, hidden = elem.nodeType && isHiddenWithinTree(elem), dataShow = dataPriv.get(elem, "fxshow");
        // Queue-skipping animations hijack the fx hooks
        if (!opts.queue) {
            hooks = jQuery._queueHooks(elem, "fx");
            if (hooks.unqueued == null) {
                hooks.unqueued = 0;
                oldfire = hooks.empty.fire;
                hooks.empty.fire = function() {
                    if (!hooks.unqueued) oldfire();
                };
            }
            hooks.unqueued++;
            anim.always(function() {
                // Ensure the complete handler is called before this completes
                anim.always(function() {
                    hooks.unqueued--;
                    if (!jQuery.queue(elem, "fx").length) hooks.empty.fire();
                });
            });
        }
        // Detect show/hide animations
        for(prop in props){
            value = props[prop];
            if (rfxtypes.test(value)) {
                delete props[prop];
                toggle = toggle || value === "toggle";
                if (value === (hidden ? "hide" : "show")) {
                    // Pretend to be hidden if this is a "show" and
                    // there is still data from a stopped show/hide
                    if (value === "show" && dataShow && dataShow[prop] !== undefined) hidden = true;
                    else continue;
                }
                orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
            }
        }
        // Bail out if this is a no-op like .hide().hide()
        propTween = !jQuery.isEmptyObject(props);
        if (!propTween && jQuery.isEmptyObject(orig)) return;
        // Restrict "overflow" and "display" styles during box animations
        if (isBox && elem.nodeType === 1) {
            // Support: IE <=9 - 11, Edge 12 - 15
            // Record all 3 overflow attributes because IE does not infer the shorthand
            // from identically-valued overflowX and overflowY and Edge just mirrors
            // the overflowX value there.
            opts.overflow = [
                style.overflow,
                style.overflowX,
                style.overflowY
            ];
            // Identify a display type, preferring old show/hide data over the CSS cascade
            restoreDisplay = dataShow && dataShow.display;
            if (restoreDisplay == null) restoreDisplay = dataPriv.get(elem, "display");
            display = jQuery.css(elem, "display");
            if (display === "none") {
                if (restoreDisplay) display = restoreDisplay;
                else {
                    // Get nonempty value(s) by temporarily forcing visibility
                    showHide([
                        elem
                    ], true);
                    restoreDisplay = elem.style.display || restoreDisplay;
                    display = jQuery.css(elem, "display");
                    showHide([
                        elem
                    ]);
                }
            }
            // Animate inline elements as inline-block
            if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
                if (jQuery.css(elem, "float") === "none") {
                    // Restore the original display value at the end of pure show/hide animations
                    if (!propTween) {
                        anim.done(function() {
                            style.display = restoreDisplay;
                        });
                        if (restoreDisplay == null) {
                            display = style.display;
                            restoreDisplay = display === "none" ? "" : display;
                        }
                    }
                    style.display = "inline-block";
                }
            }
        }
        if (opts.overflow) {
            style.overflow = "hidden";
            anim.always(function() {
                style.overflow = opts.overflow[0];
                style.overflowX = opts.overflow[1];
                style.overflowY = opts.overflow[2];
            });
        }
        // Implement show/hide animations
        propTween = false;
        for(prop in orig){
            // General show/hide setup for this element animation
            if (!propTween) {
                if (dataShow) {
                    if ("hidden" in dataShow) hidden = dataShow.hidden;
                } else dataShow = dataPriv.access(elem, "fxshow", {
                    display: restoreDisplay
                });
                // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
                if (toggle) dataShow.hidden = !hidden;
                // Show elements before animating them
                if (hidden) showHide([
                    elem
                ], true);
                /* eslint-disable no-loop-func */ anim.done(function() {
                    /* eslint-enable no-loop-func */ // The final step of a "hide" animation is actually hiding the element
                    if (!hidden) showHide([
                        elem
                    ]);
                    dataPriv.remove(elem, "fxshow");
                    for(prop in orig)jQuery.style(elem, prop, orig[prop]);
                });
            }
            // Per-property setup
            propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
            if (!(prop in dataShow)) {
                dataShow[prop] = propTween.start;
                if (hidden) {
                    propTween.end = propTween.start;
                    propTween.start = 0;
                }
            }
        }
    }
    function propFilter(props, specialEasing) {
        var index, name, easing, value, hooks;
        // camelCase, specialEasing and expand cssHook pass
        for(index in props){
            name = camelCase(index);
            easing = specialEasing[name];
            value = props[index];
            if (Array.isArray(value)) {
                easing = value[1];
                value = props[index] = value[0];
            }
            if (index !== name) {
                props[name] = value;
                delete props[index];
            }
            hooks = jQuery.cssHooks[name];
            if (hooks && "expand" in hooks) {
                value = hooks.expand(value);
                delete props[name];
                // Not quite $.extend, this won't overwrite existing keys.
                // Reusing 'index' because we have the correct "name"
                for(index in value)if (!(index in props)) {
                    props[index] = value[index];
                    specialEasing[index] = easing;
                }
            } else specialEasing[name] = easing;
        }
    }
    function Animation(elem, properties, options) {
        var result, stopped, index = 0, length = Animation.prefilters.length, deferred = jQuery.Deferred().always(function() {
            // Don't match elem in the :animated selector
            delete tick.elem;
        }), tick = function() {
            if (stopped) return false;
            var currentTime = fxNow || createFxNow(), remaining = Math.max(0, animation.startTime + animation.duration - currentTime), // Support: Android 2.3 only
            // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
            temp = remaining / animation.duration || 0, percent = 1 - temp, index = 0, length = animation.tweens.length;
            for(; index < length; index++)animation.tweens[index].run(percent);
            deferred.notifyWith(elem, [
                animation,
                percent,
                remaining
            ]);
            // If there's more to do, yield
            if (percent < 1 && length) return remaining;
            // If this was an empty animation, synthesize a final progress notification
            if (!length) deferred.notifyWith(elem, [
                animation,
                1,
                0
            ]);
            // Resolve the animation and report its conclusion
            deferred.resolveWith(elem, [
                animation
            ]);
            return false;
        }, animation = deferred.promise({
            elem: elem,
            props: jQuery.extend({}, properties),
            opts: jQuery.extend(true, {
                specialEasing: {},
                easing: jQuery.easing._default
            }, options),
            originalProperties: properties,
            originalOptions: options,
            startTime: fxNow || createFxNow(),
            duration: options.duration,
            tweens: [],
            createTween: function(prop, end) {
                var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
                animation.tweens.push(tween);
                return tween;
            },
            stop: function(gotoEnd) {
                var index = 0, // If we are going to the end, we want to run all the tweens
                // otherwise we skip this part
                length = gotoEnd ? animation.tweens.length : 0;
                if (stopped) return this;
                stopped = true;
                for(; index < length; index++)animation.tweens[index].run(1);
                // Resolve when we played the last frame; otherwise, reject
                if (gotoEnd) {
                    deferred.notifyWith(elem, [
                        animation,
                        1,
                        0
                    ]);
                    deferred.resolveWith(elem, [
                        animation,
                        gotoEnd
                    ]);
                } else deferred.rejectWith(elem, [
                    animation,
                    gotoEnd
                ]);
                return this;
            }
        }), props = animation.props;
        propFilter(props, animation.opts.specialEasing);
        for(; index < length; index++){
            result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
            if (result) {
                if (isFunction(result.stop)) jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
                return result;
            }
        }
        jQuery.map(props, createTween, animation);
        if (isFunction(animation.opts.start)) animation.opts.start.call(elem, animation);
        // Attach callbacks from options
        animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
        jQuery.fx.timer(jQuery.extend(tick, {
            elem: elem,
            anim: animation,
            queue: animation.opts.queue
        }));
        return animation;
    }
    jQuery.Animation = jQuery.extend(Animation, {
        tweeners: {
            "*": [
                function(prop, value) {
                    var tween = this.createTween(prop, value);
                    adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
                    return tween;
                }
            ]
        },
        tweener: function(props, callback) {
            if (isFunction(props)) {
                callback = props;
                props = [
                    "*"
                ];
            } else props = props.match(rnothtmlwhite);
            var prop, index = 0, length = props.length;
            for(; index < length; index++){
                prop = props[index];
                Animation.tweeners[prop] = Animation.tweeners[prop] || [];
                Animation.tweeners[prop].unshift(callback);
            }
        },
        prefilters: [
            defaultPrefilter
        ],
        prefilter: function(callback, prepend) {
            if (prepend) Animation.prefilters.unshift(callback);
            else Animation.prefilters.push(callback);
        }
    });
    jQuery.speed = function(speed, easing, fn) {
        var opt = speed && typeof speed === "object" ? jQuery.extend({}, speed) : {
            complete: fn || !fn && easing || isFunction(speed) && speed,
            duration: speed,
            easing: fn && easing || easing && !isFunction(easing) && easing
        };
        // Go to the end state if fx are off
        if (jQuery.fx.off) opt.duration = 0;
        else if (typeof opt.duration !== "number") {
            if (opt.duration in jQuery.fx.speeds) opt.duration = jQuery.fx.speeds[opt.duration];
            else opt.duration = jQuery.fx.speeds._default;
        }
        // Normalize opt.queue - true/undefined/null -> "fx"
        if (opt.queue == null || opt.queue === true) opt.queue = "fx";
        // Queueing
        opt.old = opt.complete;
        opt.complete = function() {
            if (isFunction(opt.old)) opt.old.call(this);
            if (opt.queue) jQuery.dequeue(this, opt.queue);
        };
        return opt;
    };
    jQuery.fn.extend({
        fadeTo: function(speed, to, easing, callback) {
            // Show any hidden elements after setting opacity to 0
            return this.filter(isHiddenWithinTree).css("opacity", 0).show()// Animate to the value specified
            .end().animate({
                opacity: to
            }, speed, easing, callback);
        },
        animate: function(prop, speed, easing, callback) {
            var empty = jQuery.isEmptyObject(prop), optall = jQuery.speed(speed, easing, callback), doAnimation = function() {
                // Operate on a copy of prop so per-property easing won't be lost
                var anim = Animation(this, jQuery.extend({}, prop), optall);
                // Empty animations, or finishing resolves immediately
                if (empty || dataPriv.get(this, "finish")) anim.stop(true);
            };
            doAnimation.finish = doAnimation;
            return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
        },
        stop: function(type, clearQueue, gotoEnd) {
            var stopQueue = function(hooks) {
                var stop = hooks.stop;
                delete hooks.stop;
                stop(gotoEnd);
            };
            if (typeof type !== "string") {
                gotoEnd = clearQueue;
                clearQueue = type;
                type = undefined;
            }
            if (clearQueue) this.queue(type || "fx", []);
            return this.each(function() {
                var dequeue = true, index = type != null && type + "queueHooks", timers = jQuery.timers, data = dataPriv.get(this);
                if (index) {
                    if (data[index] && data[index].stop) stopQueue(data[index]);
                } else {
                    for(index in data)if (data[index] && data[index].stop && rrun.test(index)) stopQueue(data[index]);
                }
                for(index = timers.length; index--;)if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
                    timers[index].anim.stop(gotoEnd);
                    dequeue = false;
                    timers.splice(index, 1);
                }
                // Start the next in the queue if the last step wasn't forced.
                // Timers currently will call their complete callbacks, which
                // will dequeue but only if they were gotoEnd.
                if (dequeue || !gotoEnd) jQuery.dequeue(this, type);
            });
        },
        finish: function(type) {
            if (type !== false) type = type || "fx";
            return this.each(function() {
                var index, data = dataPriv.get(this), queue = data[type + "queue"], hooks = data[type + "queueHooks"], timers = jQuery.timers, length = queue ? queue.length : 0;
                // Enable finishing flag on private data
                data.finish = true;
                // Empty the queue first
                jQuery.queue(this, type, []);
                if (hooks && hooks.stop) hooks.stop.call(this, true);
                // Look for any active animations, and finish them
                for(index = timers.length; index--;)if (timers[index].elem === this && timers[index].queue === type) {
                    timers[index].anim.stop(true);
                    timers.splice(index, 1);
                }
                // Look for any animations in the old queue and finish them
                for(index = 0; index < length; index++)if (queue[index] && queue[index].finish) queue[index].finish.call(this);
                // Turn off finishing flag
                delete data.finish;
            });
        }
    });
    jQuery.each([
        "toggle",
        "show",
        "hide"
    ], function(_i, name) {
        var cssFn = jQuery.fn[name];
        jQuery.fn[name] = function(speed, easing, callback) {
            return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
        };
    });
    // Generate shortcuts for custom animations
    jQuery.each({
        slideDown: genFx("show"),
        slideUp: genFx("hide"),
        slideToggle: genFx("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(name, props) {
        jQuery.fn[name] = function(speed, easing, callback) {
            return this.animate(props, speed, easing, callback);
        };
    });
    jQuery.timers = [];
    jQuery.fx.tick = function() {
        var timer, i = 0, timers = jQuery.timers;
        fxNow = Date.now();
        for(; i < timers.length; i++){
            timer = timers[i];
            // Run the timer and safely remove it when done (allowing for external removal)
            if (!timer() && timers[i] === timer) timers.splice(i--, 1);
        }
        if (!timers.length) jQuery.fx.stop();
        fxNow = undefined;
    };
    jQuery.fx.timer = function(timer) {
        jQuery.timers.push(timer);
        jQuery.fx.start();
    };
    jQuery.fx.interval = 13;
    jQuery.fx.start = function() {
        if (inProgress) return;
        inProgress = true;
        schedule();
    };
    jQuery.fx.stop = function() {
        inProgress = null;
    };
    jQuery.fx.speeds = {
        slow: 600,
        fast: 200,
        // Default speed
        _default: 400
    };
    // Based off of the plugin by Clint Helfers, with permission.
    jQuery.fn.delay = function(time, type) {
        time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
        type = type || "fx";
        return this.queue(type, function(next, hooks) {
            var timeout = window1.setTimeout(next, time);
            hooks.stop = function() {
                window1.clearTimeout(timeout);
            };
        });
    };
    (function() {
        var input = document.createElement("input"), select = document.createElement("select"), opt = select.appendChild(document.createElement("option"));
        input.type = "checkbox";
        // Support: Android <=4.3 only
        // Default value for a checkbox should be "on"
        support.checkOn = input.value !== "";
        // Support: IE <=11 only
        // Must access selectedIndex to make default options select
        support.optSelected = opt.selected;
        // Support: IE <=11 only
        // An input loses its value after becoming a radio
        input = document.createElement("input");
        input.value = "t";
        input.type = "radio";
        support.radioValue = input.value === "t";
    })();
    var boolHook, attrHandle = jQuery.expr.attrHandle;
    jQuery.fn.extend({
        attr: function(name, value) {
            return access(this, jQuery.attr, name, value, arguments.length > 1);
        },
        removeAttr: function(name) {
            return this.each(function() {
                jQuery.removeAttr(this, name);
            });
        }
    });
    jQuery.extend({
        attr: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set attributes on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            // Fallback to prop when attributes are not supported
            if (typeof elem.getAttribute === "undefined") return jQuery.prop(elem, name, value);
            // Attribute hooks are determined by the lowercase version
            // Grab necessary hook if one is defined
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) hooks = jQuery.attrHooks[name.toLowerCase()] || (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
            if (value !== undefined) {
                if (value === null) {
                    jQuery.removeAttr(elem, name);
                    return;
                }
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                elem.setAttribute(name, value + "");
                return value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            ret = jQuery.find.attr(elem, name);
            // Non-existent attributes return null, we normalize to undefined
            return ret == null ? undefined : ret;
        },
        attrHooks: {
            type: {
                set: function(elem, value) {
                    if (!support.radioValue && value === "radio" && nodeName(elem, "input")) {
                        var val = elem.value;
                        elem.setAttribute("type", value);
                        if (val) elem.value = val;
                        return value;
                    }
                }
            }
        },
        removeAttr: function(elem, value) {
            var name, i = 0, // Attribute names can contain non-HTML whitespace characters
            // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
            attrNames = value && value.match(rnothtmlwhite);
            if (attrNames && elem.nodeType === 1) while(name = attrNames[i++])elem.removeAttribute(name);
        }
    });
    // Hooks for boolean attributes
    boolHook = {
        set: function(elem, value, name) {
            if (value === false) // Remove boolean attributes when set to false
            jQuery.removeAttr(elem, name);
            else elem.setAttribute(name, name);
            return name;
        }
    };
    jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function(_i, name) {
        var getter = attrHandle[name] || jQuery.find.attr;
        attrHandle[name] = function(elem, name, isXML) {
            var ret, handle, lowercaseName = name.toLowerCase();
            if (!isXML) {
                // Avoid an infinite loop by temporarily removing this function from the getter
                handle = attrHandle[lowercaseName];
                attrHandle[lowercaseName] = ret;
                ret = getter(elem, name, isXML) != null ? lowercaseName : null;
                attrHandle[lowercaseName] = handle;
            }
            return ret;
        };
    });
    var rfocusable = /^(?:input|select|textarea|button)$/i, rclickable = /^(?:a|area)$/i;
    jQuery.fn.extend({
        prop: function(name, value) {
            return access(this, jQuery.prop, name, value, arguments.length > 1);
        },
        removeProp: function(name) {
            return this.each(function() {
                delete this[jQuery.propFix[name] || name];
            });
        }
    });
    jQuery.extend({
        prop: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set properties on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                // Fix name and attach hooks
                name = jQuery.propFix[name] || name;
                hooks = jQuery.propHooks[name];
            }
            if (value !== undefined) {
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                return elem[name] = value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            return elem[name];
        },
        propHooks: {
            tabIndex: {
                get: function(elem) {
                    // Support: IE <=9 - 11 only
                    // elem.tabIndex doesn't always return the
                    // correct value when it hasn't been explicitly set
                    // Use proper attribute retrieval (trac-12072)
                    var tabindex = jQuery.find.attr(elem, "tabindex");
                    if (tabindex) return parseInt(tabindex, 10);
                    if (rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href) return 0;
                    return -1;
                }
            }
        },
        propFix: {
            "for": "htmlFor",
            "class": "className"
        }
    });
    // Support: IE <=11 only
    // Accessing the selectedIndex property
    // forces the browser to respect setting selected
    // on the option
    // The getter ensures a default option is selected
    // when in an optgroup
    // eslint rule "no-unused-expressions" is disabled for this code
    // since it considers such accessions noop
    if (!support.optSelected) jQuery.propHooks.selected = {
        get: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent && parent.parentNode) parent.parentNode.selectedIndex;
            return null;
        },
        set: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent) {
                parent.selectedIndex;
                if (parent.parentNode) parent.parentNode.selectedIndex;
            }
        }
    };
    jQuery.each([
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable"
    ], function() {
        jQuery.propFix[this.toLowerCase()] = this;
    });
    // Strip and collapse whitespace according to HTML spec
    // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
    function stripAndCollapse(value) {
        var tokens = value.match(rnothtmlwhite) || [];
        return tokens.join(" ");
    }
    function getClass(elem) {
        return elem.getAttribute && elem.getAttribute("class") || "";
    }
    function classesToArray(value) {
        if (Array.isArray(value)) return value;
        if (typeof value === "string") return value.match(rnothtmlwhite) || [];
        return [];
    }
    jQuery.fn.extend({
        addClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).addClass(value.call(this, j, getClass(this)));
            });
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        if (cur.indexOf(" " + className + " ") < 0) cur += className + " ";
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        removeClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).removeClass(value.call(this, j, getClass(this)));
            });
            if (!arguments.length) return this.attr("class", "");
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                // This expression is here for better compressibility (see addClass)
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Remove *all* instances
                        while(cur.indexOf(" " + className + " ") > -1)cur = cur.replace(" " + className + " ", " ");
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        toggleClass: function(value, stateVal) {
            var classNames, className, i, self, type = typeof value, isValidValue = type === "string" || Array.isArray(value);
            if (isFunction(value)) return this.each(function(i) {
                jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
            });
            if (typeof stateVal === "boolean" && isValidValue) return stateVal ? this.addClass(value) : this.removeClass(value);
            classNames = classesToArray(value);
            return this.each(function() {
                if (isValidValue) {
                    // Toggle individual class names
                    self = jQuery(this);
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Check each className given, space separated list
                        if (self.hasClass(className)) self.removeClass(className);
                        else self.addClass(className);
                    }
                // Toggle whole class name
                } else if (value === undefined || type === "boolean") {
                    className = getClass(this);
                    if (className) // Store className if set
                    dataPriv.set(this, "__className__", className);
                    // If the element has a class name or if we're passed `false`,
                    // then remove the whole classname (if there was one, the above saved it).
                    // Otherwise bring back whatever was previously saved (if anything),
                    // falling back to the empty string if nothing was stored.
                    if (this.setAttribute) this.setAttribute("class", className || value === false ? "" : dataPriv.get(this, "__className__") || "");
                }
            });
        },
        hasClass: function(selector) {
            var className, elem, i = 0;
            className = " " + selector + " ";
            while(elem = this[i++]){
                if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) return true;
            }
            return false;
        }
    });
    var rreturn = /\r/g;
    jQuery.fn.extend({
        val: function(value) {
            var hooks, ret, valueIsFunction, elem = this[0];
            if (!arguments.length) {
                if (elem) {
                    hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
                    if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) return ret;
                    ret = elem.value;
                    // Handle most common string cases
                    if (typeof ret === "string") return ret.replace(rreturn, "");
                    // Handle cases where value is null/undef or number
                    return ret == null ? "" : ret;
                }
                return;
            }
            valueIsFunction = isFunction(value);
            return this.each(function(i) {
                var val;
                if (this.nodeType !== 1) return;
                if (valueIsFunction) val = value.call(this, i, jQuery(this).val());
                else val = value;
                // Treat null/undefined as ""; convert numbers to string
                if (val == null) val = "";
                else if (typeof val === "number") val += "";
                else if (Array.isArray(val)) val = jQuery.map(val, function(value) {
                    return value == null ? "" : value + "";
                });
                hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];
                // If set returns undefined, fall back to normal setting
                if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) this.value = val;
            });
        }
    });
    jQuery.extend({
        valHooks: {
            option: {
                get: function(elem) {
                    var val = jQuery.find.attr(elem, "value");
                    return val != null ? val : // Support: IE <=10 - 11 only
                    // option.text throws exceptions (trac-14686, trac-14858)
                    // Strip and collapse whitespace
                    // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
                    stripAndCollapse(jQuery.text(elem));
                }
            },
            select: {
                get: function(elem) {
                    var value, option, i, options = elem.options, index = elem.selectedIndex, one = elem.type === "select-one", values = one ? null : [], max = one ? index + 1 : options.length;
                    if (index < 0) i = max;
                    else i = one ? index : 0;
                    // Loop through all the selected options
                    for(; i < max; i++){
                        option = options[i];
                        // Support: IE <=9 only
                        // IE8-9 doesn't update selected after form reset (trac-2551)
                        if ((option.selected || i === index) && // Don't return options that are disabled or in a disabled optgroup
                        !option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
                            // Get the specific value for the option
                            value = jQuery(option).val();
                            // We don't need an array for one selects
                            if (one) return value;
                            // Multi-Selects return an array
                            values.push(value);
                        }
                    }
                    return values;
                },
                set: function(elem, value) {
                    var optionSet, option, options = elem.options, values = jQuery.makeArray(value), i = options.length;
                    while(i--){
                        option = options[i];
                        /* eslint-disable no-cond-assign */ if (option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) optionSet = true;
                    /* eslint-enable no-cond-assign */ }
                    // Force browsers to behave consistently when non-matching value is set
                    if (!optionSet) elem.selectedIndex = -1;
                    return values;
                }
            }
        }
    });
    // Radios and checkboxes getter/setter
    jQuery.each([
        "radio",
        "checkbox"
    ], function() {
        jQuery.valHooks[this] = {
            set: function(elem, value) {
                if (Array.isArray(value)) return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
            }
        };
        if (!support.checkOn) jQuery.valHooks[this].get = function(elem) {
            return elem.getAttribute("value") === null ? "on" : elem.value;
        };
    });
    // Return jQuery for attributes-only inclusion
    support.focusin = "onfocusin" in window1;
    var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/, stopPropagationCallback = function(e) {
        e.stopPropagation();
    };
    jQuery.extend(jQuery.event, {
        trigger: function(event, data, elem, onlyHandlers) {
            var i, cur, tmp, bubbleType, ontype, handle, special, lastElement, eventPath = [
                elem || document
            ], type = hasOwn.call(event, "type") ? event.type : event, namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
            cur = lastElement = tmp = elem = elem || document;
            // Don't do events on text and comment nodes
            if (elem.nodeType === 3 || elem.nodeType === 8) return;
            // focus/blur morphs to focusin/out; ensure we're not firing them right now
            if (rfocusMorph.test(type + jQuery.event.triggered)) return;
            if (type.indexOf(".") > -1) {
                // Namespaced trigger; create a regexp to match event type in handle()
                namespaces = type.split(".");
                type = namespaces.shift();
                namespaces.sort();
            }
            ontype = type.indexOf(":") < 0 && "on" + type;
            // Caller can pass in a jQuery.Event object, Object, or just an event type string
            event = event[jQuery.expando] ? event : new jQuery.Event(type, typeof event === "object" && event);
            // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
            event.isTrigger = onlyHandlers ? 2 : 3;
            event.namespace = namespaces.join(".");
            event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
            // Clean up the event in case it is being reused
            event.result = undefined;
            if (!event.target) event.target = elem;
            // Clone any incoming data and prepend the event, creating the handler arg list
            data = data == null ? [
                event
            ] : jQuery.makeArray(data, [
                event
            ]);
            // Allow special events to draw outside the lines
            special = jQuery.event.special[type] || {};
            if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) return;
            // Determine event propagation path in advance, per W3C events spec (trac-9951)
            // Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
            if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
                bubbleType = special.delegateType || type;
                if (!rfocusMorph.test(bubbleType + type)) cur = cur.parentNode;
                for(; cur; cur = cur.parentNode){
                    eventPath.push(cur);
                    tmp = cur;
                }
                // Only add window if we got to document (e.g., not plain obj or detached DOM)
                if (tmp === (elem.ownerDocument || document)) eventPath.push(tmp.defaultView || tmp.parentWindow || window1);
            }
            // Fire handlers on the event path
            i = 0;
            while((cur = eventPath[i++]) && !event.isPropagationStopped()){
                lastElement = cur;
                event.type = i > 1 ? bubbleType : special.bindType || type;
                // jQuery handler
                handle = (dataPriv.get(cur, "events") || Object.create(null))[event.type] && dataPriv.get(cur, "handle");
                if (handle) handle.apply(cur, data);
                // Native handler
                handle = ontype && cur[ontype];
                if (handle && handle.apply && acceptData(cur)) {
                    event.result = handle.apply(cur, data);
                    if (event.result === false) event.preventDefault();
                }
            }
            event.type = type;
            // If nobody prevented the default action, do it now
            if (!onlyHandlers && !event.isDefaultPrevented()) {
                if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) // Call a native DOM method on the target with the same name as the event.
                // Don't do default actions on window, that's where global variables be (trac-6170)
                {
                    if (ontype && isFunction(elem[type]) && !isWindow(elem)) {
                        // Don't re-trigger an onFOO event when we call its FOO() method
                        tmp = elem[ontype];
                        if (tmp) elem[ontype] = null;
                        // Prevent re-triggering of the same event, since we already bubbled it above
                        jQuery.event.triggered = type;
                        if (event.isPropagationStopped()) lastElement.addEventListener(type, stopPropagationCallback);
                        elem[type]();
                        if (event.isPropagationStopped()) lastElement.removeEventListener(type, stopPropagationCallback);
                        jQuery.event.triggered = undefined;
                        if (tmp) elem[ontype] = tmp;
                    }
                }
            }
            return event.result;
        },
        // Piggyback on a donor event to simulate a different one
        // Used only for `focus(in | out)` events
        simulate: function(type, elem, event) {
            var e = jQuery.extend(new jQuery.Event(), event, {
                type: type,
                isSimulated: true
            });
            jQuery.event.trigger(e, null, elem);
        }
    });
    jQuery.fn.extend({
        trigger: function(type, data) {
            return this.each(function() {
                jQuery.event.trigger(type, data, this);
            });
        },
        triggerHandler: function(type, data) {
            var elem = this[0];
            if (elem) return jQuery.event.trigger(type, data, elem, true);
        }
    });
    // Support: Firefox <=44
    // Firefox doesn't have focus(in | out) events
    // Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
    //
    // Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
    // focus(in | out) events fire after focus & blur events,
    // which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
    // Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
    if (!support.focusin) jQuery.each({
        focus: "focusin",
        blur: "focusout"
    }, function(orig, fix) {
        // Attach a single capturing handler on the document while someone wants focusin/focusout
        var handler = function(event) {
            jQuery.event.simulate(fix, event.target, jQuery.event.fix(event));
        };
        jQuery.event.special[fix] = {
            setup: function() {
                // Handle: regular nodes (via `this.ownerDocument`), window
                // (via `this.document`) & document (via `this`).
                var doc = this.ownerDocument || this.document || this, attaches = dataPriv.access(doc, fix);
                if (!attaches) doc.addEventListener(orig, handler, true);
                dataPriv.access(doc, fix, (attaches || 0) + 1);
            },
            teardown: function() {
                var doc = this.ownerDocument || this.document || this, attaches = dataPriv.access(doc, fix) - 1;
                if (!attaches) {
                    doc.removeEventListener(orig, handler, true);
                    dataPriv.remove(doc, fix);
                } else dataPriv.access(doc, fix, attaches);
            }
        };
    });
    var location = window1.location;
    var nonce = {
        guid: Date.now()
    };
    var rquery = /\?/;
    // Cross-browser xml parsing
    jQuery.parseXML = function(data) {
        var xml, parserErrorElem;
        if (!data || typeof data !== "string") return null;
        // Support: IE 9 - 11 only
        // IE throws on parseFromString with invalid input.
        try {
            xml = new window1.DOMParser().parseFromString(data, "text/xml");
        } catch (e) {}
        parserErrorElem = xml && xml.getElementsByTagName("parsererror")[0];
        if (!xml || parserErrorElem) jQuery.error("Invalid XML: " + (parserErrorElem ? jQuery.map(parserErrorElem.childNodes, function(el) {
            return el.textContent;
        }).join("\n") : data));
        return xml;
    };
    var rbracket = /\[\]$/, rCRLF = /\r?\n/g, rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i, rsubmittable = /^(?:input|select|textarea|keygen)/i;
    function buildParams(prefix, obj, traditional, add) {
        var name;
        if (Array.isArray(obj)) // Serialize array item.
        jQuery.each(obj, function(i, v) {
            if (traditional || rbracket.test(prefix)) // Treat each array item as a scalar.
            add(prefix, v);
            else // Item is non-scalar (array or object), encode its numeric index.
            buildParams(prefix + "[" + (typeof v === "object" && v != null ? i : "") + "]", v, traditional, add);
        });
        else if (!traditional && toType(obj) === "object") // Serialize object item.
        for(name in obj)buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
        else // Serialize scalar item.
        add(prefix, obj);
    }
    // Serialize an array of form elements or a set of
    // key/values into a query string
    jQuery.param = function(a, traditional) {
        var prefix, s = [], add = function(key, valueOrFunction) {
            // If value is a function, invoke it and use its return value
            var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;
            s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
        };
        if (a == null) return "";
        // If an array was passed in, assume that it is an array of form elements.
        if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) // Serialize the form elements
        jQuery.each(a, function() {
            add(this.name, this.value);
        });
        else // If traditional, encode the "old" way (the way 1.3.2 or older
        // did it), otherwise encode params recursively.
        for(prefix in a)buildParams(prefix, a[prefix], traditional, add);
        // Return the resulting serialization
        return s.join("&");
    };
    jQuery.fn.extend({
        serialize: function() {
            return jQuery.param(this.serializeArray());
        },
        serializeArray: function() {
            return this.map(function() {
                // Can add propHook for "elements" to filter or add form elements
                var elements = jQuery.prop(this, "elements");
                return elements ? jQuery.makeArray(elements) : this;
            }).filter(function() {
                var type = this.type;
                // Use .is( ":disabled" ) so that fieldset[disabled] works
                return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
            }).map(function(_i, elem) {
                var val = jQuery(this).val();
                if (val == null) return null;
                if (Array.isArray(val)) return jQuery.map(val, function(val) {
                    return {
                        name: elem.name,
                        value: val.replace(rCRLF, "\r\n")
                    };
                });
                return {
                    name: elem.name,
                    value: val.replace(rCRLF, "\r\n")
                };
            }).get();
        }
    });
    var r20 = /%20/g, rhash = /#.*$/, rantiCache = /([?&])_=[^&]*/, rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg, // trac-7653, trac-8125, trac-8152: local protocol detection
    rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, rnoContent = /^(?:GET|HEAD)$/, rprotocol = /^\/\//, /* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */ prefilters = {}, /* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */ transports = {}, // Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
    allTypes = "*/".concat("*"), // Anchor tag for parsing the document origin
    originAnchor = document.createElement("a");
    originAnchor.href = location.href;
    // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
    function addToPrefiltersOrTransports(structure) {
        // dataTypeExpression is optional and defaults to "*"
        return function(dataTypeExpression, func) {
            if (typeof dataTypeExpression !== "string") {
                func = dataTypeExpression;
                dataTypeExpression = "*";
            }
            var dataType, i = 0, dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];
            if (isFunction(func)) {
                // For each dataType in the dataTypeExpression
                while(dataType = dataTypes[i++])// Prepend if requested
                if (dataType[0] === "+") {
                    dataType = dataType.slice(1) || "*";
                    (structure[dataType] = structure[dataType] || []).unshift(func);
                // Otherwise append
                } else (structure[dataType] = structure[dataType] || []).push(func);
            }
        };
    }
    // Base inspection function for prefilters and transports
    function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
        var inspected = {}, seekingTransport = structure === transports;
        function inspect(dataType) {
            var selected;
            inspected[dataType] = true;
            jQuery.each(structure[dataType] || [], function(_, prefilterOrFactory) {
                var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
                if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
                    options.dataTypes.unshift(dataTypeOrTransport);
                    inspect(dataTypeOrTransport);
                    return false;
                } else if (seekingTransport) return !(selected = dataTypeOrTransport);
            });
            return selected;
        }
        return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
    }
    // A special extend for ajax options
    // that takes "flat" options (not to be deep extended)
    // Fixes trac-9887
    function ajaxExtend(target, src) {
        var key, deep, flatOptions = jQuery.ajaxSettings.flatOptions || {};
        for(key in src)if (src[key] !== undefined) (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
        if (deep) jQuery.extend(true, target, deep);
        return target;
    }
    /* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */ function ajaxHandleResponses(s, jqXHR, responses) {
        var ct, type, finalDataType, firstDataType, contents = s.contents, dataTypes = s.dataTypes;
        // Remove auto dataType and get content-type in the process
        while(dataTypes[0] === "*"){
            dataTypes.shift();
            if (ct === undefined) ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
        }
        // Check if we're dealing with a known content-type
        if (ct) {
            for(type in contents)if (contents[type] && contents[type].test(ct)) {
                dataTypes.unshift(type);
                break;
            }
        }
        // Check to see if we have a response for the expected dataType
        if (dataTypes[0] in responses) finalDataType = dataTypes[0];
        else {
            // Try convertible dataTypes
            for(type in responses){
                if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
                    finalDataType = type;
                    break;
                }
                if (!firstDataType) firstDataType = type;
            }
            // Or just use first one
            finalDataType = finalDataType || firstDataType;
        }
        // If we found a dataType
        // We add the dataType to the list if needed
        // and return the corresponding response
        if (finalDataType) {
            if (finalDataType !== dataTypes[0]) dataTypes.unshift(finalDataType);
            return responses[finalDataType];
        }
    }
    /* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */ function ajaxConvert(s, response, jqXHR, isSuccess) {
        var conv2, current, conv, tmp, prev, converters = {}, // Work with a copy of dataTypes in case we need to modify it for conversion
        dataTypes = s.dataTypes.slice();
        // Create converters map with lowercased keys
        if (dataTypes[1]) for(conv in s.converters)converters[conv.toLowerCase()] = s.converters[conv];
        current = dataTypes.shift();
        // Convert to each sequential dataType
        while(current){
            if (s.responseFields[current]) jqXHR[s.responseFields[current]] = response;
            // Apply the dataFilter if provided
            if (!prev && isSuccess && s.dataFilter) response = s.dataFilter(response, s.dataType);
            prev = current;
            current = dataTypes.shift();
            if (current) {
                // There's only work to do if current dataType is non-auto
                if (current === "*") current = prev;
                else if (prev !== "*" && prev !== current) {
                    // Seek a direct converter
                    conv = converters[prev + " " + current] || converters["* " + current];
                    // If none found, seek a pair
                    if (!conv) for(conv2 in converters){
                        // If conv2 outputs current
                        tmp = conv2.split(" ");
                        if (tmp[1] === current) {
                            // If prev can be converted to accepted input
                            conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
                            if (conv) {
                                // Condense equivalence converters
                                if (conv === true) conv = converters[conv2];
                                else if (converters[conv2] !== true) {
                                    current = tmp[0];
                                    dataTypes.unshift(tmp[1]);
                                }
                                break;
                            }
                        }
                    }
                    // Apply converter (if not an equivalence)
                    if (conv !== true) {
                        // Unless errors are allowed to bubble, catch and return them
                        if (conv && s.throws) response = conv(response);
                        else try {
                            response = conv(response);
                        } catch (e) {
                            return {
                                state: "parsererror",
                                error: conv ? e : "No conversion from " + prev + " to " + current
                            };
                        }
                    }
                }
            }
        }
        return {
            state: "success",
            data: response
        };
    }
    jQuery.extend({
        // Counter for holding the number of active queries
        active: 0,
        // Last-Modified header cache for next request
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: location.href,
            type: "GET",
            isLocal: rlocalProtocol.test(location.protocol),
            global: true,
            processData: true,
            async: true,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            /*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/ accepts: {
                "*": allTypes,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            // Data converters
            // Keys separate source (or catchall "*") and destination types with a single space
            converters: {
                // Convert anything to text
                "* text": String,
                // Text to html (true = no transformation)
                "text html": true,
                // Evaluate text as a json expression
                "text json": JSON.parse,
                // Parse text as xml
                "text xml": jQuery.parseXML
            },
            // For options that shouldn't be deep extended:
            // you can add your own custom options here if
            // and when you create one that shouldn't be
            // deep extended (see ajaxExtend)
            flatOptions: {
                url: true,
                context: true
            }
        },
        // Creates a full fledged settings object into target
        // with both ajaxSettings and settings fields.
        // If target is omitted, writes into ajaxSettings.
        ajaxSetup: function(target, settings) {
            return settings ? // Building a settings object
            ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) : // Extending ajaxSettings
            ajaxExtend(jQuery.ajaxSettings, target);
        },
        ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
        ajaxTransport: addToPrefiltersOrTransports(transports),
        // Main method
        ajax: function(url, options) {
            // If url is an object, simulate pre-1.5 signature
            if (typeof url === "object") {
                options = url;
                url = undefined;
            }
            // Force options to be an object
            options = options || {};
            var transport, // URL without anti-cache param
            cacheURL, // Response headers
            responseHeadersString, responseHeaders, // timeout handle
            timeoutTimer, // Url cleanup var
            urlAnchor, // Request state (becomes false upon send and true upon completion)
            completed, // To know if global events are to be dispatched
            fireGlobals, // Loop variable
            i, // uncached part of the url
            uncached, // Create the final options object
            s = jQuery.ajaxSetup({}, options), // Callbacks context
            callbackContext = s.context || s, // Context for global events is callbackContext if it is a DOM node or jQuery collection
            globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event, // Deferreds
            deferred = jQuery.Deferred(), completeDeferred = jQuery.Callbacks("once memory"), // Status-dependent callbacks
            statusCode = s.statusCode || {}, // Headers (they are sent all at once)
            requestHeaders = {}, requestHeadersNames = {}, // Default abort message
            strAbort = "canceled", // Fake xhr
            jqXHR = {
                readyState: 0,
                // Builds headers hashtable if needed
                getResponseHeader: function(key) {
                    var match;
                    if (completed) {
                        if (!responseHeaders) {
                            responseHeaders = {};
                            while(match = rheaders.exec(responseHeadersString))responseHeaders[match[1].toLowerCase() + " "] = (responseHeaders[match[1].toLowerCase() + " "] || []).concat(match[2]);
                        }
                        match = responseHeaders[key.toLowerCase() + " "];
                    }
                    return match == null ? null : match.join(", ");
                },
                // Raw string
                getAllResponseHeaders: function() {
                    return completed ? responseHeadersString : null;
                },
                // Caches the header
                setRequestHeader: function(name, value) {
                    if (completed == null) {
                        name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
                        requestHeaders[name] = value;
                    }
                    return this;
                },
                // Overrides response content-type header
                overrideMimeType: function(type) {
                    if (completed == null) s.mimeType = type;
                    return this;
                },
                // Status-dependent callbacks
                statusCode: function(map) {
                    var code;
                    if (map) {
                        if (completed) // Execute the appropriate callbacks
                        jqXHR.always(map[jqXHR.status]);
                        else // Lazy-add the new callbacks in a way that preserves old ones
                        for(code in map)statusCode[code] = [
                            statusCode[code],
                            map[code]
                        ];
                    }
                    return this;
                },
                // Cancel the request
                abort: function(statusText) {
                    var finalText = statusText || strAbort;
                    if (transport) transport.abort(finalText);
                    done(0, finalText);
                    return this;
                }
            };
            // Attach deferreds
            deferred.promise(jqXHR);
            // Add protocol if not provided (prefilters might expect it)
            // Handle falsy url in the settings object (trac-10093: consistency with old signature)
            // We also use the url parameter if available
            s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//");
            // Alias method option to type as per ticket trac-12004
            s.type = options.method || options.type || s.method || s.type;
            // Extract dataTypes list
            s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [
                ""
            ];
            // A cross-domain request is in order when the origin doesn't match the current origin.
            if (s.crossDomain == null) {
                urlAnchor = document.createElement("a");
                // Support: IE <=8 - 11, Edge 12 - 15
                // IE throws exception on accessing the href property if url is malformed,
                // e.g. http://example.com:80x/
                try {
                    urlAnchor.href = s.url;
                    // Support: IE <=8 - 11 only
                    // Anchor's host property isn't correctly set when s.url is relative
                    urlAnchor.href = urlAnchor.href;
                    s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
                } catch (e) {
                    // If there is an error parsing the URL, assume it is crossDomain,
                    // it can be rejected by the transport if it is invalid
                    s.crossDomain = true;
                }
            }
            // Convert data if not already a string
            if (s.data && s.processData && typeof s.data !== "string") s.data = jQuery.param(s.data, s.traditional);
            // Apply prefilters
            inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);
            // If request was aborted inside a prefilter, stop there
            if (completed) return jqXHR;
            // We can fire global events as of now if asked to
            // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
            fireGlobals = jQuery.event && s.global;
            // Watch for a new set of requests
            if (fireGlobals && jQuery.active++ === 0) jQuery.event.trigger("ajaxStart");
            // Uppercase the type
            s.type = s.type.toUpperCase();
            // Determine if request has content
            s.hasContent = !rnoContent.test(s.type);
            // Save the URL in case we're toying with the If-Modified-Since
            // and/or If-None-Match header later on
            // Remove hash to simplify url manipulation
            cacheURL = s.url.replace(rhash, "");
            // More options handling for requests with no content
            if (!s.hasContent) {
                // Remember the hash so we can put it back
                uncached = s.url.slice(cacheURL.length);
                // If data is available and should be processed, append data to url
                if (s.data && (s.processData || typeof s.data === "string")) {
                    cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;
                    // trac-9682: remove data so that it's not used in an eventual retry
                    delete s.data;
                }
                // Add or update anti-cache param if needed
                if (s.cache === false) {
                    cacheURL = cacheURL.replace(rantiCache, "$1");
                    uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce.guid++ + uncached;
                }
                // Put hash and anti-cache on the URL that will be requested (gh-1732)
                s.url = cacheURL + uncached;
            // Change '%20' to '+' if this is encoded form body content (gh-2658)
            } else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) s.data = s.data.replace(r20, "+");
            // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
            if (s.ifModified) {
                if (jQuery.lastModified[cacheURL]) jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
                if (jQuery.etag[cacheURL]) jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
            }
            // Set the correct header, if data is being sent
            if (s.data && s.hasContent && s.contentType !== false || options.contentType) jqXHR.setRequestHeader("Content-Type", s.contentType);
            // Set the Accepts header for the server, depending on the dataType
            jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);
            // Check for headers option
            for(i in s.headers)jqXHR.setRequestHeader(i, s.headers[i]);
            // Allow custom headers/mimetypes and early abort
            if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || completed)) // Abort if not done already and return
            return jqXHR.abort();
            // Aborting is no longer a cancellation
            strAbort = "abort";
            // Install callbacks on deferreds
            completeDeferred.add(s.complete);
            jqXHR.done(s.success);
            jqXHR.fail(s.error);
            // Get transport
            transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);
            // If no transport, we auto-abort
            if (!transport) done(-1, "No Transport");
            else {
                jqXHR.readyState = 1;
                // Send global event
                if (fireGlobals) globalEventContext.trigger("ajaxSend", [
                    jqXHR,
                    s
                ]);
                // If request was aborted inside ajaxSend, stop there
                if (completed) return jqXHR;
                // Timeout
                if (s.async && s.timeout > 0) timeoutTimer = window1.setTimeout(function() {
                    jqXHR.abort("timeout");
                }, s.timeout);
                try {
                    completed = false;
                    transport.send(requestHeaders, done);
                } catch (e) {
                    // Rethrow post-completion exceptions
                    if (completed) throw e;
                    // Propagate others as results
                    done(-1, e);
                }
            }
            // Callback for when everything is done
            function done(status, nativeStatusText, responses, headers) {
                var isSuccess, success, error, response, modified, statusText = nativeStatusText;
                // Ignore repeat invocations
                if (completed) return;
                completed = true;
                // Clear timeout if it exists
                if (timeoutTimer) window1.clearTimeout(timeoutTimer);
                // Dereference transport for early garbage collection
                // (no matter how long the jqXHR object will be used)
                transport = undefined;
                // Cache response headers
                responseHeadersString = headers || "";
                // Set readyState
                jqXHR.readyState = status > 0 ? 4 : 0;
                // Determine if successful
                isSuccess = status >= 200 && status < 300 || status === 304;
                // Get response data
                if (responses) response = ajaxHandleResponses(s, jqXHR, responses);
                // Use a noop converter for missing script but not if jsonp
                if (!isSuccess && jQuery.inArray("script", s.dataTypes) > -1 && jQuery.inArray("json", s.dataTypes) < 0) s.converters["text script"] = function() {};
                // Convert no matter what (that way responseXXX fields are always set)
                response = ajaxConvert(s, response, jqXHR, isSuccess);
                // If successful, handle type chaining
                if (isSuccess) {
                    // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                    if (s.ifModified) {
                        modified = jqXHR.getResponseHeader("Last-Modified");
                        if (modified) jQuery.lastModified[cacheURL] = modified;
                        modified = jqXHR.getResponseHeader("etag");
                        if (modified) jQuery.etag[cacheURL] = modified;
                    }
                    // if no content
                    if (status === 204 || s.type === "HEAD") statusText = "nocontent";
                    else if (status === 304) statusText = "notmodified";
                    else {
                        statusText = response.state;
                        success = response.data;
                        error = response.error;
                        isSuccess = !error;
                    }
                } else {
                    // Extract error from statusText and normalize for non-aborts
                    error = statusText;
                    if (status || !statusText) {
                        statusText = "error";
                        if (status < 0) status = 0;
                    }
                }
                // Set data for the fake xhr object
                jqXHR.status = status;
                jqXHR.statusText = (nativeStatusText || statusText) + "";
                // Success/Error
                if (isSuccess) deferred.resolveWith(callbackContext, [
                    success,
                    statusText,
                    jqXHR
                ]);
                else deferred.rejectWith(callbackContext, [
                    jqXHR,
                    statusText,
                    error
                ]);
                // Status-dependent callbacks
                jqXHR.statusCode(statusCode);
                statusCode = undefined;
                if (fireGlobals) globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [
                    jqXHR,
                    s,
                    isSuccess ? success : error
                ]);
                // Complete
                completeDeferred.fireWith(callbackContext, [
                    jqXHR,
                    statusText
                ]);
                if (fireGlobals) {
                    globalEventContext.trigger("ajaxComplete", [
                        jqXHR,
                        s
                    ]);
                    // Handle the global AJAX counter
                    if (!--jQuery.active) jQuery.event.trigger("ajaxStop");
                }
            }
            return jqXHR;
        },
        getJSON: function(url, data, callback) {
            return jQuery.get(url, data, callback, "json");
        },
        getScript: function(url, callback) {
            return jQuery.get(url, undefined, callback, "script");
        }
    });
    jQuery.each([
        "get",
        "post"
    ], function(_i, method) {
        jQuery[method] = function(url, data, callback, type) {
            // Shift arguments if data argument was omitted
            if (isFunction(data)) {
                type = type || callback;
                callback = data;
                data = undefined;
            }
            // The url can be an options object (which then must have .url)
            return jQuery.ajax(jQuery.extend({
                url: url,
                type: method,
                dataType: type,
                data: data,
                success: callback
            }, jQuery.isPlainObject(url) && url));
        };
    });
    jQuery.ajaxPrefilter(function(s) {
        var i;
        for(i in s.headers)if (i.toLowerCase() === "content-type") s.contentType = s.headers[i] || "";
    });
    jQuery._evalUrl = function(url, options, doc) {
        return jQuery.ajax({
            url: url,
            // Make this explicit, since user can override this through ajaxSetup (trac-11264)
            type: "GET",
            dataType: "script",
            cache: true,
            async: false,
            global: false,
            // Only evaluate the response if it is successful (gh-4126)
            // dataFilter is not invoked for failure responses, so using it instead
            // of the default converter is kludgy but it works.
            converters: {
                "text script": function() {}
            },
            dataFilter: function(response) {
                jQuery.globalEval(response, options, doc);
            }
        });
    };
    jQuery.fn.extend({
        wrapAll: function(html) {
            var wrap;
            if (this[0]) {
                if (isFunction(html)) html = html.call(this[0]);
                // The elements to wrap the target around
                wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
                if (this[0].parentNode) wrap.insertBefore(this[0]);
                wrap.map(function() {
                    var elem = this;
                    while(elem.firstElementChild)elem = elem.firstElementChild;
                    return elem;
                }).append(this);
            }
            return this;
        },
        wrapInner: function(html) {
            if (isFunction(html)) return this.each(function(i) {
                jQuery(this).wrapInner(html.call(this, i));
            });
            return this.each(function() {
                var self = jQuery(this), contents = self.contents();
                if (contents.length) contents.wrapAll(html);
                else self.append(html);
            });
        },
        wrap: function(html) {
            var htmlIsFunction = isFunction(html);
            return this.each(function(i) {
                jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
            });
        },
        unwrap: function(selector) {
            this.parent(selector).not("body").each(function() {
                jQuery(this).replaceWith(this.childNodes);
            });
            return this;
        }
    });
    jQuery.expr.pseudos.hidden = function(elem) {
        return !jQuery.expr.pseudos.visible(elem);
    };
    jQuery.expr.pseudos.visible = function(elem) {
        return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
    };
    jQuery.ajaxSettings.xhr = function() {
        try {
            return new window1.XMLHttpRequest();
        } catch (e) {}
    };
    var xhrSuccessStatus = {
        // File protocol always yields status code 0, assume 200
        0: 200,
        // Support: IE <=9 only
        // trac-1450: sometimes IE returns 1223 when it should be 204
        1223: 204
    }, xhrSupported = jQuery.ajaxSettings.xhr();
    support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
    support.ajax = xhrSupported = !!xhrSupported;
    jQuery.ajaxTransport(function(options) {
        var callback, errorCallback;
        // Cross domain only allowed if supported through XMLHttpRequest
        if (support.cors || xhrSupported && !options.crossDomain) return {
            send: function(headers, complete) {
                var i, xhr = options.xhr();
                xhr.open(options.type, options.url, options.async, options.username, options.password);
                // Apply custom fields if provided
                if (options.xhrFields) for(i in options.xhrFields)xhr[i] = options.xhrFields[i];
                // Override mime type if needed
                if (options.mimeType && xhr.overrideMimeType) xhr.overrideMimeType(options.mimeType);
                // X-Requested-With header
                // For cross-domain requests, seeing as conditions for a preflight are
                // akin to a jigsaw puzzle, we simply never set it to be sure.
                // (it can always be set on a per-request basis or even using ajaxSetup)
                // For same-domain requests, won't change header if already provided.
                if (!options.crossDomain && !headers["X-Requested-With"]) headers["X-Requested-With"] = "XMLHttpRequest";
                // Set headers
                for(i in headers)xhr.setRequestHeader(i, headers[i]);
                // Callback
                callback = function(type) {
                    return function() {
                        if (callback) {
                            callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = xhr.onreadystatechange = null;
                            if (type === "abort") xhr.abort();
                            else if (type === "error") {
                                // Support: IE <=9 only
                                // On a manual native abort, IE9 throws
                                // errors on any property access that is not readyState
                                if (typeof xhr.status !== "number") complete(0, "error");
                                else complete(// File: protocol always yields status 0; see trac-8605, trac-14207
                                xhr.status, xhr.statusText);
                            } else complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText, // Support: IE <=9 only
                            // IE9 has no XHR2 but throws on binary (trac-11426)
                            // For XHR2 non-text, let the caller handle it (gh-2498)
                            (xhr.responseType || "text") !== "text" || typeof xhr.responseText !== "string" ? {
                                binary: xhr.response
                            } : {
                                text: xhr.responseText
                            }, xhr.getAllResponseHeaders());
                        }
                    };
                };
                // Listen to events
                xhr.onload = callback();
                errorCallback = xhr.onerror = xhr.ontimeout = callback("error");
                // Support: IE 9 only
                // Use onreadystatechange to replace onabort
                // to handle uncaught aborts
                if (xhr.onabort !== undefined) xhr.onabort = errorCallback;
                else xhr.onreadystatechange = function() {
                    // Check readyState before timeout as it changes
                    if (xhr.readyState === 4) // Allow onerror to be called first,
                    // but that will not handle a native abort
                    // Also, save errorCallback to a variable
                    // as xhr.onerror cannot be accessed
                    window1.setTimeout(function() {
                        if (callback) errorCallback();
                    });
                };
                // Create the abort callback
                callback = callback("abort");
                try {
                    // Do send the request (this may raise an exception)
                    xhr.send(options.hasContent && options.data || null);
                } catch (e) {
                    // trac-14683: Only rethrow if this hasn't been notified as an error yet
                    if (callback) throw e;
                }
            },
            abort: function() {
                if (callback) callback();
            }
        };
    });
    // Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
    jQuery.ajaxPrefilter(function(s) {
        if (s.crossDomain) s.contents.script = false;
    });
    // Install script dataType
    jQuery.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(text) {
                jQuery.globalEval(text);
                return text;
            }
        }
    });
    // Handle cache's special case and crossDomain
    jQuery.ajaxPrefilter("script", function(s) {
        if (s.cache === undefined) s.cache = false;
        if (s.crossDomain) s.type = "GET";
    });
    // Bind script tag hack transport
    jQuery.ajaxTransport("script", function(s) {
        // This transport only deals with cross domain or forced-by-attrs requests
        if (s.crossDomain || s.scriptAttrs) {
            var script, callback;
            return {
                send: function(_, complete) {
                    script = jQuery("<script>").attr(s.scriptAttrs || {}).prop({
                        charset: s.scriptCharset,
                        src: s.url
                    }).on("load error", callback = function(evt) {
                        script.remove();
                        callback = null;
                        if (evt) complete(evt.type === "error" ? 404 : 200, evt.type);
                    });
                    // Use native DOM manipulation to avoid our domManip AJAX trickery
                    document.head.appendChild(script[0]);
                },
                abort: function() {
                    if (callback) callback();
                }
            };
        }
    });
    var oldCallbacks = [], rjsonp = /(=)\?(?=&|$)|\?\?/;
    // Default jsonp settings
    jQuery.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce.guid++;
            this[callback] = true;
            return callback;
        }
    });
    // Detect, normalize options and install callbacks for jsonp requests
    jQuery.ajaxPrefilter("json jsonp", function(s, originalSettings, jqXHR) {
        var callbackName, overwritten, responseContainer, jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");
        // Handle iff the expected data type is "jsonp" or we have a parameter to set
        if (jsonProp || s.dataTypes[0] === "jsonp") {
            // Get callback name, remembering preexisting value associated with it
            callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;
            // Insert callback into url or form data
            if (jsonProp) s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
            else if (s.jsonp !== false) s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
            // Use data converter to retrieve json after script execution
            s.converters["script json"] = function() {
                if (!responseContainer) jQuery.error(callbackName + " was not called");
                return responseContainer[0];
            };
            // Force json dataType
            s.dataTypes[0] = "json";
            // Install callback
            overwritten = window1[callbackName];
            window1[callbackName] = function() {
                responseContainer = arguments;
            };
            // Clean-up function (fires after converters)
            jqXHR.always(function() {
                // If previous value didn't exist - remove it
                if (overwritten === undefined) jQuery(window1).removeProp(callbackName);
                else window1[callbackName] = overwritten;
                // Save back as free
                if (s[callbackName]) {
                    // Make sure that re-using the options doesn't screw things around
                    s.jsonpCallback = originalSettings.jsonpCallback;
                    // Save the callback name for future use
                    oldCallbacks.push(callbackName);
                }
                // Call if it was a function and we have a response
                if (responseContainer && isFunction(overwritten)) overwritten(responseContainer[0]);
                responseContainer = overwritten = undefined;
            });
            // Delegate to script
            return "script";
        }
    });
    // Support: Safari 8 only
    // In Safari 8 documents created via document.implementation.createHTMLDocument
    // collapse sibling forms: the second one becomes a child of the first one.
    // Because of that, this security measure has to be disabled in Safari 8.
    // https://bugs.webkit.org/show_bug.cgi?id=137337
    support.createHTMLDocument = function() {
        var body = document.implementation.createHTMLDocument("").body;
        body.innerHTML = "<form></form><form></form>";
        return body.childNodes.length === 2;
    }();
    // Argument "data" should be string of html
    // context (optional): If specified, the fragment will be created in this context,
    // defaults to document
    // keepScripts (optional): If true, will include scripts passed in the html string
    jQuery.parseHTML = function(data, context, keepScripts) {
        if (typeof data !== "string") return [];
        if (typeof context === "boolean") {
            keepScripts = context;
            context = false;
        }
        var base, parsed, scripts;
        if (!context) {
            // Stop scripts or inline event handlers from being executed immediately
            // by using document.implementation
            if (support.createHTMLDocument) {
                context = document.implementation.createHTMLDocument("");
                // Set the base href for the created document
                // so any parsed elements with URLs
                // are based on the document's URL (gh-2965)
                base = context.createElement("base");
                base.href = document.location.href;
                context.head.appendChild(base);
            } else context = document;
        }
        parsed = rsingleTag.exec(data);
        scripts = !keepScripts && [];
        // Single tag
        if (parsed) return [
            context.createElement(parsed[1])
        ];
        parsed = buildFragment([
            data
        ], context, scripts);
        if (scripts && scripts.length) jQuery(scripts).remove();
        return jQuery.merge([], parsed.childNodes);
    };
    /**
 * Load a url into a page
 */ jQuery.fn.load = function(url, params, callback) {
        var selector, type, response, self = this, off = url.indexOf(" ");
        if (off > -1) {
            selector = stripAndCollapse(url.slice(off));
            url = url.slice(0, off);
        }
        // If it's a function
        if (isFunction(params)) {
            // We assume that it's the callback
            callback = params;
            params = undefined;
        // Otherwise, build a param string
        } else if (params && typeof params === "object") type = "POST";
        // If we have elements to modify, make the request
        if (self.length > 0) jQuery.ajax({
            url: url,
            // If "type" variable is undefined, then "GET" method will be used.
            // Make value of this field explicit since
            // user can override it through ajaxSetup method
            type: type || "GET",
            dataType: "html",
            data: params
        }).done(function(responseText) {
            // Save response for use in complete callback
            response = arguments;
            self.html(selector ? // If a selector was specified, locate the right elements in a dummy div
            // Exclude scripts to avoid IE 'Permission Denied' errors
            jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) : // Otherwise use the full result
            responseText);
        // If the request succeeds, this function gets "data", "status", "jqXHR"
        // but they are ignored because response was set above.
        // If it fails, this function gets "jqXHR", "status", "error"
        }).always(callback && function(jqXHR, status) {
            self.each(function() {
                callback.apply(this, response || [
                    jqXHR.responseText,
                    status,
                    jqXHR
                ]);
            });
        });
        return this;
    };
    jQuery.expr.pseudos.animated = function(elem) {
        return jQuery.grep(jQuery.timers, function(fn) {
            return elem === fn.elem;
        }).length;
    };
    jQuery.offset = {
        setOffset: function(elem, options, i) {
            var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition, position = jQuery.css(elem, "position"), curElem = jQuery(elem), props = {};
            // Set position first, in-case top/left are set even on static elem
            if (position === "static") elem.style.position = "relative";
            curOffset = curElem.offset();
            curCSSTop = jQuery.css(elem, "top");
            curCSSLeft = jQuery.css(elem, "left");
            calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;
            // Need to be able to calculate position if either
            // top or left is auto and position is either absolute or fixed
            if (calculatePosition) {
                curPosition = curElem.position();
                curTop = curPosition.top;
                curLeft = curPosition.left;
            } else {
                curTop = parseFloat(curCSSTop) || 0;
                curLeft = parseFloat(curCSSLeft) || 0;
            }
            if (isFunction(options)) // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
            options = options.call(elem, i, jQuery.extend({}, curOffset));
            if (options.top != null) props.top = options.top - curOffset.top + curTop;
            if (options.left != null) props.left = options.left - curOffset.left + curLeft;
            if ("using" in options) options.using.call(elem, props);
            else curElem.css(props);
        }
    };
    jQuery.fn.extend({
        // offset() relates an element's border box to the document origin
        offset: function(options) {
            // Preserve chaining for setter
            if (arguments.length) return options === undefined ? this : this.each(function(i) {
                jQuery.offset.setOffset(this, options, i);
            });
            var rect, win, elem = this[0];
            if (!elem) return;
            // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
            // Support: IE <=11 only
            // Running getBoundingClientRect on a
            // disconnected node in IE throws an error
            if (!elem.getClientRects().length) return {
                top: 0,
                left: 0
            };
            // Get document-relative position by adding viewport scroll to viewport-relative gBCR
            rect = elem.getBoundingClientRect();
            win = elem.ownerDocument.defaultView;
            return {
                top: rect.top + win.pageYOffset,
                left: rect.left + win.pageXOffset
            };
        },
        // position() relates an element's margin box to its offset parent's padding box
        // This corresponds to the behavior of CSS absolute positioning
        position: function() {
            if (!this[0]) return;
            var offsetParent, offset, doc, elem = this[0], parentOffset = {
                top: 0,
                left: 0
            };
            // position:fixed elements are offset from the viewport, which itself always has zero offset
            if (jQuery.css(elem, "position") === "fixed") // Assume position:fixed implies availability of getBoundingClientRect
            offset = elem.getBoundingClientRect();
            else {
                offset = this.offset();
                // Account for the *real* offset parent, which can be the document or its root element
                // when a statically positioned element is identified
                doc = elem.ownerDocument;
                offsetParent = elem.offsetParent || doc.documentElement;
                while(offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.parentNode;
                if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {
                    // Incorporate borders into its offset, since they are outside its content origin
                    parentOffset = jQuery(offsetParent).offset();
                    parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
                    parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
                }
            }
            // Subtract parent offsets and element margins
            return {
                top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
                left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
            };
        },
        // This method will return documentElement in the following cases:
        // 1) For the element inside the iframe without offsetParent, this method will return
        //    documentElement of the parent window
        // 2) For the hidden or detached element
        // 3) For body or html element, i.e. in case of the html node - it will return itself
        //
        // but those exceptions were never presented as a real life use-cases
        // and might be considered as more preferable results.
        //
        // This logic, however, is not guaranteed and can change at any point in the future
        offsetParent: function() {
            return this.map(function() {
                var offsetParent = this.offsetParent;
                while(offsetParent && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.offsetParent;
                return offsetParent || documentElement;
            });
        }
    });
    // Create scrollLeft and scrollTop methods
    jQuery.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(method, prop) {
        var top = "pageYOffset" === prop;
        jQuery.fn[method] = function(val) {
            return access(this, function(elem, method, val) {
                // Coalesce documents and windows
                var win;
                if (isWindow(elem)) win = elem;
                else if (elem.nodeType === 9) win = elem.defaultView;
                if (val === undefined) return win ? win[prop] : elem[method];
                if (win) win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
                else elem[method] = val;
            }, method, val, arguments.length);
        };
    });
    // Support: Safari <=7 - 9.1, Chrome <=37 - 49
    // Add the top/left cssHooks using jQuery.fn.position
    // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
    // Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
    // getComputedStyle returns percent when specified for top/left/bottom/right;
    // rather than make the css module depend on the offset module, just check for it here
    jQuery.each([
        "top",
        "left"
    ], function(_i, prop) {
        jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function(elem, computed) {
            if (computed) {
                computed = curCSS(elem, prop);
                // If curCSS returns percentage, fallback to offset
                return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
            }
        });
    });
    // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
    jQuery.each({
        Height: "height",
        Width: "width"
    }, function(name, type) {
        jQuery.each({
            padding: "inner" + name,
            content: type,
            "": "outer" + name
        }, function(defaultExtra, funcName) {
            // Margin is only for outerHeight, outerWidth
            jQuery.fn[funcName] = function(margin, value) {
                var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"), extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
                return access(this, function(elem, type, value) {
                    var doc;
                    if (isWindow(elem)) // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
                    return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
                    // Get document width or height
                    if (elem.nodeType === 9) {
                        doc = elem.documentElement;
                        // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                        // whichever is greatest
                        return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
                    }
                    return value === undefined ? // Get width or height on the element, requesting but not forcing parseFloat
                    jQuery.css(elem, type, extra) : // Set width or height on the element
                    jQuery.style(elem, type, value, extra);
                }, type, chainable ? margin : undefined, chainable);
            };
        });
    });
    jQuery.each([
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend"
    ], function(_i, type) {
        jQuery.fn[type] = function(fn) {
            return this.on(type, fn);
        };
    });
    jQuery.fn.extend({
        bind: function(types, data, fn) {
            return this.on(types, null, data, fn);
        },
        unbind: function(types, fn) {
            return this.off(types, null, fn);
        },
        delegate: function(selector, types, data, fn) {
            return this.on(types, selector, data, fn);
        },
        undelegate: function(selector, types, fn) {
            // ( namespace ) or ( selector, types [, fn] )
            return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
        },
        hover: function(fnOver, fnOut) {
            return this.mouseenter(fnOver).mouseleave(fnOut || fnOver);
        }
    });
    jQuery.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(_i, name) {
        // Handle event binding
        jQuery.fn[name] = function(data, fn) {
            return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
        };
    });
    // Support: Android <=4.0 only
    // Make sure we trim BOM and NBSP
    // Require that the "whitespace run" starts from a non-whitespace
    // to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
    var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
    // Bind a function to a context, optionally partially applying any
    // arguments.
    // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
    // However, it is not slated for removal any time soon
    jQuery.proxy = function(fn, context) {
        var tmp, args, proxy;
        if (typeof context === "string") {
            tmp = fn[context];
            context = fn;
            fn = tmp;
        }
        // Quick check to determine if target is callable, in the spec
        // this throws a TypeError, but we will just return undefined.
        if (!isFunction(fn)) return undefined;
        // Simulated bind
        args = slice.call(arguments, 2);
        proxy = function() {
            return fn.apply(context || this, args.concat(slice.call(arguments)));
        };
        // Set the guid of unique handler to the same of original handler, so it can be removed
        proxy.guid = fn.guid = fn.guid || jQuery.guid++;
        return proxy;
    };
    jQuery.holdReady = function(hold) {
        if (hold) jQuery.readyWait++;
        else jQuery.ready(true);
    };
    jQuery.isArray = Array.isArray;
    jQuery.parseJSON = JSON.parse;
    jQuery.nodeName = nodeName;
    jQuery.isFunction = isFunction;
    jQuery.isWindow = isWindow;
    jQuery.camelCase = camelCase;
    jQuery.type = toType;
    jQuery.now = Date.now;
    jQuery.isNumeric = function(obj) {
        // As of jQuery 3.0, isNumeric is limited to
        // strings and numbers (primitives or objects)
        // that can be coerced to finite numbers (gh-2662)
        var type = jQuery.type(obj);
        return (type === "number" || type === "string") && // parseFloat NaNs numeric-cast false positives ("")
        // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
        // subtraction forces infinities to NaN
        !isNaN(obj - parseFloat(obj));
    };
    jQuery.trim = function(text) {
        return text == null ? "" : (text + "").replace(rtrim, "$1");
    };
    // Register as a named AMD module, since jQuery can be concatenated with other
    // files that may use define, but not via a proper concatenation script that
    // understands anonymous AMD modules. A named AMD is safest and most robust
    // way to register. Lowercase jquery is used because AMD module names are
    // derived from file names, and jQuery is normally delivered in a lowercase
    // file name. Do this after creating the global so that if an AMD module wants
    // to call noConflict to hide this version of jQuery, it will work.
    // Note that for maximum portability, libraries that are not jQuery should
    // declare themselves as anonymous modules, and avoid setting a global if an
    // AMD loader is present. jQuery is a special case. For more information, see
    // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
    if (typeof define === "function" && define.amd) define("jquery", [], function() {
        return jQuery;
    });
    var // Map over jQuery in case of overwrite
    _jQuery = window1.jQuery, // Map over the $ in case of overwrite
    _$ = window1.$;
    jQuery.noConflict = function(deep) {
        if (window1.$ === jQuery) window1.$ = _$;
        if (deep && window1.jQuery === jQuery) window1.jQuery = _jQuery;
        return jQuery;
    };
    // Expose jQuery and $ identifiers, even in AMD
    // (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
    // and CommonJS for browser emulators (trac-13566)
    if (typeof noGlobal === "undefined") window1.jQuery = window1.$ = jQuery;
    return jQuery;
});

});

parcelRegister("cKtgb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $94807a585bb71a87$export$2e2bcd8739ae039; });
var $94807a585bb71a87$export$2e2bcd8739ae039 = {
    server_error: "Something went wrong",
    robots_label: "Robots attached to this event:",
    select_robots: "Select robots!",
    select_events: "Select event(s)!",
    organization: "Organization:",
    delete_message: "Warning!\n\n All photos in this album will be permanently deleted from the server. This operation cannot be undone.\n\n If you used an e-mail method for sharing photos with guests at this event, those photos will also be gone, and users will not be able to view them using the link in the e-mail.\n\n Photos that users already downloaded to their devices, or shared on Facebook will not be affected.\n",
    valid_data: "Please enter valid data.",
    unlimited_time: "Available for unlimited time.",
    empty_album_default_text: "There are no recent images in this album",
    delay_album_default_text: "Pictures can be delayed by up to 2 hours",
    pp_album_default_text: "Add a selfie or a portrait picture for each member of your party",
    no_event: "No Event available.",
    add_event: "Add Event",
    selected_message: "Selected photos will be permanently removed from the album. This action cannot be undone. \n",
    remove_message: "Warning! Selected photos will be permanently removed from the album. This action cannot be undone. \n",
    album_message: "Warning! Selected photos will be removed from the album.",
    print_message: "Great! <br>Click OK to confirm, and your print will be ready in a minute.<br>",
    login_message: "<strong>Failed!</strong> User Name or Password is incorrect.",
    session_message: "Your session has expired. Please log in again.",
    unsaved_message: "You have unsaved changes.",
    album_available1: "Available for",
    album_available2: "minutes on photo stream.",
    kiosk_album: "Kiosk Album",
    kiosk_stream: "Kiosk Stream",
    error_name: "Name can not contain numbers and special characters. ",
    error_email_name: "Please enter valid E-mail address. ",
    error_phone_number: "Please enter valid phone number. ",
    error_pc_event_list: "Please select event(s). ",
    HELP_TEXTS: {
        kiosk_album_title: "Open this page on a separate kiosk station. Your users will be able to print and/or request pictures without having to use their phones.",
        kiosk_stream_title: "Open event album in thumbnail only mode on a separate Kiosk station (PC or a Tablet). Users will be able to e-mail the photos to themselves, but will not be able to zoom in to see larger photos. Note! Photos in event stream will expire as per album settings.",
        slide_show_title: "Use this to display photos from this event on an external monitor. This will let all of your your guests see photos from this event on a large screen.",
        email_body_title: "This is the e-mail text that will be sent to users at this event when they request photos. \n {user_name} and {album_link} are placeholders that will be filled out with user's real name and the link to a personal album, which will contain all requested images for that user across all events.",
        email_body_sharing_title: "When users at this event request and receive images, they can further share their photos with friends and family. \n This e-mail text will be offered to the user when she chooses to share her images with others via e-mail.",
        logo_link_title: "Go to this web address if user clicks on album logo. Leave empty to disable clicking."
    },
    upload_message: "The following '~\"$,#%&*:<>?{|} ' characters are NOT allowed in the file names.",
    print_photos_count_error: "You selected too many photos. Please specify the maximum of <limit> photos that you would like printed.",
    print_from_all_albums_disabled: "Printing physical photos for this event is enabled from kiosk station only.\nPrint your photos from the physical kiosk stand where OCCO is working.",
    copies_count_title: "Select print copies count.",
    photos_copy_count_error: "Please enter a number between 1 and <limit> for the maximum number of copies of the same photo users can request to print.",
    per_request_count_error: "Please enter a number between 1 and <limit> for the maximum number of photos users can select to print in a single print request.",
    photo_delete_days_value_error: "Please enter a number between <min-limit> and <limit> for 'Photos auto delete (days)' field.",
    print_request_placeholder_error: "Sorry! The number of pictures to print should be a multiple of <b><count></b>. Select  <b> <count> </b>,  <b> <countx2> </b> or  <b> <countx3> </b> photos and try again.",
    max_photo_stream_avl_minutes_error: "Please specify number of minutes (between 1 and <limit>) to indicate when the Photos in the Event Stream must expire.",
    occo_photo_album: "OCCO Photo Album",
    support: "Support",
    sign_out: "Sign Out",
    my_events: "My Events",
    filter_by: "Filter by",
    show_all: "All ( <NUMBER> )",
    publicly_visible: "Visible ( <NUMBER> )",
    hidden_from_public: "Hidden ( <NUMBER> )",
    album_for_approval: "Album for the approval and curation by the event host",
    copy_link: "Copy Link",
    photos_expire: "Album for sharing with guests/public (photos expire as per event settings)",
    photos_never_expire: "Album for sharing with guests/public (photos never expire)",
    open_kiosk_stream: "Open Kiosk Stream",
    event_add_edit: "Event add/edit",
    edit_event: "Edit Event",
    event: "Event",
    general: "General",
    e_mail_configuration: "E-mail configuration",
    watermarks: "Watermarks",
    photo_configuration: "Photo configuration",
    album_logo: "Event album logo",
    size_for_logo: "Recommended size for logo is 320x40(px).",
    short_code: "Event name (short code):",
    enable_printing: "Use this code inside printer setup window on the print station to enable printing for this event.",
    album_title: "Event album title",
    hashtags: "Social media sharing hashtags:",
    disconnected_from: "Selected robots will be disconnected from previous event",
    delete_event: "Delete event permanently!",
    from_name: "'From Name' to appear on the e-mails sent to users when they request photos:",
    subject_line: "Subject line to appear on e-mails sent to users when they request photos:",
    email_body: "Email body",
    preview: "Preview",
    enable_live: "Enable Live Screen Watermark",
    png_size: "Recommended png size: 1200 x 1800 (width x height pixels)",
    live_view_screen: "This image will be overlayed on top of OCCO's live view screen.",
    enable_watermark: "Enable Watermark on Photos",
    recommended_png_size: "Recommended png size: 1200 x 1800 (width x height pixels)",
    overlayed_on_top: "This image will be overlayed on top of the photos that are uploaded to the album.",
    event_stream: "Photos in the Event Stream must expires (minutes):",
    photo_auto_delete: "Photos auto delete (hours):",
    auto_delete_photo_warn_massage: "Are you sure you want to set up automatic permanent deletion of photos? If this option is selected, all media accessed via links to this album will become unavailable to your end users after the specified expiry. We advise that you use this feature only to comply with legal requirements on data retention and you may want to communicate to your end users that unless they download copies of photos to their devices, they will not be able to access their pictures at a later time from an online album.",
    active_printer: "Enable printing for this event",
    print_every_photo: "Automatically print all photos",
    print_every_photo_note: "If this option is selected, each photo uploaded to this album will be immediately sent to printer once. Additional prints can be ordered by the attendees as usual, e.g. from their phones or from the kiosk. Note! Checking this option may result in high usage of paper media. Make sure that the printer is constantly monitored.",
    active_printer_note: "If you enable printing for this event, users will see a 'Print' option when they open this album either from their phones or from the kiosk.  \nNote! You will have to make sure that printer is connected to a PC where OCCO software is installed and configured to monitor this event. For more information on setting up a print station, refer to your OCCO user manual.",
    enable_printer_all_albums_note: "If this option is checked, users will not be able to print from their mobile devices. The print button on mobile devices will be grayed out and users will be asked to print from a kiosk station.",
    copy_count: "Maximum number of copies of the same photo users can request to print",
    copy_count_note: "Use this setting to prevent users from printing too many copies of the same final composition (which may contain several photos as defined in the print template). E.g. a value of 3 would mean that a user can request up to 3 copies of the same photo or a strip.",
    photos_count: "Maximum number of photos users can select to print in a single print request",
    photos_count_note: "Use this setting to limit the number of photos users can select and send to print. For example, setting this value to 6 would mean that if a user selects 7 or more photos and requests a printout - she will be asked to un-select some pictures to leave at most 6 in the selection. Note! If you are using a print template with more than one photo placeholder per printout - the final number of printed pages can be calculated using the formula: (number of photos users selected / number of placeholders in the print template)",
    distribution_models: "Photo distribution models:",
    collect_leads: "Collect leads when people request photos",
    direct_album: "Direct album access (no leads collected)",
    add: "+ Add",
    update: "Update",
    duplicate_event: "Duplicate Event",
    save: "Save",
    cancel: "Cancel",
    great: "Great!",
    click_ok: "Click OK to confirm, and your print will be ready in a minute.",
    copies_count: "Select print copies count.",
    ok: "OK",
    preview_email: "Preview Email",
    close: "Close",
    hide: "Hide",
    unhide: "Unhide",
    print: "Print",
    delete: "Delete",
    username_and_password: "Enter your username and password to log on",
    username: "Username",
    password: "Password",
    reset_your_password: "To re-set your password please contact",
    image_save_text_mob: "Tap and hold an {file} to save it to your phone. <br><span id='iSB'><a href='javascript:open(location, \"_self\").close();'>back to album</a></span>",
    image_save_text_mob_android: "Tap and hold an {file} to save it to your phone. <br><span id='iSB'><a href='{loc_url}'>back to album</a></span>",
    image_save_text_pc: "Right click on {file} to save it to your PC.<br><span id='iSB'><a href='javascript:open(location, \"_self\").close();'>back to album</a></span>",
    delete_this_template: "Are you sure you want to delete this template?",
    delete_confirm: "Are you sure you want to delete?",
    background_message: "Please select the background image.",
    placeholder_message: "Print template must have at least one placeholder for user photos.",
    template_name_message: "Please enter Printer Template name.",
    max_print_title: "On-time maximum print count is ",
    reset_filter: "Reset filter",
    title_required: "Event album title is a required field.",
    emptyText_required: "Event empty album text is a required field.",
    address_required: "Email From Address is a required field.",
    name_required: "Email From Name is a required field.",
    body_required: "Email body is a required field.",
    body_error: "Email body text has to contain {user_name} and {image_url} strings which will be used to replace the actual values before sending the mail.",
    body_share_error: "Email body text has to contain {image_url} strings which will be used to replace the actual values before sending the mail.",
    sms_body_required: "SMS body is a required field.",
    sms_body_error: "SMS body text has to contain {user_name} and {image_url} strings which will be used to replace the actual values before sending the SMS.",
    save_template: "The template was saved successfully.",
    replace_temp_image: "Replace Template Background Image",
    error_name_message: '"Your name" is required field.',
    occo_album: "Info",
    template_close_confirm: "Do you want to save changes made to this template?",
    new_template_name: "Write new template name",
    valid_url: "Please enter valid url.",
    valid_printer_pool_name: "A queue name is case-sensitive and can have up to 80 characters. You can use alphanumeric characters, hyphens ( - ), and underscores (  _  ).",
    multiple_email: "Enter your email address followed by comma, space, tab or enter",
    add_valid_email: "Add valid e-mail",
    get_images: "Get images",
    please_read_text: "Your privacy is very important to us, please read our {Privacy Policy}",
    privacy_policy_link_name: "Privacy Policy",
    great_text: "Great! <br><br>Check your inbox. You should see an e-mail from {from_name} very soon.",
    great_sms_text: "Great! <br><br>Check your mobile. You should see an SMS from {from_name} very soon.",
    spam_check: "If you don't - check your spam folder.",
    error_generate_att_count_message: "Please enter value between 1-200,000",
    success_generate_att_message: "Please check your provided e-mail to get generated album list.",
    url_contains_white_spaces: "URL won't contain white spaces!",
    slide_show_minmax_intervals_error: "Max interval needs to be more than Min interval.",
    generate_passCodes: "Generate",
    update_passCodes: "Update",
    generate_passCodes_window: "Generate Pass Codes",
    update_passCodes_window: "Update Pass Codes",
    something_wrong: "Something went wrong. Please <a href='javascript:location.reload()'> refresh </a> the page and try again.",
    unsupported_pic_format: "Invalid or unsupported picture format",
    invalid_attendee_id: "Invalid attendee ID.",
    select_pipelines: "Select Pipelines",
    secret_codes_error: "Please add Firstname/Lastname for event unlock codes.",
    unlock_code_error: "Employee authorization code is invalid.",
    kiosk_time_expired: "Sorry, public kiosk time is expired",
    attendee_time_expired: "Sorry, attendee time is expired",
    provide_email_address: "Hi, Please provide your email address.",
    unregister_face: "Remove this face from my collection? <br>New searches will not use this face. Note! Photos you already see in your album found based on this picture will still remain visible to you.",
    delete_image_1: "Yes. This is not my picture",
    attached_successfully: "Photos successfully attached to attendee. ",
    sharing_body_required: "Photo html sharing is a required field.",
    sharing_video_body_required: "Video html sharing is a required field.",
    sharing_360_body_required: "360 Photo html sharing is a required field",
    photo_tag_required: "Photo tag is a required field",
    square_access_token_error: "Square access token is invalid.",
    select_square_locations: "Select Location",
    square_device_name_required: "Device Name is a required field",
    square_location_required: "Location is a required field",
    square_create_device_error: "Creating device failed. Please try again.",
    square_get_device_error: "Device code retrieval failed. Please try again.",
    square_checkout_creation_failed: "Checkout request failed. Please try again later.",
    square_checkout_status_check_failed: "Checkout status check failed. Please try again later.",
    square_checkout_cancellation_failed: "Checkout cancellation failed. Please try again later.",
    payment_failed: "Payment failed. Please try again later."
};

});

parcelRegister("5fxxW", function(module, exports) {

$parcel$export(module.exports, "occoApi", function () { return $3d2860109a556581$export$3259b9843a3c3aa6; });

var $a4qiB = parcelRequire("a4qiB");
function $3d2860109a556581$var$OccoApi() {
    // organisationId is optional
    this.robotListRetrieve = function(organisationId, callback) {
        const body = {};
        if (organisationId) body.organisation_id = organisationId;
        const methodPath = "/occo-owner/robot/list/retrieve";
        const hasApiKey = true;
        _occoApiPostRequest(hasApiKey, methodPath, body, callback);
    };
    this.stockImageListRetrieve = function(eventId, callback) {
        const body = {};
        if (eventId) body.event_id = eventId;
        const methodPath = "/occo-owner/stock-image/list/retrieve";
        const hasApiKey = true;
        _occoApiPostRequest(hasApiKey, methodPath, body, callback);
    };
    this.organisationListRetrieve = function(callback) {
        const body = {};
        const methodPath = "/occo-owner/organisation/list/retrieve";
        const hasApiKey = true;
        _occoApiPostRequest(hasApiKey, methodPath, body, callback);
    };
    /*
   * key_type possible values
   *   - event_owner_api_key (keyValue type string : eventOwnerApiKey)
   *   - event_public_api_key (keyValue type string : eventPublicApiKey)
   *   - event_private_api_key (keyValue type string : eventPrivateApiKey)
   *   - attendee_uid (keyValue type string : attendeeUid)
   *   - attendee_and_org_uids (keyValue type json obj e.g. {"attendee_uid" : "value1", "organisation_uid" : "value2"})
   */ this.eventListRetrieve = function(keyType, keyValue, callback) {
        const body = {};
        body.max_size = 5000;
        body.page_number = 1;
        const hasApiKey = keyType == null;
        if (!hasApiKey) {
            body.key_type = keyType;
            body.key_value = keyValue;
        }
        const showApiErrors = keyType == "event_owner_api_key";
        const methodPath = hasApiKey ? "/occo-owner/event/list/retrieve" : "/event/list/retrieve";
        _occoApiPostRequestBase(hasApiKey, methodPath, body, showApiErrors, callback);
    };
    this.pptDelete = function(id, callback) {
        const body = {};
        body.id = id;
        const methodPath = "/occo-owner/ppt/delete";
        const hasApiKey = true;
        _occoApiPostRequest(hasApiKey, methodPath, body, callback);
    };
    // organisationId is optional
    this.pptListRetrieve = function(organisationId, isWatermarkTemplate, callback) {
        const body = {};
        if (organisationId) body.organisation_id = organisationId;
        if (isWatermarkTemplate) body.is_watermark = isWatermarkTemplate;
        const methodPath = "/occo-owner/ppt/list/retrieve";
        const hasApiKey = true;
        _occoApiPostRequest(hasApiKey, methodPath, body, callback);
    };
    this.customPhotoTmpUploadAccessRetrieve = function(event_name, file_name, keep_origin_name, attendeeUid, callback) {
        const body = {};
        body.event_name = event_name;
        body.file_name = file_name;
        body.keep_origin_name = keep_origin_name;
        body.attendee_uid = attendeeUid;
        const methodPath = "/event/tmp-photo-upload-access/retrieve";
        const hasApiKey = false;
        _occoApiPostRequest(hasApiKey, methodPath, body, callback);
    };
    this.miniAlbumcreateCustomPhoto = function(eventName, fullPath, attendeeUid, callback) {
        const body = {};
        body.event_name = eventName;
        body.full_path = fullPath;
        body.attendee_uid = attendeeUid;
        const methodPath = "/event/create-attendee-custom-photo/async";
        const hasApiKey = false;
        _occoApiPostRequest(hasApiKey, methodPath, body, callback);
    };
    this.activityCreateByRobotId = function(robotId, photoId, activityName, activityType, attUid, callback) {
        const body = {};
        body.robot_id = robotId;
        body.photo_id = photoId;
        body.activity_name = activityName;
        body.activity_type = activityType;
        body.attUid = attUid;
        const methodPath = "/activity/create-by-robot-id";
        const hasApiKey = false;
        _occoApiPostRequest(hasApiKey, methodPath, body, callback);
    };
    this.activityBulkCreateByRobotId = function(robotId, listOfPhotoId, activityName, activityType, attUid, callback) {
        const body = {};
        body.robot_id = robotId;
        body.list_of_photo_id = listOfPhotoId;
        body.activity_name = activityName;
        body.activity_type = activityType;
        body.attUid = attUid;
        const methodPath = "/activity/bulk-create-by-robot-id";
        const hasApiKey = false;
        _occoApiPostRequest(hasApiKey, methodPath, body, callback);
    };
    /*
   * key_type possible values
   *   - event_name_key (keyValue type string : eventName)
   *   - event_owner_api_key (keyValue type string : eventOwnerApiKey)
   *   - event_public_api_key (keyValue type string : eventPublicApiKey)
   *   - event_private_api_key (keyValue type string : eventPrivateApiKey)
   *   - attendee_uid (keyValue type string : attendeeUid)
   *   - attendee_and_org_uids (keyValue type json obj e.g. {"attendee_uid" : "value1", "organisation_uid" : "value2"})
   */ this.photoListRetrieve = function(keyType, keyValue, eventId, isVisible, startDate, endDate, maxSize, pageNumber, minInterval, maxInterval, forKiosk, isCuratable, isCurated, isOriginal, printable, printed, attId, showTotalCount, fileName, getFromTmp, callback) {
        const body = {};
        body.event_id = eventId;
        body.max_size = maxSize;
        body.page_number = pageNumber;
        body.min_time_minutes_interval = minInterval;
        body.max_time_minutes_interval = maxInterval;
        body.is_kiosk = forKiosk;
        body.is_curatable = isCuratable;
        body.is_curated = isCurated;
        body.is_original = isOriginal;
        body.printable = printable;
        body.printed = printed;
        body.file_name = fileName;
        body.attendee_uid = attId;
        body.show_total_count = showTotalCount;
        body.get_from_tmp = getFromTmp;
        if (typeof isVisible !== "undefined" && isVisible !== null && isVisible !== "" && isVisible !== "null") body.is_visible = isVisible;
        const hasApiKey = keyType == null;
        if (startDate) body.start_date = startDate;
        if (endDate) body.end_date = endDate;
        if (!hasApiKey) {
            body.key_type = keyType;
            body.key_value = keyValue;
        }
        const showApiErrors = keyType == "event_owner_api_key";
        const methodPath = hasApiKey ? "/occo-owner/photo/list/retrieve" : "/photo/list/retrieve";
        _occoApiPostRequestBase(hasApiKey, methodPath, body, showApiErrors, callback);
    };
    this.passCodeListRetrieve = function(callback) {
        const body = {};
        const methodPath = "/occo-owner/pass-code/list/retrieve";
        const hasApiKey = true;
        _occoApiPostRequest(hasApiKey, methodPath, body, callback);
    };
    this.passCodeDelete = function(id, callback) {
        const body = {};
        body.id = id;
        const methodPath = "/occo-owner/pass-code/delete";
        const hasApiKey = true;
        _occoApiPostRequest(hasApiKey, methodPath, body, callback);
    };
    // profile picture methods
    this.profilePhotoListRetrieve = function(attId, callback) {
        const body = {};
        body.attendee_uid = attId;
        const methodPath = "/attendee/profile-photo/list/retrieve";
        const hasApiKey = false;
        _occoApiPostRequest(hasApiKey, methodPath, body, callback);
    };
    this.profilePhotoTmpUploadAccessRetrieve = function(file_name, callback) {
        const body = {};
        body.file_relative_path = file_name;
        const methodPath = "/photo/tmp-upload-access/retrieve";
        const hasApiKey = false;
        _occoApiPostRequest(hasApiKey, methodPath, body, callback);
    };
    this.createProfilePhoto = function(attId, full_path, event_name, callback) {
        const body = {};
        body.attendee_uid = attId;
        body.full_path = full_path;
        body.event_name = event_name;
        const methodPath = "/attendee/profile-photo/create";
        const hasApiKey = false;
        _occoApiPostRequest(hasApiKey, methodPath, body, callback);
    };
    function _occoApiPostRequest(hasApiKey, methodPath, body, callback) {
        _occoApiPostRequestBase(hasApiKey, methodPath, body, false, callback);
    }
    function _occoApiPostRequestBase(hasApiKey, methodPath, body, showApiErrors, callback) {
        const showErr = hasApiKey || showApiErrors || window.DEBUG_MODE;
        const ajaxParams = {
            url: "https://api-new.occo.io/v1" + methodPath,
            type: "POST",
            dataType: "json",
            data: JSON.stringify(body),
            success (resp, textStatus, jqXHR) {
                if (resp.status == "ok") callback(null, resp.result);
                else if (resp.status == "nok") {
                    const err1 = {};
                    err1.type = "occo";
                    err1.message_key = showErr ? resp.error_message_key : "Internal Error";
                    err1.message_text = showErr ? resp.error.message_text : "Internal Error";
                    err1.textStatus = textStatus;
                    err1.jqXHR = jqXHR;
                    err1.resp = resp;
                    console.error("err", JSON.stringify(err1));
                    callback(err1, null);
                } else {
                    const err2 = {};
                    err2.type = "occo";
                    err2.message_key = "Internal Error";
                    err2.jqXHR = jqXHR;
                    err2.textStatus = textStatus;
                    err2.resp = resp;
                    console.error("err", JSON.stringify(err2));
                    callback(err2, null);
                }
            },
            error (jqXHR, textStatus, errorThrown) {
                if (jqXHR.readyState == 0 || jqXHR.status == 0) return; // it's not really an error,
                const err = {};
                err.type = "global";
                err.message_key = "Internal Error";
                err.jqXHR = jqXHR;
                err.textStatus = textStatus;
                err.errorThrown = errorThrown;
                console.error("err", JSON.stringify(err));
                callback(err, null);
            }
        };
        if (hasApiKey) cognitoApi.getApiKey((err, apiKey)=>{
            if (err) {
                window.location.href = "./";
                // callback(err, null);
                return;
            }
            ajaxParams.headers = {
                Authorization: apiKey
            };
            (0, (/*@__PURE__*/$parcel$interopDefault($a4qiB))).ajax(ajaxParams);
        });
        else (0, (/*@__PURE__*/$parcel$interopDefault($a4qiB))).ajax(ajaxParams);
    }
}
const $3d2860109a556581$export$3259b9843a3c3aa6 = new $3d2860109a556581$var$OccoApi();

});

parcelRegister("lIiEk", function(module, exports) {

$parcel$export(module.exports, "initAccessDataStorage", function () { return $fcec2c72204eb234$export$f7ff41ecbdcf0dc9; });
$parcel$export(module.exports, "makeAccessData", function () { return $fcec2c72204eb234$export$d52e912a0a450989; });
$parcel$export(module.exports, "isEnabledWatermarkBySrc", function () { return $fcec2c72204eb234$export$236edb79db2ae543; });
$parcel$export(module.exports, "isAvailableToUsePhoto", function () { return $fcec2c72204eb234$export$2254fffb7238a3bf; });
$parcel$export(module.exports, "getWatermarkSrc", function () { return $fcec2c72204eb234$export$fc00daa1497efd87; });
$parcel$export(module.exports, "initWatermarkStorage", function () { return $fcec2c72204eb234$export$14db028e6808e544; });
parcelRequire("4ZlRn");
var $bwvc9 = parcelRequire("bwvc9");
function $fcec2c72204eb234$export$f7ff41ecbdcf0dc9() {
    return {
        setData (access) {
            localStorage.setItem("access", JSON.stringify(access));
        },
        getData () {
            return JSON.parse(localStorage.getItem("access") || "{}");
        }
    };
}
function $fcec2c72204eb234$export$d52e912a0a450989({ isFreeEvent: isFreeEvent = false, wasPaid: wasPaid = false } = {}) {
    return {
        isFreeEvent: isFreeEvent,
        wasPaid: wasPaid
    };
}
function $fcec2c72204eb234$export$5b1ffa3a68bdd25a(access) {
    return access.isFreeEvent || access.wasPaid;
}
function $fcec2c72204eb234$export$236edb79db2ae543(src) {
    const labelWM = "nwm845";
    return !src.includes(labelWM);
}
const $fcec2c72204eb234$export$2254fffb7238a3bf = (0, $bwvc9.default)((access, photo)=>// console.log('isAvailableToUsePhoto', hasFullAccess(access) || !isEnabledWatermarkBySrc(photo.full_path), hasFullAccess(access), !isEnabledWatermarkBySrc(photo.full_path));
    $fcec2c72204eb234$export$5b1ffa3a68bdd25a(access) || !$fcec2c72204eb234$export$236edb79db2ae543(photo.full_path));
function $fcec2c72204eb234$export$fc00daa1497efd87(access, photo, watermarkSrc = null) {
    if (!$fcec2c72204eb234$export$2254fffb7238a3bf(access, photo)) return watermarkSrc;
    return null;
}
function $fcec2c72204eb234$export$14db028e6808e544() {
    return {
        setSrc (src) {
            localStorage.setItem("watermarkSrc", src);
        },
        getSrc () {
            return localStorage.getItem("watermarkSrc");
        }
    };
}

});
parcelRegister("4ZlRn", function(module, exports) {

$parcel$export(module.exports, "countBy", function () { return (parcelRequire("52xzQ")).default; });
$parcel$export(module.exports, "curry", function () { return (parcelRequire("bwvc9")).default; });
$parcel$export(module.exports, "groupBy", function () { return (parcelRequire("e6Neg")).default; });
$parcel$export(module.exports, "uniq", function () { return (parcelRequire("cUasK")).default; });

var $7KZJE = parcelRequire("7KZJE");

var $eH6Wk = parcelRequire("eH6Wk");

var $kXbl2 = parcelRequire("kXbl2");

var $gQVWJ = parcelRequire("gQVWJ");

var $hI7JW = parcelRequire("hI7JW");

var $bQJaX = parcelRequire("bQJaX");

var $3pbdp = parcelRequire("3pbdp");

var $iLCqw = parcelRequire("iLCqw");

var $kYiXR = parcelRequire("kYiXR");

var $er53b = parcelRequire("er53b");

var $94JdJ = parcelRequire("94JdJ");

var $adTN6 = parcelRequire("adTN6");

var $7WWJI = parcelRequire("7WWJI");

var $fewnZ = parcelRequire("fewnZ");

var $3qZRM = parcelRequire("3qZRM");

var $4CYoD = parcelRequire("4CYoD");

var $gBa3c = parcelRequire("gBa3c");

var $lHaNg = parcelRequire("lHaNg");

var $8Ut3a = parcelRequire("8Ut3a");

var $bAwZa = parcelRequire("bAwZa");

var $bJ6V5 = parcelRequire("bJ6V5");

var $6ISnw = parcelRequire("6ISnw");

var $lMRCz = parcelRequire("lMRCz");

var $kaTmS = parcelRequire("kaTmS");

var $5d7w3 = parcelRequire("5d7w3");

var $isJKB = parcelRequire("isJKB");

var $eprAX = parcelRequire("eprAX");

var $byUaQ = parcelRequire("byUaQ");

var $71aof = parcelRequire("71aof");

var $fYB5y = parcelRequire("fYB5y");

var $hDFDa = parcelRequire("hDFDa");

var $2kk8J = parcelRequire("2kk8J");

var $ap0Or = parcelRequire("ap0Or");

var $j492g = parcelRequire("j492g");

var $hPnpi = parcelRequire("hPnpi");

var $4pXxy = parcelRequire("4pXxy");

var $jXgv2 = parcelRequire("jXgv2");

var $dgkqv = parcelRequire("dgkqv");

var $4AxPp = parcelRequire("4AxPp");

var $52xzQ = parcelRequire("52xzQ");

var $bwvc9 = parcelRequire("bwvc9");

var $4fS8E = parcelRequire("4fS8E");

var $1WRpV = parcelRequire("1WRpV");

var $aggRQ = parcelRequire("aggRQ");

var $349Jh = parcelRequire("349Jh");

var $9bAZP = parcelRequire("9bAZP");

var $6gGsO = parcelRequire("6gGsO");

var $296j3 = parcelRequire("296j3");

var $cNWXH = parcelRequire("cNWXH");

var $a3dtn = parcelRequire("a3dtn");

var $hiSaj = parcelRequire("hiSaj");

var $2UBmu = parcelRequire("2UBmu");

var $9eTfQ = parcelRequire("9eTfQ");

var $f38Lf = parcelRequire("f38Lf");

var $17lCb = parcelRequire("17lCb");

var $2YF0S = parcelRequire("2YF0S");

var $7yOkz = parcelRequire("7yOkz");

var $b5mg2 = parcelRequire("b5mg2");

var $23Ma3 = parcelRequire("23Ma3");

var $kdTlC = parcelRequire("kdTlC");

var $jYPez = parcelRequire("jYPez");

var $imwRL = parcelRequire("imwRL");

var $c1q0D = parcelRequire("c1q0D");

var $f9Ph0 = parcelRequire("f9Ph0");

var $4VOHs = parcelRequire("4VOHs");

var $iMzRV = parcelRequire("iMzRV");

var $32oB6 = parcelRequire("32oB6");

var $1WHbP = parcelRequire("1WHbP");

var $j2hqt = parcelRequire("j2hqt");

var $44Hns = parcelRequire("44Hns");

var $jspAR = parcelRequire("jspAR");

var $8ZhTj = parcelRequire("8ZhTj");

var $fDyP5 = parcelRequire("fDyP5");

var $e6Neg = parcelRequire("e6Neg");

var $bLcTX = parcelRequire("bLcTX");

var $44CLl = parcelRequire("44CLl");

var $jhlsl = parcelRequire("jhlsl");

var $dVQ7b = parcelRequire("dVQ7b");

var $8xANO = parcelRequire("8xANO");

var $5tWcN = parcelRequire("5tWcN");

var $68oBa = parcelRequire("68oBa");

var $3Q4h5 = parcelRequire("3Q4h5");

var $7x9UL = parcelRequire("7x9UL");

var $j8Afz = parcelRequire("j8Afz");

var $8EXHZ = parcelRequire("8EXHZ");

var $5OGbd = parcelRequire("5OGbd");

var $24z4h = parcelRequire("24z4h");

var $d30Fl = parcelRequire("d30Fl");

var $5QT1G = parcelRequire("5QT1G");

var $5GjKl = parcelRequire("5GjKl");

var $hqtpz = parcelRequire("hqtpz");

var $XTBbw = parcelRequire("XTBbw");

var $e8P0k = parcelRequire("e8P0k");

var $6hiiZ = parcelRequire("6hiiZ");

var $eBOev = parcelRequire("eBOev");

var $aZ9bi = parcelRequire("aZ9bi");

var $9YzBQ = parcelRequire("9YzBQ");

var $cEVJS = parcelRequire("cEVJS");

var $cOkKO = parcelRequire("cOkKO");

var $dXLll = parcelRequire("dXLll");

var $fWvks = parcelRequire("fWvks");

var $83uBf = parcelRequire("83uBf");

var $65e2B = parcelRequire("65e2B");

var $ipwCl = parcelRequire("ipwCl");

var $6TYSi = parcelRequire("6TYSi");

var $jkKjk = parcelRequire("jkKjk");

var $avLOW = parcelRequire("avLOW");

var $he1YE = parcelRequire("he1YE");

var $r8Zow = parcelRequire("r8Zow");

var $5nCmM = parcelRequire("5nCmM");

var $agIZU = parcelRequire("agIZU");

var $8wTwB = parcelRequire("8wTwB");

var $3Jc8c = parcelRequire("3Jc8c");

var $cB4Gm = parcelRequire("cB4Gm");

var $4U32h = parcelRequire("4U32h");

var $lFc9n = parcelRequire("lFc9n");

var $aaiYf = parcelRequire("aaiYf");

var $76tHB = parcelRequire("76tHB");

var $i1Qcw = parcelRequire("i1Qcw");

var $f3BXJ = parcelRequire("f3BXJ");

var $fVzFi = parcelRequire("fVzFi");

var $2fqFd = parcelRequire("2fqFd");

var $64epv = parcelRequire("64epv");

var $cn6A8 = parcelRequire("cn6A8");

var $jLPNx = parcelRequire("jLPNx");

var $aCMLH = parcelRequire("aCMLH");

var $jWgN9 = parcelRequire("jWgN9");

var $2rRZu = parcelRequire("2rRZu");

var $dSK6u = parcelRequire("dSK6u");

var $aXbjc = parcelRequire("aXbjc");

var $8wIVI = parcelRequire("8wIVI");

var $c8cXo = parcelRequire("c8cXo");

var $d9gmn = parcelRequire("d9gmn");

var $6mxyo = parcelRequire("6mxyo");

var $i7UYI = parcelRequire("i7UYI");

var $fSdWs = parcelRequire("fSdWs");

var $gNYTO = parcelRequire("gNYTO");

var $9M7rx = parcelRequire("9M7rx");

var $4t2Mj = parcelRequire("4t2Mj");

var $2uMop = parcelRequire("2uMop");

var $dNjK4 = parcelRequire("dNjK4");

var $bKKpV = parcelRequire("bKKpV");

var $kN79E = parcelRequire("kN79E");

var $kRpXl = parcelRequire("kRpXl");

var $gRk4Y = parcelRequire("gRk4Y");

var $gdogu = parcelRequire("gdogu");

var $1ygww = parcelRequire("1ygww");

var $4U3VF = parcelRequire("4U3VF");

var $7aHtE = parcelRequire("7aHtE");

var $hOpjF = parcelRequire("hOpjF");

var $kb8Qx = parcelRequire("kb8Qx");

var $hniUa = parcelRequire("hniUa");

var $3cgNi = parcelRequire("3cgNi");

var $jQGiS = parcelRequire("jQGiS");

var $JsWNL = parcelRequire("JsWNL");

var $77Q6n = parcelRequire("77Q6n");

var $9fOQE = parcelRequire("9fOQE");

var $7ax8J = parcelRequire("7ax8J");

var $hon8i = parcelRequire("hon8i");

var $hJlbw = parcelRequire("hJlbw");

var $b43or = parcelRequire("b43or");

var $4R9pl = parcelRequire("4R9pl");

var $locxm = parcelRequire("locxm");

var $6jckq = parcelRequire("6jckq");

var $jrg6g = parcelRequire("jrg6g");

var $lGZP4 = parcelRequire("lGZP4");

var $bI2RE = parcelRequire("bI2RE");

var $aw0nC = parcelRequire("aw0nC");

var $eWfni = parcelRequire("eWfni");

var $hmL6L = parcelRequire("hmL6L");

var $3zcb7 = parcelRequire("3zcb7");

var $3Foym = parcelRequire("3Foym");

var $4PEAx = parcelRequire("4PEAx");

var $gUBuO = parcelRequire("gUBuO");

var $hHIz2 = parcelRequire("hHIz2");

var $ac5ki = parcelRequire("ac5ki");

var $3g8sN = parcelRequire("3g8sN");

var $39UUv = parcelRequire("39UUv");

var $hvsdM = parcelRequire("hvsdM");

var $gU8MS = parcelRequire("gU8MS");

var $7KKWT = parcelRequire("7KKWT");

var $3atyM = parcelRequire("3atyM");

var $5yk0W = parcelRequire("5yk0W");

var $2nBbR = parcelRequire("2nBbR");

var $3RZ3d = parcelRequire("3RZ3d");

var $hv0Dt = parcelRequire("hv0Dt");

var $5cYgD = parcelRequire("5cYgD");

var $6lfus = parcelRequire("6lfus");

var $4IOvg = parcelRequire("4IOvg");

var $37pBi = parcelRequire("37pBi");

var $8MN2o = parcelRequire("8MN2o");

var $7o3gB = parcelRequire("7o3gB");

var $4OLsx = parcelRequire("4OLsx");

var $bDzpV = parcelRequire("bDzpV");

var $dEOUW = parcelRequire("dEOUW");

var $iUpGr = parcelRequire("iUpGr");

var $kM76K = parcelRequire("kM76K");

var $3CcZV = parcelRequire("3CcZV");

var $1kRJS = parcelRequire("1kRJS");

var $heWex = parcelRequire("heWex");

var $fE7W5 = parcelRequire("fE7W5");

var $c1Uip = parcelRequire("c1Uip");

var $h1eaD = parcelRequire("h1eaD");

var $2IhIz = parcelRequire("2IhIz");

var $8aeBf = parcelRequire("8aeBf");

var $63F62 = parcelRequire("63F62");

var $1ppgG = parcelRequire("1ppgG");

var $cpb0s = parcelRequire("cpb0s");

var $gxSRW = parcelRequire("gxSRW");

var $7FHgD = parcelRequire("7FHgD");

var $eBWsJ = parcelRequire("eBWsJ");

var $kMiAN = parcelRequire("kMiAN");

var $cWyLj = parcelRequire("cWyLj");

var $8FDfT = parcelRequire("8FDfT");

var $ib5ss = parcelRequire("ib5ss");

var $9mURk = parcelRequire("9mURk");

var $3YSkq = parcelRequire("3YSkq");

var $lKSKr = parcelRequire("lKSKr");

var $bqbRU = parcelRequire("bqbRU");

var $gc8e0 = parcelRequire("gc8e0");

var $a4Usn = parcelRequire("a4Usn");

var $llaSl = parcelRequire("llaSl");

var $cXjE7 = parcelRequire("cXjE7");

var $c1JEt = parcelRequire("c1JEt");

var $220yG = parcelRequire("220yG");

var $7NyiS = parcelRequire("7NyiS");

var $8msyp = parcelRequire("8msyp");

var $1iggl = parcelRequire("1iggl");

var $cVAGQ = parcelRequire("cVAGQ");

var $lwtUC = parcelRequire("lwtUC");

var $298Xn = parcelRequire("298Xn");

var $1gWdq = parcelRequire("1gWdq");

var $dELsY = parcelRequire("dELsY");

var $2OqUW = parcelRequire("2OqUW");

var $eDfiu = parcelRequire("eDfiu");

var $2C3Vc = parcelRequire("2C3Vc");

var $cWjD4 = parcelRequire("cWjD4");

var $45X08 = parcelRequire("45X08");

var $cUasK = parcelRequire("cUasK");

var $kcZJQ = parcelRequire("kcZJQ");

var $aIwpH = parcelRequire("aIwpH");

var $dYLtE = parcelRequire("dYLtE");

var $7UMNL = parcelRequire("7UMNL");

var $1H1PQ = parcelRequire("1H1PQ");

var $bhFZP = parcelRequire("bhFZP");

var $9F9TM = parcelRequire("9F9TM");

var $2PkVS = parcelRequire("2PkVS");

var $9SNsK = parcelRequire("9SNsK");

var $kz9Ze = parcelRequire("kz9Ze");

var $bDLKn = parcelRequire("bDLKn");

var $ivVhR = parcelRequire("ivVhR");

var $f0KXx = parcelRequire("f0KXx");

var $96e5t = parcelRequire("96e5t");

var $lysVX = parcelRequire("lysVX");

var $8tUYZ = parcelRequire("8tUYZ");

var $dJwPV = parcelRequire("dJwPV");

var $b7jhD = parcelRequire("b7jhD");

var $b5liY = parcelRequire("b5liY");

var $edOvu = parcelRequire("edOvu");

var $9v1VT = parcelRequire("9v1VT");

var $kCWzi = parcelRequire("kCWzi");

});
parcelRegister("7KZJE", function(module, exports) {
/**
 * A function that always returns `false`. Any passed in parameters are ignored.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Function
 * @sig * -> Boolean
 * @param {*}
 * @return {Boolean}
 * @see R.T
 * @example
 *
 *      R.F(); //=> false
 */ var $5a5cb79a32847067$var$F = function() {
    return false;
};
var $5a5cb79a32847067$export$2e2bcd8739ae039 = $5a5cb79a32847067$var$F;

});

parcelRegister("eH6Wk", function(module, exports) {
/**
 * A function that always returns `true`. Any passed in parameters are ignored.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Function
 * @sig * -> Boolean
 * @param {*}
 * @return {Boolean}
 * @see R.F
 * @example
 *
 *      R.T(); //=> true
 */ var $ab2a76ec01452283$var$T = function() {
    return true;
};
var $ab2a76ec01452283$export$2e2bcd8739ae039 = $ab2a76ec01452283$var$T;

});

parcelRegister("kXbl2", function(module, exports) {
/**
 * A special placeholder value used to specify "gaps" within curried functions,
 * allowing partial application of any combination of arguments, regardless of
 * their positions.
 *
 * If `g` is a curried ternary function and `_` is `R.__`, the following are
 * equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2, _)(1, 3)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @name __
 * @constant
 * @memberOf R
 * @since v0.6.0
 * @category Function
 * @example
 *
 *      const greet = R.replace('{name}', R.__, 'Hello, {name}!');
 *      greet('Alice'); //=> 'Hello, Alice!'
 */ var $f4121ce4f9048803$export$2e2bcd8739ae039 = {
    "@@functional/placeholder": true
};

});

parcelRegister("gQVWJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c44e739a1307d05f$export$2e2bcd8739ae039; });

var $4E2dE = parcelRequire("4E2dE");
/**
 * Adds two values.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a
 * @param {Number} b
 * @return {Number}
 * @see R.subtract
 * @example
 *
 *      R.add(2, 3);       //=>  5
 *      R.add(7)(10);      //=> 17
 */ var $c44e739a1307d05f$var$add = /*#__PURE__*/ (0, $4E2dE.default)(function add(a, b) {
    return Number(a) + Number(b);
});
var $c44e739a1307d05f$export$2e2bcd8739ae039 = $c44e739a1307d05f$var$add;

});
parcelRegister("4E2dE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $361c9e8cfa27a3da$export$2e2bcd8739ae039; });

var $lrIA4 = parcelRequire("lrIA4");

var $95Ao6 = parcelRequire("95Ao6");
function $361c9e8cfa27a3da$export$2e2bcd8739ae039(fn) {
    return function f2(a, b) {
        switch(arguments.length){
            case 0:
                return f2;
            case 1:
                return (0, $95Ao6.default)(a) ? f2 : (0, $lrIA4.default)(function(_b) {
                    return fn(a, _b);
                });
            default:
                return (0, $95Ao6.default)(a) && (0, $95Ao6.default)(b) ? f2 : (0, $95Ao6.default)(a) ? (0, $lrIA4.default)(function(_a) {
                    return fn(_a, b);
                }) : (0, $95Ao6.default)(b) ? (0, $lrIA4.default)(function(_b) {
                    return fn(a, _b);
                }) : fn(a, b);
        }
    };
}

});
parcelRegister("lrIA4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f9ceb36724917355$export$2e2bcd8739ae039; });

var $95Ao6 = parcelRequire("95Ao6");
function $f9ceb36724917355$export$2e2bcd8739ae039(fn) {
    return function f1(a) {
        if (arguments.length === 0 || (0, $95Ao6.default)(a)) return f1;
        else return fn.apply(this, arguments);
    };
}

});
parcelRegister("95Ao6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $69e0ce8675772d40$export$2e2bcd8739ae039; });
function $69e0ce8675772d40$export$2e2bcd8739ae039(a) {
    return a != null && typeof a === "object" && a["@@functional/placeholder"] === true;
}

});




parcelRegister("hI7JW", function(module, exports) {

var $cJJmw = parcelRequire("cJJmw");

var $lrIA4 = parcelRequire("lrIA4");

var $4fS8E = parcelRequire("4fS8E");
/**
 * Creates a new list iteration function from an existing one by adding two new
 * parameters to its callback function: the current index, and the entire list.
 *
 * This would turn, for instance, [`R.map`](#map) function into one that
 * more closely resembles `Array.prototype.map`. Note that this will only work
 * for functions in which the iteration callback function is the first
 * parameter, and where the list is the last parameter. (This latter might be
 * unimportant if the list parameter is not used.)
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category Function
 * @category List
 * @sig (((a ...) -> b) ... -> [a] -> *) -> (((a ..., Int, [a]) -> b) ... -> [a] -> *)
 * @param {Function} fn A list iteration function that does not pass index or list to its callback
 * @return {Function} An altered list iteration function that passes (item, index, list) to its callback
 * @example
 *
 *      const mapIndexed = R.addIndex(R.map);
 *      mapIndexed((val, idx) => idx + '-' + val, ['f', 'o', 'o', 'b', 'a', 'r']);
 *      //=> ['0-f', '1-o', '2-o', '3-b', '4-a', '5-r']
 */ var $ce4c8cb8d731139d$var$addIndex = /*#__PURE__*/ (0, $lrIA4.default)(function addIndex(fn) {
    return (0, $4fS8E.default)(fn.length, function() {
        var idx = 0;
        var origFn = arguments[0];
        var list = arguments[arguments.length - 1];
        var args = Array.prototype.slice.call(arguments, 0);
        args[0] = function() {
            var result = origFn.apply(this, (0, $cJJmw.default)(arguments, [
                idx,
                list
            ]));
            idx += 1;
            return result;
        };
        return fn.apply(this, args);
    });
});
var $ce4c8cb8d731139d$export$2e2bcd8739ae039 = $ce4c8cb8d731139d$var$addIndex;

});
parcelRegister("cJJmw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $945ce001a95d68cd$export$2e2bcd8739ae039; });
/**
 * Private `concat` function to merge two array-like objects.
 *
 * @private
 * @param {Array|Arguments} [set1=[]] An array-like object.
 * @param {Array|Arguments} [set2=[]] An array-like object.
 * @return {Array} A new, merged array.
 * @example
 *
 *      _concat([4, 5, 6], [1, 2, 3]); //=> [4, 5, 6, 1, 2, 3]
 */ function $945ce001a95d68cd$export$2e2bcd8739ae039(set1, set2) {
    set1 = set1 || [];
    set2 = set2 || [];
    var idx;
    var len1 = set1.length;
    var len2 = set2.length;
    var result = [];
    idx = 0;
    while(idx < len1){
        result[result.length] = set1[idx];
        idx += 1;
    }
    idx = 0;
    while(idx < len2){
        result[result.length] = set2[idx];
        idx += 1;
    }
    return result;
}

});

parcelRegister("4fS8E", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $31928eeadc92a247$export$2e2bcd8739ae039; });

var $fe9oK = parcelRequire("fe9oK");

var $lrIA4 = parcelRequire("lrIA4");

var $4E2dE = parcelRequire("4E2dE");

var $2ikoZ = parcelRequire("2ikoZ");
/**
 * Returns a curried equivalent of the provided function, with the specified
 * arity. The curried function has two unusual capabilities. First, its
 * arguments needn't be provided one at a time. If `g` is `R.curryN(3, f)`, the
 * following are equivalent:
 *
 *   - `g(1)(2)(3)`
 *   - `g(1)(2, 3)`
 *   - `g(1, 2)(3)`
 *   - `g(1, 2, 3)`
 *
 * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
 * "gaps", allowing partial application of any combination of arguments,
 * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
 * the following are equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @func
 * @memberOf R
 * @since v0.5.0
 * @category Function
 * @sig Number -> (* -> a) -> (* -> a)
 * @param {Number} length The arity for the returned function.
 * @param {Function} fn The function to curry.
 * @return {Function} A new, curried function.
 * @see R.curry
 * @example
 *
 *      const sumArgs = (...args) => R.sum(args);
 *
 *      const curriedAddFourNumbers = R.curryN(4, sumArgs);
 *      const f = curriedAddFourNumbers(1, 2);
 *      const g = f(3);
 *      g(4); //=> 10
 */ var $31928eeadc92a247$var$curryN = /*#__PURE__*/ (0, $4E2dE.default)(function curryN(length, fn) {
    if (length === 1) return (0, $lrIA4.default)(fn);
    return (0, $fe9oK.default)(length, (0, $2ikoZ.default)(length, [], fn));
});
var $31928eeadc92a247$export$2e2bcd8739ae039 = $31928eeadc92a247$var$curryN;

});
parcelRegister("fe9oK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b15f74174e60620e$export$2e2bcd8739ae039; });
function $b15f74174e60620e$export$2e2bcd8739ae039(n, fn) {
    /* eslint-disable no-unused-vars */ switch(n){
        case 0:
            return function() {
                return fn.apply(this, arguments);
            };
        case 1:
            return function(a0) {
                return fn.apply(this, arguments);
            };
        case 2:
            return function(a0, a1) {
                return fn.apply(this, arguments);
            };
        case 3:
            return function(a0, a1, a2) {
                return fn.apply(this, arguments);
            };
        case 4:
            return function(a0, a1, a2, a3) {
                return fn.apply(this, arguments);
            };
        case 5:
            return function(a0, a1, a2, a3, a4) {
                return fn.apply(this, arguments);
            };
        case 6:
            return function(a0, a1, a2, a3, a4, a5) {
                return fn.apply(this, arguments);
            };
        case 7:
            return function(a0, a1, a2, a3, a4, a5, a6) {
                return fn.apply(this, arguments);
            };
        case 8:
            return function(a0, a1, a2, a3, a4, a5, a6, a7) {
                return fn.apply(this, arguments);
            };
        case 9:
            return function(a0, a1, a2, a3, a4, a5, a6, a7, a8) {
                return fn.apply(this, arguments);
            };
        case 10:
            return function(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
                return fn.apply(this, arguments);
            };
        default:
            throw new Error("First argument to _arity must be a non-negative integer no greater than ten");
    }
}

});

parcelRegister("2ikoZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1abd16a6f5e85a08$export$2e2bcd8739ae039; });

var $fe9oK = parcelRequire("fe9oK");

var $95Ao6 = parcelRequire("95Ao6");
function $1abd16a6f5e85a08$export$2e2bcd8739ae039(length, received, fn) {
    return function() {
        var combined = [];
        var argsIdx = 0;
        var left = length;
        var combinedIdx = 0;
        while(combinedIdx < received.length || argsIdx < arguments.length){
            var result;
            if (combinedIdx < received.length && (!(0, $95Ao6.default)(received[combinedIdx]) || argsIdx >= arguments.length)) result = received[combinedIdx];
            else {
                result = arguments[argsIdx];
                argsIdx += 1;
            }
            combined[combinedIdx] = result;
            if (!(0, $95Ao6.default)(result)) left -= 1;
            combinedIdx += 1;
        }
        return left <= 0 ? fn.apply(this, combined) : (0, $fe9oK.default)(left, $1abd16a6f5e85a08$export$2e2bcd8739ae039(length, combined, fn));
    };
}

});



parcelRegister("bQJaX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8a0798058e5b251c$export$2e2bcd8739ae039; });

var $cJJmw = parcelRequire("cJJmw");

var $cjSwl = parcelRequire("cjSwl");
/**
 * Applies a function to the value at the given index of an array, returning a
 * new copy of the array with the element at the given index replaced with the
 * result of the function application.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig Number -> (a -> a) -> [a] -> [a]
 * @param {Number} idx The index.
 * @param {Function} fn The function to apply.
 * @param {Array|Arguments} list An array-like object whose value
 *        at the supplied index will be replaced.
 * @return {Array} A copy of the supplied array-like object with
 *         the element at index `idx` replaced with the value
 *         returned by applying `fn` to the existing element.
 * @see R.update
 * @example
 *
 *      R.adjust(1, R.toUpper, ['a', 'b', 'c', 'd']);      //=> ['a', 'B', 'c', 'd']
 *      R.adjust(-1, R.toUpper, ['a', 'b', 'c', 'd']);     //=> ['a', 'b', 'c', 'D']
 * @symb R.adjust(-1, f, [a, b]) = [a, f(b)]
 * @symb R.adjust(0, f, [a, b]) = [f(a), b]
 */ var $8a0798058e5b251c$var$adjust = /*#__PURE__*/ (0, $cjSwl.default)(function adjust(idx, fn, list) {
    var len = list.length;
    if (idx >= len || idx < -len) return list;
    var _idx = (len + idx) % len;
    var _list = (0, $cJJmw.default)(list);
    _list[_idx] = fn(list[_idx]);
    return _list;
});
var $8a0798058e5b251c$export$2e2bcd8739ae039 = $8a0798058e5b251c$var$adjust;

});
parcelRegister("cjSwl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8f818d0beb181944$export$2e2bcd8739ae039; });

var $lrIA4 = parcelRequire("lrIA4");

var $4E2dE = parcelRequire("4E2dE");

var $95Ao6 = parcelRequire("95Ao6");
function $8f818d0beb181944$export$2e2bcd8739ae039(fn) {
    return function f3(a, b, c) {
        switch(arguments.length){
            case 0:
                return f3;
            case 1:
                return (0, $95Ao6.default)(a) ? f3 : (0, $4E2dE.default)(function(_b, _c) {
                    return fn(a, _b, _c);
                });
            case 2:
                return (0, $95Ao6.default)(a) && (0, $95Ao6.default)(b) ? f3 : (0, $95Ao6.default)(a) ? (0, $4E2dE.default)(function(_a, _c) {
                    return fn(_a, b, _c);
                }) : (0, $95Ao6.default)(b) ? (0, $4E2dE.default)(function(_b, _c) {
                    return fn(a, _b, _c);
                }) : (0, $lrIA4.default)(function(_c) {
                    return fn(a, b, _c);
                });
            default:
                return (0, $95Ao6.default)(a) && (0, $95Ao6.default)(b) && (0, $95Ao6.default)(c) ? f3 : (0, $95Ao6.default)(a) && (0, $95Ao6.default)(b) ? (0, $4E2dE.default)(function(_a, _b) {
                    return fn(_a, _b, c);
                }) : (0, $95Ao6.default)(a) && (0, $95Ao6.default)(c) ? (0, $4E2dE.default)(function(_a, _c) {
                    return fn(_a, b, _c);
                }) : (0, $95Ao6.default)(b) && (0, $95Ao6.default)(c) ? (0, $4E2dE.default)(function(_b, _c) {
                    return fn(a, _b, _c);
                }) : (0, $95Ao6.default)(a) ? (0, $lrIA4.default)(function(_a) {
                    return fn(_a, b, c);
                }) : (0, $95Ao6.default)(b) ? (0, $lrIA4.default)(function(_b) {
                    return fn(a, _b, c);
                }) : (0, $95Ao6.default)(c) ? (0, $lrIA4.default)(function(_c) {
                    return fn(a, b, _c);
                }) : fn(a, b, c);
        }
    };
}

});


parcelRegister("3pbdp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $27ac68065294a136$export$2e2bcd8739ae039; });

var $4E2dE = parcelRequire("4E2dE");

var $AZnlR = parcelRequire("AZnlR");

var $6Kba3 = parcelRequire("6Kba3");
/**
 * Returns `true` if all elements of the list match the predicate, `false` if
 * there are any that don't.
 *
 * Dispatches to the `all` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> Boolean
 * @param {Function} fn The predicate function.
 * @param {Array} list The array to consider.
 * @return {Boolean} `true` if the predicate is satisfied by every element, `false`
 *         otherwise.
 * @see R.any, R.none, R.transduce
 * @example
 *
 *      const equals3 = R.equals(3);
 *      R.all(equals3)([3, 3, 3, 3]); //=> true
 *      R.all(equals3)([3, 3, 1, 3]); //=> false
 */ var $27ac68065294a136$var$all = /*#__PURE__*/ (0, $4E2dE.default)(/*#__PURE__*/ (0, $AZnlR.default)([
    "all"
], (0, $6Kba3.default), function all(fn, list) {
    var idx = 0;
    while(idx < list.length){
        if (!fn(list[idx])) return false;
        idx += 1;
    }
    return true;
}));
var $27ac68065294a136$export$2e2bcd8739ae039 = $27ac68065294a136$var$all;

});
parcelRegister("AZnlR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $06f2f8d4a120071c$export$2e2bcd8739ae039; });

var $9hDA3 = parcelRequire("9hDA3");

var $jR7J3 = parcelRequire("jR7J3");
function $06f2f8d4a120071c$export$2e2bcd8739ae039(methodNames, transducerCreator, fn) {
    return function() {
        if (arguments.length === 0) return fn();
        var obj = arguments[arguments.length - 1];
        if (!(0, $9hDA3.default)(obj)) {
            var idx = 0;
            while(idx < methodNames.length){
                if (typeof obj[methodNames[idx]] === "function") return obj[methodNames[idx]].apply(obj, Array.prototype.slice.call(arguments, 0, -1));
                idx += 1;
            }
            if ((0, $jR7J3.default)(obj)) {
                var transducer = transducerCreator.apply(null, Array.prototype.slice.call(arguments, 0, -1));
                return transducer(obj);
            }
        }
        return fn.apply(this, arguments);
    };
}

});
parcelRegister("9hDA3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6c246772e74133a0$export$2e2bcd8739ae039; });
/**
 * Tests whether or not an object is an array.
 *
 * @private
 * @param {*} val The object to test.
 * @return {Boolean} `true` if `val` is an array, `false` otherwise.
 * @example
 *
 *      _isArray([]); //=> true
 *      _isArray(null); //=> false
 *      _isArray({}); //=> false
 */ var $6c246772e74133a0$export$2e2bcd8739ae039 = Array.isArray || function _isArray(val) {
    return val != null && val.length >= 0 && Object.prototype.toString.call(val) === "[object Array]";
};

});

parcelRegister("jR7J3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e748f5b8f5431f7f$export$2e2bcd8739ae039; });
function $e748f5b8f5431f7f$export$2e2bcd8739ae039(obj) {
    return obj != null && typeof obj["@@transducer/step"] === "function";
}

});


parcelRegister("6Kba3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4e8fb254e98d8a08$export$2e2bcd8739ae039; });

var $4E2dE = parcelRequire("4E2dE");

var $1OnxV = parcelRequire("1OnxV");

var $dki4v = parcelRequire("dki4v");
var $4e8fb254e98d8a08$var$XAll = /*#__PURE__*/ function() {
    function XAll(f, xf) {
        this.xf = xf;
        this.f = f;
        this.all = true;
    }
    XAll.prototype["@@transducer/init"] = (0, $dki4v.default).init;
    XAll.prototype["@@transducer/result"] = function(result) {
        if (this.all) result = this.xf["@@transducer/step"](result, true);
        return this.xf["@@transducer/result"](result);
    };
    XAll.prototype["@@transducer/step"] = function(result, input) {
        if (!this.f(input)) {
            this.all = false;
            result = (0, $1OnxV.default)(this.xf["@@transducer/step"](result, false));
        }
        return result;
    };
    return XAll;
}();
var $4e8fb254e98d8a08$var$_xall = /*#__PURE__*/ (0, $4E2dE.default)(function _xall(f, xf) {
    return new $4e8fb254e98d8a08$var$XAll(f, xf);
});
var $4e8fb254e98d8a08$export$2e2bcd8739ae039 = $4e8fb254e98d8a08$var$_xall;

});
parcelRegister("1OnxV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $151cb9c323df4d23$export$2e2bcd8739ae039; });
function $151cb9c323df4d23$export$2e2bcd8739ae039(x) {
    return x && x["@@transducer/reduced"] ? x : {
        "@@transducer/value": x,
        "@@transducer/reduced": true
    };
}

});

parcelRegister("dki4v", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9b3b294c1ab92ba4$export$2e2bcd8739ae039; });
var $9b3b294c1ab92ba4$export$2e2bcd8739ae039 = {
    init: function() {
        return this.xf["@@transducer/init"]();
    },
    result: function(result) {
        return this.xf["@@transducer/result"](result);
    }
};

});



parcelRegister("iLCqw", function(module, exports) {

var $lrIA4 = parcelRequire("lrIA4");

var $4fS8E = parcelRequire("4fS8E");

var $64epv = parcelRequire("64epv");

var $gUBuO = parcelRequire("gUBuO");

var $hv0Dt = parcelRequire("hv0Dt");
/**
 * Takes a list of predicates and returns a predicate that returns true for a
 * given list of arguments if every one of the provided predicates is satisfied
 * by those arguments.
 *
 * The function returned is a curried function whose arity matches that of the
 * highest-arity predicate.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Logic
 * @sig [(*... -> Boolean)] -> (*... -> Boolean)
 * @param {Array} predicates An array of predicates to check
 * @return {Function} The combined predicate
 * @see R.anyPass
 * @example
 *
 *      const isQueen = R.propEq('rank', 'Q');
 *      const isSpade = R.propEq('suit', '♠︎');
 *      const isQueenOfSpades = R.allPass([isQueen, isSpade]);
 *
 *      isQueenOfSpades({rank: 'Q', suit: '♣︎'}); //=> false
 *      isQueenOfSpades({rank: 'Q', suit: '♠︎'}); //=> true
 */ var $da9a6c8df089777d$var$allPass = /*#__PURE__*/ (0, $lrIA4.default)(function allPass(preds) {
    return (0, $4fS8E.default)((0, $hv0Dt.default)((0, $64epv.default), 0, (0, $gUBuO.default)("length", preds)), function() {
        var idx = 0;
        var len = preds.length;
        while(idx < len){
            if (!preds[idx].apply(this, arguments)) return false;
            idx += 1;
        }
        return true;
    });
});
var $da9a6c8df089777d$export$2e2bcd8739ae039 = $da9a6c8df089777d$var$allPass;

});
parcelRegister("64epv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $46ae4b66072d76a5$export$2e2bcd8739ae039; });

var $4E2dE = parcelRequire("4E2dE");
/**
 * Returns the larger of its two arguments.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> a
 * @param {*} a
 * @param {*} b
 * @return {*}
 * @see R.maxBy, R.min
 * @example
 *
 *      R.max(789, 123); //=> 789
 *      R.max('a', 'b'); //=> 'b'
 */ var $46ae4b66072d76a5$var$max = /*#__PURE__*/ (0, $4E2dE.default)(function max(a, b) {
    return b > a ? b : a;
});
var $46ae4b66072d76a5$export$2e2bcd8739ae039 = $46ae4b66072d76a5$var$max;

});

parcelRegister("gUBuO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c4fef634fa1e7631$export$2e2bcd8739ae039; });

var $4E2dE = parcelRequire("4E2dE");

var $aaiYf = parcelRequire("aaiYf");

var $hvsdM = parcelRequire("hvsdM");
/**
 * Returns a new list by plucking the same named property off all objects in
 * the list supplied.
 *
 * `pluck` will work on
 * any [functor](https://github.com/fantasyland/fantasy-land#functor) in
 * addition to arrays, as it is equivalent to `R.map(R.prop(k), f)`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Functor f => k -> f {k: v} -> f v
 * @param {Number|String} key The key name to pluck off of each object.
 * @param {Array} f The array or functor to consider.
 * @return {Array} The list of values for the given key.
 * @see R.project, R.prop, R.props
 * @example
 *
 *      var getAges = R.pluck('age');
 *      getAges([{name: 'fred', age: 29}, {name: 'wilma', age: 27}]); //=> [29, 27]
 *
 *      R.pluck(0, [[1, 2], [3, 4]]);               //=> [1, 3]
 *      R.pluck('val', {a: {val: 3}, b: {val: 5}}); //=> {a: 3, b: 5}
 * @symb R.pluck('x', [{x: 1, y: 2}, {x: 3, y: 4}, {x: 5, y: 6}]) = [1, 3, 5]
 * @symb R.pluck(0, [[1, 2], [3, 4], [5, 6]]) = [1, 3, 5]
 */ var $c4fef634fa1e7631$var$pluck = /*#__PURE__*/ (0, $4E2dE.default)(function pluck(p, list) {
    return (0, $aaiYf.default)((0, $hvsdM.default)(p), list);
});
var $c4fef634fa1e7631$export$2e2bcd8739ae039 = $c4fef634fa1e7631$var$pluck;

});
parcelRegister("aaiYf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $76698dc275188796$export$2e2bcd8739ae039; });

var $4E2dE = parcelRequire("4E2dE");

var $AZnlR = parcelRequire("AZnlR");

var $5DhuU = parcelRequire("5DhuU");

var $jdcIJ = parcelRequire("jdcIJ");

var $3PMe3 = parcelRequire("3PMe3");

var $4fS8E = parcelRequire("4fS8E");

var $ipwCl = parcelRequire("ipwCl");
/**
 * Takes a function and
 * a [functor](https://github.com/fantasyland/fantasy-land#functor),
 * applies the function to each of the functor's values, and returns
 * a functor of the same shape.
 *
 * Ramda provides suitable `map` implementations for `Array` and `Object`,
 * so this function may be applied to `[1, 2, 3]` or `{x: 1, y: 2, z: 3}`.
 *
 * Dispatches to the `map` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * Also treats functions as functors and will compose them together.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Functor f => (a -> b) -> f a -> f b
 * @param {Function} fn The function to be called on every element of the input `list`.
 * @param {Array} list The list to be iterated over.
 * @return {Array} The new list.
 * @see R.transduce, R.addIndex, R.pluck, R.project
 * @example
 *
 *      const double = x => x * 2;
 *
 *      R.map(double, [1, 2, 3]); //=> [2, 4, 6]
 *
 *      R.map(double, {x: 1, y: 2, z: 3}); //=> {x: 2, y: 4, z: 6}
 * @symb R.map(f, [a, b]) = [f(a), f(b)]
 * @symb R.map(f, { x: a, y: b }) = { x: f(a), y: f(b) }
 * @symb R.map(f, functor_o) = functor_o.map(f)
 */ var $76698dc275188796$var$map = /*#__PURE__*/ (0, $4E2dE.default)(/*#__PURE__*/ (0, $AZnlR.default)([
    "fantasy-land/map",
    "map"
], (0, $3PMe3.default), function map(fn, functor) {
    switch(Object.prototype.toString.call(functor)){
        case "[object Function]":
            return (0, $4fS8E.default)(functor.length, function() {
                return fn.call(this, functor.apply(this, arguments));
            });
        case "[object Object]":
            return (0, $jdcIJ.default)(function(acc, key) {
                acc[key] = fn(functor[key]);
                return acc;
            }, {}, (0, $ipwCl.default)(functor));
        default:
            return (0, $5DhuU.default)(fn, functor);
    }
}));
var $76698dc275188796$export$2e2bcd8739ae039 = $76698dc275188796$var$map;

});
parcelRegister("5DhuU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $419e2ae6d9e4ae4f$export$2e2bcd8739ae039; });
function $419e2ae6d9e4ae4f$export$2e2bcd8739ae039(fn, functor) {
    var idx = 0;
    var len = functor.length;
    var result = Array(len);
    while(idx < len){
        result[idx] = fn(functor[idx]);
        idx += 1;
    }
    return result;
}

});

parcelRegister("jdcIJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dfc9193e5557702d$export$2e2bcd8739ae039; });

var $dpzcU = parcelRequire("dpzcU");

var $eBPr7 = parcelRequire("eBPr7");

var $lMRCz = parcelRequire("lMRCz");
function $dfc9193e5557702d$var$_arrayReduce(xf, acc, list) {
    var idx = 0;
    var len = list.length;
    while(idx < len){
        acc = xf["@@transducer/step"](acc, list[idx]);
        if (acc && acc["@@transducer/reduced"]) {
            acc = acc["@@transducer/value"];
            break;
        }
        idx += 1;
    }
    return xf["@@transducer/result"](acc);
}
function $dfc9193e5557702d$var$_iterableReduce(xf, acc, iter) {
    var step = iter.next();
    while(!step.done){
        acc = xf["@@transducer/step"](acc, step.value);
        if (acc && acc["@@transducer/reduced"]) {
            acc = acc["@@transducer/value"];
            break;
        }
        step = iter.next();
    }
    return xf["@@transducer/result"](acc);
}
function $dfc9193e5557702d$var$_methodReduce(xf, acc, obj, methodName) {
    return xf["@@transducer/result"](obj[methodName]((0, $lMRCz.default)(xf["@@transducer/step"], xf), acc));
}
var $dfc9193e5557702d$var$symIterator = typeof Symbol !== "undefined" ? Symbol.iterator : "@@iterator";
function $dfc9193e5557702d$export$2e2bcd8739ae039(fn, acc, list) {
    if (typeof fn === "function") fn = (0, $eBPr7.default)(fn);
    if ((0, $dpzcU.default)(list)) return $dfc9193e5557702d$var$_arrayReduce(fn, acc, list);
    if (typeof list["fantasy-land/reduce"] === "function") return $dfc9193e5557702d$var$_methodReduce(fn, acc, list, "fantasy-land/reduce");
    if (list[$dfc9193e5557702d$var$symIterator] != null) return $dfc9193e5557702d$var$_iterableReduce(fn, acc, list[$dfc9193e5557702d$var$symIterator]());
    if (typeof list.next === "function") return $dfc9193e5557702d$var$_iterableReduce(fn, acc, list);
    if (typeof list.reduce === "function") return $dfc9193e5557702d$var$_methodReduce(fn, acc, list, "reduce");
    throw new TypeError("reduce: list must be array or iterable");
}

});
parcelRegister("dpzcU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9c38eb939de84958$export$2e2bcd8739ae039; });

var $lrIA4 = parcelRequire("lrIA4");

var $9hDA3 = parcelRequire("9hDA3");

var $ij2HL = parcelRequire("ij2HL");
/**
 * Tests whether or not an object is similar to an array.
 *
 * @private
 * @category Type
 * @category List
 * @sig * -> Boolean
 * @param {*} x The object to test.
 * @return {Boolean} `true` if `x` has a numeric length property and extreme indices defined; `false` otherwise.
 * @example
 *
 *      _isArrayLike([]); //=> true
 *      _isArrayLike(true); //=> false
 *      _isArrayLike({}); //=> false
 *      _isArrayLike({length: 10}); //=> false
 *      _isArrayLike({0: 'zero', 9: 'nine', length: 10}); //=> true
 *      _isArrayLike({nodeType: 1, length: 1}) // => false
 */ var $9c38eb939de84958$var$_isArrayLike = /*#__PURE__*/ (0, $lrIA4.default)(function isArrayLike(x) {
    if ((0, $9hDA3.default)(x)) return true;
    if (!x) return false;
    if (typeof x !== "object") return false;
    if ((0, $ij2HL.default)(x)) return false;
    if (x.length === 0) return true;
    if (x.length > 0) return x.hasOwnProperty(0) && x.hasOwnProperty(x.length - 1);
    return false;
});
var $9c38eb939de84958$export$2e2bcd8739ae039 = $9c38eb939de84958$var$_isArrayLike;

});
parcelRegister("ij2HL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d53c1975ffcda254$export$2e2bcd8739ae039; });
function $d53c1975ffcda254$export$2e2bcd8739ae039(x) {
    return Object.prototype.toString.call(x) === "[object String]";
}

});


parcelRegister("eBPr7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aa2c6b9520a50463$export$2e2bcd8739ae039; });
var $aa2c6b9520a50463$var$XWrap = /*#__PURE__*/ function() {
    function XWrap(fn) {
        this.f = fn;
    }
    XWrap.prototype["@@transducer/init"] = function() {
        throw new Error("init not implemented on XWrap");
    };
    XWrap.prototype["@@transducer/result"] = function(acc) {
        return acc;
    };
    XWrap.prototype["@@transducer/step"] = function(acc, x) {
        return this.f(acc, x);
    };
    return XWrap;
}();
function $aa2c6b9520a50463$export$2e2bcd8739ae039(fn) {
    return new $aa2c6b9520a50463$var$XWrap(fn);
}

});

parcelRegister("lMRCz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fdc7acb75653b152$export$2e2bcd8739ae039; });

var $fe9oK = parcelRequire("fe9oK");

var $4E2dE = parcelRequire("4E2dE");
/**
 * Creates a function that is bound to a context.
 * Note: `R.bind` does not provide the additional argument-binding capabilities of
 * [Function.prototype.bind](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category Function
 * @category Object
 * @sig (* -> *) -> {*} -> (* -> *)
 * @param {Function} fn The function to bind to context
 * @param {Object} thisObj The context to bind `fn` to
 * @return {Function} A function that will execute in the context of `thisObj`.
 * @see R.partial
 * @example
 *
 *      const log = R.bind(console.log, console);
 *      R.pipe(R.assoc('a', 2), R.tap(log), R.assoc('a', 3))({a: 1}); //=> {a: 3}
 *      // logs {a: 2}
 * @symb R.bind(f, o)(a, b) = f.call(o, a, b)
 */ var $fdc7acb75653b152$var$bind = /*#__PURE__*/ (0, $4E2dE.default)(function bind(fn, thisObj) {
    return (0, $fe9oK.default)(fn.length, function() {
        return fn.apply(thisObj, arguments);
    });
});
var $fdc7acb75653b152$export$2e2bcd8739ae039 = $fdc7acb75653b152$var$bind;

});


parcelRegister("3PMe3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2cab8b22d2a90cfe$export$2e2bcd8739ae039; });

var $4E2dE = parcelRequire("4E2dE");

var $dki4v = parcelRequire("dki4v");
var $2cab8b22d2a90cfe$var$XMap = /*#__PURE__*/ function() {
    function XMap(f, xf) {
        this.xf = xf;
        this.f = f;
    }
    XMap.prototype["@@transducer/init"] = (0, $dki4v.default).init;
    XMap.prototype["@@transducer/result"] = (0, $dki4v.default).result;
    XMap.prototype["@@transducer/step"] = function(result, input) {
        return this.xf["@@transducer/step"](result, this.f(input));
    };
    return XMap;
}();
var $2cab8b22d2a90cfe$var$_xmap = /*#__PURE__*/ (0, $4E2dE.default)(function _xmap(f, xf) {
    return new $2cab8b22d2a90cfe$var$XMap(f, xf);
});
var $2cab8b22d2a90cfe$export$2e2bcd8739ae039 = $2cab8b22d2a90cfe$var$_xmap;

});

parcelRegister("ipwCl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d673dcede00d14b6$export$2e2bcd8739ae039; });

var $lrIA4 = parcelRequire("lrIA4");

var $jn7AE = parcelRequire("jn7AE");

var $gOmmY = parcelRequire("gOmmY");
var $d673dcede00d14b6$var$hasEnumBug = !/*#__PURE__*/ ({
    toString: null
}).propertyIsEnumerable("toString");
var $d673dcede00d14b6$var$nonEnumerableProps = [
    "constructor",
    "valueOf",
    "isPrototypeOf",
    "toString",
    "propertyIsEnumerable",
    "hasOwnProperty",
    "toLocaleString"
]; // Safari bug
var $d673dcede00d14b6$var$hasArgsEnumBug = /*#__PURE__*/ function() {
    "use strict";
    return arguments.propertyIsEnumerable("length");
}();
var $d673dcede00d14b6$var$contains = function contains(list, item) {
    var idx = 0;
    while(idx < list.length){
        if (list[idx] === item) return true;
        idx += 1;
    }
    return false;
};
/**
 * Returns a list containing the names of all the enumerable own properties of
 * the supplied object.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {k: v} -> [k]
 * @param {Object} obj The object to extract properties from
 * @return {Array} An array of the object's own properties.
 * @see R.keysIn, R.values, R.toPairs
 * @example
 *
 *      R.keys({a: 1, b: 2, c: 3}); //=> ['a', 'b', 'c']
 */ var $d673dcede00d14b6$var$keys = typeof Object.keys === "function" && !$d673dcede00d14b6$var$hasArgsEnumBug ? /*#__PURE__*/ (0, $lrIA4.default)(function keys(obj) {
    return Object(obj) !== obj ? [] : Object.keys(obj);
}) : /*#__PURE__*/ (0, $lrIA4.default)(function keys(obj) {
    if (Object(obj) !== obj) return [];
    var prop, nIdx;
    var ks = [];
    var checkArgsLength = $d673dcede00d14b6$var$hasArgsEnumBug && (0, $gOmmY.default)(obj);
    for(prop in obj)if ((0, $jn7AE.default)(prop, obj) && (!checkArgsLength || prop !== "length")) ks[ks.length] = prop;
    if ($d673dcede00d14b6$var$hasEnumBug) {
        nIdx = $d673dcede00d14b6$var$nonEnumerableProps.length - 1;
        while(nIdx >= 0){
            prop = $d673dcede00d14b6$var$nonEnumerableProps[nIdx];
            if ((0, $jn7AE.default)(prop, obj) && !$d673dcede00d14b6$var$contains(ks, prop)) ks[ks.length] = prop;
            nIdx -= 1;
        }
    }
    return ks;
});
var $d673dcede00d14b6$export$2e2bcd8739ae039 = $d673dcede00d14b6$var$keys;

});
parcelRegister("jn7AE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e1a60d8c9e7d1c20$export$2e2bcd8739ae039; });
function $e1a60d8c9e7d1c20$export$2e2bcd8739ae039(prop, obj) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}

});

parcelRegister("gOmmY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c3d2aafa47288cd2$export$2e2bcd8739ae039; });

var $jn7AE = parcelRequire("jn7AE");
var $c3d2aafa47288cd2$var$toString = Object.prototype.toString;
var $c3d2aafa47288cd2$var$_isArguments = /*#__PURE__*/ function() {
    return $c3d2aafa47288cd2$var$toString.call(arguments) === "[object Arguments]" ? function _isArguments(x) {
        return $c3d2aafa47288cd2$var$toString.call(x) === "[object Arguments]";
    } : function _isArguments(x) {
        return (0, $jn7AE.default)("callee", x);
    };
}();
var $c3d2aafa47288cd2$export$2e2bcd8739ae039 = $c3d2aafa47288cd2$var$_isArguments;

});



parcelRegister("hvsdM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cbeb3915c96b819b$export$2e2bcd8739ae039; });

var $4E2dE = parcelRequire("4E2dE");

var $4uaMM = parcelRequire("4uaMM");

var $7aHtE = parcelRequire("7aHtE");
/**
 * Returns a function that when supplied an object returns the indicated
 * property of that object, if it exists.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @typedefn Idx = String | Int | Symbol
 * @sig Idx -> {s: a} -> a | Undefined
 * @param {String|Number} p The property name or array index
 * @param {Object} obj The object to query
 * @return {*} The value at `obj.p`.
 * @see R.path, R.props, R.pluck, R.project, R.nth
 * @example
 *
 *      R.prop('x', {x: 100}); //=> 100
 *      R.prop('x', {}); //=> undefined
 *      R.prop(0, [100]); //=> 100
 *      R.compose(R.inc, R.prop('x'))({ x: 3 }) //=> 4
 */ var $cbeb3915c96b819b$var$prop = /*#__PURE__*/ (0, $4E2dE.default)(function prop(p, obj) {
    if (obj == null) return;
    return (0, $4uaMM.default)(p) ? (0, $7aHtE.default)(p, obj) : obj[p];
});
var $cbeb3915c96b819b$export$2e2bcd8739ae039 = $cbeb3915c96b819b$var$prop;

});
parcelRegister("4uaMM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3442549af4b39127$export$2e2bcd8739ae039; });
/**
 * Determine if the passed argument is an integer.
 *
 * @private
 * @param {*} n
 * @category Type
 * @return {Boolean}
 */ var $3442549af4b39127$export$2e2bcd8739ae039 = Number.isInteger || function _isInteger(n) {
    return n << 0 === n;
};

});

parcelRegister("7aHtE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $538b3144b1157682$export$2e2bcd8739ae039; });

var $4E2dE = parcelRequire("4E2dE");

var $ij2HL = parcelRequire("ij2HL");
/**
 * Returns the nth element of the given list or string. If n is negative the
 * element at index length + n is returned.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Number -> [a] -> a | Undefined
 * @sig Number -> String -> String
 * @param {Number} offset
 * @param {*} list
 * @return {*}
 * @example
 *
 *      const list = ['foo', 'bar', 'baz', 'quux'];
 *      R.nth(1, list); //=> 'bar'
 *      R.nth(-1, list); //=> 'quux'
 *      R.nth(-99, list); //=> undefined
 *
 *      R.nth(2, 'abc'); //=> 'c'
 *      R.nth(3, 'abc'); //=> ''
 * @symb R.nth(-1, [a, b, c]) = c
 * @symb R.nth(0, [a, b, c]) = a
 * @symb R.nth(1, [a, b, c]) = b
 */ var $538b3144b1157682$var$nth = /*#__PURE__*/ (0, $4E2dE.default)(function nth(offset, list) {
    var idx = offset < 0 ? list.length + offset : offset;
    return (0, $ij2HL.default)(list) ? list.charAt(idx) : list[idx];
});
var $538b3144b1157682$export$2e2bcd8739ae039 = $538b3144b1157682$var$nth;

});



parcelRegister("hv0Dt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cbd5d32bd31e4685$export$2e2bcd8739ae039; });

var $cjSwl = parcelRequire("cjSwl");

var $jdcIJ = parcelRequire("jdcIJ");
/**
 * Returns a single item by iterating through the list, successively calling
 * the iterator function and passing it an accumulator value and the current
 * value from the array, and then passing the result to the next call.
 *
 * The iterator function receives two values: *(acc, value)*. It may use
 * [`R.reduced`](#reduced) to shortcut the iteration.
 *
 * The arguments' order of [`reduceRight`](#reduceRight)'s iterator function
 * is *(value, acc)*.
 *
 * Note: `R.reduce` does not skip deleted or unassigned indices (sparse
 * arrays), unlike the native `Array.prototype.reduce` method. For more details
 * on this behavior, see:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce#Description
 *
 * Dispatches to the `reduce` method of the third argument, if present. When
 * doing so, it is up to the user to handle the [`R.reduced`](#reduced)
 * shortcuting, as this is not implemented by `reduce`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig ((a, b) -> a) -> a -> [b] -> a
 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
 *        current element from the array.
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduced, R.addIndex, R.reduceRight
 * @example
 *
 *      R.reduce(R.subtract, 0, [1, 2, 3, 4]) // => ((((0 - 1) - 2) - 3) - 4) = -10
 *      //          -               -10
 *      //         / \              / \
 *      //        -   4           -6   4
 *      //       / \              / \
 *      //      -   3   ==>     -3   3
 *      //     / \              / \
 *      //    -   2           -1   2
 *      //   / \              / \
 *      //  0   1            0   1
 *
 * @symb R.reduce(f, a, [b, c, d]) = f(f(f(a, b), c), d)
 */ var $cbd5d32bd31e4685$var$reduce = /*#__PURE__*/ (0, $cjSwl.default)((0, $jdcIJ.default));
var $cbd5d32bd31e4685$export$2e2bcd8739ae039 = $cbd5d32bd31e4685$var$reduce;

});


parcelRegister("kYiXR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f4481f33356a5220$export$2e2bcd8739ae039; });

var $lrIA4 = parcelRequire("lrIA4");
/**
 * Returns a function that always returns the given value. Note that for
 * non-primitives the value returned is a reference to the original value.
 *
 * This function is known as `const`, `constant`, or `K` (for K combinator) in
 * other languages and libraries.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig a -> (* -> a)
 * @param {*} val The value to wrap in a function
 * @return {Function} A Function :: * -> val.
 * @example
 *
 *      const t = R.always('Tee');
 *      t(); //=> 'Tee'
 */ var $f4481f33356a5220$var$always = /*#__PURE__*/ (0, $lrIA4.default)(function always(val) {
    return function() {
        return val;
    };
});
var $f4481f33356a5220$export$2e2bcd8739ae039 = $f4481f33356a5220$var$always;

});

parcelRegister("er53b", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a8278132572082cb$export$2e2bcd8739ae039; });

var $4E2dE = parcelRequire("4E2dE");
/**
 * Returns the first argument if it is falsy, otherwise the second argument.
 * Acts as the boolean `and` statement if both inputs are `Boolean`s.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Logic
 * @sig a -> b -> a | b
 * @param {Any} a
 * @param {Any} b
 * @return {Any}
 * @see R.both, R.or
 * @example
 *
 *      R.and(true, true); //=> true
 *      R.and(true, false); //=> false
 *      R.and(false, true); //=> false
 *      R.and(false, false); //=> false
 */ var $a8278132572082cb$var$and = /*#__PURE__*/ (0, $4E2dE.default)(function and(a, b) {
    return a && b;
});
var $a8278132572082cb$export$2e2bcd8739ae039 = $a8278132572082cb$var$and;

});

parcelRegister("94JdJ", function(module, exports) {

var $4E2dE = parcelRequire("4E2dE");

var $AZnlR = parcelRequire("AZnlR");

var $1s31E = parcelRequire("1s31E");
/**
 * Returns `true` if at least one of the elements of the list match the predicate,
 * `false` otherwise.
 *
 * Dispatches to the `any` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> Boolean
 * @param {Function} fn The predicate function.
 * @param {Array} list The array to consider.
 * @return {Boolean} `true` if the predicate is satisfied by at least one element, `false`
 *         otherwise.
 * @see R.all, R.none, R.transduce
 * @example
 *
 *      const lessThan0 = R.flip(R.lt)(0);
 *      const lessThan2 = R.flip(R.lt)(2);
 *      R.any(lessThan0)([1, 2]); //=> false
 *      R.any(lessThan2)([1, 2]); //=> true
 */ var $69b7909bd28dd4ff$var$any = /*#__PURE__*/ (0, $4E2dE.default)(/*#__PURE__*/ (0, $AZnlR.default)([
    "any"
], (0, $1s31E.default), function any(fn, list) {
    var idx = 0;
    while(idx < list.length){
        if (fn(list[idx])) return true;
        idx += 1;
    }
    return false;
}));
var $69b7909bd28dd4ff$export$2e2bcd8739ae039 = $69b7909bd28dd4ff$var$any;

});
parcelRegister("1s31E", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $10eac0c85cbf6ea1$export$2e2bcd8739ae039; });

var $4E2dE = parcelRequire("4E2dE");

var $1OnxV = parcelRequire("1OnxV");

var $dki4v = parcelRequire("dki4v");
var $10eac0c85cbf6ea1$var$XAny = /*#__PURE__*/ function() {
    function XAny(f, xf) {
        this.xf = xf;
        this.f = f;
        this.any = false;
    }
    XAny.prototype["@@transducer/init"] = (0, $dki4v.default).init;
    XAny.prototype["@@transducer/result"] = function(result) {
        if (!this.any) result = this.xf["@@transducer/step"](result, false);
        return this.xf["@@transducer/result"](result);
    };
    XAny.prototype["@@transducer/step"] = function(result, input) {
        if (this.f(input)) {
            this.any = true;
            result = (0, $1OnxV.default)(this.xf["@@transducer/step"](result, true));
        }
        return result;
    };
    return XAny;
}();
var $10eac0c85cbf6ea1$var$_xany = /*#__PURE__*/ (0, $4E2dE.default)(function _xany(f, xf) {
    return new $10eac0c85cbf6ea1$var$XAny(f, xf);
});
var $10eac0c85cbf6ea1$export$2e2bcd8739ae039 = $10eac0c85cbf6ea1$var$_xany;

});


parcelRegister("adTN6", function(module, exports) {

var $lrIA4 = parcelRequire("lrIA4");

var $4fS8E = parcelRequire("4fS8E");

var $64epv = parcelRequire("64epv");

var $gUBuO = parcelRequire("gUBuO");

var $hv0Dt = parcelRequire("hv0Dt");
/**
 * Takes a list of predicates and returns a predicate that returns true for a
 * given list of arguments if at least one of the provided predicates is
 * satisfied by those arguments.
 *
 * The function returned is a curried function whose arity matches that of the
 * highest-arity predicate.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Logic
 * @sig [(*... -> Boolean)] -> (*... -> Boolean)
 * @param {Array} predicates An array of predicates to check
 * @return {Function} The combined predicate
 * @see R.allPass
 * @example
 *
 *      const isClub = R.propEq('suit', '♣');
 *      const isSpade = R.propEq('suit', '♠');
 *      const isBlackCard = R.anyPass([isClub, isSpade]);
 *
 *      isBlackCard({rank: '10', suit: '♣'}); //=> true
 *      isBlackCard({rank: 'Q', suit: '♠'}); //=> true
 *      isBlackCard({rank: 'Q', suit: '♦'}); //=> false
 */ var $771665353079d0d0$var$anyPass = /*#__PURE__*/ (0, $lrIA4.default)(function anyPass(preds) {
    return (0, $4fS8E.default)((0, $hv0Dt.default)((0, $64epv.default), 0, (0, $gUBuO.default)("length", preds)), function() {
        var idx = 0;
        var len = preds.length;
        while(idx < len){
            if (preds[idx].apply(this, arguments)) return true;
            idx += 1;
        }
        return false;
    });
});
var $771665353079d0d0$export$2e2bcd8739ae039 = $771665353079d0d0$var$anyPass;

});

parcelRegister("7WWJI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c9b83003cdb9db0$export$2e2bcd8739ae039; });

var $cJJmw = parcelRequire("cJJmw");

var $4E2dE = parcelRequire("4E2dE");

var $jdcIJ = parcelRequire("jdcIJ");

var $aaiYf = parcelRequire("aaiYf");
/**
 * ap applies a list of functions to a list of values.
 *
 * Dispatches to the `ap` method of the second argument, if present. Also
 * treats curried functions as applicatives.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Function
 * @sig [a -> b] -> [a] -> [b]
 * @sig Apply f => f (a -> b) -> f a -> f b
 * @sig (r -> a -> b) -> (r -> a) -> (r -> b)
 * @param {*} applyF
 * @param {*} applyX
 * @return {*}
 * @example
 *
 *      R.ap([R.multiply(2), R.add(3)], [1,2,3]); //=> [2, 4, 6, 4, 5, 6]
 *      R.ap([R.concat('tasty '), R.toUpper], ['pizza', 'salad']); //=> ["tasty pizza", "tasty salad", "PIZZA", "SALAD"]
 *
 *      // R.ap can also be used as S combinator
 *      // when only two functions are passed
 *      R.ap(R.concat, R.toUpper)('Ramda') //=> 'RamdaRAMDA'
 * @symb R.ap([f, g], [a, b]) = [f(a), f(b), g(a), g(b)]
 */ var $5c9b83003cdb9db0$var$ap = /*#__PURE__*/ (0, $4E2dE.default)(function ap(applyF, applyX) {
    return typeof applyX["fantasy-land/ap"] === "function" ? applyX["fantasy-land/ap"](applyF) : typeof applyF.ap === "function" ? applyF.ap(applyX) : typeof applyF === "function" ? function(x) {
        return applyF(x)(applyX(x));
    } : (0, $jdcIJ.default)(function(acc, f) {
        return (0, $cJJmw.default)(acc, (0, $aaiYf.default)(f, applyX));
    }, [], applyF);
});
var $5c9b83003cdb9db0$export$2e2bcd8739ae039 = $5c9b83003cdb9db0$var$ap;

});

parcelRegister("fewnZ", function(module, exports) {

var $2mqpy = parcelRequire("2mqpy");

var $4E2dE = parcelRequire("4E2dE");

var $AZnlR = parcelRequire("AZnlR");

var $1SBsp = parcelRequire("1SBsp");
/**
 * Returns a new list, composed of n-tuples of consecutive elements. If `n` is
 * greater than the length of the list, an empty list is returned.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category List
 * @sig Number -> [a] -> [[a]]
 * @param {Number} n The size of the tuples to create
 * @param {Array} list The list to split into `n`-length tuples
 * @return {Array} The resulting list of `n`-length tuples
 * @see R.transduce
 * @example
 *
 *      R.aperture(2, [1, 2, 3, 4, 5]); //=> [[1, 2], [2, 3], [3, 4], [4, 5]]
 *      R.aperture(3, [1, 2, 3, 4, 5]); //=> [[1, 2, 3], [2, 3, 4], [3, 4, 5]]
 *      R.aperture(7, [1, 2, 3, 4, 5]); //=> []
 */ var $b17148fdcc6683de$var$aperture = /*#__PURE__*/ (0, $4E2dE.default)(/*#__PURE__*/ (0, $AZnlR.default)([], (0, $1SBsp.default), (0, $2mqpy.default)));
var $b17148fdcc6683de$export$2e2bcd8739ae039 = $b17148fdcc6683de$var$aperture;

});
parcelRegister("2mqpy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1b821f8c23fa0ed2$export$2e2bcd8739ae039; });
function $1b821f8c23fa0ed2$export$2e2bcd8739ae039(n, list) {
    var idx = 0;
    var limit = list.length - (n - 1);
    var acc = new Array(limit >= 0 ? limit : 0);
    while(idx < limit){
        acc[idx] = Array.prototype.slice.call(list, idx, idx + n);
        idx += 1;
    }
    return acc;
}

});

parcelRegister("1SBsp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $15e7e3d0353f32b6$export$2e2bcd8739ae039; });

var $cJJmw = parcelRequire("cJJmw");

var $4E2dE = parcelRequire("4E2dE");

var $dki4v = parcelRequire("dki4v");
var $15e7e3d0353f32b6$var$XAperture = /*#__PURE__*/ function() {
    function XAperture(n, xf) {
        this.xf = xf;
        this.pos = 0;
        this.full = false;
        this.acc = new Array(n);
    }
    XAperture.prototype["@@transducer/init"] = (0, $dki4v.default).init;
    XAperture.prototype["@@transducer/result"] = function(result) {
        this.acc = null;
        return this.xf["@@transducer/result"](result);
    };
    XAperture.prototype["@@transducer/step"] = function(result, input) {
        this.store(input);
        return this.full ? this.xf["@@transducer/step"](result, this.getCopy()) : result;
    };
    XAperture.prototype.store = function(input) {
        this.acc[this.pos] = input;
        this.pos += 1;
        if (this.pos === this.acc.length) {
            this.pos = 0;
            this.full = true;
        }
    };
    XAperture.prototype.getCopy = function() {
        return (0, $cJJmw.default)(Array.prototype.slice.call(this.acc, this.pos), Array.prototype.slice.call(this.acc, 0, this.pos));
    };
    return XAperture;
}();
var $15e7e3d0353f32b6$var$_xaperture = /*#__PURE__*/ (0, $4E2dE.default)(function _xaperture(n, xf) {
    return new $15e7e3d0353f32b6$var$XAperture(n, xf);
});
var $15e7e3d0353f32b6$export$2e2bcd8739ae039 = $15e7e3d0353f32b6$var$_xaperture;

});


parcelRegister("3qZRM", function(module, exports) {

var $cJJmw = parcelRequire("cJJmw");

var $4E2dE = parcelRequire("4E2dE");
/**
 * Returns a new list containing the contents of the given list, followed by
 * the given element.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig a -> [a] -> [a]
 * @param {*} el The element to add to the end of the new list.
 * @param {Array} list The list of elements to add a new item to.
 *        list.
 * @return {Array} A new list containing the elements of the old list followed by `el`.
 * @see R.prepend
 * @example
 *
 *      R.append('tests', ['write', 'more']); //=> ['write', 'more', 'tests']
 *      R.append('tests', []); //=> ['tests']
 *      R.append(['tests'], ['write', 'more']); //=> ['write', 'more', ['tests']]
 */ var $2803ca2e2dac5218$var$append = /*#__PURE__*/ (0, $4E2dE.default)(function append(el, list) {
    return (0, $cJJmw.default)(list, [
        el
    ]);
});
var $2803ca2e2dac5218$export$2e2bcd8739ae039 = $2803ca2e2dac5218$var$append;

});

parcelRegister("4CYoD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $35e98f81f100f92f$export$2e2bcd8739ae039; });

var $4E2dE = parcelRequire("4E2dE");
/**
 * Applies function `fn` to the argument list `args`. This is useful for
 * creating a fixed-arity function from a variadic function. `fn` should be a
 * bound function if context is significant.
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Function
 * @sig (*... -> a) -> [*] -> a
 * @param {Function} fn The function which will be called with `args`
 * @param {Array} args The arguments to call `fn` with
 * @return {*} result The result, equivalent to `fn(...args)`
 * @see R.call, R.unapply
 * @example
 *
 *      const nums = [1, 2, 3, -99, 42, 6, 7];
 *      R.apply(Math.max, nums); //=> 42
 * @symb R.apply(f, [a, b, c]) = f(a, b, c)
 */ var $35e98f81f100f92f$var$apply = /*#__PURE__*/ (0, $4E2dE.default)(function apply(fn, args) {
    return fn.apply(this, args);
});
var $35e98f81f100f92f$export$2e2bcd8739ae039 = $35e98f81f100f92f$var$apply;

});

parcelRegister("gBa3c", function(module, exports) {

var $lrIA4 = parcelRequire("lrIA4");

var $9hDA3 = parcelRequire("9hDA3");

var $4CYoD = parcelRequire("4CYoD");

var $4fS8E = parcelRequire("4fS8E");

var $64epv = parcelRequire("64epv");

var $gUBuO = parcelRequire("gUBuO");

var $hv0Dt = parcelRequire("hv0Dt");

var $ipwCl = parcelRequire("ipwCl");

var $9SNsK = parcelRequire("9SNsK");
// delegating calls to .map
function $c157e5e477d938b1$var$mapValues(fn, obj) {
    return (0, $9hDA3.default)(obj) ? obj.map(fn) : (0, $ipwCl.default)(obj).reduce(function(acc, key) {
        acc[key] = fn(obj[key]);
        return acc;
    }, {});
}
/**
 * Given a spec object recursively mapping properties to functions, creates a
 * function producing an object of the same structure, by mapping each property
 * to the result of calling its associated function with the supplied arguments.
 *
 * @func
 * @memberOf R
 * @since v0.20.0
 * @category Function
 * @sig {k: ((a, b, ..., m) -> v)} -> ((a, b, ..., m) -> {k: v})
 * @param {Object} spec an object recursively mapping properties to functions for
 *        producing the values for these properties.
 * @return {Function} A function that returns an object of the same structure
 * as `spec', with each property set to the value returned by calling its
 * associated function with the supplied arguments.
 * @see R.converge, R.juxt
 * @example
 *
 *      const getMetrics = R.applySpec({
 *        sum: R.add,
 *        nested: { mul: R.multiply }
 *      });
 *      getMetrics(2, 4); // => { sum: 6, nested: { mul: 8 } }
 * @symb R.applySpec({ x: f, y: { z: g } })(a, b) = { x: f(a, b), y: { z: g(a, b) } }
 */ var $c157e5e477d938b1$var$applySpec = /*#__PURE__*/ (0, $lrIA4.default)(function applySpec(spec) {
    spec = $c157e5e477d938b1$var$mapValues(function(v) {
        return typeof v == "function" ? v : applySpec(v);
    }, spec);
    return (0, $4fS8E.default)((0, $hv0Dt.default)((0, $64epv.default), 0, (0, $gUBuO.default)("length", (0, $9SNsK.default)(spec))), function() {
        var args = arguments;
        return $c157e5e477d938b1$var$mapValues(function(f) {
            return (0, $4CYoD.default)(f, args);
        }, spec);
    });
});
var $c157e5e477d938b1$export$2e2bcd8739ae039 = $c157e5e477d938b1$var$applySpec;

});
parcelRegister("9SNsK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $731f867be62f6615$export$2e2bcd8739ae039; });

var $lrIA4 = parcelRequire("lrIA4");

var $ipwCl = parcelRequire("ipwCl");
/**
 * Returns a list of all the enumerable own properties of the supplied object.
 * Note that the order of the output array is not guaranteed across different
 * JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {k: v} -> [v]
 * @param {Object} obj The object to extract values from
 * @return {Array} An array of the values of the object's own properties.
 * @see R.valuesIn, R.keys, R.toPairs
 * @example
 *
 *      R.values({a: 1, b: 2, c: 3}); //=> [1, 2, 3]
 */ var $731f867be62f6615$var$values = /*#__PURE__*/ (0, $lrIA4.default)(function values(obj) {
    var props = (0, $ipwCl.default)(obj);
    var len = props.length;
    var vals = [];
    var idx = 0;
    while(idx < len){
        vals[idx] = obj[props[idx]];
        idx += 1;
    }
    return vals;
});
var $731f867be62f6615$export$2e2bcd8739ae039 = $731f867be62f6615$var$values;

});


parcelRegister("lHaNg", function(module, exports) {

var $4E2dE = parcelRequire("4E2dE");
/**
 * Takes a value and applies a function to it.
 *
 * This function is also known as the `thrush` combinator.
 *
 * @func
 * @memberOf R
 * @since v0.25.0
 * @category Function
 * @sig a -> (a -> b) -> b
 * @param {*} x The value
 * @param {Function} f The function to apply
 * @return {*} The result of applying `f` to `x`
 * @example
 *
 *      const t42 = R.applyTo(42);
 *      t42(R.identity); //=> 42
 *      t42(R.add(1)); //=> 43
 */ var $fcb5fc811ef22fd2$var$applyTo = /*#__PURE__*/ (0, $4E2dE.default)(function applyTo(x, f) {
    return f(x);
});
var $fcb5fc811ef22fd2$export$2e2bcd8739ae039 = $fcb5fc811ef22fd2$var$applyTo;

});

parcelRegister("8Ut3a", function(module, exports) {

var $cjSwl = parcelRequire("cjSwl");
/**
 * Makes an ascending comparator function out of a function that returns a value
 * that can be compared with `<` and `>`.
 *
 * @func
 * @memberOf R
 * @since v0.23.0
 * @category Function
 * @sig Ord b => (a -> b) -> a -> a -> Number
 * @param {Function} fn A function of arity one that returns a value that can be compared
 * @param {*} a The first item to be compared.
 * @param {*} b The second item to be compared.
 * @return {Number} `-1` if fn(a) < fn(b), `1` if fn(b) < fn(a), otherwise `0`
 * @see R.descend
 * @example
 *
 *      const byAge = R.ascend(R.prop('age'));
 *      const people = [
 *        { name: 'Emma', age: 70 },
 *        { name: 'Peter', age: 78 },
 *        { name: 'Mikhail', age: 62 },
 *      ];
 *      const peopleByYoungestFirst = R.sort(byAge, people);
 *        //=> [{ name: 'Mikhail', age: 62 },{ name: 'Emma', age: 70 }, { name: 'Peter', age: 78 }]
 */ var $67ca167145f0cbd0$var$ascend = /*#__PURE__*/ (0, $cjSwl.default)(function ascend(fn, a, b) {
    var aa = fn(a);
    var bb = fn(b);
    return aa < bb ? -1 : aa > bb ? 1 : 0;
});
var $67ca167145f0cbd0$export$2e2bcd8739ae039 = $67ca167145f0cbd0$var$ascend;

});

parcelRegister("bAwZa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $86fca4c0bab3304b$export$2e2bcd8739ae039; });

var $cjSwl = parcelRequire("cjSwl");

var $bJ6V5 = parcelRequire("bJ6V5");
/**
 * Makes a shallow clone of an object, setting or overriding the specified
 * property with the given value. Note that this copies and flattens prototype
 * properties onto the new object as well. All non-primitive properties are
 * copied by reference.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Object
 * @typedefn Idx = String | Int
 * @sig Idx -> a -> {k: v} -> {k: v}
 * @param {String|Number} prop The property name to set
 * @param {*} val The new value
 * @param {Object} obj The object to clone
 * @return {Object} A new object equivalent to the original except for the changed property.
 * @see R.dissoc, R.pick
 * @example
 *
 *      R.assoc('c', 3, {a: 1, b: 2}); //=> {a: 1, b: 2, c: 3}
 */ var $86fca4c0bab3304b$var$assoc = /*#__PURE__*/ (0, $cjSwl.default)(function assoc(prop, val, obj) {
    return (0, $bJ6V5.default)([
        prop
    ], val, obj);
});
var $86fca4c0bab3304b$export$2e2bcd8739ae039 = $86fca4c0bab3304b$var$assoc;

});
parcelRegister("bJ6V5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $889943cb32f14506$export$2e2bcd8739ae039; });

var $cjSwl = parcelRequire("cjSwl");

var $jn7AE = parcelRequire("jn7AE");

var $4uaMM = parcelRequire("4uaMM");

var $cNL0t = parcelRequire("cNL0t");

var $fWvks = parcelRequire("fWvks");
/**
 * Makes a shallow clone of an object, setting or overriding the nodes required
 * to create the given path, and placing the specific value at the tail end of
 * that path. Note that this copies and flattens prototype properties onto the
 * new object as well. All non-primitive properties are copied by reference.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Object
 * @typedefn Idx = String | Int | Symbol
 * @sig [Idx] -> a -> {a} -> {a}
 * @param {Array} path the path to set
 * @param {*} val The new value
 * @param {Object} obj The object to clone
 * @return {Object} A new object equivalent to the original except along the specified path.
 * @see R.dissocPath
 * @example
 *
 *      R.assocPath(['a', 'b', 'c'], 42, {a: {b: {c: 0}}}); //=> {a: {b: {c: 42}}}
 *
 *      // Any missing or non-object keys in path will be overridden
 *      R.assocPath(['a', 'b', 'c'], 42, {a: 5}); //=> {a: {b: {c: 42}}}
 */ var $889943cb32f14506$var$assocPath = /*#__PURE__*/ (0, $cjSwl.default)(function assocPath(path, val, obj) {
    if (path.length === 0) return val;
    var idx = path[0];
    if (path.length > 1) {
        var nextObj = !(0, $fWvks.default)(obj) && (0, $jn7AE.default)(idx, obj) ? obj[idx] : (0, $4uaMM.default)(path[1]) ? [] : {};
        val = assocPath(Array.prototype.slice.call(path, 1), val, nextObj);
    }
    return (0, $cNL0t.default)(idx, val, obj);
});
var $889943cb32f14506$export$2e2bcd8739ae039 = $889943cb32f14506$var$assocPath;

});
parcelRegister("cNL0t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $951e862f1b3356ba$export$2e2bcd8739ae039; });

var $9hDA3 = parcelRequire("9hDA3");

var $4uaMM = parcelRequire("4uaMM");
function $951e862f1b3356ba$export$2e2bcd8739ae039(prop, val, obj) {
    if ((0, $4uaMM.default)(prop) && (0, $9hDA3.default)(obj)) {
        var arr = [].concat(obj);
        arr[prop] = val;
        return arr;
    }
    var result = {};
    for(var p in obj)result[p] = obj[p];
    result[prop] = val;
    return result;
}

});

parcelRegister("fWvks", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b9b49318b7c9e312$export$2e2bcd8739ae039; });

var $lrIA4 = parcelRequire("lrIA4");
/**
 * Checks if the input value is `null` or `undefined`.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Type
 * @sig * -> Boolean
 * @param {*} x The value to test.
 * @return {Boolean} `true` if `x` is `undefined` or `null`, otherwise `false`.
 * @example
 *
 *      R.isNil(null); //=> true
 *      R.isNil(undefined); //=> true
 *      R.isNil(0); //=> false
 *      R.isNil([]); //=> false
 */ var $b9b49318b7c9e312$var$isNil = /*#__PURE__*/ (0, $lrIA4.default)(function isNil(x) {
    return x == null;
});
var $b9b49318b7c9e312$export$2e2bcd8739ae039 = $b9b49318b7c9e312$var$isNil;

});



parcelRegister("6ISnw", function(module, exports) {

var $lrIA4 = parcelRequire("lrIA4");

var $kRpXl = parcelRequire("kRpXl");
/**
 * Wraps a function of any arity (including nullary) in a function that accepts
 * exactly 2 parameters. Any extraneous parameters will not be passed to the
 * supplied function.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Function
 * @sig (a -> b -> c -> ... -> z) -> ((a, b) -> z)
 * @param {Function} fn The function to wrap.
 * @return {Function} A new function wrapping `fn`. The new function is guaranteed to be of
 *         arity 2.
 * @see R.nAry, R.unary
 * @example
 *
 *      const takesThreeArgs = function(a, b, c) {
 *        return [a, b, c];
 *      };
 *      takesThreeArgs.length; //=> 3
 *      takesThreeArgs(1, 2, 3); //=> [1, 2, 3]
 *
 *      const takesTwoArgs = R.binary(takesThreeArgs);
 *      takesTwoArgs.length; //=> 2
 *      // Only 2 arguments are passed to the wrapped function
 *      takesTwoArgs(1, 2, 3); //=> [1, 2, undefined]
 * @symb R.binary(f)(a, b, c) = f(a, b)
 */ var $4e51088af9555014$var$binary = /*#__PURE__*/ (0, $lrIA4.default)(function binary(fn) {
    return (0, $kRpXl.default)(2, fn);
});
var $4e51088af9555014$export$2e2bcd8739ae039 = $4e51088af9555014$var$binary;

});
parcelRegister("kRpXl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f2fce4391325cb29$export$2e2bcd8739ae039; });

var $4E2dE = parcelRequire("4E2dE");
/**
 * Wraps a function of any arity (including nullary) in a function that accepts
 * exactly `n` parameters. Any extraneous parameters will not be passed to the
 * supplied function.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig Number -> (* -> a) -> (* -> a)
 * @param {Number} n The desired arity of the new function.
 * @param {Function} fn The function to wrap.
 * @return {Function} A new function wrapping `fn`. The new function is guaranteed to be of
 *         arity `n`.
 * @see R.binary, R.unary
 * @example
 *
 *      const takesTwoArgs = (a, b) => [a, b];
 *
 *      takesTwoArgs.length; //=> 2
 *      takesTwoArgs(1, 2); //=> [1, 2]
 *
 *      const takesOneArg = R.nAry(1, takesTwoArgs);
 *      takesOneArg.length; //=> 1
 *      // Only `n` arguments are passed to the wrapped function
 *      takesOneArg(1, 2); //=> [1, undefined]
 * @symb R.nAry(0, f)(a, b) = f()
 * @symb R.nAry(1, f)(a, b) = f(a)
 * @symb R.nAry(2, f)(a, b) = f(a, b)
 */ var $f2fce4391325cb29$var$nAry = /*#__PURE__*/ (0, $4E2dE.default)(function nAry(n, fn) {
    switch(n){
        case 0:
            return function() {
                return fn.call(this);
            };
        case 1:
            return function(a0) {
                return fn.call(this, a0);
            };
        case 2:
            return function(a0, a1) {
                return fn.call(this, a0, a1);
            };
        case 3:
            return function(a0, a1, a2) {
                return fn.call(this, a0, a1, a2);
            };
        case 4:
            return function(a0, a1, a2, a3) {
                return fn.call(this, a0, a1, a2, a3);
            };
        case 5:
            return function(a0, a1, a2, a3, a4) {
                return fn.call(this, a0, a1, a2, a3, a4);
            };
        case 6:
            return function(a0, a1, a2, a3, a4, a5) {
                return fn.call(this, a0, a1, a2, a3, a4, a5);
            };
        case 7:
            return function(a0, a1, a2, a3, a4, a5, a6) {
                return fn.call(this, a0, a1, a2, a3, a4, a5, a6);
            };
        case 8:
            return function(a0, a1, a2, a3, a4, a5, a6, a7) {
                return fn.call(this, a0, a1, a2, a3, a4, a5, a6, a7);
            };
        case 9:
            return function(a0, a1, a2, a3, a4, a5, a6, a7, a8) {
                return fn.call(this, a0, a1, a2, a3, a4, a5, a6, a7, a8);
            };
        case 10:
            return function(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
                return fn.call(this, a0, a1, a2, a3, a4, a5, a6, a7, a8, a9);
            };
        default:
            throw new Error("First argument to nAry must be a non-negative integer no greater than ten");
    }
});
var $f2fce4391325cb29$export$2e2bcd8739ae039 = $f2fce4391325cb29$var$nAry;

});


parcelRegister("kaTmS", function(module, exports) {

var $4E2dE = parcelRequire("4E2dE");

var $aizOG = parcelRequire("aizOG");

var $er53b = parcelRequire("er53b");

var $3Jc8c = parcelRequire("3Jc8c");
/**
 * A function which calls the two provided functions and returns the `&&`
 * of the results.
 * It returns the result of the first function if it is false-y and the result
 * of the second function otherwise. Note that this is short-circuited,
 * meaning that the second function will not be invoked if the first returns a
 * false-y value.
 *
 * In addition to functions, `R.both` also accepts any fantasy-land compatible
 * applicative functor.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category Logic
 * @sig (*... -> Boolean) -> (*... -> Boolean) -> (*... -> Boolean)
 * @param {Function} f A predicate
 * @param {Function} g Another predicate
 * @return {Function} a function that applies its arguments to `f` and `g` and `&&`s their outputs together.
 * @see R.either, R.and
 * @example
 *
 *      const gt10 = R.gt(R.__, 10)
 *      const lt20 = R.lt(R.__, 20)
 *      const f = R.both(gt10, lt20);
 *      f(15); //=> true
 *      f(30); //=> false
 *
 *      R.both(Maybe.Just(false), Maybe.Just(55)); // => Maybe.Just(false)
 *      R.both([false, false, 'a'], [11]); //=> [false, false, 11]
 */ var $eaffb0c27ee43286$var$both = /*#__PURE__*/ (0, $4E2dE.default)(function both(f, g) {
    return (0, $aizOG.default)(f) ? function _both() {
        return f.apply(this, arguments) && g.apply(this, arguments);
    } : (0, $3Jc8c.default)((0, $er53b.default))(f, g);
});
var $eaffb0c27ee43286$export$2e2bcd8739ae039 = $eaffb0c27ee43286$var$both;

});
parcelRegister("aizOG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $77f75e3eff3fcee8$export$2e2bcd8739ae039; });
function $77f75e3eff3fcee8$export$2e2bcd8739ae039(x) {
    var type = Object.prototype.toString.call(x);
    return type === "[object Function]" || type === "[object AsyncFunction]" || type === "[object GeneratorFunction]" || type === "[object AsyncGeneratorFunction]";
}

});

parcelRegister("3Jc8c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2b6efc16ebb8bbb0$export$2e2bcd8739ae039; });

var $lrIA4 = parcelRequire("lrIA4");

var $cB4Gm = parcelRequire("cB4Gm");
/**
 * "lifts" a function of arity >= 1 so that it may "map over" a list, Function or other
 * object that satisfies the [FantasyLand Apply spec](https://github.com/fantasyland/fantasy-land#apply).
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Function
 * @sig (*... -> *) -> ([*]... -> [*])
 * @param {Function} fn The function to lift into higher context
 * @return {Function} The lifted function.
 * @see R.liftN
 * @example
 *
 *      const madd3 = R.lift((a, b, c) => a + b + c);
 *
 *      madd3([100, 200], [30, 40], [5, 6, 7]); //=> [135, 136, 137, 145, 146, 147, 235, 236, 237, 245, 246, 247]
 *
 *      const madd5 = R.lift((a, b, c, d, e) => a + b + c + d + e);
 *
 *      madd5([10, 20], [1], [2, 3], [4], [100, 200]); //=> [117, 217, 118, 218, 127, 227, 128, 228]
 */ var $2b6efc16ebb8bbb0$var$lift = /*#__PURE__*/ (0, $lrIA4.default)(function lift(fn) {
    return (0, $cB4Gm.default)(fn.length, fn);
});
var $2b6efc16ebb8bbb0$export$2e2bcd8739ae039 = $2b6efc16ebb8bbb0$var$lift;

});
parcelRegister("cB4Gm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $92bc92838ca3ce7d$export$2e2bcd8739ae039; });

var $4E2dE = parcelRequire("4E2dE");

var $jdcIJ = parcelRequire("jdcIJ");

var $7WWJI = parcelRequire("7WWJI");

var $4fS8E = parcelRequire("4fS8E");

var $aaiYf = parcelRequire("aaiYf");
/**
 * "lifts" a function to be the specified arity, so that it may "map over" that
 * many lists, Functions or other objects that satisfy the [FantasyLand Apply spec](https://github.com/fantasyland/fantasy-land#apply).
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Function
 * @sig Number -> (*... -> *) -> ([*]... -> [*])
 * @param {Function} fn The function to lift into higher context
 * @return {Function} The lifted function.
 * @see R.lift, R.ap
 * @example
 *
 *      const madd3 = R.liftN(3, (...args) => R.sum(args));
 *      madd3([1,2,3], [1,2,3], [1]); //=> [3, 4, 5, 4, 5, 6, 5, 6, 7]
 */ var $92bc92838ca3ce7d$var$liftN = /*#__PURE__*/ (0, $4E2dE.default)(function liftN(arity, fn) {
    var lifted = (0, $4fS8E.default)(arity, fn);
    return (0, $4fS8E.default)(arity, function() {
        return (0, $jdcIJ.default)((0, $7WWJI.default), (0, $aaiYf.default)(lifted, arguments[0]), Array.prototype.slice.call(arguments, 1));
    });
});
var $92bc92838ca3ce7d$export$2e2bcd8739ae039 = $92bc92838ca3ce7d$var$liftN;

});



parcelRegister("5d7w3", function(module, exports) {

var $lrIA4 = parcelRequire("lrIA4");
/**
 * Returns the result of calling its first argument with the remaining
 * arguments. This is occasionally useful as a converging function for
 * [`R.converge`](#converge): the first branch can produce a function while the
 * remaining branches produce values to be passed to that function as its
 * arguments.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Function
 * @sig ((*... -> a), *...) -> a
 * @param {Function} fn The function to apply to the remaining arguments.
 * @param {...*} args Any number of positional arguments.
 * @return {*}
 * @see R.apply
 * @example
 *
 *      R.call(R.add, 1, 2); //=> 3
 *
 *      const indentN = R.pipe(
 *        R.repeat(' '),
 *        R.join(''),
 *        R.replace(/^(?!$)/gm)
 *      );
 *
 *      const format = R.converge(
 *        R.call,
 *        [
 *          R.pipe(R.prop('indent'), indentN),
 *          R.prop('value')
 *        ]
 *      );
 *
 *      format({indent: 2, value: 'foo\nbar\nbaz\n'}); //=> '  foo\n  bar\n  baz\n'
 * @symb R.call(f, a, b) = f(a, b)
 */ var $3cb3ff2c2508d91d$var$call = /*#__PURE__*/ (0, $lrIA4.default)(function call(fn) {
    return fn.apply(this, Array.prototype.slice.call(arguments, 1));
});
var $3cb3ff2c2508d91d$export$2e2bcd8739ae039 = $3cb3ff2c2508d91d$var$call;

});

parcelRegister("isJKB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d70e54a7f7ea4ea0$export$2e2bcd8739ae039; });

var $4E2dE = parcelRequire("4E2dE");

var $AZnlR = parcelRequire("AZnlR");

var $jJf0h = parcelRequire("jJf0h");

var $6kYs0 = parcelRequire("6kYs0");

var $aaiYf = parcelRequire("aaiYf");
/**
 * `chain` maps a function over a list and concatenates the results. `chain`
 * is also known as `flatMap` in some libraries.
 *
 * Dispatches to the `chain` method of the second argument, if present,
 * according to the [FantasyLand Chain spec](https://github.com/fantasyland/fantasy-land#chain).
 *
 * If second argument is a function, `chain(f, g)(x)` is equivalent to `f(g(x), x)`.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig Chain m => (a -> m b) -> m a -> m b
 * @param {Function} fn The function to map with
 * @param {Array} list The list to map over
 * @return {Array} The result of flat-mapping `list` with `fn`
 * @example
 *
 *      const duplicate = n => [n, n];
 *      R.chain(duplicate, [1, 2, 3]); //=> [1, 1, 2, 2, 3, 3]
 *
 *      R.chain(R.append, R.head)([1, 2, 3]); //=> [1, 2, 3, 1]
 */ var $d70e54a7f7ea4ea0$var$chain = /*#__PURE__*/ (0, $4E2dE.default)(/*#__PURE__*/ (0, $AZnlR.default)([
    "fantasy-land/chain",
    "chain"
], (0, $6kYs0.default), function chain(fn, monad) {
    if (typeof monad === "function") return function(x) {
        return fn(monad(x))(x);
    };
    return (0, $jJf0h.default)(false)((0, $aaiYf.default)(fn, monad));
}));
var $d70e54a7f7ea4ea0$export$2e2bcd8739ae039 = $d70e54a7f7ea4ea0$var$chain;

});
parcelRegister("jJf0h", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e5cddbaeb2505253$export$2e2bcd8739ae039; });

var $dpzcU = parcelRequire("dpzcU");
function $e5cddbaeb2505253$export$2e2bcd8739ae039(recursive) {
    return function flatt(list) {
        var value, jlen, j;
        var result = [];
        var idx = 0;
        var ilen = list.length;
        while(idx < ilen){
            if ((0, $dpzcU.default)(list[idx])) {
                value = recursive ? flatt(list[idx]) : list[idx];
                j = 0;
                jlen = value.length;
                while(j < jlen){
                    result[result.length] = value[j];
                    j += 1;
                }
            } else result[result.length] = list[idx];
            idx += 1;
        }
        return result;
    };
}

});

parcelRegister("6kYs0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $49d3809a583882d9$export$2e2bcd8739ae039; });

var $4E2dE = parcelRequire("4E2dE");

var $8RKrQ = parcelRequire("8RKrQ");

var $aaiYf = parcelRequire("aaiYf");
var $49d3809a583882d9$var$_xchain = /*#__PURE__*/ (0, $4E2dE.default)(function _xchain(f, xf) {
    return (0, $aaiYf.default)(f, (0, $8RKrQ.default)(xf));
});
var $49d3809a583882d9$export$2e2bcd8739ae039 = $49d3809a583882d9$var$_xchain;

});
parcelRegister("8RKrQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $67474d9d85e67a3d$export$2e2bcd8739ae039; });

var $lqBts = parcelRequire("lqBts");

var $dpzcU = parcelRequire("dpzcU");

var $jdcIJ = parcelRequire("jdcIJ");

var $dki4v = parcelRequire("dki4v");
var $67474d9d85e67a3d$var$preservingReduced = function(xf) {
    return {
        "@@transducer/init": (0, $dki4v.default).init,
        "@@transducer/result": function(result) {
            return xf["@@transducer/result"](result);
        },
        "@@transducer/step": function(result, input) {
            var ret = xf["@@transducer/step"](result, input);
            return ret["@@transducer/reduced"] ? (0, $lqBts.default)(ret) : ret;
        }
    };
};
var $67474d9d85e67a3d$var$_flatCat = function _xcat(xf) {
    var rxf = $67474d9d85e67a3d$var$preservingReduced(xf);
    return {
        "@@transducer/init": (0, $dki4v.default).init,
        "@@transducer/result": function(result) {
            return rxf["@@transducer/result"](result);
        },
        "@@transducer/step": function(result, input) {
            return !(0, $dpzcU.default)(input) ? (0, $jdcIJ.default)(rxf, result, [
                input
            ]) : (0, $jdcIJ.default)(rxf, result, input);
        }
    };
};
var $67474d9d85e67a3d$export$2e2bcd8739ae039 = $67474d9d85e67a3d$var$_flatCat;

});
parcelRegister("lqBts", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f99918462e8951f5$export$2e2bcd8739ae039; });
function $f99918462e8951f5$export$2e2bcd8739ae039(x) {
    return {
        "@@transducer/value": x,
        "@@transducer/reduced": true
    };
}

});




parcelRegister("eprAX", function(module, exports) {

var $cjSwl = parcelRequire("cjSwl");
/**
 * Restricts a number to be within a range.
 *
 * Also works for other ordered types such as Strings and Dates.
 *
 * @func
 * @memberOf R
 * @since v0.20.0
 * @category Relation
 * @sig Ord a => a -> a -> a -> a
 * @param {Number} minimum The lower limit of the clamp (inclusive)
 * @param {Number} maximum The upper limit of the clamp (inclusive)
 * @param {Number} value Value to be clamped
 * @return {Number} Returns `minimum` when `val < minimum`, `maximum` when `val > maximum`, returns `val` otherwise
 * @example
 *
 *      R.clamp(1, 10, -5) // => 1
 *      R.clamp(1, 10, 15) // => 10
 *      R.clamp(1, 10, 4)  // => 4
 */ var $a7d8ce48abe5e6c0$var$clamp = /*#__PURE__*/ (0, $cjSwl.default)(function clamp(min, max, value) {
    if (min > max) throw new Error("min must not be greater than max in clamp(min, max, value)");
    return value < min ? min : value > max ? max : value;
});
var $a7d8ce48abe5e6c0$export$2e2bcd8739ae039 = $a7d8ce48abe5e6c0$var$clamp;

});

parcelRegister("byUaQ", function(module, exports) {

var $gPAhz = parcelRequire("gPAhz");

var $lrIA4 = parcelRequire("lrIA4");
/**
 * Creates a deep copy of the source that can be used in place of the source
 * object without retaining any references to it.
 * The source object may contain (nested) `Array`s and `Object`s,
 * `Number`s, `String`s, `Boolean`s and `Date`s.
 * `Function`s are assigned by reference rather than copied.
 *
 * Dispatches to a `clone` method if present.
 *
 * Note that if the source object has multiple nodes that share a reference,
 * the returned object will have the same structure, but the references will
 * be pointed to the location within the cloned value.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {*} -> {*}
 * @param {*} value The object or array to clone
 * @return {*} A deeply cloned copy of `val`
 * @example
 *
 *      const objects = [{}, {}, {}];
 *      const objectsClone = R.clone(objects);
 *      objects === objectsClone; //=> false
 *      objects[0] === objectsClone[0]; //=> false
 */ var $86ae71a8a0ab77b7$var$clone = /*#__PURE__*/ (0, $lrIA4.default)(function clone(value) {
    return value != null && typeof value.clone === "function" ? value.clone() : (0, $gPAhz.default)(value, [], [], true);
});
var $86ae71a8a0ab77b7$export$2e2bcd8739ae039 = $86ae71a8a0ab77b7$var$clone;

});
parcelRegister("gPAhz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c40d8db19d7a10d4$export$2e2bcd8739ae039; });

var $i5qW0 = parcelRequire("i5qW0");

var $1gWdq = parcelRequire("1gWdq");
function $c40d8db19d7a10d4$export$2e2bcd8739ae039(value, refFrom, refTo, deep) {
    var copy = function copy(copiedValue) {
        var len = refFrom.length;
        var idx = 0;
        while(idx < len){
            if (value === refFrom[idx]) return refTo[idx];
            idx += 1;
        }
        refFrom[idx] = value;
        refTo[idx] = copiedValue;
        for(var key in value)if (value.hasOwnProperty(key)) copiedValue[key] = deep ? $c40d8db19d7a10d4$export$2e2bcd8739ae039(value[key], refFrom, refTo, true) : value[key];
        return copiedValue;
    };
    switch((0, $1gWdq.default)(value)){
        case "Object":
            return copy(Object.create(Object.getPrototypeOf(value)));
        case "Array":
            return copy([]);
        case "Date":
            return new Date(value.valueOf());
        case "RegExp":
            return (0, $i5qW0.default)(value);
        case "Int8Array":
        case "Uint8Array":
        case "Uint8ClampedArray":
        case "Int16Array":
        case "Uint16Array":
        case "Int32Array":
        case "Uint32Array":
        case "Float32Array":
        case "Float64Array":
        case "BigInt64Array":
        case "BigUint64Array":
            return value.slice();
        default:
            return value;
    }
}

});
parcelRegister("i5qW0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d2ad96437586c84c$export$2e2bcd8739ae039; });
function $d2ad96437586c84c$export$2e2bcd8739ae039(pattern) {
    return new RegExp(pattern.source, (pattern.global ? "g" : "") + (pattern.ignoreCase ? "i" : "") + (pattern.multiline ? "m" : "") + (pattern.sticky ? "y" : "") + (pattern.unicode ? "u" : ""));
}

});

parcelRegister("1gWdq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0ed47171ea239dbf$export$2e2bcd8739ae039; });

var $lrIA4 = parcelRequire("lrIA4");
/**
 * Gives a single-word string description of the (native) type of a value,
 * returning such answers as 'Object', 'Number', 'Array', or 'Null'. Does not
 * attempt to distinguish user Object types any further, reporting them all as
 * 'Object'.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Type
 * @sig (* -> {*}) -> String
 * @param {*} val The value to test
 * @return {String}
 * @example
 *
 *      R.type({}); //=> "Object"
 *      R.type(1); //=> "Number"
 *      R.type(false); //=> "Boolean"
 *      R.type('s'); //=> "String"
 *      R.type(null); //=> "Null"
 *      R.type([]); //=> "Array"
 *      R.type(/[A-z]/); //=> "RegExp"
 *      R.type(() => {}); //=> "Function"
 *      R.type(undefined); //=> "Undefined"
 */ var $0ed47171ea239dbf$var$type = /*#__PURE__*/ (0, $lrIA4.default)(function type(val) {
    return val === null ? "Null" : val === undefined ? "Undefined" : Object.prototype.toString.call(val).slice(8, -1);
});
var $0ed47171ea239dbf$export$2e2bcd8739ae039 = $0ed47171ea239dbf$var$type;

});



parcelRegister("71aof", function(module, exports) {

var $4E2dE = parcelRequire("4E2dE");

var $jdcIJ = parcelRequire("jdcIJ");
/**
 * Splits a list into sub-lists, based on the result of calling a key-returning function on each element,
 * and grouping the results according to values returned.
 *
 * @func
 * @memberOf R
 * @since v0.28.0
 * @category List
 * @typedefn Idx = String | Int | Symbol
 * @sig Idx a => (b -> a) -> [b] -> [[b]]
 * @param {Function} fn Function :: a -> Idx
 * @param {Array} list The array to group
 * @return {Array}
 *    An array of arrays where each sub-array contains items for which
 *    the String-returning function has returned the same value.
 * @see R.groupBy, R.partition
 * @example
 *      R.collectBy(R.prop('type'), [
 *        {type: 'breakfast', item: '☕️'},
 *        {type: 'lunch', item: '🌯'},
 *        {type: 'dinner', item: '🍝'},
 *        {type: 'breakfast', item: '🥐'},
 *        {type: 'lunch', item: '🍕'}
 *      ]);
 *
 *      // [ [ {type: 'breakfast', item: '☕️'},
 *      //     {type: 'breakfast', item: '🥐'} ],
 *      //   [ {type: 'lunch', item: '🌯'},
 *      //     {type: 'lunch', item: '🍕'} ],
 *      //   [ {type: 'dinner', item: '🍝'} ] ]
 */ var $51c0afa1aa8dcb19$var$collectBy = /*#__PURE__*/ (0, $4E2dE.default)(function collectBy(fn, list) {
    var group = (0, $jdcIJ.default)(function(o, x) {
        var tag = fn(x);
        if (o[tag] === undefined) o[tag] = [];
        o[tag].push(x);
        return o;
    }, {}, list);
    var newList = [];
    for(var tag in group)newList.push(group[tag]);
    return newList;
});
var $51c0afa1aa8dcb19$export$2e2bcd8739ae039 = $51c0afa1aa8dcb19$var$collectBy;

});

parcelRegister("fYB5y", function(module, exports) {

var $lrIA4 = parcelRequire("lrIA4");
/**
 * Makes a comparator function out of a function that reports whether the first
 * element is less than the second.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig ((a, b) -> Boolean) -> ((a, b) -> Number)
 * @param {Function} pred A predicate function of arity two which will return `true` if the first argument
 * is less than the second, `false` otherwise
 * @return {Function} A Function :: a -> b -> Int that returns `-1` if a < b, `1` if b < a, otherwise `0`
 * @example
 *
 *      const byAge = R.comparator((a, b) => a.age < b.age);
 *      const people = [
 *        { name: 'Emma', age: 70 },
 *        { name: 'Peter', age: 78 },
 *        { name: 'Mikhail', age: 62 },
 *      ];
 *      const peopleByIncreasingAge = R.sort(byAge, people);
 *        //=> [{ name: 'Mikhail', age: 62 },{ name: 'Emma', age: 70 }, { name: 'Peter', age: 78 }]
 */ var $ba193aa1690a0987$var$comparator = /*#__PURE__*/ (0, $lrIA4.default)(function comparator(pred) {
    return function(a, b) {
        return pred(a, b) ? -1 : pred(b, a) ? 1 : 0;
    };
});
var $ba193aa1690a0987$export$2e2bcd8739ae039 = $ba193aa1690a0987$var$comparator;

});

parcelRegister("hDFDa", function(module, exports) {

var $3Jc8c = parcelRequire("3Jc8c");

var $4U3VF = parcelRequire("4U3VF");
/**
 * Takes a function `f` and returns a function `g` such that if called with the same arguments
 * when `f` returns a "truthy" value, `g` returns `false` and when `f` returns a "falsy" value `g` returns `true`.
 *
 * `R.complement` may be applied to any functor
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category Logic
 * @sig (*... -> *) -> (*... -> Boolean)
 * @param {Function} f
 * @return {Function}
 * @see R.not
 * @example
 *
 *      const isNotNil = R.complement(R.isNil);
 *      R.isNil(null); //=> true
 *      isNotNil(null); //=> false
 *      R.isNil(7); //=> false
 *      isNotNil(7); //=> true
 */ var $cd765f2b7830654e$var$complement = /*#__PURE__*/ (0, $3Jc8c.default)((0, $4U3VF.default));
var $cd765f2b7830654e$export$2e2bcd8739ae039 = $cd765f2b7830654e$var$complement;

});
parcelRegister("4U3VF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $391f709b0bc7f25f$export$2e2bcd8739ae039; });

var $lrIA4 = parcelRequire("lrIA4");
/**
 * A function that returns the `!` of its argument. It will return `true` when
 * passed false-y value, and `false` when passed a truth-y one.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Logic
 * @sig * -> Boolean
 * @param {*} a any value
 * @return {Boolean} the logical inverse of passed argument.
 * @see R.complement
 * @example
 *
 *      R.not(true); //=> false
 *      R.not(false); //=> true
 *      R.not(0); //=> true
 *      R.not(1); //=> false
 */ var $391f709b0bc7f25f$var$not = /*#__PURE__*/ (0, $lrIA4.default)(function not(a) {
    return !a;
});
var $391f709b0bc7f25f$export$2e2bcd8739ae039 = $391f709b0bc7f25f$var$not;

});


parcelRegister("2kk8J", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1b1d126288727cda$export$2e2bcd8739ae039; });

var $3Foym = parcelRequire("3Foym");

var $dEOUW = parcelRequire("dEOUW");
function $1b1d126288727cda$export$2e2bcd8739ae039() {
    if (arguments.length === 0) throw new Error("compose requires at least one argument");
    return (0, $3Foym.default).apply(this, (0, $dEOUW.default)(arguments));
}

});
parcelRegister("3Foym", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2ab83f3418c7eed8$export$2e2bcd8739ae039; });

var $fe9oK = parcelRequire("fe9oK");

var $3f3rJ = parcelRequire("3f3rJ");

var $hv0Dt = parcelRequire("hv0Dt");

var $cWyLj = parcelRequire("cWyLj");
function $2ab83f3418c7eed8$export$2e2bcd8739ae039() {
    if (arguments.length === 0) throw new Error("pipe requires at least one argument");
    return (0, $fe9oK.default)(arguments[0].length, (0, $hv0Dt.default)((0, $3f3rJ.default), arguments[0], (0, $cWyLj.default)(arguments)));
}

});
parcelRegister("3f3rJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $25c57227eabadf24$export$2e2bcd8739ae039; });
function $25c57227eabadf24$export$2e2bcd8739ae039(f, g) {
    return function() {
        return g.call(this, f.apply(this, arguments));
    };
}

});

parcelRegister("cWyLj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $96c5ddd880e10f71$export$2e2bcd8739ae039; });

var $jQ8CJ = parcelRequire("jQ8CJ");

var $lrIA4 = parcelRequire("lrIA4");

var $1kRJS = parcelRequire("1kRJS");
/**
 * Returns all but the first element of the given list or string (or object
 * with a `tail` method).
 *
 * Dispatches to the `slice` method of the first argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a]
 * @sig String -> String
 * @param {*} list
 * @return {*}
 * @see R.head, R.init, R.last
 * @example
 *
 *      R.tail([1, 2, 3]);  //=> [2, 3]
 *      R.tail([1, 2]);     //=> [2]
 *      R.tail([1]);        //=> []
 *      R.tail([]);         //=> []
 *
 *      R.tail('abc');  //=> 'bc'
 *      R.tail('ab');   //=> 'b'
 *      R.tail('a');    //=> ''
 *      R.tail('');     //=> ''
 */ var $96c5ddd880e10f71$var$tail = /*#__PURE__*/ (0, $lrIA4.default)(/*#__PURE__*/ (0, $jQ8CJ.default)("tail", /*#__PURE__*/ (0, $1kRJS.default)(1, Infinity)));
var $96c5ddd880e10f71$export$2e2bcd8739ae039 = $96c5ddd880e10f71$var$tail;

});
parcelRegister("jQ8CJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e71990299509b98a$export$2e2bcd8739ae039; });

var $9hDA3 = parcelRequire("9hDA3");
function $e71990299509b98a$export$2e2bcd8739ae039(methodname, fn) {
    return function() {
        var length = arguments.length;
        if (length === 0) return fn();
        var obj = arguments[length - 1];
        return (0, $9hDA3.default)(obj) || typeof obj[methodname] !== "function" ? fn.apply(this, arguments) : obj[methodname].apply(obj, Array.prototype.slice.call(arguments, 0, length - 1));
    };
}

});

parcelRegister("1kRJS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0f9158297df9aaa4$export$2e2bcd8739ae039; });

var $jQ8CJ = parcelRequire("jQ8CJ");

var $cjSwl = parcelRequire("cjSwl");
/**
 * Returns the elements of the given list or string (or object with a `slice`
 * method) from `fromIndex` (inclusive) to `toIndex` (exclusive).
 *
 * Dispatches to the `slice` method of the third argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.4
 * @category List
 * @sig Number -> Number -> [a] -> [a]
 * @sig Number -> Number -> String -> String
 * @param {Number} fromIndex The start index (inclusive).
 * @param {Number} toIndex The end index (exclusive).
 * @param {*} list
 * @return {*}
 * @example
 *
 *      R.slice(1, 3, ['a', 'b', 'c', 'd']);        //=> ['b', 'c']
 *      R.slice(1, Infinity, ['a', 'b', 'c', 'd']); //=> ['b', 'c', 'd']
 *      R.slice(0, -1, ['a', 'b', 'c', 'd']);       //=> ['a', 'b', 'c']
 *      R.slice(-3, -1, ['a', 'b', 'c', 'd']);      //=> ['b', 'c']
 *      R.slice(0, 3, 'ramda');                     //=> 'ram'
 */ var $0f9158297df9aaa4$var$slice = /*#__PURE__*/ (0, $cjSwl.default)(/*#__PURE__*/ (0, $jQ8CJ.default)("slice", function slice(fromIndex, toIndex, list) {
    return Array.prototype.slice.call(list, fromIndex, toIndex);
}));
var $0f9158297df9aaa4$export$2e2bcd8739ae039 = $0f9158297df9aaa4$var$slice;

});



parcelRegister("dEOUW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0290e110443c5b3c$export$2e2bcd8739ae039; });

var $lrIA4 = parcelRequire("lrIA4");

var $ij2HL = parcelRequire("ij2HL");
/**
 * Returns a new list or string with the elements or characters in reverse
 * order.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a]
 * @sig String -> String
 * @param {Array|String} list
 * @return {Array|String}
 * @example
 *
 *      R.reverse([1, 2, 3]);  //=> [3, 2, 1]
 *      R.reverse([1, 2]);     //=> [2, 1]
 *      R.reverse([1]);        //=> [1]
 *      R.reverse([]);         //=> []
 *
 *      R.reverse('abc');      //=> 'cba'
 *      R.reverse('ab');       //=> 'ba'
 *      R.reverse('a');        //=> 'a'
 *      R.reverse('');         //=> ''
 */ var $0290e110443c5b3c$var$reverse = /*#__PURE__*/ (0, $lrIA4.default)(function reverse(list) {
    return (0, $ij2HL.default)(list) ? list.split("").reverse().join("") : Array.prototype.slice.call(list, 0).reverse();
});
var $0290e110443c5b3c$export$2e2bcd8739ae039 = $0290e110443c5b3c$var$reverse;

});


parcelRegister("ap0Or", function(module, exports) {

var $4E2dE = parcelRequire("4E2dE");

var $4PEAx = parcelRequire("4PEAx");

var $dEOUW = parcelRequire("dEOUW");
/**
 * Performs right-to-left function composition using transforming function. The last function may have
 * any arity; the remaining functions must be unary.
 *
 * **Note:** The result of composeWith is not automatically curried. Transforming function is not used
 * on the last argument.
 *
 * @func
 * @memberOf R
 * @since v0.26.0
 * @category Function
 * @sig ((* -> *), [(y -> z), (x -> y), ..., (o -> p), ((a, b, ..., n) -> o)]) -> ((a, b, ..., n) -> z)
 * @param {Function} transformer The transforming function
 * @param {Array} functions The functions to compose
 * @return {Function}
 * @see R.compose, R.pipeWith
 * @example
 *
 *      const composeWhileNotNil = R.composeWith((f, res) => R.isNil(res) ? res : f(res));
 *
 *      composeWhileNotNil([R.inc, R.prop('age')])({age: 1}) //=> 2
 *      composeWhileNotNil([R.inc, R.prop('age')])({}) //=> undefined
 *
 * @symb R.composeWith(f)([g, h, i])(...args) = f(g, f(h, i(...args)))
 */ var $792cde8dee3f7f00$var$composeWith = /*#__PURE__*/ (0, $4E2dE.default)(function composeWith(xf, list) {
    return (0, $4PEAx.default).apply(this, [
        xf,
        (0, $dEOUW.default)(list)
    ]);
});
var $792cde8dee3f7f00$export$2e2bcd8739ae039 = $792cde8dee3f7f00$var$composeWith;

});
parcelRegister("4PEAx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $384b68d49257e286$export$2e2bcd8739ae039; });

var $fe9oK = parcelRequire("fe9oK");

var $4E2dE = parcelRequire("4E2dE");

var $68oBa = parcelRequire("68oBa");

var $jdcIJ = parcelRequire("jdcIJ");

var $cWyLj = parcelRequire("cWyLj");

var $7x9UL = parcelRequire("7x9UL");
/**
 * Performs left-to-right function composition using transforming function. The first function may have
 * any arity; the remaining functions must be unary.
 *
 * **Note:** The result of pipeWith is not automatically curried. Transforming function is not used on the
 * first argument.
 *
 * @func
 * @memberOf R
 * @since v0.26.0
 * @category Function
 * @sig ((* -> *), [((a, b, ..., n) -> o), (o -> p), ..., (x -> y), (y -> z)]) -> ((a, b, ..., n) -> z)
 * @param {Function} transformer The transforming function
 * @param {Array} functions The functions to pipe
 * @return {Function}
 * @see R.composeWith, R.pipe
 * @example
 *
 *      const pipeWhileNotNil = R.pipeWith((f, res) => R.isNil(res) ? res : f(res));
 *      const f = pipeWhileNotNil([Math.pow, R.negate, R.inc])
 *
 *      f(3, 4); // -(3^4) + 1
 * @symb R.pipeWith(f)([g, h, i])(...args) = f(i, f(h, g(...args)))
 */ var $384b68d49257e286$var$pipeWith = /*#__PURE__*/ (0, $4E2dE.default)(function pipeWith(xf, list) {
    if (list.length <= 0) return 0, $7x9UL.default;
    var headList = (0, $68oBa.default)(list);
    var tailList = (0, $cWyLj.default)(list);
    return (0, $fe9oK.default)(headList.length, function() {
        return (0, $jdcIJ.default)(function(result, f) {
            return xf.call(this, f, result);
        }, headList.apply(this, arguments), tailList);
    });
});
var $384b68d49257e286$export$2e2bcd8739ae039 = $384b68d49257e286$var$pipeWith;

});
parcelRegister("68oBa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4776922f2bd98dfb$export$2e2bcd8739ae039; });

var $7aHtE = parcelRequire("7aHtE");
/**
 * Returns the first element of the given list or string. In some libraries
 * this function is named `first`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> a | Undefined
 * @sig String -> String
 * @param {Array|String} list
 * @return {*}
 * @see R.tail, R.init, R.last
 * @example
 *
 *      R.head(['fi', 'fo', 'fum']); //=> 'fi'
 *      R.head([]); //=> undefined
 *
 *      R.head('abc'); //=> 'a'
 *      R.head(''); //=> ''
 */ var $4776922f2bd98dfb$var$head = /*#__PURE__*/ (0, $7aHtE.default)(0);
var $4776922f2bd98dfb$export$2e2bcd8739ae039 = $4776922f2bd98dfb$var$head;

});

parcelRegister("7x9UL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $57c34e448e1d38ee$export$2e2bcd8739ae039; });

var $lrIA4 = parcelRequire("lrIA4");

var $k3Ml1 = parcelRequire("k3Ml1");
/**
 * A function that does nothing but return the parameter supplied to it. Good
 * as a default or placeholder function.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig a -> a
 * @param {*} x The value to return.
 * @return {*} The input value, `x`.
 * @example
 *
 *      R.identity(1); //=> 1
 *
 *      const obj = {};
 *      R.identity(obj) === obj; //=> true
 * @symb R.identity(a) = a
 */ var $57c34e448e1d38ee$var$identity = /*#__PURE__*/ (0, $lrIA4.default)((0, $k3Ml1.default));
var $57c34e448e1d38ee$export$2e2bcd8739ae039 = $57c34e448e1d38ee$var$identity;

});
parcelRegister("k3Ml1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e9a99568835de02b$export$2e2bcd8739ae039; });
function $e9a99568835de02b$export$2e2bcd8739ae039(x) {
    return x;
}

});




parcelRegister("j492g", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de15664cc6ed003b$export$2e2bcd8739ae039; });

var $4E2dE = parcelRequire("4E2dE");

var $9hDA3 = parcelRequire("9hDA3");

var $aizOG = parcelRequire("aizOG");

var $ij2HL = parcelRequire("ij2HL");

var $220yG = parcelRequire("220yG");
/**
 * Returns the result of concatenating the given lists or strings.
 *
 * Note: `R.concat` expects both arguments to be of the same type,
 * unlike the native `Array.prototype.concat` method. It will throw
 * an error if you `concat` an Array with a non-Array value.
 *
 * Dispatches to the `concat` method of the first argument, if present.
 * Can also concatenate two members of a [fantasy-land
 * compatible semigroup](https://github.com/fantasyland/fantasy-land#semigroup).
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a] -> [a]
 * @sig String -> String -> String
 * @param {Array|String} firstList The first list
 * @param {Array|String} secondList The second list
 * @return {Array|String} A list consisting of the elements of `firstList` followed by the elements of
 * `secondList`.
 *
 * @example
 *
 *      R.concat('ABC', 'DEF'); // 'ABCDEF'
 *      R.concat([4, 5, 6], [1, 2, 3]); //=> [4, 5, 6, 1, 2, 3]
 *      R.concat([], []); //=> []
 */ var $de15664cc6ed003b$var$concat = /*#__PURE__*/ (0, $4E2dE.default)(function concat(a, b) {
    if ((0, $9hDA3.default)(a)) {
        if ((0, $9hDA3.default)(b)) return a.concat(b);
        throw new TypeError((0, $220yG.default)(b) + " is not an array");
    }
    if ((0, $ij2HL.default)(a)) {
        if ((0, $ij2HL.default)(b)) return a + b;
        throw new TypeError((0, $220yG.default)(b) + " is not a string");
    }
    if (a != null && (0, $aizOG.default)(a["fantasy-land/concat"])) return a["fantasy-land/concat"](b);
    if (a != null && (0, $aizOG.default)(a.concat)) return a.concat(b);
    throw new TypeError((0, $220yG.default)(a) + ' does not have a method named "concat" or "fantasy-land/concat"');
});
var $de15664cc6ed003b$export$2e2bcd8739ae039 = $de15664cc6ed003b$var$concat;

});
parcelRegister("220yG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $17ac3393040f50bc$export$2e2bcd8739ae039; });

var $lrIA4 = parcelRequire("lrIA4");

var $hAe6X = parcelRequire("hAe6X");
/**
 * Returns the string representation of the given value. `eval`'ing the output
 * should result in a value equivalent to the input value. Many of the built-in
 * `toString` methods do not satisfy this requirement.
 *
 * If the given value is an `[object Object]` with a `toString` method other
 * than `Object.prototype.toString`, this method is invoked with no arguments
 * to produce the return value. This means user-defined constructor functions
 * can provide a suitable `toString` method. For example:
 *
 *     function Point(x, y) {
 *       this.x = x;
 *       this.y = y;
 *     }
 *
 *     Point.prototype.toString = function() {
 *       return 'new Point(' + this.x + ', ' + this.y + ')';
 *     };
 *
 *     R.toString(new Point(1, 2)); //=> 'new Point(1, 2)'
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category String
 * @sig * -> String
 * @param {*} val
 * @return {String}
 * @example
 *
 *      R.toString(42); //=> '42'
 *      R.toString('abc'); //=> '"abc"'
 *      R.toString([1, 2, 3]); //=> '[1, 2, 3]'
 *      R.toString({foo: 1, bar: 2, baz: 3}); //=> '{"bar": 2, "baz": 3, "foo": 1}'
 *      R.toString(new Date('2001-02-03T04:05:06Z')); //=> 'new Date("2001-02-03T04:05:06.000Z")'
 */ var $17ac3393040f50bc$var$toString = /*#__PURE__*/ (0, $lrIA4.default)(function toString(val) {
    return (0, $hAe6X.default)(val, []);
});
var $17ac3393040f50bc$export$2e2bcd8739ae039 = $17ac3393040f50bc$var$toString;

});
parcelRegister("hAe6X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ccd0bead95c5c320$export$2e2bcd8739ae039; });

var $k7LM5 = parcelRequire("k7LM5");

var $5DhuU = parcelRequire("5DhuU");

var $7XuNf = parcelRequire("7XuNf");

var $aSpf7 = parcelRequire("aSpf7");

var $ipwCl = parcelRequire("ipwCl");

var $8MN2o = parcelRequire("8MN2o");
function $ccd0bead95c5c320$export$2e2bcd8739ae039(x, seen) {
    var recur = function recur(y) {
        var xs = seen.concat([
            x
        ]);
        return (0, $k7LM5.default)(y, xs) ? "<Circular>" : $ccd0bead95c5c320$export$2e2bcd8739ae039(y, xs);
    }; //  mapPairs :: (Object, [String]) -> [String]
    var mapPairs = function(obj, keys) {
        return (0, $5DhuU.default)(function(k) {
            return (0, $7XuNf.default)(k) + ": " + recur(obj[k]);
        }, keys.slice().sort());
    };
    switch(Object.prototype.toString.call(x)){
        case "[object Arguments]":
            return "(function() { return arguments; }(" + (0, $5DhuU.default)(recur, x).join(", ") + "))";
        case "[object Array]":
            return "[" + (0, $5DhuU.default)(recur, x).concat(mapPairs(x, (0, $8MN2o.default)(function(k) {
                return /^\d+$/.test(k);
            }, (0, $ipwCl.default)(x)))).join(", ") + "]";
        case "[object Boolean]":
            return typeof x === "object" ? "new Boolean(" + recur(x.valueOf()) + ")" : x.toString();
        case "[object Date]":
            return "new Date(" + (isNaN(x.valueOf()) ? recur(NaN) : (0, $7XuNf.default)((0, $aSpf7.default)(x))) + ")";
        case "[object Null]":
            return "null";
        case "[object Number]":
            return typeof x === "object" ? "new Number(" + recur(x.valueOf()) + ")" : 1 / x === -Infinity ? "-0" : x.toString(10);
        case "[object String]":
            return typeof x === "object" ? "new String(" + recur(x.valueOf()) + ")" : (0, $7XuNf.default)(x);
        case "[object Undefined]":
            return "undefined";
        default:
            if (typeof x.toString === "function") {
                var repr = x.toString();
                if (repr !== "[object Object]") return repr;
            }
            return "{" + mapPairs(x, (0, $ipwCl.default)(x)).join(", ") + "}";
    }
}

});
parcelRegister("k7LM5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ea6985219c037cfd$export$2e2bcd8739ae039; });

var $b5dJf = parcelRequire("b5dJf");
function $ea6985219c037cfd$export$2e2bcd8739ae039(a, list) {
    return (0, $b5dJf.default)(list, a, 0) >= 0;
}

});
parcelRegister("b5dJf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $811acf98ba75716c$export$2e2bcd8739ae039; });

var $imwRL = parcelRequire("imwRL");
function $811acf98ba75716c$export$2e2bcd8739ae039(list, a, idx) {
    var inf, item; // Array.prototype.indexOf doesn't exist below IE9
    if (typeof list.indexOf === "function") switch(typeof a){
        case "number":
            if (a === 0) {
                // manually crawl the list to distinguish between +0 and -0
                inf = 1 / a;
                while(idx < list.length){
                    item = list[idx];
                    if (item === 0 && 1 / item === inf) return idx;
                    idx += 1;
                }
                return -1;
            } else if (a !== a) {
                // NaN
                while(idx < list.length){
                    item = list[idx];
                    if (typeof item === "number" && item !== item) return idx;
                    idx += 1;
                }
                return -1;
            } // non-zero numbers can utilise Set
            return list.indexOf(a, idx);
        // all these types can utilise Set
        case "string":
        case "boolean":
        case "function":
        case "undefined":
            return list.indexOf(a, idx);
        case "object":
            if (a === null) // null can utilise Set
            return list.indexOf(a, idx);
    }
     // anything else not covered above, defer to R.equals
    while(idx < list.length){
        if ((0, $imwRL.default)(list[idx], a)) return idx;
        idx += 1;
    }
    return -1;
}

});
parcelRegister("imwRL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d5e3c6996ab223ad$export$2e2bcd8739ae039; });

var $4E2dE = parcelRequire("4E2dE");

var $aVQwK = parcelRequire("aVQwK");
/**
 * Returns `true` if its arguments are equivalent, `false` otherwise. Handles
 * cyclical data structures.
 *
 * Dispatches symmetrically to the `equals` methods of both arguments, if
 * present.
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category Relation
 * @sig a -> b -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @example
 *
 *      R.equals(1, 1); //=> true
 *      R.equals(1, '1'); //=> false
 *      R.equals([1, 2, 3], [1, 2, 3]); //=> true
 *
 *      const a = {}; a.v = a;
 *      const b = {}; b.v = b;
 *      R.equals(a, b); //=> true
 */ var $d5e3c6996ab223ad$var$equals = /*#__PURE__*/ (0, $4E2dE.default)(function equals(a, b) {
    return (0, $aVQwK.default)(a, b, [], []);
});
var $d5e3c6996ab223ad$export$2e2bcd8739ae039 = $d5e3c6996ab223ad$var$equals;

});
parcelRegister("aVQwK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7f57f90caf1aede8$export$2e2bcd8739ae039; });

var $6YbJ7 = parcelRequire("6YbJ7");

var $iiRAt = parcelRequire("iiRAt");

var $bWrAd = parcelRequire("bWrAd");

var $jn7AE = parcelRequire("jn7AE");

var $jARjV = parcelRequire("jARjV");

var $ipwCl = parcelRequire("ipwCl");

var $1gWdq = parcelRequire("1gWdq");
/**
 * private _uniqContentEquals function.
 * That function is checking equality of 2 iterator contents with 2 assumptions
 * - iterators lengths are the same
 * - iterators values are unique
 *
 * false-positive result will be returned for comparison of, e.g.
 * - [1,2,3] and [1,2,3,4]
 * - [1,1,1] and [1,2,3]
 * */ function $7f57f90caf1aede8$var$_uniqContentEquals(aIterator, bIterator, stackA, stackB) {
    var a = (0, $6YbJ7.default)(aIterator);
    var b = (0, $6YbJ7.default)(bIterator);
    function eq(_a, _b) {
        return $7f57f90caf1aede8$export$2e2bcd8739ae039(_a, _b, stackA.slice(), stackB.slice());
    } // if *a* array contains any element that is not included in *b*
    return !(0, $iiRAt.default)(function(b, aItem) {
        return !(0, $iiRAt.default)(eq, aItem, b);
    }, b, a);
}
function $7f57f90caf1aede8$export$2e2bcd8739ae039(a, b, stackA, stackB) {
    if ((0, $jARjV.default)(a, b)) return true;
    var typeA = (0, $1gWdq.default)(a);
    if (typeA !== (0, $1gWdq.default)(b)) return false;
    if (typeof a["fantasy-land/equals"] === "function" || typeof b["fantasy-land/equals"] === "function") return typeof a["fantasy-land/equals"] === "function" && a["fantasy-land/equals"](b) && typeof b["fantasy-land/equals"] === "function" && b["fantasy-land/equals"](a);
    if (typeof a.equals === "function" || typeof b.equals === "function") return typeof a.equals === "function" && a.equals(b) && typeof b.equals === "function" && b.equals(a);
    switch(typeA){
        case "Arguments":
        case "Array":
        case "Object":
            if (typeof a.constructor === "function" && (0, $bWrAd.default)(a.constructor) === "Promise") return a === b;
            break;
        case "Boolean":
        case "Number":
        case "String":
            if (!(typeof a === typeof b && (0, $jARjV.default)(a.valueOf(), b.valueOf()))) return false;
            break;
        case "Date":
            if (!(0, $jARjV.default)(a.valueOf(), b.valueOf())) return false;
            break;
        case "Error":
            return a.name === b.name && a.message === b.message;
        case "RegExp":
            if (!(a.source === b.source && a.global === b.global && a.ignoreCase === b.ignoreCase && a.multiline === b.multiline && a.sticky === b.sticky && a.unicode === b.unicode)) return false;
            break;
    }
    var idx = stackA.length - 1;
    while(idx >= 0){
        if (stackA[idx] === a) return stackB[idx] === b;
        idx -= 1;
    }
    switch(typeA){
        case "Map":
            if (a.size !== b.size) return false;
            return $7f57f90caf1aede8$var$_uniqContentEquals(a.entries(), b.entries(), stackA.concat([
                a
            ]), stackB.concat([
                b
            ]));
        case "Set":
            if (a.size !== b.size) return false;
            return $7f57f90caf1aede8$var$_uniqContentEquals(a.values(), b.values(), stackA.concat([
                a
            ]), stackB.concat([
                b
            ]));
        case "Arguments":
        case "Array":
        case "Object":
        case "Boolean":
        case "Number":
        case "String":
        case "Date":
        case "Error":
        case "RegExp":
        case "Int8Array":
        case "Uint8Array":
        case "Uint8ClampedArray":
        case "Int16Array":
        case "Uint16Array":
        case "Int32Array":
        case "Uint32Array":
        case "Float32Array":
        case "Float64Array":
        case "ArrayBuffer":
            break;
        default:
            // Values of other types are only equal if identical.
            return false;
    }
    var keysA = (0, $ipwCl.default)(a);
    if (keysA.length !== (0, $ipwCl.default)(b).length) return false;
    var extendedStackA = stackA.concat([
        a
    ]);
    var extendedStackB = stackB.concat([
        b
    ]);
    idx = keysA.length - 1;
    while(idx >= 0){
        var key = keysA[idx];
        if (!((0, $jn7AE.default)(key, b) && $7f57f90caf1aede8$export$2e2bcd8739ae039(b[key], a[key], extendedStackA, extendedStackB))) return false;
        idx -= 1;
    }
    return true;
}

});
parcelRegister("6YbJ7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5131715e337b3cf2$export$2e2bcd8739ae039; });
function $5131715e337b3cf2$export$2e2bcd8739ae039(iter) {
    var list = [];
    var next;
    while(!(next = iter.next()).done)list.push(next.value);
    return list;
}

});

parcelRegister("iiRAt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d53379c2e9ae23b4$export$2e2bcd8739ae039; });
function $d53379c2e9ae23b4$export$2e2bcd8739ae039(pred, x, list) {
    var idx = 0;
    var len = list.length;
    while(idx < len){
        if (pred(x, list[idx])) return true;
        idx += 1;
    }
    return false;
}

});

parcelRegister("bWrAd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8b1a81f14a3f0e14$export$2e2bcd8739ae039; });
function $8b1a81f14a3f0e14$export$2e2bcd8739ae039(f) {
    // String(x => x) evaluates to "x => x", so the pattern may not match.
    var match = String(f).match(/^function (\w*)/);
    return match == null ? "" : match[1];
}

});

parcelRegister("jARjV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e43abd67c2d31aab$export$2e2bcd8739ae039; });
// Based on https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function $e43abd67c2d31aab$var$_objectIs(a, b) {
    // SameValue algorithm
    if (a === b) // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    return a !== 0 || 1 / a === 1 / b;
    else // Step 6.a: NaN == NaN
    return a !== a && b !== b;
}
var $e43abd67c2d31aab$export$2e2bcd8739ae039 = typeof Object.is === "function" ? Object.is : $e43abd67c2d31aab$var$_objectIs;

});





parcelRegister("7XuNf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5cb5ee0263957283$export$2e2bcd8739ae039; });
function $5cb5ee0263957283$export$2e2bcd8739ae039(s) {
    var escaped = s.replace(/\\/g, "\\\\").replace(/[\b]/g, "\\b") // \b matches word boundary; [\b] matches backspace
    .replace(/\f/g, "\\f").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/\t/g, "\\t").replace(/\v/g, "\\v").replace(/\0/g, "\\0");
    return '"' + escaped.replace(/"/g, '\\"') + '"';
}

});

parcelRegister("aSpf7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7eb287385b1d9207$export$2e2bcd8739ae039; });
/**
 * Polyfill from <https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toISOString>.
 */ var $7eb287385b1d9207$var$pad = function pad(n) {
    return (n < 10 ? "0" : "") + n;
};
var $7eb287385b1d9207$var$_toISOString = typeof Date.prototype.toISOString === "function" ? function _toISOString(d) {
    return d.toISOString();
} : function _toISOString(d) {
    return d.getUTCFullYear() + "-" + $7eb287385b1d9207$var$pad(d.getUTCMonth() + 1) + "-" + $7eb287385b1d9207$var$pad(d.getUTCDate()) + "T" + $7eb287385b1d9207$var$pad(d.getUTCHours()) + ":" + $7eb287385b1d9207$var$pad(d.getUTCMinutes()) + ":" + $7eb287385b1d9207$var$pad(d.getUTCSeconds()) + "." + (d.getUTCMilliseconds() / 1000).toFixed(3).slice(2, 5) + "Z";
};
var $7eb287385b1d9207$export$2e2bcd8739ae039 = $7eb287385b1d9207$var$_toISOString;

});

parcelRegister("8MN2o", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6658d8499c9c02e8$export$2e2bcd8739ae039; });

var $2t09Y = parcelRequire("2t09Y");

var $4E2dE = parcelRequire("4E2dE");

var $f9Ph0 = parcelRequire("f9Ph0");
/**
 * The complement of [`filter`](#filter).
 *
 * Acts as a transducer if a transformer is given in list position. Filterable
 * objects include plain objects or any object that has a filter method such
 * as `Array`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Filterable f => (a -> Boolean) -> f a -> f a
 * @param {Function} pred
 * @param {Array} filterable
 * @return {Array}
 * @see R.filter, R.transduce, R.addIndex
 * @example
 *
 *      const isOdd = (n) => n % 2 !== 0;
 *
 *      R.reject(isOdd, [1, 2, 3, 4]); //=> [2, 4]
 *
 *      R.reject(isOdd, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
 */ var $6658d8499c9c02e8$var$reject = /*#__PURE__*/ (0, $4E2dE.default)(function reject(pred, filterable) {
    return (0, $f9Ph0.default)((0, $2t09Y.default)(pred), filterable);
});
var $6658d8499c9c02e8$export$2e2bcd8739ae039 = $6658d8499c9c02e8$var$reject;

});
parcelRegister("2t09Y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1cbe69f0ab5ceba8$export$2e2bcd8739ae039; });
function $1cbe69f0ab5ceba8$export$2e2bcd8739ae039(f) {
    return function() {
        return !f.apply(this, arguments);
    };
}

});

parcelRegister("f9Ph0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b08f7812dd6e2125$export$2e2bcd8739ae039; });

var $4E2dE = parcelRequire("4E2dE");

var $AZnlR = parcelRequire("AZnlR");

var $cgyVq = parcelRequire("cgyVq");

var $fGe1Y = parcelRequire("fGe1Y");

var $jdcIJ = parcelRequire("jdcIJ");

var $pgJo1 = parcelRequire("pgJo1");

var $ipwCl = parcelRequire("ipwCl");
/**
 * Takes a predicate and a `Filterable`, and returns a new filterable of the
 * same type containing the members of the given filterable which satisfy the
 * given predicate. Filterable objects include plain objects or any object
 * that has a filter method such as `Array`.
 *
 * Dispatches to the `filter` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Filterable f => (a -> Boolean) -> f a -> f a
 * @param {Function} pred
 * @param {Array} filterable
 * @return {Array} Filterable
 * @see R.reject, R.transduce, R.addIndex
 * @example
 *
 *      const isEven = n => n % 2 === 0;
 *
 *      R.filter(isEven, [1, 2, 3, 4]); //=> [2, 4]
 *
 *      R.filter(isEven, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
 */ var $b08f7812dd6e2125$var$filter = /*#__PURE__*/ (0, $4E2dE.default)(/*#__PURE__*/ (0, $AZnlR.default)([
    "fantasy-land/filter",
    "filter"
], (0, $pgJo1.default), function(pred, filterable) {
    return (0, $fGe1Y.default)(filterable) ? (0, $jdcIJ.default)(function(acc, key) {
        if (pred(filterable[key])) acc[key] = filterable[key];
        return acc;
    }, {}, (0, $ipwCl.default)(filterable)) : (0, $cgyVq.default)(pred, filterable);
}));
var $b08f7812dd6e2125$export$2e2bcd8739ae039 = $b08f7812dd6e2125$var$filter;

});
parcelRegister("cgyVq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ee21215080c6c34$export$2e2bcd8739ae039; });
function $8ee21215080c6c34$export$2e2bcd8739ae039(fn, list) {
    var idx = 0;
    var len = list.length;
    var result = [];
    while(idx < len){
        if (fn(list[idx])) result[result.length] = list[idx];
        idx += 1;
    }
    return result;
}

});

parcelRegister("fGe1Y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b6a5a9826989a74a$export$2e2bcd8739ae039; });
function $b6a5a9826989a74a$export$2e2bcd8739ae039(x) {
    return Object.prototype.toString.call(x) === "[object Object]";
}

});

parcelRegister("pgJo1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $04bf5059b17dc4e0$export$2e2bcd8739ae039; });

var $4E2dE = parcelRequire("4E2dE");

var $dki4v = parcelRequire("dki4v");
var $04bf5059b17dc4e0$var$XFilter = /*#__PURE__*/ function() {
    function XFilter(f, xf) {
        this.xf = xf;
        this.f = f;
    }
    XFilter.prototype["@@transducer/init"] = (0, $dki4v.default).init;
    XFilter.prototype["@@transducer/result"] = (0, $dki4v.default).result;
    XFilter.prototype["@@transducer/step"] = function(result, input) {
        return this.f(input) ? this.xf["@@transducer/step"](result, input) : result;
    };
    return XFilter;
}();
var $04bf5059b17dc4e0$var$_xfilter = /*#__PURE__*/ (0, $4E2dE.default)(function _xfilter(f, xf) {
    return new $04bf5059b17dc4e0$var$XFilter(f, xf);
});
var $04bf5059b17dc4e0$export$2e2bcd8739ae039 = $04bf5059b17dc4e0$var$_xfilter;

});






parcelRegister("hPnpi", function(module, exports) {

var $fe9oK = parcelRequire("fe9oK");

var $lrIA4 = parcelRequire("lrIA4");

var $aaiYf = parcelRequire("aaiYf");

var $64epv = parcelRequire("64epv");

var $hv0Dt = parcelRequire("hv0Dt");
/**
 * Returns a function, `fn`, which encapsulates `if/else, if/else, ...` logic.
 * `R.cond` takes a list of [predicate, transformer] pairs. All of the arguments
 * to `fn` are applied to each of the predicates in turn until one returns a
 * "truthy" value, at which point `fn` returns the result of applying its
 * arguments to the corresponding transformer. If none of the predicates
 * matches, `fn` returns undefined.
 *
 * **Please note**: This is not a direct substitute for a `switch` statement.
 * Remember that both elements of every pair passed to `cond` are *functions*,
 * and `cond` returns a function.
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category Logic
 * @sig [[(*... -> Boolean),(*... -> *)]] -> (*... -> *)
 * @param {Array} pairs A list of [predicate, transformer]
 * @return {Function}
 * @see R.ifElse, R.unless, R.when
 * @example
 *
 *      const fn = R.cond([
 *        [R.equals(0),   R.always('water freezes at 0°C')],
 *        [R.equals(100), R.always('water boils at 100°C')],
 *        [R.T,           temp => 'nothing special happens at ' + temp + '°C']
 *      ]);
 *      fn(0); //=> 'water freezes at 0°C'
 *      fn(50); //=> 'nothing special happens at 50°C'
 *      fn(100); //=> 'water boils at 100°C'
 */ var $cfa95b361d4985da$var$cond = /*#__PURE__*/ (0, $lrIA4.default)(function cond(pairs) {
    var arity = (0, $hv0Dt.default)((0, $64epv.default), 0, (0, $aaiYf.default)(function(pair) {
        return pair[0].length;
    }, pairs));
    return (0, $fe9oK.default)(arity, function() {
        var idx = 0;
        while(idx < pairs.length){
            if (pairs[idx][0].apply(this, arguments)) return pairs[idx][1].apply(this, arguments);
            idx += 1;
        }
    });
});
var $cfa95b361d4985da$export$2e2bcd8739ae039 = $cfa95b361d4985da$var$cond;

});

parcelRegister("4pXxy", function(module, exports) {

var $lrIA4 = parcelRequire("lrIA4");

var $jXgv2 = parcelRequire("jXgv2");
/**
 * Wraps a constructor function inside a curried function that can be called
 * with the same arguments and returns the same type.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (* -> {*}) -> (* -> {*})
 * @param {Function} fn The constructor function to wrap.
 * @return {Function} A wrapped, curried constructor function.
 * @see R.invoker
 * @example
 *
 *      // Constructor function
 *      function Animal(kind) {
 *        this.kind = kind;
 *      };
 *      Animal.prototype.sighting = function() {
 *        return "It's a " + this.kind + "!";
 *      }
 *
 *      const AnimalConstructor = R.construct(Animal)
 *
 *      // Notice we no longer need the 'new' keyword:
 *      AnimalConstructor('Pig'); //=> {"kind": "Pig", "sighting": function (){...}};
 *
 *      const animalTypes = ["Lion", "Tiger", "Bear"];
 *      const animalSighting = R.invoker(0, 'sighting');
 *      const sightNewAnimal = R.compose(animalSighting, AnimalConstructor);
 *      R.map(sightNewAnimal, animalTypes); //=> ["It's a Lion!", "It's a Tiger!", "It's a Bear!"]
 */ var $3377aeae1b438b2a$var$construct = /*#__PURE__*/ (0, $lrIA4.default)(function construct(Fn) {
    return (0, $jXgv2.default)(Fn.length, Fn);
});
var $3377aeae1b438b2a$export$2e2bcd8739ae039 = $3377aeae1b438b2a$var$construct;

});
parcelRegister("jXgv2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e870538377afcc9d$export$2e2bcd8739ae039; });

var $4E2dE = parcelRequire("4E2dE");

var $bwvc9 = parcelRequire("bwvc9");

var $kRpXl = parcelRequire("kRpXl");
/**
 * Wraps a constructor function inside a curried function that can be called
 * with the same arguments and returns the same type. The arity of the function
 * returned is specified to allow using variadic constructor functions.
 *
 * @func
 * @memberOf R
 * @since v0.4.0
 * @category Function
 * @sig Number -> (* -> {*}) -> (* -> {*})
 * @param {Number} n The arity of the constructor function.
 * @param {Function} Fn The constructor function to wrap.
 * @return {Function} A wrapped, curried constructor function.
 * @example
 *
 *      // Variadic Constructor function
 *      function Salad() {
 *        this.ingredients = arguments;
 *      }
 *
 *      Salad.prototype.recipe = function() {
 *        const instructions = R.map(ingredient => 'Add a dollop of ' + ingredient, this.ingredients);
 *        return R.join('\n', instructions);
 *      };
 *
 *      const ThreeLayerSalad = R.constructN(3, Salad);
 *
 *      // Notice we no longer need the 'new' keyword, and the constructor is curried for 3 arguments.
 *      const salad = ThreeLayerSalad('Mayonnaise')('Potato Chips')('Ketchup');
 *
 *      console.log(salad.recipe());
 *      // Add a dollop of Mayonnaise
 *      // Add a dollop of Potato Chips
 *      // Add a dollop of Ketchup
 */ var $e870538377afcc9d$var$constructN = /*#__PURE__*/ (0, $4E2dE.default)(function constructN(n, Fn) {
    if (n > 10) throw new Error("Constructor with greater than ten arguments");
    if (n === 0) return function() {
        return new Fn();
    };
    return (0, $bwvc9.default)((0, $kRpXl.default)(n, function($0, $1, $2, $3, $4, $5, $6, $7, $8, $9) {
        switch(arguments.length){
            case 1:
                return new Fn($0);
            case 2:
                return new Fn($0, $1);
            case 3:
                return new Fn($0, $1, $2);
            case 4:
                return new Fn($0, $1, $2, $3);
            case 5:
                return new Fn($0, $1, $2, $3, $4);
            case 6:
                return new Fn($0, $1, $2, $3, $4, $5);
            case 7:
                return new Fn($0, $1, $2, $3, $4, $5, $6);
            case 8:
                return new Fn($0, $1, $2, $3, $4, $5, $6, $7);
            case 9:
                return new Fn($0, $1, $2, $3, $4, $5, $6, $7, $8);
            case 10:
                return new Fn($0, $1, $2, $3, $4, $5, $6, $7, $8, $9);
        }
    }));
});
var $e870538377afcc9d$export$2e2bcd8739ae039 = $e870538377afcc9d$var$constructN;

});
parcelRegister("bwvc9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $863ae185a1c04043$export$2e2bcd8739ae039; });

var $lrIA4 = parcelRequire("lrIA4");

var $4fS8E = parcelRequire("4fS8E");
/**
 * Returns a curried equivalent of the provided function. The curried function
 * has two unusual capabilities. First, its arguments needn't be provided one
 * at a time. If `f` is a ternary function and `g` is `R.curry(f)`, the
 * following are equivalent:
 *
 *   - `g(1)(2)(3)`
 *   - `g(1)(2, 3)`
 *   - `g(1, 2)(3)`
 *   - `g(1, 2, 3)`
 *
 * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
 * "gaps", allowing partial application of any combination of arguments,
 * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
 * the following are equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (* -> a) -> (* -> a)
 * @param {Function} fn The function to curry.
 * @return {Function} A new, curried function.
 * @see R.curryN, R.partial
 * @example
 *
 *      const addFourNumbers = (a, b, c, d) => a + b + c + d;
 *
 *      const curriedAddFourNumbers = R.curry(addFourNumbers);
 *      const f = curriedAddFourNumbers(1, 2);
 *      const g = f(3);
 *      g(4); //=> 10
 */ var $863ae185a1c04043$var$curry = /*#__PURE__*/ (0, $lrIA4.default)(function curry(fn) {
    return (0, $4fS8E.default)(fn.length, fn);
});
var $863ae185a1c04043$export$2e2bcd8739ae039 = $863ae185a1c04043$var$curry;

});



parcelRegister("dgkqv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9a7c9d4720487417$export$2e2bcd8739ae039; });

var $4E2dE = parcelRequire("4E2dE");

var $5DhuU = parcelRequire("5DhuU");

var $4fS8E = parcelRequire("4fS8E");

var $64epv = parcelRequire("64epv");

var $gUBuO = parcelRequire("gUBuO");

var $hv0Dt = parcelRequire("hv0Dt");
/**
 * Accepts a converging function and a list of branching functions and returns
 * a new function. The arity of the new function is the same as the arity of
 * the longest branching function. When invoked, this new function is applied
 * to some arguments, and each branching function is applied to those same
 * arguments. The results of each branching function are passed as arguments
 * to the converging function to produce the return value.
 *
 * @func
 * @memberOf R
 * @since v0.4.2
 * @category Function
 * @sig ((x1, x2, ...) -> z) -> [((a, b, ...) -> x1), ((a, b, ...) -> x2), ...] -> (a -> b -> ... -> z)
 * @param {Function} after A function. `after` will be invoked with the return values of
 *        `fn1` and `fn2` as its arguments.
 * @param {Array} functions A list of functions.
 * @return {Function} A new function.
 * @see R.useWith
 * @example
 *
 *      const average = R.converge(R.divide, [R.sum, R.length])
 *      average([1, 2, 3, 4, 5, 6, 7]) //=> 4
 *
 *      const strangeConcat = R.converge(R.concat, [R.toUpper, R.toLower])
 *      strangeConcat("Yodel") //=> "YODELyodel"
 *
 * @symb R.converge(f, [g, h])(a, b) = f(g(a, b), h(a, b))
 */ var $9a7c9d4720487417$var$converge = /*#__PURE__*/ (0, $4E2dE.default)(function converge(after, fns) {
    return (0, $4fS8E.default)((0, $hv0Dt.default)((0, $64epv.default), 0, (0, $gUBuO.default)("length", fns)), function() {
        var args = arguments;
        var context = this;
        return after.apply(context, (0, $5DhuU.default)(function(fn) {
            return fn.apply(context, args);
        }, fns));
    });
});
var $9a7c9d4720487417$export$2e2bcd8739ae039 = $9a7c9d4720487417$var$converge;

});

parcelRegister("4AxPp", function(module, exports) {

var $jdcIJ = parcelRequire("jdcIJ");

var $bwvc9 = parcelRequire("bwvc9");
/**
 * Returns the number of items in a given `list` matching the predicate `f`
 *
 * @func
 * @memberOf R
 * @since v0.28.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> Number
 * @param {Function} predicate to match items against
 * @return {Array} list of items to count in
 * @example
 *
 *      const even = x => x % 2 == 0;
 *
 *      R.count(even, [1, 2, 3, 4, 5]); // => 2
 *      R.map(R.count(even), [[1, 1, 1], [2, 3, 4, 5], [6]]); // => [0, 2, 1]
 */ var $3574c3c8943f8933$var$count = /*#__PURE__*/ (0, $bwvc9.default)(function(pred, list) {
    return (0, $jdcIJ.default)(function(a, e) {
        return pred(e) ? a + 1 : a;
    }, 0, list);
});
var $3574c3c8943f8933$export$2e2bcd8739ae039 = $3574c3c8943f8933$var$count;

});

parcelRegister("52xzQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3ab72f5b80583c37$export$2e2bcd8739ae039; });

var $5cYgD = parcelRequire("5cYgD");
/**
 * Counts the elements of a list according to how many match each value of a
 * key generated by the supplied function. Returns an object mapping the keys
 * produced by `fn` to the number of occurrences in the list. Note that all
 * keys are coerced to strings because of how JavaScript objects work.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig (a -> String) -> [a] -> {*}
 * @param {Function} fn The function used to map values to keys.
 * @param {Array} list The list to count elements from.
 * @return {Object} An object mapping keys to number of occurrences in the list.
 * @example
 *
 *      const numbers = [1.0, 1.1, 1.2, 2.0, 3.0, 2.2];
 *      R.countBy(Math.floor)(numbers);    //=> {'1': 3, '2': 2, '3': 1}
 *
 *      const letters = ['a', 'b', 'A', 'a', 'B', 'c'];
 *      R.countBy(R.toLower)(letters);   //=> {'a': 3, 'b': 2, 'c': 1}
 */ var $3ab72f5b80583c37$var$countBy = /*#__PURE__*/ (0, $5cYgD.default)(function(acc, elem) {
    return acc + 1;
}, 0);
var $3ab72f5b80583c37$export$2e2bcd8739ae039 = $3ab72f5b80583c37$var$countBy;

});
parcelRegister("5cYgD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3cacd292cb6e3032$export$2e2bcd8739ae039; });

var $gPAhz = parcelRequire("gPAhz");

var $2ikoZ = parcelRequire("2ikoZ");

var $AZnlR = parcelRequire("AZnlR");

var $jn7AE = parcelRequire("jn7AE");

var $jdcIJ = parcelRequire("jdcIJ");

var $1OnxV = parcelRequire("1OnxV");

var $cnYJS = parcelRequire("cnYJS");
/**
 * Groups the elements of the list according to the result of calling
 * the String-returning function `keyFn` on each element and reduces the elements
 * of each group to a single value via the reducer function `valueFn`.
 *
 * The value function receives two values: *(acc, value)*. It may use
 * [`R.reduced`](#reduced) to short circuit the iteration.
 *
 * This function is basically a more general [`groupBy`](#groupBy) function.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.20.0
 * @category List
 * @sig ((a, b) -> a) -> a -> (b -> String) -> [b] -> {String: a}
 * @param {Function} valueFn The function that reduces the elements of each group to a single
 *        value. Receives two values, accumulator for a particular group and the current element.
 * @param {*} acc The (initial) accumulator value for each group.
 * @param {Function} keyFn The function that maps the list's element into a key.
 * @param {Array} list The array to group.
 * @return {Object} An object with the output of `keyFn` for keys, mapped to the output of
 *         `valueFn` for elements which produced that key when passed to `keyFn`.
 * @see R.groupBy, R.reduce, R.reduced
 * @example
 *
 *      const groupNames = (acc, {name}) => acc.concat(name)
 *      const toGrade = ({score}) =>
 *        score < 65 ? 'F' :
 *        score < 70 ? 'D' :
 *        score < 80 ? 'C' :
 *        score < 90 ? 'B' : 'A'
 *
 *      var students = [
 *        {name: 'Abby', score: 83},
 *        {name: 'Bart', score: 62},
 *        {name: 'Curt', score: 88},
 *        {name: 'Dora', score: 92},
 *      ]
 *
 *      reduceBy(groupNames, [], toGrade, students)
 *      //=> {"A": ["Dora"], "B": ["Abby", "Curt"], "F": ["Bart"]}
 */ var $3cacd292cb6e3032$var$reduceBy = /*#__PURE__*/ (0, $2ikoZ.default)(4, [], /*#__PURE__*/ (0, $AZnlR.default)([], (0, $cnYJS.default), function reduceBy(valueFn, valueAcc, keyFn, list) {
    return (0, $jdcIJ.default)(function(acc, elt) {
        var key = keyFn(elt);
        var value = valueFn((0, $jn7AE.default)(key, acc) ? acc[key] : (0, $gPAhz.default)(valueAcc, [], [], false), elt);
        if (value && value["@@transducer/reduced"]) return (0, $1OnxV.default)(acc);
        acc[key] = value;
        return acc;
    }, {}, list);
}));
var $3cacd292cb6e3032$export$2e2bcd8739ae039 = $3cacd292cb6e3032$var$reduceBy;

});
parcelRegister("cnYJS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9046bf8681e900a9$export$2e2bcd8739ae039; });

var $2ikoZ = parcelRequire("2ikoZ");

var $jn7AE = parcelRequire("jn7AE");

var $dki4v = parcelRequire("dki4v");
var $9046bf8681e900a9$var$XReduceBy = /*#__PURE__*/ function() {
    function XReduceBy(valueFn, valueAcc, keyFn, xf) {
        this.valueFn = valueFn;
        this.valueAcc = valueAcc;
        this.keyFn = keyFn;
        this.xf = xf;
        this.inputs = {};
    }
    XReduceBy.prototype["@@transducer/init"] = (0, $dki4v.default).init;
    XReduceBy.prototype["@@transducer/result"] = function(result) {
        var key;
        for(key in this.inputs)if ((0, $jn7AE.default)(key, this.inputs)) {
            result = this.xf["@@transducer/step"](result, this.inputs[key]);
            if (result["@@transducer/reduced"]) {
                result = result["@@transducer/value"];
                break;
            }
        }
        this.inputs = null;
        return this.xf["@@transducer/result"](result);
    };
    XReduceBy.prototype["@@transducer/step"] = function(result, input) {
        var key = this.keyFn(input);
        this.inputs[key] = this.inputs[key] || [
            key,
            this.valueAcc
        ];
        this.inputs[key][1] = this.valueFn(this.inputs[key][1], input);
        return result;
    };
    return XReduceBy;
}();
var $9046bf8681e900a9$var$_xreduceBy = /*#__PURE__*/ (0, $2ikoZ.default)(4, [], function _xreduceBy(valueFn, valueAcc, keyFn, xf) {
    return new $9046bf8681e900a9$var$XReduceBy(valueFn, valueAcc, keyFn, xf);
});
var $9046bf8681e900a9$export$2e2bcd8739ae039 = $9046bf8681e900a9$var$_xreduceBy;

});



parcelRegister("1WRpV", function(module, exports) {

var $gQVWJ = parcelRequire("gQVWJ");
/**
 * Decrements its argument.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Math
 * @sig Number -> Number
 * @param {Number} n
 * @return {Number} n - 1
 * @see R.inc
 * @example
 *
 *      R.dec(42); //=> 41
 */ var $16b4a4c7dfad9ee5$var$dec = /*#__PURE__*/ (0, $gQVWJ.default)(-1);
var $16b4a4c7dfad9ee5$export$2e2bcd8739ae039 = $16b4a4c7dfad9ee5$var$dec;

});

parcelRegister("aggRQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $77887b834e4e8d8b$export$2e2bcd8739ae039; });

var $4E2dE = parcelRequire("4E2dE");
/**
 * Returns the second argument if it is not `null`, `undefined` or `NaN`;
 * otherwise the first argument is returned.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category Logic
 * @sig a -> b -> a | b
 * @param {a} default The default value.
 * @param {b} val `val` will be returned instead of `default` unless `val` is `null`, `undefined` or `NaN`.
 * @return {*} The second value if it is not `null`, `undefined` or `NaN`, otherwise the default value
 * @example
 *
 *      const defaultTo42 = R.defaultTo(42);
 *
 *      defaultTo42(null);  //=> 42
 *      defaultTo42(undefined);  //=> 42
 *      defaultTo42(false);  //=> false
 *      defaultTo42('Ramda');  //=> 'Ramda'
 *      // parseInt('string') results in NaN
 *      defaultTo42(parseInt('string')); //=> 42
 */ var $77887b834e4e8d8b$var$defaultTo = /*#__PURE__*/ (0, $4E2dE.default)(function defaultTo(d, v) {
    return v == null || v !== v ? d : v;
});
var $77887b834e4e8d8b$export$2e2bcd8739ae039 = $77887b834e4e8d8b$var$defaultTo;

});

parcelRegister("349Jh", function(module, exports) {

var $cjSwl = parcelRequire("cjSwl");
/**
 * Makes a descending comparator function out of a function that returns a value
 * that can be compared with `<` and `>`.
 *
 * @func
 * @memberOf R
 * @since v0.23.0
 * @category Function
 * @sig Ord b => (a -> b) -> a -> a -> Number
 * @param {Function} fn A function of arity one that returns a value that can be compared
 * @param {*} a The first item to be compared.
 * @param {*} b The second item to be compared.
 * @return {Number} `-1` if fn(a) > fn(b), `1` if fn(b) > fn(a), otherwise `0`
 * @see R.ascend
 * @example
 *
 *      const byAge = R.descend(R.prop('age'));
 *      const people = [
 *        { name: 'Emma', age: 70 },
 *        { name: 'Peter', age: 78 },
 *        { name: 'Mikhail', age: 62 },
 *      ];
 *      const peopleByOldestFirst = R.sort(byAge, people);
 *        //=> [{ name: 'Peter', age: 78 }, { name: 'Emma', age: 70 }, { name: 'Mikhail', age: 62 }]
 */ var $23b94ae1eb179e4d$var$descend = /*#__PURE__*/ (0, $cjSwl.default)(function descend(fn, a, b) {
    var aa = fn(a);
    var bb = fn(b);
    return aa > bb ? -1 : aa < bb ? 1 : 0;
});
var $23b94ae1eb179e4d$export$2e2bcd8739ae039 = $23b94ae1eb179e4d$var$descend;

});

parcelRegister("9bAZP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6b01d6d0f329b848$export$2e2bcd8739ae039; });

var $4E2dE = parcelRequire("4E2dE");

var $ccVNH = parcelRequire("ccVNH");
/**
 * Finds the set (i.e. no duplicates) of all elements in the first list not
 * contained in the second list. Objects and Arrays are compared in terms of
 * value equality, not reference equality.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig [*] -> [*] -> [*]
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The elements in `list1` that are not in `list2`.
 * @see R.differenceWith, R.symmetricDifference, R.symmetricDifferenceWith, R.without
 * @example
 *
 *      R.difference([1,2,3,4], [7,6,5,4,3]); //=> [1,2]
 *      R.difference([7,6,5,4,3], [1,2,3,4]); //=> [7,6,5]
 *      R.difference([{a: 1}, {b: 2}], [{a: 1}, {c: 3}]) //=> [{b: 2}]
 */ var $6b01d6d0f329b848$var$difference = /*#__PURE__*/ (0, $4E2dE.default)(function difference(first, second) {
    var out = [];
    var idx = 0;
    var firstLen = first.length;
    var secondLen = second.length;
    var toFilterOut = new (0, $ccVNH.default)();
    for(var i = 0; i < secondLen; i += 1)toFilterOut.add(second[i]);
    while(idx < firstLen){
        if (toFilterOut.add(first[idx])) out[out.length] = first[idx];
        idx += 1;
    }
    return out;
});
var $6b01d6d0f329b848$export$2e2bcd8739ae039 = $6b01d6d0f329b848$var$difference;

});
parcelRegister("ccVNH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8e337104c0a9a1cd$export$2e2bcd8739ae039; });

var $k7LM5 = parcelRequire("k7LM5");
var $8e337104c0a9a1cd$var$_Set = /*#__PURE__*/ function() {
    function _Set() {
        /* globals Set */ this._nativeSet = typeof Set === "function" ? new Set() : null;
        this._items = {};
    }
    // until we figure out why jsdoc chokes on this
    // @param item The item to add to the Set
    // @returns {boolean} true if the item did not exist prior, otherwise false
    //
    _Set.prototype.add = function(item) {
        return !$8e337104c0a9a1cd$var$hasOrAdd(item, true, this);
    }; //
    // @param item The item to check for existence in the Set
    // @returns {boolean} true if the item exists in the Set, otherwise false
    //
    _Set.prototype.has = function(item) {
        return $8e337104c0a9a1cd$var$hasOrAdd(item, false, this);
    }; //
    // Combines the logic for checking whether an item is a member of the set and
    // for adding a new item to the set.
    //
    // @param item       The item to check or add to the Set instance.
    // @param shouldAdd  If true, the item will be added to the set if it doesn't
    //                   already exist.
    // @param set        The set instance to check or add to.
    // @return {boolean} true if the item already existed, otherwise false.
    //
    return _Set;
}();
function $8e337104c0a9a1cd$var$hasOrAdd(item, shouldAdd, set) {
    var type = typeof item;
    var prevSize, newSize;
    switch(type){
        case "string":
        case "number":
            // distinguish between +0 and -0
            if (item === 0 && 1 / item === -Infinity) {
                if (set._items["-0"]) return true;
                else {
                    if (shouldAdd) set._items["-0"] = true;
                    return false;
                }
            } // these types can all utilise the native Set
            if (set._nativeSet !== null) {
                if (shouldAdd) {
                    prevSize = set._nativeSet.size;
                    set._nativeSet.add(item);
                    newSize = set._nativeSet.size;
                    return newSize === prevSize;
                } else return set._nativeSet.has(item);
            } else {
                if (!(type in set._items)) {
                    if (shouldAdd) {
                        set._items[type] = {};
                        set._items[type][item] = true;
                    }
                    return false;
                } else if (item in set._items[type]) return true;
                else {
                    if (shouldAdd) set._items[type][item] = true;
                    return false;
                }
            }
        case "boolean":
            // set._items['boolean'] holds a two element array
            // representing [ falseExists, trueExists ]
            if (type in set._items) {
                var bIdx = item ? 1 : 0;
                if (set._items[type][bIdx]) return true;
                else {
                    if (shouldAdd) set._items[type][bIdx] = true;
                    return false;
                }
            } else {
                if (shouldAdd) set._items[type] = item ? [
                    false,
                    true
                ] : [
                    true,
                    false
                ];
                return false;
            }
        case "function":
            // compare functions for reference equality
            if (set._nativeSet !== null) {
                if (shouldAdd) {
                    prevSize = set._nativeSet.size;
                    set._nativeSet.add(item);
                    newSize = set._nativeSet.size;
                    return newSize === prevSize;
                } else return set._nativeSet.has(item);
            } else {
                if (!(type in set._items)) {
                    if (shouldAdd) set._items[type] = [
                        item
                    ];
                    return false;
                }
                if (!(0, $k7LM5.default)(item, set._items[type])) {
                    if (shouldAdd) set._items[type].push(item);
                    return false;
                }
                return true;
            }
        case "undefined":
            if (set._items[type]) return true;
            else {
                if (shouldAdd) set._items[type] = true;
                return false;
            }
        case "object":
            if (item === null) {
                if (!set._items["null"]) {
                    if (shouldAdd) set._items["null"] = true;
                    return false;
                }
                return true;
            }
        /* falls through */ default:
            // reduce the search size of heterogeneous sets by creating buckets
            // for each type.
            type = Object.prototype.toString.call(item);
            if (!(type in set._items)) {
                if (shouldAdd) set._items[type] = [
                    item
                ];
                return false;
            } // scan through all previously applied items
            if (!(0, $k7LM5.default)(item, set._items[type])) {
                if (shouldAdd) set._items[type].push(item);
                return false;
            }
            return true;
    }
} // A simple Set type that honours R.equals semantics
var $8e337104c0a9a1cd$export$2e2bcd8739ae039 = $8e337104c0a9a1cd$var$_Set;

});


parcelRegister("6gGsO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $49052d190b7cf333$export$2e2bcd8739ae039; });

var $iiRAt = parcelRequire("iiRAt");

var $cjSwl = parcelRequire("cjSwl");
/**
 * Finds the set (i.e. no duplicates) of all elements in the first list not
 * contained in the second list. Duplication is determined according to the
 * value returned by applying the supplied predicate to two list elements.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig ((a, a) -> Boolean) -> [a] -> [a] -> [a]
 * @param {Function} pred A predicate used to test whether two items are equal.
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The elements in `list1` that are not in `list2`.
 * @see R.difference, R.symmetricDifference, R.symmetricDifferenceWith
 * @example
 *
 *      const cmp = (x, y) => x.a === y.a;
 *      const l1 = [{a: 1}, {a: 2}, {a: 3}];
 *      const l2 = [{a: 3}, {a: 4}];
 *      R.differenceWith(cmp, l1, l2); //=> [{a: 1}, {a: 2}]
 */ var $49052d190b7cf333$var$differenceWith = /*#__PURE__*/ (0, $cjSwl.default)(function differenceWith(pred, first, second) {
    var out = [];
    var idx = 0;
    var firstLen = first.length;
    while(idx < firstLen){
        if (!(0, $iiRAt.default)(pred, first[idx], second) && !(0, $iiRAt.default)(pred, first[idx], out)) out.push(first[idx]);
        idx += 1;
    }
    return out;
});
var $49052d190b7cf333$export$2e2bcd8739ae039 = $49052d190b7cf333$var$differenceWith;

});

parcelRegister("296j3", function(module, exports) {

var $4E2dE = parcelRequire("4E2dE");

var $cNWXH = parcelRequire("cNWXH");
/**
 * Returns a new object that does not contain a `prop` property.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category Object
 * @sig String -> {k: v} -> {k: v}
 * @param {String} prop The name of the property to dissociate
 * @param {Object} obj The object to clone
 * @return {Object} A new object equivalent to the original but without the specified property
 * @see R.assoc, R.omit
 * @example
 *
 *      R.dissoc('b', {a: 1, b: 2, c: 3}); //=> {a: 1, c: 3}
 */ var $1901505cc9e9ff6f$var$dissoc = /*#__PURE__*/ (0, $4E2dE.default)(function dissoc(prop, obj) {
    return (0, $cNWXH.default)([
        prop
    ], obj);
});
var $1901505cc9e9ff6f$export$2e2bcd8739ae039 = $1901505cc9e9ff6f$var$dissoc;

});
parcelRegister("cNWXH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9527cc397703f790$export$2e2bcd8739ae039; });

var $4E2dE = parcelRequire("4E2dE");

var $5ubTr = parcelRequire("5ubTr");

var $4uaMM = parcelRequire("4uaMM");

var $9hDA3 = parcelRequire("9hDA3");

var $bAwZa = parcelRequire("bAwZa");
/**
 * Makes a shallow clone of an object. Note that this copies and flattens
 * prototype properties onto the new object as well. All non-primitive
 * properties are copied by reference.
 *
 * @private
 * @param {String|Integer} prop The prop operating
 * @param {Object|Array} obj The object to clone
 * @return {Object|Array} A new object equivalent to the original.
 */ function $9527cc397703f790$var$_shallowCloneObject(prop, obj) {
    if ((0, $4uaMM.default)(prop) && (0, $9hDA3.default)(obj)) return [].concat(obj);
    var result = {};
    for(var p in obj)result[p] = obj[p];
    return result;
}
/**
 * Makes a shallow clone of an object, omitting the property at the given path.
 * Note that this copies and flattens prototype properties onto the new object
 * as well. All non-primitive properties are copied by reference.
 *
 * @func
 * @memberOf R
 * @since v0.11.0
 * @category Object
 * @typedefn Idx = String | Int | Symbol
 * @sig [Idx] -> {k: v} -> {k: v}
 * @param {Array} path The path to the value to omit
 * @param {Object} obj The object to clone
 * @return {Object} A new object without the property at path
 * @see R.assocPath
 * @example
 *
 *      R.dissocPath(['a', 'b', 'c'], {a: {b: {c: 42}}}); //=> {a: {b: {}}}
 */ var $9527cc397703f790$var$dissocPath = /*#__PURE__*/ (0, $4E2dE.default)(function dissocPath(path, obj) {
    if (obj == null) return obj;
    switch(path.length){
        case 0:
            return obj;
        case 1:
            return (0, $5ubTr.default)(path[0], obj);
        default:
            var head = path[0];
            var tail = Array.prototype.slice.call(path, 1);
            if (obj[head] == null) return $9527cc397703f790$var$_shallowCloneObject(head, obj);
            else return (0, $bAwZa.default)(head, dissocPath(tail, obj[head]), obj);
    }
});
var $9527cc397703f790$export$2e2bcd8739ae039 = $9527cc397703f790$var$dissocPath;

});
parcelRegister("5ubTr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3fe8fad6c349e437$export$2e2bcd8739ae039; });

var $4uaMM = parcelRequire("4uaMM");

var $9hDA3 = parcelRequire("9hDA3");

var $7o3gB = parcelRequire("7o3gB");
function $3fe8fad6c349e437$export$2e2bcd8739ae039(prop, obj) {
    if (obj == null) return obj;
    if ((0, $4uaMM.default)(prop) && (0, $9hDA3.default)(obj)) return (0, $7o3gB.default)(prop, 1, obj);
    var result = {};
    for(var p in obj)result[p] = obj[p];
    delete result[prop];
    return result;
}

});
parcelRegister("7o3gB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $560d4efc260365a1$export$2e2bcd8739ae039; });

var $cjSwl = parcelRequire("cjSwl");
/**
 * Removes the sub-list of `list` starting at index `start` and containing
 * `count` elements. _Note that this is not destructive_: it returns a copy of
 * the list with the changes.
 * <small>No lists have been harmed in the application of this function.</small>
 *
 * @func
 * @memberOf R
 * @since v0.2.2
 * @category List
 * @sig Number -> Number -> [a] -> [a]
 * @param {Number} start The position to start removing elements
 * @param {Number} count The number of elements to remove
 * @param {Array} list The list to remove from
 * @return {Array} A new Array with `count` elements from `start` removed.
 * @see R.without
 * @example
 *
 *      R.remove(2, 3, [1,2,3,4,5,6,7,8]); //=> [1,2,6,7,8]
 */ var $560d4efc260365a1$var$remove = /*#__PURE__*/ (0, $cjSwl.default)(function remove(start, count, list) {
    var result = Array.prototype.slice.call(list, 0);
    result.splice(start, count);
    return result;
});
var $560d4efc260365a1$export$2e2bcd8739ae039 = $560d4efc260365a1$var$remove;

});




parcelRegister("a3dtn", function(module, exports) {

var $4E2dE = parcelRequire("4E2dE");
/**
 * Divides two numbers. Equivalent to `a / b`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a The first value.
 * @param {Number} b The second value.
 * @return {Number} The result of `a / b`.
 * @see R.multiply
 * @example
 *
 *      R.divide(71, 100); //=> 0.71
 *
 *      const half = R.divide(R.__, 2);
 *      half(42); //=> 21
 *
 *      const reciprocal = R.divide(1);
 *      reciprocal(4);   //=> 0.25
 */ var $7514a29a50b81853$var$divide = /*#__PURE__*/ (0, $4E2dE.default)(function divide(a, b) {
    return a / b;
});
var $7514a29a50b81853$export$2e2bcd8739ae039 = $7514a29a50b81853$var$divide;

});

parcelRegister("hiSaj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c98e223bf8dbbef2$export$2e2bcd8739ae039; });

var $4E2dE = parcelRequire("4E2dE");

var $AZnlR = parcelRequire("AZnlR");

var $31Oj3 = parcelRequire("31Oj3");

var $1kRJS = parcelRequire("1kRJS");
/**
 * Returns all but the first `n` elements of the given list, string, or
 * transducer/transformer (or object with a `drop` method).
 *
 * Dispatches to the `drop` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Number -> [a] -> [a]
 * @sig Number -> String -> String
 * @param {Number} n
 * @param {*} list
 * @return {*} A copy of list without the first `n` elements
 * @see R.take, R.transduce, R.dropLast, R.dropWhile
 * @example
 *
 *      R.drop(1, ['foo', 'bar', 'baz']); //=> ['bar', 'baz']
 *      R.drop(2, ['foo', 'bar', 'baz']); //=> ['baz']
 *      R.drop(3, ['foo', 'bar', 'baz']); //=> []
 *      R.drop(4, ['foo', 'bar', 'baz']); //=> []
 *      R.drop(3, 'ramda');               //=> 'da'
 */ var $c98e223bf8dbbef2$var$drop = /*#__PURE__*/ (0, $4E2dE.default)(/*#__PURE__*/ (0, $AZnlR.default)([
    "drop"
], (0, $31Oj3.default), function drop(n, xs) {
    return (0, $1kRJS.default)(Math.max(0, n), Infinity, xs);
}));
var $c98e223bf8dbbef2$export$2e2bcd8739ae039 = $c98e223bf8dbbef2$var$drop;

});
parcelRegister("31Oj3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $23487ce0208dd27b$export$2e2bcd8739ae039; });

var $4E2dE = parcelRequire("4E2dE");

var $dki4v = parcelRequire("dki4v");
var $23487ce0208dd27b$var$XDrop = /*#__PURE__*/ function() {
    function XDrop(n, xf) {
        this.xf = xf;
        this.n = n;
    }
    XDrop.prototype["@@transducer/init"] = (0, $dki4v.default).init;
    XDrop.prototype["@@transducer/result"] = (0, $dki4v.default).result;
    XDrop.prototype["@@transducer/step"] = function(result, input) {
        if (this.n > 0) {
            this.n -= 1;
            return result;
        }
        return this.xf["@@transducer/step"](result, input);
    };
    return XDrop;
}();
var $23487ce0208dd27b$var$_xdrop = /*#__PURE__*/ (0, $4E2dE.default)(function _xdrop(n, xf) {
    return new $23487ce0208dd27b$var$XDrop(n, xf);
});
var $23487ce0208dd27b$export$2e2bcd8739ae039 = $23487ce0208dd27b$var$_xdrop;

});


parcelRegister("2UBmu", function(module, exports) {

var $4E2dE = parcelRequire("4E2dE");

var $AZnlR = parcelRequire("AZnlR");

var $aOPbY = parcelRequire("aOPbY");

var $8aLzo = parcelRequire("8aLzo");
/**
 * Returns a list containing all but the last `n` elements of the given `list`.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig Number -> [a] -> [a]
 * @sig Number -> String -> String
 * @param {Number} n The number of elements of `list` to skip.
 * @param {Array} list The list of elements to consider.
 * @return {Array} A copy of the list with only the first `list.length - n` elements
 * @see R.takeLast, R.drop, R.dropWhile, R.dropLastWhile
 * @example
 *
 *      R.dropLast(1, ['foo', 'bar', 'baz']); //=> ['foo', 'bar']
 *      R.dropLast(2, ['foo', 'bar', 'baz']); //=> ['foo']
 *      R.dropLast(3, ['foo', 'bar', 'baz']); //=> []
 *      R.dropLast(4, ['foo', 'bar', 'baz']); //=> []
 *      R.dropLast(3, 'ramda');               //=> 'ra'
 */ var $21edcaf9af7d5c5d$var$dropLast = /*#__PURE__*/ (0, $4E2dE.default)(/*#__PURE__*/ (0, $AZnlR.default)([], (0, $8aLzo.default), (0, $aOPbY.default)));
var $21edcaf9af7d5c5d$export$2e2bcd8739ae039 = $21edcaf9af7d5c5d$var$dropLast;

});
parcelRegister("aOPbY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7e064894134dc10c$export$2e2bcd8739ae039; });

var $8FDfT = parcelRequire("8FDfT");
function $7e064894134dc10c$export$2e2bcd8739ae039(n, xs) {
    return (0, $8FDfT.default)(n < xs.length ? xs.length - n : 0, xs);
}

});
parcelRegister("8FDfT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $65009a5c51ecd388$export$2e2bcd8739ae039; });

var $4E2dE = parcelRequire("4E2dE");

var $AZnlR = parcelRequire("AZnlR");

var $9gUmu = parcelRequire("9gUmu");

var $1kRJS = parcelRequire("1kRJS");
/**
 * Returns the first `n` elements of the given list, string, or
 * transducer/transformer (or object with a `take` method).
 *
 * Dispatches to the `take` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Number -> [a] -> [a]
 * @sig Number -> String -> String
 * @param {Number} n
 * @param {*} list
 * @return {*}
 * @see R.drop
 * @example
 *
 *      R.take(1, ['foo', 'bar', 'baz']); //=> ['foo']
 *      R.take(2, ['foo', 'bar', 'baz']); //=> ['foo', 'bar']
 *      R.take(3, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
 *      R.take(4, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
 *      R.take(3, 'ramda');               //=> 'ram'
 *
 *      const personnel = [
 *        'Dave Brubeck',
 *        'Paul Desmond',
 *        'Eugene Wright',
 *        'Joe Morello',
 *        'Gerry Mulligan',
 *        'Bob Bates',
 *        'Joe Dodge',
 *        'Ron Crotty'
 *      ];
 *
 *      const takeFive = R.take(5);
 *      takeFive(personnel);
 *      //=> ['Dave Brubeck', 'Paul Desmond', 'Eugene Wright', 'Joe Morello', 'Gerry Mulligan']
 * @symb R.take(-1, [a, b]) = [a, b]
 * @symb R.take(0, [a, b]) = []
 * @symb R.take(1, [a, b]) = [a]
 * @symb R.take(2, [a, b]) = [a, b]
 */ var $65009a5c51ecd388$var$take = /*#__PURE__*/ (0, $4E2dE.default)(/*#__PURE__*/ (0, $AZnlR.default)([
    "take"
], (0, $9gUmu.default), function take(n, xs) {
    return (0, $1kRJS.default)(0, n < 0 ? Infinity : n, xs);
}));
var $65009a5c51ecd388$export$2e2bcd8739ae039 = $65009a5c51ecd388$var$take;

});
parcelRegister("9gUmu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6c0153f12f0e8efc$export$2e2bcd8739ae039; });

var $4E2dE = parcelRequire("4E2dE");

var $1OnxV = parcelRequire("1OnxV");

var $dki4v = parcelRequire("dki4v");
var $6c0153f12f0e8efc$var$XTake = /*#__PURE__*/ function() {
    function XTake(n, xf) {
        this.xf = xf;
        this.n = n;
        this.i = 0;
    }
    XTake.prototype["@@transducer/init"] = (0, $dki4v.default).init;
    XTake.prototype["@@transducer/result"] = (0, $dki4v.default).result;
    XTake.prototype["@@transducer/step"] = function(result, input) {
        this.i += 1;
        var ret = this.n === 0 ? result : this.xf["@@transducer/step"](result, input);
        return this.n >= 0 && this.i >= this.n ? (0, $1OnxV.default)(ret) : ret;
    };
    return XTake;
}();
var $6c0153f12f0e8efc$var$_xtake = /*#__PURE__*/ (0, $4E2dE.default)(function _xtake(n, xf) {
    return new $6c0153f12f0e8efc$var$XTake(n, xf);
});
var $6c0153f12f0e8efc$export$2e2bcd8739ae039 = $6c0153f12f0e8efc$var$_xtake;

});



parcelRegister("8aLzo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5f34284ba803358a$export$2e2bcd8739ae039; });

var $4E2dE = parcelRequire("4E2dE");

var $dki4v = parcelRequire("dki4v");
var $5f34284ba803358a$var$XDropLast = /*#__PURE__*/ function() {
    function XDropLast(n, xf) {
        this.xf = xf;
        this.pos = 0;
        this.full = false;
        this.acc = new Array(n);
    }
    XDropLast.prototype["@@transducer/init"] = (0, $dki4v.default).init;
    XDropLast.prototype["@@transducer/result"] = function(result) {
        this.acc = null;
        return this.xf["@@transducer/result"](result);
    };
    XDropLast.prototype["@@transducer/step"] = function(result, input) {
        if (this.full) result = this.xf["@@transducer/step"](result, this.acc[this.pos]);
        this.store(input);
        return result;
    };
    XDropLast.prototype.store = function(input) {
        this.acc[this.pos] = input;
        this.pos += 1;
        if (this.pos === this.acc.length) {
            this.pos = 0;
            this.full = true;
        }
    };
    return XDropLast;
}();
var $5f34284ba803358a$var$_xdropLast = /*#__PURE__*/ (0, $4E2dE.default)(function _xdropLast(n, xf) {
    return new $5f34284ba803358a$var$XDropLast(n, xf);
});
var $5f34284ba803358a$export$2e2bcd8739ae039 = $5f34284ba803358a$var$_xdropLast;

});


parcelRegister("9eTfQ", function(module, exports) {

var $4E2dE = parcelRequire("4E2dE");

var $AZnlR = parcelRequire("AZnlR");

var $a0lr7 = parcelRequire("a0lr7");

var $hh8Z7 = parcelRequire("hh8Z7");
/**
 * Returns a new list excluding all the tailing elements of a given list which
 * satisfy the supplied predicate function. It passes each value from the right
 * to the supplied predicate function, skipping elements until the predicate
 * function returns a `falsy` value. The predicate function is applied to one argument:
 * *(value)*.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> [a]
 * @sig (a -> Boolean) -> String -> String
 * @param {Function} predicate The function to be called on each element
 * @param {Array} xs The collection to iterate over.
 * @return {Array} A new array without any trailing elements that return `falsy` values from the `predicate`.
 * @see R.takeLastWhile, R.addIndex, R.drop, R.dropWhile
 * @example
 *
 *      const lteThree = x => x <= 3;
 *
 *      R.dropLastWhile(lteThree, [1, 2, 3, 4, 3, 2, 1]); //=> [1, 2, 3, 4]
 *
 *      R.dropLastWhile(x => x !== 'd' , 'Ramda'); //=> 'Ramd'
 */ var $6ba0484983646db1$var$dropLastWhile = /*#__PURE__*/ (0, $4E2dE.default)(/*#__PURE__*/ (0, $AZnlR.default)([], (0, $hh8Z7.default), (0, $a0lr7.default)));
var $6ba0484983646db1$export$2e2bcd8739ae039 = $6ba0484983646db1$var$dropLastWhile;

});
parcelRegister("a0lr7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $748a884d3fc50b35$export$2e2bcd8739ae039; });

var $1kRJS = parcelRequire("1kRJS");
function $748a884d3fc50b35$export$2e2bcd8739ae039(pred, xs) {
    var idx = xs.length - 1;
    while(idx >= 0 && pred(xs[idx]))idx -= 1;
    return (0, $1kRJS.default)(0, idx + 1, xs);
}

});

parcelRegister("hh8Z7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c93afe682fe9c110$export$2e2bcd8739ae039; });

var $4E2dE = parcelRequire("4E2dE");

var $jdcIJ = parcelRequire("jdcIJ");

var $dki4v = parcelRequire("dki4v");
var $c93afe682fe9c110$var$XDropLastWhile = /*#__PURE__*/ function() {
    function XDropLastWhile(fn, xf) {
        this.f = fn;
        this.retained = [];
        this.xf = xf;
    }
    XDropLastWhile.prototype["@@transducer/init"] = (0, $dki4v.default).init;
    XDropLastWhile.prototype["@@transducer/result"] = function(result) {
        this.retained = null;
        return this.xf["@@transducer/result"](result);
    };
    XDropLastWhile.prototype["@@transducer/step"] = function(result, input) {
        return this.f(input) ? this.retain(result, input) : this.flush(result, input);
    };
    XDropLastWhile.prototype.flush = function(result, input) {
        result = (0, $jdcIJ.default)(this.xf["@@transducer/step"], result, this.retained);
        this.retained = [];
        return this.xf["@@transducer/step"](result, input);
    };
    XDropLastWhile.prototype.retain = function(result, input) {
        this.retained.push(input);
        return result;
    };
    return XDropLastWhile;
}();
var $c93afe682fe9c110$var$_xdropLastWhile = /*#__PURE__*/ (0, $4E2dE.default)(function _xdropLastWhile(fn, xf) {
    return new $c93afe682fe9c110$var$XDropLastWhile(fn, xf);
});
var $c93afe682fe9c110$export$2e2bcd8739ae039 = $c93afe682fe9c110$var$_xdropLastWhile;

});


parcelRegister("f38Lf", function(module, exports) {

var $lrIA4 = parcelRequire("lrIA4");

var $AZnlR = parcelRequire("AZnlR");

var $gwkbx = parcelRequire("gwkbx");

var $17lCb = parcelRequire("17lCb");

var $imwRL = parcelRequire("imwRL");
/**
 * Returns a new list without any consecutively repeating elements.
 * [`R.equals`](#equals) is used to determine equality.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig [a] -> [a]
 * @param {Array} list The array to consider.
 * @return {Array} `list` without repeating elements.
 * @see R.transduce
 * @example
 *
 *     R.dropRepeats([1, 1, 1, 2, 3, 4, 4, 2, 2]); //=> [1, 2, 3, 4, 2]
 */ var $af4dee99eaf19a88$var$dropRepeats = /*#__PURE__*/ (0, $lrIA4.default)(/*#__PURE__*/ (0, $AZnlR.default)([], /*#__PURE__*/ (0, $gwkbx.default)((0, $imwRL.default)), /*#__PURE__*/ (0, $17lCb.default)((0, $imwRL.default))));
var $af4dee99eaf19a88$export$2e2bcd8739ae039 = $af4dee99eaf19a88$var$dropRepeats;

});
parcelRegister("gwkbx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c06f4add83c1c13a$export$2e2bcd8739ae039; });

var $4E2dE = parcelRequire("4E2dE");

var $dki4v = parcelRequire("dki4v");
var $c06f4add83c1c13a$var$XDropRepeatsWith = /*#__PURE__*/ function() {
    function XDropRepeatsWith(pred, xf) {
        this.xf = xf;
        this.pred = pred;
        this.lastValue = undefined;
        this.seenFirstValue = false;
    }
    XDropRepeatsWith.prototype["@@transducer/init"] = (0, $dki4v.default).init;
    XDropRepeatsWith.prototype["@@transducer/result"] = (0, $dki4v.default).result;
    XDropRepeatsWith.prototype["@@transducer/step"] = function(result, input) {
        var sameAsLast = false;
        if (!this.seenFirstValue) this.seenFirstValue = true;
        else if (this.pred(this.lastValue, input)) sameAsLast = true;
        this.lastValue = input;
        return sameAsLast ? result : this.xf["@@transducer/step"](result, input);
    };
    return XDropRepeatsWith;
}();
var $c06f4add83c1c13a$var$_xdropRepeatsWith = /*#__PURE__*/ (0, $4E2dE.default)(function _xdropRepeatsWith(pred, xf) {
    return new $c06f4add83c1c13a$var$XDropRepeatsWith(pred, xf);
});
var $c06f4add83c1c13a$export$2e2bcd8739ae039 = $c06f4add83c1c13a$var$_xdropRepeatsWith;

});

parcelRegister("17lCb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0d073628bc785b7d$export$2e2bcd8739ae039; });

var $4E2dE = parcelRequire("4E2dE");

var $AZnlR = parcelRequire("AZnlR");

var $gwkbx = parcelRequire("gwkbx");

var $jkKjk = parcelRequire("jkKjk");
/**
 * Returns a new list without any consecutively repeating elements. Equality is
 * determined by applying the supplied predicate to each pair of consecutive elements. The
 * first element in a series of equal elements will be preserved.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig ((a, a) -> Boolean) -> [a] -> [a]
 * @param {Function} pred A predicate used to test whether two items are equal.
 * @param {Array} list The array to consider.
 * @return {Array} `list` without repeating elements.
 * @see R.transduce
 * @example
 *
 *      const l = [1, -1, 1, 3, 4, -4, -4, -5, 5, 3, 3];
 *      R.dropRepeatsWith(R.eqBy(Math.abs), l); //=> [1, 3, 4, -5, 3]
 */ var $0d073628bc785b7d$var$dropRepeatsWith = /*#__PURE__*/ (0, $4E2dE.default)(/*#__PURE__*/ (0, $AZnlR.default)([], (0, $gwkbx.default), function dropRepeatsWith(pred, list) {
    var result = [];
    var idx = 1;
    var len = list.length;
    if (len !== 0) {
        result[0] = list[0];
        while(idx < len){
            if (!pred((0, $jkKjk.default)(result), list[idx])) result[result.length] = list[idx];
            idx += 1;
        }
    }
    return result;
}));
var $0d073628bc785b7d$export$2e2bcd8739ae039 = $0d073628bc785b7d$var$dropRepeatsWith;

});
parcelRegister("jkKjk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e133cee9211fa497$export$2e2bcd8739ae039; });

var $7aHtE = parcelRequire("7aHtE");
/**
 * Returns the last element of the given list or string.
 *
 * @func
 * @memberOf R
 * @since v0.1.4
 * @category List
 * @sig [a] -> a | Undefined
 * @sig String -> String
 * @param {*} list
 * @return {*}
 * @see R.init, R.head, R.tail
 * @example
 *
 *      R.last(['fi', 'fo', 'fum']); //=> 'fum'
 *      R.last([]); //=> undefined
 *
 *      R.last('abc'); //=> 'c'
 *      R.last(''); //=> ''
 */ var $e133cee9211fa497$var$last = /*#__PURE__*/ (0, $7aHtE.default)(-1);
var $e133cee9211fa497$export$2e2bcd8739ae039 = $e133cee9211fa497$var$last;

});



parcelRegister("2YF0S", function(module, exports) {

var $4E2dE = parcelRequire("4E2dE");

var $AZnlR = parcelRequire("AZnlR");

var $f4RO0 = parcelRequire("f4RO0");

var $1kRJS = parcelRequire("1kRJS");
/**
 * Returns a new list excluding the leading elements of a given list which
 * satisfy the supplied predicate function. It passes each value to the supplied
 * predicate function, skipping elements while the predicate function returns
 * `true`. The predicate function is applied to one argument: *(value)*.
 *
 * Dispatches to the `dropWhile` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> [a]
 * @sig (a -> Boolean) -> String -> String
 * @param {Function} fn The function called per iteration.
 * @param {Array} xs The collection to iterate over.
 * @return {Array} A new array.
 * @see R.takeWhile, R.transduce, R.addIndex
 * @example
 *
 *      const lteTwo = x => x <= 2;
 *
 *      R.dropWhile(lteTwo, [1, 2, 3, 4, 3, 2, 1]); //=> [3, 4, 3, 2, 1]
 *
 *      R.dropWhile(x => x !== 'd' , 'Ramda'); //=> 'da'
 */ var $22b0ffb982ea85cc$var$dropWhile = /*#__PURE__*/ (0, $4E2dE.default)(/*#__PURE__*/ (0, $AZnlR.default)([
    "dropWhile"
], (0, $f4RO0.default), function dropWhile(pred, xs) {
    var idx = 0;
    var len = xs.length;
    while(idx < len && pred(xs[idx]))idx += 1;
    return (0, $1kRJS.default)(idx, Infinity, xs);
}));
var $22b0ffb982ea85cc$export$2e2bcd8739ae039 = $22b0ffb982ea85cc$var$dropWhile;

});
parcelRegister("f4RO0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $afa0f76b8057f0d9$export$2e2bcd8739ae039; });

var $4E2dE = parcelRequire("4E2dE");

var $dki4v = parcelRequire("dki4v");
var $afa0f76b8057f0d9$var$XDropWhile = /*#__PURE__*/ function() {
    function XDropWhile(f, xf) {
        this.xf = xf;
        this.f = f;
    }
    XDropWhile.prototype["@@transducer/init"] = (0, $dki4v.default).init;
    XDropWhile.prototype["@@transducer/result"] = (0, $dki4v.default).result;
    XDropWhile.prototype["@@transducer/step"] = function(result, input) {
        if (this.f) {
            if (this.f(input)) return result;
            this.f = null;
        }
        return this.xf["@@transducer/step"](result, input);
    };
    return XDropWhile;
}();
var $afa0f76b8057f0d9$var$_xdropWhile = /*#__PURE__*/ (0, $4E2dE.default)(function _xdropWhile(f, xf) {
    return new $afa0f76b8057f0d9$var$XDropWhile(f, xf);
});
var $afa0f76b8057f0d9$export$2e2bcd8739ae039 = $afa0f76b8057f0d9$var$_xdropWhile;

});


parcelRegister("7yOkz", function(module, exports) {

var $4E2dE = parcelRequire("4E2dE");

var $aizOG = parcelRequire("aizOG");

var $3Jc8c = parcelRequire("3Jc8c");

var $9fOQE = parcelRequire("9fOQE");
/**
 * A function wrapping calls to the two functions in an `||` operation,
 * returning the result of the first function if it is truth-y and the result
 * of the second function otherwise. Note that this is short-circuited,
 * meaning that the second function will not be invoked if the first returns a
 * truth-y value.
 *
 * In addition to functions, `R.either` also accepts any fantasy-land compatible
 * applicative functor.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category Logic
 * @sig (*... -> Boolean) -> (*... -> Boolean) -> (*... -> Boolean)
 * @param {Function} f a predicate
 * @param {Function} g another predicate
 * @return {Function} a function that applies its arguments to `f` and `g` and `||`s their outputs together.
 * @see R.both, R.or
 * @example
 *
 *      const gt10 = x => x > 10;
 *      const even = x => x % 2 === 0;
 *      const f = R.either(gt10, even);
 *      f(101); //=> true
 *      f(8); //=> true
 *
 *      R.either(Maybe.Just(false), Maybe.Just(55)); // => Maybe.Just(55)
 *      R.either([false, false, 'a'], [11]) // => [11, 11, "a"]
 */ var $5812c005bf011e97$var$either = /*#__PURE__*/ (0, $4E2dE.default)(function either(f, g) {
    return (0, $aizOG.default)(f) ? function _either() {
        return f.apply(this, arguments) || g.apply(this, arguments);
    } : (0, $3Jc8c.default)((0, $9fOQE.default))(f, g);
});
var $5812c005bf011e97$export$2e2bcd8739ae039 = $5812c005bf011e97$var$either;

});
parcelRegister("9fOQE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6bccf530b0222fa6$export$2e2bcd8739ae039; });

var $4E2dE = parcelRequire("4E2dE");
/**
 * Returns the first argument if it is truthy, otherwise the second argument.
 * Acts as the boolean `or` statement if both inputs are `Boolean`s.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Logic
 * @sig a -> b -> a | b
 * @param {Any} a
 * @param {Any} b
 * @return {Any}
 * @see R.either, R.and
 * @example
 *
 *      R.or(true, true); //=> true
 *      R.or(true, false); //=> true
 *      R.or(false, true); //=> true
 *      R.or(false, false); //=> false
 */ var $6bccf530b0222fa6$var$or = /*#__PURE__*/ (0, $4E2dE.default)(function or(a, b) {
    return a || b;
});
var $6bccf530b0222fa6$export$2e2bcd8739ae039 = $6bccf530b0222fa6$var$or;

});


parcelRegister("b5mg2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $81216d411edceb1c$export$2e2bcd8739ae039; });

var $lrIA4 = parcelRequire("lrIA4");

var $gOmmY = parcelRequire("gOmmY");

var $9hDA3 = parcelRequire("9hDA3");

var $fGe1Y = parcelRequire("fGe1Y");

var $ij2HL = parcelRequire("ij2HL");

var $8vScg = parcelRequire("8vScg");
/**
 * Returns the empty value of its argument's type. Ramda defines the empty
 * value of Array (`[]`), Object (`{}`), String (`''`),
 * TypedArray (`Uint8Array []`, `Float32Array []`, etc), and Arguments. Other
 * types are supported if they define `<Type>.empty`,
 * `<Type>.prototype.empty` or implement the
 * [FantasyLand Monoid spec](https://github.com/fantasyland/fantasy-land#monoid).
 *
 * Dispatches to the `empty` method of the first argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Function
 * @sig a -> a
 * @param {*} x
 * @return {*}
 * @example
 *
 *      R.empty(Just(42));               //=> Nothing()
 *      R.empty([1, 2, 3]);              //=> []
 *      R.empty('unicorns');             //=> ''
 *      R.empty({x: 1, y: 2});           //=> {}
 *      R.empty(Uint8Array.from('123')); //=> Uint8Array []
 */ var $81216d411edceb1c$var$empty = /*#__PURE__*/ (0, $lrIA4.default)(function empty(x) {
    return x != null && typeof x["fantasy-land/empty"] === "function" ? x["fantasy-land/empty"]() : x != null && x.constructor != null && typeof x.constructor["fantasy-land/empty"] === "function" ? x.constructor["fantasy-land/empty"]() : x != null && typeof x.empty === "function" ? x.empty() : x != null && x.constructor != null && typeof x.constructor.empty === "function" ? x.constructor.empty() : (0, $9hDA3.default)(x) ? [] : (0, $ij2HL.default)(x) ? "" : (0, $fGe1Y.default)(x) ? {} : (0, $gOmmY.default)(x) ? function() {
        return arguments;
    }() : (0, $8vScg.default)(x) ? x.constructor.from("") : void 0 // else
    ;
});
var $81216d411edceb1c$export$2e2bcd8739ae039 = $81216d411edceb1c$var$empty;

});
parcelRegister("8vScg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $632b4257643ea372$export$2e2bcd8739ae039; });
/**
 * Tests whether or not an object is a typed array.
 *
 * @private
 * @param {*} val The object to test.
 * @return {Boolean} `true` if `val` is a typed array, `false` otherwise.
 * @example
 *
 *      _isTypedArray(new Uint8Array([])); //=> true
 *      _isTypedArray(new Float32Array([])); //=> true
 *      _isTypedArray([]); //=> false
 *      _isTypedArray(null); //=> false
 *      _isTypedArray({}); //=> false
 */ function $632b4257643ea372$export$2e2bcd8739ae039(val) {
    var type = Object.prototype.toString.call(val);
    return type === "[object Uint8ClampedArray]" || type === "[object Int8Array]" || type === "[object Uint8Array]" || type === "[object Int16Array]" || type === "[object Uint16Array]" || type === "[object Int32Array]" || type === "[object Uint32Array]" || type === "[object Float32Array]" || type === "[object Float64Array]" || type === "[object BigInt64Array]" || type === "[object BigUint64Array]";
}

});


parcelRegister("23Ma3", function(module, exports) {

var $4E2dE = parcelRequire("4E2dE");

var $imwRL = parcelRequire("imwRL");

var $ib5ss = parcelRequire("ib5ss");
/**
 * Checks if a list ends with the provided sublist.
 *
 * Similarly, checks if a string ends with the provided substring.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category List
 * @sig [a] -> [a] -> Boolean
 * @sig String -> String -> Boolean
 * @param {*} suffix
 * @param {*} list
 * @return {Boolean}
 * @see R.startsWith
 * @example
 *
 *      R.endsWith('c', 'abc')                //=> true
 *      R.endsWith('b', 'abc')                //=> false
 *      R.endsWith(['c'], ['a', 'b', 'c'])    //=> true
 *      R.endsWith(['b'], ['a', 'b', 'c'])    //=> false
 */ var $18013869559422e3$var$endsWith = /*#__PURE__*/ (0, $4E2dE.default)(function(suffix, list) {
    return (0, $imwRL.default)((0, $ib5ss.default)(suffix.length, list), suffix);
});
var $18013869559422e3$export$2e2bcd8739ae039 = $18013869559422e3$var$endsWith;

});
parcelRegister("ib5ss", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d3bd7ceac4f5478a$export$2e2bcd8739ae039; });

var $4E2dE = parcelRequire("4E2dE");

var $hiSaj = parcelRequire("hiSaj");
/**
 * Returns a new list containing the last `n` elements of the given list.
 * If `n > list.length`, returns a list of `list.length` elements.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig Number -> [a] -> [a]
 * @sig Number -> String -> String
 * @param {Number} n The number of elements to return.
 * @param {Array} xs The collection to consider.
 * @return {Array}
 * @see R.dropLast
 * @example
 *
 *      R.takeLast(1, ['foo', 'bar', 'baz']); //=> ['baz']
 *      R.takeLast(2, ['foo', 'bar', 'baz']); //=> ['bar', 'baz']
 *      R.takeLast(3, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
 *      R.takeLast(4, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
 *      R.takeLast(3, 'ramda');               //=> 'mda'
 */ var $d3bd7ceac4f5478a$var$takeLast = /*#__PURE__*/ (0, $4E2dE.default)(function takeLast(n, xs) {
    return (0, $hiSaj.default)(n >= 0 ? xs.length - n : 0, xs);
});
var $d3bd7ceac4f5478a$export$2e2bcd8739ae039 = $d3bd7ceac4f5478a$var$takeLast;

});


parcelRegister("kdTlC", function(module, exports) {

var $cjSwl = parcelRequire("cjSwl");

var $imwRL = parcelRequire("imwRL");
/**
 * Takes a function and two values in its domain and returns `true` if the
 * values map to the same value in the codomain; `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category Relation
 * @sig (a -> b) -> a -> a -> Boolean
 * @param {Function} f
 * @param {*} x
 * @param {*} y
 * @return {Boolean}
 * @example
 *
 *      R.eqBy(Math.abs, 5, -5); //=> true
 */ var $03cca4f97cfc3a32$var$eqBy = /*#__PURE__*/ (0, $cjSwl.default)(function eqBy(f, x, y) {
    return (0, $imwRL.default)(f(x), f(y));
});
var $03cca4f97cfc3a32$export$2e2bcd8739ae039 = $03cca4f97cfc3a32$var$eqBy;

});

parcelRegister("jYPez", function(module, exports) {

var $cjSwl = parcelRequire("cjSwl");

var $imwRL = parcelRequire("imwRL");
/**
 * Reports whether two objects have the same value, in [`R.equals`](#equals)
 * terms, for the specified property. Useful as a curried predicate.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig k -> {k: v} -> {k: v} -> Boolean
 * @param {String} prop The name of the property to compare
 * @param {Object} obj1
 * @param {Object} obj2
 * @return {Boolean}
 *
 * @example
 *
 *      const o1 = { a: 1, b: 2, c: 3, d: 4 };
 *      const o2 = { a: 10, b: 20, c: 3, d: 40 };
 *      R.eqProps('a', o1, o2); //=> false
 *      R.eqProps('c', o1, o2); //=> true
 */ var $e8bb5cef26728387$var$eqProps = /*#__PURE__*/ (0, $cjSwl.default)(function eqProps(prop, obj1, obj2) {
    return (0, $imwRL.default)(obj1[prop], obj2[prop]);
});
var $e8bb5cef26728387$export$2e2bcd8739ae039 = $e8bb5cef26728387$var$eqProps;

});

parcelRegister("c1q0D", function(module, exports) {

var $4E2dE = parcelRequire("4E2dE");

var $9hDA3 = parcelRequire("9hDA3");

var $fGe1Y = parcelRequire("fGe1Y");
/**
 * Creates a new object by recursively evolving a shallow copy of `object`,
 * according to the `transformation` functions. All non-primitive properties
 * are copied by reference.
 *
 * A `transformation` function will not be invoked if its corresponding key
 * does not exist in the evolved object.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Object
 * @sig {k: (v -> v)} -> {k: v} -> {k: v}
 * @param {Object} transformations The object specifying transformation functions to apply
 *        to the object.
 * @param {Object} object The object to be transformed.
 * @return {Object} The transformed object.
 * @example
 *
 *      const tomato = {firstName: '  Tomato ', data: {elapsed: 100, remaining: 1400}, id:123};
 *      const transformations = {
 *        firstName: R.trim,
 *        lastName: R.trim, // Will not get invoked.
 *        data: {elapsed: R.add(1), remaining: R.add(-1)}
 *      };
 *      R.evolve(transformations, tomato); //=> {firstName: 'Tomato', data: {elapsed: 101, remaining: 1399}, id:123}
 */ var $8c09c0e9d294662c$var$evolve = /*#__PURE__*/ (0, $4E2dE.default)(function evolve(transformations, object) {
    if (!(0, $fGe1Y.default)(object) && !(0, $9hDA3.default)(object)) return object;
    var result = object instanceof Array ? [] : {};
    var transformation, key, type;
    for(key in object){
        transformation = transformations[key];
        type = typeof transformation;
        result[key] = type === "function" ? transformation(object[key]) : transformation && type === "object" ? evolve(transformation, object[key]) : object[key];
    }
    return result;
});
var $8c09c0e9d294662c$export$2e2bcd8739ae039 = $8c09c0e9d294662c$var$evolve;

});

parcelRegister("4VOHs", function(module, exports) {

var $4E2dE = parcelRequire("4E2dE");

var $AZnlR = parcelRequire("AZnlR");

var $6jMqx = parcelRequire("6jMqx");
/**
 * Returns the first element of the list which matches the predicate, or
 * `undefined` if no element matches.
 *
 * Dispatches to the `find` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> a | undefined
 * @param {Function} fn The predicate function used to determine if the element is the
 *        desired one.
 * @param {Array} list The array to consider.
 * @return {Object} The element found, or `undefined`.
 * @see R.transduce
 * @example
 *
 *      const xs = [{a: 1}, {a: 2}, {a: 3}];
 *      R.find(R.propEq('a', 2))(xs); //=> {a: 2}
 *      R.find(R.propEq('a', 4))(xs); //=> undefined
 */ var $3973d043eb2a334b$var$find = /*#__PURE__*/ (0, $4E2dE.default)(/*#__PURE__*/ (0, $AZnlR.default)([
    "find"
], (0, $6jMqx.default), function find(fn, list) {
    var idx = 0;
    var len = list.length;
    while(idx < len){
        if (fn(list[idx])) return list[idx];
        idx += 1;
    }
}));
var $3973d043eb2a334b$export$2e2bcd8739ae039 = $3973d043eb2a334b$var$find;

});
parcelRegister("6jMqx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $499a1507343e457f$export$2e2bcd8739ae039; });

var $4E2dE = parcelRequire("4E2dE");

var $1OnxV = parcelRequire("1OnxV");

var $dki4v = parcelRequire("dki4v");
var $499a1507343e457f$var$XFind = /*#__PURE__*/ function() {
    function XFind(f, xf) {
        this.xf = xf;
        this.f = f;
        this.found = false;
    }
    XFind.prototype["@@transducer/init"] = (0, $dki4v.default).init;
    XFind.prototype["@@transducer/result"] = function(result) {
        if (!this.found) result = this.xf["@@transducer/step"](result, void 0);
        return this.xf["@@transducer/result"](result);
    };
    XFind.prototype["@@transducer/step"] = function(result, input) {
        if (this.f(input)) {
            this.found = true;
            result = (0, $1OnxV.default)(this.xf["@@transducer/step"](result, input));
        }
        return result;
    };
    return XFind;
}();
var $499a1507343e457f$var$_xfind = /*#__PURE__*/ (0, $4E2dE.default)(function _xfind(f, xf) {
    return new $499a1507343e457f$var$XFind(f, xf);
});
var $499a1507343e457f$export$2e2bcd8739ae039 = $499a1507343e457f$var$_xfind;

});


parcelRegister("iMzRV", function(module, exports) {

var $4E2dE = parcelRequire("4E2dE");

var $AZnlR = parcelRequire("AZnlR");

var $gaiSK = parcelRequire("gaiSK");
/**
 * Returns the index of the first element of the list which matches the
 * predicate, or `-1` if no element matches.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category List
 * @sig (a -> Boolean) -> [a] -> Number
 * @param {Function} fn The predicate function used to determine if the element is the
 * desired one.
 * @param {Array} list The array to consider.
 * @return {Number} The index of the element found, or `-1`.
 * @see R.transduce, R.indexOf
 * @example
 *
 *      const xs = [{a: 1}, {a: 2}, {a: 3}];
 *      R.findIndex(R.propEq('a', 2))(xs); //=> 1
 *      R.findIndex(R.propEq('a', 4))(xs); //=> -1
 */ var $dac88880b9319841$var$findIndex = /*#__PURE__*/ (0, $4E2dE.default)(/*#__PURE__*/ (0, $AZnlR.default)([], (0, $gaiSK.default), function findIndex(fn, list) {
    var idx = 0;
    var len = list.length;
    while(idx < len){
        if (fn(list[idx])) return idx;
        idx += 1;
    }
    return -1;
}));
var $dac88880b9319841$export$2e2bcd8739ae039 = $dac88880b9319841$var$findIndex;

});
parcelRegister("gaiSK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bc4c3a1df0677e1a$export$2e2bcd8739ae039; });

var $4E2dE = parcelRequire("4E2dE");

var $1OnxV = parcelRequire("1OnxV");

var $dki4v = parcelRequire("dki4v");
var $bc4c3a1df0677e1a$var$XFindIndex = /*#__PURE__*/ function() {
    function XFindIndex(f, xf) {
        this.xf = xf;
        this.f = f;
        this.idx = -1;
        this.found = false;
    }
    XFindIndex.prototype["@@transducer/init"] = (0, $dki4v.default).init;
    XFindIndex.prototype["@@transducer/result"] = function(result) {
        if (!this.found) result = this.xf["@@transducer/step"](result, -1);
        return this.xf["@@transducer/result"](result);
    };
    XFindIndex.prototype["@@transducer/step"] = function(result, input) {
        this.idx += 1;
        if (this.f(input)) {
            this.found = true;
            result = (0, $1OnxV.default)(this.xf["@@transducer/step"](result, this.idx));
        }
        return result;
    };
    return XFindIndex;
}();
var $bc4c3a1df0677e1a$var$_xfindIndex = /*#__PURE__*/ (0, $4E2dE.default)(function _xfindIndex(f, xf) {
    return new $bc4c3a1df0677e1a$var$XFindIndex(f, xf);
});
var $bc4c3a1df0677e1a$export$2e2bcd8739ae039 = $bc4c3a1df0677e1a$var$_xfindIndex;

});


parcelRegister("32oB6", function(module, exports) {

var $4E2dE = parcelRequire("4E2dE");

var $AZnlR = parcelRequire("AZnlR");

var $dtxLV = parcelRequire("dtxLV");
/**
 * Returns the last element of the list which matches the predicate, or
 * `undefined` if no element matches.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category List
 * @sig (a -> Boolean) -> [a] -> a | undefined
 * @param {Function} fn The predicate function used to determine if the element is the
 * desired one.
 * @param {Array} list The array to consider.
 * @return {Object} The element found, or `undefined`.
 * @see R.transduce
 * @example
 *
 *      const xs = [{a: 1, b: 0}, {a:1, b: 1}];
 *      R.findLast(R.propEq('a', 1))(xs); //=> {a: 1, b: 1}
 *      R.findLast(R.propEq('a', 4))(xs); //=> undefined
 */ var $2364a38d1d4d21e5$var$findLast = /*#__PURE__*/ (0, $4E2dE.default)(/*#__PURE__*/ (0, $AZnlR.default)([], (0, $dtxLV.default), function findLast(fn, list) {
    var idx = list.length - 1;
    while(idx >= 0){
        if (fn(list[idx])) return list[idx];
        idx -= 1;
    }
}));
var $2364a38d1d4d21e5$export$2e2bcd8739ae039 = $2364a38d1d4d21e5$var$findLast;

});
parcelRegister("dtxLV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9cf82e327a51470c$export$2e2bcd8739ae039; });

var $4E2dE = parcelRequire("4E2dE");

var $dki4v = parcelRequire("dki4v");
var $9cf82e327a51470c$var$XFindLast = /*#__PURE__*/ function() {
    function XFindLast(f, xf) {
        this.xf = xf;
        this.f = f;
    }
    XFindLast.prototype["@@transducer/init"] = (0, $dki4v.default).init;
    XFindLast.prototype["@@transducer/result"] = function(result) {
        return this.xf["@@transducer/result"](this.xf["@@transducer/step"](result, this.last));
    };
    XFindLast.prototype["@@transducer/step"] = function(result, input) {
        if (this.f(input)) this.last = input;
        return result;
    };
    return XFindLast;
}();
var $9cf82e327a51470c$var$_xfindLast = /*#__PURE__*/ (0, $4E2dE.default)(function _xfindLast(f, xf) {
    return new $9cf82e327a51470c$var$XFindLast(f, xf);
});
var $9cf82e327a51470c$export$2e2bcd8739ae039 = $9cf82e327a51470c$var$_xfindLast;

});


parcelRegister("1WHbP", function(module, exports) {

var $4E2dE = parcelRequire("4E2dE");

var $AZnlR = parcelRequire("AZnlR");

var $c0OX7 = parcelRequire("c0OX7");
/**
 * Returns the index of the last element of the list which matches the
 * predicate, or `-1` if no element matches.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category List
 * @sig (a -> Boolean) -> [a] -> Number
 * @param {Function} fn The predicate function used to determine if the element is the
 * desired one.
 * @param {Array} list The array to consider.
 * @return {Number} The index of the element found, or `-1`.
 * @see R.transduce, R.lastIndexOf
 * @example
 *
 *      const xs = [{a: 1, b: 0}, {a:1, b: 1}];
 *      R.findLastIndex(R.propEq('a', 1))(xs); //=> 1
 *      R.findLastIndex(R.propEq('a', 4))(xs); //=> -1
 */ var $16acb5ce93c42c5a$var$findLastIndex = /*#__PURE__*/ (0, $4E2dE.default)(/*#__PURE__*/ (0, $AZnlR.default)([], (0, $c0OX7.default), function findLastIndex(fn, list) {
    var idx = list.length - 1;
    while(idx >= 0){
        if (fn(list[idx])) return idx;
        idx -= 1;
    }
    return -1;
}));
var $16acb5ce93c42c5a$export$2e2bcd8739ae039 = $16acb5ce93c42c5a$var$findLastIndex;

});
parcelRegister("c0OX7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8bed02378a7a810c$export$2e2bcd8739ae039; });

var $4E2dE = parcelRequire("4E2dE");

var $dki4v = parcelRequire("dki4v");
var $8bed02378a7a810c$var$XFindLastIndex = /*#__PURE__*/ function() {
    function XFindLastIndex(f, xf) {
        this.xf = xf;
        this.f = f;
        this.idx = -1;
        this.lastIdx = -1;
    }
    XFindLastIndex.prototype["@@transducer/init"] = (0, $dki4v.default).init;
    XFindLastIndex.prototype["@@transducer/result"] = function(result) {
        return this.xf["@@transducer/result"](this.xf["@@transducer/step"](result, this.lastIdx));
    };
    XFindLastIndex.prototype["@@transducer/step"] = function(result, input) {
        this.idx += 1;
        if (this.f(input)) this.lastIdx = this.idx;
        return result;
    };
    return XFindLastIndex;
}();
var $8bed02378a7a810c$var$_xfindLastIndex = /*#__PURE__*/ (0, $4E2dE.default)(function _xfindLastIndex(f, xf) {
    return new $8bed02378a7a810c$var$XFindLastIndex(f, xf);
});
var $8bed02378a7a810c$export$2e2bcd8739ae039 = $8bed02378a7a810c$var$_xfindLastIndex;

});


parcelRegister("j2hqt", function(module, exports) {

var $lrIA4 = parcelRequire("lrIA4");

var $jJf0h = parcelRequire("jJf0h");
/**
 * Returns a new list by pulling every item out of it (and all its sub-arrays)
 * and putting them in a new array, depth-first.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [b]
 * @param {Array} list The array to consider.
 * @return {Array} The flattened list.
 * @see R.unnest
 * @example
 *
 *      R.flatten([1, 2, [3, 4], 5, [6, [7, 8, [9, [10, 11], 12]]]]);
 *      //=> [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
 */ var $ddbbb8ad26cd7d0e$var$flatten = /*#__PURE__*/ (0, $lrIA4.default)(/*#__PURE__*/ (0, $jJf0h.default)(true));
var $ddbbb8ad26cd7d0e$export$2e2bcd8739ae039 = $ddbbb8ad26cd7d0e$var$flatten;

});

parcelRegister("44Hns", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2f792efc8067d3fd$export$2e2bcd8739ae039; });

var $lrIA4 = parcelRequire("lrIA4");

var $4fS8E = parcelRequire("4fS8E");
/**
 * Returns a new function much like the supplied one, except that the first two
 * arguments' order is reversed.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig ((a, b, c, ...) -> z) -> (b -> a -> c -> ... -> z)
 * @param {Function} fn The function to invoke with its first two parameters reversed.
 * @return {*} The result of invoking `fn` with its first two parameters' order reversed.
 * @example
 *
 *      const mergeThree = (a, b, c) => [].concat(a, b, c);
 *
 *      mergeThree(1, 2, 3); //=> [1, 2, 3]
 *
 *      R.flip(mergeThree)(1, 2, 3); //=> [2, 1, 3]
 * @symb R.flip(f)(a, b, c) = f(b, a, c)
 */ var $2f792efc8067d3fd$var$flip = /*#__PURE__*/ (0, $lrIA4.default)(function flip(fn) {
    return (0, $4fS8E.default)(fn.length, function(a, b) {
        var args = Array.prototype.slice.call(arguments, 0);
        args[0] = b;
        args[1] = a;
        return fn.apply(this, args);
    });
});
var $2f792efc8067d3fd$export$2e2bcd8739ae039 = $2f792efc8067d3fd$var$flip;

});

parcelRegister("jspAR", function(module, exports) {

var $jQ8CJ = parcelRequire("jQ8CJ");

var $4E2dE = parcelRequire("4E2dE");
/**
 * Iterate over an input `list`, calling a provided function `fn` for each
 * element in the list.
 *
 * `fn` receives one argument: *(value)*.
 *
 * Note: `R.forEach` does not skip deleted or unassigned indices (sparse
 * arrays), unlike the native `Array.prototype.forEach` method. For more
 * details on this behavior, see:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/forEach#Description
 *
 * Also note that, unlike `Array.prototype.forEach`, Ramda's `forEach` returns
 * the original array. In some libraries this function is named `each`.
 *
 * Dispatches to the `forEach` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category List
 * @sig (a -> *) -> [a] -> [a]
 * @param {Function} fn The function to invoke. Receives one argument, `value`.
 * @param {Array} list The list to iterate over.
 * @return {Array} The original list.
 * @see R.addIndex
 * @example
 *
 *      const printXPlusFive = x => console.log(x + 5);
 *      R.forEach(printXPlusFive, [1, 2, 3]); //=> [1, 2, 3]
 *      // logs 6
 *      // logs 7
 *      // logs 8
 * @symb R.forEach(f, [a, b, c]) = [a, b, c]
 */ var $e2a47c344dbdbb23$var$forEach = /*#__PURE__*/ (0, $4E2dE.default)(/*#__PURE__*/ (0, $jQ8CJ.default)("forEach", function forEach(fn, list) {
    var len = list.length;
    var idx = 0;
    while(idx < len){
        fn(list[idx]);
        idx += 1;
    }
    return list;
}));
var $e2a47c344dbdbb23$export$2e2bcd8739ae039 = $e2a47c344dbdbb23$var$forEach;

});

parcelRegister("8ZhTj", function(module, exports) {

var $4E2dE = parcelRequire("4E2dE");

var $ipwCl = parcelRequire("ipwCl");
/**
 * Iterate over an input `object`, calling a provided function `fn` for each
 * key and value in the object.
 *
 * `fn` receives three argument: *(value, key, obj)*.
 *
 * @func
 * @memberOf R
 * @since v0.23.0
 * @category Object
 * @sig ((a, String, StrMap a) -> Any) -> StrMap a -> StrMap a
 * @param {Function} fn The function to invoke. Receives three argument, `value`, `key`, `obj`.
 * @param {Object} obj The object to iterate over.
 * @return {Object} The original object.
 * @example
 *
 *      const printKeyConcatValue = (value, key) => console.log(key + ':' + value);
 *      R.forEachObjIndexed(printKeyConcatValue, {x: 1, y: 2}); //=> {x: 1, y: 2}
 *      // logs x:1
 *      // logs y:2
 * @symb R.forEachObjIndexed(f, {x: a, y: b}) = {x: a, y: b}
 */ var $68b1e6086ae7a415$var$forEachObjIndexed = /*#__PURE__*/ (0, $4E2dE.default)(function forEachObjIndexed(fn, obj) {
    var keyList = (0, $ipwCl.default)(obj);
    var idx = 0;
    while(idx < keyList.length){
        var key = keyList[idx];
        fn(obj[key], key, obj);
        idx += 1;
    }
    return obj;
});
var $68b1e6086ae7a415$export$2e2bcd8739ae039 = $68b1e6086ae7a415$var$forEachObjIndexed;

});

parcelRegister("fDyP5", function(module, exports) {

var $lrIA4 = parcelRequire("lrIA4");
/**
 * Creates a new object from a list key-value pairs. If a key appears in
 * multiple pairs, the rightmost pair is included in the object.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig [[k,v]] -> {k: v}
 * @param {Array} pairs An array of two-element arrays that will be the keys and values of the output object.
 * @return {Object} The object made by pairing up `keys` and `values`.
 * @see R.toPairs, R.pair
 * @example
 *
 *      R.fromPairs([['a', 1], ['b', 2], ['c', 3]]); //=> {a: 1, b: 2, c: 3}
 */ var $b62582a401cf7934$var$fromPairs = /*#__PURE__*/ (0, $lrIA4.default)(function fromPairs(pairs) {
    var result = {};
    var idx = 0;
    while(idx < pairs.length){
        result[pairs[idx][0]] = pairs[idx][1];
        idx += 1;
    }
    return result;
});
var $b62582a401cf7934$export$2e2bcd8739ae039 = $b62582a401cf7934$var$fromPairs;

});

parcelRegister("e6Neg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a457d0164d6cc2a4$export$2e2bcd8739ae039; });

var $jQ8CJ = parcelRequire("jQ8CJ");

var $4E2dE = parcelRequire("4E2dE");

var $5cYgD = parcelRequire("5cYgD");
/**
 * Splits a list into sub-lists stored in an object, based on the result of
 * calling a key-returning function on each element, and grouping the
 * results according to values returned.
 *
 * Dispatches to the `groupBy` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @typedefn Idx = String | Int | Symbol
 * @sig Idx a => (b -> a) -> [b] -> {a: [b]}
 * @param {Function} fn Function :: a -> Idx
 * @param {Array} list The array to group
 * @return {Object} An object with the output of `fn` for keys, mapped to arrays of elements
 *         that produced that key when passed to `fn`.
 * @see R.reduceBy, R.transduce, R.indexBy
 * @example
 *
 *      const byGrade = R.groupBy(function(student) {
 *        const score = student.score;
 *        return score < 65 ? 'F' :
 *               score < 70 ? 'D' :
 *               score < 80 ? 'C' :
 *               score < 90 ? 'B' : 'A';
 *      });
 *      const students = [{name: 'Abby', score: 84},
 *                      {name: 'Eddy', score: 58},
 *                      // ...
 *                      {name: 'Jack', score: 69}];
 *      byGrade(students);
 *      // {
 *      //   'A': [{name: 'Dianne', score: 99}],
 *      //   'B': [{name: 'Abby', score: 84}]
 *      //   // ...,
 *      //   'F': [{name: 'Eddy', score: 58}]
 *      // }
 */ var $a457d0164d6cc2a4$var$groupBy = /*#__PURE__*/ (0, $4E2dE.default)(/*#__PURE__*/ (0, $jQ8CJ.default)("groupBy", /*#__PURE__*/ (0, $5cYgD.default)(function(acc, item) {
    acc.push(item);
    return acc;
}, [])));
var $a457d0164d6cc2a4$export$2e2bcd8739ae039 = $a457d0164d6cc2a4$var$groupBy;

});

parcelRegister("bLcTX", function(module, exports) {

var $4E2dE = parcelRequire("4E2dE");
/**
 * Takes a list and returns a list of lists where each sublist's elements are
 * all satisfied pairwise comparison according to the provided function.
 * Only adjacent elements are passed to the comparison function.
 *
 * @func
 * @memberOf R
 * @since v0.21.0
 * @category List
 * @sig ((a, a) → Boolean) → [a] → [[a]]
 * @param {Function} fn Function for determining whether two given (adjacent)
 *        elements should be in the same group
 * @param {Array} list The array to group. Also accepts a string, which will be
 *        treated as a list of characters.
 * @return {List} A list that contains sublists of elements,
 *         whose concatenations are equal to the original list.
 * @example
 *
 * R.groupWith(R.equals, [0, 1, 1, 2, 3, 5, 8, 13, 21])
 * //=> [[0], [1, 1], [2], [3], [5], [8], [13], [21]]
 *
 * R.groupWith((a, b) => a + 1 === b, [0, 1, 1, 2, 3, 5, 8, 13, 21])
 * //=> [[0, 1], [1, 2, 3], [5], [8], [13], [21]]
 *
 * R.groupWith((a, b) => a % 2 === b % 2, [0, 1, 1, 2, 3, 5, 8, 13, 21])
 * //=> [[0], [1, 1], [2], [3, 5], [8], [13, 21]]
 *
 * const isVowel = R.test(/^[aeiou]$/i);
 * R.groupWith(R.eqBy(isVowel), 'aestiou')
 * //=> ['ae', 'st', 'iou']
 */ var $88fe17740b7d6f81$var$groupWith = /*#__PURE__*/ (0, $4E2dE.default)(function(fn, list) {
    var res = [];
    var idx = 0;
    var len = list.length;
    while(idx < len){
        var nextidx = idx + 1;
        while(nextidx < len && fn(list[nextidx - 1], list[nextidx]))nextidx += 1;
        res.push(list.slice(idx, nextidx));
        idx = nextidx;
    }
    return res;
});
var $88fe17740b7d6f81$export$2e2bcd8739ae039 = $88fe17740b7d6f81$var$groupWith;

});

parcelRegister("44CLl", function(module, exports) {

var $4E2dE = parcelRequire("4E2dE");
/**
 * Returns `true` if the first argument is greater than the second; `false`
 * otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @see R.lt
 * @example
 *
 *      R.gt(2, 1); //=> true
 *      R.gt(2, 2); //=> false
 *      R.gt(2, 3); //=> false
 *      R.gt('a', 'z'); //=> false
 *      R.gt('z', 'a'); //=> true
 */ var $2f759a9dace5db66$var$gt = /*#__PURE__*/ (0, $4E2dE.default)(function gt(a, b) {
    return a > b;
});
var $2f759a9dace5db66$export$2e2bcd8739ae039 = $2f759a9dace5db66$var$gt;

});

parcelRegister("jhlsl", function(module, exports) {

var $4E2dE = parcelRequire("4E2dE");
/**
 * Returns `true` if the first argument is greater than or equal to the second;
 * `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> Boolean
 * @param {Number} a
 * @param {Number} b
 * @return {Boolean}
 * @see R.lte
 * @example
 *
 *      R.gte(2, 1); //=> true
 *      R.gte(2, 2); //=> true
 *      R.gte(2, 3); //=> false
 *      R.gte('a', 'z'); //=> false
 *      R.gte('z', 'a'); //=> true
 */ var $e0903f9fbe90726e$var$gte = /*#__PURE__*/ (0, $4E2dE.default)(function gte(a, b) {
    return a >= b;
});
var $e0903f9fbe90726e$export$2e2bcd8739ae039 = $e0903f9fbe90726e$var$gte;

});

parcelRegister("dVQ7b", function(module, exports) {

var $4E2dE = parcelRequire("4E2dE");

var $5tWcN = parcelRequire("5tWcN");
/**
 * Returns whether or not an object has an own property with the specified name
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Object
 * @sig s -> {s: x} -> Boolean
 * @param {String} prop The name of the property to check for.
 * @param {Object} obj The object to query.
 * @return {Boolean} Whether the property exists.
 * @example
 *
 *      const hasName = R.has('name');
 *      hasName({name: 'alice'});   //=> true
 *      hasName({name: 'bob'});     //=> true
 *      hasName({});                //=> false
 *
 *      const point = {x: 0, y: 0};
 *      const pointHas = R.has(R.__, point);
 *      pointHas('x');  //=> true
 *      pointHas('y');  //=> true
 *      pointHas('z');  //=> false
 */ var $a249062f5475f79c$var$has = /*#__PURE__*/ (0, $4E2dE.default)(function has(prop, obj) {
    return (0, $5tWcN.default)([
        prop
    ], obj);
});
var $a249062f5475f79c$export$2e2bcd8739ae039 = $a249062f5475f79c$var$has;

});
parcelRegister("5tWcN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3fdccf92fc777bfd$export$2e2bcd8739ae039; });

var $4E2dE = parcelRequire("4E2dE");

var $jn7AE = parcelRequire("jn7AE");

var $fWvks = parcelRequire("fWvks");
/**
 * Returns whether or not a path exists in an object. Only the object's
 * own properties are checked.
 *
 * @func
 * @memberOf R
 * @since v0.26.0
 * @category Object
 * @typedefn Idx = String | Int | Symbol
 * @sig [Idx] -> {a} -> Boolean
 * @param {Array} path The path to use.
 * @param {Object} obj The object to check the path in.
 * @return {Boolean} Whether the path exists.
 * @see R.has
 * @example
 *
 *      R.hasPath(['a', 'b'], {a: {b: 2}});         // => true
 *      R.hasPath(['a', 'b'], {a: {b: undefined}}); // => true
 *      R.hasPath(['a', 'b'], {a: {c: 2}});         // => false
 *      R.hasPath(['a', 'b'], {});                  // => false
 */ var $3fdccf92fc777bfd$var$hasPath = /*#__PURE__*/ (0, $4E2dE.default)(function hasPath(_path, obj) {
    if (_path.length === 0 || (0, $fWvks.default)(obj)) return false;
    var val = obj;
    var idx = 0;
    while(idx < _path.length){
        if (!(0, $fWvks.default)(val) && (0, $jn7AE.default)(_path[idx], val)) {
            val = val[_path[idx]];
            idx += 1;
        } else return false;
    }
    return true;
});
var $3fdccf92fc777bfd$export$2e2bcd8739ae039 = $3fdccf92fc777bfd$var$hasPath;

});


parcelRegister("8xANO", function(module, exports) {

var $4E2dE = parcelRequire("4E2dE");

var $fWvks = parcelRequire("fWvks");
/**
 * Returns whether or not an object or its prototype chain has a property with
 * the specified name
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Object
 * @sig s -> {s: x} -> Boolean
 * @param {String} prop The name of the property to check for.
 * @param {Object} obj The object to query.
 * @return {Boolean} Whether the property exists.
 * @example
 *
 *      function Rectangle(width, height) {
 *        this.width = width;
 *        this.height = height;
 *      }
 *      Rectangle.prototype.area = function() {
 *        return this.width * this.height;
 *      };
 *
 *      const square = new Rectangle(2, 2);
 *      R.hasIn('width', square);  //=> true
 *      R.hasIn('area', square);  //=> true
 */ var $637df40221ba49c1$var$hasIn = /*#__PURE__*/ (0, $4E2dE.default)(function hasIn(prop, obj) {
    if ((0, $fWvks.default)(obj)) return false;
    return prop in obj;
});
var $637df40221ba49c1$export$2e2bcd8739ae039 = $637df40221ba49c1$var$hasIn;

});

parcelRegister("3Q4h5", function(module, exports) {

var $jARjV = parcelRequire("jARjV");

var $4E2dE = parcelRequire("4E2dE");
/**
 * Returns true if its arguments are identical, false otherwise. Values are
 * identical if they reference the same memory. `NaN` is identical to `NaN`;
 * `0` and `-0` are not identical.
 *
 * Note this is merely a curried version of ES6 `Object.is`.
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category Relation
 * @sig a -> a -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @example
 *
 *      const o = {};
 *      R.identical(o, o); //=> true
 *      R.identical(1, 1); //=> true
 *      R.identical(1, '1'); //=> false
 *      R.identical([], []); //=> false
 *      R.identical(0, -0); //=> false
 *      R.identical(NaN, NaN); //=> true
 */ var $2cb98b41f951a7ad$var$identical = /*#__PURE__*/ (0, $4E2dE.default)((0, $jARjV.default));
var $2cb98b41f951a7ad$export$2e2bcd8739ae039 = $2cb98b41f951a7ad$var$identical;

});

parcelRegister("j8Afz", function(module, exports) {

var $cjSwl = parcelRequire("cjSwl");

var $4fS8E = parcelRequire("4fS8E");
/**
 * Creates a function that will process either the `onTrue` or the `onFalse`
 * function depending upon the result of the `condition` predicate.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Logic
 * @sig (*... -> Boolean) -> (*... -> *) -> (*... -> *) -> (*... -> *)
 * @param {Function} condition A predicate function
 * @param {Function} onTrue A function to invoke when the `condition` evaluates to a truthy value.
 * @param {Function} onFalse A function to invoke when the `condition` evaluates to a falsy value.
 * @return {Function} A new function that will process either the `onTrue` or the `onFalse`
 *                    function depending upon the result of the `condition` predicate.
 * @see R.unless, R.when, R.cond
 * @example
 *
 *      const incCount = R.ifElse(
 *        R.has('count'),
 *        R.over(R.lensProp('count'), R.inc),
 *        R.assoc('count', 1)
 *      );
 *      incCount({ count: 1 }); //=> { count: 2 }
 *      incCount({});           //=> { count: 1 }
 */ var $deeae231109acdde$var$ifElse = /*#__PURE__*/ (0, $cjSwl.default)(function ifElse(condition, onTrue, onFalse) {
    return (0, $4fS8E.default)(Math.max(condition.length, onTrue.length, onFalse.length), function _ifElse() {
        return condition.apply(this, arguments) ? onTrue.apply(this, arguments) : onFalse.apply(this, arguments);
    });
});
var $deeae231109acdde$export$2e2bcd8739ae039 = $deeae231109acdde$var$ifElse;

});

parcelRegister("8EXHZ", function(module, exports) {

var $gQVWJ = parcelRequire("gQVWJ");
/**
 * Increments its argument.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Math
 * @sig Number -> Number
 * @param {Number} n
 * @return {Number} n + 1
 * @see R.dec
 * @example
 *
 *      R.inc(42); //=> 43
 */ var $64e060011f2d95d3$var$inc = /*#__PURE__*/ (0, $gQVWJ.default)(1);
var $64e060011f2d95d3$export$2e2bcd8739ae039 = $64e060011f2d95d3$var$inc;

});

parcelRegister("5OGbd", function(module, exports) {

var $k7LM5 = parcelRequire("k7LM5");

var $4E2dE = parcelRequire("4E2dE");
/**
 * Returns `true` if the specified value is equal, in [`R.equals`](#equals)
 * terms, to at least one element of the given list; `false` otherwise.
 * Also works with strings.
 *
 * @func
 * @memberOf R
 * @since v0.26.0
 * @category List
 * @sig a -> [a] -> Boolean
 * @param {Object} a The item to compare against.
 * @param {Array} list The array to consider.
 * @return {Boolean} `true` if an equivalent item is in the list, `false` otherwise.
 * @see R.any
 * @example
 *
 *      R.includes(3, [1, 2, 3]); //=> true
 *      R.includes(4, [1, 2, 3]); //=> false
 *      R.includes({ name: 'Fred' }, [{ name: 'Fred' }]); //=> true
 *      R.includes([42], [[42]]); //=> true
 *      R.includes('ba', 'banana'); //=>true
 */ var $43c25749a7812380$var$includes = /*#__PURE__*/ (0, $4E2dE.default)((0, $k7LM5.default));
var $43c25749a7812380$export$2e2bcd8739ae039 = $43c25749a7812380$var$includes;

});

parcelRegister("24z4h", function(module, exports) {

var $5cYgD = parcelRequire("5cYgD");
/**
 * Given a function that generates a key, turns a list of objects into an
 * object indexing the objects by the given key. Note that if multiple
 * objects generate the same value for the indexing key only the last value
 * will be included in the generated object.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @typedefn Idx = String | Int | Symbol
 * @sig Idx a => (b -> a) -> [b] -> {a: b}
 * @param {Function} fn Function :: a -> Idx
 * @param {Array} array The array of objects to index
 * @return {Object} An object indexing each array element by the given property.
 * @see R.groupBy
 * @example
 *
 *      const list = [{id: 'xyz', title: 'A'}, {id: 'abc', title: 'B'}];
 *      R.indexBy(R.prop('id'), list);
 *      //=> {abc: {id: 'abc', title: 'B'}, xyz: {id: 'xyz', title: 'A'}}
 */ var $182728438630c5a4$var$indexBy = /*#__PURE__*/ (0, $5cYgD.default)(function(acc, elem) {
    return elem;
}, null);
var $182728438630c5a4$export$2e2bcd8739ae039 = $182728438630c5a4$var$indexBy;

});

parcelRegister("d30Fl", function(module, exports) {

var $4E2dE = parcelRequire("4E2dE");

var $b5dJf = parcelRequire("b5dJf");

var $9hDA3 = parcelRequire("9hDA3");
/**
 * Returns the position of the first occurrence of an item in an array, or -1
 * if the item is not included in the array. [`R.equals`](#equals) is used to
 * determine equality.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig a -> [a] -> Number
 * @param {*} target The item to find.
 * @param {Array} xs The array to search in.
 * @return {Number} the index of the target, or -1 if the target is not found.
 * @see R.lastIndexOf, R.findIndex
 * @example
 *
 *      R.indexOf(3, [1,2,3,4]); //=> 2
 *      R.indexOf(10, [1,2,3,4]); //=> -1
 */ var $97fc1267fcdbc2c7$var$indexOf = /*#__PURE__*/ (0, $4E2dE.default)(function indexOf(target, xs) {
    return typeof xs.indexOf === "function" && !(0, $9hDA3.default)(xs) ? xs.indexOf(target) : (0, $b5dJf.default)(xs, target, 0);
});
var $97fc1267fcdbc2c7$export$2e2bcd8739ae039 = $97fc1267fcdbc2c7$var$indexOf;

});

parcelRegister("5QT1G", function(module, exports) {

var $1kRJS = parcelRequire("1kRJS");
/**
 * Returns all but the last element of the given list or string.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category List
 * @sig [a] -> [a]
 * @sig String -> String
 * @param {*} list
 * @return {*}
 * @see R.last, R.head, R.tail
 * @example
 *
 *      R.init([1, 2, 3]);  //=> [1, 2]
 *      R.init([1, 2]);     //=> [1]
 *      R.init([1]);        //=> []
 *      R.init([]);         //=> []
 *
 *      R.init('abc');  //=> 'ab'
 *      R.init('ab');   //=> 'a'
 *      R.init('a');    //=> ''
 *      R.init('');     //=> ''
 */ var $442c7e1f36602eea$var$init = /*#__PURE__*/ (0, $1kRJS.default)(0, -1);
var $442c7e1f36602eea$export$2e2bcd8739ae039 = $442c7e1f36602eea$var$init;

});

parcelRegister("5GjKl", function(module, exports) {

var $iiRAt = parcelRequire("iiRAt");

var $cjSwl = parcelRequire("cjSwl");

var $cgyVq = parcelRequire("cgyVq");
/**
 * Takes a predicate `pred`, a list `xs`, and a list `ys`, and returns a list
 * `xs'` comprising each of the elements of `xs` which is equal to one or more
 * elements of `ys` according to `pred`.
 *
 * `pred` must be a binary function expecting an element from each list.
 *
 * `xs`, `ys`, and `xs'` are treated as sets, semantically, so ordering should
 * not be significant, but since `xs'` is ordered the implementation guarantees
 * that its values are in the same order as they appear in `xs`. Duplicates are
 * not removed, so `xs'` may contain duplicates if `xs` contains duplicates.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Relation
 * @sig ((a, b) -> Boolean) -> [a] -> [b] -> [a]
 * @param {Function} pred
 * @param {Array} xs
 * @param {Array} ys
 * @return {Array}
 * @see R.intersection
 * @example
 *
 *      R.innerJoin(
 *        (record, id) => record.id === id,
 *        [{id: 824, name: 'Richie Furay'},
 *         {id: 956, name: 'Dewey Martin'},
 *         {id: 313, name: 'Bruce Palmer'},
 *         {id: 456, name: 'Stephen Stills'},
 *         {id: 177, name: 'Neil Young'}],
 *        [177, 456, 999]
 *      );
 *      //=> [{id: 456, name: 'Stephen Stills'}, {id: 177, name: 'Neil Young'}]
 */ var $42303140fde0dca9$var$innerJoin = /*#__PURE__*/ (0, $cjSwl.default)(function innerJoin(pred, xs, ys) {
    return (0, $cgyVq.default)(function(x) {
        return (0, $iiRAt.default)(pred, x, ys);
    }, xs);
});
var $42303140fde0dca9$export$2e2bcd8739ae039 = $42303140fde0dca9$var$innerJoin;

});

parcelRegister("hqtpz", function(module, exports) {

var $cjSwl = parcelRequire("cjSwl");
/**
 * Inserts the supplied element into the list, at the specified `index`. _Note that

 * this is not destructive_: it returns a copy of the list with the changes.
 * <small>No lists have been harmed in the application of this function.</small>
 *
 * @func
 * @memberOf R
 * @since v0.2.2
 * @category List
 * @sig Number -> a -> [a] -> [a]
 * @param {Number} index The position to insert the element
 * @param {*} elt The element to insert into the Array
 * @param {Array} list The list to insert into
 * @return {Array} A new Array with `elt` inserted at `index`.
 * @example
 *
 *      R.insert(2, 'x', [1,2,3,4]); //=> [1,2,'x',3,4]
 */ var $cafbade128120841$var$insert = /*#__PURE__*/ (0, $cjSwl.default)(function insert(idx, elt, list) {
    idx = idx < list.length && idx >= 0 ? idx : list.length;
    var result = Array.prototype.slice.call(list, 0);
    result.splice(idx, 0, elt);
    return result;
});
var $cafbade128120841$export$2e2bcd8739ae039 = $cafbade128120841$var$insert;

});

parcelRegister("XTBbw", function(module, exports) {

var $cjSwl = parcelRequire("cjSwl");
/**
 * Inserts the sub-list into the list, at the specified `index`. _Note that this is not
 * destructive_: it returns a copy of the list with the changes.
 * <small>No lists have been harmed in the application of this function.</small>
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category List
 * @sig Number -> [a] -> [a] -> [a]
 * @param {Number} index The position to insert the sub-list
 * @param {Array} elts The sub-list to insert into the Array
 * @param {Array} list The list to insert the sub-list into
 * @return {Array} A new Array with `elts` inserted starting at `index`.
 * @example
 *
 *      R.insertAll(2, ['x','y','z'], [1,2,3,4]); //=> [1,2,'x','y','z',3,4]
 */ var $0b40a38eb5f019a6$var$insertAll = /*#__PURE__*/ (0, $cjSwl.default)(function insertAll(idx, elts, list) {
    idx = idx < list.length && idx >= 0 ? idx : list.length;
    return [].concat(Array.prototype.slice.call(list, 0, idx), elts, Array.prototype.slice.call(list, idx));
});
var $0b40a38eb5f019a6$export$2e2bcd8739ae039 = $0b40a38eb5f019a6$var$insertAll;

});

parcelRegister("e8P0k", function(module, exports) {

var $k7LM5 = parcelRequire("k7LM5");

var $4E2dE = parcelRequire("4E2dE");

var $cgyVq = parcelRequire("cgyVq");

var $44Hns = parcelRequire("44Hns");

var $cUasK = parcelRequire("cUasK");
/**
 * Combines two lists into a set (i.e. no duplicates) composed of those
 * elements common to both lists.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig [*] -> [*] -> [*]
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The list of elements found in both `list1` and `list2`.
 * @see R.innerJoin
 * @example
 *
 *      R.intersection([1,2,3,4], [7,6,5,4,3]); //=> [4, 3]
 */ var $a4b96069f08c3728$var$intersection = /*#__PURE__*/ (0, $4E2dE.default)(function intersection(list1, list2) {
    var lookupList, filteredList;
    if (list1.length > list2.length) {
        lookupList = list1;
        filteredList = list2;
    } else {
        lookupList = list2;
        filteredList = list1;
    }
    return (0, $cUasK.default)((0, $cgyVq.default)((0, $44Hns.default)((0, $k7LM5.default))(lookupList), filteredList));
});
var $a4b96069f08c3728$export$2e2bcd8739ae039 = $a4b96069f08c3728$var$intersection;

});
parcelRegister("cUasK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9652d4ab805ea9cd$export$2e2bcd8739ae039; });

var $7x9UL = parcelRequire("7x9UL");

var $kcZJQ = parcelRequire("kcZJQ");
/**
 * Returns a new list containing only one copy of each element in the original
 * list. [`R.equals`](#equals) is used to determine equality.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a]
 * @param {Array} list The array to consider.
 * @return {Array} The list of unique items.
 * @example
 *
 *      R.uniq([1, 1, 2, 1]); //=> [1, 2]
 *      R.uniq([1, '1']);     //=> [1, '1']
 *      R.uniq([[42], [42]]); //=> [[42]]
 */ var $9652d4ab805ea9cd$var$uniq = /*#__PURE__*/ (0, $kcZJQ.default)((0, $7x9UL.default));
var $9652d4ab805ea9cd$export$2e2bcd8739ae039 = $9652d4ab805ea9cd$var$uniq;

});
parcelRegister("kcZJQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eb64d19cd6856c0a$export$2e2bcd8739ae039; });

var $ccVNH = parcelRequire("ccVNH");

var $4E2dE = parcelRequire("4E2dE");

var $AZnlR = parcelRequire("AZnlR");

var $eF2Ji = parcelRequire("eF2Ji");
/**
 * Returns a new list containing only one copy of each element in the original
 * list, based upon the value returned by applying the supplied function to
 * each list element. Prefers the first item if the supplied function produces
 * the same value on two items. [`R.equals`](#equals) is used for comparison.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig (a -> b) -> [a] -> [a]
 * @param {Function} fn A function used to produce a value to use during comparisons.
 * @param {Array} list The array to consider.
 * @return {Array} The list of unique items.
 * @example
 *
 *      R.uniqBy(Math.abs, [-1, -5, 2, 10, 1, 2]); //=> [-1, -5, 2, 10]
 */ var $eb64d19cd6856c0a$var$uniqBy = /*#__PURE__*/ (0, $4E2dE.default)(/*#__PURE__*/ (0, $AZnlR.default)([], (0, $eF2Ji.default), function(fn, list) {
    var set = new (0, $ccVNH.default)();
    var result = [];
    var idx = 0;
    var appliedItem, item;
    while(idx < list.length){
        item = list[idx];
        appliedItem = fn(item);
        if (set.add(appliedItem)) result.push(item);
        idx += 1;
    }
    return result;
}));
var $eb64d19cd6856c0a$export$2e2bcd8739ae039 = $eb64d19cd6856c0a$var$uniqBy;

});
parcelRegister("eF2Ji", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aac7030c467e44c4$export$2e2bcd8739ae039; });

var $4E2dE = parcelRequire("4E2dE");

var $ccVNH = parcelRequire("ccVNH");

var $dki4v = parcelRequire("dki4v");
var $aac7030c467e44c4$var$XUniqBy = /*#__PURE__*/ function() {
    function XUniqBy(f, xf) {
        this.xf = xf;
        this.f = f;
        this.set = new (0, $ccVNH.default)();
    }
    XUniqBy.prototype["@@transducer/init"] = (0, $dki4v.default).init;
    XUniqBy.prototype["@@transducer/result"] = (0, $dki4v.default).result;
    XUniqBy.prototype["@@transducer/step"] = function(result, input) {
        return this.set.add(this.f(input)) ? this.xf["@@transducer/step"](result, input) : result;
    };
    return XUniqBy;
}();
var $aac7030c467e44c4$var$_xuniqBy = /*#__PURE__*/ (0, $4E2dE.default)(function _xuniqBy(f, xf) {
    return new $aac7030c467e44c4$var$XUniqBy(f, xf);
});
var $aac7030c467e44c4$export$2e2bcd8739ae039 = $aac7030c467e44c4$var$_xuniqBy;

});




parcelRegister("6hiiZ", function(module, exports) {

var $jQ8CJ = parcelRequire("jQ8CJ");

var $4E2dE = parcelRequire("4E2dE");
/**
 * Creates a new list with the separator interposed between elements.
 *
 * Dispatches to the `intersperse` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig a -> [a] -> [a]
 * @param {*} separator The element to add to the list.
 * @param {Array} list The list to be interposed.
 * @return {Array} The new list.
 * @example
 *
 *      R.intersperse('a', ['b', 'n', 'n', 's']); //=> ['b', 'a', 'n', 'a', 'n', 'a', 's']
 */ var $492287aa1e8200f3$var$intersperse = /*#__PURE__*/ (0, $4E2dE.default)(/*#__PURE__*/ (0, $jQ8CJ.default)("intersperse", function intersperse(separator, list) {
    var out = [];
    var idx = 0;
    var length = list.length;
    while(idx < length){
        if (idx === length - 1) out.push(list[idx]);
        else out.push(list[idx], separator);
        idx += 1;
    }
    return out;
}));
var $492287aa1e8200f3$export$2e2bcd8739ae039 = $492287aa1e8200f3$var$intersperse;

});

parcelRegister("eBOev", function(module, exports) {

var $gPAhz = parcelRequire("gPAhz");

var $cjSwl = parcelRequire("cjSwl");

var $jR7J3 = parcelRequire("jR7J3");

var $jdcIJ = parcelRequire("jdcIJ");

var $kmYWK = parcelRequire("kmYWK");
/**
 * Transforms the items of the list with the transducer and appends the
 * transformed items to the accumulator using an appropriate iterator function
 * based on the accumulator type.
 *
 * The accumulator can be an array, string, object or a transformer. Iterated
 * items will be appended to arrays and concatenated to strings. Objects will
 * be merged directly or 2-item arrays will be merged as key, value pairs.
 *
 * The accumulator can also be a transformer object that provides a 2-arity
 * reducing iterator function, step, 0-arity initial value function, init, and
 * 1-arity result extraction function result. The step function is used as the
 * iterator function in reduce. The result function is used to convert the
 * final accumulator into the return type and in most cases is R.identity. The
 * init function is used to provide the initial accumulator.
 *
 * The iteration is performed with [`R.reduce`](#reduce) after initializing the
 * transducer.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category List
 * @sig a -> (b -> b) -> [c] -> a
 * @param {*} acc The initial accumulator value.
 * @param {Function} xf The transducer function. Receives a transformer and returns a transformer.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.transduce
 * @example
 *
 *      const numbers = [1, 2, 3, 4];
 *      const transducer = R.compose(R.map(R.add(1)), R.take(2));
 *
 *      R.into([], transducer, numbers); //=> [2, 3]
 *
 *      const intoArray = R.into([]);
 *      intoArray(transducer, numbers); //=> [2, 3]
 */ var $aa2b7c97c37c463b$var$into = /*#__PURE__*/ (0, $cjSwl.default)(function into(acc, xf, list) {
    return (0, $jR7J3.default)(acc) ? (0, $jdcIJ.default)(xf(acc), acc["@@transducer/init"](), list) : (0, $jdcIJ.default)(xf((0, $kmYWK.default)(acc)), (0, $gPAhz.default)(acc, [], [], false), list);
});
var $aa2b7c97c37c463b$export$2e2bcd8739ae039 = $aa2b7c97c37c463b$var$into;

});
parcelRegister("kmYWK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ed45236f841c5156$export$2e2bcd8739ae039; });

var $7qHZJ = parcelRequire("7qHZJ");

var $k3Ml1 = parcelRequire("k3Ml1");

var $dpzcU = parcelRequire("dpzcU");

var $jR7J3 = parcelRequire("jR7J3");

var $hniUa = parcelRequire("hniUa");
var $ed45236f841c5156$var$_stepCatArray = {
    "@@transducer/init": Array,
    "@@transducer/step": function(xs, x) {
        xs.push(x);
        return xs;
    },
    "@@transducer/result": (0, $k3Ml1.default)
};
var $ed45236f841c5156$var$_stepCatString = {
    "@@transducer/init": String,
    "@@transducer/step": function(a, b) {
        return a + b;
    },
    "@@transducer/result": (0, $k3Ml1.default)
};
var $ed45236f841c5156$var$_stepCatObject = {
    "@@transducer/init": Object,
    "@@transducer/step": function(result, input) {
        return (0, $7qHZJ.default)(result, (0, $dpzcU.default)(input) ? (0, $hniUa.default)(input[0], input[1]) : input);
    },
    "@@transducer/result": (0, $k3Ml1.default)
};
function $ed45236f841c5156$export$2e2bcd8739ae039(obj) {
    if ((0, $jR7J3.default)(obj)) return obj;
    if ((0, $dpzcU.default)(obj)) return $ed45236f841c5156$var$_stepCatArray;
    if (typeof obj === "string") return $ed45236f841c5156$var$_stepCatString;
    if (typeof obj === "object") return $ed45236f841c5156$var$_stepCatObject;
    throw new Error("Cannot create transformer for " + obj);
}

});
parcelRegister("7qHZJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $568d168c084da7ba$export$2e2bcd8739ae039; });

var $jn7AE = parcelRequire("jn7AE");
function $568d168c084da7ba$var$_objectAssign(target) {
    if (target == null) throw new TypeError("Cannot convert undefined or null to object");
    var output = Object(target);
    var idx = 1;
    var length = arguments.length;
    while(idx < length){
        var source = arguments[idx];
        if (source != null) {
            for(var nextKey in source)if ((0, $jn7AE.default)(nextKey, source)) output[nextKey] = source[nextKey];
        }
        idx += 1;
    }
    return output;
}
var $568d168c084da7ba$export$2e2bcd8739ae039 = typeof Object.assign === "function" ? Object.assign : $568d168c084da7ba$var$_objectAssign;

});

parcelRegister("hniUa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ca633fc5abbf44df$export$2e2bcd8739ae039; });

var $4E2dE = parcelRequire("4E2dE");
/**
 * Creates an object containing a single key:value pair.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category Object
 * @sig String -> a -> {String:a}
 * @param {String} key
 * @param {*} val
 * @return {Object}
 * @see R.pair
 * @example
 *
 *      const matchPhrases = R.compose(
 *        R.objOf('must'),
 *        R.map(R.objOf('match_phrase'))
 *      );
 *      matchPhrases(['foo', 'bar', 'baz']); //=> {must: [{match_phrase: 'foo'}, {match_phrase: 'bar'}, {match_phrase: 'baz'}]}
 */ var $ca633fc5abbf44df$var$objOf = /*#__PURE__*/ (0, $4E2dE.default)(function objOf(key, val) {
    var obj = {};
    obj[key] = val;
    return obj;
});
var $ca633fc5abbf44df$export$2e2bcd8739ae039 = $ca633fc5abbf44df$var$objOf;

});



parcelRegister("aZ9bi", function(module, exports) {

var $lrIA4 = parcelRequire("lrIA4");

var $jn7AE = parcelRequire("jn7AE");

var $ipwCl = parcelRequire("ipwCl");
/**
 * Same as [`R.invertObj`](#invertObj), however this accounts for objects with
 * duplicate values by putting the values into an array.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Object
 * @sig {s: x} -> {x: [ s, ... ]}
 * @param {Object} obj The object or array to invert
 * @return {Object} out A new object with keys in an array.
 * @see R.invertObj
 * @example
 *
 *      const raceResultsByFirstName = {
 *        first: 'alice',
 *        second: 'jake',
 *        third: 'alice',
 *      };
 *      R.invert(raceResultsByFirstName);
 *      //=> { 'alice': ['first', 'third'], 'jake':['second'] }
 */ var $7ff6b90f6de9e9f1$var$invert = /*#__PURE__*/ (0, $lrIA4.default)(function invert(obj) {
    var props = (0, $ipwCl.default)(obj);
    var len = props.length;
    var idx = 0;
    var out = {};
    while(idx < len){
        var key = props[idx];
        var val = obj[key];
        var list = (0, $jn7AE.default)(val, out) ? out[val] : out[val] = [];
        list[list.length] = key;
        idx += 1;
    }
    return out;
});
var $7ff6b90f6de9e9f1$export$2e2bcd8739ae039 = $7ff6b90f6de9e9f1$var$invert;

});

parcelRegister("9YzBQ", function(module, exports) {

var $lrIA4 = parcelRequire("lrIA4");

var $ipwCl = parcelRequire("ipwCl");
/**
 * Returns a new object with the keys of the given object as values, and the
 * values of the given object, which are coerced to strings, as keys. Note
 * that the last key found is preferred when handling the same value.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Object
 * @sig {s: x} -> {x: s}
 * @param {Object} obj The object or array to invert
 * @return {Object} out A new object
 * @see R.invert
 * @example
 *
 *      const raceResults = {
 *        first: 'alice',
 *        second: 'jake'
 *      };
 *      R.invertObj(raceResults);
 *      //=> { 'alice': 'first', 'jake':'second' }
 *
 *      // Alternatively:
 *      const raceResults = ['alice', 'jake'];
 *      R.invertObj(raceResults);
 *      //=> { 'alice': '0', 'jake':'1' }
 */ var $743556f2603e1626$var$invertObj = /*#__PURE__*/ (0, $lrIA4.default)(function invertObj(obj) {
    var props = (0, $ipwCl.default)(obj);
    var len = props.length;
    var idx = 0;
    var out = {};
    while(idx < len){
        var key = props[idx];
        out[obj[key]] = key;
        idx += 1;
    }
    return out;
});
var $743556f2603e1626$export$2e2bcd8739ae039 = $743556f2603e1626$var$invertObj;

});

parcelRegister("cEVJS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $937602341909ea56$export$2e2bcd8739ae039; });

var $4E2dE = parcelRequire("4E2dE");

var $aizOG = parcelRequire("aizOG");

var $4fS8E = parcelRequire("4fS8E");

var $220yG = parcelRequire("220yG");
/**
 * Turns a named method with a specified arity into a function that can be
 * called directly supplied with arguments and a target object.
 *
 * The returned function is curried and accepts `arity + 1` parameters where
 * the final parameter is the target object.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig Number -> String -> (a -> b -> ... -> n -> Object -> *)
 * @param {Number} arity Number of arguments the returned function should take
 *        before the target object.
 * @param {String} method Name of any of the target object's methods to call.
 * @return {Function} A new curried function.
 * @see R.construct
 * @example
 *
 *      const sliceFrom = R.invoker(1, 'slice');
 *      sliceFrom(6, 'abcdefghijklm'); //=> 'ghijklm'
 *      const sliceFrom6 = R.invoker(2, 'slice')(6);
 *      sliceFrom6(8, 'abcdefghijklm'); //=> 'gh'
 *
 *      const dog = {
 *        speak: async () => 'Woof!'
 *      };
 *      const speak = R.invoker(0, 'speak');
 *      speak(dog).then(console.log) //~> 'Woof!'
 *
 * @symb R.invoker(0, 'method')(o) = o['method']()
 * @symb R.invoker(1, 'method')(a, o) = o['method'](a)
 * @symb R.invoker(2, 'method')(a, b, o) = o['method'](a, b)
 */ var $937602341909ea56$var$invoker = /*#__PURE__*/ (0, $4E2dE.default)(function invoker(arity, method) {
    return (0, $4fS8E.default)(arity + 1, function() {
        var target = arguments[arity];
        if (target != null && (0, $aizOG.default)(target[method])) return target[method].apply(target, Array.prototype.slice.call(arguments, 0, arity));
        throw new TypeError((0, $220yG.default)(target) + ' does not have a method named "' + method + '"');
    });
});
var $937602341909ea56$export$2e2bcd8739ae039 = $937602341909ea56$var$invoker;

});

parcelRegister("cOkKO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $953a40dc0d72a266$export$2e2bcd8739ae039; });

var $4E2dE = parcelRequire("4E2dE");
/**
 * See if an object (i.e. `val`) is an instance of the supplied constructor. This
 * function will check up the inheritance chain, if any.
 * If `val` was created using `Object.create`, `R.is(Object, val) === true`.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Type
 * @sig (* -> {*}) -> a -> Boolean
 * @param {Object} ctor A constructor
 * @param {*} val The value to test
 * @return {Boolean}
 * @example
 *
 *      R.is(Object, {}); //=> true
 *      R.is(Number, 1); //=> true
 *      R.is(Object, 1); //=> false
 *      R.is(String, 's'); //=> true
 *      R.is(String, new String('')); //=> true
 *      R.is(Object, new String('')); //=> true
 *      R.is(Object, 's'); //=> false
 *      R.is(Number, {}); //=> false
 */ var $953a40dc0d72a266$var$is = /*#__PURE__*/ (0, $4E2dE.default)(function is(Ctor, val) {
    return val instanceof Ctor || val != null && (val.constructor === Ctor || Ctor.name === "Object" && typeof val === "object");
});
var $953a40dc0d72a266$export$2e2bcd8739ae039 = $953a40dc0d72a266$var$is;

});

parcelRegister("dXLll", function(module, exports) {

var $lrIA4 = parcelRequire("lrIA4");

var $b5mg2 = parcelRequire("b5mg2");

var $imwRL = parcelRequire("imwRL");
/**
 * Returns `true` if the given value is its type's empty value; `false`
 * otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Logic
 * @sig a -> Boolean
 * @param {*} x
 * @return {Boolean}
 * @see R.empty
 * @example
 *
 *      R.isEmpty([1, 2, 3]);           //=> false
 *      R.isEmpty([]);                  //=> true
 *      R.isEmpty('');                  //=> true
 *      R.isEmpty(null);                //=> false
 *      R.isEmpty({});                  //=> true
 *      R.isEmpty({length: 0});         //=> false
 *      R.isEmpty(Uint8Array.from('')); //=> true
 */ var $a2a5826a066a7d01$var$isEmpty = /*#__PURE__*/ (0, $lrIA4.default)(function isEmpty(x) {
    return x != null && (0, $imwRL.default)(x, (0, $b5mg2.default)(x));
});
var $a2a5826a066a7d01$export$2e2bcd8739ae039 = $a2a5826a066a7d01$var$isEmpty;

});

parcelRegister("83uBf", function(module, exports) {

var $cEVJS = parcelRequire("cEVJS");
/**
 * Returns a string made by inserting the `separator` between each element and
 * concatenating all the elements into a single string.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig String -> [a] -> String
 * @param {Number|String} separator The string used to separate the elements.
 * @param {Array} xs The elements to join into a string.
 * @return {String} str The string made by concatenating `xs` with `separator`.
 * @see R.split
 * @example
 *
 *      const spacer = R.join(' ');
 *      spacer(['a', 2, 3.4]);   //=> 'a 2 3.4'
 *      R.join('|', [1, 2, 3]);    //=> '1|2|3'
 */ var $5dd65706bb0dacc9$var$join = /*#__PURE__*/ (0, $cEVJS.default)(1, "join");
var $5dd65706bb0dacc9$export$2e2bcd8739ae039 = $5dd65706bb0dacc9$var$join;

});

parcelRegister("65e2B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $46de19f3f63d65fe$export$2e2bcd8739ae039; });

var $lrIA4 = parcelRequire("lrIA4");

var $dgkqv = parcelRequire("dgkqv");
/**
 * juxt applies a list of functions to a list of values.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Function
 * @sig [(a, b, ..., m) -> n] -> ((a, b, ..., m) -> [n])
 * @param {Array} fns An array of functions
 * @return {Function} A function that returns a list of values after applying each of the original `fns` to its parameters.
 * @see R.applySpec
 * @example
 *
 *      const getRange = R.juxt([Math.min, Math.max]);
 *      getRange(3, 4, 9, -3); //=> [-3, 9]
 * @symb R.juxt([f, g, h])(a, b) = [f(a, b), g(a, b), h(a, b)]
 */ var $46de19f3f63d65fe$var$juxt = /*#__PURE__*/ (0, $lrIA4.default)(function juxt(fns) {
    return (0, $dgkqv.default)(function() {
        return Array.prototype.slice.call(arguments, 0);
    }, fns);
});
var $46de19f3f63d65fe$export$2e2bcd8739ae039 = $46de19f3f63d65fe$var$juxt;

});

parcelRegister("6TYSi", function(module, exports) {

var $lrIA4 = parcelRequire("lrIA4");
/**
 * Returns a list containing the names of all the properties of the supplied
 * object, including prototype properties.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Object
 * @sig {k: v} -> [k]
 * @param {Object} obj The object to extract properties from
 * @return {Array} An array of the object's own and prototype properties.
 * @see R.keys, R.valuesIn
 * @example
 *
 *      const F = function() { this.x = 'X'; };
 *      F.prototype.y = 'Y';
 *      const f = new F();
 *      R.keysIn(f); //=> ['x', 'y']
 */ var $5067199309a08624$var$keysIn = /*#__PURE__*/ (0, $lrIA4.default)(function keysIn(obj) {
    var prop;
    var ks = [];
    for(prop in obj)ks[ks.length] = prop;
    return ks;
});
var $5067199309a08624$export$2e2bcd8739ae039 = $5067199309a08624$var$keysIn;

});

parcelRegister("avLOW", function(module, exports) {

var $4E2dE = parcelRequire("4E2dE");

var $9hDA3 = parcelRequire("9hDA3");

var $imwRL = parcelRequire("imwRL");
/**
 * Returns the position of the last occurrence of an item in an array, or -1 if
 * the item is not included in the array. [`R.equals`](#equals) is used to
 * determine equality.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig a -> [a] -> Number
 * @param {*} target The item to find.
 * @param {Array} xs The array to search in.
 * @return {Number} the index of the target, or -1 if the target is not found.
 * @see R.indexOf, R.findLastIndex
 * @example
 *
 *      R.lastIndexOf(3, [-1,3,3,0,1,2,3,4]); //=> 6
 *      R.lastIndexOf(10, [1,2,3,4]); //=> -1
 */ var $7a71e4d1fa3b339a$var$lastIndexOf = /*#__PURE__*/ (0, $4E2dE.default)(function lastIndexOf(target, xs) {
    if (typeof xs.lastIndexOf === "function" && !(0, $9hDA3.default)(xs)) return xs.lastIndexOf(target);
    else {
        var idx = xs.length - 1;
        while(idx >= 0){
            if ((0, $imwRL.default)(xs[idx], target)) return idx;
            idx -= 1;
        }
        return -1;
    }
});
var $7a71e4d1fa3b339a$export$2e2bcd8739ae039 = $7a71e4d1fa3b339a$var$lastIndexOf;

});

parcelRegister("he1YE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c8a5472345f65517$export$2e2bcd8739ae039; });

var $lrIA4 = parcelRequire("lrIA4");

var $8xbXG = parcelRequire("8xbXG");
/**
 * Returns the number of elements in the array by returning `list.length`.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig [a] -> Number
 * @param {Array} list The array to inspect.
 * @return {Number} The length of the array.
 * @example
 *
 *      R.length([]); //=> 0
 *      R.length([1, 2, 3]); //=> 3
 */ var $c8a5472345f65517$var$length = /*#__PURE__*/ (0, $lrIA4.default)(function length(list) {
    return list != null && (0, $8xbXG.default)(list.length) ? list.length : NaN;
});
var $c8a5472345f65517$export$2e2bcd8739ae039 = $c8a5472345f65517$var$length;

});
parcelRegister("8xbXG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $636aaf1c039a344a$export$2e2bcd8739ae039; });
function $636aaf1c039a344a$export$2e2bcd8739ae039(x) {
    return Object.prototype.toString.call(x) === "[object Number]";
}

});


parcelRegister("r8Zow", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $05197ece4282f468$export$2e2bcd8739ae039; });

var $4E2dE = parcelRequire("4E2dE");

var $aaiYf = parcelRequire("aaiYf");
/**
 * Returns a lens for the given getter and setter functions. The getter "gets"
 * the value of the focus; the setter "sets" the value of the focus. The setter
 * should not mutate the data structure.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig (s -> a) -> ((a, s) -> s) -> Lens s a
 * @param {Function} getter
 * @param {Function} setter
 * @return {Lens}
 * @see R.view, R.set, R.over, R.lensIndex, R.lensProp
 * @example
 *
 *      const xLens = R.lens(R.prop('x'), R.assoc('x'));
 *
 *      R.view(xLens, {x: 1, y: 2});            //=> 1
 *      R.set(xLens, 4, {x: 1, y: 2});          //=> {x: 4, y: 2}
 *      R.over(xLens, R.negate, {x: 1, y: 2});  //=> {x: -1, y: 2}
 */ var $05197ece4282f468$var$lens = /*#__PURE__*/ (0, $4E2dE.default)(function lens(getter, setter) {
    return function(toFunctorFn) {
        return function(target) {
            return (0, $aaiYf.default)(function(focus) {
                return setter(focus, target);
            }, toFunctorFn(getter(target)));
        };
    };
});
var $05197ece4282f468$export$2e2bcd8739ae039 = $05197ece4282f468$var$lens;

});

parcelRegister("5nCmM", function(module, exports) {

var $lrIA4 = parcelRequire("lrIA4");

var $r8Zow = parcelRequire("r8Zow");

var $7aHtE = parcelRequire("7aHtE");

var $9F9TM = parcelRequire("9F9TM");
/**
 * Returns a lens whose focus is the specified index.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig Number -> Lens s a
 * @param {Number} n
 * @return {Lens}
 * @see R.view, R.set, R.over, R.nth
 * @example
 *
 *      const headLens = R.lensIndex(0);
 *
 *      R.view(headLens, ['a', 'b', 'c']);            //=> 'a'
 *      R.set(headLens, 'x', ['a', 'b', 'c']);        //=> ['x', 'b', 'c']
 *      R.over(headLens, R.toUpper, ['a', 'b', 'c']); //=> ['A', 'b', 'c']
 */ var $3eacdc85b21cbbe8$var$lensIndex = /*#__PURE__*/ (0, $lrIA4.default)(function lensIndex(n) {
    return (0, $r8Zow.default)((0, $7aHtE.default)(n), (0, $9F9TM.default)(n));
});
var $3eacdc85b21cbbe8$export$2e2bcd8739ae039 = $3eacdc85b21cbbe8$var$lensIndex;

});
parcelRegister("9F9TM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $708f9f1006fff605$export$2e2bcd8739ae039; });

var $cjSwl = parcelRequire("cjSwl");

var $bQJaX = parcelRequire("bQJaX");

var $kYiXR = parcelRequire("kYiXR");
/**
 * Returns a new copy of the array with the element at the provided index
 * replaced with the given value.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig Number -> a -> [a] -> [a]
 * @param {Number} idx The index to update.
 * @param {*} x The value to exist at the given index of the returned array.
 * @param {Array|Arguments} list The source array-like object to be updated.
 * @return {Array} A copy of `list` with the value at index `idx` replaced with `x`.
 * @see R.adjust
 * @example
 *
 *      R.update(1, '_', ['a', 'b', 'c']);      //=> ['a', '_', 'c']
 *      R.update(-1, '_', ['a', 'b', 'c']);     //=> ['a', 'b', '_']
 * @symb R.update(-1, a, [b, c]) = [b, a]
 * @symb R.update(0, a, [b, c]) = [a, c]
 * @symb R.update(1, a, [b, c]) = [b, a]
 */ var $708f9f1006fff605$var$update = /*#__PURE__*/ (0, $cjSwl.default)(function update(idx, x, list) {
    return (0, $bQJaX.default)(idx, (0, $kYiXR.default)(x), list);
});
var $708f9f1006fff605$export$2e2bcd8739ae039 = $708f9f1006fff605$var$update;

});


parcelRegister("agIZU", function(module, exports) {

var $lrIA4 = parcelRequire("lrIA4");

var $bJ6V5 = parcelRequire("bJ6V5");

var $r8Zow = parcelRequire("r8Zow");

var $6jckq = parcelRequire("6jckq");
/**
 * Returns a lens whose focus is the specified path.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Object
 * @typedefn Idx = String | Int | Symbol
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig [Idx] -> Lens s a
 * @param {Array} path The path to use.
 * @return {Lens}
 * @see R.view, R.set, R.over
 * @example
 *
 *      const xHeadYLens = R.lensPath(['x', 0, 'y']);
 *
 *      R.view(xHeadYLens, {x: [{y: 2, z: 3}, {y: 4, z: 5}]});
 *      //=> 2
 *      R.set(xHeadYLens, 1, {x: [{y: 2, z: 3}, {y: 4, z: 5}]});
 *      //=> {x: [{y: 1, z: 3}, {y: 4, z: 5}]}
 *      R.over(xHeadYLens, R.negate, {x: [{y: 2, z: 3}, {y: 4, z: 5}]});
 *      //=> {x: [{y: -2, z: 3}, {y: 4, z: 5}]}
 */ var $779e4d91db1c1e1c$var$lensPath = /*#__PURE__*/ (0, $lrIA4.default)(function lensPath(p) {
    return (0, $r8Zow.default)((0, $6jckq.default)(p), (0, $bJ6V5.default)(p));
});
var $779e4d91db1c1e1c$export$2e2bcd8739ae039 = $779e4d91db1c1e1c$var$lensPath;

});
parcelRegister("6jckq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $497e14997d96c17e$export$2e2bcd8739ae039; });

var $4E2dE = parcelRequire("4E2dE");

var $jrg6g = parcelRequire("jrg6g");
/**
 * Retrieve the value at a given path.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Object
 * @typedefn Idx = String | Int | Symbol
 * @sig [Idx] -> {a} -> a | Undefined
 * @param {Array} path The path to use.
 * @param {Object} obj The object to retrieve the nested property from.
 * @return {*} The data at `path`.
 * @see R.prop, R.nth
 * @example
 *
 *      R.path(['a', 'b'], {a: {b: 2}}); //=> 2
 *      R.path(['a', 'b'], {c: {b: 2}}); //=> undefined
 *      R.path(['a', 'b', 0], {a: {b: [1, 2, 3]}}); //=> 1
 *      R.path(['a', 'b', -2], {a: {b: [1, 2, 3]}}); //=> 2
 */ var $497e14997d96c17e$var$path = /*#__PURE__*/ (0, $4E2dE.default)(function path(pathAr, obj) {
    return (0, $jrg6g.default)([
        pathAr
    ], obj)[0];
});
var $497e14997d96c17e$export$2e2bcd8739ae039 = $497e14997d96c17e$var$path;

});
parcelRegister("jrg6g", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e26d071545b1cd39$export$2e2bcd8739ae039; });

var $4E2dE = parcelRequire("4E2dE");

var $4uaMM = parcelRequire("4uaMM");

var $7aHtE = parcelRequire("7aHtE");
/**
 * Retrieves the values at given paths of an object.
 *
 * @func
 * @memberOf R
 * @since v0.27.1
 * @category Object
 * @typedefn Idx = [String | Int | Symbol]
 * @sig [Idx] -> {a} -> [a | Undefined]
 * @param {Array} pathsArray The array of paths to be fetched.
 * @param {Object} obj The object to retrieve the nested properties from.
 * @return {Array} A list consisting of values at paths specified by "pathsArray".
 * @see R.path
 * @example
 *
 *      R.paths([['a', 'b'], ['p', 0, 'q']], {a: {b: 2}, p: [{q: 3}]}); //=> [2, 3]
 *      R.paths([['a', 'b'], ['p', 'r']], {a: {b: 2}, p: [{q: 3}]}); //=> [2, undefined]
 */ var $e26d071545b1cd39$var$paths = /*#__PURE__*/ (0, $4E2dE.default)(function paths(pathsArray, obj) {
    return pathsArray.map(function(paths) {
        var val = obj;
        var idx = 0;
        var p;
        while(idx < paths.length){
            if (val == null) return;
            p = paths[idx];
            val = (0, $4uaMM.default)(p) ? (0, $7aHtE.default)(p, val) : val[p];
            idx += 1;
        }
        return val;
    });
});
var $e26d071545b1cd39$export$2e2bcd8739ae039 = $e26d071545b1cd39$var$paths;

});



parcelRegister("8wTwB", function(module, exports) {

var $lrIA4 = parcelRequire("lrIA4");

var $bAwZa = parcelRequire("bAwZa");

var $r8Zow = parcelRequire("r8Zow");

var $hvsdM = parcelRequire("hvsdM");
/**
 * Returns a lens whose focus is the specified property.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig String -> Lens s a
 * @param {String} k
 * @return {Lens}
 * @see R.view, R.set, R.over
 * @example
 *
 *      const xLens = R.lensProp('x');
 *
 *      R.view(xLens, {x: 1, y: 2});            //=> 1
 *      R.set(xLens, 4, {x: 1, y: 2});          //=> {x: 4, y: 2}
 *      R.over(xLens, R.negate, {x: 1, y: 2});  //=> {x: -1, y: 2}
 */ var $019a43a503826030$var$lensProp = /*#__PURE__*/ (0, $lrIA4.default)(function lensProp(k) {
    return (0, $r8Zow.default)((0, $hvsdM.default)(k), (0, $bAwZa.default)(k));
});
var $019a43a503826030$export$2e2bcd8739ae039 = $019a43a503826030$var$lensProp;

});

parcelRegister("4U32h", function(module, exports) {

var $4E2dE = parcelRequire("4E2dE");
/**
 * Returns `true` if the first argument is less than the second; `false`
 * otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @see R.gt
 * @example
 *
 *      R.lt(2, 1); //=> false
 *      R.lt(2, 2); //=> false
 *      R.lt(2, 3); //=> true
 *      R.lt('a', 'z'); //=> true
 *      R.lt('z', 'a'); //=> false
 */ var $391ebf34c3b0ee3d$var$lt = /*#__PURE__*/ (0, $4E2dE.default)(function lt(a, b) {
    return a < b;
});
var $391ebf34c3b0ee3d$export$2e2bcd8739ae039 = $391ebf34c3b0ee3d$var$lt;

});

parcelRegister("lFc9n", function(module, exports) {

var $4E2dE = parcelRequire("4E2dE");
/**
 * Returns `true` if the first argument is less than or equal to the second;
 * `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> Boolean
 * @param {Number} a
 * @param {Number} b
 * @return {Boolean}
 * @see R.gte
 * @example
 *
 *      R.lte(2, 1); //=> false
 *      R.lte(2, 2); //=> true
 *      R.lte(2, 3); //=> true
 *      R.lte('a', 'z'); //=> true
 *      R.lte('z', 'a'); //=> false
 */ var $fc56da1608f8dce4$var$lte = /*#__PURE__*/ (0, $4E2dE.default)(function lte(a, b) {
    return a <= b;
});
var $fc56da1608f8dce4$export$2e2bcd8739ae039 = $fc56da1608f8dce4$var$lte;

});

parcelRegister("76tHB", function(module, exports) {

var $cjSwl = parcelRequire("cjSwl");
/**
 * The `mapAccum` function behaves like a combination of map and reduce; it
 * applies a function to each element of a list, passing an accumulating
 * parameter from left to right, and returning a final value of this
 * accumulator together with the new list.
 *
 * The iterator function receives two arguments, *acc* and *value*, and should
 * return a tuple *[acc, value]*.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category List
 * @sig ((acc, x) -> (acc, y)) -> acc -> [x] -> (acc, [y])
 * @param {Function} fn The function to be called on every element of the input `list`.
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.scan, R.addIndex, R.mapAccumRight
 * @example
 *
 *      const digits = ['1', '2', '3', '4'];
 *      const appender = (a, b) => [a + b, a + b];
 *
 *      R.mapAccum(appender, 0, digits); //=> ['01234', ['01', '012', '0123', '01234']]
 * @symb R.mapAccum(f, a, [b, c, d]) = [
 *   f(f(f(a, b)[0], c)[0], d)[0],
 *   [
 *     f(a, b)[1],
 *     f(f(a, b)[0], c)[1],
 *     f(f(f(a, b)[0], c)[0], d)[1]
 *   ]
 * ]
 */ var $52c0222c088023e7$var$mapAccum = /*#__PURE__*/ (0, $cjSwl.default)(function mapAccum(fn, acc, list) {
    var idx = 0;
    var len = list.length;
    var result = [];
    var tuple = [
        acc
    ];
    while(idx < len){
        tuple = fn(tuple[0], list[idx]);
        result[idx] = tuple[1];
        idx += 1;
    }
    return [
        tuple[0],
        result
    ];
});
var $52c0222c088023e7$export$2e2bcd8739ae039 = $52c0222c088023e7$var$mapAccum;

});

parcelRegister("i1Qcw", function(module, exports) {

var $cjSwl = parcelRequire("cjSwl");
/**
 * The `mapAccumRight` function behaves like a combination of map and reduce; it
 * applies a function to each element of a list, passing an accumulating
 * parameter from right to left, and returning a final value of this
 * accumulator together with the new list.
 *
 * Similar to [`mapAccum`](#mapAccum), except moves through the input list from
 * the right to the left.
 *
 * The iterator function receives two arguments, *acc* and *value*, and should
 * return a tuple *[acc, value]*.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category List
 * @sig ((acc, x) -> (acc, y)) -> acc -> [x] -> (acc, [y])
 * @param {Function} fn The function to be called on every element of the input `list`.
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.addIndex, R.mapAccum
 * @example
 *
 *      const digits = ['1', '2', '3', '4'];
 *      const appender = (a, b) => [b + a, b + a];
 *
 *      R.mapAccumRight(appender, 5, digits); //=> ['12345', ['12345', '2345', '345', '45']]
 * @symb R.mapAccumRight(f, a, [b, c, d]) = [
 *   f(f(f(a, d)[0], c)[0], b)[0],
 *   [
 *     f(a, d)[1],
 *     f(f(a, d)[0], c)[1],
 *     f(f(f(a, d)[0], c)[0], b)[1]
 *   ]
 * ]
 */ var $d200d00406a6e290$var$mapAccumRight = /*#__PURE__*/ (0, $cjSwl.default)(function mapAccumRight(fn, acc, list) {
    var idx = list.length - 1;
    var result = [];
    var tuple = [
        acc
    ];
    while(idx >= 0){
        tuple = fn(tuple[0], list[idx]);
        result[idx] = tuple[1];
        idx -= 1;
    }
    return [
        tuple[0],
        result
    ];
});
var $d200d00406a6e290$export$2e2bcd8739ae039 = $d200d00406a6e290$var$mapAccumRight;

});

parcelRegister("f3BXJ", function(module, exports) {

var $4E2dE = parcelRequire("4E2dE");

var $jdcIJ = parcelRequire("jdcIJ");

var $ipwCl = parcelRequire("ipwCl");
/**
 * An Object-specific version of [`map`](#map). The function is applied to three
 * arguments: *(value, key, obj)*. If only the value is significant, use
 * [`map`](#map) instead.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Object
 * @sig ((*, String, Object) -> *) -> Object -> Object
 * @param {Function} fn
 * @param {Object} obj
 * @return {Object}
 * @see R.map
 * @example
 *
 *      const xyz = { x: 1, y: 2, z: 3 };
 *      const prependKeyAndDouble = (num, key, obj) => key + (num * 2);
 *
 *      R.mapObjIndexed(prependKeyAndDouble, xyz); //=> { x: 'x2', y: 'y4', z: 'z6' }
 */ var $af64955e28cc786b$var$mapObjIndexed = /*#__PURE__*/ (0, $4E2dE.default)(function mapObjIndexed(fn, obj) {
    return (0, $jdcIJ.default)(function(acc, key) {
        acc[key] = fn(obj[key], key, obj);
        return acc;
    }, {}, (0, $ipwCl.default)(obj));
});
var $af64955e28cc786b$export$2e2bcd8739ae039 = $af64955e28cc786b$var$mapObjIndexed;

});

parcelRegister("fVzFi", function(module, exports) {

var $4E2dE = parcelRequire("4E2dE");
/**
 * Tests a regular expression against a String. Note that this function will
 * return an empty array when there are no matches. This differs from
 * [`String.prototype.match`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/match)
 * which returns `null` when there are no matches.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category String
 * @sig RegExp -> String -> [String | Undefined]
 * @param {RegExp} rx A regular expression.
 * @param {String} str The string to match against
 * @return {Array} The list of matches or empty array.
 * @see R.test
 * @example
 *
 *      R.match(/([a-z]a)/g, 'bananas'); //=> ['ba', 'na', 'na']
 *      R.match(/a/, 'b'); //=> []
 *      R.match(/a/, null); //=> TypeError: null does not have a method named "match"
 */ var $b987d837aeee0e97$var$match = /*#__PURE__*/ (0, $4E2dE.default)(function match(rx, str) {
    return str.match(rx) || [];
});
var $b987d837aeee0e97$export$2e2bcd8739ae039 = $b987d837aeee0e97$var$match;

});

parcelRegister("2fqFd", function(module, exports) {

var $4E2dE = parcelRequire("4E2dE");

var $4uaMM = parcelRequire("4uaMM");
/**
 * `mathMod` behaves like the modulo operator should mathematically, unlike the
 * `%` operator (and by extension, [`R.modulo`](#modulo)). So while
 * `-17 % 5` is `-2`, `mathMod(-17, 5)` is `3`. `mathMod` requires Integer
 * arguments, and returns NaN when the modulus is zero or negative.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} m The dividend.
 * @param {Number} p the modulus.
 * @return {Number} The result of `b mod a`.
 * @see R.modulo
 * @example
 *
 *      R.mathMod(-17, 5);  //=> 3
 *      R.mathMod(17, 5);   //=> 2
 *      R.mathMod(17, -5);  //=> NaN
 *      R.mathMod(17, 0);   //=> NaN
 *      R.mathMod(17.2, 5); //=> NaN
 *      R.mathMod(17, 5.3); //=> NaN
 *
 *      const clock = R.mathMod(R.__, 12);
 *      clock(15); //=> 3
 *      clock(24); //=> 0
 *
 *      const seventeenMod = R.mathMod(17);
 *      seventeenMod(3);  //=> 2
 *      seventeenMod(4);  //=> 1
 *      seventeenMod(10); //=> 7
 */ var $1a31aa5943663fa2$var$mathMod = /*#__PURE__*/ (0, $4E2dE.default)(function mathMod(m, p) {
    if (!(0, $4uaMM.default)(m)) return NaN;
    if (!(0, $4uaMM.default)(p) || p < 1) return NaN;
    return (m % p + p) % p;
});
var $1a31aa5943663fa2$export$2e2bcd8739ae039 = $1a31aa5943663fa2$var$mathMod;

});

parcelRegister("cn6A8", function(module, exports) {

var $cjSwl = parcelRequire("cjSwl");
/**
 * Takes a function and two values, and returns whichever value produces the
 * larger result when passed to the provided function.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Relation
 * @sig Ord b => (a -> b) -> a -> a -> a
 * @param {Function} f
 * @param {*} a
 * @param {*} b
 * @return {*}
 * @see R.max, R.minBy
 * @example
 *
 *      //  square :: Number -> Number
 *      const square = n => n * n;
 *
 *      R.maxBy(square, -3, 2); //=> -3
 *
 *      R.reduce(R.maxBy(square), 0, [3, -5, 4, 1, -2]); //=> -5
 *      R.reduce(R.maxBy(square), 0, []); //=> 0
 */ var $901cbd0a7e3d1a74$var$maxBy = /*#__PURE__*/ (0, $cjSwl.default)(function maxBy(f, a, b) {
    return f(b) > f(a) ? b : a;
});
var $901cbd0a7e3d1a74$export$2e2bcd8739ae039 = $901cbd0a7e3d1a74$var$maxBy;

});

parcelRegister("jLPNx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e64a9622982f7831$export$2e2bcd8739ae039; });

var $lrIA4 = parcelRequire("lrIA4");

var $7FHgD = parcelRequire("7FHgD");
/**
 * Returns the mean of the given list of numbers.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Math
 * @sig [Number] -> Number
 * @param {Array} list
 * @return {Number}
 * @see R.median
 * @example
 *
 *      R.mean([2, 7, 9]); //=> 6
 *      R.mean([]); //=> NaN
 */ var $e64a9622982f7831$var$mean = /*#__PURE__*/ (0, $lrIA4.default)(function mean(list) {
    return (0, $7FHgD.default)(list) / list.length;
});
var $e64a9622982f7831$export$2e2bcd8739ae039 = $e64a9622982f7831$var$mean;

});
parcelRegister("7FHgD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $595decbc8f78468d$export$2e2bcd8739ae039; });

var $gQVWJ = parcelRequire("gQVWJ");

var $hv0Dt = parcelRequire("hv0Dt");
/**
 * Adds together all the elements of a list.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig [Number] -> Number
 * @param {Array} list An array of numbers
 * @return {Number} The sum of all the numbers in the list.
 * @see R.reduce
 * @example
 *
 *      R.sum([2,4,6,8,100,1]); //=> 121
 */ var $595decbc8f78468d$var$sum = /*#__PURE__*/ (0, $hv0Dt.default)((0, $gQVWJ.default), 0);
var $595decbc8f78468d$export$2e2bcd8739ae039 = $595decbc8f78468d$var$sum;

});


parcelRegister("aCMLH", function(module, exports) {

var $lrIA4 = parcelRequire("lrIA4");

var $jLPNx = parcelRequire("jLPNx");
/**
 * Returns the median of the given list of numbers.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Math
 * @sig [Number] -> Number
 * @param {Array} list
 * @return {Number}
 * @see R.mean
 * @example
 *
 *      R.median([2, 9, 7]); //=> 7
 *      R.median([7, 2, 10, 9]); //=> 8
 *      R.median([]); //=> NaN
 */ var $7bc34864322c1a62$var$median = /*#__PURE__*/ (0, $lrIA4.default)(function median(list) {
    var len = list.length;
    if (len === 0) return NaN;
    var width = 2 - len % 2;
    var idx = (len - width) / 2;
    return (0, $jLPNx.default)(Array.prototype.slice.call(list, 0).sort(function(a, b) {
        return a < b ? -1 : a > b ? 1 : 0;
    }).slice(idx, idx + width));
});
var $7bc34864322c1a62$export$2e2bcd8739ae039 = $7bc34864322c1a62$var$median;

});

parcelRegister("jWgN9", function(module, exports) {

var $fe9oK = parcelRequire("fe9oK");

var $4E2dE = parcelRequire("4E2dE");

var $jn7AE = parcelRequire("jn7AE");
/**
 * Creates a new function that, when invoked, caches the result of calling `fn`
 * for a given argument set and returns the result. Subsequent calls to the
 * memoized `fn` with the same argument set will not result in an additional
 * call to `fn`; instead, the cached result for that set of arguments will be
 * returned.
 *
 * Care must be taken when implementing key generation to avoid key collision,
 * or if tracking references, memory leaks and mutating arguments.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Function
 * @sig (*... -> String) -> (*... -> a) -> (*... -> a)
 * @param {Function} fn The function to generate the cache key.
 * @param {Function} fn The function to memoize.
 * @return {Function} Memoized version of `fn`.
 * @example
 *
 *      let count = 0;
 *      const factorial = R.memoizeWith(Number, n => {
 *        count += 1;
 *        return R.product(R.range(1, n + 1));
 *      });
 *      factorial(5); //=> 120
 *      factorial(5); //=> 120
 *      factorial(5); //=> 120
 *      count; //=> 1
 */ var $e8407596e320b5e2$var$memoizeWith = /*#__PURE__*/ (0, $4E2dE.default)(function memoizeWith(mFn, fn) {
    var cache = {};
    return (0, $fe9oK.default)(fn.length, function() {
        var key = mFn.apply(this, arguments);
        if (!(0, $jn7AE.default)(key, cache)) cache[key] = fn.apply(this, arguments);
        return cache[key];
    });
});
var $e8407596e320b5e2$export$2e2bcd8739ae039 = $e8407596e320b5e2$var$memoizeWith;

});

parcelRegister("2rRZu", function(module, exports) {

var $7qHZJ = parcelRequire("7qHZJ");

var $lrIA4 = parcelRequire("lrIA4");
/**
 * Creates one new object with the own properties from a list of objects.
 * If a key exists in more than one object, the value from the last
 * object it exists in will be used.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category List
 * @sig [{k: v}] -> {k: v}
 * @param {Array} list An array of objects
 * @return {Object} A merged object.
 * @see R.reduce
 * @example
 *
 *      R.mergeAll([{foo:1},{bar:2},{baz:3}]); //=> {foo:1,bar:2,baz:3}
 *      R.mergeAll([{foo:1},{foo:2},{bar:2}]); //=> {foo:2,bar:2}
 * @symb R.mergeAll([{ x: 1 }, { y: 2 }, { z: 3 }]) = { x: 1, y: 2, z: 3 }
 */ var $1c87fbdab463e7bc$var$mergeAll = /*#__PURE__*/ (0, $lrIA4.default)(function mergeAll(list) {
    return (0, $7qHZJ.default).apply(null, [
        {}
    ].concat(list));
});
var $1c87fbdab463e7bc$export$2e2bcd8739ae039 = $1c87fbdab463e7bc$var$mergeAll;

});

parcelRegister("dSK6u", function(module, exports) {

var $4E2dE = parcelRequire("4E2dE");

var $c8cXo = parcelRequire("c8cXo");
/**
 * Creates a new object with the own properties of the first object merged with
 * the own properties of the second object. If a key exists in both objects:
 * - and both values are objects, the two values will be recursively merged
 * - otherwise the value from the first object will be used.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Object
 * @sig {a} -> {a} -> {a}
 * @param {Object} lObj
 * @param {Object} rObj
 * @return {Object}
 * @see R.merge, R.mergeDeepRight, R.mergeDeepWith, R.mergeDeepWithKey
 * @example
 *
 *      R.mergeDeepLeft({ name: 'fred', age: 10, contact: { email: 'moo@example.com' }},
 *                      { age: 40, contact: { email: 'baa@example.com' }});
 *      //=> { name: 'fred', age: 10, contact: { email: 'moo@example.com' }}
 */ var $a1b414b857d551d6$var$mergeDeepLeft = /*#__PURE__*/ (0, $4E2dE.default)(function mergeDeepLeft(lObj, rObj) {
    return (0, $c8cXo.default)(function(k, lVal, rVal) {
        return lVal;
    }, lObj, rObj);
});
var $a1b414b857d551d6$export$2e2bcd8739ae039 = $a1b414b857d551d6$var$mergeDeepLeft;

});
parcelRegister("c8cXo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8d504858efd3a7d5$export$2e2bcd8739ae039; });

var $cjSwl = parcelRequire("cjSwl");

var $fGe1Y = parcelRequire("fGe1Y");

var $fSdWs = parcelRequire("fSdWs");
/**
 * Creates a new object with the own properties of the two provided objects.
 * If a key exists in both objects:
 * - and both associated values are also objects then the values will be
 *   recursively merged.
 * - otherwise the provided function is applied to the key and associated values
 *   using the resulting value as the new value associated with the key.
 * If a key only exists in one object, the value will be associated with the key
 * of the resulting object.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Object
 * @sig ((String, a, a) -> a) -> {a} -> {a} -> {a}
 * @param {Function} fn
 * @param {Object} lObj
 * @param {Object} rObj
 * @return {Object}
 * @see R.mergeWithKey, R.mergeDeepWith
 * @example
 *
 *      let concatValues = (k, l, r) => k == 'values' ? R.concat(l, r) : r
 *      R.mergeDeepWithKey(concatValues,
 *                         { a: true, c: { thing: 'foo', values: [10, 20] }},
 *                         { b: true, c: { thing: 'bar', values: [15, 35] }});
 *      //=> { a: true, b: true, c: { thing: 'bar', values: [10, 20, 15, 35] }}
 */ var $8d504858efd3a7d5$var$mergeDeepWithKey = /*#__PURE__*/ (0, $cjSwl.default)(function mergeDeepWithKey(fn, lObj, rObj) {
    return (0, $fSdWs.default)(function(k, lVal, rVal) {
        if ((0, $fGe1Y.default)(lVal) && (0, $fGe1Y.default)(rVal)) return mergeDeepWithKey(fn, lVal, rVal);
        else return fn(k, lVal, rVal);
    }, lObj, rObj);
});
var $8d504858efd3a7d5$export$2e2bcd8739ae039 = $8d504858efd3a7d5$var$mergeDeepWithKey;

});
parcelRegister("fSdWs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b8e6b6b85eb56ac8$export$2e2bcd8739ae039; });

var $cjSwl = parcelRequire("cjSwl");

var $jn7AE = parcelRequire("jn7AE");
/**
 * Creates a new object with the own properties of the two provided objects. If
 * a key exists in both objects, the provided function is applied to the key
 * and the values associated with the key in each object, with the result being
 * used as the value associated with the key in the returned object.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Object
 * @sig ((String, a, a) -> a) -> {a} -> {a} -> {a}
 * @param {Function} fn
 * @param {Object} l
 * @param {Object} r
 * @return {Object}
 * @see R.mergeDeepWithKey, R.merge, R.mergeWith
 * @example
 *
 *      let concatValues = (k, l, r) => k == 'values' ? R.concat(l, r) : r
 *      R.mergeWithKey(concatValues,
 *                     { a: true, thing: 'foo', values: [10, 20] },
 *                     { b: true, thing: 'bar', values: [15, 35] });
 *      //=> { a: true, b: true, thing: 'bar', values: [10, 20, 15, 35] }
 * @symb R.mergeWithKey(f, { x: 1, y: 2 }, { y: 5, z: 3 }) = { x: 1, y: f('y', 2, 5), z: 3 }
 */ var $b8e6b6b85eb56ac8$var$mergeWithKey = /*#__PURE__*/ (0, $cjSwl.default)(function mergeWithKey(fn, l, r) {
    var result = {};
    var k;
    for(k in l)if ((0, $jn7AE.default)(k, l)) result[k] = (0, $jn7AE.default)(k, r) ? fn(k, l[k], r[k]) : l[k];
    for(k in r)if ((0, $jn7AE.default)(k, r) && !(0, $jn7AE.default)(k, result)) result[k] = r[k];
    return result;
});
var $b8e6b6b85eb56ac8$export$2e2bcd8739ae039 = $b8e6b6b85eb56ac8$var$mergeWithKey;

});



parcelRegister("aXbjc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7f982fc2cf8fe650$export$2e2bcd8739ae039; });

var $4E2dE = parcelRequire("4E2dE");

var $c8cXo = parcelRequire("c8cXo");
/**
 * Creates a new object with the own properties of the first object merged with
 * the own properties of the second object. If a key exists in both objects:
 * - and both values are objects, the two values will be recursively merged
 * - otherwise the value from the second object will be used.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Object
 * @sig {a} -> {a} -> {a}
 * @param {Object} lObj
 * @param {Object} rObj
 * @return {Object}
 * @see R.merge, R.mergeDeepLeft, R.mergeDeepWith, R.mergeDeepWithKey
 * @example
 *
 *      R.mergeDeepRight({ name: 'fred', age: 10, contact: { email: 'moo@example.com' }},
 *                       { age: 40, contact: { email: 'baa@example.com' }});
 *      //=> { name: 'fred', age: 40, contact: { email: 'baa@example.com' }}
 */ var $7f982fc2cf8fe650$var$mergeDeepRight = /*#__PURE__*/ (0, $4E2dE.default)(function mergeDeepRight(lObj, rObj) {
    return (0, $c8cXo.default)(function(k, lVal, rVal) {
        return rVal;
    }, lObj, rObj);
});
var $7f982fc2cf8fe650$export$2e2bcd8739ae039 = $7f982fc2cf8fe650$var$mergeDeepRight;

});

parcelRegister("8wIVI", function(module, exports) {

var $cjSwl = parcelRequire("cjSwl");

var $c8cXo = parcelRequire("c8cXo");
/**
 * Creates a new object with the own properties of the two provided objects.
 * If a key exists in both objects:
 * - and both associated values are also objects then the values will be
 *   recursively merged.
 * - otherwise the provided function is applied to associated values using the
 *   resulting value as the new value associated with the key.
 * If a key only exists in one object, the value will be associated with the key
 * of the resulting object.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Object
 * @sig ((a, a) -> a) -> {a} -> {a} -> {a}
 * @param {Function} fn
 * @param {Object} lObj
 * @param {Object} rObj
 * @return {Object}
 * @see R.mergeWith, R.mergeDeepWithKey
 * @example
 *
 *      R.mergeDeepWith(R.concat,
 *                      { a: true, c: { values: [10, 20] }},
 *                      { b: true, c: { values: [15, 35] }});
 *      //=> { a: true, b: true, c: { values: [10, 20, 15, 35] }}
 */ var $63542a054ea5c1be$var$mergeDeepWith = /*#__PURE__*/ (0, $cjSwl.default)(function mergeDeepWith(fn, lObj, rObj) {
    return (0, $c8cXo.default)(function(k, lVal, rVal) {
        return fn(lVal, rVal);
    }, lObj, rObj);
});
var $63542a054ea5c1be$export$2e2bcd8739ae039 = $63542a054ea5c1be$var$mergeDeepWith;

});

parcelRegister("d9gmn", function(module, exports) {

var $7qHZJ = parcelRequire("7qHZJ");

var $4E2dE = parcelRequire("4E2dE");
/**
 * Create a new object with the own properties of the first object merged with
 * the own properties of the second object. If a key exists in both objects,
 * the value from the first object will be used.
 *
 * @func
 * @memberOf R
 * @since v0.26.0
 * @category Object
 * @sig {k: v} -> {k: v} -> {k: v}
 * @param {Object} l
 * @param {Object} r
 * @return {Object}
 * @see R.mergeRight, R.mergeDeepLeft, R.mergeWith, R.mergeWithKey
 * @example
 *
 *      R.mergeLeft({ 'age': 40 }, { 'name': 'fred', 'age': 10 });
 *      //=> { 'name': 'fred', 'age': 40 }
 *
 *      const resetToDefault = R.mergeLeft({x: 0});
 *      resetToDefault({x: 5, y: 2}); //=> {x: 0, y: 2}
 * @symb R.mergeLeft(a, b) = {...b, ...a}
 */ var $9928ce5c1bb68db2$var$mergeLeft = /*#__PURE__*/ (0, $4E2dE.default)(function mergeLeft(l, r) {
    return (0, $7qHZJ.default)({}, r, l);
});
var $9928ce5c1bb68db2$export$2e2bcd8739ae039 = $9928ce5c1bb68db2$var$mergeLeft;

});

parcelRegister("6mxyo", function(module, exports) {

var $7qHZJ = parcelRequire("7qHZJ");

var $4E2dE = parcelRequire("4E2dE");
/**
 * Create a new object with the own properties of the first object merged with
 * the own properties of the second object. If a key exists in both objects,
 * the value from the second object will be used.
 *
 * @func
 * @memberOf R
 * @since v0.26.0
 * @category Object
 * @sig {k: v} -> {k: v} -> {k: v}
 * @param {Object} l
 * @param {Object} r
 * @return {Object}
 * @see R.mergeLeft, R.mergeDeepRight, R.mergeWith, R.mergeWithKey
 * @example
 *
 *      R.mergeRight({ 'name': 'fred', 'age': 10 }, { 'age': 40 });
 *      //=> { 'name': 'fred', 'age': 40 }
 *
 *      const withDefaults = R.mergeRight({x: 0, y: 0});
 *      withDefaults({y: 2}); //=> {x: 0, y: 2}
 * @symb R.mergeRight(a, b) = {...a, ...b}
 */ var $4a1ed33dc2027630$var$mergeRight = /*#__PURE__*/ (0, $4E2dE.default)(function mergeRight(l, r) {
    return (0, $7qHZJ.default)({}, l, r);
});
var $4a1ed33dc2027630$export$2e2bcd8739ae039 = $4a1ed33dc2027630$var$mergeRight;

});

parcelRegister("i7UYI", function(module, exports) {

var $cjSwl = parcelRequire("cjSwl");

var $fSdWs = parcelRequire("fSdWs");
/**
 * Creates a new object with the own properties of the two provided objects. If
 * a key exists in both objects, the provided function is applied to the values
 * associated with the key in each object, with the result being used as the
 * value associated with the key in the returned object.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Object
 * @sig ((a, a) -> a) -> {a} -> {a} -> {a}
 * @param {Function} fn
 * @param {Object} l
 * @param {Object} r
 * @return {Object}
 * @see R.mergeDeepWith, R.merge, R.mergeWithKey
 * @example
 *
 *      R.mergeWith(R.concat,
 *                  { a: true, values: [10, 20] },
 *                  { b: true, values: [15, 35] });
 *      //=> { a: true, b: true, values: [10, 20, 15, 35] }
 */ var $d32514274faaba27$var$mergeWith = /*#__PURE__*/ (0, $cjSwl.default)(function mergeWith(fn, l, r) {
    return (0, $fSdWs.default)(function(_, _l, _r) {
        return fn(_l, _r);
    }, l, r);
});
var $d32514274faaba27$export$2e2bcd8739ae039 = $d32514274faaba27$var$mergeWith;

});

parcelRegister("gNYTO", function(module, exports) {

var $4E2dE = parcelRequire("4E2dE");
/**
 * Returns the smaller of its two arguments.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> a
 * @param {*} a
 * @param {*} b
 * @return {*}
 * @see R.minBy, R.max
 * @example
 *
 *      R.min(789, 123); //=> 123
 *      R.min('a', 'b'); //=> 'a'
 */ var $c3c0763bf4824bda$var$min = /*#__PURE__*/ (0, $4E2dE.default)(function min(a, b) {
    return b < a ? b : a;
});
var $c3c0763bf4824bda$export$2e2bcd8739ae039 = $c3c0763bf4824bda$var$min;

});

parcelRegister("9M7rx", function(module, exports) {

var $cjSwl = parcelRequire("cjSwl");
/**
 * Takes a function and two values, and returns whichever value produces the
 * smaller result when passed to the provided function.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Relation
 * @sig Ord b => (a -> b) -> a -> a -> a
 * @param {Function} f
 * @param {*} a
 * @param {*} b
 * @return {*}
 * @see R.min, R.maxBy
 * @example
 *
 *      //  square :: Number -> Number
 *      const square = n => n * n;
 *
 *      R.minBy(square, -3, 2); //=> 2
 *
 *      R.reduce(R.minBy(square), Infinity, [3, -5, 4, 1, -2]); //=> 1
 *      R.reduce(R.minBy(square), Infinity, []); //=> Infinity
 */ var $71de5ed35ed17561$var$minBy = /*#__PURE__*/ (0, $cjSwl.default)(function minBy(f, a, b) {
    return f(b) < f(a) ? b : a;
});
var $71de5ed35ed17561$export$2e2bcd8739ae039 = $71de5ed35ed17561$var$minBy;

});

parcelRegister("4t2Mj", function(module, exports) {

var $cjSwl = parcelRequire("cjSwl");

var $2uMop = parcelRequire("2uMop");
/**
 * Creates a copy of the passed object by applying an `fn` function to the given `prop` property.
 *
 * The function will not be invoked, and the object will not change
 * if its corresponding property does not exist in the object.
 * All non-primitive properties are copied to the new object by reference.
 *
 * @func
 * @memberOf R
 * @since v0.28.0
 * @category Object
 * @sig Idx -> (v -> v) -> {k: v} -> {k: v}
 * @param {String|Number} prop The property to be modified.
 * @param {Function} fn The function to apply to the property.
 * @param {Object} object The object to be transformed.
 * @return {Object} The transformed object.
 * @example
 *
 *      const person = {name: 'James', age: 20, pets: ['dog', 'cat']};
 *      R.modify('age', R.add(1), person); //=> {name: 'James', age: 21, pets: ['dog', 'cat']}
 *      R.modify('pets', R.append('turtle'), person); //=> {name: 'James', age: 20, pets: ['dog', 'cat', 'turtle']}
 */ var $340c068b5627c9a4$var$modify = /*#__PURE__*/ (0, $cjSwl.default)(function modify(prop, fn, object) {
    return (0, $2uMop.default)([
        prop
    ], fn, object);
});
var $340c068b5627c9a4$export$2e2bcd8739ae039 = $340c068b5627c9a4$var$modify;

});
parcelRegister("2uMop", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1d13ebe7a10f18b4$export$2e2bcd8739ae039; });

var $cjSwl = parcelRequire("cjSwl");

var $9hDA3 = parcelRequire("9hDA3");

var $fGe1Y = parcelRequire("fGe1Y");

var $jn7AE = parcelRequire("jn7AE");

var $cNL0t = parcelRequire("cNL0t");

var $4dGne = parcelRequire("4dGne");
/**
 * Creates a shallow clone of the passed object by applying an `fn` function
 * to the value at the given path.
 *
 * The function will not be invoked, and the object will not change
 * if its corresponding path does not exist in the object.
 * All non-primitive properties are copied to the new object by reference.
 *
 * @func
 * @memberOf R
 * @since v0.28.0
 * @category Object
 * @sig [Idx] -> (v -> v) -> {k: v} -> {k: v}
 * @param {Array} path The path to be modified.
 * @param {Function} fn The function to apply to the path.
 * @param {Object} object The object to be transformed.
 * @return {Object} The transformed object.
 * @example
 *
 *      const person = {name: 'James', address: { zipCode: '90216' }};
 *      R.modifyPath(['address', 'zipCode'], R.reverse, person); //=> {name: 'James', address: { zipCode: '61209' }}
 *
 *      // Can handle arrays too
 *      const person = {name: 'James', addresses: [{ zipCode: '90216' }]};
 *      R.modifyPath(['addresses', 0, 'zipCode'], R.reverse, person); //=> {name: 'James', addresses: [{ zipCode: '61209' }]}
 */ var $1d13ebe7a10f18b4$var$modifyPath = /*#__PURE__*/ (0, $cjSwl.default)(function modifyPath(path, fn, object) {
    if (!(0, $fGe1Y.default)(object) && !(0, $9hDA3.default)(object) || path.length === 0) return object;
    var idx = path[0];
    if (!(0, $jn7AE.default)(idx, object)) return object;
    if (path.length === 1) return (0, $4dGne.default)(idx, fn, object);
    var val = modifyPath(Array.prototype.slice.call(path, 1), fn, object[idx]);
    if (val === object[idx]) return object;
    return (0, $cNL0t.default)(idx, val, object);
});
var $1d13ebe7a10f18b4$export$2e2bcd8739ae039 = $1d13ebe7a10f18b4$var$modifyPath;

});
parcelRegister("4dGne", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $31293ed6363f7cb4$export$2e2bcd8739ae039; });

var $9hDA3 = parcelRequire("9hDA3");

var $4uaMM = parcelRequire("4uaMM");
function $31293ed6363f7cb4$export$2e2bcd8739ae039(prop, fn, obj) {
    if ((0, $4uaMM.default)(prop) && (0, $9hDA3.default)(obj)) {
        var arr = [].concat(obj);
        arr[prop] = fn(arr[prop]);
        return arr;
    }
    var result = {};
    for(var p in obj)result[p] = obj[p];
    result[prop] = fn(result[prop]);
    return result;
}

});



parcelRegister("dNjK4", function(module, exports) {

var $4E2dE = parcelRequire("4E2dE");
/**
 * Divides the first parameter by the second and returns the remainder. Note
 * that this function preserves the JavaScript-style behavior for modulo. For
 * mathematical modulo see [`mathMod`](#mathMod).
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a The value to the divide.
 * @param {Number} b The pseudo-modulus
 * @return {Number} The result of `b % a`.
 * @see R.mathMod
 * @example
 *
 *      R.modulo(17, 3); //=> 2
 *      // JS behavior:
 *      R.modulo(-17, 3); //=> -2
 *      R.modulo(17, -3); //=> 2
 *
 *      const isOdd = R.modulo(R.__, 2);
 *      isOdd(42); //=> 0
 *      isOdd(21); //=> 1
 */ var $a0af2a4fbc45ad31$var$modulo = /*#__PURE__*/ (0, $4E2dE.default)(function modulo(a, b) {
    return a % b;
});
var $a0af2a4fbc45ad31$export$2e2bcd8739ae039 = $a0af2a4fbc45ad31$var$modulo;

});

parcelRegister("bKKpV", function(module, exports) {

var $cjSwl = parcelRequire("cjSwl");
/**
 * Move an item, at index `from`, to index `to`, in a list of elements.
 * A new list will be created containing the new elements order.
 *
 * @func
 * @memberOf R
 * @since v0.27.1
 * @category List
 * @sig Number -> Number -> [a] -> [a]
 * @param {Number} from The source index
 * @param {Number} to The destination index
 * @param {Array} list The list which will serve to realise the move
 * @return {Array} The new list reordered
 * @example
 *
 *      R.move(0, 2, ['a', 'b', 'c', 'd', 'e', 'f']); //=> ['b', 'c', 'a', 'd', 'e', 'f']
 *      R.move(-1, 0, ['a', 'b', 'c', 'd', 'e', 'f']); //=> ['f', 'a', 'b', 'c', 'd', 'e'] list rotation
 */ var $88e7ff0bd20d3c10$var$move = /*#__PURE__*/ (0, $cjSwl.default)(function(from, to, list) {
    var length = list.length;
    var result = list.slice();
    var positiveFrom = from < 0 ? length + from : from;
    var positiveTo = to < 0 ? length + to : to;
    var item = result.splice(positiveFrom, 1);
    return positiveFrom < 0 || positiveFrom >= list.length || positiveTo < 0 || positiveTo >= list.length ? list : [].concat(result.slice(0, positiveTo)).concat(item).concat(result.slice(positiveTo, list.length));
});
var $88e7ff0bd20d3c10$export$2e2bcd8739ae039 = $88e7ff0bd20d3c10$var$move;

});

parcelRegister("kN79E", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f22def04fe03969a$export$2e2bcd8739ae039; });

var $4E2dE = parcelRequire("4E2dE");
/**
 * Multiplies two numbers. Equivalent to `a * b` but curried.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a The first value.
 * @param {Number} b The second value.
 * @return {Number} The result of `a * b`.
 * @see R.divide
 * @example
 *
 *      const double = R.multiply(2);
 *      const triple = R.multiply(3);
 *      double(3);       //=>  6
 *      triple(4);       //=> 12
 *      R.multiply(2, 5);  //=> 10
 */ var $f22def04fe03969a$var$multiply = /*#__PURE__*/ (0, $4E2dE.default)(function multiply(a, b) {
    return a * b;
});
var $f22def04fe03969a$export$2e2bcd8739ae039 = $f22def04fe03969a$var$multiply;

});

parcelRegister("gRk4Y", function(module, exports) {

var $aXbjc = parcelRequire("aXbjc");

var $4E2dE = parcelRequire("4E2dE");
var /**
 * Takes a function `f` and an object, and returns a function `g`.
 * When applied, `g` returns the result of applying `f` to the object
 * provided initially merged deeply (right) with the object provided as an argument to `g`.
 *
 * @func
 * @memberOf R
 * @since v0.28.0
 * @category Function
 * @sig (({ a, b, c, ..., n }) -> x) -> { a, b, c, ...} -> ({ d, e, f, ..., n } -> x)
 * @param {Function} f
 * @param {Object} props
 * @return {Function}
 * @see R.partial, R.partialRight, R.curry, R.mergeDeepRight
 * @example
 *
 *      const multiply2 = ({ a, b }) => a * b;
 *      const double = R.partialObject(multiply2, { a: 2 });
 *      double({ b: 2 }); //=> 4
 *
 *      const greet = ({ salutation, title, firstName, lastName }) =>
 *        salutation + ', ' + title + ' ' + firstName + ' ' + lastName + '!';
 *
 *      const sayHello = R.partialObject(greet, { salutation: 'Hello' });
 *      const sayHelloToMs = R.partialObject(sayHello, { title: 'Ms.' });
 *      sayHelloToMs({ firstName: 'Jane', lastName: 'Jones' }); //=> 'Hello, Ms. Jane Jones!'
 * @symb R.partialObject(f, { a, b })({ c, d }) = f({ a, b, c, d })
 */ $c4612be87cd0f8ca$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $4E2dE.default)((f, o)=>(props)=>f.call(undefined, (0, $aXbjc.default)(o, props)));

});

parcelRegister("gdogu", function(module, exports) {

var $lrIA4 = parcelRequire("lrIA4");
/**
 * Negates its argument.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Math
 * @sig Number -> Number
 * @param {Number} n
 * @return {Number}
 * @example
 *
 *      R.negate(42); //=> -42
 */ var $bce0aebae2725a9d$var$negate = /*#__PURE__*/ (0, $lrIA4.default)(function negate(n) {
    return -n;
});
var $bce0aebae2725a9d$export$2e2bcd8739ae039 = $bce0aebae2725a9d$var$negate;

});

parcelRegister("1ygww", function(module, exports) {

var $2t09Y = parcelRequire("2t09Y");

var $4E2dE = parcelRequire("4E2dE");

var $3pbdp = parcelRequire("3pbdp");
/**
 * Returns `true` if no elements of the list match the predicate, `false`
 * otherwise.
 *
 * Dispatches to the `all` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> Boolean
 * @param {Function} fn The predicate function.
 * @param {Array} list The array to consider.
 * @return {Boolean} `true` if the predicate is not satisfied by every element, `false` otherwise.
 * @see R.all, R.any
 * @example
 *
 *      const isEven = n => n % 2 === 0;
 *      const isOdd = n => n % 2 !== 0;
 *
 *      R.none(isEven, [1, 3, 5, 7, 9, 11]); //=> true
 *      R.none(isOdd, [1, 3, 5, 7, 8, 11]); //=> false
 */ var $1215c8a9e18f7145$var$none = /*#__PURE__*/ (0, $4E2dE.default)(function none(fn, input) {
    return (0, $3pbdp.default)((0, $2t09Y.default)(fn), input);
});
var $1215c8a9e18f7145$export$2e2bcd8739ae039 = $1215c8a9e18f7145$var$none;

});

parcelRegister("hOpjF", function(module, exports) {

var $lrIA4 = parcelRequire("lrIA4");

var $4fS8E = parcelRequire("4fS8E");

var $7aHtE = parcelRequire("7aHtE");
/**
 * Returns a function which returns its nth argument.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Function
 * @sig Number -> *... -> *
 * @param {Number} n
 * @return {Function}
 * @example
 *
 *      R.nthArg(1)('a', 'b', 'c'); //=> 'b'
 *      R.nthArg(-1)('a', 'b', 'c'); //=> 'c'
 * @symb R.nthArg(-1)(a, b, c) = c
 * @symb R.nthArg(0)(a, b, c) = a
 * @symb R.nthArg(1)(a, b, c) = b
 */ var $cf7abe792b44d4c0$var$nthArg = /*#__PURE__*/ (0, $lrIA4.default)(function nthArg(n) {
    var arity = n < 0 ? 1 : n + 1;
    return (0, $4fS8E.default)(arity, function() {
        return (0, $7aHtE.default)(n, arguments);
    });
});
var $cf7abe792b44d4c0$export$2e2bcd8739ae039 = $cf7abe792b44d4c0$var$nthArg;

});

parcelRegister("kb8Qx", function(module, exports) {

var $cjSwl = parcelRequire("cjSwl");
/**
 * `o` is a curried composition function that returns a unary function.
 * Like [`compose`](#compose), `o` performs right-to-left function composition.
 * Unlike [`compose`](#compose), the rightmost function passed to `o` will be
 * invoked with only one argument. Also, unlike [`compose`](#compose), `o` is
 * limited to accepting only 2 unary functions. The name o was chosen because
 * of its similarity to the mathematical composition operator ∘.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Function
 * @sig (b -> c) -> (a -> b) -> a -> c
 * @param {Function} f
 * @param {Function} g
 * @return {Function}
 * @see R.compose, R.pipe
 * @example
 *
 *      const classyGreeting = name => "The name's " + name.last + ", " + name.first + " " + name.last
 *      const yellGreeting = R.o(R.toUpper, classyGreeting);
 *      yellGreeting({first: 'James', last: 'Bond'}); //=> "THE NAME'S BOND, JAMES BOND"
 *
 *      R.o(R.multiply(10), R.add(10))(-4) //=> 60
 *
 * @symb R.o(f, g, x) = f(g(x))
 */ var $eb0bb269ba7d8c2a$var$o = /*#__PURE__*/ (0, $cjSwl.default)(function o(f, g, x) {
    return f(g(x));
});
var $eb0bb269ba7d8c2a$export$2e2bcd8739ae039 = $eb0bb269ba7d8c2a$var$o;

});

parcelRegister("3cgNi", function(module, exports) {

var $lrIA4 = parcelRequire("lrIA4");

var $8sDg3 = parcelRequire("8sDg3");
/**
 * Returns a singleton array containing the value provided.
 *
 * Note this `of` is different from the ES6 `of`; See
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/of
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Function
 * @sig a -> [a]
 * @param {*} x any value
 * @return {Array} An array wrapping `x`.
 * @example
 *
 *      R.of(null); //=> [null]
 *      R.of([42]); //=> [[42]]
 */ var $253f85122ff4d05c$var$of = /*#__PURE__*/ (0, $lrIA4.default)((0, $8sDg3.default));
var $253f85122ff4d05c$export$2e2bcd8739ae039 = $253f85122ff4d05c$var$of;

});
parcelRegister("8sDg3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $628f6415d850e3e7$export$2e2bcd8739ae039; });
function $628f6415d850e3e7$export$2e2bcd8739ae039(x) {
    return [
        x
    ];
}

});


parcelRegister("jQGiS", function(module, exports) {

var $4E2dE = parcelRequire("4E2dE");
/**
 * Returns a partial copy of an object omitting the keys specified.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig [String] -> {String: *} -> {String: *}
 * @param {Array} names an array of String property names to omit from the new object
 * @param {Object} obj The object to copy from
 * @return {Object} A new object with properties from `names` not on it.
 * @see R.pick
 * @example
 *
 *      R.omit(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, c: 3}
 */ var $e733b03fb4d74268$var$omit = /*#__PURE__*/ (0, $4E2dE.default)(function omit(names, obj) {
    var result = {};
    var index = {};
    var idx = 0;
    var len = names.length;
    while(idx < len){
        index[names[idx]] = 1;
        idx += 1;
    }
    for(var prop in obj)if (!index.hasOwnProperty(prop)) result[prop] = obj[prop];
    return result;
});
var $e733b03fb4d74268$export$2e2bcd8739ae039 = $e733b03fb4d74268$var$omit;

});

parcelRegister("JsWNL", function(module, exports) {

var $2ikoZ = parcelRequire("2ikoZ");
/**
 * Takes a binary function `f`, a unary function `g`, and two values.
 * Applies `g` to each value, then applies the result of each to `f`.
 *
 * Also known as the P combinator.
 *
 * @func
 * @memberOf R
 * @since v0.28.0
 * @category Function
 * @sig ((a, a) -> b) -> (c -> a) -> c -> c -> b
 * @param {Function} f a binary function
 * @param {Function} g a unary function
 * @param {any} a any value
 * @param {any} b any value
 * @return {any} The result of `f`
 * @example
 *
 *      const eqBy = R.on((a, b) => a === b);
 *      eqBy(R.prop('a'), {b:0, a:1}, {a:1}) //=> true;
 *
 *      const containsInsensitive = R.on(R.contains, R.toLower);
 *      containsInsensitive('o', 'FOO'); //=> true
 * @symb R.on(f, g, a, b) = f(g(a), g(b))
 */ var $088aa8700417d5d7$var$on = /*#__PURE__*/ (0, $2ikoZ.default)(4, [], function on(f, g, a, b) {
    return f(g(a), g(b));
});
var $088aa8700417d5d7$export$2e2bcd8739ae039 = $088aa8700417d5d7$var$on;

});

parcelRegister("77Q6n", function(module, exports) {

var $fe9oK = parcelRequire("fe9oK");

var $lrIA4 = parcelRequire("lrIA4");
/**
 * Accepts a function `fn` and returns a function that guards invocation of
 * `fn` such that `fn` can only ever be called once, no matter how many times
 * the returned function is invoked. The first value calculated is returned in
 * subsequent invocations.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (a... -> b) -> (a... -> b)
 * @param {Function} fn The function to wrap in a call-only-once wrapper.
 * @return {Function} The wrapped function.
 * @example
 *
 *      const addOneOnce = R.once(x => x + 1);
 *      addOneOnce(10); //=> 11
 *      addOneOnce(addOneOnce(50)); //=> 11
 */ var $53019a37ee058a5f$var$once = /*#__PURE__*/ (0, $lrIA4.default)(function once(fn) {
    var called = false;
    var result;
    return (0, $fe9oK.default)(fn.length, function() {
        if (called) return result;
        called = true;
        result = fn.apply(this, arguments);
        return result;
    });
});
var $53019a37ee058a5f$export$2e2bcd8739ae039 = $53019a37ee058a5f$var$once;

});

parcelRegister("7ax8J", function(module, exports) {

var $4E2dE = parcelRequire("4E2dE");

var $1ckyD = parcelRequire("1ckyD");
/**
 * Returns the result of applying the onFailure function to the value inside
 * a failed promise. This is useful for handling rejected promises
 * inside function compositions.
 *
 * @func
 * @memberOf R
 * @since v0.26.0
 * @category Function
 * @sig (e -> b) -> (Promise e a) -> (Promise e b)
 * @sig (e -> (Promise f b)) -> (Promise e a) -> (Promise f b)
 * @param {Function} onFailure The function to apply. Can return a value or a promise of a value.
 * @param {Promise} p
 * @return {Promise} The result of calling `p.then(null, onFailure)`
 * @see R.andThen
 * @example
 *
 *      const failedFetch = id => Promise.reject('bad ID');
 *      const useDefault = () => ({ firstName: 'Bob', lastName: 'Loblaw' });
 *
 *      //recoverFromFailure :: String -> Promise ({ firstName, lastName })
 *      const recoverFromFailure = R.pipe(
 *        failedFetch,
 *        R.otherwise(useDefault),
 *        R.andThen(R.pick(['firstName', 'lastName'])),
 *      );
 *      recoverFromFailure(12345).then(console.log);
 */ var $53832c77f608ffee$var$otherwise = /*#__PURE__*/ (0, $4E2dE.default)(function otherwise(f, p) {
    (0, $1ckyD.default)("otherwise", p);
    return p.then(null, f);
});
var $53832c77f608ffee$export$2e2bcd8739ae039 = $53832c77f608ffee$var$otherwise;

});
parcelRegister("1ckyD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0df6dbc54f82eeba$export$2e2bcd8739ae039; });

var $aizOG = parcelRequire("aizOG");

var $hAe6X = parcelRequire("hAe6X");
function $0df6dbc54f82eeba$export$2e2bcd8739ae039(name, p) {
    if (p == null || !(0, $aizOG.default)(p.then)) throw new TypeError("`" + name + "` expected a Promise, received " + (0, $hAe6X.default)(p, []));
}

});


parcelRegister("hon8i", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ca969f3d3632a631$export$2e2bcd8739ae039; });

var $cjSwl = parcelRequire("cjSwl");
// transforms the held value with the provided function.
var $ca969f3d3632a631$var$Identity = function(x) {
    return {
        value: x,
        map: function(f) {
            return $ca969f3d3632a631$var$Identity(f(x));
        }
    };
};
/**
 * Returns the result of "setting" the portion of the given data structure
 * focused by the given lens to the result of applying the given function to
 * the focused value.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig Lens s a -> (a -> a) -> s -> s
 * @param {Lens} lens
 * @param {*} v
 * @param {*} x
 * @return {*}
 * @see R.view, R.set, R.lens, R.lensIndex, R.lensProp, R.lensPath
 * @example
 *
 *      const headLens = R.lensIndex(0);
 *
 *      R.over(headLens, R.toUpper, ['foo', 'bar', 'baz']); //=> ['FOO', 'bar', 'baz']
 */ var $ca969f3d3632a631$var$over = /*#__PURE__*/ (0, $cjSwl.default)(function over(lens, f, x) {
    // The value returned by the getter function is first transformed with `f`,
    // then set as the value of an `Identity`. This is then mapped over with the
    // setter function of the lens.
    return lens(function(y) {
        return $ca969f3d3632a631$var$Identity(f(y));
    })(x).value;
});
var $ca969f3d3632a631$export$2e2bcd8739ae039 = $ca969f3d3632a631$var$over;

});

parcelRegister("hJlbw", function(module, exports) {

var $4E2dE = parcelRequire("4E2dE");
/**
 * Takes two arguments, `fst` and `snd`, and returns `[fst, snd]`.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category List
 * @sig a -> b -> (a,b)
 * @param {*} fst
 * @param {*} snd
 * @return {Array}
 * @see R.objOf, R.of
 * @example
 *
 *      R.pair('foo', 'bar'); //=> ['foo', 'bar']
 */ var $ce871280333fff80$var$pair = /*#__PURE__*/ (0, $4E2dE.default)(function pair(fst, snd) {
    return [
        fst,
        snd
    ];
});
var $ce871280333fff80$export$2e2bcd8739ae039 = $ce871280333fff80$var$pair;

});

parcelRegister("b43or", function(module, exports) {

var $cJJmw = parcelRequire("cJJmw");

var $aIBYG = parcelRequire("aIBYG");
/**
 * Takes a function `f` and a list of arguments, and returns a function `g`.
 * When applied, `g` returns the result of applying `f` to the arguments
 * provided initially followed by the arguments provided to `g`.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category Function
 * @sig ((a, b, c, ..., n) -> x) -> [a, b, c, ...] -> ((d, e, f, ..., n) -> x)
 * @param {Function} f
 * @param {Array} args
 * @return {Function}
 * @see R.partialRight, R.curry
 * @example
 *
 *      const multiply2 = (a, b) => a * b;
 *      const double = R.partial(multiply2, [2]);
 *      double(3); //=> 6
 *
 *      const greet = (salutation, title, firstName, lastName) =>
 *        salutation + ', ' + title + ' ' + firstName + ' ' + lastName + '!';
 *
 *      const sayHello = R.partial(greet, ['Hello']);
 *      const sayHelloToMs = R.partial(sayHello, ['Ms.']);
 *      sayHelloToMs('Jane', 'Jones'); //=> 'Hello, Ms. Jane Jones!'
 * @symb R.partial(f, [a, b])(c, d) = f(a, b, c, d)
 */ var $80e2b343e34c1031$var$partial = /*#__PURE__*/ (0, $aIBYG.default)((0, $cJJmw.default));
var $80e2b343e34c1031$export$2e2bcd8739ae039 = $80e2b343e34c1031$var$partial;

});
parcelRegister("aIBYG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7cdb790e9e2d39db$export$2e2bcd8739ae039; });

var $fe9oK = parcelRequire("fe9oK");

var $4E2dE = parcelRequire("4E2dE");
function $7cdb790e9e2d39db$export$2e2bcd8739ae039(concat) {
    return (0, $4E2dE.default)(function(fn, args) {
        return (0, $fe9oK.default)(Math.max(0, fn.length - args.length), function() {
            return fn.apply(this, concat(args, arguments));
        });
    });
}

});


parcelRegister("4R9pl", function(module, exports) {

var $cJJmw = parcelRequire("cJJmw");

var $aIBYG = parcelRequire("aIBYG");

var $44Hns = parcelRequire("44Hns");
/**
 * Takes a function `f` and a list of arguments, and returns a function `g`.
 * When applied, `g` returns the result of applying `f` to the arguments
 * provided to `g` followed by the arguments provided initially.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category Function
 * @sig ((a, b, c, ..., n) -> x) -> [d, e, f, ..., n] -> ((a, b, c, ...) -> x)
 * @param {Function} f
 * @param {Array} args
 * @return {Function}
 * @see R.partial
 * @example
 *
 *      const greet = (salutation, title, firstName, lastName) =>
 *        salutation + ', ' + title + ' ' + firstName + ' ' + lastName + '!';
 *
 *      const greetMsJaneJones = R.partialRight(greet, ['Ms.', 'Jane', 'Jones']);
 *
 *      greetMsJaneJones('Hello'); //=> 'Hello, Ms. Jane Jones!'
 * @symb R.partialRight(f, [a, b])(c, d) = f(c, d, a, b)
 */ var $389368d8a52edb7b$var$partialRight = /*#__PURE__*/ (0, $aIBYG.default)(/*#__PURE__*/ (0, $44Hns.default)((0, $cJJmw.default)));
var $389368d8a52edb7b$export$2e2bcd8739ae039 = $389368d8a52edb7b$var$partialRight;

});

parcelRegister("locxm", function(module, exports) {

var $f9Ph0 = parcelRequire("f9Ph0");

var $65e2B = parcelRequire("65e2B");

var $8MN2o = parcelRequire("8MN2o");
/**
 * Takes a predicate and a list or other `Filterable` object and returns the
 * pair of filterable objects of the same type of elements which do and do not
 * satisfy, the predicate, respectively. Filterable objects include plain objects or any object
 * that has a filter method such as `Array`.
 *
 * @func
 * @memberOf R
 * @since v0.1.4
 * @category List
 * @sig Filterable f => (a -> Boolean) -> f a -> [f a, f a]
 * @param {Function} pred A predicate to determine which side the element belongs to.
 * @param {Array} filterable the list (or other filterable) to partition.
 * @return {Array} An array, containing first the subset of elements that satisfy the
 *         predicate, and second the subset of elements that do not satisfy.
 * @see R.filter, R.reject
 * @example
 *
 *      R.partition(R.includes('s'), ['sss', 'ttt', 'foo', 'bars']);
 *      // => [ [ 'sss', 'bars' ],  [ 'ttt', 'foo' ] ]
 *
 *      R.partition(R.includes('s'), { a: 'sss', b: 'ttt', foo: 'bars' });
 *      // => [ { a: 'sss', foo: 'bars' }, { b: 'ttt' }  ]
 */ var $f9259078c97ad811$var$partition = /*#__PURE__*/ (0, $65e2B.default)([
    (0, $f9Ph0.default),
    (0, $8MN2o.default)
]);
var $f9259078c97ad811$export$2e2bcd8739ae039 = $f9259078c97ad811$var$partition;

});

parcelRegister("lGZP4", function(module, exports) {

var $cjSwl = parcelRequire("cjSwl");

var $imwRL = parcelRequire("imwRL");

var $6jckq = parcelRequire("6jckq");
/**
 * Determines whether a nested path on an object has a specific value, in
 * [`R.equals`](#equals) terms. Most likely used to filter a list.
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Relation
 * @typedefn Idx = String | Int | Symbol
 * @sig [Idx] -> a -> {a} -> Boolean
 * @param {Array} path The path of the nested property to use
 * @param {*} val The value to compare the nested property with
 * @param {Object} obj The object to check the nested property in
 * @return {Boolean} `true` if the value equals the nested object property,
 *         `false` otherwise.
 * @example
 *
 *      const user1 = { address: { zipCode: 90210 } };
 *      const user2 = { address: { zipCode: 55555 } };
 *      const user3 = { name: 'Bob' };
 *      const users = [ user1, user2, user3 ];
 *      const isFamous = R.pathEq(['address', 'zipCode'], 90210);
 *      R.filter(isFamous, users); //=> [ user1 ]
 */ var $fcad79e9acdcc1d0$var$pathEq = /*#__PURE__*/ (0, $cjSwl.default)(function pathEq(_path, val, obj) {
    return (0, $imwRL.default)((0, $6jckq.default)(_path, obj), val);
});
var $fcad79e9acdcc1d0$export$2e2bcd8739ae039 = $fcad79e9acdcc1d0$var$pathEq;

});

parcelRegister("bI2RE", function(module, exports) {

var $cjSwl = parcelRequire("cjSwl");

var $aggRQ = parcelRequire("aggRQ");

var $6jckq = parcelRequire("6jckq");
/**
 * If the given, non-null object has a value at the given path, returns the
 * value at that path. Otherwise returns the provided default value.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category Object
 * @typedefn Idx = String | Int | Symbol
 * @sig a -> [Idx] -> {a} -> a
 * @param {*} d The default value.
 * @param {Array} p The path to use.
 * @param {Object} obj The object to retrieve the nested property from.
 * @return {*} The data at `path` of the supplied object or the default value.
 * @example
 *
 *      R.pathOr('N/A', ['a', 'b'], {a: {b: 2}}); //=> 2
 *      R.pathOr('N/A', ['a', 'b'], {c: {b: 2}}); //=> "N/A"
 */ var $8866068be7659071$var$pathOr = /*#__PURE__*/ (0, $cjSwl.default)(function pathOr(d, p, obj) {
    return (0, $aggRQ.default)(d, (0, $6jckq.default)(p, obj));
});
var $8866068be7659071$export$2e2bcd8739ae039 = $8866068be7659071$var$pathOr;

});

parcelRegister("aw0nC", function(module, exports) {

var $cjSwl = parcelRequire("cjSwl");

var $6jckq = parcelRequire("6jckq");
/**
 * Returns `true` if the specified object property at given path satisfies the
 * given predicate; `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Logic
 * @typedefn Idx = String | Int | Symbol
 * @sig (a -> Boolean) -> [Idx] -> {a} -> Boolean
 * @param {Function} pred
 * @param {Array} propPath
 * @param {*} obj
 * @return {Boolean}
 * @see R.propSatisfies, R.path
 * @example
 *
 *      R.pathSatisfies(y => y > 0, ['x', 'y'], {x: {y: 2}}); //=> true
 *      R.pathSatisfies(R.is(Object), [], {x: {y: 2}}); //=> true
 */ var $7a7d2ff948259eda$var$pathSatisfies = /*#__PURE__*/ (0, $cjSwl.default)(function pathSatisfies(pred, propPath, obj) {
    return pred((0, $6jckq.default)(propPath, obj));
});
var $7a7d2ff948259eda$export$2e2bcd8739ae039 = $7a7d2ff948259eda$var$pathSatisfies;

});

parcelRegister("eWfni", function(module, exports) {

var $4E2dE = parcelRequire("4E2dE");
/**
 * Returns a partial copy of an object containing only the keys specified. If
 * the key does not exist, the property is ignored.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig [k] -> {k: v} -> {k: v}
 * @param {Array} names an array of String property names to copy onto a new object
 * @param {Object} obj The object to copy from
 * @return {Object} A new object with only properties from `names` on it.
 * @see R.omit, R.props
 * @example
 *
 *      R.pick(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, d: 4}
 *      R.pick(['a', 'e', 'f'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1}
 */ var $ae026895248fcf0c$var$pick = /*#__PURE__*/ (0, $4E2dE.default)(function pick(names, obj) {
    var result = {};
    var idx = 0;
    while(idx < names.length){
        if (names[idx] in obj) result[names[idx]] = obj[names[idx]];
        idx += 1;
    }
    return result;
});
var $ae026895248fcf0c$export$2e2bcd8739ae039 = $ae026895248fcf0c$var$pick;

});

parcelRegister("hmL6L", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ca490871ffa212e1$export$2e2bcd8739ae039; });

var $4E2dE = parcelRequire("4E2dE");
/**
 * Similar to `pick` except that this one includes a `key: undefined` pair for
 * properties that don't exist.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig [k] -> {k: v} -> {k: v}
 * @param {Array} names an array of String property names to copy onto a new object
 * @param {Object} obj The object to copy from
 * @return {Object} A new object with only properties from `names` on it.
 * @see R.pick
 * @example
 *
 *      R.pickAll(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, d: 4}
 *      R.pickAll(['a', 'e', 'f'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, e: undefined, f: undefined}
 */ var $ca490871ffa212e1$var$pickAll = /*#__PURE__*/ (0, $4E2dE.default)(function pickAll(names, obj) {
    var result = {};
    var idx = 0;
    var len = names.length;
    while(idx < len){
        var name = names[idx];
        result[name] = obj[name];
        idx += 1;
    }
    return result;
});
var $ca490871ffa212e1$export$2e2bcd8739ae039 = $ca490871ffa212e1$var$pickAll;

});

parcelRegister("3zcb7", function(module, exports) {

var $4E2dE = parcelRequire("4E2dE");
/**
 * Returns a partial copy of an object containing only the keys that satisfy
 * the supplied predicate.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Object
 * @sig ((v, k) -> Boolean) -> {k: v} -> {k: v}
 * @param {Function} pred A predicate to determine whether or not a key
 *        should be included on the output object.
 * @param {Object} obj The object to copy from
 * @return {Object} A new object with only properties that satisfy `pred`
 *         on it.
 * @see R.pick, R.filter
 * @example
 *
 *      const isUpperCase = (val, key) => key.toUpperCase() === key;
 *      R.pickBy(isUpperCase, {a: 1, b: 2, A: 3, B: 4}); //=> {A: 3, B: 4}
 */ var $298e1657652c939d$var$pickBy = /*#__PURE__*/ (0, $4E2dE.default)(function pickBy(test, obj) {
    var result = {};
    for(var prop in obj)if (test(obj[prop], prop, obj)) result[prop] = obj[prop];
    return result;
});
var $298e1657652c939d$export$2e2bcd8739ae039 = $298e1657652c939d$var$pickBy;

});

parcelRegister("hHIz2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ce39055502e8a381$export$2e2bcd8739ae039; });

var $cJJmw = parcelRequire("cJJmw");

var $4E2dE = parcelRequire("4E2dE");
/**
 * Returns a new list with the given element at the front, followed by the
 * contents of the list.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig a -> [a] -> [a]
 * @param {*} el The item to add to the head of the output list.
 * @param {Array} list The array to add to the tail of the output list.
 * @return {Array} A new array.
 * @see R.append
 * @example
 *
 *      R.prepend('fee', ['fi', 'fo', 'fum']); //=> ['fee', 'fi', 'fo', 'fum']
 */ var $ce39055502e8a381$var$prepend = /*#__PURE__*/ (0, $4E2dE.default)(function prepend(el, list) {
    return (0, $cJJmw.default)([
        el
    ], list);
});
var $ce39055502e8a381$export$2e2bcd8739ae039 = $ce39055502e8a381$var$prepend;

});

parcelRegister("ac5ki", function(module, exports) {

var $kN79E = parcelRequire("kN79E");

var $hv0Dt = parcelRequire("hv0Dt");
/**
 * Multiplies together all the elements of a list.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig [Number] -> Number
 * @param {Array} list An array of numbers
 * @return {Number} The product of all the numbers in the list.
 * @see R.reduce
 * @example
 *
 *      R.product([2,4,6,8,100,1]); //=> 38400
 */ var $76bf28132c8632b8$var$product = /*#__PURE__*/ (0, $hv0Dt.default)((0, $kN79E.default), 1);
var $76bf28132c8632b8$export$2e2bcd8739ae039 = $76bf28132c8632b8$var$product;

});

parcelRegister("3g8sN", function(module, exports) {

var $5DhuU = parcelRequire("5DhuU");

var $7x9UL = parcelRequire("7x9UL");

var $hmL6L = parcelRequire("hmL6L");

var $2PkVS = parcelRequire("2PkVS");
/**
 * Reasonable analog to SQL `select` statement.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @category Relation
 * @sig [k] -> [{k: v}] -> [{k: v}]
 * @param {Array} props The property names to project
 * @param {Array} objs The objects to query
 * @return {Array} An array of objects with just the `props` properties.
 * @see R.pluck, R.props, R.prop
 * @example
 *
 *      const abby = {name: 'Abby', age: 7, hair: 'blond', grade: 2};
 *      const fred = {name: 'Fred', age: 12, hair: 'brown', grade: 7};
 *      const kids = [abby, fred];
 *      R.project(['name', 'grade'], kids); //=> [{name: 'Abby', grade: 2}, {name: 'Fred', grade: 7}]
 */ var $25f96e627b2a0b43$var$project = /*#__PURE__*/ (0, $2PkVS.default)((0, $5DhuU.default), [
    (0, $hmL6L.default),
    (0, $7x9UL.default)
]); // passing `identity` gives correct arity
var $25f96e627b2a0b43$export$2e2bcd8739ae039 = $25f96e627b2a0b43$var$project;

});
parcelRegister("2PkVS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $20f094eff3a210e5$export$2e2bcd8739ae039; });

var $4E2dE = parcelRequire("4E2dE");

var $4fS8E = parcelRequire("4fS8E");
/**
 * Accepts a function `fn` and a list of transformer functions and returns a
 * new curried function. When the new function is invoked, it calls the
 * function `fn` with parameters consisting of the result of calling each
 * supplied handler on successive arguments to the new function.
 *
 * If more arguments are passed to the returned function than transformer
 * functions, those arguments are passed directly to `fn` as additional
 * parameters. If you expect additional arguments that don't need to be
 * transformed, although you can ignore them, it's best to pass an identity
 * function so that the new function reports the correct arity.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig ((x1, x2, ...) -> z) -> [(a -> x1), (b -> x2), ...] -> (a -> b -> ... -> z)
 * @param {Function} fn The function to wrap.
 * @param {Array} transformers A list of transformer functions
 * @return {Function} The wrapped function.
 * @see R.converge
 * @example
 *
 *      R.useWith(Math.pow, [R.identity, R.identity])(3, 4); //=> 81
 *      R.useWith(Math.pow, [R.identity, R.identity])(3)(4); //=> 81
 *      R.useWith(Math.pow, [R.dec, R.inc])(3, 4); //=> 32
 *      R.useWith(Math.pow, [R.dec, R.inc])(3)(4); //=> 32
 * @symb R.useWith(f, [g, h])(a, b) = f(g(a), h(b))
 */ var $20f094eff3a210e5$var$useWith = /*#__PURE__*/ (0, $4E2dE.default)(function useWith(fn, transformers) {
    return (0, $4fS8E.default)(transformers.length, function() {
        var args = [];
        var idx = 0;
        while(idx < transformers.length){
            args.push(transformers[idx].call(this, arguments[idx]));
            idx += 1;
        }
        return fn.apply(this, args.concat(Array.prototype.slice.call(arguments, transformers.length)));
    });
});
var $20f094eff3a210e5$export$2e2bcd8739ae039 = $20f094eff3a210e5$var$useWith;

});


parcelRegister("39UUv", function(module, exports) {

var $cjSwl = parcelRequire("cjSwl");

var $AZnlR = parcelRequire("AZnlR");

var $goOmY = parcelRequire("goOmY");

var $e4gFA = parcelRequire("e4gFA");
/**
 * Takes two functions as pre- and post- processors respectively for a third function,
 * i.e. `promap(f, g, h)(x) === g(h(f(x)))`.
 *
 * Dispatches to the `promap` method of the third argument, if present,
 * according to the [FantasyLand Profunctor spec](https://github.com/fantasyland/fantasy-land#profunctor).
 *
 * Acts as a transducer if a transformer is given in profunctor position.
 *
 * @func
 * @memberOf R
 * @since v0.28.0
 * @category Function
 * @sig (a -> b) -> (c -> d) -> (b -> c) -> (a -> d)
 * @sig Profunctor p => (a -> b) -> (c -> d) -> p b c -> p a d
 * @param {Function} f The preprocessor function, a -> b
 * @param {Function} g The postprocessor function, c -> d
 * @param {Profunctor} profunctor The profunctor instance to be promapped, e.g. b -> c
 * @return {Profunctor} The new profunctor instance, e.g. a -> d
 * @see R.transduce
 * @example
 *
 *      const decodeChar = R.promap(s => s.charCodeAt(), String.fromCharCode, R.add(-8))
 *      const decodeString = R.promap(R.split(''), R.join(''), R.map(decodeChar))
 *      decodeString("ziuli") //=> "ramda"
 *
 * @symb R.promap(f, g, h) = x => g(h(f(x)))
 * @symb R.promap(f, g, profunctor) = profunctor.promap(f, g)
 */ var $24ce5b953c166458$var$promap = /*#__PURE__*/ (0, $cjSwl.default)(/*#__PURE__*/ (0, $AZnlR.default)([
    "fantasy-land/promap",
    "promap"
], (0, $e4gFA.default), (0, $goOmY.default)));
var $24ce5b953c166458$export$2e2bcd8739ae039 = $24ce5b953c166458$var$promap;

});
parcelRegister("goOmY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bf05f595f298aa5e$export$2e2bcd8739ae039; });
function $bf05f595f298aa5e$export$2e2bcd8739ae039(f, g, profunctor) {
    return function(x) {
        return g(profunctor(f(x)));
    };
}

});

parcelRegister("e4gFA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a3de5eb2c6d6532b$export$2e2bcd8739ae039; });

var $cjSwl = parcelRequire("cjSwl");

var $dki4v = parcelRequire("dki4v");

var $goOmY = parcelRequire("goOmY");
var $a3de5eb2c6d6532b$var$XPromap = /*#__PURE__*/ function() {
    function XPromap(f, g, xf) {
        this.xf = xf;
        this.f = f;
        this.g = g;
    }
    XPromap.prototype["@@transducer/init"] = (0, $dki4v.default).init;
    XPromap.prototype["@@transducer/result"] = (0, $dki4v.default).result;
    XPromap.prototype["@@transducer/step"] = function(result, input) {
        return this.xf["@@transducer/step"](result, (0, $goOmY.default)(this.f, this.g, input));
    };
    return XPromap;
}();
var $a3de5eb2c6d6532b$var$_xpromap = /*#__PURE__*/ (0, $cjSwl.default)(function _xpromap(f, g, xf) {
    return new $a3de5eb2c6d6532b$var$XPromap(f, g, xf);
});
var $a3de5eb2c6d6532b$export$2e2bcd8739ae039 = $a3de5eb2c6d6532b$var$_xpromap;

});


parcelRegister("gU8MS", function(module, exports) {

var $cjSwl = parcelRequire("cjSwl");

var $hvsdM = parcelRequire("hvsdM");

var $imwRL = parcelRequire("imwRL");
/**
 * Returns `true` if the specified object property is equal, in
 * [`R.equals`](#equals) terms, to the given value; `false` otherwise.
 * You can test multiple properties with [`R.whereEq`](#whereEq).
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig String -> a -> Object -> Boolean
 * @param {String} name
 * @param {*} val
 * @param {*} obj
 * @return {Boolean}
 * @see R.whereEq, R.propSatisfies, R.equals
 * @example
 *
 *      const abby = {name: 'Abby', age: 7, hair: 'blond'};
 *      const fred = {name: 'Fred', age: 12, hair: 'brown'};
 *      const rusty = {name: 'Rusty', age: 10, hair: 'brown'};
 *      const alois = {name: 'Alois', age: 15, disposition: 'surly'};
 *      const kids = [abby, fred, rusty, alois];
 *      const hasBrownHair = R.propEq('hair', 'brown');
 *      R.filter(hasBrownHair, kids); //=> [fred, rusty]
 */ var $c4e8b1464bb69a52$var$propEq = /*#__PURE__*/ (0, $cjSwl.default)(function propEq(name, val, obj) {
    return (0, $imwRL.default)(val, (0, $hvsdM.default)(name, obj));
});
var $c4e8b1464bb69a52$export$2e2bcd8739ae039 = $c4e8b1464bb69a52$var$propEq;

});

parcelRegister("7KKWT", function(module, exports) {

var $cjSwl = parcelRequire("cjSwl");

var $hvsdM = parcelRequire("hvsdM");

var $cOkKO = parcelRequire("cOkKO");
/**
 * Returns `true` if the specified object property is of the given type;
 * `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Type
 * @sig Type -> String -> Object -> Boolean
 * @param {Function} type
 * @param {String} name
 * @param {*} obj
 * @return {Boolean}
 * @see R.is, R.propSatisfies
 * @example
 *
 *      R.propIs(Number, 'x', {x: 1, y: 2});  //=> true
 *      R.propIs(Number, 'x', {x: 'foo'});    //=> false
 *      R.propIs(Number, 'x', {});            //=> false
 */ var $5a513f56c17c3ea1$var$propIs = /*#__PURE__*/ (0, $cjSwl.default)(function propIs(type, name, obj) {
    return (0, $cOkKO.default)(type, (0, $hvsdM.default)(name, obj));
});
var $5a513f56c17c3ea1$export$2e2bcd8739ae039 = $5a513f56c17c3ea1$var$propIs;

});

parcelRegister("3atyM", function(module, exports) {

var $cjSwl = parcelRequire("cjSwl");

var $aggRQ = parcelRequire("aggRQ");

var $hvsdM = parcelRequire("hvsdM");
/**
 * Return the specified property of the given non-null object if the property
 * is present and it's value is not `null`, `undefined` or `NaN`.
 *
 * Otherwise the first argument is returned.
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category Object
 * @sig a -> String -> Object -> a
 * @param {*} val The default value.
 * @param {String} p The name of the property to return.
 * @param {Object} obj The object to query.
 * @return {*} The value of given property of the supplied object or the default value.
 * @example
 *
 *      const alice = {
 *        name: 'ALICE',
 *        age: 101
 *      };
 *      const favorite = R.prop('favoriteLibrary');
 *      const favoriteWithDefault = R.propOr('Ramda', 'favoriteLibrary');
 *
 *      favorite(alice);  //=> undefined
 *      favoriteWithDefault(alice);  //=> 'Ramda'
 */ var $24e93c439875b29d$var$propOr = /*#__PURE__*/ (0, $cjSwl.default)(function propOr(val, p, obj) {
    return (0, $aggRQ.default)(val, (0, $hvsdM.default)(p, obj));
});
var $24e93c439875b29d$export$2e2bcd8739ae039 = $24e93c439875b29d$var$propOr;

});

parcelRegister("5yk0W", function(module, exports) {

var $cjSwl = parcelRequire("cjSwl");

var $hvsdM = parcelRequire("hvsdM");
/**
 * Returns `true` if the specified object property satisfies the given
 * predicate; `false` otherwise. You can test multiple properties with
 * [`R.where`](#where).
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Logic
 * @sig (a -> Boolean) -> String -> {String: a} -> Boolean
 * @param {Function} pred
 * @param {String} name
 * @param {*} obj
 * @return {Boolean}
 * @see R.where, R.propEq, R.propIs
 * @example
 *
 *      R.propSatisfies(x => x > 0, 'x', {x: 1, y: 2}); //=> true
 */ var $40afa7211474ef07$var$propSatisfies = /*#__PURE__*/ (0, $cjSwl.default)(function propSatisfies(pred, name, obj) {
    return pred((0, $hvsdM.default)(name, obj));
});
var $40afa7211474ef07$export$2e2bcd8739ae039 = $40afa7211474ef07$var$propSatisfies;

});

parcelRegister("2nBbR", function(module, exports) {

var $4E2dE = parcelRequire("4E2dE");

var $6jckq = parcelRequire("6jckq");
/**
 * Acts as multiple `prop`: array of keys in, array of values out. Preserves
 * order.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig [k] -> {k: v} -> [v]
 * @param {Array} ps The property names to fetch
 * @param {Object} obj The object to query
 * @return {Array} The corresponding values or partially applied function.
 * @see R.prop, R.pluck, R.project
 * @example
 *
 *      R.props(['x', 'y'], {x: 1, y: 2}); //=> [1, 2]
 *      R.props(['c', 'a', 'b'], {b: 2, a: 1}); //=> [undefined, 1, 2]
 *
 *      const fullName = R.compose(R.join(' '), R.props(['first', 'last']));
 *      fullName({last: 'Bullet-Tooth', age: 33, first: 'Tony'}); //=> 'Tony Bullet-Tooth'
 */ var $1bba93f323a9dc31$var$props = /*#__PURE__*/ (0, $4E2dE.default)(function props(ps, obj) {
    return ps.map(function(p) {
        return (0, $6jckq.default)([
            p
        ], obj);
    });
});
var $1bba93f323a9dc31$export$2e2bcd8739ae039 = $1bba93f323a9dc31$var$props;

});

parcelRegister("3RZ3d", function(module, exports) {

var $4E2dE = parcelRequire("4E2dE");

var $8xbXG = parcelRequire("8xbXG");
/**
 * Returns a list of numbers from `from` (inclusive) to `to` (exclusive).
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Number -> Number -> [Number]
 * @param {Number} from The first number in the list.
 * @param {Number} to One more than the last number in the list.
 * @return {Array} The list of numbers in the set `[a, b)`.
 * @example
 *
 *      R.range(1, 5);    //=> [1, 2, 3, 4]
 *      R.range(50, 53);  //=> [50, 51, 52]
 */ var $2d15adc4b4d561d6$var$range = /*#__PURE__*/ (0, $4E2dE.default)(function range(from, to) {
    if (!((0, $8xbXG.default)(from) && (0, $8xbXG.default)(to))) throw new TypeError("Both arguments to range must be numbers");
    var result = [];
    var n = from;
    while(n < to){
        result.push(n);
        n += 1;
    }
    return result;
});
var $2d15adc4b4d561d6$export$2e2bcd8739ae039 = $2d15adc4b4d561d6$var$range;

});

parcelRegister("6lfus", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $49e0b845ecdcd1fd$export$2e2bcd8739ae039; });

var $cjSwl = parcelRequire("cjSwl");
/**
 * Returns a single item by iterating through the list, successively calling
 * the iterator function and passing it an accumulator value and the current
 * value from the array, and then passing the result to the next call.
 *
 * Similar to [`reduce`](#reduce), except moves through the input list from the
 * right to the left.
 *
 * The iterator function receives two values: *(value, acc)*, while the arguments'
 * order of `reduce`'s iterator function is *(acc, value)*. `reduceRight` may use [`reduced`](#reduced)
 * to short circuit the iteration.
 *
 * Note: `R.reduceRight` does not skip deleted or unassigned indices (sparse
 * arrays), unlike the native `Array.prototype.reduceRight` method. For more details
 * on this behavior, see:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduceRight#Description
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig ((a, b) -> b) -> b -> [a] -> b
 * @param {Function} fn The iterator function. Receives two values, the current element from the array
 *        and the accumulator.
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduce, R.addIndex, R.reduced
 * @example
 *
 *      R.reduceRight(R.subtract, 0, [1, 2, 3, 4]) // => (1 - (2 - (3 - (4 - 0)))) = -2
 *      //    -               -2
 *      //   / \              / \
 *      //  1   -            1   3
 *      //     / \              / \
 *      //    2   -     ==>    2  -1
 *      //       / \              / \
 *      //      3   -            3   4
 *      //         / \              / \
 *      //        4   0            4   0
 *
 * @symb R.reduceRight(f, a, [b, c, d]) = f(b, f(c, f(d, a)))
 */ var $49e0b845ecdcd1fd$var$reduceRight = /*#__PURE__*/ (0, $cjSwl.default)(function reduceRight(fn, acc, list) {
    var idx = list.length - 1;
    while(idx >= 0){
        acc = fn(list[idx], acc);
        if (acc && acc["@@transducer/reduced"]) {
            acc = acc["@@transducer/value"];
            break;
        }
        idx -= 1;
    }
    return acc;
});
var $49e0b845ecdcd1fd$export$2e2bcd8739ae039 = $49e0b845ecdcd1fd$var$reduceRight;

});

parcelRegister("4IOvg", function(module, exports) {

var $2ikoZ = parcelRequire("2ikoZ");

var $jdcIJ = parcelRequire("jdcIJ");

var $1OnxV = parcelRequire("1OnxV");
/**
 * Like [`reduce`](#reduce), `reduceWhile` returns a single item by iterating
 * through the list, successively calling the iterator function. `reduceWhile`
 * also takes a predicate that is evaluated before each step. If the predicate
 * returns `false`, it "short-circuits" the iteration and returns the current
 * value of the accumulator. `reduceWhile` may alternatively be short-circuited
 * via [`reduced`](#reduced).
 *
 * @func
 * @memberOf R
 * @since v0.22.0
 * @category List
 * @sig ((a, b) -> Boolean) -> ((a, b) -> a) -> a -> [b] -> a
 * @param {Function} pred The predicate. It is passed the accumulator and the
 *        current element.
 * @param {Function} fn The iterator function. Receives two values, the
 *        accumulator and the current element.
 * @param {*} a The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduce, R.reduced
 * @example
 *
 *      const isOdd = (acc, x) => x % 2 !== 0;
 *      const xs = [1, 3, 5, 60, 777, 800];
 *      R.reduceWhile(isOdd, R.add, 0, xs); //=> 9
 *
 *      const ys = [2, 4, 6]
 *      R.reduceWhile(isOdd, R.add, 111, ys); //=> 111
 */ var $3702726696c4400e$var$reduceWhile = /*#__PURE__*/ (0, $2ikoZ.default)(4, [], function _reduceWhile(pred, fn, a, list) {
    return (0, $jdcIJ.default)(function(acc, x) {
        return pred(acc, x) ? fn(acc, x) : (0, $1OnxV.default)(acc);
    }, a, list);
});
var $3702726696c4400e$export$2e2bcd8739ae039 = $3702726696c4400e$var$reduceWhile;

});

parcelRegister("37pBi", function(module, exports) {

var $lrIA4 = parcelRequire("lrIA4");

var $1OnxV = parcelRequire("1OnxV");
/**
 * Returns a value wrapped to indicate that it is the final value of the reduce
 * and transduce functions. The returned value should be considered a black
 * box: the internal structure is not guaranteed to be stable.
 *
 * This optimization is available to the below functions:
 * - [`reduce`](#reduce)
 * - [`reduceWhile`](#reduceWhile)
 * - [`reduceBy`](#reduceBy)
 * - [`reduceRight`](#reduceRight)
 * - [`transduce`](#transduce)
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category List
 * @sig a -> *
 * @param {*} x The final value of the reduce.
 * @return {*} The wrapped value.
 * @see R.reduce, R.reduceWhile, R.reduceBy, R.reduceRight, R.transduce
 * @example
 *
 *     R.reduce(
 *       (acc, item) => item > 3 ? R.reduced(acc) : acc.concat(item),
 *       [],
 *       [1, 2, 3, 4, 5]) // [1, 2, 3]
 */ var $2455e24438bd3dde$var$reduced = /*#__PURE__*/ (0, $lrIA4.default)((0, $1OnxV.default));
var $2455e24438bd3dde$export$2e2bcd8739ae039 = $2455e24438bd3dde$var$reduced;

});

parcelRegister("4OLsx", function(module, exports) {

var $4E2dE = parcelRequire("4E2dE");

var $kYiXR = parcelRequire("kYiXR");

var $a4Usn = parcelRequire("a4Usn");
/**
 * Returns a fixed list of size `n` containing a specified identical value.
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category List
 * @sig a -> n -> [a]
 * @param {*} value The value to repeat.
 * @param {Number} n The desired size of the output list.
 * @return {Array} A new array containing `n` `value`s.
 * @see R.times
 * @example
 *
 *      R.repeat('hi', 5); //=> ['hi', 'hi', 'hi', 'hi', 'hi']
 *
 *      const obj = {};
 *      const repeatedObjs = R.repeat(obj, 5); //=> [{}, {}, {}, {}, {}]
 *      repeatedObjs[0] === repeatedObjs[1]; //=> true
 * @symb R.repeat(a, 0) = []
 * @symb R.repeat(a, 1) = [a]
 * @symb R.repeat(a, 2) = [a, a]
 */ var $3820a5608686fccd$var$repeat = /*#__PURE__*/ (0, $4E2dE.default)(function repeat(value, n) {
    return (0, $a4Usn.default)((0, $kYiXR.default)(value), n);
});
var $3820a5608686fccd$export$2e2bcd8739ae039 = $3820a5608686fccd$var$repeat;

});
parcelRegister("a4Usn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7566123e4d51f501$export$2e2bcd8739ae039; });

var $4E2dE = parcelRequire("4E2dE");
/**
 * Calls an input function `n` times, returning an array containing the results
 * of those function calls.
 *
 * `fn` is passed one argument: The current value of `n`, which begins at `0`
 * and is gradually incremented to `n - 1`.
 *
 * @func
 * @memberOf R
 * @since v0.2.3
 * @category List
 * @sig (Number -> a) -> Number -> [a]
 * @param {Function} fn The function to invoke. Passed one argument, the current value of `n`.
 * @param {Number} n A value between `0` and `n - 1`. Increments after each function call.
 * @return {Array} An array containing the return values of all calls to `fn`.
 * @see R.repeat
 * @example
 *
 *      R.times(R.identity, 5); //=> [0, 1, 2, 3, 4]
 * @symb R.times(f, 0) = []
 * @symb R.times(f, 1) = [f(0)]
 * @symb R.times(f, 2) = [f(0), f(1)]
 */ var $7566123e4d51f501$var$times = /*#__PURE__*/ (0, $4E2dE.default)(function times(fn, n) {
    var len = Number(n);
    var idx = 0;
    var list;
    if (len < 0 || isNaN(len)) throw new RangeError("n must be a non-negative number");
    list = new Array(len);
    while(idx < len){
        list[idx] = fn(idx);
        idx += 1;
    }
    return list;
});
var $7566123e4d51f501$export$2e2bcd8739ae039 = $7566123e4d51f501$var$times;

});


parcelRegister("bDzpV", function(module, exports) {

var $cjSwl = parcelRequire("cjSwl");
/**
 * Replace a substring or regex match in a string with a replacement.
 *
 * The first two parameters correspond to the parameters of the
 * `String.prototype.replace()` function, so the second parameter can also be a
 * function.
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category String
 * @sig RegExp|String -> String -> String -> String
 * @param {RegExp|String} pattern A regular expression or a substring to match.
 * @param {String} replacement The string to replace the matches with.
 * @param {String} str The String to do the search and replacement in.
 * @return {String} The result.
 * @example
 *
 *      R.replace('foo', 'bar', 'foo foo foo'); //=> 'bar foo foo'
 *      R.replace(/foo/, 'bar', 'foo foo foo'); //=> 'bar foo foo'
 *
 *      // Use the "g" (global) flag to replace all occurrences:
 *      R.replace(/foo/g, 'bar', 'foo foo foo'); //=> 'bar bar bar'
 */ var $878ecf55be3c51e0$var$replace = /*#__PURE__*/ (0, $cjSwl.default)(function replace(regex, replacement, str) {
    return str.replace(regex, replacement);
});
var $878ecf55be3c51e0$export$2e2bcd8739ae039 = $878ecf55be3c51e0$var$replace;

});

parcelRegister("iUpGr", function(module, exports) {

var $cjSwl = parcelRequire("cjSwl");
/**
 * Scan is similar to [`reduce`](#reduce), but returns a list of successively
 * reduced values from the left
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category List
 * @sig ((a, b) -> a) -> a -> [b] -> [a]
 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
 *        current element from the array
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {Array} A list of all intermediately reduced values.
 * @see R.reduce, R.mapAccum
 * @example
 *
 *      const numbers = [1, 2, 3, 4];
 *      const factorials = R.scan(R.multiply, 1, numbers); //=> [1, 1, 2, 6, 24]
 * @symb R.scan(f, a, [b, c]) = [a, f(a, b), f(f(a, b), c)]
 */ var $dc416132ce6b9024$var$scan = /*#__PURE__*/ (0, $cjSwl.default)(function scan(fn, acc, list) {
    var idx = 0;
    var len = list.length;
    var result = [
        acc
    ];
    while(idx < len){
        acc = fn(acc, list[idx]);
        result[idx + 1] = acc;
        idx += 1;
    }
    return result;
});
var $dc416132ce6b9024$export$2e2bcd8739ae039 = $dc416132ce6b9024$var$scan;

});

parcelRegister("kM76K", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f1fdcdd4ff61623f$export$2e2bcd8739ae039; });

var $4E2dE = parcelRequire("4E2dE");

var $7WWJI = parcelRequire("7WWJI");

var $aaiYf = parcelRequire("aaiYf");

var $hHIz2 = parcelRequire("hHIz2");

var $6lfus = parcelRequire("6lfus");
/**
 * Transforms a [Traversable](https://github.com/fantasyland/fantasy-land#traversable)
 * of [Applicative](https://github.com/fantasyland/fantasy-land#applicative) into an
 * Applicative of Traversable.
 *
 * Dispatches to the `sequence` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig (Applicative f, Traversable t) => (a -> f a) -> t (f a) -> f (t a)
 * @param {Function} of
 * @param {*} traversable
 * @return {*}
 * @see R.traverse
 * @example
 *
 *      R.sequence(Maybe.of, [Just(1), Just(2), Just(3)]);   //=> Just([1, 2, 3])
 *      R.sequence(Maybe.of, [Just(1), Just(2), Nothing()]); //=> Nothing()
 *
 *      R.sequence(R.of, Just([1, 2, 3])); //=> [Just(1), Just(2), Just(3)]
 *      R.sequence(R.of, Nothing());       //=> [Nothing()]
 */ var $f1fdcdd4ff61623f$var$sequence = /*#__PURE__*/ (0, $4E2dE.default)(function sequence(of, traversable) {
    return typeof traversable.sequence === "function" ? traversable.sequence(of) : (0, $6lfus.default)(function(x, acc) {
        return (0, $7WWJI.default)((0, $aaiYf.default)((0, $hHIz2.default), x), acc);
    }, of([]), traversable);
});
var $f1fdcdd4ff61623f$export$2e2bcd8739ae039 = $f1fdcdd4ff61623f$var$sequence;

});

parcelRegister("3CcZV", function(module, exports) {

var $cjSwl = parcelRequire("cjSwl");

var $kYiXR = parcelRequire("kYiXR");

var $hon8i = parcelRequire("hon8i");
/**
 * Returns the result of "setting" the portion of the given data structure
 * focused by the given lens to the given value.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig Lens s a -> a -> s -> s
 * @param {Lens} lens
 * @param {*} v
 * @param {*} x
 * @return {*}
 * @see R.view, R.over, R.lens, R.lensIndex, R.lensProp, R.lensPath
 * @example
 *
 *      const xLens = R.lensProp('x');
 *
 *      R.set(xLens, 4, {x: 1, y: 2});  //=> {x: 4, y: 2}
 *      R.set(xLens, 8, {x: 1, y: 2});  //=> {x: 8, y: 2}
 */ var $2a1f00cb7732ecd5$var$set = /*#__PURE__*/ (0, $cjSwl.default)(function set(lens, v, x) {
    return (0, $hon8i.default)(lens, (0, $kYiXR.default)(v), x);
});
var $2a1f00cb7732ecd5$export$2e2bcd8739ae039 = $2a1f00cb7732ecd5$var$set;

});

parcelRegister("heWex", function(module, exports) {

var $4E2dE = parcelRequire("4E2dE");
/**
 * Returns a copy of the list, sorted according to the comparator function,
 * which should accept two values at a time and return a negative number if the
 * first value is smaller, a positive number if it's larger, and zero if they
 * are equal. Please note that this is a **copy** of the list. It does not
 * modify the original.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig ((a, a) -> Number) -> [a] -> [a]
 * @param {Function} comparator A sorting function :: a -> b -> Int
 * @param {Array} list The list to sort
 * @return {Array} a new array with its elements sorted by the comparator function.
 * @see R.ascend, R.descend
 * @example
 *
 *      const diff = function(a, b) { return a - b; };
 *      R.sort(diff, [4,2,7,5]); //=> [2, 4, 5, 7]
 */ var $c8d0ea6e26c37d30$var$sort = /*#__PURE__*/ (0, $4E2dE.default)(function sort(comparator, list) {
    return Array.prototype.slice.call(list, 0).sort(comparator);
});
var $c8d0ea6e26c37d30$export$2e2bcd8739ae039 = $c8d0ea6e26c37d30$var$sort;

});

parcelRegister("fE7W5", function(module, exports) {

var $4E2dE = parcelRequire("4E2dE");
/**
 * Sorts the list according to the supplied function.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord b => (a -> b) -> [a] -> [a]
 * @param {Function} fn
 * @param {Array} list The list to sort.
 * @return {Array} A new list sorted by the keys generated by `fn`.
 * @example
 *
 *      const sortByFirstItem = R.sortBy(R.prop(0));
 *      const pairs = [[-1, 1], [-2, 2], [-3, 3]];
 *      sortByFirstItem(pairs); //=> [[-3, 3], [-2, 2], [-1, 1]]
 *
 *      const sortByNameCaseInsensitive = R.sortBy(R.compose(R.toLower, R.prop('name')));
 *      const alice = {
 *        name: 'ALICE',
 *        age: 101
 *      };
 *      const bob = {
 *        name: 'Bob',
 *        age: -10
 *      };
 *      const clara = {
 *        name: 'clara',
 *        age: 314.159
 *      };
 *      const people = [clara, bob, alice];
 *      sortByNameCaseInsensitive(people); //=> [alice, bob, clara]
 */ var $b640bf58e35f897e$var$sortBy = /*#__PURE__*/ (0, $4E2dE.default)(function sortBy(fn, list) {
    return Array.prototype.slice.call(list, 0).sort(function(a, b) {
        var aa = fn(a);
        var bb = fn(b);
        return aa < bb ? -1 : aa > bb ? 1 : 0;
    });
});
var $b640bf58e35f897e$export$2e2bcd8739ae039 = $b640bf58e35f897e$var$sortBy;

});

parcelRegister("c1Uip", function(module, exports) {

var $4E2dE = parcelRequire("4E2dE");
/**
 * Sorts a list according to a list of comparators.
 *
 * @func
 * @memberOf R
 * @since v0.23.0
 * @category Relation
 * @sig [(a, a) -> Number] -> [a] -> [a]
 * @param {Array} functions A list of comparator functions.
 * @param {Array} list The list to sort.
 * @return {Array} A new list sorted according to the comarator functions.
 * @see R.ascend, R.descend
 * @example
 *
 *      const alice = {
 *        name: 'alice',
 *        age: 40
 *      };
 *      const bob = {
 *        name: 'bob',
 *        age: 30
 *      };
 *      const clara = {
 *        name: 'clara',
 *        age: 40
 *      };
 *      const people = [clara, bob, alice];
 *      const ageNameSort = R.sortWith([
 *        R.descend(R.prop('age')),
 *        R.ascend(R.prop('name'))
 *      ]);
 *      ageNameSort(people); //=> [alice, clara, bob]
 */ var $8c213f3d04b76ba8$var$sortWith = /*#__PURE__*/ (0, $4E2dE.default)(function sortWith(fns, list) {
    return Array.prototype.slice.call(list, 0).sort(function(a, b) {
        var result = 0;
        var i = 0;
        while(result === 0 && i < fns.length){
            result = fns[i](a, b);
            i += 1;
        }
        return result;
    });
});
var $8c213f3d04b76ba8$export$2e2bcd8739ae039 = $8c213f3d04b76ba8$var$sortWith;

});

parcelRegister("h1eaD", function(module, exports) {

var $cEVJS = parcelRequire("cEVJS");
/**
 * Splits a string into an array of strings based on the given
 * separator.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category String
 * @sig (String | RegExp) -> String -> [String]
 * @param {String|RegExp} sep The pattern.
 * @param {String} str The string to separate into an array.
 * @return {Array} The array of strings from `str` separated by `sep`.
 * @see R.join
 * @example
 *
 *      const pathComponents = R.split('/');
 *      R.tail(pathComponents('/usr/local/bin/node')); //=> ['usr', 'local', 'bin', 'node']
 *
 *      R.split('.', 'a.b.c.xyz.d'); //=> ['a', 'b', 'c', 'xyz', 'd']
 */ var $c63d85a5b1728b87$var$split = /*#__PURE__*/ (0, $cEVJS.default)(1, "split");
var $c63d85a5b1728b87$export$2e2bcd8739ae039 = $c63d85a5b1728b87$var$split;

});

parcelRegister("2IhIz", function(module, exports) {

var $4E2dE = parcelRequire("4E2dE");

var $he1YE = parcelRequire("he1YE");

var $1kRJS = parcelRequire("1kRJS");
/**
 * Splits a given list or string at a given index.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig Number -> [a] -> [[a], [a]]
 * @sig Number -> String -> [String, String]
 * @param {Number} index The index where the array/string is split.
 * @param {Array|String} array The array/string to be split.
 * @return {Array}
 * @example
 *
 *      R.splitAt(1, [1, 2, 3]);          //=> [[1], [2, 3]]
 *      R.splitAt(5, 'hello world');      //=> ['hello', ' world']
 *      R.splitAt(-1, 'foobar');          //=> ['fooba', 'r']
 */ var $1f9d6f3d7770b468$var$splitAt = /*#__PURE__*/ (0, $4E2dE.default)(function splitAt(index, array) {
    return [
        (0, $1kRJS.default)(0, index, array),
        (0, $1kRJS.default)(index, (0, $he1YE.default)(array), array)
    ];
});
var $1f9d6f3d7770b468$export$2e2bcd8739ae039 = $1f9d6f3d7770b468$var$splitAt;

});

parcelRegister("8aeBf", function(module, exports) {

var $4E2dE = parcelRequire("4E2dE");

var $1kRJS = parcelRequire("1kRJS");
/**
 * Splits a collection into slices of the specified length.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig Number -> [a] -> [[a]]
 * @sig Number -> String -> [String]
 * @param {Number} n
 * @param {Array} list
 * @return {Array}
 * @example
 *
 *      R.splitEvery(3, [1, 2, 3, 4, 5, 6, 7]); //=> [[1, 2, 3], [4, 5, 6], [7]]
 *      R.splitEvery(3, 'foobarbaz'); //=> ['foo', 'bar', 'baz']
 */ var $5f1a9519b987f6c2$var$splitEvery = /*#__PURE__*/ (0, $4E2dE.default)(function splitEvery(n, list) {
    if (n <= 0) throw new Error("First argument to splitEvery must be a positive integer");
    var result = [];
    var idx = 0;
    while(idx < list.length)result.push((0, $1kRJS.default)(idx, idx += n, list));
    return result;
});
var $5f1a9519b987f6c2$export$2e2bcd8739ae039 = $5f1a9519b987f6c2$var$splitEvery;

});

parcelRegister("63F62", function(module, exports) {

var $4E2dE = parcelRequire("4E2dE");
/**
 * Takes a list and a predicate and returns a pair of lists with the following properties:
 *
 *  - the result of concatenating the two output lists is equivalent to the input list;
 *  - none of the elements of the first output list satisfies the predicate; and
 *  - if the second output list is non-empty, its first element satisfies the predicate.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> [[a], [a]]
 * @param {Function} pred The predicate that determines where the array is split.
 * @param {Array} list The array to be split.
 * @return {Array}
 * @example
 *
 *      R.splitWhen(R.equals(2), [1, 2, 3, 1, 2, 3]);   //=> [[1], [2, 3, 1, 2, 3]]
 */ var $4692e6c0db6b0d39$var$splitWhen = /*#__PURE__*/ (0, $4E2dE.default)(function splitWhen(pred, list) {
    var idx = 0;
    var len = list.length;
    var prefix = [];
    while(idx < len && !pred(list[idx])){
        prefix.push(list[idx]);
        idx += 1;
    }
    return [
        prefix,
        Array.prototype.slice.call(list, idx)
    ];
});
var $4692e6c0db6b0d39$export$2e2bcd8739ae039 = $4692e6c0db6b0d39$var$splitWhen;

});

parcelRegister("1ppgG", function(module, exports) {

var $2ikoZ = parcelRequire("2ikoZ");
/**
 * Splits an array into slices on every occurrence of a value.
 *
 * @func
 * @memberOf R
 * @since v0.26.1
 * @category List
 * @sig (a -> Boolean) -> [a] -> [[a]]
 * @param {Function} pred The predicate that determines where the array is split.
 * @param {Array} list The array to be split.
 * @return {Array}
 * @example
 *
 *      R.splitWhenever(R.equals(2), [1, 2, 3, 2, 4, 5, 2, 6, 7]); //=> [[1], [3], [4, 5], [6, 7]]
 */ var $106bb9f1d63c0ea8$var$splitWhenever = /*#__PURE__*/ (0, $2ikoZ.default)(2, [], function splitWhenever(pred, list) {
    var acc = [];
    var curr = [];
    for(var i = 0; i < list.length; i = i + 1){
        if (!pred(list[i])) curr.push(list[i]);
        if ((i < list.length - 1 && pred(list[i + 1]) || i === list.length - 1) && curr.length > 0) {
            acc.push(curr);
            curr = [];
        }
    }
    return acc;
});
var $106bb9f1d63c0ea8$export$2e2bcd8739ae039 = $106bb9f1d63c0ea8$var$splitWhenever;

});

parcelRegister("cpb0s", function(module, exports) {

var $4E2dE = parcelRequire("4E2dE");

var $imwRL = parcelRequire("imwRL");

var $8FDfT = parcelRequire("8FDfT");
/**
 * Checks if a list starts with the provided sublist.
 *
 * Similarly, checks if a string starts with the provided substring.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category List
 * @sig [a] -> [a] -> Boolean
 * @sig String -> String -> Boolean
 * @param {*} prefix
 * @param {*} list
 * @return {Boolean}
 * @see R.endsWith
 * @example
 *
 *      R.startsWith('a', 'abc')                //=> true
 *      R.startsWith('b', 'abc')                //=> false
 *      R.startsWith(['a'], ['a', 'b', 'c'])    //=> true
 *      R.startsWith(['b'], ['a', 'b', 'c'])    //=> false
 */ var $90805b79ccb00d6a$var$startsWith = /*#__PURE__*/ (0, $4E2dE.default)(function(prefix, list) {
    return (0, $imwRL.default)((0, $8FDfT.default)(prefix.length, list), prefix);
});
var $90805b79ccb00d6a$export$2e2bcd8739ae039 = $90805b79ccb00d6a$var$startsWith;

});

parcelRegister("gxSRW", function(module, exports) {

var $4E2dE = parcelRequire("4E2dE");
/**
 * Subtracts its second argument from its first argument.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a The first value.
 * @param {Number} b The second value.
 * @return {Number} The result of `a - b`.
 * @see R.add
 * @example
 *
 *      R.subtract(10, 8); //=> 2
 *
 *      const minus5 = R.subtract(R.__, 5);
 *      minus5(17); //=> 12
 *
 *      const complementaryAngle = R.subtract(90);
 *      complementaryAngle(30); //=> 60
 *      complementaryAngle(72); //=> 18
 */ var $c0ba4a44cc69b919$var$subtract = /*#__PURE__*/ (0, $4E2dE.default)(function subtract(a, b) {
    return Number(a) - Number(b);
});
var $c0ba4a44cc69b919$export$2e2bcd8739ae039 = $c0ba4a44cc69b919$var$subtract;

});

parcelRegister("eBWsJ", function(module, exports) {

var $4E2dE = parcelRequire("4E2dE");

var $j492g = parcelRequire("j492g");

var $9bAZP = parcelRequire("9bAZP");
/**
 * Finds the set (i.e. no duplicates) of all elements contained in the first or
 * second list, but not both.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Relation
 * @sig [*] -> [*] -> [*]
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The elements in `list1` or `list2`, but not both.
 * @see R.symmetricDifferenceWith, R.difference, R.differenceWith
 * @example
 *
 *      R.symmetricDifference([1,2,3,4], [7,6,5,4,3]); //=> [1,2,7,6,5]
 *      R.symmetricDifference([7,6,5,4,3], [1,2,3,4]); //=> [7,6,5,1,2]
 */ var $aa31ded4104d17a7$var$symmetricDifference = /*#__PURE__*/ (0, $4E2dE.default)(function symmetricDifference(list1, list2) {
    return (0, $j492g.default)((0, $9bAZP.default)(list1, list2), (0, $9bAZP.default)(list2, list1));
});
var $aa31ded4104d17a7$export$2e2bcd8739ae039 = $aa31ded4104d17a7$var$symmetricDifference;

});

parcelRegister("kMiAN", function(module, exports) {

var $cjSwl = parcelRequire("cjSwl");

var $j492g = parcelRequire("j492g");

var $6gGsO = parcelRequire("6gGsO");
/**
 * Finds the set (i.e. no duplicates) of all elements contained in the first or
 * second list, but not both. Duplication is determined according to the value
 * returned by applying the supplied predicate to two list elements.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Relation
 * @sig ((a, a) -> Boolean) -> [a] -> [a] -> [a]
 * @param {Function} pred A predicate used to test whether two items are equal.
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The elements in `list1` or `list2`, but not both.
 * @see R.symmetricDifference, R.difference, R.differenceWith
 * @example
 *
 *      const eqA = R.eqBy(R.prop('a'));
 *      const l1 = [{a: 1}, {a: 2}, {a: 3}, {a: 4}];
 *      const l2 = [{a: 3}, {a: 4}, {a: 5}, {a: 6}];
 *      R.symmetricDifferenceWith(eqA, l1, l2); //=> [{a: 1}, {a: 2}, {a: 5}, {a: 6}]
 */ var $f206b66b8f9f9d3d$var$symmetricDifferenceWith = /*#__PURE__*/ (0, $cjSwl.default)(function symmetricDifferenceWith(pred, list1, list2) {
    return (0, $j492g.default)((0, $6gGsO.default)(pred, list1, list2), (0, $6gGsO.default)(pred, list2, list1));
});
var $f206b66b8f9f9d3d$export$2e2bcd8739ae039 = $f206b66b8f9f9d3d$var$symmetricDifferenceWith;

});

parcelRegister("9mURk", function(module, exports) {

var $4E2dE = parcelRequire("4E2dE");

var $1kRJS = parcelRequire("1kRJS");
/**
 * Returns a new list containing the last `n` elements of a given list, passing
 * each value to the supplied predicate function, and terminating when the
 * predicate function returns `false`. Excludes the element that caused the
 * predicate function to fail. The predicate function is passed one argument:
 * *(value)*.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> [a]
 * @sig (a -> Boolean) -> String -> String
 * @param {Function} fn The function called per iteration.
 * @param {Array} xs The collection to iterate over.
 * @return {Array} A new array.
 * @see R.dropLastWhile, R.addIndex
 * @example
 *
 *      const isNotOne = x => x !== 1;
 *
 *      R.takeLastWhile(isNotOne, [1, 2, 3, 4]); //=> [2, 3, 4]
 *
 *      R.takeLastWhile(x => x !== 'R' , 'Ramda'); //=> 'amda'
 */ var $6d224626edfb1b58$var$takeLastWhile = /*#__PURE__*/ (0, $4E2dE.default)(function takeLastWhile(fn, xs) {
    var idx = xs.length - 1;
    while(idx >= 0 && fn(xs[idx]))idx -= 1;
    return (0, $1kRJS.default)(idx + 1, Infinity, xs);
});
var $6d224626edfb1b58$export$2e2bcd8739ae039 = $6d224626edfb1b58$var$takeLastWhile;

});

parcelRegister("3YSkq", function(module, exports) {

var $4E2dE = parcelRequire("4E2dE");

var $AZnlR = parcelRequire("AZnlR");

var $1h3OS = parcelRequire("1h3OS");

var $1kRJS = parcelRequire("1kRJS");
/**
 * Returns a new list containing the first `n` elements of a given list,
 * passing each value to the supplied predicate function, and terminating when
 * the predicate function returns `false`. Excludes the element that caused the
 * predicate function to fail. The predicate function is passed one argument:
 * *(value)*.
 *
 * Dispatches to the `takeWhile` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> [a]
 * @sig (a -> Boolean) -> String -> String
 * @param {Function} fn The function called per iteration.
 * @param {Array} xs The collection to iterate over.
 * @return {Array} A new array.
 * @see R.dropWhile, R.transduce, R.addIndex
 * @example
 *
 *      const isNotFour = x => x !== 4;
 *
 *      R.takeWhile(isNotFour, [1, 2, 3, 4, 3, 2, 1]); //=> [1, 2, 3]
 *
 *      R.takeWhile(x => x !== 'd' , 'Ramda'); //=> 'Ram'
 */ var $2e611e303c5641d3$var$takeWhile = /*#__PURE__*/ (0, $4E2dE.default)(/*#__PURE__*/ (0, $AZnlR.default)([
    "takeWhile"
], (0, $1h3OS.default), function takeWhile(fn, xs) {
    var idx = 0;
    var len = xs.length;
    while(idx < len && fn(xs[idx]))idx += 1;
    return (0, $1kRJS.default)(0, idx, xs);
}));
var $2e611e303c5641d3$export$2e2bcd8739ae039 = $2e611e303c5641d3$var$takeWhile;

});
parcelRegister("1h3OS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0eda5779efbb9bbe$export$2e2bcd8739ae039; });

var $4E2dE = parcelRequire("4E2dE");

var $1OnxV = parcelRequire("1OnxV");

var $dki4v = parcelRequire("dki4v");
var $0eda5779efbb9bbe$var$XTakeWhile = /*#__PURE__*/ function() {
    function XTakeWhile(f, xf) {
        this.xf = xf;
        this.f = f;
    }
    XTakeWhile.prototype["@@transducer/init"] = (0, $dki4v.default).init;
    XTakeWhile.prototype["@@transducer/result"] = (0, $dki4v.default).result;
    XTakeWhile.prototype["@@transducer/step"] = function(result, input) {
        return this.f(input) ? this.xf["@@transducer/step"](result, input) : (0, $1OnxV.default)(result);
    };
    return XTakeWhile;
}();
var $0eda5779efbb9bbe$var$_xtakeWhile = /*#__PURE__*/ (0, $4E2dE.default)(function _xtakeWhile(f, xf) {
    return new $0eda5779efbb9bbe$var$XTakeWhile(f, xf);
});
var $0eda5779efbb9bbe$export$2e2bcd8739ae039 = $0eda5779efbb9bbe$var$_xtakeWhile;

});


parcelRegister("lKSKr", function(module, exports) {

var $4E2dE = parcelRequire("4E2dE");

var $AZnlR = parcelRequire("AZnlR");

var $4pEgN = parcelRequire("4pEgN");
/**
 * Runs the given function with the supplied object, then returns the object.
 *
 * Acts as a transducer if a transformer is given as second parameter.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (a -> *) -> a -> a
 * @param {Function} fn The function to call with `x`. The return value of `fn` will be thrown away.
 * @param {*} x
 * @return {*} `x`.
 * @example
 *
 *      const sayX = x => console.log('x is ' + x);
 *      R.tap(sayX, 100); //=> 100
 *      // logs 'x is 100'
 * @symb R.tap(f, a) = a
 */ var $fd685cb037229e39$var$tap = /*#__PURE__*/ (0, $4E2dE.default)(/*#__PURE__*/ (0, $AZnlR.default)([], (0, $4pEgN.default), function tap(fn, x) {
    fn(x);
    return x;
}));
var $fd685cb037229e39$export$2e2bcd8739ae039 = $fd685cb037229e39$var$tap;

});
parcelRegister("4pEgN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3368bbf934d52003$export$2e2bcd8739ae039; });

var $4E2dE = parcelRequire("4E2dE");

var $dki4v = parcelRequire("dki4v");
var $3368bbf934d52003$var$XTap = /*#__PURE__*/ function() {
    function XTap(f, xf) {
        this.xf = xf;
        this.f = f;
    }
    XTap.prototype["@@transducer/init"] = (0, $dki4v.default).init;
    XTap.prototype["@@transducer/result"] = (0, $dki4v.default).result;
    XTap.prototype["@@transducer/step"] = function(result, input) {
        this.f(input);
        return this.xf["@@transducer/step"](result, input);
    };
    return XTap;
}();
var $3368bbf934d52003$var$_xtap = /*#__PURE__*/ (0, $4E2dE.default)(function _xtap(f, xf) {
    return new $3368bbf934d52003$var$XTap(f, xf);
});
var $3368bbf934d52003$export$2e2bcd8739ae039 = $3368bbf934d52003$var$_xtap;

});


parcelRegister("bqbRU", function(module, exports) {

var $i5qW0 = parcelRequire("i5qW0");

var $4E2dE = parcelRequire("4E2dE");

var $hJJpN = parcelRequire("hJJpN");

var $220yG = parcelRequire("220yG");
/**
 * Determines whether a given string matches a given regular expression.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category String
 * @sig RegExp -> String -> Boolean
 * @param {RegExp} pattern
 * @param {String} str
 * @return {Boolean}
 * @see R.match
 * @example
 *
 *      R.test(/^x/, 'xyz'); //=> true
 *      R.test(/^y/, 'xyz'); //=> false
 */ var $850b543bcfcd15a1$var$test = /*#__PURE__*/ (0, $4E2dE.default)(function test(pattern, str) {
    if (!(0, $hJJpN.default)(pattern)) throw new TypeError("\u2018test\u2019 requires a value of type RegExp as its first argument; received " + (0, $220yG.default)(pattern));
    return (0, $i5qW0.default)(pattern).test(str);
});
var $850b543bcfcd15a1$export$2e2bcd8739ae039 = $850b543bcfcd15a1$var$test;

});
parcelRegister("hJJpN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ce99de219ef55a17$export$2e2bcd8739ae039; });
function $ce99de219ef55a17$export$2e2bcd8739ae039(x) {
    return Object.prototype.toString.call(x) === "[object RegExp]";
}

});


parcelRegister("gc8e0", function(module, exports) {

var $4E2dE = parcelRequire("4E2dE");

var $1ckyD = parcelRequire("1ckyD");
/**
 * Returns the result of applying the onSuccess function to the value inside
 * a successfully resolved promise. This is useful for working with promises
 * inside function compositions.
 *
 * @func
 * @memberOf R
 * @since v0.27.1
 * @category Function
 * @sig (a -> b) -> (Promise e a) -> (Promise e b)
 * @sig (a -> (Promise e b)) -> (Promise e a) -> (Promise e b)
 * @param {Function} onSuccess The function to apply. Can return a value or a promise of a value.
 * @param {Promise} p
 * @return {Promise} The result of calling `p.then(onSuccess)`
 * @see R.otherwise
 * @example
 *
 *      const makeQuery = email => ({ query: { email }});
 *      const fetchMember = request =>
 *        Promise.resolve({ firstName: 'Bob', lastName: 'Loblaw', id: 42 });
 *
 *      //getMemberName :: String -> Promise ({ firstName, lastName })
 *      const getMemberName = R.pipe(
 *        makeQuery,
 *        fetchMember,
 *        R.andThen(R.pick(['firstName', 'lastName']))
 *      );
 *
 *      getMemberName('bob@gmail.com').then(console.log);
 */ var $bca425a35e58e471$var$andThen = /*#__PURE__*/ (0, $4E2dE.default)(function andThen(f, p) {
    (0, $1ckyD.default)("andThen", p);
    return p.then(f);
});
var $bca425a35e58e471$export$2e2bcd8739ae039 = $bca425a35e58e471$var$andThen;

});

parcelRegister("llaSl", function(module, exports) {

var $cEVJS = parcelRequire("cEVJS");
/**
 * The lower case version of a string.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category String
 * @sig String -> String
 * @param {String} str The string to lower case.
 * @return {String} The lower case version of `str`.
 * @see R.toUpper
 * @example
 *
 *      R.toLower('XYZ'); //=> 'xyz'
 */ var $f893fecfe3e761da$var$toLower = /*#__PURE__*/ (0, $cEVJS.default)(0, "toLowerCase");
var $f893fecfe3e761da$export$2e2bcd8739ae039 = $f893fecfe3e761da$var$toLower;

});

parcelRegister("cXjE7", function(module, exports) {

var $lrIA4 = parcelRequire("lrIA4");

var $jn7AE = parcelRequire("jn7AE");
/**
 * Converts an object into an array of key, value arrays. Only the object's
 * own properties are used.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.4.0
 * @category Object
 * @sig {String: *} -> [[String,*]]
 * @param {Object} obj The object to extract from
 * @return {Array} An array of key, value arrays from the object's own properties.
 * @see R.fromPairs, R.keys, R.values
 * @example
 *
 *      R.toPairs({a: 1, b: 2, c: 3}); //=> [['a', 1], ['b', 2], ['c', 3]]
 */ var $96ea3c05b020d0e1$var$toPairs = /*#__PURE__*/ (0, $lrIA4.default)(function toPairs(obj) {
    var pairs = [];
    for(var prop in obj)if ((0, $jn7AE.default)(prop, obj)) pairs[pairs.length] = [
        prop,
        obj[prop]
    ];
    return pairs;
});
var $96ea3c05b020d0e1$export$2e2bcd8739ae039 = $96ea3c05b020d0e1$var$toPairs;

});

parcelRegister("c1JEt", function(module, exports) {

var $lrIA4 = parcelRequire("lrIA4");
/**
 * Converts an object into an array of key, value arrays. The object's own
 * properties and prototype properties are used. Note that the order of the
 * output array is not guaranteed to be consistent across different JS
 * platforms.
 *
 * @func
 * @memberOf R
 * @since v0.4.0
 * @category Object
 * @sig {String: *} -> [[String,*]]
 * @param {Object} obj The object to extract from
 * @return {Array} An array of key, value arrays from the object's own
 *         and prototype properties.
 * @example
 *
 *      const F = function() { this.x = 'X'; };
 *      F.prototype.y = 'Y';
 *      const f = new F();
 *      R.toPairsIn(f); //=> [['x','X'], ['y','Y']]
 */ var $8c18fd82d0802703$var$toPairsIn = /*#__PURE__*/ (0, $lrIA4.default)(function toPairsIn(obj) {
    var pairs = [];
    for(var prop in obj)pairs[pairs.length] = [
        prop,
        obj[prop]
    ];
    return pairs;
});
var $8c18fd82d0802703$export$2e2bcd8739ae039 = $8c18fd82d0802703$var$toPairsIn;

});

parcelRegister("7NyiS", function(module, exports) {

var $cEVJS = parcelRequire("cEVJS");
/**
 * The upper case version of a string.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category String
 * @sig String -> String
 * @param {String} str The string to upper case.
 * @return {String} The upper case version of `str`.
 * @see R.toLower
 * @example
 *
 *      R.toUpper('abc'); //=> 'ABC'
 */ var $5ad7b7f2d5ba959c$var$toUpper = /*#__PURE__*/ (0, $cEVJS.default)(0, "toUpperCase");
var $5ad7b7f2d5ba959c$export$2e2bcd8739ae039 = $5ad7b7f2d5ba959c$var$toUpper;

});

parcelRegister("8msyp", function(module, exports) {

var $jdcIJ = parcelRequire("jdcIJ");

var $eBPr7 = parcelRequire("eBPr7");

var $4fS8E = parcelRequire("4fS8E");
/**
 * Initializes a transducer using supplied iterator function. Returns a single
 * item by iterating through the list, successively calling the transformed
 * iterator function and passing it an accumulator value and the current value
 * from the array, and then passing the result to the next call.
 *
 * The iterator function receives two values: *(acc, value)*. It will be
 * wrapped as a transformer to initialize the transducer. A transformer can be
 * passed directly in place of an iterator function. In both cases, iteration
 * may be stopped early with the [`R.reduced`](#reduced) function.
 *
 * A transducer is a function that accepts a transformer and returns a
 * transformer and can be composed directly.
 *
 * A transformer is an object that provides a 2-arity reducing iterator
 * function, step, 0-arity initial value function, init, and 1-arity result
 * extraction function, result. The step function is used as the iterator
 * function in reduce. The result function is used to convert the final
 * accumulator into the return type and in most cases is
 * [`R.identity`](#identity). The init function can be used to provide an
 * initial accumulator, but is ignored by transduce.
 *
 * The iteration is performed with [`R.reduce`](#reduce) after initializing the transducer.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category List
 * @sig (c -> c) -> ((a, b) -> a) -> a -> [b] -> a
 * @param {Function} xf The transducer function. Receives a transformer and returns a transformer.
 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
 *        current element from the array. Wrapped as transformer, if necessary, and used to
 *        initialize the transducer
 * @param {*} acc The initial accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduce, R.reduced, R.into
 * @example
 *
 *      const numbers = [1, 2, 3, 4];
 *      const transducer = R.compose(R.map(R.add(1)), R.take(2));
 *      R.transduce(transducer, R.flip(R.append), [], numbers); //=> [2, 3]
 *
 *      const isOdd = (x) => x % 2 !== 0;
 *      const firstOddTransducer = R.compose(R.filter(isOdd), R.take(1));
 *      R.transduce(firstOddTransducer, R.flip(R.append), [], R.range(0, 100)); //=> [1]
 */ var $6166870ace46f200$var$transduce = /*#__PURE__*/ (0, $4fS8E.default)(4, function transduce(xf, fn, acc, list) {
    return (0, $jdcIJ.default)(xf(typeof fn === "function" ? (0, $eBPr7.default)(fn) : fn), acc, list);
});
var $6166870ace46f200$export$2e2bcd8739ae039 = $6166870ace46f200$var$transduce;

});

parcelRegister("1iggl", function(module, exports) {

var $lrIA4 = parcelRequire("lrIA4");
/**
 * Transposes the rows and columns of a 2D list.
 * When passed a list of `n` lists of length `x`,
 * returns a list of `x` lists of length `n`.
 *
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig [[a]] -> [[a]]
 * @param {Array} list A 2D list
 * @return {Array} A 2D list
 * @example
 *
 *      R.transpose([[1, 'a'], [2, 'b'], [3, 'c']]) //=> [[1, 2, 3], ['a', 'b', 'c']]
 *      R.transpose([[1, 2, 3], ['a', 'b', 'c']]) //=> [[1, 'a'], [2, 'b'], [3, 'c']]
 *
 *      // If some of the rows are shorter than the following rows, their elements are skipped:
 *      R.transpose([[10, 11], [20], [], [30, 31, 32]]) //=> [[10, 20, 30], [11, 31], [32]]
 * @symb R.transpose([[a], [b], [c]]) = [a, b, c]
 * @symb R.transpose([[a, b], [c, d]]) = [[a, c], [b, d]]
 * @symb R.transpose([[a, b], [c]]) = [[a, c], [b]]
 */ var $0f141653fd5bd10c$var$transpose = /*#__PURE__*/ (0, $lrIA4.default)(function transpose(outerlist) {
    var i = 0;
    var result = [];
    while(i < outerlist.length){
        var innerlist = outerlist[i];
        var j = 0;
        while(j < innerlist.length){
            if (typeof result[j] === "undefined") result[j] = [];
            result[j].push(innerlist[j]);
            j += 1;
        }
        i += 1;
    }
    return result;
});
var $0f141653fd5bd10c$export$2e2bcd8739ae039 = $0f141653fd5bd10c$var$transpose;

});

parcelRegister("cVAGQ", function(module, exports) {

var $cjSwl = parcelRequire("cjSwl");

var $aaiYf = parcelRequire("aaiYf");

var $kM76K = parcelRequire("kM76K");
/**
 * Maps an [Applicative](https://github.com/fantasyland/fantasy-land#applicative)-returning
 * function over a [Traversable](https://github.com/fantasyland/fantasy-land#traversable),
 * then uses [`sequence`](#sequence) to transform the resulting Traversable of Applicative
 * into an Applicative of Traversable.
 *
 * Dispatches to the `traverse` method of the third argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig (Applicative f, Traversable t) => (a -> f a) -> (a -> f b) -> t a -> f (t b)
 * @param {Function} of
 * @param {Function} f
 * @param {*} traversable
 * @return {*}
 * @see R.sequence
 * @example
 *
 *      // Returns `Maybe.Nothing` if the given divisor is `0`
 *      const safeDiv = n => d => d === 0 ? Maybe.Nothing() : Maybe.Just(n / d)
 *
 *      R.traverse(Maybe.of, safeDiv(10), [2, 4, 5]); //=> Maybe.Just([5, 2.5, 2])
 *      R.traverse(Maybe.of, safeDiv(10), [2, 0, 5]); //=> Maybe.Nothing
 */ var $969744ca442604a2$var$traverse = /*#__PURE__*/ (0, $cjSwl.default)(function traverse(of, f, traversable) {
    return typeof traversable["fantasy-land/traverse"] === "function" ? traversable["fantasy-land/traverse"](f, of) : typeof traversable.traverse === "function" ? traversable.traverse(f, of) : (0, $kM76K.default)(of, (0, $aaiYf.default)(f, traversable));
});
var $969744ca442604a2$export$2e2bcd8739ae039 = $969744ca442604a2$var$traverse;

});

parcelRegister("lwtUC", function(module, exports) {

var $lrIA4 = parcelRequire("lrIA4");
var $fab3ca101c7b6e7e$var$ws = "	\n\v\f\r \xa0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";
var $fab3ca101c7b6e7e$var$zeroWidth = "\u200B";
var $fab3ca101c7b6e7e$var$hasProtoTrim = typeof String.prototype.trim === "function";
/**
 * Removes (strips) whitespace from both ends of the string.
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category String
 * @sig String -> String
 * @param {String} str The string to trim.
 * @return {String} Trimmed version of `str`.
 * @example
 *
 *      R.trim('   xyz  '); //=> 'xyz'
 *      R.map(R.trim, R.split(',', 'x, y, z')); //=> ['x', 'y', 'z']
 */ var $fab3ca101c7b6e7e$var$trim = !$fab3ca101c7b6e7e$var$hasProtoTrim || /*#__PURE__*/ $fab3ca101c7b6e7e$var$ws.trim() || !/*#__PURE__*/ $fab3ca101c7b6e7e$var$zeroWidth.trim() ? /*#__PURE__*/ (0, $lrIA4.default)(function trim(str) {
    var beginRx = new RegExp("^[" + $fab3ca101c7b6e7e$var$ws + "][" + $fab3ca101c7b6e7e$var$ws + "]*");
    var endRx = new RegExp("[" + $fab3ca101c7b6e7e$var$ws + "][" + $fab3ca101c7b6e7e$var$ws + "]*$");
    return str.replace(beginRx, "").replace(endRx, "");
}) : /*#__PURE__*/ (0, $lrIA4.default)(function trim(str) {
    return str.trim();
});
var $fab3ca101c7b6e7e$export$2e2bcd8739ae039 = $fab3ca101c7b6e7e$var$trim;

});

parcelRegister("298Xn", function(module, exports) {

var $fe9oK = parcelRequire("fe9oK");

var $cJJmw = parcelRequire("cJJmw");

var $4E2dE = parcelRequire("4E2dE");
/**
 * `tryCatch` takes two functions, a `tryer` and a `catcher`. The returned
 * function evaluates the `tryer`; if it does not throw, it simply returns the
 * result. If the `tryer` *does* throw, the returned function evaluates the
 * `catcher` function and returns its result. Note that for effective
 * composition with this function, both the `tryer` and `catcher` functions
 * must return the same type of results.
 *
 * @func
 * @memberOf R
 * @since v0.20.0
 * @category Function
 * @sig (...x -> a) -> ((e, ...x) -> a) -> (...x -> a)
 * @param {Function} tryer The function that may throw.
 * @param {Function} catcher The function that will be evaluated if `tryer` throws.
 * @return {Function} A new function that will catch exceptions and send them to the catcher.
 * @example
 *
 *      R.tryCatch(R.prop('x'), R.F)({x: true}); //=> true
 *      R.tryCatch(() => { throw 'foo'}, R.always('caught'))('bar') // =>
 *      'caught'
 *      R.tryCatch(R.times(R.identity), R.always([]))('s') // => []
 *      R.tryCatch(() => { throw 'this is not a valid value'}, (err, value)=>({error : err,  value }))('bar') // => {'error': 'this is not a valid value', 'value': 'bar'}
 */ var $19035ea946cb92be$var$tryCatch = /*#__PURE__*/ (0, $4E2dE.default)(function _tryCatch(tryer, catcher) {
    return (0, $fe9oK.default)(tryer.length, function() {
        try {
            return tryer.apply(this, arguments);
        } catch (e) {
            return catcher.apply(this, (0, $cJJmw.default)([
                e
            ], arguments));
        }
    });
});
var $19035ea946cb92be$export$2e2bcd8739ae039 = $19035ea946cb92be$var$tryCatch;

});

parcelRegister("dELsY", function(module, exports) {

var $lrIA4 = parcelRequire("lrIA4");
/**
 * Takes a function `fn`, which takes a single array argument, and returns a
 * function which:
 *
 *   - takes any number of positional arguments;
 *   - passes these arguments to `fn` as an array; and
 *   - returns the result.
 *
 * In other words, `R.unapply` derives a variadic function from a function which
 * takes an array. `R.unapply` is the inverse of [`R.apply`](#apply).
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Function
 * @sig ([*...] -> a) -> (*... -> a)
 * @param {Function} fn
 * @return {Function}
 * @see R.apply
 * @example
 *
 *      R.unapply(JSON.stringify)(1, 2, 3); //=> '[1,2,3]'
 * @symb R.unapply(f)(a, b) = f([a, b])
 */ var $9f13d4a2a4e39ddd$var$unapply = /*#__PURE__*/ (0, $lrIA4.default)(function unapply(fn) {
    return function() {
        return fn(Array.prototype.slice.call(arguments, 0));
    };
});
var $9f13d4a2a4e39ddd$export$2e2bcd8739ae039 = $9f13d4a2a4e39ddd$var$unapply;

});

parcelRegister("2OqUW", function(module, exports) {

var $lrIA4 = parcelRequire("lrIA4");

var $kRpXl = parcelRequire("kRpXl");
/**
 * Wraps a function of any arity (including nullary) in a function that accepts
 * exactly 1 parameter. Any extraneous parameters will not be passed to the
 * supplied function.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Function
 * @sig (a -> b -> c -> ... -> z) -> (a -> z)
 * @param {Function} fn The function to wrap.
 * @return {Function} A new function wrapping `fn`. The new function is guaranteed to be of
 *         arity 1.
 * @see R.binary, R.nAry
 * @example
 *
 *      const takesTwoArgs = function(a, b) {
 *        return [a, b];
 *      };
 *      takesTwoArgs.length; //=> 2
 *      takesTwoArgs(1, 2); //=> [1, 2]
 *
 *      const takesOneArg = R.unary(takesTwoArgs);
 *      takesOneArg.length; //=> 1
 *      // Only 1 argument is passed to the wrapped function
 *      takesOneArg(1, 2); //=> [1, undefined]
 * @symb R.unary(f)(a, b, c) = f(a)
 */ var $20c52186b4202b87$var$unary = /*#__PURE__*/ (0, $lrIA4.default)(function unary(fn) {
    return (0, $kRpXl.default)(1, fn);
});
var $20c52186b4202b87$export$2e2bcd8739ae039 = $20c52186b4202b87$var$unary;

});

parcelRegister("eDfiu", function(module, exports) {

var $4E2dE = parcelRequire("4E2dE");

var $4fS8E = parcelRequire("4fS8E");
/**
 * Returns a function of arity `n` from a (manually) curried function.
 * Note that, the returned function is actually a ramda style
 * curryied function, which can accept one or more arguments in each
 * function calling.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Function
 * @sig Number -> (a -> b -> c ... -> z) -> ((a -> b -> c ...) -> z)
 * @param {Number} length The arity for the returned function.
 * @param {Function} fn The function to uncurry.
 * @return {Function} A new function.
 * @see R.curry, R.curryN
 * @example
 *
 *      const addFour = a => b => c => d => a + b + c + d;
 *
 *      const uncurriedAddFour = R.uncurryN(4, addFour);
 *      uncurriedAddFour(1, 2, 3, 4); //=> 10
 */ var $aa7092ea2dc796bc$var$uncurryN = /*#__PURE__*/ (0, $4E2dE.default)(function uncurryN(depth, fn) {
    return (0, $4fS8E.default)(depth, function() {
        var currentDepth = 1;
        var value = fn;
        var idx = 0;
        var endIdx;
        while(currentDepth <= depth && typeof value === "function"){
            endIdx = currentDepth === depth ? arguments.length : idx + value.length;
            value = value.apply(this, Array.prototype.slice.call(arguments, idx, endIdx));
            currentDepth += 1;
            idx = endIdx;
        }
        return value;
    });
});
var $aa7092ea2dc796bc$export$2e2bcd8739ae039 = $aa7092ea2dc796bc$var$uncurryN;

});

parcelRegister("2C3Vc", function(module, exports) {

var $4E2dE = parcelRequire("4E2dE");
/**
 * Builds a list from a seed value. Accepts an iterator function, which returns
 * either false to stop iteration or an array of length 2 containing the value
 * to add to the resulting list and the seed to be used in the next call to the
 * iterator function.
 *
 * The iterator function receives one argument: *(seed)*.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category List
 * @sig (a -> [b]) -> * -> [b]
 * @param {Function} fn The iterator function. receives one argument, `seed`, and returns
 *        either false to quit iteration or an array of length two to proceed. The element
 *        at index 0 of this array will be added to the resulting array, and the element
 *        at index 1 will be passed to the next call to `fn`.
 * @param {*} seed The seed value.
 * @return {Array} The final list.
 * @example
 *
 *      const f = n => n > 50 ? false : [-n, n + 10];
 *      R.unfold(f, 10); //=> [-10, -20, -30, -40, -50]
 * @symb R.unfold(f, x) = [f(x)[0], f(f(x)[1])[0], f(f(f(x)[1])[1])[0], ...]
 */ var $1e722c1cd74241d5$var$unfold = /*#__PURE__*/ (0, $4E2dE.default)(function unfold(fn, seed) {
    var pair = fn(seed);
    var result = [];
    while(pair && pair.length){
        result[result.length] = pair[0];
        pair = fn(pair[1]);
    }
    return result;
});
var $1e722c1cd74241d5$export$2e2bcd8739ae039 = $1e722c1cd74241d5$var$unfold;

});

parcelRegister("cWjD4", function(module, exports) {

var $cJJmw = parcelRequire("cJJmw");

var $4E2dE = parcelRequire("4E2dE");

var $2kk8J = parcelRequire("2kk8J");

var $cUasK = parcelRequire("cUasK");
/**
 * Combines two lists into a set (i.e. no duplicates) composed of the elements
 * of each list.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig [*] -> [*] -> [*]
 * @param {Array} as The first list.
 * @param {Array} bs The second list.
 * @return {Array} The first and second lists concatenated, with
 *         duplicates removed.
 * @example
 *
 *      R.union([1, 2, 3], [2, 3, 4]); //=> [1, 2, 3, 4]
 */ var $96ba20c8fb9c554e$var$union = /*#__PURE__*/ (0, $4E2dE.default)(/*#__PURE__*/ (0, $2kk8J.default)((0, $cUasK.default), (0, $cJJmw.default)));
var $96ba20c8fb9c554e$export$2e2bcd8739ae039 = $96ba20c8fb9c554e$var$union;

});

parcelRegister("45X08", function(module, exports) {

var $cJJmw = parcelRequire("cJJmw");

var $cjSwl = parcelRequire("cjSwl");

var $aIwpH = parcelRequire("aIwpH");
/**
 * Combines two lists into a set (i.e. no duplicates) composed of the elements
 * of each list. Duplication is determined according to the value returned by
 * applying the supplied predicate to two list elements. If an element exists
 * in both lists, the first element from the first list will be used.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig ((a, a) -> Boolean) -> [*] -> [*] -> [*]
 * @param {Function} pred A predicate used to test whether two items are equal.
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The first and second lists concatenated, with
 *         duplicates removed.
 * @see R.union
 * @example
 *
 *      const l1 = [{a: 1}, {a: 2}];
 *      const l2 = [{a: 1}, {a: 4}];
 *      R.unionWith(R.eqBy(R.prop('a')), l1, l2); //=> [{a: 1}, {a: 2}, {a: 4}]
 */ var $2fb56579b966df42$var$unionWith = /*#__PURE__*/ (0, $cjSwl.default)(function unionWith(pred, list1, list2) {
    return (0, $aIwpH.default)(pred, (0, $cJJmw.default)(list1, list2));
});
var $2fb56579b966df42$export$2e2bcd8739ae039 = $2fb56579b966df42$var$unionWith;

});
parcelRegister("aIwpH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $02037863757093a4$export$2e2bcd8739ae039; });

var $4E2dE = parcelRequire("4E2dE");

var $AZnlR = parcelRequire("AZnlR");

var $iiRAt = parcelRequire("iiRAt");

var $aEGqW = parcelRequire("aEGqW");
/**
 * Returns a new list containing only one copy of each element in the original
 * list, based upon the value returned by applying the supplied predicate to
 * two list elements. Prefers the first item if two items compare equal based
 * on the predicate.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category List
 * @sig ((a, a) -> Boolean) -> [a] -> [a]
 * @param {Function} pred A predicate used to test whether two items are equal.
 * @param {Array} list The array to consider.
 * @return {Array} The list of unique items.
 * @example
 *
 *      const strEq = R.eqBy(String);
 *      R.uniqWith(strEq)([1, '1', 2, 1]); //=> [1, 2]
 *      R.uniqWith(strEq)([{}, {}]);       //=> [{}]
 *      R.uniqWith(strEq)([1, '1', 1]);    //=> [1]
 *      R.uniqWith(strEq)(['1', 1, 1]);    //=> ['1']
 */ var $02037863757093a4$var$uniqWith = /*#__PURE__*/ (0, $4E2dE.default)(/*#__PURE__*/ (0, $AZnlR.default)([], (0, $aEGqW.default), function(pred, list) {
    var idx = 0;
    var len = list.length;
    var result = [];
    var item;
    while(idx < len){
        item = list[idx];
        if (!(0, $iiRAt.default)(pred, item, result)) result[result.length] = item;
        idx += 1;
    }
    return result;
}));
var $02037863757093a4$export$2e2bcd8739ae039 = $02037863757093a4$var$uniqWith;

});
parcelRegister("aEGqW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7c1e8e3a4ef3bb7a$export$2e2bcd8739ae039; });

var $4E2dE = parcelRequire("4E2dE");

var $iiRAt = parcelRequire("iiRAt");

var $dki4v = parcelRequire("dki4v");
var $7c1e8e3a4ef3bb7a$var$XUniqWith = /*#__PURE__*/ function() {
    function XUniqWith(pred, xf) {
        this.xf = xf;
        this.pred = pred;
        this.items = [];
    }
    XUniqWith.prototype["@@transducer/init"] = (0, $dki4v.default).init;
    XUniqWith.prototype["@@transducer/result"] = (0, $dki4v.default).result;
    XUniqWith.prototype["@@transducer/step"] = function(result, input) {
        if ((0, $iiRAt.default)(this.pred, input, this.items)) return result;
        else {
            this.items.push(input);
            return this.xf["@@transducer/step"](result, input);
        }
    };
    return XUniqWith;
}();
var $7c1e8e3a4ef3bb7a$var$_xuniqWith = /*#__PURE__*/ (0, $4E2dE.default)(function _xuniqWith(pred, xf) {
    return new $7c1e8e3a4ef3bb7a$var$XUniqWith(pred, xf);
});
var $7c1e8e3a4ef3bb7a$export$2e2bcd8739ae039 = $7c1e8e3a4ef3bb7a$var$_xuniqWith;

});



parcelRegister("dYLtE", function(module, exports) {

var $cjSwl = parcelRequire("cjSwl");
/**
 * Tests the final argument by passing it to the given predicate function. If
 * the predicate is not satisfied, the function will return the result of
 * calling the `whenFalseFn` function with the same argument. If the predicate
 * is satisfied, the argument is returned as is.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category Logic
 * @sig (a -> Boolean) -> (a -> b) -> a -> a | b
 * @param {Function} pred        A predicate function
 * @param {Function} whenFalseFn A function to invoke when the `pred` evaluates
 *                               to a falsy value.
 * @param {*}        x           An object to test with the `pred` function and
 *                               pass to `whenFalseFn` if necessary.
 * @return {*} Either `x` or the result of applying `x` to `whenFalseFn`.
 * @see R.ifElse, R.when, R.cond
 * @example
 *
 *      let safeInc = R.unless(R.isNil, R.inc);
 *      safeInc(null); //=> null
 *      safeInc(1); //=> 2
 */ var $a2d5b4f049199a1f$var$unless = /*#__PURE__*/ (0, $cjSwl.default)(function unless(pred, whenFalseFn, x) {
    return pred(x) ? x : whenFalseFn(x);
});
var $a2d5b4f049199a1f$export$2e2bcd8739ae039 = $a2d5b4f049199a1f$var$unless;

});

parcelRegister("7UMNL", function(module, exports) {

var $k3Ml1 = parcelRequire("k3Ml1");

var $isJKB = parcelRequire("isJKB");
/**
 * Shorthand for `R.chain(R.identity)`, which removes one level of nesting from
 * any [Chain](https://github.com/fantasyland/fantasy-land#chain).
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig Chain c => c (c a) -> c a
 * @param {*} list
 * @return {*}
 * @see R.flatten, R.chain
 * @example
 *
 *      R.unnest([1, [2], [[3]]]); //=> [1, 2, [3]]
 *      R.unnest([[1, 2], [3, 4], [5, 6]]); //=> [1, 2, 3, 4, 5, 6]
 */ var $5c339e588c2b3d95$var$unnest = /*#__PURE__*/ (0, $isJKB.default)((0, $k3Ml1.default));
var $5c339e588c2b3d95$export$2e2bcd8739ae039 = $5c339e588c2b3d95$var$unnest;

});

parcelRegister("1H1PQ", function(module, exports) {

var $cjSwl = parcelRequire("cjSwl");
/**
 * Takes a predicate, a transformation function, and an initial value,
 * and returns a value of the same type as the initial value.
 * It does so by applying the transformation until the predicate is satisfied,
 * at which point it returns the satisfactory value.
 *
 * @func
 * @memberOf R
 * @since v0.20.0
 * @category Logic
 * @sig (a -> Boolean) -> (a -> a) -> a -> a
 * @param {Function} pred A predicate function
 * @param {Function} fn The iterator function
 * @param {*} init Initial value
 * @return {*} Final value that satisfies predicate
 * @example
 *
 *      R.until(R.gt(R.__, 100), R.multiply(2))(1) // => 128
 */ var $13bb3b05051d2127$var$until = /*#__PURE__*/ (0, $cjSwl.default)(function until(pred, fn, init) {
    var val = init;
    while(!pred(val))val = fn(val);
    return val;
});
var $13bb3b05051d2127$export$2e2bcd8739ae039 = $13bb3b05051d2127$var$until;

});

parcelRegister("bhFZP", function(module, exports) {

var $4E2dE = parcelRequire("4E2dE");

var $9hDA3 = parcelRequire("9hDA3");

var $5DhuU = parcelRequire("5DhuU");

var $cNL0t = parcelRequire("cNL0t");
/**
 *
 * Deconstructs an array field from the input documents to output a document for each element.
 * Each output document is the input document with the value of the array field replaced by the element.
 *
 * @func
 * @memberOf R
 * @since v0.28.0
 * @category Object
 * @sig String -> {k: [v]} -> [{k: v}]
 * @param {String} key The key to determine which property of the object should be unwind
 * @param {Object} object The object containing list under property named as key which is to unwind
 * @return {List} A new list of object containing the value of input key having list replaced by each element in the object.
 * @example
 *
 * R.unwind('hobbies', {
 *   name: 'alice',
 *   hobbies: ['Golf', 'Hacking'],
 *   colors: ['red', 'green'],
 * });
 * // [
 * //   { name: 'alice', hobbies: 'Golf', colors: ['red', 'green'] },
 * //   { name: 'alice', hobbies: 'Hacking', colors: ['red', 'green'] }
 * // ]
 */ var $8371dbcb4dd1411a$var$unwind = /*#__PURE__*/ (0, $4E2dE.default)(function(key, object) {
    // If key is not in object or key is not as a list in object
    if (!(key in object && (0, $9hDA3.default)(object[key]))) return [
        object
    ];
     // Map over object[key] which is a list and assoc each element with key
    return (0, $5DhuU.default)(function(item) {
        return (0, $cNL0t.default)(key, item, object);
    }, object[key]);
});
var $8371dbcb4dd1411a$export$2e2bcd8739ae039 = $8371dbcb4dd1411a$var$unwind;

});

parcelRegister("kz9Ze", function(module, exports) {

var $lrIA4 = parcelRequire("lrIA4");
/**
 * Returns a list of all the properties, including prototype properties, of the
 * supplied object.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Object
 * @sig {k: v} -> [v]
 * @param {Object} obj The object to extract values from
 * @return {Array} An array of the values of the object's own and prototype properties.
 * @see R.values, R.keysIn
 * @example
 *
 *      const F = function() { this.x = 'X'; };
 *      F.prototype.y = 'Y';
 *      const f = new F();
 *      R.valuesIn(f); //=> ['X', 'Y']
 */ var $ef8ed2b088aa429b$var$valuesIn = /*#__PURE__*/ (0, $lrIA4.default)(function valuesIn(obj) {
    var prop;
    var vs = [];
    for(prop in obj)vs[vs.length] = obj[prop];
    return vs;
});
var $ef8ed2b088aa429b$export$2e2bcd8739ae039 = $ef8ed2b088aa429b$var$valuesIn;

});

parcelRegister("bDLKn", function(module, exports) {

var $4E2dE = parcelRequire("4E2dE");
var $87985fc6fe1f8ebe$var$Const = function(x) {
    return {
        value: x,
        "fantasy-land/map": function() {
            return this;
        }
    };
};
/**
 * Returns a "view" of the given data structure, determined by the given lens.
 * The lens's focus determines which portion of the data structure is visible.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig Lens s a -> s -> a
 * @param {Lens} lens
 * @param {*} x
 * @return {*}
 * @see R.set, R.over, R.lens, R.lensIndex, R.lensProp, R.lensPath
 * @example
 *
 *      const xLens = R.lensProp('x');
 *
 *      R.view(xLens, {x: 1, y: 2});  //=> 1
 *      R.view(xLens, {x: 4, y: 2});  //=> 4
 */ var $87985fc6fe1f8ebe$var$view = /*#__PURE__*/ (0, $4E2dE.default)(function view(lens, x) {
    // Using `Const` effectively ignores the setter function of the `lens`,
    // leaving the value returned by the getter function unmodified.
    return lens($87985fc6fe1f8ebe$var$Const)(x).value;
});
var $87985fc6fe1f8ebe$export$2e2bcd8739ae039 = $87985fc6fe1f8ebe$var$view;

});

parcelRegister("ivVhR", function(module, exports) {

var $cjSwl = parcelRequire("cjSwl");
/**
 * Tests the final argument by passing it to the given predicate function. If
 * the predicate is satisfied, the function will return the result of calling
 * the `whenTrueFn` function with the same argument. If the predicate is not
 * satisfied, the argument is returned as is.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category Logic
 * @sig (a -> Boolean) -> (a -> b) -> a -> a | b
 * @param {Function} pred       A predicate function
 * @param {Function} whenTrueFn A function to invoke when the `condition`
 *                              evaluates to a truthy value.
 * @param {*}        x          An object to test with the `pred` function and
 *                              pass to `whenTrueFn` if necessary.
 * @return {*} Either `x` or the result of applying `x` to `whenTrueFn`.
 * @see R.ifElse, R.unless, R.cond
 * @example
 *
 *      // truncate :: String -> String
 *      const truncate = R.when(
 *        R.propSatisfies(R.gt(R.__, 10), 'length'),
 *        R.pipe(R.take(10), R.append('…'), R.join(''))
 *      );
 *      truncate('12345');         //=> '12345'
 *      truncate('0123456789ABC'); //=> '0123456789…'
 */ var $d7a78f4a6ab14028$var$when = /*#__PURE__*/ (0, $cjSwl.default)(function when(pred, whenTrueFn, x) {
    return pred(x) ? whenTrueFn(x) : x;
});
var $d7a78f4a6ab14028$export$2e2bcd8739ae039 = $d7a78f4a6ab14028$var$when;

});

parcelRegister("f0KXx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aedb48391b8d5279$export$2e2bcd8739ae039; });

var $4E2dE = parcelRequire("4E2dE");

var $jn7AE = parcelRequire("jn7AE");
/**
 * Takes a spec object and a test object; returns true if the test satisfies
 * the spec. Each of the spec's own properties must be a predicate function.
 * Each predicate is applied to the value of the corresponding property of the
 * test object. `where` returns true if all the predicates return true, false
 * otherwise.
 *
 * `where` is well suited to declaratively expressing constraints for other
 * functions such as [`filter`](#filter) and [`find`](#find).
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category Object
 * @sig {String: (* -> Boolean)} -> {String: *} -> Boolean
 * @param {Object} spec
 * @param {Object} testObj
 * @return {Boolean}
 * @see R.propSatisfies, R.whereEq
 * @example
 *
 *      // pred :: Object -> Boolean
 *      const pred = R.where({
 *        a: R.equals('foo'),
 *        b: R.complement(R.equals('bar')),
 *        x: R.gt(R.__, 10),
 *        y: R.lt(R.__, 20)
 *      });
 *
 *      pred({a: 'foo', b: 'xxx', x: 11, y: 19}); //=> true
 *      pred({a: 'xxx', b: 'xxx', x: 11, y: 19}); //=> false
 *      pred({a: 'foo', b: 'bar', x: 11, y: 19}); //=> false
 *      pred({a: 'foo', b: 'xxx', x: 10, y: 19}); //=> false
 *      pred({a: 'foo', b: 'xxx', x: 11, y: 20}); //=> false
 */ var $aedb48391b8d5279$var$where = /*#__PURE__*/ (0, $4E2dE.default)(function where(spec, testObj) {
    for(var prop in spec){
        if ((0, $jn7AE.default)(prop, spec) && !spec[prop](testObj[prop])) return false;
    }
    return true;
});
var $aedb48391b8d5279$export$2e2bcd8739ae039 = $aedb48391b8d5279$var$where;

});

parcelRegister("96e5t", function(module, exports) {

var $4E2dE = parcelRequire("4E2dE");

var $jn7AE = parcelRequire("jn7AE");
/**
 * Takes a spec object and a test object; each of the spec's own properties must be a predicate function.
 * Each predicate is applied to the value of the corresponding property of the
 * test object. `whereAny` returns true if at least one of the predicates return true,
 * false otherwise.
 *
 * `whereAny` is well suited to declaratively expressing constraints for other
 * functions such as [`filter`](#filter) and [`find`](#find).
 *
 * @func
 * @memberOf R
 * @since v0.28.0
 * @category Object
 * @sig {String: (* -> Boolean)} -> {String: *} -> Boolean
 * @param {Object} spec
 * @param {Object} testObj
 * @return {Boolean}
 * @see R.propSatisfies, R.where
 * @example
 *
 *      // pred :: Object -> Boolean
 *      const pred = R.whereAny({
 *        a: R.equals('foo'),
 *        b: R.complement(R.equals('xxx')),
 *        x: R.gt(R.__, 10),
 *        y: R.lt(R.__, 20)
 *      });
 *
 *      pred({a: 'foo', b: 'xxx', x: 8, y: 34}); //=> true
 *      pred({a: 'xxx', b: 'xxx', x: 9, y: 21}); //=> false
 *      pred({a: 'bar', b: 'xxx', x: 10, y: 20}); //=> false
 *      pred({a: 'foo', b: 'bar', x: 10, y: 20}); //=> true
 *      pred({a: 'foo', b: 'xxx', x: 11, y: 20}); //=> true
 */ var $69ff9a07832c6344$var$whereAny = /*#__PURE__*/ (0, $4E2dE.default)(function whereAny(spec, testObj) {
    for(var prop in spec){
        if ((0, $jn7AE.default)(prop, spec) && spec[prop](testObj[prop])) return true;
    }
    return false;
});
var $69ff9a07832c6344$export$2e2bcd8739ae039 = $69ff9a07832c6344$var$whereAny;

});

parcelRegister("lysVX", function(module, exports) {

var $4E2dE = parcelRequire("4E2dE");

var $imwRL = parcelRequire("imwRL");

var $aaiYf = parcelRequire("aaiYf");

var $f0KXx = parcelRequire("f0KXx");
/**
 * Takes a spec object and a test object; returns true if the test satisfies
 * the spec, false otherwise. An object satisfies the spec if, for each of the
 * spec's own properties, accessing that property of the object gives the same
 * value (in [`R.equals`](#equals) terms) as accessing that property of the
 * spec.
 *
 * `whereEq` is a specialization of [`where`](#where).
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Object
 * @sig {String: *} -> {String: *} -> Boolean
 * @param {Object} spec
 * @param {Object} testObj
 * @return {Boolean}
 * @see R.propEq, R.where
 * @example
 *
 *      // pred :: Object -> Boolean
 *      const pred = R.whereEq({a: 1, b: 2});
 *
 *      pred({a: 1});              //=> false
 *      pred({a: 1, b: 2});        //=> true
 *      pred({a: 1, b: 2, c: 3});  //=> true
 *      pred({a: 1, b: 1});        //=> false
 */ var $fb133794b80dcdad$var$whereEq = /*#__PURE__*/ (0, $4E2dE.default)(function whereEq(spec, testObj) {
    return (0, $f0KXx.default)((0, $aaiYf.default)((0, $imwRL.default), spec), testObj);
});
var $fb133794b80dcdad$export$2e2bcd8739ae039 = $fb133794b80dcdad$var$whereEq;

});

parcelRegister("8tUYZ", function(module, exports) {

var $k7LM5 = parcelRequire("k7LM5");

var $4E2dE = parcelRequire("4E2dE");

var $44Hns = parcelRequire("44Hns");

var $8MN2o = parcelRequire("8MN2o");
/**
 * Returns a new list without values in the first argument.
 * [`R.equals`](#equals) is used to determine equality.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig [a] -> [a] -> [a]
 * @param {Array} list1 The values to be removed from `list2`.
 * @param {Array} list2 The array to remove values from.
 * @return {Array} The new array without values in `list1`.
 * @see R.transduce, R.difference, R.remove
 * @example
 *
 *      R.without([1, 2], [1, 2, 1, 3, 4]); //=> [3, 4]
 */ var $62cd3bbf4a396862$var$without = /*#__PURE__*/ (0, $4E2dE.default)(function(xs, list) {
    return (0, $8MN2o.default)((0, $44Hns.default)((0, $k7LM5.default))(xs), list);
});
var $62cd3bbf4a396862$export$2e2bcd8739ae039 = $62cd3bbf4a396862$var$without;

});

parcelRegister("dJwPV", function(module, exports) {

var $4E2dE = parcelRequire("4E2dE");
/**
 * Exclusive disjunction logical operation.
 * Returns `true` if one of the arguments is truthy and the other is falsy.
 * Otherwise, it returns `false`.
 *
 * @func
 * @memberOf R
 * @since v0.27.1
 * @category Logic
 * @sig a -> b -> Boolean
 * @param {Any} a
 * @param {Any} b
 * @return {Boolean} true if one of the arguments is truthy and the other is falsy
 * @see R.or, R.and
 * @example
 *
 *      R.xor(true, true); //=> false
 *      R.xor(true, false); //=> true
 *      R.xor(false, true); //=> true
 *      R.xor(false, false); //=> false
 */ var $9ff8f2f9d2b7ef50$var$xor = /*#__PURE__*/ (0, $4E2dE.default)(function xor(a, b) {
    return Boolean(!a ^ !b);
});
var $9ff8f2f9d2b7ef50$export$2e2bcd8739ae039 = $9ff8f2f9d2b7ef50$var$xor;

});

parcelRegister("b7jhD", function(module, exports) {

var $4E2dE = parcelRequire("4E2dE");
/**
 * Creates a new list out of the two supplied by creating each possible pair
 * from the lists.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [b] -> [[a,b]]
 * @param {Array} as The first list.
 * @param {Array} bs The second list.
 * @return {Array} The list made by combining each possible pair from
 *         `as` and `bs` into pairs (`[a, b]`).
 * @example
 *
 *      R.xprod([1, 2], ['a', 'b']); //=> [[1, 'a'], [1, 'b'], [2, 'a'], [2, 'b']]
 * @symb R.xprod([a, b], [c, d]) = [[a, c], [a, d], [b, c], [b, d]]
 */ var $817f4e6e94c18199$var$xprod = /*#__PURE__*/ (0, $4E2dE.default)(function xprod(a, b) {
    // = xprodWith(prepend); (takes about 3 times as long...)
    var idx = 0;
    var ilen = a.length;
    var j;
    var jlen = b.length;
    var result = [];
    while(idx < ilen){
        j = 0;
        while(j < jlen){
            result[result.length] = [
                a[idx],
                b[j]
            ];
            j += 1;
        }
        idx += 1;
    }
    return result;
});
var $817f4e6e94c18199$export$2e2bcd8739ae039 = $817f4e6e94c18199$var$xprod;

});

parcelRegister("b5liY", function(module, exports) {

var $4E2dE = parcelRequire("4E2dE");
/**
 * Creates a new list out of the two supplied by pairing up equally-positioned
 * items from both lists. The returned list is truncated to the length of the
 * shorter of the two input lists.
 * Note: `zip` is equivalent to `zipWith(function(a, b) { return [a, b] })`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [b] -> [[a,b]]
 * @param {Array} list1 The first array to consider.
 * @param {Array} list2 The second array to consider.
 * @return {Array} The list made by pairing up same-indexed elements of `list1` and `list2`.
 * @example
 *
 *      R.zip([1, 2, 3], ['a', 'b', 'c']); //=> [[1, 'a'], [2, 'b'], [3, 'c']]
 * @symb R.zip([a, b, c], [d, e, f]) = [[a, d], [b, e], [c, f]]
 */ var $8120b017a3a434ab$var$zip = /*#__PURE__*/ (0, $4E2dE.default)(function zip(a, b) {
    var rv = [];
    var idx = 0;
    var len = Math.min(a.length, b.length);
    while(idx < len){
        rv[idx] = [
            a[idx],
            b[idx]
        ];
        idx += 1;
    }
    return rv;
});
var $8120b017a3a434ab$export$2e2bcd8739ae039 = $8120b017a3a434ab$var$zip;

});

parcelRegister("edOvu", function(module, exports) {

var $4E2dE = parcelRequire("4E2dE");
/**
 * Creates a new object out of a list of keys and a list of values.
 * Key/value pairing is truncated to the length of the shorter of the two lists.
 * Note: `zipObj` is equivalent to `pipe(zip, fromPairs)`.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig [String] -> [*] -> {String: *}
 * @param {Array} keys The array that will be properties on the output object.
 * @param {Array} values The list of values on the output object.
 * @return {Object} The object made by pairing up same-indexed elements of `keys` and `values`.
 * @example
 *
 *      R.zipObj(['a', 'b', 'c'], [1, 2, 3]); //=> {a: 1, b: 2, c: 3}
 */ var $a5a9753292381782$var$zipObj = /*#__PURE__*/ (0, $4E2dE.default)(function zipObj(keys, values) {
    var idx = 0;
    var len = Math.min(keys.length, values.length);
    var out = {};
    while(idx < len){
        out[keys[idx]] = values[idx];
        idx += 1;
    }
    return out;
});
var $a5a9753292381782$export$2e2bcd8739ae039 = $a5a9753292381782$var$zipObj;

});

parcelRegister("9v1VT", function(module, exports) {

var $cjSwl = parcelRequire("cjSwl");
/**
 * Creates a new list out of the two supplied by applying the function to each
 * equally-positioned pair in the lists. The returned list is truncated to the
 * length of the shorter of the two input lists.
 *
 * @function
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig ((a, b) -> c) -> [a] -> [b] -> [c]
 * @param {Function} fn The function used to combine the two elements into one value.
 * @param {Array} list1 The first array to consider.
 * @param {Array} list2 The second array to consider.
 * @return {Array} The list made by combining same-indexed elements of `list1` and `list2`
 *         using `fn`.
 * @example
 *
 *      const f = (x, y) => {
 *        // ...
 *      };
 *      R.zipWith(f, [1, 2, 3], ['a', 'b', 'c']);
 *      //=> [f(1, 'a'), f(2, 'b'), f(3, 'c')]
 * @symb R.zipWith(fn, [a, b, c], [d, e, f]) = [fn(a, d), fn(b, e), fn(c, f)]
 */ var $6ea88220da818e01$var$zipWith = /*#__PURE__*/ (0, $cjSwl.default)(function zipWith(fn, a, b) {
    var rv = [];
    var idx = 0;
    var len = Math.min(a.length, b.length);
    while(idx < len){
        rv[idx] = fn(a[idx], b[idx]);
        idx += 1;
    }
    return rv;
});
var $6ea88220da818e01$export$2e2bcd8739ae039 = $6ea88220da818e01$var$zipWith;

});

parcelRegister("kCWzi", function(module, exports) {

var $4fS8E = parcelRequire("4fS8E");

var $lrIA4 = parcelRequire("lrIA4");
/**
 * Creates a thunk out of a function. A thunk delays a calculation until
 * its result is needed, providing lazy evaluation of arguments.
 *
 * @func
 * @memberOf R
 * @since v0.26.0
 * @category Function
 * @sig ((a, b, ..., j) -> k) -> (a, b, ..., j) -> (() -> k)
 * @param {Function} fn A function to wrap in a thunk
 * @return {Function} Expects arguments for `fn` and returns a new function
 *  that, when called, applies those arguments to `fn`.
 * @see R.partial, R.partialRight
 * @example
 *
 *      R.thunkify(R.identity)(42)(); //=> 42
 *      R.thunkify((a, b) => a + b)(25, 17)(); //=> 42
 */ var $f044c9b117ce5e49$var$thunkify = /*#__PURE__*/ (0, $lrIA4.default)(function thunkify(fn) {
    return (0, $4fS8E.default)(fn.length, function createThunk() {
        var fnArgs = arguments;
        return function invokeThunk() {
            return fn.apply(this, fnArgs);
        };
    });
});
var $f044c9b117ce5e49$export$2e2bcd8739ae039 = $f044c9b117ce5e49$var$thunkify;

});



parcelRegister("2iUhu", function(module, exports) {

$parcel$export(module.exports, "ShopifyService", function () { return $1ad8eb7786180d18$export$b8044c8a21a059c7; });

var $jUeMt = parcelRequire("jUeMt");
class $1ad8eb7786180d18$export$b8044c8a21a059c7 {
    getCheckout(isFromWebapp, callback, attempt) {
        return this.impl.getCheckout(isFromWebapp, callback, attempt);
    }
    createCheckout(callback) {
        return this.impl.createCheckout(callback);
    }
    applyDiscount(checkoutId, discountCode, callback) {
        return this.impl.applyDiscount(checkoutId, discountCode, callback);
    }
    getCollection(collectionId) {
        return this.impl.getCollection(collectionId);
    }
    addLineItems(checkoutId, lineItems) {
        return this.impl.addLineItems(checkoutId, lineItems);
    }
    updateLineItems(checkoutId, lineItems) {
        return this.impl.updateLineItems(checkoutId, lineItems);
    }
    getProduct(productId) {
        return this.impl.getProduct(productId);
    }
    cleanCheckout() {
        return this.impl.cleanCheckout();
    }
    getCollectionALaCarteVariantArray(collectionId, isVip, isFromWebapp) {
        return this.impl.getCollectionALaCarteVariantArray(collectionId, isVip, isFromWebapp);
    }
    getCollVariant(collectionId, isVip, isFromWebapp) {
        return this.impl.getCollVariant(collectionId, isVip, isFromWebapp);
    }
    getProductVariant(product, isVip) {
        return this.impl.getProductVariant(product, isVip);
    }
    getVariantSelectedOption(prodVariant, optionName) {
        return this.impl.getVariantSelectedOption(prodVariant, optionName);
    }
    normalizeProductId(id) {
        return this.impl.normalizeProductId(id);
    }
    normalizeCollectionId(id) {
        return this.impl.normalizeCollectionId(id);
    }
    normalizeProductVariantId(id) {
        return this.impl.normalizeProductVariantId(id);
    }
    constructor(){
        this.impl = new (0, $jUeMt.NewShopifyImpl)();
    }
}

});
parcelRegister("jUeMt", function(module, exports) {

$parcel$export(module.exports, "NewShopifyImpl", function () { return $e7deb66cd46cb699$export$a36d218e0c603f66; });

var $hVJj1 = parcelRequire("hVJj1");
class $e7deb66cd46cb699$export$a36d218e0c603f66 {
    getCheckout(isFromWebapp, callback, attempt = 5) {
        this.isFromWebapp = isFromWebapp;
        if (typeof callback === "function") this.getOrCreateCart().then((cart)=>callback(cart)).catch((err)=>{
            console.error("Error getting cart in getCheckout:", err);
            if (attempt > 1) setTimeout(()=>this.getCheckout(callback, attempt - 1), 500);
            else callback(null);
        });
        else return this.getOrCreateCart();
    }
    createCheckout(callback) {
        if (typeof callback === "function") this.createAndStoreCart([]).then((cart)=>callback(cart)).catch(()=>callback(null));
        else return this.createAndStoreCart([]);
    }
    addLineItems(cartId, lineItems) {
        const lines = (lineItems || []).map((item)=>({
                merchandiseId: item.variantId,
                quantity: item.quantity || 1,
                attributes: item.customAttributes || []
            }));
        return this.cartLinesAdd(cartId, lines);
    }
    async updateLineItems(cartId, oldLineItems) {
        var _updatePayload_userErrors;
        const lines = oldLineItems.map((item)=>({
                id: item.id,
                quantity: item.quantity,
                attributes: item.customAttributes || []
            }));
        // 2) Build the GraphQL mutation
        const query = `
      mutation cartLinesUpdate($cartId: ID!, $lines: [CartLineUpdateInput!]!) {
        cartLinesUpdate(cartId: $cartId, lines: $lines) {
          cart {
            id
            webUrl: checkoutUrl
            lines(first: 50) {
              edges {
                node {
                  id
                  quantity
                  attributes {
                    key
                    value
                  }
                  merchandise {
                    ... on ProductVariant {
                      id
                      title
                      image {
                        src: url
                        altText
                      }
                      product {
                        id
                        title
                        description
                        handle
                      }
                      priceV2 {
                        amount
                        currencyCode
                      }
                    }
                  }
                  discountAllocations {
                    discountApplication {
                      value {
                        ... on PricingPercentageValue {
                          percentage
                        }
                        ... on MoneyV2 {
                          amount
                        }
                      }
                    }
                    allocatedAmount: discountedAmount {
                      amount
                      currencyCode
                    }
                  }
                }
              }
            }
            cost {
              subtotalPrice: subtotalAmount {
                amount
                currencyCode
              }
              totalTax: totalTaxAmount {
                amount
                currencyCode
              }
              totalPrice: totalAmount {
                amount
                currencyCode
              }
            }
            discountAllocations {
              discountApplication {
                value {
                  ... on PricingPercentageValue {
                    percentage
                  }
                  ... on MoneyV2 {
                    amount
                  }
                }
              }
              allocatedAmount:discountedAmount {
                amount
                currencyCode
              }
            }
            discountCodes {
              code
              applicable
            }
          }
          userErrors {
            field
            message
          }
        }
      }
    `;
        // 3) Execute the GraphQL request
        const variables = {
            cartId: cartId,
            lines: lines
        };
        const response = await (0, $hVJj1.shopifyGraphQLRequest)(query, variables);
        // 4) Error handling / userErrors
        const updatePayload = response.cartLinesUpdate;
        if (!updatePayload || ((_updatePayload_userErrors = updatePayload.userErrors) === null || _updatePayload_userErrors === void 0 ? void 0 : _updatePayload_userErrors.length)) {
            const errors = (updatePayload === null || updatePayload === void 0 ? void 0 : updatePayload.userErrors) || [];
            console.error("cartLinesUpdate errors", errors);
            throw new Error("Failed to update cart lines");
        }
        // 5) Return the updated cart
        this._removeDraftOrderInfoFromLocalStorage();
        const flatCart = this._flattenCost(updatePayload.cart);
        flatCart.lineItems = this._flattenCartLines(flatCart);
        flatCart.discountApplications = this._fillDiscountApplications(flatCart);
        return flatCart;
    }
    getCollection(collectionId) {
        const collectionGid = `gid://shopify/Collection/${collectionId}`;
        return this.fetchCollectionById(collectionGid);
    }
    cleanCheckout() {
        return this.resetCart();
    }
    /**
   * Applies discount codes to an existing cart (supports callback or promise).
   *
   * @param {string} cartId - The ID of the cart to update.
   * @param {Array<string>} discountCodes - An array of discount code strings to apply.
   * @param {Function} [callback] - (Optional) A callback to handle the result or error.
   * @returns {Promise<Object>|void} - Returns a Promise if callback is not provided.
   */ async applyDiscount(cartId, discountCode, callback = null) {
        const query = `
      mutation cartDiscountCodesUpdate($cartId: ID!, $discountCodes: [String!]!) {
        cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $discountCodes) {
          cart {
            id
            webUrl: checkoutUrl
            discountCodes {
              code
              applicable
            }
            discountAllocations {
              discountApplication {
                value {
                  ... on PricingPercentageValue {
                    percentage
                  }
                  ... on MoneyV2 {
                    amount
                  }
                }
              }
              allocatedAmount:discountedAmount {
                amount
                currencyCode
              }
            }
            lines(first: 50) {
              edges {
                node {
                  id
                  quantity
                  attributes {
                    key
                    value
                  }
                  merchandise {
                    ... on ProductVariant {
                      id
                      title
                      image {
                        src: url
                        altText
                      }
                      product {
                        id
                        title
                        description
                        handle
                      }
                      priceV2 {
                        amount
                        currencyCode
                      }
                    }
                  }
                  discountAllocations {
                    discountApplication {
                      value {
                        ... on PricingPercentageValue {
                          percentage
                        }
                        ... on MoneyV2 {
                          amount
                        }
                      }
                    }
                    allocatedAmount:discountedAmount {
                      amount
                      currencyCode
                    }
                  }
                }
              }
            }
            cost {
              subtotalAmount {
                amount
                currencyCode
              }
              totalTaxAmount {
                amount
                currencyCode
              }
              totalAmount {
                amount
                currencyCode
              }
            }
          }
          userErrors {
            field
            message
          }
        }
      }
    `;
        const variables = {
            cartId: cartId,
            discountCodes: [
                discountCode
            ]
        };
        // Helper function for success => either callback or return the updated cart
        const handleSuccess = (updatedCart)=>{
            if (typeof callback === "function") {
                callback(updatedCart);
                return;
            }
            // Promise style
            return updatedCart;
        };
        const handleError = (err)=>{
            if (typeof callback === "function") {
                callback(null);
                return;
            }
            throw err;
        };
        try {
            const { cartDiscountCodesUpdate: cartDiscountCodesUpdate } = await (0, $hVJj1.shopifyGraphQLRequest)(query, variables);
            if (cartDiscountCodesUpdate.userErrors && cartDiscountCodesUpdate.userErrors.length > 0) {
                console.error("applyDiscount userErrors:", cartDiscountCodesUpdate.userErrors);
                return handleError(new Error("Failed to apply discount codes"));
            }
            this._removeDraftOrderInfoFromLocalStorage();
            const updatedCart = cartDiscountCodesUpdate.cart;
            // 5) Return the updated cart
            const flatCart = this._flattenCost(updatedCart);
            flatCart.lineItems = this._flattenCartLines(flatCart);
            // flatCart.discountApplications = flatCart.discountAllocations && flatCart.discountAllocations[0] ? flatCart.discountAllocations[0]['discountApplication'] : [];
            flatCart.discountApplications = this._fillDiscountApplications(flatCart);
            return handleSuccess(flatCart);
        } catch (error) {
            console.error("Error applying discount codes:", error);
            return handleError(null);
        }
    }
    getCollVariant(collectionId, isVip, isFromWebapp) {
        return this.getCollVariantNew(collectionId, isVip, isFromWebapp);
    }
    getProduct(productId) {
        const productGid = `gid://shopify/Product/${productId}`;
        return this.fetchProductById(productGid);
    }
    async getCollectionALaCarteVariantArray(collectionId, isVip, isFromWebapp) {
        try {
            // 1) Convert numeric ID to a GID if needed
            const collectionGid = this.normalizeCollectionId(collectionId);
            // 2) Fetch the collection via GraphQL
            const collection = await this.fetchCollectionById(collectionGid);
            if (!collection) throw new Error(`No collection found for ID ${collectionId}`);
            // 3) Build an array of variants
            const variantArr = [];
            const { products: products } = collection;
            for (const product of products){
                var _product_variantsArray;
                // 4) Attempt to find a "VIP" variant or fallback
                let variant = this.getProductVariant(product, isVip);
                if (!variant && ((_product_variantsArray = product.variantsArray) === null || _product_variantsArray === void 0 ? void 0 : _product_variantsArray.length)) variant = product.variantsArray[0];
                // 5) If still no variant, skip or handle
                if (!variant) continue;
                // 6) poolPrefix logic (similar to old approach)
                const poolPrefix = this.getVariantSelectedOption(variant, this.PRODUCT_OPTION_POOL_PREFIX);
                const unlockMedia = this.getVariantSelectedOption(variant, this.PRODUCT_OPTION_UNLOCK_MEDIA);
                // 7) Attach any extra fields
                variant.productTitle = product.title;
                variant.poolPrefix = poolPrefix;
                variant.unlockMedia = unlockMedia;
                variant.desc = product.description;
                if (isFromWebapp) variant.shipmentPoolPrefix = this.getShipmentPoolPrefixFromDescription(product.description);
                variantArr.push(variant);
            }
            return variantArr;
        } catch (err) {
            throw err;
        }
    }
    getShipmentPoolPrefixFromDescription(description) {
        let shipPoolPrefix = null;
        if (!description) return null;
        try {
            const descr = JSON.parse(description);
            if (descr && descr.shipment_pool_prefix) shipPoolPrefix = descr.shipment_pool_prefix;
        } catch (err) {
            console.log(err);
            return null;
        }
        return shipPoolPrefix;
    }
    getProductVariant(product, isVip) {
        return this._getProductVariant(product, isVip);
    }
    getVariantSelectedOption(prodVariant, optionName) {
        const { selectedOptions: selectedOptions } = prodVariant || {};
        if (!Array.isArray(selectedOptions) || !selectedOptions.length) return null;
        const matchedOption = selectedOptions.find((opt)=>opt.name === optionName);
        return matchedOption ? matchedOption.value : null;
    }
    normalizeProductId(id) {
        return `gid://shopify/Product/${id}`;
    }
    normalizeCollectionId(id) {
        return `gid://shopify/Collection/${id}`;
    }
    normalizeProductVariantId(id) {
        return `gid://shopify/ProductVariant/${id}`;
    }
    async getOrCreateCart() {
        const cartId = this._getStoredCartId();
        if (cartId) {
            let cart = await this.fetchCart(cartId);
            if (!cart) return this.createAndStoreCart([]);
            const shippingAddress = this._getShippingAddress();
            // If a shipping address is provided, update the cart with it
            if (this.isFromWebapp && shippingAddress && shippingAddress.address1) try {
                cart = await this.updateCartAddress(cart.id, shippingAddress);
            } catch (error) {
                console.error("Failed to update cart address:", error);
                throw new Error("Cart created but failed to set shipping address");
            }
            const flatCart = this._flattenCost(cart);
            flatCart.lineItems = this._flattenCartLines(flatCart);
            flatCart.discountApplications = this._fillDiscountApplications(flatCart);
            return flatCart;
        }
        const newCart = await this.createAndStoreCart([]);
        const flatCart = this._flattenCost(newCart);
        flatCart.lineItems = this._flattenCartLines(flatCart);
        return flatCart;
    }
    async cartLinesAdd(cartId, lines) {
        const query = `
      mutation cartLinesAdd($cartId: ID!, $lines: [CartLineInput!]!) {
        cartLinesAdd(cartId: $cartId, lines: $lines) {
          cart {
            id
            webUrl: checkoutUrl
            discountCodes {
              code
              applicable
            }
            discountAllocations {
              discountApplication {
                value {
                  ... on PricingPercentageValue {
                    percentage
                  }
                  ... on MoneyV2 {
                    amount
                  }
                }
              }
              allocatedAmount:discountedAmount {
                amount
                currencyCode
              }
            }
            lines(first: 50) {
              edges {
                node {
                  id
                  quantity
                  attributes {
                    key
                    value
                  }
                  merchandise {
                    ... on ProductVariant {
                      id
                      title
                      image {
                        src: url
                        altText
                      }
                      product {
                        id
                        title
                        description
                        handle
                      }
                      priceV2 {
                        amount
                        currencyCode
                      }
                    }
                  }
                  discountAllocations {
                    discountApplication {
                      value {
                        ... on PricingPercentageValue {
                          percentage
                        }
                        ... on MoneyV2 {
                          amount
                        }
                      }
                    }
                    allocatedAmount:discountedAmount {
                      amount
                      currencyCode
                    }
                  }
                }
              }
            }
            cost {
              subtotalPrice: subtotalAmount {
                amount
                currencyCode
              }
              totalTax: totalTaxAmount {
                amount
                currencyCode
              }
              totalPrice: totalAmount {
                amount
                currencyCode
              }
            }
            discountAllocations {
              discountApplication {
                value {
                  ... on PricingPercentageValue {
                    percentage
                  }
                  ... on MoneyV2 {
                    amount
                  }
                }
              }
              allocatedAmount:discountedAmount {
                amount
                currencyCode
              }
            }
            discountCodes {
              code
              applicable
            }
          }
          userErrors {
            field
            message
          }
        }
      }
    `;
        const variables = {
            cartId: cartId,
            lines: lines
        };
        const { cartLinesAdd: cartLinesAdd } = await (0, $hVJj1.shopifyGraphQLRequest)(query, variables);
        if (cartLinesAdd.userErrors && cartLinesAdd.userErrors.length) {
            console.error("cartLinesAdd userErrors", cartLinesAdd.userErrors);
            throw new Error("Failed to add line items");
        }
        this._removeDraftOrderInfoFromLocalStorage();
        const flatCart = this._flattenCost(cartLinesAdd.cart);
        flatCart.lineItems = this._flattenCartLines(flatCart);
        flatCart.discountApplications = this._fillDiscountApplications(flatCart);
        return flatCart;
    }
    async cartLinesRemove(cartId, lineIds) {
        const query = `
      mutation cartLinesRemove($cartId: ID!, $lineIds: [ID!]!) {
        cartLinesRemove(cartId: $cartId, lineIds: $lineIds) {
          cart {
            id
            webUrl: checkoutUrl
            lines(first: 50) {
              edges {
                node {
                  id
                  quantity
                }
              }
            }
          }
          userErrors {
            field
            message
          }
        }
      }
    `;
        const variables = {
            cartId: cartId,
            lineIds: lineIds
        };
        const { cartLinesRemove: cartLinesRemove } = await (0, $hVJj1.shopifyGraphQLRequest)(query, variables);
        if (cartLinesRemove.userErrors && cartLinesRemove.userErrors.length) {
            console.error("cartLinesRemove userErrors", cartLinesRemove.userErrors);
            throw new Error("Failed to remove line items");
        }
        this._removeDraftOrderInfoFromLocalStorage();
        return cartLinesRemove.cart;
    }
    async fetchCart(cartId) {
        const query = `
      query getCart($cartId: ID!) {
        cart(id: $cartId) {
          id
          webUrl: checkoutUrl
          lines(first: 50) {
            edges {
              node {
                id
                quantity
                attributes {
                  key
                  value
                }
                merchandise {
                  ... on ProductVariant {
                    id
                    title
                    image {
                      src: url
                      altText
                    }
                    product {
                      id
                      title
                      description
                      handle
                    }
                    priceV2 {
                      amount
                      currencyCode
                    }
                  }
                }
                discountAllocations {
                  discountApplication {
                    value {
                      ... on PricingPercentageValue {
                        percentage
                      }
                      ... on MoneyV2 {
                        amount
                      }
                    }
                  }
                  allocatedAmount: discountedAmount {
                    amount
                    currencyCode
                  }
                }
              }
            }
          }
          cost {
            subtotalPrice: subtotalAmount {
              amount
              currencyCode
            }
            totalTax: totalTaxAmount {
              amount
              currencyCode
            }
            totalPrice: totalAmount {
              amount
              currencyCode
            }
          }
          discountAllocations {
            discountApplication {
              value {
                ... on PricingPercentageValue {
                  percentage
                }
                ... on MoneyV2 {
                  amount
                }
              }
            }
            allocatedAmount: discountedAmount {
              amount
              currencyCode
            }
          }
          discountCodes {
            code
            applicable
          }
        }
      }
    `;
        const data = await (0, $hVJj1.shopifyGraphQLRequest)(query, {
            cartId: cartId
        });
        return data.cart || null;
    }
    async createAndStoreCart(lines = []) {
        const query = `
      mutation cartCreate($lines: [CartLineInput!]!) {
        cartCreate(input: { lines: $lines }) {
          cart {
            id
            webUrl: checkoutUrl
            lines(first: 50) {
              edges {
                node {
                  id
                  quantity
                  attributes {
                    key
                    value
                  }
                  merchandise {
                    ... on ProductVariant {
                      id
                      title
                      image {
                        src: url
                        altText
                      }
                      product {
                        id
                        title
                        description
                        handle
                      }
                      priceV2 {
                        amount
                        currencyCode
                      }
                    }
                  }
                  discountAllocations {
                    discountApplication {
                      value {
                        ... on PricingPercentageValue {
                          percentage
                        }
                        ... on MoneyV2 {
                          amount
                        }
                      }
                    }
                    allocatedAmount: discountedAmount {
                      amount
                      currencyCode
                    }
                  }
                }
              }
            }
            cost {
              subtotalPrice: subtotalAmount {
                amount
                currencyCode
              }
              totalTax: totalTaxAmount {
                amount
                currencyCode
              }
              totalPrice: totalAmount {
                amount
                currencyCode
              }
            }
            discountAllocations {
              discountApplication {
                value {
                  ... on PricingPercentageValue {
                    percentage
                  }
                  ... on MoneyV2 {
                    amount
                  }
                }
              }
              allocatedAmount: discountedAmount {
                amount
                currencyCode
              }
            }
            discountCodes {
              code
              applicable
            }
          }
          userErrors {
            field
            message
          }
        }
      }
    `;
        const variables = {
            lines: lines
        };
        const { cartCreate: cartCreate } = await (0, $hVJj1.shopifyGraphQLRequest)(query, variables);
        if (cartCreate.userErrors && cartCreate.userErrors.length) {
            console.error("cartCreate userErrors", cartCreate.userErrors);
            throw new Error("Failed to create cart");
        }
        const newCart = cartCreate.cart;
        if (newCart) this._setStoredCartId(newCart.id);
        const shippingAddress = this._getShippingAddress();
        // If a shipping address is provided, update the cart with it
        if (this.isFromWebapp && shippingAddress && shippingAddress.address1) try {
            const updatedCart = await this.updateCartAddress(newCart.id, shippingAddress);
            return updatedCart; // Return the updated cart with the shipping address
        } catch (error) {
            console.error("Failed to update cart address:", error);
            throw new Error("Cart created but failed to set shipping address");
        }
        this._removeDraftOrderInfoFromLocalStorage();
        return newCart;
    }
    async updateCartAddress(cartId, newShippingAddress) {
        const query = `
      mutation UpdateCartBuyerIdentity($cartId: ID!, $buyerIdentity: CartBuyerIdentityInput!) {
        cartBuyerIdentityUpdate(cartId: $cartId, buyerIdentity: $buyerIdentity) {
          cart {
            id
            webUrl: checkoutUrl
            cost {
              totalTaxAmount {
                amount
                currencyCode
              }
              totalAmount {
                amount
                currencyCode
              }
            }
            lines(first: 50) {
              edges {
                node {
                  id
                  quantity
                  attributes {
                    key
                    value
                  }
                  merchandise {
                    ... on ProductVariant {
                      id
                      title
                      image {
                        src: url
                        altText
                      }
                      product {
                        id
                        title
                        description
                        handle
                      }
                      priceV2 {
                        amount
                        currencyCode
                      }
                    }
                  }
                  discountAllocations {
                    discountApplication {
                      value {
                        ... on PricingPercentageValue {
                          percentage
                        }
                        ... on MoneyV2 {
                          amount
                        }
                      }
                    }
                    allocatedAmount: discountedAmount {
                      amount
                      currencyCode
                    }
                  }
                }
              }
            }
            cost {
              subtotalPrice: subtotalAmount {
                amount
                currencyCode
              }
              totalTax: totalTaxAmount {
                amount
                currencyCode
              }
              totalPrice: totalAmount {
                amount
                currencyCode
              }
            }
            discountAllocations {
              discountApplication {
                value {
                  ... on PricingPercentageValue {
                    percentage
                  }
                  ... on MoneyV2 {
                    amount
                  }
                }
              }
              allocatedAmount: discountedAmount {
                amount
                currencyCode
              }
            }
            discountCodes {
              code
              applicable
            }
          }
          userErrors {
            field
            message
          }
        }
      }
    `;
        const variables = {
            cartId: cartId,
            buyerIdentity: {
                deliveryAddressPreferences: [
                    {
                        deliveryAddress: {
                            address1: newShippingAddress.address1 || "",
                            address2: newShippingAddress.address2 || "",
                            city: newShippingAddress.city || "",
                            province: newShippingAddress.province || "",
                            country: newShippingAddress.country || "",
                            zip: newShippingAddress.zip || ""
                        }
                    }
                ]
            }
        };
        try {
            const response = await (0, $hVJj1.shopifyGraphQLRequest)(query, variables);
            const { cartBuyerIdentityUpdate: cartBuyerIdentityUpdate } = response;
            if (cartBuyerIdentityUpdate.userErrors && cartBuyerIdentityUpdate.userErrors.length) {
                console.error("cartBuyerIdentityUpdate userErrors", cartBuyerIdentityUpdate.userErrors);
                throw new Error("Failed to update cart address");
            }
            return cartBuyerIdentityUpdate.cart;
        } catch (error) {
            console.error("Error updating cart address:", error);
            throw error;
        }
    }
    async fetchCollectionById(collectionGid) {
        const query = `
      query getCollection($id: ID!) {
        collection(id: $id) {
          id
          title
          description
          image {
            src: url
          }
          products(first: 50) {
            edges {
              node {
                id
                title
                description
                variants(first: 10) {
                  edges {
                    node {
                      id
                      title
                      priceV2 {
                        amount
                        currencyCode
                      }
                      availableForSale
                      selectedOptions {
                        name
                        value
                      }
                      image {
                        src: url
                        altText
                      }
                    }
                  }
                }
                options {
                  name
                  values
                }
              }
            }
          }
        }
      }
    `;
        const variables = {
            id: collectionGid
        };
        const { collection: collection } = await (0, $hVJj1.shopifyGraphQLRequest)(query, variables);
        if (!collection) return null;
        const productsArray = this._flattenEdges(collection.products);
        // flatten each product’s variants
        for (const product of productsArray)product.variantsArray = this._flattenEdges(product.variants);
        return {
            ...collection,
            products: productsArray
        };
    }
    async fetchProductById(productGid) {
        const query = `
      query getProduct($id: ID!) {
        product(id: $id) {
          id
          title
          variants(first: 10) {
            edges {
              node {
                id
                title
                availableForSale
                selectedOptions {
                  name
                  value
                }
                image {
                  src: url
                  altText
                }
              }
            }
          }
        }
      }
    `;
        const variables = {
            id: productGid
        };
        const response = await (0, $hVJj1.shopifyGraphQLRequest)(query, variables);
        return response.product;
    }
    async getCollVariantNew(collectionId, isVip, isFromWebapp) {
        try {
            const collectionGid = this.normalizeCollectionId(collectionId);
            const collection = await this.fetchCollectionById(collectionGid);
            if (!collection) throw new Error(`No collection found for ID ${collectionId}`);
            const description = collection.description || "{}";
            const collObj = JSON.parse(description);
            const prodCount = collObj.product_list;
            const packProductId = collObj.pack_product;
            const packProductGid = this.normalizeProductId(packProductId);
            const packProd = await this.fetchProductById(packProductGid);
            if (!packProd) throw new Error(`No product found for packProductId ${packProductId}`);
            const variantProdPack = this.getProductVariant(packProd, isVip);
            const newProdCount = {};
            for (const pId of Object.keys(prodCount)){
                const normalizedId = this.normalizeProductId(pId);
                newProdCount[normalizedId] = prodCount[pId];
            }
            const variantArr = [];
            const { products: products } = collection;
            let prod_group = 0;
            for (const product of products){
                var _product_variantsArray, _variant_image;
                prod_group++;
                const resortFeeData = this._getResortDescriptionData(product);
                let variant = this.getProductVariant(product, isVip);
                if (!variant && ((_product_variantsArray = product.variantsArray) === null || _product_variantsArray === void 0 ? void 0 : _product_variantsArray.length)) variant = product.variantsArray[0];
                const imageSrc = (variant === null || variant === void 0 ? void 0 : (_variant_image = variant.image) === null || _variant_image === void 0 ? void 0 : _variant_image.src) || "";
                const poolPrefix = this.getVariantSelectedOption(variant, this.PRODUCT_OPTION_POOL_PREFIX) || "";
                const unlockMedia = this.getVariantSelectedOption(variant, this.PRODUCT_OPTION_UNLOCK_MEDIA) || "";
                const shipmentPoolPrefix = this.getShipmentPoolPrefixFromDescription(product.description) || "";
                if (newProdCount[product.id]) for(let i = 0; i < newProdCount[product.id]; i++){
                    const newVariant = {};
                    newVariant.productTitle = product.title;
                    newVariant.id = variant === null || variant === void 0 ? void 0 : variant.id;
                    newVariant.pid = `${prod_group}_${i}`;
                    newVariant.imgUrl = imageSrc;
                    newVariant.poolPrefix = poolPrefix;
                    newVariant.unlockMedia = unlockMedia;
                    newVariant.desc = product.description;
                    if (isFromWebapp) newVariant.shipmentPoolPrefix = shipmentPoolPrefix;
                    variantArr.push(newVariant);
                }
                else {
                    const newVariant = {};
                    if (resortFeeData) {
                        var _packProd_variants_edges, _packProd_variants;
                        const packVariantEdge = (_packProd_variants = packProd.variants) === null || _packProd_variants === void 0 ? void 0 : (_packProd_variants_edges = _packProd_variants.edges) === null || _packProd_variants_edges === void 0 ? void 0 : _packProd_variants_edges[isVip];
                        const packVariantNode = packVariantEdge === null || packVariantEdge === void 0 ? void 0 : packVariantEdge.node;
                        if (packVariantNode === null || packVariantNode === void 0 ? void 0 : packVariantNode.priceV2) {
                            let fee = packVariantNode.priceV2.amount * resortFeeData.fee_persent / 100;
                            fee = Math.round(fee * 100) / 100;
                            const ttl = `${product.title} (${resortFeeData.fee_persent}% included) - ${this.formatPrice({
                                amount: fee,
                                currencyCode: packVariantNode.priceV2.currencyCode
                            })}`;
                            newVariant.productTitle = ttl;
                            newVariant.isResortFee = true;
                        } else newVariant.productTitle = product.title;
                    } else newVariant.productTitle = product.title;
                    newVariant.id = variant === null || variant === void 0 ? void 0 : variant.id;
                    newVariant.pid = `${prod_group}_0`;
                    newVariant.imgUrl = imageSrc;
                    newVariant.poolPrefix = poolPrefix;
                    newVariant.unlockMedia = unlockMedia;
                    newVariant.desc = product.description;
                    variantArr.push(newVariant);
                }
            }
            variantProdPack.variantArr = variantArr;
            return variantProdPack;
        } catch (err) {
            throw err;
        }
    }
    _getProductVariant(product, isVip) {
        var _product_variants;
        const prodVariantList = (product === null || product === void 0 ? void 0 : (_product_variants = product.variants) === null || _product_variants === void 0 ? void 0 : _product_variants.edges) ? product.variants.edges.map((edge)=>edge.node) : [];
        if (prodVariantList.length < 1) return null;
        for (const prodVariant of prodVariantList){
            const variantIsVipValue = this.getVariantSelectedOption(prodVariant, this.PRODUCT_OPTION_IS_VIP);
            if (!isVip || isVip === variantIsVipValue || prodVariantList.length === 1) return prodVariant;
        }
        return null;
    }
    async resetCart() {
        this._removeDraftOrderInfoFromLocalStorage();
        this._removeStoredCartId();
        return this.createAndStoreCart([]);
    }
    // -------------------------------------------------------------------------
    // Private utilities
    // -------------------------------------------------------------------------
    _flattenEdges(connection) {
        if (!connection || !connection.edges) return [];
        return connection.edges.map((edge)=>edge.node);
    }
    _getStoredCartId() {
        return localStorage.getItem(this.localStorageCheckoutIdKey);
    }
    _setStoredCartId(cartId) {
        localStorage.setItem(this.localStorageCheckoutIdKey, cartId);
    }
    _removeStoredCartId() {
        localStorage.removeItem(this.localStorageCheckoutIdKey);
    }
    _getResortDescriptionData(product) {
        if (!product.description) return null;
        const resortDescriptionData = {};
        try {
            // { "key_type": "resort", "fee_persent": 6 }
            const descr = JSON.parse(product.description);
            if (descr && descr.product_type === "resort_fee") {
                resortDescriptionData.isResortFee = true;
                if (descr.fee_persent) resortDescriptionData.fee_persent = descr.fee_persent;
                else return null;
            } else return null;
        } catch (err) {
            console.log(err);
            return null;
        }
        return resortDescriptionData;
    }
    _flattenCartLines(cart) {
        if (!cart || !cart.lines || !cart.lines.edges) return [];
        return cart.lines.edges.map((edge)=>{
            const { node: node } = edge;
            const merch = node.merchandise || {};
            return {
                id: node.id,
                quantity: node.quantity,
                merchandiseId: merch.id,
                title: merch.product.title,
                variant: merch,
                discountAllocations: node.discountAllocations,
                customAttributes: node.attributes
            };
        });
    }
    _flattenCost(cart) {
        if (!(cart === null || cart === void 0 ? void 0 : cart.cost)) return cart;
        const { cost: cost, ...rest } = cart;
        return {
            ...rest,
            subtotalPrice: cost.subtotalPrice,
            totalPrice: cost.totalPrice,
            totalTax: cost.totalTax
        };
    }
    _calculateDiscountApplicationValueAmount(cart) {
        const values = cart.discountAllocations.filter((allocation)=>allocation.discountApplication).map((allocation)=>allocation.discountApplication.value);
        const totalDiscount = values.every((value)=>value.amount) ? values.reduce((sum, value)=>sum + parseFloat(value.amount), 0) : null;
        return totalDiscount;
    }
    _fillDiscountApplications(flatCart) {
        const discountApplications = [];
        if (flatCart.discountAllocations && flatCart.discountAllocations[0]) {
            discountApplications[0] = {
                ...flatCart.discountAllocations[0].discountApplication,
                title: flatCart.discountCodes[0].code,
                allocatedAmount: flatCart.discountAllocations[0].discountedAmount
            };
            const discountApplicationValueAmount = this._calculateDiscountApplicationValueAmount(flatCart);
            if (discountApplicationValueAmount) discountApplications[0].value = {
                amount: discountApplicationValueAmount
            };
        }
        return discountApplications;
    }
    _removeDraftOrderInfoFromLocalStorage() {
        localStorage.removeItem("draftOrderInfo");
    }
    _getShippingAddress() {
        const shippingAddress = this.SHIPPING_ADDRESS;
        if (!shippingAddress || shippingAddress === "null" || shippingAddress === "undefined" || shippingAddress.length < 50) return;
        const shippAddresObj = JSON.parse(shippingAddress);
        return {
            address1: shippAddresObj.shopifyAddress1,
            address2: shippAddresObj.shopifyAddress2,
            city: shippAddresObj.shopifyCity,
            company: shippAddresObj.shopifyCompany,
            country: shippAddresObj.shopifyCountry,
            firstName: shippAddresObj.shopifyFirstName,
            lastName: shippAddresObj.shopifyLastName,
            phone: shippAddresObj.shopifyPhoneNumber,
            province: shippAddresObj.shopifyState,
            zip: shippAddresObj.shopifyZip
        };
    }
    constructor(){
        this.localStorageCheckoutIdKey = "occo-shopify-checkout-id-key";
        this.PRODUCT_OPTION_POOL_PREFIX = "pool_prefix";
        this.PRODUCT_OPTION_UNLOCK_MEDIA = "unlock_media";
        this.PRODUCT_OPTION_IS_VIP = "is_vip";
        this.SHIPPING_ADDRESS = localStorage.getItem("shippingAddress");
    }
}

});
parcelRegister("hVJj1", function(module, exports) {

$parcel$export(module.exports, "shopifyGraphQLRequest", function () { return $d0dae7510a521abd$export$a25e7de498d4c88d; });
async function $d0dae7510a521abd$export$a25e7de498d4c88d(query, variables = {}) {
    const shopifyDomain = localStorage.getItem("shopDomain");
    const shopifyAccessToken = localStorage.getItem("shopToken");
    const shopifyVersion = "2025-01";
    const endpoint = `https://${shopifyDomain}/api/${shopifyVersion}/graphql.json`;
    const response = await fetch(endpoint, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "X-Shopify-Storefront-Access-Token": shopifyAccessToken
        },
        body: JSON.stringify({
            query: query,
            variables: variables
        })
    });
    const { data: data, errors: errors } = await response.json();
    if (errors) {
        console.error("Shopify GraphQL errors:", errors);
        throw new Error("Shopify GraphQL request failed");
    }
    return data;
}

});



parcelRegister("6ct87", function(module, exports) {

$parcel$export(module.exports, "pageRoutes", function () { return $483a75a5c050f458$export$738797e9235a190b; });
$parcel$export(module.exports, "redirectToPage", function () { return $483a75a5c050f458$export$f37e913827f0fcca; });
const $483a75a5c050f458$export$738797e9235a190b = {
    index: "index.html",
    addons: "addons.html",
    changePictures: "change-pictures.html",
    combos: "combos.html",
    faq: "faq.html",
    privacyPolicy: "privacy.html",
    incognitoMode: "incognito-mode.html",
    registration: {
        showIdFirst: "reg-id-first.html",
        normal: "reg-user.html"
    },
    contactCompletion: "contact-completion.html",
    selectImages: "select-images.html",
    selfies: "selfies.html",
    shoppingCart: "shopping-cart.html",
    selectImagesAddon: "select-images-addon.html",
    shoot: "shoot.html",
    aShoot: "a-shoot.html"
};
function $483a75a5c050f458$export$a0b32aef6b0d7373(search, params = {}) {
    const searchParams = new URLSearchParams(search);
    Object.entries(params).forEach(([key, value])=>{
        searchParams.set(key, value);
    });
    return `?${decodeURIComponent(searchParams.toString())}`;
}
function $483a75a5c050f458$var$redirectConstructor(routes) {
    return Object.keys(routes).reduce((acc, key)=>{
        let value;
        if (typeof routes[key] === "object") value = $483a75a5c050f458$var$redirectConstructor(routes[key]);
        else value = $483a75a5c050f458$var$initRedirectTo(routes[key]);
        return {
            ...acc,
            [key]: value
        };
    }, {});
}
const $483a75a5c050f458$export$f37e913827f0fcca = $483a75a5c050f458$var$redirectConstructor($483a75a5c050f458$export$738797e9235a190b);
function $483a75a5c050f458$var$initRedirectTo(path) {
    return async ({ rawSearch: rawSearch = "" } = {})=>Promise.resolve().then(()=>{
            window.location.href = `${path}${rawSearch}`;
        });
}

});


parcelRegister("ii2Pe", function(module, exports) {

$parcel$export(module.exports, "initGalleryViewController", function () { return $d50c1975946e507b$export$8657575fec04fee3; });

var $a4qiB = parcelRequire("a4qiB");

var $6MtXf = parcelRequire("6MtXf");

var $82R4n = parcelRequire("82R4n");

var $jSGkS = parcelRequire("jSGkS");

var $iZrZy = parcelRequire("iZrZy");

var $74kUW = parcelRequire("74kUW");

var $QsXqF = parcelRequire("QsXqF");

var $hCm7x = parcelRequire("hCm7x");
const $d50c1975946e507b$var$itemCssPath = ".gallery__item";
const $d50c1975946e507b$var$getItemCssPathWithId = (id)=>`${$d50c1975946e507b$var$itemCssPath}[data-id="${id}"]`;
const $d50c1975946e507b$var$galleryCssPath = ".gallery";
const $d50c1975946e507b$var$downloadPlaceInGallery = ".gallery__item-btn-download";
const $d50c1975946e507b$var$sharePlaceInGallery = ".gallery__item-btn-share";
const $d50c1975946e507b$var$classHiddenDownloadPlaceInGallery = "gallery__item-btn-download_hidden";
const $d50c1975946e507b$var$classHiddenCheckboxPlaceInGallery = "gallery__item-checkbox_hidden";
const $d50c1975946e507b$var$classHiddenSharePlaceInGallery = "gallery__item-btn-share_hidden";
const $d50c1975946e507b$var$downloadBtnsInGallery = `${$d50c1975946e507b$var$downloadPlaceInGallery} .download-btn`;
const $d50c1975946e507b$var$shareBtnsInGallery = `${$d50c1975946e507b$var$sharePlaceInGallery} .share-btn`;
const $d50c1975946e507b$var$viewBtns = `.gallery__item-view`;
const $d50c1975946e507b$var$classActivateSelection = "gallery__item_active-select";
const $d50c1975946e507b$var$classActivateMultiSelectionItem = "gallery__item_active-multi-select-item";
const $d50c1975946e507b$var$classActivateView = "gallery__item_active-view";
const $d50c1975946e507b$var$classActivateIconType = "gallery__item_active-icon-type";
const $d50c1975946e507b$var$classCheckedItem = "gallery__item_checked";
function $d50c1975946e507b$export$8657575fec04fee3({ isShowDownloadBtn: isShowDownloadBtn = true, isShowShareBtn: isShowShareBtn = true, isShowSelectItem: isShowSelectItem = true, numberOfRows: numberOfRows = 3 } = {}) {
    let handlerOnClick = ()=>{};
    let handlerOnLongTouch = ()=>{};
    let handlerOnClickDownloadBtn = ()=>{};
    let handlerOnClickShareBtn = ()=>{};
    let handlerOnClickViewBtn = ()=>{};
    let handlerOnClickIncrease = ()=>{};
    let handlerOnClickDecrease = ()=>{};
    const listenerOnClick = (event)=>{
        event.preventDefault();
        handlerOnClick(getDataByEvent(event));
    };
    const listenerOnLongTouch = (event)=>{
        event.preventDefault();
        handlerOnLongTouch(getDataByEvent(event));
    };
    const listenerOnClickDownloadBtn = (event)=>{
        event.stopPropagation();
        handlerOnClickDownloadBtn(getDataByEvent(event));
    };
    const listenerOnClickShareBtn = (event)=>{
        event.stopPropagation();
        handlerOnClickShareBtn(getDataByEvent(event));
    };
    const listenerOnClickView = (event)=>{
        event.stopPropagation();
        handlerOnClickViewBtn(getDataByEvent(event));
    };
    console.log("numberOfRows", numberOfRows);
    setRow(numberOfRows);
    return {
        render: render,
        onClick: onClick,
        onLongTouch: onLongTouch,
        select: select,
        unselect: unselect,
        unselectAll: unselectAll,
        enableSelect: enableSelect,
        disableSelect: disableSelect,
        showSelectItem: $82R4n.show,
        hideSelectItem: $82R4n.hide,
        enableMultiSelectItem: enableMultiSelectItem,
        disableMultiSelectItem: disableMultiSelectItem,
        onClickIncrease: onClickIncrease,
        onClickDecrease: onClickDecrease,
        updateCounter: updateCounter,
        onClickDownloadBtn: onClickDownloadBtn,
        onClickShareBtn: onClickShareBtn,
        enableView: enableView,
        disableView: disableView,
        onClickView: onClickView,
        enableIconType: enableIconType
    };
    function setRow() {
        (0, (/*@__PURE__*/$parcel$interopDefault($a4qiB)))($d50c1975946e507b$var$galleryCssPath).removeClass("gallery_row_1 gallery_row_2 gallery_row_3");
        if (numberOfRows === 1 || numberOfRows === 2 || numberOfRows === 3) (0, (/*@__PURE__*/$parcel$interopDefault($a4qiB)))($d50c1975946e507b$var$galleryCssPath).addClass(`gallery_row_${numberOfRows}`);
    }
    function getDataByEvent(event) {
        return {
            id: Number(event.currentTarget.dataset.id),
            type: event.currentTarget.dataset.type
        };
    }
    function render(items, emptyAlbumText) {
        if (items.length === 0) {
            (0, (/*@__PURE__*/$parcel$interopDefault($a4qiB)))($d50c1975946e507b$var$galleryCssPath).hide();
            $hCm7x.setText(emptyAlbumText);
            $hCm7x.show();
            (0, (/*@__PURE__*/$parcel$interopDefault($a4qiB)))($d50c1975946e507b$var$galleryCssPath).html();
            unsubscribe(items);
        } else {
            const htmlImages = items.map(renderItem).reduce((acc, str)=>acc + str, "");
            $hCm7x.hide();
            (0, (/*@__PURE__*/$parcel$interopDefault($a4qiB)))($d50c1975946e507b$var$galleryCssPath).html(htmlImages);
            (0, (/*@__PURE__*/$parcel$interopDefault($a4qiB)))($d50c1975946e507b$var$galleryCssPath).show();
            subscribe(items);
        }
    }
    function dataAttributes({ id: id, type: type }) {
        return `data-id="${id}" data-type="${type}"`;
    }
    function isShowIcon({ type: type }) {
        if ((0, $QsXqF.isMobile)()) return type === "360" || type === "video";
        return true;
    }
    function getIconSrc({ type: type }) {
        if (type === "360") return 0, (/*@__PURE__*/$parcel$interopDefault($jSGkS));
        if (type === "video") return 0, (/*@__PURE__*/$parcel$interopDefault($iZrZy));
        return 0, (/*@__PURE__*/$parcel$interopDefault($74kUW));
    }
    function renderItem(item) {
        return `
        <div class="gallery__item" ${dataAttributes(item)}>
           <img class="gallery__item-img" src="${item.src}" alt="image" 
                onerror="this.parentElement.style.display='none';"
            />
           ${renderWatermark(item.watermarkSrc)}
           <div class="gallery__item-checkbox ${item.canSelect ? "" : $d50c1975946e507b$var$classHiddenCheckboxPlaceInGallery}">
               <img class="gallery__item-checkbox-img-checked" src="img/icons/checkbox-checked.svg" alt="checked" />
               <img class="gallery__item-checkbox-img-unchecked" src="img/icons/checkbox-unchecked.svg" alt="unchecked" />
           </div>
           ${renderIcon(item)}
           <img class="gallery__item-view" ${dataAttributes(item)} src="${getIconSrc(item)}" alt="" style="display:block;"/>
           <div class="gallery__item-multi-select-item">
               ${$82R4n.render({
            id: item.id,
            isShow: isShowSelectItem
        })}
           </div>
           <div class="gallery__item-btn-download ${isShowDownloadBtn && item.canDownload ? "" : $d50c1975946e507b$var$classHiddenDownloadPlaceInGallery}">
               <div class="download-btn" ${dataAttributes(item)}>
                   <img class="download-icon" src="img/icons/icon-download.svg" alt="download icon" />
                   <div class="download-btn__text">download</div>
               </div>
           </div>
           <div class="gallery__item-btn-share ${isShowShareBtn && item.canShare ? "" : $d50c1975946e507b$var$classHiddenSharePlaceInGallery}">
               <div class="share-btn" ${dataAttributes(item)}>
                   <img class="share-icon" src="img/icons/icon-share-white.svg" alt="share icon" />
                   <div class="share-btn__text">share</div>
               </div>
           </div>
       </div>
      `;
    }
    function renderWatermark(src) {
        if (src) return `<div class="gallery__item-watermark" style="background-image:url('${src}')"></div>`;
        return "";
    }
    function renderIcon(item) {
        if (!isShowIcon(item)) return "";
        return `<img class="gallery__item-icon-type" src="${getIconSrc(item)}" alt="icon" />`;
    }
    function subscribe(items) {
        (0, $6MtXf.onClickAll)($d50c1975946e507b$var$itemCssPath, listenerOnClick);
        (0, $6MtXf.onLongTouchAll)($d50c1975946e507b$var$itemCssPath, listenerOnLongTouch);
        (0, $6MtXf.onClickAll)($d50c1975946e507b$var$downloadBtnsInGallery, listenerOnClickDownloadBtn);
        (0, $6MtXf.onClickAll)($d50c1975946e507b$var$shareBtnsInGallery, listenerOnClickShareBtn);
        (0, $6MtXf.onClickAll)($d50c1975946e507b$var$viewBtns, listenerOnClickView);
        items.forEach((item)=>{
            $82R4n.onClickPlus(item.id, handlerOnClickIncrease);
            $82R4n.onClickMinus(item.id, handlerOnClickDecrease);
        });
    }
    function unsubscribe() {
        (0, $6MtXf.unsubscribeOnClickAll)($d50c1975946e507b$var$itemCssPath, listenerOnClick);
        (0, $6MtXf.unsubscribeOnLongTouchAll)($d50c1975946e507b$var$itemCssPath, listenerOnLongTouch);
        (0, $6MtXf.unsubscribeOnClickAll)($d50c1975946e507b$var$downloadBtnsInGallery, listenerOnClickDownloadBtn);
        (0, $6MtXf.unsubscribeOnClickAll)($d50c1975946e507b$var$shareBtnsInGallery, listenerOnClickShareBtn);
        (0, $6MtXf.unsubscribeOnClickAll)($d50c1975946e507b$var$viewBtns, listenerOnClickView);
    }
    function onClick(cb) {
        handlerOnClick = cb;
    }
    function onLongTouch(cb) {
        handlerOnLongTouch = cb;
    }
    function onClickIncrease(cb) {
        handlerOnClickIncrease = cb;
    }
    function onClickDecrease(cb) {
        handlerOnClickDecrease = cb;
    }
    function updateCounter(id, count) {
        $82R4n.updateAmount(id, count);
    }
    function select(id) {
        const $element = document.querySelector($d50c1975946e507b$var$getItemCssPathWithId(id));
        $element.classList.add($d50c1975946e507b$var$classCheckedItem);
    }
    function unselect(id) {
        const $element = document.querySelector($d50c1975946e507b$var$getItemCssPathWithId(id));
        $element.classList.remove($d50c1975946e507b$var$classCheckedItem);
    }
    function unselectAll() {
        const $elements = document.querySelectorAll($d50c1975946e507b$var$itemCssPath);
        Array.from($elements).forEach(($element)=>{
            $element.classList.remove($d50c1975946e507b$var$classCheckedItem);
        });
    }
    function enableSelect() {
        const $elements = document.querySelectorAll($d50c1975946e507b$var$itemCssPath);
        Array.from($elements).forEach(($element)=>{
            $element.classList.add($d50c1975946e507b$var$classActivateSelection);
        });
    }
    function disableSelect() {
        const $elements = document.querySelectorAll($d50c1975946e507b$var$itemCssPath);
        Array.from($elements).forEach(($element)=>{
            $element.classList.remove($d50c1975946e507b$var$classActivateSelection);
        });
    }
    function enableMultiSelectItem() {
        const $elements = document.querySelectorAll($d50c1975946e507b$var$itemCssPath);
        Array.from($elements).forEach(($element)=>{
            $element.classList.add($d50c1975946e507b$var$classActivateMultiSelectionItem);
        });
    }
    function disableMultiSelectItem() {
        const $elements = document.querySelectorAll($d50c1975946e507b$var$itemCssPath);
        Array.from($elements).forEach(($element)=>{
            $element.classList.remove($d50c1975946e507b$var$classActivateMultiSelectionItem);
        });
    }
    function enableView() {
        const $elements = document.querySelectorAll($d50c1975946e507b$var$itemCssPath);
        Array.from($elements).forEach(($element)=>{
            $element.classList.add($d50c1975946e507b$var$classActivateView);
        });
    }
    function disableView() {
        const $elements = document.querySelectorAll($d50c1975946e507b$var$itemCssPath);
        Array.from($elements).forEach(($element)=>{
            $element.classList.remove($d50c1975946e507b$var$classActivateView);
        });
    }
    function enableIconType() {
        const $elements = document.querySelectorAll($d50c1975946e507b$var$itemCssPath);
        Array.from($elements).forEach(($element)=>{
            $element.classList.add($d50c1975946e507b$var$classActivateIconType);
        });
    }
    function onClickDownloadBtn(cb) {
        handlerOnClickDownloadBtn = cb;
    }
    function onClickShareBtn(cb) {
        handlerOnClickShareBtn = cb;
    }
    function onClickView(cb) {
        handlerOnClickViewBtn = cb;
    }
}

});
parcelRegister("6MtXf", function(module, exports) {

$parcel$export(module.exports, "onClickAll", function () { return $4efe762786f5ce68$export$cc8a3418dfb33c84; });
$parcel$export(module.exports, "unsubscribeOnClickAll", function () { return $4efe762786f5ce68$export$146495d6130917a8; });
$parcel$export(module.exports, "onLongTouchAll", function () { return $4efe762786f5ce68$export$33fec3bf402c1222; });
$parcel$export(module.exports, "unsubscribeOnLongTouchAll", function () { return $4efe762786f5ce68$export$645f603e7f28e695; });
function $4efe762786f5ce68$export$cc8a3418dfb33c84(cssPath, cb) {
    const $elements = document.querySelectorAll(cssPath);
    Array.from($elements).forEach(($element)=>{
        $element.addEventListener("click", cb);
        $element.addEventListener("keydown", (event)=>{
            if (event.key === " " || event.key === "Enter") {
                event.preventDefault();
                cb(event);
            }
        });
    });
}
function $4efe762786f5ce68$export$146495d6130917a8(cssPath, cb) {
    const $elements = document.querySelectorAll(cssPath);
    Array.from($elements).forEach(($element)=>{
        $element.removeEventListener("click", cb);
    });
}
const $4efe762786f5ce68$var$subscribersOnLongTouch = {};
function $4efe762786f5ce68$export$11706adc15ed0a8e(element, callback, timeout = 500) {
    let timeoutId;
    let blockPreventDefault = false;
    const obj = {
        touchstart (e) {
            const copyCurrentTarget = e.currentTarget; // NOTE: Need not lose currentTarget
            timeoutId = setTimeout(()=>{
                e.preventDefault();
                e.stopPropagation();
                timeoutId = null;
                Object.defineProperty(e, "currentTarget", {
                    value: copyCurrentTarget
                }); // overwrite currentTarget
                blockPreventDefault = true;
                callback(e);
            }, timeout);
        },
        contextmenu (e) {
            e.preventDefault();
        },
        touchend (e) {
            if (blockPreventDefault) {
                e.preventDefault();
                blockPreventDefault = false;
            }
            if (timeoutId) clearTimeout(timeoutId);
        },
        touchmove () {
            if (timeoutId) clearTimeout(timeoutId);
        }
    };
    $4efe762786f5ce68$var$subscribersOnLongTouch[callback] = obj;
    element.addEventListener("touchstart", obj.touchstart);
    element.addEventListener("contextmenu", obj.contextmenu);
    element.addEventListener("touchend", obj.touchend);
    element.addEventListener("touchmove", obj.touchmove);
}
function $4efe762786f5ce68$export$23c666e242eb615f(element, cb) {
    const obj = $4efe762786f5ce68$var$subscribersOnLongTouch[cb];
    if (obj) {
        element.removeEventListener("touchstart", obj.touchstart);
        element.removeEventListener("contextmenu", obj.contextmenu);
        element.removeEventListener("touchend", obj.touchend);
        element.removeEventListener("touchmove", obj.touchmove);
    }
}
function $4efe762786f5ce68$export$33fec3bf402c1222(cssPath, cb) {
    const $elements = document.querySelectorAll(cssPath);
    Array.from($elements).forEach(($element)=>{
        $4efe762786f5ce68$export$11706adc15ed0a8e($element, cb);
    });
}
function $4efe762786f5ce68$export$645f603e7f28e695(cssPath, cb) {
    const $elements = document.querySelectorAll(cssPath);
    Array.from($elements).forEach(($element)=>{
        $4efe762786f5ce68$export$23c666e242eb615f($element, cb);
    });
}

});

parcelRegister("82R4n", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $5db7ad20bddd67e3$export$b3890eb0ae9dca99; });
$parcel$export(module.exports, "show", function () { return $5db7ad20bddd67e3$export$57bf213be019eeb0; });
$parcel$export(module.exports, "hide", function () { return $5db7ad20bddd67e3$export$fe8985bb6374093c; });
$parcel$export(module.exports, "updateAmount", function () { return $5db7ad20bddd67e3$export$48416bd5fd755ffa; });
$parcel$export(module.exports, "onClickPlus", function () { return $5db7ad20bddd67e3$export$eaa3163416f1c3e9; });
$parcel$export(module.exports, "onClickMinus", function () { return $5db7ad20bddd67e3$export$763aa1a738e37545; });
const $5db7ad20bddd67e3$var$mainClassName = "item-select-counter";
const $5db7ad20bddd67e3$var$hiddenClassName = `${$5db7ad20bddd67e3$var$mainClassName}_hidden`;
const $5db7ad20bddd67e3$var$amountClassName = `${$5db7ad20bddd67e3$var$mainClassName}__amount`;
const $5db7ad20bddd67e3$var$plusClassName = `${$5db7ad20bddd67e3$var$mainClassName}__plus`;
const $5db7ad20bddd67e3$var$minusClassName = `${$5db7ad20bddd67e3$var$mainClassName}__minus`;
const $5db7ad20bddd67e3$var$getIdName = (id)=>`itemSelectCounter-${id}`;
const $5db7ad20bddd67e3$var$getItem = (id)=>document.querySelector(`#${$5db7ad20bddd67e3$var$getIdName(id)}`);
const $5db7ad20bddd67e3$var$getAmountItem = (id)=>document.querySelector(`#${$5db7ad20bddd67e3$var$getIdName(id)} .${$5db7ad20bddd67e3$var$amountClassName}`);
const $5db7ad20bddd67e3$var$getPlusItem = (id)=>document.querySelector(`#${$5db7ad20bddd67e3$var$getIdName(id)} .${$5db7ad20bddd67e3$var$plusClassName}`);
const $5db7ad20bddd67e3$var$getMinusItem = (id)=>document.querySelector(`#${$5db7ad20bddd67e3$var$getIdName(id)} .${$5db7ad20bddd67e3$var$minusClassName}`);
const $5db7ad20bddd67e3$var$getMainClassName = ({ isShow: isShow })=>{
    let className = $5db7ad20bddd67e3$var$mainClassName;
    if (!isShow) className += ` ${$5db7ad20bddd67e3$var$hiddenClassName}`;
    return className;
};
function $5db7ad20bddd67e3$export$b3890eb0ae9dca99({ id: id, amount: amount = 0, isShow: isShow = true }) {
    return `
    <div class="${$5db7ad20bddd67e3$var$getMainClassName({
        isShow: isShow
    })}" id="${$5db7ad20bddd67e3$var$getIdName(id)}">
      <div class="${$5db7ad20bddd67e3$var$amountClassName}">${amount}</div>
      <div class="${$5db7ad20bddd67e3$var$plusClassName}">+</div>
      <div class="${$5db7ad20bddd67e3$var$minusClassName}">-</div>
    </div>
  `;
}
function $5db7ad20bddd67e3$export$57bf213be019eeb0(id) {
    const $elem = $5db7ad20bddd67e3$var$getItem(id);
    $elem.classList.remove($5db7ad20bddd67e3$var$hiddenClassName);
}
function $5db7ad20bddd67e3$export$fe8985bb6374093c(id) {
    const $elem = $5db7ad20bddd67e3$var$getItem(id);
    $elem.classList.add($5db7ad20bddd67e3$var$hiddenClassName);
}
function $5db7ad20bddd67e3$export$48416bd5fd755ffa(id, amount = 0) {
    const $elem = $5db7ad20bddd67e3$var$getAmountItem(id);
    $elem.innerHTML = amount;
}
function $5db7ad20bddd67e3$export$eaa3163416f1c3e9(id, cb) {
    const $elem = $5db7ad20bddd67e3$var$getPlusItem(id);
    if (!$elem) return;
    $elem.addEventListener("click", (e)=>{
        e.stopPropagation();
        cb(id);
    });
}
function $5db7ad20bddd67e3$export$763aa1a738e37545(id, cb) {
    const $elem = $5db7ad20bddd67e3$var$getMinusItem(id);
    if (!$elem) return;
    $elem.addEventListener("click", (e)=>{
        e.stopPropagation();
        cb(id);
    });
}

});

parcelRegister("jSGkS", function(module, exports) {
module.exports = new URL("360.e45a06ae.svg", import.meta.url).toString();

});

parcelRegister("iZrZy", function(module, exports) {
module.exports = new URL("video.b2f36271.svg", import.meta.url).toString();

});

parcelRegister("74kUW", function(module, exports) {
module.exports = new URL("image.605cfe2c.svg", import.meta.url).toString();

});

parcelRegister("hCm7x", function(module, exports) {

$parcel$export(module.exports, "show", function () { return $cd3724f3d1041e12$export$57bf213be019eeb0; });
$parcel$export(module.exports, "setText", function () { return $cd3724f3d1041e12$export$cbe0d99836e1498f; });
$parcel$export(module.exports, "hide", function () { return $cd3724f3d1041e12$export$fe8985bb6374093c; });

var $a4qiB = parcelRequire("a4qiB");

var $gpTMx = parcelRequire("gpTMx");
const $cd3724f3d1041e12$var$defaultText = (0, $gpTMx.defaultValue)(`There are no images in your<br>album yet.`);
function $cd3724f3d1041e12$export$57bf213be019eeb0() {
    const emptyContentCssPath = ".empty-content";
    (0, (/*@__PURE__*/$parcel$interopDefault($a4qiB)))(emptyContentCssPath).show();
}
function $cd3724f3d1041e12$export$cbe0d99836e1498f(text = "") {
    const element = (0, $gpTMx.makeText)(".empty-content__subtext");
    (0, $gpTMx.setHtml)($cd3724f3d1041e12$var$defaultText(text), element);
}
function $cd3724f3d1041e12$export$fe8985bb6374093c() {
    const element = document.querySelector(".empty-content");
    if (element) element.style.display = "none";
}

});
parcelRegister("gpTMx", function(module, exports) {

$parcel$export(module.exports, "defaultValue", function () { return $bf3a403e0b9bff74$export$1a01ae0705bafd37; });
$parcel$export(module.exports, "setHtml", function () { return $bf3a403e0b9bff74$export$e9d3191caab19f4d; });
$parcel$export(module.exports, "makeText", function () { return $bf3a403e0b9bff74$export$2235873b95f89ea; });
function $bf3a403e0b9bff74$export$1a01ae0705bafd37(defaultVal, value) {
    if (value !== undefined) return exec(value);
    return exec;
    function exec(arg) {
        return arg === undefined || arg === "" ? defaultVal : arg;
    }
}
function $bf3a403e0b9bff74$export$e9d3191caab19f4d(content, elem) {
    const el = document.querySelector(elem.cssPath);
    el.innerHTML = content;
}
function $bf3a403e0b9bff74$export$41eb24ad62fa2ca7(cssPath) {
    return {
        type: "$Button",
        cssPath: cssPath
    };
}
function $bf3a403e0b9bff74$export$2235873b95f89ea(cssPath) {
    return {
        type: "$Text",
        cssPath: cssPath
    };
}

});



parcelRegister("7TTCE", function(module, exports) {

$parcel$export(module.exports, "initModeSwitcher", function () { return $5c08d0e59a2dff19$export$fa231eac623040e; });
function $5c08d0e59a2dff19$export$fa231eac623040e(defaultModeNumber = 0) {
    const modes = [
        "default",
        "select"
    ];
    const [defaultMode, selectMode] = modes;
    let mode = modes[defaultModeNumber];
    const fnOnSelectMode = [];
    const fnOnDefaultMode = [];
    return {
        switchToSelect: ()=>{
            mode = selectMode;
            fnOnSelectMode.forEach((fn)=>fn());
        },
        switchToDefaultMode: ()=>{
            mode = defaultMode;
            fnOnDefaultMode.forEach((fn)=>fn());
        },
        mode: ()=>mode,
        isSelectMode: ()=>mode === selectMode,
        isDefaultMode: ()=>mode === defaultMode,
        onSelectMode: (fn)=>{
            fnOnSelectMode.push(fn);
        },
        onDefaultMode: (fn)=>{
            fnOnDefaultMode.push(fn);
        }
    };
}

});

parcelRegister("k8ze7", function(module, exports) {

$parcel$export(module.exports, "initSelect", function () { return $ea8fe149eab69ca9$export$660e86cf22853707; });
function $ea8fe149eab69ca9$export$660e86cf22853707() {
    let ignoredIds = new Set();
    const selectedList = new Set();
    const updateListeners = [];
    const selectListeners = [];
    const unselectListeners = [];
    const unselectAllListeners = [];
    return {
        onUpdate: (fn)=>{
            updateListeners.push(fn);
        },
        onSelect: (fn)=>{
            selectListeners.push(fn);
        },
        onUnselect: (fn)=>{
            unselectListeners.push(fn);
        },
        onUnselectAll: (fn)=>{
            unselectAllListeners.push(fn);
        },
        toggle: toggle,
        contains: contains,
        select: select,
        unselect: unselect,
        unselectAll: unselectAll,
        setIgnoreList: setIgnoreList,
        list: ()=>selectedList,
        array: ()=>Array.from(selectedList)
    };
    function emitOnUpdate() {
        updateListeners.forEach((fn)=>fn(selectedList));
    }
    function emitOnSelect(id) {
        selectListeners.forEach((fn)=>fn(id));
    }
    function emitOnUnselect(id) {
        unselectListeners.forEach((fn)=>fn(id));
    }
    function emitOnUnselectAll() {
        unselectAllListeners.forEach((fn)=>fn());
    }
    function toggle(id) {
        if (contains(id)) unselect(id);
        else select(id);
    }
    function unselect(id) {
        selectedList.delete(id);
        emitOnUnselect(id);
        emitOnUpdate();
    }
    function unselectAll() {
        selectedList.clear();
        emitOnUnselectAll();
        emitOnUpdate();
    }
    function select(id) {
        if (ignoredIds.has(id)) return;
        selectedList.add(id);
        emitOnSelect(id);
        emitOnUpdate();
    }
    function contains(id) {
        return selectedList.has(id);
    }
    function setIgnoreList(ignoreList = []) {
        ignoredIds = new Set(ignoreList);
    }
}

});

parcelRegister("dc4rr", function(module, exports) {

$parcel$export(module.exports, "initItemCounter", function () { return $99afd75b62c810c7$export$773b9010e446aaa2; });
function $99afd75b62c810c7$export$773b9010e446aaa2() {
    let obj = {};
    const updateItemListeners = [];
    const updateCounterListeners = [];
    return {
        onUpdatedItem: (fn)=>{
            updateItemListeners.push(fn);
        },
        onUpdatedCounter: (fn)=>{
            updateCounterListeners.push(fn);
        },
        increase: increase,
        decrease: decrease,
        total: total,
        clear: clear,
        asArray: asArray
    };
    function emitOnUpdateItem(id, count) {
        updateItemListeners.forEach((fn)=>fn(id, count));
    }
    function emitOnUpdateCounter() {
        updateCounterListeners.forEach((fn)=>fn());
    }
    function increase(id) {
        if (obj[id]) obj[id] += 1;
        else obj[id] = 1;
        emitOnUpdateItem(id, obj[id]);
        emitOnUpdateCounter();
    }
    function decrease(id) {
        if (obj[id]) obj[id] = Math.max(0, obj[id] - 1);
        else obj[id] = 0;
        emitOnUpdateItem(id, obj[id]);
        emitOnUpdateCounter();
    }
    function total() {
        return Object.keys(obj).reduce((acc, id)=>acc + obj[id], 0);
    }
    function asArray(type = "string") {
        return Object.keys(obj).reduce((acc, id)=>{
            const elements = Array(obj[id]).fill(transform(id));
            return [
                ...acc,
                ...elements
            ];
        }, []);
        function transform(id) {
            if (type === "number") return Number(id);
            return id;
        }
    }
    function clear() {
        Object.keys(obj).forEach((id)=>emitOnUpdateItem(id, 0));
        obj = {};
        emitOnUpdateCounter();
    }
}

});

parcelRegister("bTO5t", function(module, exports) {

$parcel$export(module.exports, "initActionPanel", function () { return $8a9baf0e5a79df5a$export$364d44420c6c9762; });

var $ckpwZ = parcelRequire("ckpwZ");

var $hm9ti = parcelRequire("hm9ti");

var $6Dnht = parcelRequire("6Dnht");

var $cRHxk = parcelRequire("cRHxk");

var $hluEw = parcelRequire("hluEw");

var $gyz80 = parcelRequire("gyz80");

var $2iLlF = parcelRequire("2iLlF");
const $8a9baf0e5a79df5a$var$actionPanelCSSPath = ".action-panel";
const $8a9baf0e5a79df5a$var$showActionPanelClassName = "action-panel_show";
const $8a9baf0e5a79df5a$var$disabledBtnClassName = "action-button_disabled";
const $8a9baf0e5a79df5a$var$hiddenBtnClassName = "action-button_hidden";
const $8a9baf0e5a79df5a$var$getIdName = (id)=>`action-panel-${id}`;
const $8a9baf0e5a79df5a$var$getItem = (id)=>document.querySelector(`#${$8a9baf0e5a79df5a$var$getIdName(id)}`);
const $8a9baf0e5a79df5a$var$getItemText = (id)=>document.querySelector(`#${$8a9baf0e5a79df5a$var$getIdName(id)} .action-button__text`);
const $8a9baf0e5a79df5a$var$icons = {
    share: (0, (/*@__PURE__*/$parcel$interopDefault($ckpwZ))),
    createStory: (0, (/*@__PURE__*/$parcel$interopDefault($hm9ti))),
    payment: (0, (/*@__PURE__*/$parcel$interopDefault($2iLlF))),
    delete: (0, (/*@__PURE__*/$parcel$interopDefault($6Dnht))),
    clear: (0, (/*@__PURE__*/$parcel$interopDefault($hluEw))),
    done: (0, (/*@__PURE__*/$parcel$interopDefault($gyz80))),
    download: (0, (/*@__PURE__*/$parcel$interopDefault($cRHxk)))
};
const $8a9baf0e5a79df5a$var$getIconSrcByName = (name)=>{
    if (!$8a9baf0e5a79df5a$var$icons[name]) return null;
    return $8a9baf0e5a79df5a$var$icons[name];
};
function $8a9baf0e5a79df5a$export$364d44420c6c9762() {
    return {
        onClickBtn: onClickBtn,
        onClickBtnOnce: onClickBtnOnce,
        enableBtn: enableBtn,
        disableBtn: disableBtn,
        hideBtn: hideBtn,
        showBtn: showBtn,
        updateBtnText: updateBtnText,
        render: render,
        show: show,
        hide: hide,
        isDisabledBtn: isDisabledBtn
    };
    function onClickBtn(id, cb) {
        const $elem = $8a9baf0e5a79df5a$var$getItem(id);
        $elem.addEventListener("click", cb);
    }
    function onClickBtnOnce(id, cb) {
        const $elem = $8a9baf0e5a79df5a$var$getItem(id);
        $elem.addEventListener("click", cb, {
            once: true
        });
    }
    function disableBtn(id) {
        const $elem = $8a9baf0e5a79df5a$var$getItem(id);
        $elem.classList.add($8a9baf0e5a79df5a$var$disabledBtnClassName);
    }
    function isDisabledBtn(id) {
        const $elem = $8a9baf0e5a79df5a$var$getItem(id);
        return $elem.classList.contains($8a9baf0e5a79df5a$var$disabledBtnClassName);
    }
    function enableBtn(id) {
        const $elem = $8a9baf0e5a79df5a$var$getItem(id);
        $elem.classList.remove($8a9baf0e5a79df5a$var$disabledBtnClassName);
    }
    function hideBtn(id) {
        const $elem = $8a9baf0e5a79df5a$var$getItem(id);
        $elem.classList.add($8a9baf0e5a79df5a$var$hiddenBtnClassName);
    }
    function showBtn(id) {
        const $elem = $8a9baf0e5a79df5a$var$getItem(id);
        $elem.classList.remove($8a9baf0e5a79df5a$var$hiddenBtnClassName);
    }
    function updateBtnText(id, text) {
        const $elem = $8a9baf0e5a79df5a$var$getItemText(id);
        $elem.innerHTML = text;
    }
    function render(list) {
        const $elem = document.querySelector($8a9baf0e5a79df5a$var$actionPanelCSSPath);
        $elem.innerHTML = list.reduce((acc, data)=>acc + item(data), "");
    }
    function show() {
        const $elem = document.querySelector($8a9baf0e5a79df5a$var$actionPanelCSSPath);
        $elem.classList.add($8a9baf0e5a79df5a$var$showActionPanelClassName);
    }
    function hide() {
        const $elem = document.querySelector($8a9baf0e5a79df5a$var$actionPanelCSSPath);
        $elem.classList.remove($8a9baf0e5a79df5a$var$showActionPanelClassName);
    }
    function item({ id: id, iconName: iconName, text: text }) {
        return `
           <button class="action-button" id="${$8a9baf0e5a79df5a$var$getIdName(id)}">
               <img class="action-button__img" src="${$8a9baf0e5a79df5a$var$getIconSrcByName(iconName)}" alt="icon ${iconName}" />
               <span class="action-button__text">${text}</span>
           </button>
    `;
    }
}

});
parcelRegister("ckpwZ", function(module, exports) {
module.exports = new URL("menu-share.e76a67ed.svg", import.meta.url).toString();

});

parcelRegister("hm9ti", function(module, exports) {
module.exports = new URL("menu-create-story.0e81c19c.svg", import.meta.url).toString();

});

parcelRegister("6Dnht", function(module, exports) {
module.exports = new URL("menu-delete.0ff79e4e.svg", import.meta.url).toString();

});

parcelRegister("cRHxk", function(module, exports) {
module.exports = new URL("menu-download.425894b8.svg", import.meta.url).toString();

});

parcelRegister("hluEw", function(module, exports) {
module.exports = new URL("clear.c30ac5ac.svg", import.meta.url).toString();

});

parcelRegister("gyz80", function(module, exports) {
module.exports = new URL("done.2b5746ec.svg", import.meta.url).toString();

});

parcelRegister("2iLlF", function(module, exports) {
module.exports = new URL("icon-payment-white.bc3bf55c.svg", import.meta.url).toString();

});


parcelRegister("8pHZ5", function(module, exports) {

$parcel$export(module.exports, "initTopPanelSelectForShoppingCart", function () { return $6202c6e030e37e62$export$2aa9546b293d978e; });
const $6202c6e030e37e62$var$mainElemCSSPath = ".top-panel_select-for-shopping-cart";
const $6202c6e030e37e62$var$stepsCSSPath = `${$6202c6e030e37e62$var$mainElemCSSPath} .top-panel__title-steps`;
const $6202c6e030e37e62$var$selectedTitleCSSPath = `${$6202c6e030e37e62$var$mainElemCSSPath} .top-panel__title-center .top-panel__menu-text`;
const $6202c6e030e37e62$var$selectedSubtitleCSSPath = `${$6202c6e030e37e62$var$mainElemCSSPath} .top-panel__title-center .top-panel__menu-subtext`;
const $6202c6e030e37e62$var$getTextForSteps = (amount, total)=>`Step ${amount} of ${total}`;
const $6202c6e030e37e62$var$getTextForSelect = (amount)=>{
    if (Number.isFinite(amount)) return `Select up to ${amount} image(s)`;
    return `Select up as many images as you want`;
};
const $6202c6e030e37e62$var$getTextForTarget = (name)=>`for "${name}"`;
function $6202c6e030e37e62$export$2aa9546b293d978e() {
    return {
        setSteps: setSteps,
        setSelectedImageTitle: setSelectedImageTitle,
        setNameOfTarget: setNameOfTarget
    };
    function setSteps(amount, total) {
        if (total > 1) {
            const $elem = document.querySelector($6202c6e030e37e62$var$stepsCSSPath);
            $elem.innerHTML = $6202c6e030e37e62$var$getTextForSteps(amount, total);
        }
    }
    function setSelectedImageTitle(amount) {
        const $elem = document.querySelector($6202c6e030e37e62$var$selectedTitleCSSPath);
        $elem.innerHTML = $6202c6e030e37e62$var$getTextForSelect(amount);
    }
    function setNameOfTarget(name) {
        const $elem = document.querySelector($6202c6e030e37e62$var$selectedSubtitleCSSPath);
        $elem.innerHTML = $6202c6e030e37e62$var$getTextForTarget(name);
    }
}

});

parcelRegister("6lqdz", function(module, exports) {

$parcel$export(module.exports, "initSelectedPanel", function () { return $49e90a8f2933cc96$export$7f5adc7bd148a32b; });
const $49e90a8f2933cc96$var$mainElemCSSPath = ".top-panel_selected";
const $49e90a8f2933cc96$var$hiddenClassName = "top-panel_hidden";
const $49e90a8f2933cc96$var$clearBtnCSSPath = `${$49e90a8f2933cc96$var$mainElemCSSPath} .top-panel__btn-clear`;
const $49e90a8f2933cc96$var$textCSSPath = `${$49e90a8f2933cc96$var$mainElemCSSPath} .top-panel__selected-text`;
const $49e90a8f2933cc96$var$getElem = ()=>document.querySelector($49e90a8f2933cc96$var$mainElemCSSPath);
const $49e90a8f2933cc96$var$getTextForSelect = (amount)=>`${amount} item(s) selected`;
function $49e90a8f2933cc96$export$7f5adc7bd148a32b() {
    return {
        show: show,
        hide: hide,
        onClickClearBtn: onClickClearBtn,
        updateAmountOfSelect: updateAmountOfSelect
    };
    function show() {
        const $elem = $49e90a8f2933cc96$var$getElem();
        $elem.classList.remove($49e90a8f2933cc96$var$hiddenClassName);
    }
    function hide() {
        const $elem = $49e90a8f2933cc96$var$getElem();
        $elem.classList.add($49e90a8f2933cc96$var$hiddenClassName);
    }
    function onClickClearBtn(cb) {
        const $elem = document.querySelector($49e90a8f2933cc96$var$clearBtnCSSPath);
        $elem.addEventListener("click", cb);
    }
    function updateAmountOfSelect(amount) {
        const $elem = document.querySelector($49e90a8f2933cc96$var$textCSSPath);
        $elem.innerHTML = $49e90a8f2933cc96$var$getTextForSelect(amount);
    }
}

});

parcelRegister("g0ZwT", function(module, exports) {

$parcel$export(module.exports, "id", function () { return $ba8c5feefdf248da$export$d560c7e4a29451c2; });
$parcel$export(module.exports, "src", function () { return $ba8c5feefdf248da$export$2e40c9e35e9506f4; });
$parcel$export(module.exports, "viewModel", function () { return $ba8c5feefdf248da$export$d5f57ca352775f8; });
$parcel$export(module.exports, "fullScreenVM", function () { return $ba8c5feefdf248da$export$a3b12e8008abcd0c; });
$parcel$export(module.exports, "isPhotoById", function () { return $ba8c5feefdf248da$export$ea2fe7eadaed6ce4; });
$parcel$export(module.exports, "isStockImage", function () { return $ba8c5feefdf248da$export$570736ac64863d14; });
$parcel$export(module.exports, "includesById", function () { return $ba8c5feefdf248da$export$26211ec182ff1a4e; });
$parcel$export(module.exports, "notIncludesById", function () { return $ba8c5feefdf248da$export$3c48fedc9138a00d; });
const $ba8c5feefdf248da$export$d560c7e4a29451c2 = (photo)=>photo.id;
const $ba8c5feefdf248da$export$2e40c9e35e9506f4 = (photo)=>photo.full_path;
const $ba8c5feefdf248da$var$determineType = (photo)=>{
    if (photo.image_type === "360_DEGREE") return "360";
    if (photo.full_path.split(".").pop().toLowerCase() === "mp4") return "video";
    return "regular";
};
const $ba8c5feefdf248da$export$d5f57ca352775f8 = (photo, { watermarkSrc: watermarkSrc = null, canDownload: canDownload = false, canShare: canShare = false, canSelect: canSelect = true })=>({
        id: $ba8c5feefdf248da$export$d560c7e4a29451c2(photo),
        type: $ba8c5feefdf248da$var$determineType(photo),
        src: photo.thumb_full_path,
        watermarkSrc: watermarkSrc,
        canSelect: canSelect,
        canDownload: canDownload,
        canShare: canShare
    });
const $ba8c5feefdf248da$export$a3b12e8008abcd0c = (photo, { watermarkSrc: watermarkSrc = null, canShare: canShare = false, canDownload: canDownload = false })=>({
        id: $ba8c5feefdf248da$export$d560c7e4a29451c2(photo),
        type: $ba8c5feefdf248da$var$determineType(photo),
        src: photo.full_path,
        watermarkSrc: watermarkSrc,
        canShare: canShare,
        canDownload: canDownload
    });
const $ba8c5feefdf248da$export$ea2fe7eadaed6ce4 = (photoId)=>(photo)=>$ba8c5feefdf248da$export$d560c7e4a29451c2(photo) === photoId;
const $ba8c5feefdf248da$export$570736ac64863d14 = ({ stock_image_uid: stockImageUid })=>stockImageUid !== null && stockImageUid !== undefined;
const $ba8c5feefdf248da$export$26211ec182ff1a4e = (ids)=>(photo)=>ids.includes($ba8c5feefdf248da$export$d560c7e4a29451c2(photo));
const $ba8c5feefdf248da$export$3c48fedc9138a00d = (ids)=>(photo)=>!$ba8c5feefdf248da$export$26211ec182ff1a4e(ids)(photo);

});

parcelRegister("3Y14T", function(module, exports) {

$parcel$export(module.exports, "initWaitingNotice", function () { return $2e37cfbd7564079f$export$cc0c8e645028aca3; });

var $a4qiB = parcelRequire("a4qiB");
function $2e37cfbd7564079f$export$cc0c8e645028aca3() {
    const $elem = (0, (/*@__PURE__*/$parcel$interopDefault($a4qiB)))(".waiting-notice");
    const $text = (0, (/*@__PURE__*/$parcel$interopDefault($a4qiB)))(".waiting-notice__text");
    if ($elem.length === 0) console.error("Didn't find a element of .waiting-notice");
    return {
        show: show,
        hide: hide,
        text: text,
        resetOffset: resetOffset,
        bottomOffset: bottomOffset
    };
    function text(html) {
        $text.html(html);
    }
    function show() {
        $elem.show();
    }
    function hide() {
        $elem.hide();
    }
    function resetOffset() {
        $elem.css("bottom", 0);
    }
    function bottomOffset(value) {
        $elem.css("bottom", value);
    }
}

});

parcelRegister("5oI2J", function(module, exports) {

$parcel$export(module.exports, "showItems", function () { return $3ee15bb2864734d3$export$fbb6e6d252751cb8; });
$parcel$export(module.exports, "hideItems", function () { return $3ee15bb2864734d3$export$289567757ca9418e; });
$parcel$export(module.exports, "onShareBtn", function () { return $3ee15bb2864734d3$export$f69d7b52fafb14eb; });
$parcel$export(module.exports, "onDownloadBtn", function () { return $3ee15bb2864734d3$export$9c87faec25714f20; });
// eslint-disable-next-line import/no-extraneous-dependencies
parcelRequire("krKJQ");

var $1IcXo = parcelRequire("1IcXo");

var $QsXqF = parcelRequire("QsXqF");
const $3ee15bb2864734d3$var$blockElem = $3ee15bb2864734d3$var$initBlockElem();
const $3ee15bb2864734d3$var$bodyPage = $3ee15bb2864734d3$var$initBodyPage();
const $3ee15bb2864734d3$var$itemsElems = $3ee15bb2864734d3$var$initItemsElems();
const $3ee15bb2864734d3$var$block = ".full-screen-view";
const $3ee15bb2864734d3$var$active = `${$3ee15bb2864734d3$var$block}_show`;
const $3ee15bb2864734d3$var$list = `${$3ee15bb2864734d3$var$block}__list`;
const $3ee15bb2864734d3$var$item = `${$3ee15bb2864734d3$var$block}__item`;
const $3ee15bb2864734d3$var$content = `${$3ee15bb2864734d3$var$block}__content`;
const $3ee15bb2864734d3$var$contentType360 = `${$3ee15bb2864734d3$var$block}__content_type_360`;
const $3ee15bb2864734d3$var$watermark = `${$3ee15bb2864734d3$var$block}__watermark`;
const $3ee15bb2864734d3$var$getItemByIndex = (index)=>`${$3ee15bb2864734d3$var$item}[data-index="${index}"]`;
const $3ee15bb2864734d3$var$getVideoByIndex = (index)=>`${$3ee15bb2864734d3$var$getItemByIndex(index)} video${$3ee15bb2864734d3$var$content}`;
const $3ee15bb2864734d3$var$currentItem = `${$3ee15bb2864734d3$var$block}__item_current`;
const $3ee15bb2864734d3$var$closeBtn = ".close-full-screen-view";
const $3ee15bb2864734d3$var$docBody = ".body";
const $3ee15bb2864734d3$var$holdDocBody = ".body_hold";
const $3ee15bb2864734d3$var$prev = `${$3ee15bb2864734d3$var$block}__nav-btn-prev`;
const $3ee15bb2864734d3$var$next = `${$3ee15bb2864734d3$var$block}__nav-btn-next`;
const $3ee15bb2864734d3$var$disabledBtnClassName = `${$3ee15bb2864734d3$var$block}__button_disabled`;
const $3ee15bb2864734d3$var$shareBtn = `${$3ee15bb2864734d3$var$block}__button_share`;
const $3ee15bb2864734d3$var$downloadBtn = `${$3ee15bb2864734d3$var$block}__button_download`;
const $3ee15bb2864734d3$var$shareBtnText = `${$3ee15bb2864734d3$var$shareBtn} ${$3ee15bb2864734d3$var$block}__btn-text`;
const $3ee15bb2864734d3$var$downloadBtnText = `${$3ee15bb2864734d3$var$downloadBtn} ${$3ee15bb2864734d3$var$block}__btn-text`;
const $3ee15bb2864734d3$var$playBtn = `${$3ee15bb2864734d3$var$block}__video-btn_play`;
const $3ee15bb2864734d3$var$pauseBtn = `${$3ee15bb2864734d3$var$block}__video-btn_pause`;
const $3ee15bb2864734d3$var$displayOffVideoBtn = `${$3ee15bb2864734d3$var$block}__video-btn_display-off`;
const $3ee15bb2864734d3$var$hiddenBtnClassName = `${$3ee15bb2864734d3$var$block}__video-btn_hidden`;
const $3ee15bb2864734d3$var$getPlayBtnByIndex = (index)=>`${$3ee15bb2864734d3$var$getItemByIndex(index)} ${$3ee15bb2864734d3$var$playBtn}`;
const $3ee15bb2864734d3$var$getPauseBtnByIndex = (index)=>`${$3ee15bb2864734d3$var$getItemByIndex(index)} ${$3ee15bb2864734d3$var$pauseBtn}`;
function $3ee15bb2864734d3$var$getClassName(cssPath) {
    return cssPath.slice(1);
}
function $3ee15bb2864734d3$var$showPrevItem() {
    const currentIndex = $3ee15bb2864734d3$var$itemsElems.currentIndex();
    const prevIndex = currentIndex - 1;
    const index = prevIndex < 0 ? $3ee15bb2864734d3$var$itemsElems.maxIndex() : prevIndex;
    // console.log('showPrevItem', prevIndex, getMaxIndex(), index);
    $3ee15bb2864734d3$var$itemsElems.goFromItemToItem({
        currentIndex: currentIndex,
        nextIndex: index
    });
}
function $3ee15bb2864734d3$var$showNextItem() {
    const currentIndex = $3ee15bb2864734d3$var$itemsElems.currentIndex();
    const nextIndex = currentIndex + 1;
    const index = nextIndex > $3ee15bb2864734d3$var$itemsElems.maxIndex() ? 0 : nextIndex;
    // console.log('showNextItem', nextIndex, getMaxIndex(), index);
    $3ee15bb2864734d3$var$itemsElems.goFromItemToItem({
        currentIndex: currentIndex,
        nextIndex: index
    });
}
function $3ee15bb2864734d3$export$fbb6e6d252751cb8(items, showIndex = 0) {
    // console.log('showItems', items, showIndex);
    $3ee15bb2864734d3$var$itemsElems.render(items);
    $3ee15bb2864734d3$var$itemsElems.goFromItemToItem({
        nextIndex: showIndex
    });
    $3ee15bb2864734d3$var$blockElem.display();
    $3ee15bb2864734d3$var$bodyPage.freeze();
    $3ee15bb2864734d3$var$blockElem.onceClose($3ee15bb2864734d3$export$289567757ca9418e);
    $3ee15bb2864734d3$var$blockElem.onNextItem($3ee15bb2864734d3$var$showNextItem);
    $3ee15bb2864734d3$var$blockElem.onPrevItem($3ee15bb2864734d3$var$showPrevItem);
}
function $3ee15bb2864734d3$export$289567757ca9418e() {
    $3ee15bb2864734d3$var$blockElem.displayOff();
    $3ee15bb2864734d3$var$bodyPage.unfreeze();
    $3ee15bb2864734d3$var$itemsElems.clearRender();
    $3ee15bb2864734d3$var$blockElem.offNextItem($3ee15bb2864734d3$var$showNextItem);
    $3ee15bb2864734d3$var$blockElem.offPrevItem($3ee15bb2864734d3$var$showPrevItem);
}
function $3ee15bb2864734d3$export$f69d7b52fafb14eb(cb) {
    const $btn = document.querySelector($3ee15bb2864734d3$var$shareBtn);
    $btn.addEventListener("click", ()=>{
        const currentIndex = $3ee15bb2864734d3$var$itemsElems.currentIndex();
        const $item = document.querySelector($3ee15bb2864734d3$var$getItemByIndex(currentIndex));
        cb({
            id: Number($item.dataset.id)
        });
    });
}
function $3ee15bb2864734d3$export$9c87faec25714f20(cb) {
    const $btn = document.querySelector($3ee15bb2864734d3$var$downloadBtn);
    $btn.addEventListener("click", ()=>{
        const currentIndex = $3ee15bb2864734d3$var$itemsElems.currentIndex();
        const $item = document.querySelector($3ee15bb2864734d3$var$getItemByIndex(currentIndex));
        cb({
            id: Number($item.dataset.id)
        });
    });
}
function $3ee15bb2864734d3$var$initBlockElem() {
    return {
        display: display,
        displayOff: displayOff,
        onNextItem: onNextItem,
        onPrevItem: onPrevItem,
        offNextItem: offNextItem,
        offPrevItem: offPrevItem,
        onceClose: onceClose
    };
    function display() {
        const $block = document.querySelector($3ee15bb2864734d3$var$block);
        $block.classList.add($3ee15bb2864734d3$var$getClassName($3ee15bb2864734d3$var$active));
    }
    function displayOff() {
        const $block = document.querySelector($3ee15bb2864734d3$var$block);
        $block.classList.remove($3ee15bb2864734d3$var$getClassName($3ee15bb2864734d3$var$active));
    }
    function onNextItem(cb) {
        onSwipedLeft(cb);
        onClickNextBtn(cb);
    }
    function onPrevItem(cb) {
        onSwipedRight(cb);
        onClickPrevBtn(cb);
    }
    function offNextItem(cb) {
        offSwipedLeft(cb);
        offClickNextBtn(cb);
    }
    function offPrevItem(cb) {
        offSwipedRight(cb);
        offClickPrevBtn(cb);
    }
    function onceClose(cb) {
        const $btn = document.querySelector($3ee15bb2864734d3$var$closeBtn);
        $btn.addEventListener("click", cb, {
            once: true
        });
    }
    function onSwipedLeft(cb) {
        const $block = document.querySelector($3ee15bb2864734d3$var$block);
        $block.addEventListener("swiped-left", cb);
    }
    function onSwipedRight(cb) {
        const $block = document.querySelector($3ee15bb2864734d3$var$block);
        $block.addEventListener("swiped-right", cb);
    }
    function offSwipedLeft(cb) {
        const $block = document.querySelector($3ee15bb2864734d3$var$block);
        $block.removeEventListener("swiped-left", cb);
    }
    function offSwipedRight(cb) {
        const $block = document.querySelector($3ee15bb2864734d3$var$block);
        $block.removeEventListener("swiped-right", cb);
    }
    function onClickNextBtn(cb) {
        const $btn = document.querySelector($3ee15bb2864734d3$var$next);
        $btn.addEventListener("click", cb);
    }
    function onClickPrevBtn(cb) {
        const $btn = document.querySelector($3ee15bb2864734d3$var$prev);
        $btn.addEventListener("click", cb);
    }
    function offClickNextBtn(cb) {
        const $btn = document.querySelector($3ee15bb2864734d3$var$next);
        $btn.removeEventListener("click", cb);
    }
    function offClickPrevBtn(cb) {
        const $btn = document.querySelector($3ee15bb2864734d3$var$prev);
        $btn.removeEventListener("click", cb);
    }
}
function $3ee15bb2864734d3$var$initItemsElems() {
    const pinchZoomManager = $3ee15bb2864734d3$var$initPinchZoomManager();
    const videoEventsSubscribers = {};
    return {
        render: render,
        clearRender: clearRender,
        currentIndex: getCurrentIndex,
        maxIndex: getMaxIndex,
        goFromItemToItem: goFromItemToItem
    };
    function render(items) {
        const $list = document.querySelector($3ee15bb2864734d3$var$list);
        const itemsHTML = items.map(({ id: id, type: type, src: src, watermarkSrc: watermarkSrc, canShare: canShare, canDownload: canDownload }, index)=>prepareItem({
                index: index,
                id: id,
                type: type,
                src: src,
                watermarkSrc: watermarkSrc,
                canShare: canShare,
                canDownload: canDownload
            })).join(" ");
        $list.innerHTML = itemsHTML;
        $list.dataset.length = items.length;
    }
    function clearRender() {
        pinchZoomManager.clearAll();
        const $list = document.querySelector($3ee15bb2864734d3$var$list);
        $list.innerHTML = "";
        $list.dataset.length = 0;
    }
    function prepareItem({ index: index, id: id, type: type, src: src, watermarkSrc: watermarkSrc, canShare: canShare, canDownload: canDownload }) {
        return `
     <div 
       class="${$3ee15bb2864734d3$var$getClassName($3ee15bb2864734d3$var$item)}" 
       data-id="${id}" 
       data-type="${getTypeContent()}" 
       data-index="${index}" 
       data-can-download="${canDownload}" 
       data-can-share="${canShare}"
    >
     ${renderWatermark(watermarkSrc)}${contentElem()}
    </div>
    `;
        function contentElem() {
            if (type === "360") return `
          <iframe class="${$3ee15bb2864734d3$var$getClassName($3ee15bb2864734d3$var$content)} ${$3ee15bb2864734d3$var$getClassName($3ee15bb2864734d3$var$contentType360)}" src="${(0, $QsXqF.get360url)(src)}" frameborder="0" allowfullscreen></iframe>
        `;
            if (isVideo()) return `
          <video class="${$3ee15bb2864734d3$var$getClassName($3ee15bb2864734d3$var$content)}" playsinline>
            <source src="${src}" type="video/mp4">
            Your browser does not support the video tag.
          </video>
          <div class="${$3ee15bb2864734d3$var$getClassName($3ee15bb2864734d3$var$playBtn)} ${$3ee15bb2864734d3$var$getClassName($3ee15bb2864734d3$var$displayOffVideoBtn)}"></div>
          <div class="${$3ee15bb2864734d3$var$getClassName($3ee15bb2864734d3$var$pauseBtn)} ${$3ee15bb2864734d3$var$getClassName($3ee15bb2864734d3$var$displayOffVideoBtn)}"></div>
        `;
            return `<img class="${$3ee15bb2864734d3$var$getClassName($3ee15bb2864734d3$var$content)}" src="${src}" alt="" />`;
        }
        function renderWatermark(imgSrc) {
            if (imgSrc) return `<div class="${$3ee15bb2864734d3$var$getClassName($3ee15bb2864734d3$var$watermark)}" style="background-image:url('${imgSrc}')"></div>`;
            return "";
        }
        function getTypeContent() {
            if (isVideo()) return "video";
            return "photo";
        }
        function isVideo() {
            return src.split(".").pop().toLowerCase() === "mp4";
        }
    }
    function getCurrentIndex() {
        const $currentItem = document.querySelector($3ee15bb2864734d3$var$currentItem);
        if (!$currentItem) return 0;
        return Number($currentItem.dataset.index);
    }
    function getMaxIndex() {
        const $list = document.querySelector($3ee15bb2864734d3$var$list);
        return Number($list.dataset.length) - 1;
    }
    function goFromItemToItem({ currentIndex: currentIndex = -1, nextIndex: nextIndex }) {
        if (currentIndex > -1) {
            pinchZoomManager.resetZoom(currentIndex);
            if (isItemVideo(currentIndex)) pauseVideo(currentIndex);
            unsetAsCurrent(currentIndex);
            setTimeout(()=>{
                unsubscribeOnVideoEvents(currentIndex);
            }, 0);
        }
        subscribeOnVideoEvents(nextIndex, {
            onPlay: onPlayVideo,
            onPause: onPauseVideo,
            onEnded: onVideoEnded
        });
        if (isItemVideo(nextIndex)) playVideo(nextIndex, 0);
        setAsCurrent(nextIndex);
        if (isItemPhoto(nextIndex)) pinchZoomManager.setUp(nextIndex);
        showBtn("share", isAvailableToShare(nextIndex));
        showBtn("download", isAvailableDownload(nextIndex));
    }
    function subscribeOnVideoEvents(index, { onPlay: onPlay, onPause: onPause, onEnded: onEnded }) {
        const $video = document.querySelector($3ee15bb2864734d3$var$getVideoByIndex(index));
        const $playBtn = document.querySelector($3ee15bb2864734d3$var$getPlayBtnByIndex(index));
        const $pauseBtn = document.querySelector($3ee15bb2864734d3$var$getPauseBtnByIndex(index));
        if (!$video) return;
        videoEventsSubscribers[index] = {
            onPlay: ()=>onPlay(index),
            onPause: ()=>onPause(index),
            onEnded: ()=>onEnded(index),
            play: ()=>playVideo(index),
            pause: ()=>pauseVideo(index)
        };
        $video.addEventListener("play", videoEventsSubscribers[index].onPlay);
        $video.addEventListener("pause", videoEventsSubscribers[index].onPause);
        $video.addEventListener("ended", videoEventsSubscribers[index].onEnded);
        $playBtn.addEventListener("click", videoEventsSubscribers[index].play);
        $pauseBtn.addEventListener("click", videoEventsSubscribers[index].pause);
    }
    function unsubscribeOnVideoEvents(index) {
        const $video = document.querySelector($3ee15bb2864734d3$var$getVideoByIndex(index));
        const $playBtn = document.querySelector($3ee15bb2864734d3$var$getPlayBtnByIndex(index));
        const $pauseBtn = document.querySelector($3ee15bb2864734d3$var$getPauseBtnByIndex(index));
        if (!$video || !videoEventsSubscribers[index]) return;
        $video.removeEventListener("play", videoEventsSubscribers[index].onPlay);
        $video.removeEventListener("pause", videoEventsSubscribers[index].onPause);
        $video.removeEventListener("ended", videoEventsSubscribers[index].onEnded);
        $playBtn.removeEventListener("click", videoEventsSubscribers[index].play);
        $pauseBtn.removeEventListener("click", videoEventsSubscribers[index].pause);
        delete videoEventsSubscribers[index];
    }
    function onPlayVideo(index, { hideBtnTimeout: hideBtnTimeout = 2000 } = {}) {
        const $playBtn = document.querySelector($3ee15bb2864734d3$var$getPlayBtnByIndex(index));
        const $pauseBtn = document.querySelector($3ee15bb2864734d3$var$getPauseBtnByIndex(index));
        if (!$playBtn || !$pauseBtn) return;
        $playBtn.classList.add($3ee15bb2864734d3$var$getClassName($3ee15bb2864734d3$var$displayOffVideoBtn));
        $pauseBtn.classList.remove($3ee15bb2864734d3$var$getClassName($3ee15bb2864734d3$var$displayOffVideoBtn));
        setTimeout(()=>{
            if ($pauseBtn.classList.contains($3ee15bb2864734d3$var$getClassName($3ee15bb2864734d3$var$displayOffVideoBtn))) return;
            $pauseBtn.classList.add($3ee15bb2864734d3$var$getClassName($3ee15bb2864734d3$var$hiddenBtnClassName));
        }, hideBtnTimeout);
    }
    function onPauseVideo(index) {
        const $playBtn = document.querySelector($3ee15bb2864734d3$var$getPlayBtnByIndex(index));
        const $pauseBtn = document.querySelector($3ee15bb2864734d3$var$getPauseBtnByIndex(index));
        if (!$playBtn || !$pauseBtn) return;
        $playBtn.classList.remove($3ee15bb2864734d3$var$getClassName($3ee15bb2864734d3$var$displayOffVideoBtn));
        $pauseBtn.classList.add($3ee15bb2864734d3$var$getClassName($3ee15bb2864734d3$var$displayOffVideoBtn));
        $pauseBtn.classList.remove($3ee15bb2864734d3$var$getClassName($3ee15bb2864734d3$var$hiddenBtnClassName));
    }
    function onVideoEnded(index) {
        const $video = document.querySelector($3ee15bb2864734d3$var$getVideoByIndex(index));
        const $playBtn = document.querySelector($3ee15bb2864734d3$var$getPlayBtnByIndex(index));
        const $pauseBtn = document.querySelector($3ee15bb2864734d3$var$getPauseBtnByIndex(index));
        $video.currentTime = 0;
        if (!$playBtn || !$pauseBtn) return;
        $playBtn.classList.remove($3ee15bb2864734d3$var$getClassName($3ee15bb2864734d3$var$displayOffVideoBtn));
        $pauseBtn.classList.add($3ee15bb2864734d3$var$getClassName($3ee15bb2864734d3$var$displayOffVideoBtn));
        $pauseBtn.classList.remove($3ee15bb2864734d3$var$getClassName($3ee15bb2864734d3$var$hiddenBtnClassName));
    }
    function isAvailableToShare(index) {
        const $item = document.querySelector($3ee15bb2864734d3$var$getItemByIndex(index));
        if (!$item) return false;
        return $item.dataset.canShare === "true";
    }
    function isAvailableDownload(index) {
        const $item = document.querySelector($3ee15bb2864734d3$var$getItemByIndex(index));
        if (!$item) return false;
        return $item.dataset.canDownload === "true";
    }
    function isItemVideo(index) {
        return isItem("video", index);
    }
    function isItemPhoto(index) {
        return isItem("photo", index);
    }
    function isItem(type, index) {
        const $item = document.querySelector($3ee15bb2864734d3$var$getItemByIndex(index));
        if (!$item) return false;
        return $item.dataset.type === type;
    }
    function setAsCurrent(index) {
        const $elem = document.querySelector($3ee15bb2864734d3$var$getItemByIndex(index));
        if (!$elem) return;
        $elem.classList.add($3ee15bb2864734d3$var$getClassName($3ee15bb2864734d3$var$currentItem));
    }
    function unsetAsCurrent(index) {
        const $elem = document.querySelector($3ee15bb2864734d3$var$getItemByIndex(index));
        if (!$elem) return;
        $elem.classList.remove($3ee15bb2864734d3$var$getClassName($3ee15bb2864734d3$var$currentItem));
    }
    function playVideo(index, startTime = null) {
        const $video = document.querySelector($3ee15bb2864734d3$var$getVideoByIndex(index));
        if (!$video) return;
        if (startTime !== null) $video.currentTime = startTime;
        $video.play().catch(()=>{
        /* Ignore interrupt play video */ });
    }
    function pauseVideo(index) {
        const $video = document.querySelector($3ee15bb2864734d3$var$getVideoByIndex(index));
        if (!$video) return;
        $video.pause();
    }
    function showBtn(name, bool) {
        const $btn = document.querySelector(getBtnClass(name));
        if (bool) $btn.classList.remove($3ee15bb2864734d3$var$getClassName($3ee15bb2864734d3$var$disabledBtnClassName));
        else $btn.classList.add($3ee15bb2864734d3$var$getClassName($3ee15bb2864734d3$var$disabledBtnClassName));
    }
    function getBtnClass(name) {
        if (name === "share") return $3ee15bb2864734d3$var$shareBtn;
        if (name === "download") return $3ee15bb2864734d3$var$downloadBtn;
        return null;
    }
    function getBtnTextClass(name) {
        if (name === "share") return $3ee15bb2864734d3$var$shareBtnText;
        if (name === "download") return $3ee15bb2864734d3$var$downloadBtnText;
        return null;
    }
}
function $3ee15bb2864734d3$var$initPinchZoomManager() {
    let cachePinchZoom = {};
    let stopInitPinchZoom = false;
    return {
        setUp: (index)=>{
            if (!cachePinchZoom[index]) {
                stopInitPinchZoom = false;
                const $item = document.querySelector($3ee15bb2864734d3$var$getItemByIndex(index));
                if (!$item) return;
                const img = $item.querySelector($3ee15bb2864734d3$var$content);
                if (!img) return;
                if (img.complete) // If image is already loaded, initialize immediately
                initPinchZoom(img);
                else // If image is still loading, wait for load event
                img.addEventListener("load", ()=>{
                    initPinchZoom(img);
                }, {
                    once: true
                });
            }
            function initPinchZoom(img) {
                if (!stopInitPinchZoom) cachePinchZoom[index] = new (0, $1IcXo.default)(img, {
                    draggableUnzoomed: false
                });
            }
        },
        resetZoom: (index)=>{
            if (cachePinchZoom[index]) cachePinchZoom[index].zoomOutAnimation();
        },
        clearAll: ()=>{
            Object.values(cachePinchZoom).forEach((pz)=>pz.destroy());
            cachePinchZoom = {};
            stopInitPinchZoom = true;
        }
    };
}
function $3ee15bb2864734d3$var$initBodyPage() {
    return {
        freeze: freeze,
        unfreeze: unfreeze
    };
    function freeze() {
        const $body = document.querySelector($3ee15bb2864734d3$var$docBody);
        $body.classList.add($3ee15bb2864734d3$var$getClassName($3ee15bb2864734d3$var$holdDocBody));
    }
    function unfreeze() {
        const $body = document.querySelector($3ee15bb2864734d3$var$docBody);
        $body.classList.remove($3ee15bb2864734d3$var$getClassName($3ee15bb2864734d3$var$holdDocBody));
    }
}

});
parcelRegister("krKJQ", function(module, exports) {
/*!
 * swiped-events.js - v@version@
 * Pure JavaScript swipe events
 * https://github.com/john-doherty/swiped-events
 * @inspiration https://stackoverflow.com/questions/16348031/disable-scrolling-when-touch-moving-certain-element
 * @author John Doherty <www.johndoherty.info>
 * @license MIT
 */ (function(window1, document1) {
    "use strict";
    // patch CustomEvent to allow constructor creation (IE/Chrome)
    if (typeof window1.CustomEvent !== "function") {
        window1.CustomEvent = function(event, params) {
            params = params || {
                bubbles: false,
                cancelable: false,
                detail: undefined
            };
            var evt = document1.createEvent("CustomEvent");
            evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
            return evt;
        };
        window1.CustomEvent.prototype = window1.Event.prototype;
    }
    document1.addEventListener("touchstart", handleTouchStart, false);
    document1.addEventListener("touchmove", handleTouchMove, false);
    document1.addEventListener("touchend", handleTouchEnd, false);
    var xDown = null;
    var yDown = null;
    var xDiff = null;
    var yDiff = null;
    var timeDown = null;
    var startEl = null;
    /**
     * Fires swiped event if swipe detected on touchend
     * @param {object} e - browser event object
     * @returns {void}
     */ function handleTouchEnd(e) {
        // if the user released on a different target, cancel!
        if (startEl !== e.target) return;
        var swipeThreshold = parseInt(getNearestAttribute(startEl, "data-swipe-threshold", "20"), 10); // default 20 units
        var swipeUnit = getNearestAttribute(startEl, "data-swipe-unit", "px"); // default px
        var swipeTimeout = parseInt(getNearestAttribute(startEl, "data-swipe-timeout", "500"), 10); // default 500ms
        var timeDiff = Date.now() - timeDown;
        var eventType = "";
        var changedTouches = e.changedTouches || e.touches || [];
        if (swipeUnit === "vh") swipeThreshold = Math.round(swipeThreshold / 100 * document1.documentElement.clientHeight); // get percentage of viewport height in pixels
        if (swipeUnit === "vw") swipeThreshold = Math.round(swipeThreshold / 100 * document1.documentElement.clientWidth); // get percentage of viewport height in pixels
        if (Math.abs(xDiff) > Math.abs(yDiff)) {
            if (Math.abs(xDiff) > swipeThreshold && timeDiff < swipeTimeout) {
                if (xDiff > 0) eventType = "swiped-left";
                else eventType = "swiped-right";
            }
        } else if (Math.abs(yDiff) > swipeThreshold && timeDiff < swipeTimeout) {
            if (yDiff > 0) eventType = "swiped-up";
            else eventType = "swiped-down";
        }
        if (eventType !== "") {
            var eventData = {
                dir: eventType.replace(/swiped-/, ""),
                touchType: (changedTouches[0] || {}).touchType || "direct",
                xStart: parseInt(xDown, 10),
                xEnd: parseInt((changedTouches[0] || {}).clientX || -1, 10),
                yStart: parseInt(yDown, 10),
                yEnd: parseInt((changedTouches[0] || {}).clientY || -1, 10)
            };
            // fire `swiped` event event on the element that started the swipe
            startEl.dispatchEvent(new CustomEvent("swiped", {
                bubbles: true,
                cancelable: true,
                detail: eventData
            }));
            // fire `swiped-dir` event on the element that started the swipe
            startEl.dispatchEvent(new CustomEvent(eventType, {
                bubbles: true,
                cancelable: true,
                detail: eventData
            }));
        }
        // reset values
        xDown = null;
        yDown = null;
        timeDown = null;
    }
    /**
     * Records current location on touchstart event
     * @param {object} e - browser event object
     * @returns {void}
     */ function handleTouchStart(e) {
        // if the element has data-swipe-ignore="true" we stop listening for swipe events
        if (e.target.getAttribute("data-swipe-ignore") === "true") return;
        startEl = e.target;
        timeDown = Date.now();
        xDown = e.touches[0].clientX;
        yDown = e.touches[0].clientY;
        xDiff = 0;
        yDiff = 0;
    }
    /**
     * Records location diff in px on touchmove event
     * @param {object} e - browser event object
     * @returns {void}
     */ function handleTouchMove(e) {
        if (!xDown || !yDown) return;
        var xUp = e.touches[0].clientX;
        var yUp = e.touches[0].clientY;
        xDiff = xDown - xUp;
        yDiff = yDown - yUp;
    }
    /**
     * Gets attribute off HTML element or nearest parent
     * @param {object} el - HTML element to retrieve attribute from
     * @param {string} attributeName - name of the attribute
     * @param {any} defaultValue - default value to return if no match found
     * @returns {any} attribute value or defaultValue
     */ function getNearestAttribute(el, attributeName, defaultValue) {
        // walk up the dom tree looking for attributeName
        while(el && el !== document1.documentElement){
            var attributeValue = el.getAttribute(attributeName);
            if (attributeValue) return attributeValue;
            el = el.parentNode;
        }
        return defaultValue;
    }
})(window, document);

});

parcelRegister("1IcXo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $13f3f379151e46ba$export$2e2bcd8739ae039; });
/*

    PinchZoom.js
    Copyright (c) Manuel Stofer 2013 - today

    Author: Manuel Stofer (mst@rtp.ch)
    Version: 2.3.5

    Permission is hereby granted, free of charge, to any person obtaining a copy
    of this software and associated documentation files (the "Software"), to deal
    in the Software without restriction, including without limitation the rights
    to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
    copies of the Software, and to permit persons to whom the Software is
    furnished to do so, subject to the following conditions:

    The above copyright notice and this permission notice shall be included in
    all copies or substantial portions of the Software.

    THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
    IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
    FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
    AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
    LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
    OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
    THE SOFTWARE.

*/ // polyfills
if (typeof Object.assign != "function") // Must be writable: true, enumerable: false, configurable: true
Object.defineProperty(Object, "assign", {
    value: function assign(target, varArgs) {
        if (target == null) throw new TypeError("Cannot convert undefined or null to object");
        var to = Object(target);
        for(var index = 1; index < arguments.length; index++){
            var nextSource = arguments[index];
            if (nextSource != null) {
                for(var nextKey in nextSource)// Avoid bugs when hasOwnProperty is shadowed
                if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) to[nextKey] = nextSource[nextKey];
            }
        }
        return to;
    },
    writable: true,
    configurable: true
});
if (typeof Array.from != "function") Array.from = function(object) {
    return [].slice.call(object);
};
// utils
var $13f3f379151e46ba$var$buildElement = function(str) {
    // empty string as title argument required by IE and Edge
    var tmp = document.implementation.createHTMLDocument("");
    tmp.body.innerHTML = str;
    return Array.from(tmp.body.children)[0];
};
var $13f3f379151e46ba$var$triggerEvent = function(el, name) {
    var event1 = document.createEvent("HTMLEvents");
    event1.initEvent(name, true, false);
    el.dispatchEvent(event1);
};
var $13f3f379151e46ba$var$definePinchZoom = function() {
    /**
     * Pinch zoom
     * @param el
     * @param options
     * @constructor
     */ var PinchZoom = function(el, options) {
        this.el = el;
        this.zoomFactor = 1;
        this.lastScale = 1;
        this.offset = {
            x: 0,
            y: 0
        };
        this.initialOffset = {
            x: 0,
            y: 0
        };
        this.options = Object.assign({}, this.defaults, options);
        this.setupMarkup();
        this.bindEvents();
        this.update();
        // The image may already be loaded when PinchZoom is initialized,
        // and then the load event (which trigger update) will never fire.
        if (this.isImageLoaded(this.el)) {
            this.updateAspectRatio();
            this.setupOffsets();
        }
        this.enable();
    }, sum = function(a, b) {
        return a + b;
    }, isCloseTo = function(value, expected) {
        return value > expected - 0.01 && value < expected + 0.01;
    };
    PinchZoom.prototype = {
        defaults: {
            tapZoomFactor: 2,
            zoomOutFactor: 1.3,
            animationDuration: 300,
            maxZoom: 4,
            minZoom: 0.5,
            draggableUnzoomed: true,
            lockDragAxis: false,
            setOffsetsOnce: false,
            use2d: true,
            zoomStartEventName: "pz_zoomstart",
            zoomUpdateEventName: "pz_zoomupdate",
            zoomEndEventName: "pz_zoomend",
            dragStartEventName: "pz_dragstart",
            dragUpdateEventName: "pz_dragupdate",
            dragEndEventName: "pz_dragend",
            doubleTapEventName: "pz_doubletap",
            verticalPadding: 0,
            horizontalPadding: 0,
            onZoomStart: null,
            onZoomEnd: null,
            onZoomUpdate: null,
            onDragStart: null,
            onDragEnd: null,
            onDragUpdate: null,
            onDoubleTap: null
        },
        /**
         * Event handler for 'dragstart'
         * @param event
         */ handleDragStart: function(event1) {
            $13f3f379151e46ba$var$triggerEvent(this.el, this.options.dragStartEventName);
            if (typeof this.options.onDragStart == "function") this.options.onDragStart(this, event1);
            this.stopAnimation();
            this.lastDragPosition = false;
            this.hasInteraction = true;
            this.handleDrag(event1);
        },
        /**
         * Event handler for 'drag'
         * @param event
         */ handleDrag: function(event1) {
            var touch = this.getTouches(event1)[0];
            this.drag(touch, this.lastDragPosition);
            this.offset = this.sanitizeOffset(this.offset);
            this.lastDragPosition = touch;
        },
        handleDragEnd: function() {
            $13f3f379151e46ba$var$triggerEvent(this.el, this.options.dragEndEventName);
            if (typeof this.options.onDragEnd == "function") this.options.onDragEnd(this, event);
            this.end();
        },
        /**
         * Event handler for 'zoomstart'
         * @param event
         */ handleZoomStart: function(event1) {
            $13f3f379151e46ba$var$triggerEvent(this.el, this.options.zoomStartEventName);
            if (typeof this.options.onZoomStart == "function") this.options.onZoomStart(this, event1);
            this.stopAnimation();
            this.lastScale = 1;
            this.nthZoom = 0;
            this.lastZoomCenter = false;
            this.hasInteraction = true;
        },
        /**
         * Event handler for 'zoom'
         * @param event
         */ handleZoom: function(event1, newScale) {
            // a relative scale factor is used
            var touchCenter = this.getTouchCenter(this.getTouches(event1)), scale = newScale / this.lastScale;
            this.lastScale = newScale;
            // the first touch events are thrown away since they are not precise
            this.nthZoom += 1;
            if (this.nthZoom > 3) {
                this.scale(scale, touchCenter);
                this.drag(touchCenter, this.lastZoomCenter);
            }
            this.lastZoomCenter = touchCenter;
        },
        handleZoomEnd: function() {
            $13f3f379151e46ba$var$triggerEvent(this.el, this.options.zoomEndEventName);
            if (typeof this.options.onZoomEnd == "function") this.options.onZoomEnd(this, event);
            this.end();
        },
        /**
         * Event handler for 'doubletap'
         * @param event
         */ handleDoubleTap: function(event1) {
            var center = this.getTouches(event1)[0], zoomFactor = this.zoomFactor > 1 ? 1 : this.options.tapZoomFactor, startZoomFactor = this.zoomFactor, updateProgress = (function(progress) {
                this.scaleTo(startZoomFactor + progress * (zoomFactor - startZoomFactor), center);
            }).bind(this);
            if (this.hasInteraction) return;
            this.isDoubleTap = true;
            if (startZoomFactor > zoomFactor) center = this.getCurrentZoomCenter();
            this.animate(this.options.animationDuration, updateProgress, this.swing);
            $13f3f379151e46ba$var$triggerEvent(this.el, this.options.doubleTapEventName);
            if (typeof this.options.onDoubleTap == "function") this.options.onDoubleTap(this, event1);
        },
        /**
         * Compute the initial offset
         *
         * the element should be centered in the container upon initialization
         */ computeInitialOffset: function() {
            this.initialOffset = {
                x: -Math.abs(this.el.offsetWidth * this.getInitialZoomFactor() - this.container.offsetWidth) / 2,
                y: -Math.abs(this.el.offsetHeight * this.getInitialZoomFactor() - this.container.offsetHeight) / 2
            };
        },
        /**
         * Reset current image offset to that of the initial offset
         */ resetOffset: function() {
            this.offset.x = this.initialOffset.x;
            this.offset.y = this.initialOffset.y;
        },
        /**
         * Determine if image is loaded
         */ isImageLoaded: function(el) {
            if (el.nodeName === "IMG") return el.complete && el.naturalHeight !== 0;
            else return Array.from(el.querySelectorAll("img")).every(this.isImageLoaded);
        },
        setupOffsets: function() {
            if (this.options.setOffsetsOnce && this._isOffsetsSet) return;
            this._isOffsetsSet = true;
            this.computeInitialOffset();
            this.resetOffset();
        },
        /**
         * Max / min values for the offset
         * @param offset
         * @return {Object} the sanitized offset
         */ sanitizeOffset: function(offset) {
            var elWidth = this.el.offsetWidth * this.getInitialZoomFactor() * this.zoomFactor;
            var elHeight = this.el.offsetHeight * this.getInitialZoomFactor() * this.zoomFactor;
            var maxX = elWidth - this.getContainerX() + this.options.horizontalPadding, maxY = elHeight - this.getContainerY() + this.options.verticalPadding, maxOffsetX = Math.max(maxX, 0), maxOffsetY = Math.max(maxY, 0), minOffsetX = Math.min(maxX, 0) - this.options.horizontalPadding, minOffsetY = Math.min(maxY, 0) - this.options.verticalPadding;
            return {
                x: Math.min(Math.max(offset.x, minOffsetX), maxOffsetX),
                y: Math.min(Math.max(offset.y, minOffsetY), maxOffsetY)
            };
        },
        /**
         * Scale to a specific zoom factor (not relative)
         * @param zoomFactor
         * @param center
         */ scaleTo: function(zoomFactor, center) {
            this.scale(zoomFactor / this.zoomFactor, center);
        },
        /**
         * Scales the element from specified center
         * @param scale
         * @param center
         */ scale: function(scale, center) {
            scale = this.scaleZoomFactor(scale);
            this.addOffset({
                x: (scale - 1) * (center.x + this.offset.x),
                y: (scale - 1) * (center.y + this.offset.y)
            });
            $13f3f379151e46ba$var$triggerEvent(this.el, this.options.zoomUpdateEventName);
            if (typeof this.options.onZoomUpdate == "function") this.options.onZoomUpdate(this, event);
        },
        /**
         * Scales the zoom factor relative to current state
         * @param scale
         * @return the actual scale (can differ because of max min zoom factor)
         */ scaleZoomFactor: function(scale) {
            var originalZoomFactor = this.zoomFactor;
            this.zoomFactor *= scale;
            this.zoomFactor = Math.min(this.options.maxZoom, Math.max(this.zoomFactor, this.options.minZoom));
            return this.zoomFactor / originalZoomFactor;
        },
        /**
         * Determine if the image is in a draggable state
         *
         * When the image can be dragged, the drag event is acted upon and cancelled.
         * When not draggable, the drag event bubbles through this component.
         *
         * @return {Boolean}
         */ canDrag: function() {
            return this.options.draggableUnzoomed || !isCloseTo(this.zoomFactor, 1);
        },
        /**
         * Drags the element
         * @param center
         * @param lastCenter
         */ drag: function(center, lastCenter) {
            if (lastCenter) {
                if (this.options.lockDragAxis) {
                    // lock scroll to position that was changed the most
                    if (Math.abs(center.x - lastCenter.x) > Math.abs(center.y - lastCenter.y)) this.addOffset({
                        x: -(center.x - lastCenter.x),
                        y: 0
                    });
                    else this.addOffset({
                        y: -(center.y - lastCenter.y),
                        x: 0
                    });
                } else this.addOffset({
                    y: -(center.y - lastCenter.y),
                    x: -(center.x - lastCenter.x)
                });
                $13f3f379151e46ba$var$triggerEvent(this.el, this.options.dragUpdateEventName);
                if (typeof this.options.onDragUpdate == "function") this.options.onDragUpdate(this, event);
            }
        },
        /**
         * Calculates the touch center of multiple touches
         * @param touches
         * @return {Object}
         */ getTouchCenter: function(touches) {
            return this.getVectorAvg(touches);
        },
        /**
         * Calculates the average of multiple vectors (x, y values)
         */ getVectorAvg: function(vectors) {
            return {
                x: vectors.map(function(v) {
                    return v.x;
                }).reduce(sum) / vectors.length,
                y: vectors.map(function(v) {
                    return v.y;
                }).reduce(sum) / vectors.length
            };
        },
        /**
         * Adds an offset
         * @param offset the offset to add
         * @return return true when the offset change was accepted
         */ addOffset: function(offset) {
            this.offset = {
                x: this.offset.x + offset.x,
                y: this.offset.y + offset.y
            };
        },
        sanitize: function() {
            if (this.zoomFactor < this.options.zoomOutFactor) this.zoomOutAnimation();
            else if (this.isInsaneOffset(this.offset)) this.sanitizeOffsetAnimation();
        },
        /**
         * Checks if the offset is ok with the current zoom factor
         * @param offset
         * @return {Boolean}
         */ isInsaneOffset: function(offset) {
            var sanitizedOffset = this.sanitizeOffset(offset);
            return sanitizedOffset.x !== offset.x || sanitizedOffset.y !== offset.y;
        },
        /**
         * Creates an animation moving to a sane offset
         */ sanitizeOffsetAnimation: function() {
            var targetOffset = this.sanitizeOffset(this.offset), startOffset = {
                x: this.offset.x,
                y: this.offset.y
            }, updateProgress = (function(progress) {
                this.offset.x = startOffset.x + progress * (targetOffset.x - startOffset.x);
                this.offset.y = startOffset.y + progress * (targetOffset.y - startOffset.y);
                this.update();
            }).bind(this);
            this.animate(this.options.animationDuration, updateProgress, this.swing);
        },
        /**
         * Zooms back to the original position,
         * (no offset and zoom factor 1)
         */ zoomOutAnimation: function() {
            if (this.zoomFactor === 1) return;
            var startZoomFactor = this.zoomFactor, zoomFactor = 1, center = this.getCurrentZoomCenter(), updateProgress = (function(progress) {
                this.scaleTo(startZoomFactor + progress * (zoomFactor - startZoomFactor), center);
            }).bind(this);
            this.animate(this.options.animationDuration, updateProgress, this.swing);
        },
        /**
         * Updates the container aspect ratio
         *
         * Any previous container height must be cleared before re-measuring the
         * parent height, since it depends implicitly on the height of any of its children
         */ updateAspectRatio: function() {
            this.unsetContainerY();
            this.setContainerY(this.container.parentElement.offsetHeight);
        },
        /**
         * Calculates the initial zoom factor (for the element to fit into the container)
         * @return {number} the initial zoom factor
         */ getInitialZoomFactor: function() {
            var xZoomFactor = this.container.offsetWidth / this.el.offsetWidth;
            var yZoomFactor = this.container.offsetHeight / this.el.offsetHeight;
            return Math.min(xZoomFactor, yZoomFactor);
        },
        /**
         * Calculates the aspect ratio of the element
         * @return the aspect ratio
         */ getAspectRatio: function() {
            return this.el.offsetWidth / this.el.offsetHeight;
        },
        /**
         * Calculates the virtual zoom center for the current offset and zoom factor
         * (used for reverse zoom)
         * @return {Object} the current zoom center
         */ getCurrentZoomCenter: function() {
            var offsetLeft = this.offset.x - this.initialOffset.x;
            var centerX = -1 * this.offset.x - offsetLeft / (1 / this.zoomFactor - 1);
            var offsetTop = this.offset.y - this.initialOffset.y;
            var centerY = -1 * this.offset.y - offsetTop / (1 / this.zoomFactor - 1);
            return {
                x: centerX,
                y: centerY
            };
        },
        /**
         * Returns the touches of an event relative to the container offset
         * @param event
         * @return array touches
         */ getTouches: function(event1) {
            var rect = this.container.getBoundingClientRect();
            var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            var scrollLeft = document.documentElement.scrollLeft || document.body.scrollLeft;
            var posTop = rect.top + scrollTop;
            var posLeft = rect.left + scrollLeft;
            return Array.prototype.slice.call(event1.touches).map(function(touch) {
                return {
                    x: touch.pageX - posLeft,
                    y: touch.pageY - posTop
                };
            });
        },
        /**
         * Animation loop
         * does not support simultaneous animations
         * @param duration
         * @param framefn
         * @param timefn
         * @param callback
         */ animate: function(duration, framefn, timefn, callback) {
            var startTime = new Date().getTime(), renderFrame = (function() {
                if (!this.inAnimation) return;
                var frameTime = new Date().getTime() - startTime, progress = frameTime / duration;
                if (frameTime >= duration) {
                    framefn(1);
                    if (callback) callback();
                    this.update();
                    this.stopAnimation();
                    this.update();
                } else {
                    if (timefn) progress = timefn(progress);
                    framefn(progress);
                    this.update();
                    requestAnimationFrame(renderFrame);
                }
            }).bind(this);
            this.inAnimation = true;
            requestAnimationFrame(renderFrame);
        },
        /**
         * Stops the animation
         */ stopAnimation: function() {
            this.inAnimation = false;
        },
        /**
         * Swing timing function for animations
         * @param p
         * @return {Number}
         */ swing: function(p) {
            return -Math.cos(p * Math.PI) / 2 + 0.5;
        },
        getContainerX: function() {
            return this.container.offsetWidth;
        },
        getContainerY: function() {
            return this.container.offsetHeight;
        },
        setContainerY: function(y) {
            return this.container.style.height = y + "px";
        },
        unsetContainerY: function() {
            this.container.style.height = null;
        },
        /**
         * Creates the expected html structure
         */ setupMarkup: function() {
            this.container = $13f3f379151e46ba$var$buildElement('<div class="pinch-zoom-container"></div>');
            this.el.parentNode.insertBefore(this.container, this.el);
            this.container.appendChild(this.el);
            this.container.style.overflow = "hidden";
            this.container.style.position = "relative";
            this.el.style.webkitTransformOrigin = "0% 0%";
            this.el.style.mozTransformOrigin = "0% 0%";
            this.el.style.msTransformOrigin = "0% 0%";
            this.el.style.oTransformOrigin = "0% 0%";
            this.el.style.transformOrigin = "0% 0%";
            this.el.style.position = "absolute";
        },
        end: function() {
            this.hasInteraction = false;
            this.sanitize();
            this.update();
        },
        /**
         * Binds all required event listeners
         */ bindEvents: function() {
            var self = this;
            detectGestures(this.container, this);
            this.resizeHandler = this.update.bind(this);
            window.addEventListener("resize", this.resizeHandler);
            Array.from(this.el.querySelectorAll("img")).forEach(function(imgEl) {
                imgEl.addEventListener("load", self.update.bind(self));
            });
            if (this.el.nodeName === "IMG") this.el.addEventListener("load", this.update.bind(this));
        },
        /**
         * Updates the css values according to the current zoom factor and offset
         */ update: function(event1) {
            if (event1 && event1.type === "resize") {
                this.updateAspectRatio();
                this.setupOffsets();
            }
            if (event1 && event1.type === "load") {
                this.updateAspectRatio();
                this.setupOffsets();
            }
            if (this.updatePlanned) return;
            this.updatePlanned = true;
            window.setTimeout((function() {
                this.updatePlanned = false;
                var zoomFactor = this.getInitialZoomFactor() * this.zoomFactor, offsetX = -this.offset.x / zoomFactor, offsetY = -this.offset.y / zoomFactor, transform3d = "scale3d(" + zoomFactor + ", " + zoomFactor + ",1) " + "translate3d(" + offsetX + "px," + offsetY + "px,0px)", transform2d = "scale(" + zoomFactor + ", " + zoomFactor + ") " + "translate(" + offsetX + "px," + offsetY + "px)", removeClone = (function() {
                    if (this.clone) {
                        this.clone.parentNode.removeChild(this.clone);
                        delete this.clone;
                    }
                }).bind(this);
                // Scale 3d and translate3d are faster (at least on ios)
                // but they also reduce the quality.
                // PinchZoom uses the 3d transformations during interactions
                // after interactions it falls back to 2d transformations
                if (!this.options.use2d || this.hasInteraction || this.inAnimation) {
                    this.is3d = true;
                    removeClone();
                    this.el.style.webkitTransform = transform3d;
                    this.el.style.mozTransform = transform2d;
                    this.el.style.msTransform = transform2d;
                    this.el.style.oTransform = transform2d;
                    this.el.style.transform = transform3d;
                } else {
                    // When changing from 3d to 2d transform webkit has some glitches.
                    // To avoid this, a copy of the 3d transformed element is displayed in the
                    // foreground while the element is converted from 3d to 2d transform
                    if (this.is3d) {
                        this.clone = this.el.cloneNode(true);
                        this.clone.style.pointerEvents = "none";
                        this.container.appendChild(this.clone);
                        window.setTimeout(removeClone, 200);
                    }
                    this.el.style.webkitTransform = transform2d;
                    this.el.style.mozTransform = transform2d;
                    this.el.style.msTransform = transform2d;
                    this.el.style.oTransform = transform2d;
                    this.el.style.transform = transform2d;
                    this.is3d = false;
                }
            }).bind(this), 0);
        },
        /**
         * Enables event handling for gestures
         */ enable: function() {
            this.enabled = true;
        },
        /**
         * Disables event handling for gestures
         */ disable: function() {
            this.enabled = false;
        },
        /**
         * Unmounts the zooming container and global event listeners
         */ destroy: function() {
            window.removeEventListener("resize", this.resizeHandler);
            if (this.container) {
                this.container.remove();
                this.container = null;
            }
        }
    };
    var detectGestures = function(el, target) {
        var interaction = null, fingers = 0, lastTouchStart = null, startTouches = null, setInteraction = function(newInteraction, event1) {
            if (interaction !== newInteraction) {
                if (interaction && !newInteraction) switch(interaction){
                    case "zoom":
                        target.handleZoomEnd(event1);
                        break;
                    case "drag":
                        target.handleDragEnd(event1);
                        break;
                }
                switch(newInteraction){
                    case "zoom":
                        target.handleZoomStart(event1);
                        break;
                    case "drag":
                        target.handleDragStart(event1);
                        break;
                }
            }
            interaction = newInteraction;
        }, updateInteraction = function(event1) {
            if (fingers === 2) setInteraction("zoom");
            else if (fingers === 1 && target.canDrag()) setInteraction("drag", event1);
            else setInteraction(null, event1);
        }, targetTouches = function(touches) {
            return Array.from(touches).map(function(touch) {
                return {
                    x: touch.pageX,
                    y: touch.pageY
                };
            });
        }, getDistance = function(a, b) {
            var x, y;
            x = a.x - b.x;
            y = a.y - b.y;
            return Math.sqrt(x * x + y * y);
        }, calculateScale = function(startTouches, endTouches) {
            var startDistance = getDistance(startTouches[0], startTouches[1]), endDistance = getDistance(endTouches[0], endTouches[1]);
            return endDistance / startDistance;
        }, cancelEvent = function(event1) {
            event1.stopPropagation();
            event1.preventDefault();
        }, detectDoubleTap = function(event1) {
            var time = new Date().getTime();
            if (fingers > 1) lastTouchStart = null;
            if (time - lastTouchStart < 300) {
                cancelEvent(event1);
                target.handleDoubleTap(event1);
                switch(interaction){
                    case "zoom":
                        target.handleZoomEnd(event1);
                        break;
                    case "drag":
                        target.handleDragEnd(event1);
                        break;
                }
            } else target.isDoubleTap = false;
            if (fingers === 1) lastTouchStart = time;
        }, firstMove = true;
        el.addEventListener("touchstart", function(event1) {
            if (target.enabled) {
                firstMove = true;
                fingers = event1.touches.length;
                detectDoubleTap(event1);
            }
        }, {
            passive: false
        });
        el.addEventListener("touchmove", function(event1) {
            if (target.enabled && !target.isDoubleTap) {
                if (firstMove) {
                    updateInteraction(event1);
                    if (interaction) cancelEvent(event1);
                    startTouches = targetTouches(event1.touches);
                } else {
                    switch(interaction){
                        case "zoom":
                            if (startTouches.length == 2 && event1.touches.length == 2) target.handleZoom(event1, calculateScale(startTouches, targetTouches(event1.touches)));
                            break;
                        case "drag":
                            target.handleDrag(event1);
                            break;
                    }
                    if (interaction) {
                        cancelEvent(event1);
                        target.update();
                    }
                }
                firstMove = false;
            }
        }, {
            passive: false
        });
        el.addEventListener("touchend", function(event1) {
            if (target.enabled) {
                fingers = event1.touches.length;
                updateInteraction(event1);
            }
        });
    };
    return PinchZoom;
};
var $13f3f379151e46ba$var$PinchZoom = $13f3f379151e46ba$var$definePinchZoom();
var $13f3f379151e46ba$export$2e2bcd8739ae039 = $13f3f379151e46ba$var$PinchZoom;

});


parcelRegister("hOrWP", function(module, exports) {

$parcel$export(module.exports, "init", function () { return $cf7cc9077c924891$export$2cd8252107eb640b; });
// NOTE: Just add to your button class open-zendesk
function $cf7cc9077c924891$export$2cd8252107eb640b(zendeskKey) {
    if (zendeskKey) addZenDeskScript(`https://static.zdassets.com/ekr/snippet.js?key=${zendeskKey}`, ()=>{
        window.zESettings = {
            webWidget: {
                color: {
                    theme: "#436db5"
                }
            }
        };
        zE("webWidget", "hide");
        showSupportBtn();
        onClickSupportBtn(()=>{
            zE("webWidget", "show");
            zE("webWidget", "open");
            const $menu = document.querySelector(".menu");
            $menu.classList.add("menu_hidden");
        });
        zE("webWidget:on", "close", ()=>{
            zE("webWidget", "hide");
        });
    });
    function addZenDeskScript(src, cb) {
        const $script = document.createElement("script");
        $script.setAttribute("id", "ze-snippet");
        $script.setAttribute("src", src);
        $script.addEventListener("load", cb);
        document.body.appendChild($script);
    }
    function showSupportBtn() {
        const $openSupportBtn = document.querySelector(".open-zendesk");
        $openSupportBtn.style.display = "inline-flex";
    }
    function onClickSupportBtn(cb) {
        const $openSupportBtn = document.querySelector(".open-zendesk");
        $openSupportBtn.addEventListener("click", cb);
    }
}

});

const $f93f76e61c3f6b39$var$r = ()=>"undefined" != typeof window, $f93f76e61c3f6b39$var$t = ()=>!(!$f93f76e61c3f6b39$var$r() || !window.hj), $f93f76e61c3f6b39$var$e = (t, ...e)=>{
    if ($f93f76e61c3f6b39$var$r() && window.hj) return window.hj(t, ...e);
    throw Error("Hotjar is not available, make sure init has been called.");
}, $f93f76e61c3f6b39$var$n = (r, e, n)=>{
    if (!((r, t, e)=>{
        try {
            const n = document.getElementById(t) || document.createElement("script");
            return n.id = t, n.nonce = e, n.innerText = r, n.crossOrigin = "anonymous", document.head.appendChild(n), !0;
        } catch (r) {
            return !1;
        }
    })(`(function(h,o,t,j,a,r){h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};h._hjSettings={hjid:${r},hjsv:${e},hjdebug:${(null == n ? void 0 : n.debug) || !1}};a=o.getElementsByTagName('head')[0];r=o.createElement('script');r.async=1;r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;a.appendChild(r);})(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');`, "hotjar-init-script", null == n ? void 0 : n.nonce) || !$f93f76e61c3f6b39$var$t()) throw Error("Failed to initialize Hotjar tracking script.");
}, $f93f76e61c3f6b39$var$o = {
    init: (r, t, e)=>{
        try {
            return $f93f76e61c3f6b39$var$n(r, t, e), !0;
        } catch (r) {
            return console.error("Error:", r), !1;
        }
    },
    event: (r)=>{
        try {
            return $f93f76e61c3f6b39$var$e("event", r), !0;
        } catch (r) {
            return console.error("Error:", r), !1;
        }
    },
    identify: (r, t)=>{
        try {
            return $f93f76e61c3f6b39$var$e("identify", r, t), !0;
        } catch (r) {
            return console.error("Error:", r), !1;
        }
    },
    stateChange: (r)=>{
        try {
            return $f93f76e61c3f6b39$var$e("stateChange", r), !0;
        } catch (r) {
            return console.error("Error:", r), !1;
        }
    },
    isReady: $f93f76e61c3f6b39$var$t
};
var $f93f76e61c3f6b39$export$2e2bcd8739ae039 = $f93f76e61c3f6b39$var$o;


/**
 * Set up in window environment variable
 * WARNING: key and process.env.key_name should be the same
 * like this initEnvValue('NODE_ENV', process.env.NODE_ENV);
 * to find a error if key doesn't exist
 * because not work such process.env[key]
 */ function $2e09d8e15c7dd742$export$70085a6410560595(key, value, withValidation = true) {
    if (withValidation && value === undefined) throw new Error(`A env key "${key}" is required. Please and to .env file`);
    window[key] = value;
}



var $1QpD4 = parcelRequire("1QpD4");

var $QsXqF = parcelRequire("QsXqF");

var $ii2Pe = parcelRequire("ii2Pe");

var $7TTCE = parcelRequire("7TTCE");

var $k8ze7 = parcelRequire("k8ze7");

var $dc4rr = parcelRequire("dc4rr");

var $bTO5t = parcelRequire("bTO5t");

var $8pHZ5 = parcelRequire("8pHZ5");

var $6lqdz = parcelRequire("6lqdz");

var $g0ZwT = parcelRequire("g0ZwT");

var $3Y14T = parcelRequire("3Y14T");

var $5oI2J = parcelRequire("5oI2J");

var $hOrWP = parcelRequire("hOrWP");
// Envs
(0, $2e09d8e15c7dd742$export$70085a6410560595)("BACKEND_API", "https://api-new.occo.io/v1");
window.addVisitDateInfo = (0, $1QpD4.addVisitDateInfo);
window.print = (0, $1QpD4.print);
window.regByWebappIdFirstStep1 = (0, $1QpD4.regByWebappIdFirstStep1);
window.regByWebappIdFirstStep2 = (0, $1QpD4.regByWebappIdFirstStep2);
window.captureEvents = (0, $1QpD4.captureEvents);
window.fullScreenView = $5oI2J;
Object.keys($QsXqF).forEach((name)=>{
    window[name] = $QsXqF[name];
});
window.initGalleryViewController = (0, $ii2Pe.initGalleryViewController);
window.initModeSwitcher = (0, $7TTCE.initModeSwitcher);
window.initSelect = (0, $k8ze7.initSelect);
window.initItemCounter = (0, $dc4rr.initItemCounter);
window.initActionPanel = (0, $bTO5t.initActionPanel);
window.initTopPanelSelectForShoppingCart = (0, $8pHZ5.initTopPanelSelectForShoppingCart);
window.initSelectedPanel = (0, $6lqdz.initSelectedPanel);
window.photoDC = $g0ZwT;
window.initWaitingNotice = (0, $3Y14T.initWaitingNotice);
window.initZendesk = (0, $hOrWP.init);
(0, $f93f76e61c3f6b39$export$2e2bcd8739ae039).init("5070839", 6);


//# sourceMappingURL=a-shoot.3c476e7f.js.map
